module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "04f7":
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/esm/defineProperty");

/***/ }),

/***/ "0a57":
/***/ (function(module, exports) {

module.exports = require("hui/lib/locale");

/***/ }),

/***/ "0cda":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.split.js");

/***/ }),

/***/ "0d58":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.find.js");

/***/ }),

/***/ "105d":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.trim.js");

/***/ }),

/***/ "13e3":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/web.dom-collections.for-each.js");

/***/ }),

/***/ "16b9":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.define-properties.js");

/***/ }),

/***/ "1a25":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/web.dom-collections.iterator.js");

/***/ }),

/***/ "1a89":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.filter.js");

/***/ }),

/***/ "1c32":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.search.js");

/***/ }),

/***/ "1e79":
/***/ (function(module, exports) {

module.exports = require("throttle-debounce/throttle");

/***/ }),

/***/ "2c81":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2ff9":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.symbol.iterator.js");

/***/ }),

/***/ "30df":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.regexp.to-string.js");

/***/ }),

/***/ "3732":
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/esm/arrayWithoutHoles");

/***/ }),

/***/ "3910":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.parse-int.js");

/***/ }),

/***/ "3ee4":
/***/ (function(module, exports) {

module.exports = require("async-validator");

/***/ }),

/***/ "4131":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.small.js");

/***/ }),

/***/ "4391":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.map.js");

/***/ }),

/***/ "4933":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.symbol.description.js");

/***/ }),

/***/ "4c07":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.sort.js");

/***/ }),

/***/ "4ccb":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.iterator.js");

/***/ }),

/***/ "503b":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\r\n<svg viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->\r\n    <defs>\r\n        <path d=\"M3.80443443,5.51685566 L8.67806729,0.766150827 C8.95406217,0.44048717 9.43143253,0.409370647 9.74430382,0.696650128 C10.0571751,0.983929609 10.0870694,1.4808182 9.81107447,1.80648186 L4.36397272,7.23385857 C4.06080599,7.59158399 3.52393374,7.5881988 3.22495286,7.22667661 L0.182916667,4.54830223 C-0.0892675314,4.21918209 -0.0535921568,3.72270694 0.262599847,3.43939395 C0.57879185,3.15608096 1.055765,3.19321499 1.3279492,3.52233513 L3.80443443,5.51685566 Z\" id=\"path-1\"></path>\r\n    </defs>\r\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\r\n        <g transform=\"translate(2.000000, 3.000000)\">\r\n            <mask class=\"el-checkbox__mask\">\r\n                <use xlink:href=\"#path-1\"></use>\r\n            </mask>\r\n            <use class=\"el-checkbox__tick\" fill-rule=\"nonzero\" xlink:href=\"#path-1\"></use>\r\n        </g>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "5118":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("aca7");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "5225":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.every.js");

/***/ }),

/***/ "5a5e":
/***/ (function(module, exports) {

module.exports = require("@vue/babel-helper-vue-jsx-merge-props");

/***/ }),

/***/ "61b7":
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/esm/unsupportedIterableToArray");

/***/ }),

/***/ "6378":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.replace.js");

/***/ }),

/***/ "65ef":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\r\n<svg viewBox=\"5 5 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com -->\r\n    <title>ctrl_tick</title>\r\n    <desc>Created with Sketch.</desc>\r\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g class=\"el-checkbox__tick\">\r\n            <g transform=\"translate(5.000000, 5.000000)\">\r\n                <rect fill-opacity=\"0\" x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"1\" ></rect>\r\n                <g transform=\"translate(2.000000, 3.000000)\">\r\n                    <path d=\"M3.8044344,5.5168557 L8.6780673,0.76615083 C8.9540622,0.44048717 9.4314325,0.40937065 9.7443038,0.69665013 C10.0571751,0.98392961 10.0870694,1.4808182 9.8110745,1.80648186 L4.3639727,7.2338586 C4.060806,7.591584 3.5239337,7.5881988 3.2249529,7.2266766 L0.18291667,4.5483022 C-0.08926753,4.2191821 -0.05359216,3.7227069 0.26259985,3.4393939 C0.57879185,3.156081 1.055765,3.193215 1.3279492,3.5223351 L3.8044344,5.5168557 Z\"></path>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>"

/***/ }),

/***/ "69ce":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.date.to-string.js");

/***/ }),

/***/ "6d2b":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.function.bind.js");

/***/ }),

/***/ "6de0":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.get-own-property-descriptor.js");

/***/ }),

/***/ "7435":
/***/ (function(module, exports) {

module.exports = require("throttle-debounce/debounce");

/***/ }),

/***/ "7664":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.get-own-property-descriptors.js");

/***/ }),

/***/ "7df0":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.fixed.js");

/***/ }),

/***/ "8361":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.for-each.js");

/***/ }),

/***/ "84a7":
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/esm/iterableToArrayLimit");

/***/ }),

/***/ "8535":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.set.js");

/***/ }),

/***/ "85f7":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.includes.js");

/***/ }),

/***/ "86d1":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.regexp.constructor.js");

/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8f1c":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.some.js");

/***/ }),

/***/ "9224":
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"hui\",\"version\":\"2.16.1\",\"files\":[\"lib\",\"src\",\"packages\",\"types\"],\"main\":\"lib/hui.common.js\",\"author\":\"xiangxiao3\",\"license\":\"MIT\",\"bugs\":{\"url\":\"http://iris.hikvision.com.cn/hui-vue/hui-vue/issues\"},\"repository\":\"http://iris.hikvision.com.cn/hui-vue/hui-vue.git\",\"homePage\":\"http://hui.dev.hikhub.net/\",\"keywords\":[\"components\",\"hui\",\"common\"],\"cover\":\"http://hui.dev.hikhub.net/favicon.ico\",\"description\":\"A hik UI design language and Vue 2 components implementation\",\"changelog\":\"http://iris.hikvision.com.cn/hui-vue/hui-vue/blob/master/CHANGELOG.md\",\"scripts\":{\"dev\":\"vuepress dev docs\",\"build\":\"yarn lint && vuepress build docs\",\"build:all\":\"yarn test && yarn build && yarn lib:all\",\"lint\":\"vue-cli-service lint src packages && yarn lint:style\",\"lint:style\":\"stylelint packages/**/*.scss --fix\",\"cz:commit\":\"git-cz\",\"lib:all\":\"yarn lib:clean && yarn lib:i18n && yarn lib:common && yarn lib:umd\",\"lib:clean\":\"rimraf lib\",\"lib:common\":\"cross-env LIB_TYPE=common vue-cli-service build --no-clean --target lib --formats commonjs --name hui src/index.js\",\"lib:i18n\":\"cross-env NODE_ENV=i18n babel src/locale --out-dir lib/locale\",\"lib:umd\":\"cross-env LIB_TYPE=umd vue-cli-service build --no-clean --target lib --formats umd-min --name hui src/index.js\",\"release\":\"standard-version && npm run cz:changelog\",\"cz:changelog\":\"conventional-changelog -p angular -i CHANGELOG.md -s && git add CHANGELOG.md\",\"build:icon-data\":\"node docs/.vuepress/public/build/build-icon-data.js && node docs/.vuepress/public/build/build-svg-icon-data.js\",\"test:style\":\"sass packages/theme:packages/theme/release && rimraf packages/theme/release\",\"test\":\"cross-env NODE_ENV=test jest\"},\"dependencies\":{\"@soda/get-current-script\":\"^1.0.1\",\"async-validator\":\"1.6.9\",\"core-js\":\"^3.6.5\",\"deepmerge\":\"^1.5.2\",\"global\":\"^4.4.0\",\"resize-observer-polyfill\":\"^1.5.0\",\"throttle-debounce\":\"^1.0.1\"},\"devDependencies\":{\"@babel/cli\":\"^7.2.3\",\"@babel/core\":\"^7.8.4\",\"@babel/plugin-syntax-dynamic-import\":\"^7.2.0\",\"@commitlint/cli\":\"^8.3.5\",\"@commitlint/config-conventional\":\"^8.3.4\",\"@hui/eslint-config-vue\":\"1.0.6\",\"@hui/stylelint-scss\":\"1.0.2\",\"@hui/svg-icon\":\"^1.0.0\",\"@types/jest\":\"^24.0.18\",\"@typescript-eslint/eslint-plugin\":\"^1.11.0\",\"@typescript-eslint/parser\":\"^1.11.0\",\"@vue/cli-plugin-babel\":\"^4.3.0\",\"@vue/cli-plugin-eslint\":\"^4.3.0\",\"@vue/cli-service\":\"^4.3.0\",\"@vue/test-utils\":\"^1.0.3\",\"@vuepress/plugin-back-to-top\":\"^1.0.1\",\"axios\":\"^0.18.0\",\"babel-jest\":\"^24.8.0\",\"babel-plugin-module-resolver\":\"^3.1.3\",\"commitizen\":\"^4.1.2\",\"compass-sass-mixins\":\"^0.12.7\",\"conventional-changelog-cli\":\"^2.0.34\",\"cross-env\":\"^5.2.0\",\"css-prefers-color-scheme\":\"^4.0.0\",\"dart-sass\":\"^1.19.0\",\"eslint\":\"6.8.0\",\"eslint-formatter-friendly\":\"^7.0.0\",\"eslint-loader\":\"3.0.4\",\"git-cz\":\"^4.7.3\",\"highlightjs\":\"^9.12.0\",\"husky\":\"^4.2.5\",\"jest\":\"^24.8.0\",\"jest-svg-transformer\":\"^1.0.0\",\"lint-staged\":\"^8.1.3\",\"live-server\":\"^1.2.1\",\"mo-js\":\"^0.288.2\",\"moment\":\"^2.24.0\",\"normalize-wheel\":\"^1.0.1\",\"optimize-css-assets-webpack-plugin\":\"^5.0.3\",\"prettier\":\"^1.16.4\",\"raw-loader\":\"^0.5.1\",\"sass\":\"^1.19.0\",\"sass-loader\":\"8.0.2\",\"standard-version\":\"^8.0.0\",\"stylelint-webpack-plugin\":\"1.2.3\",\"typescript\":\"^3.5.2\",\"vue\":\"^2.5.21\",\"vue-cli-plugin-changelog\":\"^1.1.9\",\"vue-cli-plugin-lint-staged\":\"^0.1.1\",\"vue-jest\":\"^4.0.0-beta.2\",\"vue-template-compiler\":\"^2.5.21\",\"vuepress\":\"^1.0.0\",\"vuepress-plugin-lego-analytics\":\"^0.3.0\",\"webpack-node-externals\":\"^1.7.2\"},\"postcss\":{\"plugins\":{\"autoprefixer\":{}}},\"browserslist\":[\"defaults\"],\"commitlint\":{\"extends\":[\"@commitlint/config-conventional\"]},\"config\":{\"commitizen\":{\"path\":\"git-cz\"}},\"husky\":{\"hooks\":{\"commit-msg\":\"commitlint -E HUSKY_GIT_PARAMS\",\"post-merge\":\"yarn\",\"pre-commit\":\"lint-staged\"}},\"typings\":\"types/index.d.ts\"}");

/***/ }),

/***/ "94a6":
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/esm/arrayWithHoles");

/***/ }),

/***/ "96b3":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.index-of.js");

/***/ }),

/***/ "97d3":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.to-string.js");

/***/ }),

/***/ "9837":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.define-property.js");

/***/ }),

/***/ "9b22":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.symbol.js");

/***/ }),

/***/ "9bb0":
/***/ (function(module, exports) {

module.exports = require("@soda/get-current-script");

/***/ }),

/***/ "9bb5":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.iterator.js");

/***/ }),

/***/ "a1cc":
/***/ (function(module, exports) {

module.exports = require("resize-observer-polyfill");

/***/ }),

/***/ "a9aa":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/web.timers.js");

/***/ }),

/***/ "aca7":
/***/ (function(module, exports) {

module.exports = require("setimmediate");

/***/ }),

/***/ "ad1b":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.assign.js");

/***/ }),

/***/ "b684":
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/esm/nonIterableRest");

/***/ }),

/***/ "b7ac":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.reduce.js");

/***/ }),

/***/ "b94f":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/web.url.js");

/***/ }),

/***/ "be94":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.join.js");

/***/ }),

/***/ "bf90":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.anchor.js");

/***/ }),

/***/ "c74c":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.match.js");

/***/ }),

/***/ "c8a6":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.regexp.exec.js");

/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ccb0":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.concat.js");

/***/ }),

/***/ "ccb3":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.number.to-fixed.js");

/***/ }),

/***/ "d08f":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.link.js");

/***/ }),

/***/ "d096":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.fill.js");

/***/ }),

/***/ "db0a":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.function.name.js");

/***/ }),

/***/ "e01a":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.values.js");

/***/ }),

/***/ "e354":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.parse-float.js");

/***/ }),

/***/ "e893":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.date.now.js");

/***/ }),

/***/ "ea12":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.slice.js");

/***/ }),

/***/ "ea64":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.keys.js");

/***/ }),

/***/ "eb54":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./checkbox_checked.svg": "503b",
	"./ctrl_tick.svg": "65ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb54";

/***/ }),

/***/ "ec71":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.promise.js");

/***/ }),

/***/ "ed0f":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.create.js");

/***/ }),

/***/ "efd2":
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/esm/nonIterableSpread");

/***/ }),

/***/ "f319":
/***/ (function(module, exports) {

module.exports = require("querystring");

/***/ }),

/***/ "f3b8":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.splice.js");

/***/ }),

/***/ "f3ec":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.is-array.js");

/***/ }),

/***/ "f655":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.number.to-precision.js");

/***/ }),

/***/ "f906":
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/esm/iterableToArray");

/***/ }),

/***/ "f989":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.number.constructor.js");

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("9bb0")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: external "core-js/modules/es.array.map.js"
var es_array_map_js_ = __webpack_require__("4391");

// EXTERNAL MODULE: external "core-js/modules/es.function.name.js"
var es_function_name_js_ = __webpack_require__("db0a");

// EXTERNAL MODULE: external "core-js/modules/es.array.for-each.js"
var es_array_for_each_js_ = __webpack_require__("8361");

// EXTERNAL MODULE: external "core-js/modules/es.array.index-of.js"
var es_array_index_of_js_ = __webpack_require__("96b3");

// EXTERNAL MODULE: external "core-js/modules/es.array.is-array.js"
var es_array_is_array_js_ = __webpack_require__("f3ec");

// EXTERNAL MODULE: external "core-js/modules/es.array.join.js"
var es_array_join_js_ = __webpack_require__("be94");

// EXTERNAL MODULE: external "core-js/modules/es.number.constructor.js"
var es_number_constructor_js_ = __webpack_require__("f989");

// EXTERNAL MODULE: external "core-js/modules/es.object.to-string.js"
var es_object_to_string_js_ = __webpack_require__("97d3");

// EXTERNAL MODULE: external "core-js/modules/es.parse-int.js"
var es_parse_int_js_ = __webpack_require__("3910");

// EXTERNAL MODULE: external "core-js/modules/es.promise.js"
var es_promise_js_ = __webpack_require__("ec71");

// EXTERNAL MODULE: external "core-js/modules/es.regexp.exec.js"
var es_regexp_exec_js_ = __webpack_require__("c8a6");

// EXTERNAL MODULE: external "core-js/modules/es.string.replace.js"
var es_string_replace_js_ = __webpack_require__("6378");

// EXTERNAL MODULE: external "core-js/modules/es.string.split.js"
var es_string_split_js_ = __webpack_require__("0cda");

// EXTERNAL MODULE: external "core-js/modules/es.string.trim.js"
var es_string_trim_js_ = __webpack_require__("105d");

// EXTERNAL MODULE: external "core-js/modules/es.string.small.js"
var es_string_small_js_ = __webpack_require__("4131");

// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.for-each.js"
var web_dom_collections_for_each_js_ = __webpack_require__("13e3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=template&id=fcca394c&
var pagervue_type_template_id_fcca394c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"el-pager",on:{"click":_vm.onPagerClick}},[(_vm.pageCount > 0)?_c('li',{staticClass:"number",class:{ active: _vm.currentPage === 1, disabled: _vm.disabled }},[_vm._v(" 1 ")]):_vm._e(),(_vm.showPrevMore)?_c('el-tooltip',{attrs:{"content":_vm.t('el.pagination.prevMore', { count: _vm.pageCountOffset }),"effect":"light","placement":"top"}},[_c('li',{staticClass:"el-icon more btn-quickprev",class:[_vm.quickprevIconClass, { disabled: _vm.disabled }],on:{"mouseenter":function($event){return _vm.onMouseenter('left')},"mouseleave":function($event){_vm.quickprevIconClass = 'h-icon-more_hori'}}})]):_vm._e(),_vm._l((_vm.pagers),function(pager){return _c('li',{key:pager,staticClass:"number",class:{ active: _vm.currentPage === pager, disabled: _vm.disabled }},[_vm._v(" "+_vm._s(pager)+" ")])}),(_vm.showNextMore)?_c('el-tooltip',{attrs:{"content":_vm.t('el.pagination.nextMore', { count: _vm.pageCountOffset }),"effect":"light","placement":"top"}},[_c('li',{staticClass:"el-icon more btn-quicknext",class:[_vm.quicknextIconClass, { disabled: _vm.disabled }],on:{"mouseenter":function($event){return _vm.onMouseenter('right')},"mouseleave":function($event){_vm.quicknextIconClass = 'h-icon-more_hori'}}})]):_vm._e(),(_vm.pageCount > 1)?_c('li',{staticClass:"number",class:{ active: _vm.currentPage === _vm.pageCount, disabled: _vm.disabled }},[_vm._v(" "+_vm._s(_vm.pageCount)+" ")]):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=template&id=fcca394c&

// EXTERNAL MODULE: external "hui/lib/locale"
var locale_ = __webpack_require__("0a57");
var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);

// CONCATENATED MODULE: ./src/mixins/locale.js

/* harmony default export */ var locale = ({
  methods: {
    t: function t() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return locale_["t"].apply(this, args);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pagervue_type_script_lang_js_ = ({
  name: 'ElPager',
  mixins: [locale],
  props: {
    currentPage: {
      type: Number,
      "default": null
    },
    pageCount: {
      type: Number,
      "default": null
    },
    pagerCount: {
      type: Number,
      "default": 7
    },
    disabled: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      current: null,
      quicknextIconClass: 'h-icon-more_hori',
      quickprevIconClass: 'h-icon-more_hori',
      showPrevMore: false,
      showNextMore: false
    };
  },
  computed: {
    pagers: function pagers() {
      var array = [];
      var pagerCount = this.pagerCount;
      var halfPagerCount = Math.floor(pagerCount / 2);
      var currentPage = Number(this.currentPage);
      var pageCount = Number(this.pageCount);
      var showPrevMore = false;
      var showNextMore = false;

      if (pageCount > pagerCount) {
        if (currentPage > pagerCount - halfPagerCount) {
          showPrevMore = true;
        }

        if (currentPage < pageCount - halfPagerCount) {
          showNextMore = true;
        }
      }

      if (showPrevMore && !showNextMore) {
        var startPage = pageCount - (pagerCount - 2);

        for (var i = startPage; i < pageCount; i++) {
          array.push(i);
        }
      } else if (!showPrevMore && showNextMore) {
        for (var _i = 2; _i < pagerCount; _i++) {
          array.push(_i);
        }
      } else if (showPrevMore && showNextMore) {
        var offset = Math.floor(pagerCount / 2) - 1; // 对pagerCount为偶数的情况做处理, 但是不推荐用户使用偶数的pagerCount

        var startNum = pagerCount % 2 ? currentPage - offset : currentPage - offset + 1;

        for (var _i2 = startNum; _i2 <= currentPage + offset; _i2++) {
          array.push(_i2);
        }
      } else {
        for (var _i3 = 2; _i3 < pageCount; _i3++) {
          array.push(_i3);
        }
      } // eslint-disable-next-line vue/no-side-effects-in-computed-properties


      this.showPrevMore = showPrevMore; // eslint-disable-next-line vue/no-side-effects-in-computed-properties

      this.showNextMore = showNextMore;
      return array;
    },
    pageCountOffset: function pageCountOffset() {
      return Number(this.pagerCount) >= 2 ? Number(this.pagerCount) - 2 : 2;
    }
  },
  watch: {
    showPrevMore: function showPrevMore(val) {
      if (!val) this.quickprevIconClass = 'h-icon-more_hori';
    },
    showNextMore: function showNextMore(val) {
      if (!val) this.quicknextIconClass = 'h-icon-more_hori';
    }
  },
  methods: {
    onPagerClick: function onPagerClick(event) {
      var target = event.target;

      if (target.tagName === 'UL' || this.disabled) {
        return;
      }

      var newPage = Number(event.target.textContent);
      var pageCount = this.pageCount;
      var currentPage = this.currentPage;

      if (target.className.indexOf('more') !== -1) {
        if (target.className.indexOf('quickprev') !== -1) {
          newPage = currentPage - this.pageCountOffset;
        } else if (target.className.indexOf('quicknext') !== -1) {
          newPage = currentPage + this.pageCountOffset;
        }
      }
      /* istanbul ignore if */


      if (!isNaN(newPage)) {
        if (newPage < 1) {
          newPage = 1;
        }

        if (newPage > pageCount) {
          newPage = pageCount;
        }
      }

      if (newPage !== currentPage) {
        this.$emit('change', newPage);
      }
    },
    onMouseenter: function onMouseenter(direction) {
      if (this.disabled) return;

      if (direction === 'left') {
        this.quickprevIconClass = 'h-icon-angles_left_sm';
      } else {
        this.quicknextIconClass = 'h-icon-angles_right_sm';
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_pagervue_type_script_lang_js_ = (pagervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./packages/pagination/src/pager.vue





/* normalize component */

var component = normalizeComponent(
  src_pagervue_type_script_lang_js_,
  pagervue_type_template_id_fcca394c_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var pager = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=ab079138&
var selectvue_type_template_id_ab079138_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.handleClose),expression:"handleClose"}],staticClass:"el-select",class:[_vm.kind ? 'el-select--' + _vm.kind : '']},[(_vm.multiple)?_c('div',{ref:"tags",staticClass:"el-select__tags",class:{
      'el-select__tags--nowrap': _vm.multipleNowrap,
      'el-select__tags--filterable-left': _vm.multipleNowrap && _vm.filterable
    },style:({ 'max-width': _vm.inputWidth - _vm.inputWidthMin + 'px' }),on:{"click":function($event){$event.stopPropagation();return _vm.toggleMenu($event)}}},[(_vm.collapseTags && _vm.selected.length)?_c('span',[_c('el-tag',{class:[
          {
            'el-tag--disabled': _vm.disabled
          }
        ],attrs:{"closable":!_vm.selected[0].disabled,"size":_vm.collapseTagSize,"title":_vm.selected[0].currentLabel,"hit":_vm.selected[0].hitState,"max-width":"94px","type":"primary","close-transitions":""},on:{"close":function($event){return _vm.deleteTag($event, _vm.selected[0])}}},[_c('span',{staticClass:"el-select__tags-text"},[_vm._v(" "+_vm._s(_vm.selected[0].currentLabel)+" ")])]),(_vm.selected.length > 1)?_c('el-tag',{attrs:{"closable":false,"size":_vm.collapseTagSize,"type":"primary","close-transitions":""}},[_c('span',{staticClass:"el-select__tags-text"},[_vm._v("+ "+_vm._s(_vm.selected.length - 1))])]):_vm._e()],1):_vm._e(),(!_vm.collapseTags)?_c('transition-group',{on:{"after-leave":_vm.resetInputHeight}},_vm._l((_vm.selected),function(item){return _c('el-tag',{key:_vm.getValueKey(item),class:[
          {
            'el-tag--disabled': _vm.disabled
          }
        ],attrs:{"title":item.currentLabel,"closable":!item.disabled,"size":_vm.collapseTagSize,"hit":item.hitState,"max-width":"94px","type":"primary","close-transition":""},on:{"close":function($event){return _vm.deleteTag($event, item)}}},[_c('span',{staticClass:"el-select__tags-text"},[_vm._v(_vm._s(item.currentLabel))])])}),1):_vm._e(),(_vm.filterable)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],ref:"input",staticClass:"el-select__input",class:("is-" + _vm.size),style:({
        width: _vm.textWidth + 16 + 'px',
        'max-width': _vm.inputWidth - _vm.inputWidthMin + 'px'
      }),attrs:{"disabled":_vm.disabled,"debounce":_vm.remote ? 300 : 0,"type":"text"},domProps:{"value":(_vm.query)},on:{"keyup":_vm.managePlaceholder,"keydown":[function($event){if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.resetInputState($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.navigateOptions('next')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.navigateOptions('prev')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.selectOption($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.stopPropagation();$event.preventDefault();_vm.visible = false},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }return _vm.deletePrevTag($event)}],"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}):_vm._e()],1):_vm._e(),_c('span',{ref:"text",staticClass:"el-select__text",domProps:{"textContent":_vm._s(_vm.query)}}),(_vm.isIE && !_vm.multiple && !_vm.filterable)?_c('div',{staticClass:"el-select__isIE",attrs:{"icon":_vm.iconClass},on:{"click":_vm.toggleMenu,"mouseenter":function($event){_vm.inputHovering = true},"mouseleave":function($event){_vm.inputHovering = false}}}):_vm._e(),_c('el-input',{ref:"reference",attrs:{"title":_vm.selectedLabel,"placeholder":_vm.currentPlaceholder,"select":_vm.inputClear,"name":_vm.name,"size":_vm.size,"disabled":_vm.disabled,"readonly":!_vm.filterable || _vm.multiple,"unselectable":_vm.isIE && !_vm.multiple && !_vm.filterable ? 'on' : 'off',"validate-event":false,"type":"text"},on:{"focus":_vm.handleFocus,"blur":_vm.handleBlur,"click":_vm.handleIconClick,"input":_vm.debouncedOnInputChange},nativeOn:{"mousedown":function($event){return _vm.handleMouseDown($event)},"keyup":function($event){return _vm.debouncedOnInputChange($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.navigateOptions('next')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.navigateOptions('prev')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.selectOption($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.stopPropagation();$event.preventDefault();_vm.visible = false},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }_vm.visible = false}],"paste":function($event){return _vm.debouncedOnInputChange($event)},"mouseenter":function($event){_vm.inputHovering = true},"mouseleave":function($event){_vm.inputHovering = false}},model:{value:(_vm.selectedLabel),callback:function ($$v) {_vm.selectedLabel=$$v},expression:"selectedLabel"}},[(_vm.$slots.prefix)?_c('template',{slot:"prefix"},[_vm._t("prefix")],2):_vm._e(),_c('i',{staticClass:"el-input__icon",class:_vm.iconClass,attrs:{"slot":"suffix"},on:{"click":_vm.handleIconClick},slot:"suffix"})],2),_c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"before-enter":_vm.handleMenuEnter,"after-enter":_vm.afterEnter,"after-leave":_vm.doDestroy}},[_c('el-select-menu',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropdown),expression:"showDropdown"}],ref:"popper",attrs:{"append-to-body":_vm.popperAppendToBody}},[_c('el-scrollbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.length > 0 && !_vm.loading),expression:"options.length > 0 && !loading"}],ref:"scrollbar",class:{
          'is-empty': !_vm.allowCreate && _vm.filteredOptionsCount === 0
        },attrs:{"always-show":"","is-small":"","tag":"ul","wrap-class":"el-select-dropdown__wrap","view-class":"el-select-dropdown__list"},on:{"on-scrolling-x":_vm.onScrollingX,"on-scrolling-y":_vm.onScrollingY}},[_vm._t("default"),(_vm.showNewOption)?_c('el-option',{attrs:{"value":_vm.query,"created":""}}):_vm._e()],2),(
          _vm.emptyText && ((_vm.allowCreate && _vm.options.length === 0) || !_vm.allowCreate)
        )?_c('p',{staticClass:"el-select-dropdown__empty"},[_vm._v(" "+_vm._s(_vm.emptyText)+" ")]):_vm._e()],1)],1)],1)}
var selectvue_type_template_id_ab079138_staticRenderFns = []


// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=ab079138&

// EXTERNAL MODULE: external "core-js/modules/es.array.filter.js"
var es_array_filter_js_ = __webpack_require__("1a89");

// EXTERNAL MODULE: external "core-js/modules/es.array.slice.js"
var es_array_slice_js_ = __webpack_require__("ea12");

// EXTERNAL MODULE: external "core-js/modules/es.array.some.js"
var es_array_some_js_ = __webpack_require__("8f1c");

// EXTERNAL MODULE: external "core-js/modules/es.array.splice.js"
var es_array_splice_js_ = __webpack_require__("f3b8");

// EXTERNAL MODULE: external "core-js/modules/es.date.to-string.js"
var es_date_to_string_js_ = __webpack_require__("69ce");

// EXTERNAL MODULE: external "core-js/modules/es.regexp.to-string.js"
var es_regexp_to_string_js_ = __webpack_require__("30df");

// EXTERNAL MODULE: external "core-js/modules/web.timers.js"
var web_timers_js_ = __webpack_require__("a9aa");

// EXTERNAL MODULE: external "core-js/modules/es.symbol.js"
var es_symbol_js_ = __webpack_require__("9b22");

// EXTERNAL MODULE: external "core-js/modules/es.symbol.description.js"
var es_symbol_description_js_ = __webpack_require__("4933");

// EXTERNAL MODULE: external "core-js/modules/es.symbol.iterator.js"
var es_symbol_iterator_js_ = __webpack_require__("2ff9");

// EXTERNAL MODULE: external "core-js/modules/es.array.iterator.js"
var es_array_iterator_js_ = __webpack_require__("4ccb");

// EXTERNAL MODULE: external "core-js/modules/es.string.iterator.js"
var es_string_iterator_js_ = __webpack_require__("9bb5");

// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.iterator.js"
var web_dom_collections_iterator_js_ = __webpack_require__("1a25");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
// EXTERNAL MODULE: external "core-js/modules/es.array.concat.js"
var es_array_concat_js_ = __webpack_require__("ccb0");

// CONCATENATED MODULE: ./src/mixins/emitter.js




function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}

/* harmony default export */ var emitter = ({
  methods: {
    /**
     * @desc 若存在指定的父控件，触发他的指定事件
     * @example Form中使用Input控件，Input失去焦点，触发Form的失去焦点事件
     * @param {String} componentName 父控件的名称
     * @param {String} eventName 需要触发的事件名称
     * @param {Object} params 事件参数
     */
    dispatch: function dispatch(componentName, eventName, params) {
      // 获取父组件，如果是根组件，则是$root
      var parent = this.$parent || this.$root; // 获取父节点的组件名

      var name = parent.$options.componentName; // 当父组件不是所需组件时继续向上寻找

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      } // 找到所需组件后调用$emit触发当前事件


      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    // 与dispatch相反
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=cc2eab2a&
var inputvue_type_template_id_cc2eab2a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",class:[
    _vm.type === 'textarea' ? 'el-textarea' : 'el-input',
    _vm.kind ? 'el-input--' + _vm.kind : '',
    _vm.size ? 'el-input--' + _vm.size : '',
    {
      'is-disabled': _vm.disabled,
      'is-count': _vm.count,
      'el-input-group': _vm.$slots.prepend || _vm.$slots.append,
      'el-input-group--append': _vm.$slots.append,
      'el-input-group--prepend': _vm.$slots.prepend,
      'el-input--prefix': _vm.$slots.prefix || _vm.prefixIcon,
      'el-input--suffix': _vm.$slots.suffix || _vm.suffixIcon,
      'is-hover': _vm.count && _vm.isHover,
      'is-focus': _vm.count && _vm.isFocus
    }
  ]},[(_vm.type !== 'textarea')?[(_vm.$slots.prepend)?_c('div',{staticClass:"el-input-group__prepend"},[_vm._t("prepend")],2):_vm._e(),_vm._t("icon",[(_vm.icon)?_c('i',{staticClass:"el-input__icon",class:[
          _vm.icon,
          _vm.onIconClick || _vm.onMousedownClick || _vm.onMouseupClick
            ? 'is-clickable'
            : ''
        ],style:(_vm.suffixOffset),on:{"click":_vm.handleIconClick,"mousedown":_vm.handleMousedownClick,"mouseup":_vm.handleMouseupClick}}):_vm._e()]),(_vm.clearable && _vm.value && (String(_vm.value).length || _vm.select))?_c('i',{staticClass:"el-input__icon h-icon-close_f is-clickable",style:({
        right: _vm.$slots.suffix || _vm.suffixIcon ? 28 + 'px' : 4 + 'px',
        transform: _vm.suffixOffset ? _vm.suffixOffset.transform : 0,
        zIndex: 1
      }),on:{"click":_vm.handleClearClick}}):_vm._e(),(_vm.tips)?[_c('el-popover',{ref:"popoverInput",attrs:{"content":_vm.tips,"max-width":_vm.tipsMaxWidth,"placement":_vm.tipsPlacement,"trigger":_vm.tipsTrigger,"disabled":_vm.tipsDisabled,"show-html":true,"offset-placement":_vm.tipsOffset,"popper-class":("el-popover__for-input " + _vm.tipsClass + " el-popover__for-input-form"),"effect":"light"}},[_c('input',_vm._b({ref:"input",staticClass:"el-input__inner",style:(_vm.inputStyle),attrs:{"slot":"reference","autocomplete":_vm.autoComplete},domProps:{"value":_vm.nativeInputValue},on:{"compositionstart":_vm.handleCompositionStart,"compositionend":_vm.handleCompositionEnd,"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur},slot:"reference"},'input',[_vm.$props, _vm.$attrs],false))])]:[_c('input',_vm._b({ref:"input",staticClass:"el-input__inner",style:(_vm.inputStyle),attrs:{"autocomplete":_vm.autoComplete},domProps:{"value":_vm.nativeInputValue},on:{"compositionstart":_vm.handleCompositionStart,"compositionend":_vm.handleCompositionEnd,"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur}},'input',[_vm.$props, _vm.$attrs],false))],(_vm.$slots.prefix || _vm.prefixIcon)?_c('span',{ref:"prefix",staticClass:"el-input__prefix",style:(_vm.prefixOffset)},[_vm._t("prefix"),(_vm.prefixIcon)?_c('i',{staticClass:"el-input__icon",class:_vm.prefixIcon,on:{"click":_vm.handleIconClick}}):_vm._e()],2):_vm._e(),(_vm.$slots.suffix || _vm.suffixIcon)?_c('span',{ref:"suffix",staticClass:"el-input__suffix",style:(_vm.suffixOffset)},[_c('span',{staticClass:"el-input__suffix-inner"},[[_vm._t("suffix"),(_vm.suffixIcon)?_c('i',{staticClass:"el-input__icon",class:_vm.suffixIcon,on:{"click":_vm.handleIconClick}}):_vm._e()]],2)]):_vm._e(),(_vm.validating)?_c('i',{staticClass:"el-input__icon el-validate__icon el-icon-restart"}):_vm._e(),(_vm.$slots.append)?_c('div',{staticClass:"el-input-group__append"},[_vm._t("append")],2):_vm._e()]:[(_vm.tips)?[_c('el-popover',{ref:"popoverTextarea",attrs:{"content":_vm.tips,"max-width":_vm.tipsMaxWidth,"placement":_vm.tipsPlacement,"trigger":_vm.tipsTrigger,"disabled":_vm.tipsDisabled,"show-html":true,"offset-placement":_vm.tipsOffset,"popper-class":("el-popover__for-input " + _vm.tipsClass + " el-popover__for-input-form"),"effect":"light"}},[_c('textarea',_vm._b({ref:"textarea",staticClass:"el-textarea__inner",style:(_vm.textareaStyle),attrs:{"slot":"reference"},domProps:{"value":_vm.nativeInputValue},on:{"compositionstart":_vm.handleCompositionStart,"compositionend":_vm.handleCompositionEnd,"input":_vm.handleInput,"mouseenter":_vm.handleMouseenter,"mouseout":_vm.handleMouseout,"focus":_vm.handleFocus,"blur":_vm.handleBlur},slot:"reference"},'textarea',[_vm.$props, _vm.$attrs],false))]),(_vm.count)?_c('span',{staticClass:"el-textarea__count",domProps:{"textContent":_vm._s(_vm.total)}}):_vm._e()]:[_c('textarea',_vm._b({ref:"textarea",staticClass:"el-textarea__inner",style:(_vm.textareaStyle),domProps:{"value":_vm.nativeInputValue},on:{"compositionstart":_vm.handleCompositionStart,"compositionend":_vm.handleCompositionEnd,"mouseenter":_vm.handleMouseenter,"mouseout":_vm.handleMouseout,"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur}},'textarea',[_vm.$props, _vm.$attrs],false)),_vm._v(" "),(_vm.count)?_c('span',{staticClass:"el-textarea__count",domProps:{"textContent":_vm._s(_vm.total)}}):_vm._e()]]],2)}
var inputvue_type_template_id_cc2eab2a_staticRenderFns = []


// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=cc2eab2a&

// EXTERNAL MODULE: external "core-js/modules/es.parse-float.js"
var es_parse_float_js_ = __webpack_require__("e354");

// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js




var hiddenTextarea;
var HIDDEN_STYLE = "\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];

function calculateNodeStyling(targetElement) {
  var style = window.getComputedStyle(targetElement);
  var boxSizing = style.getPropertyValue('box-sizing');
  var paddingWidth = parseFloat(style.getPropertyValue('padding-left')) + parseFloat(style.getPropertyValue('padding-right'));
  var paddingHeight = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
  var borderWidth = parseFloat(style.getPropertyValue('border-left-width')) + parseFloat(style.getPropertyValue('border-right-width'));
  var borderHeight = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
  var lineHeight = parseFloat(style.getPropertyValue('line-height'));
  var contextStyle = CONTEXT_STYLE.map(function (name) {
    return "".concat(name, ":").concat(style.getPropertyValue(name));
  }).join(';');
  return {
    contextStyle: contextStyle,
    paddingWidth: paddingWidth,
    paddingHeight: paddingHeight,
    borderWidth: borderWidth,
    borderHeight: borderHeight,
    lineHeight: lineHeight,
    boxSizing: boxSizing
  };
}

function calcTextareaHeight(targetElement, rect) {
  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var maxWidth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  }

  var style = {};

  var _calculateNodeStyling = calculateNodeStyling(targetElement),
      contextStyle = _calculateNodeStyling.contextStyle,
      paddingHeight = _calculateNodeStyling.paddingHeight,
      borderHeight = _calculateNodeStyling.borderHeight,
      boxSizing = _calculateNodeStyling.boxSizing;

  hiddenTextarea.setAttribute('style', "".concat(contextStyle, ";").concat(HIDDEN_STYLE));
  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';
  var height = hiddenTextarea.scrollHeight;

  if (boxSizing === 'border-box') {
    height = height + borderHeight;
  } else if (boxSizing === 'content-box') {
    height = height - paddingHeight;
  }

  hiddenTextarea.value = '';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingHeight;

  if (minRows !== null) {
    var minHeight = singleRowHeight * minRows;

    if (boxSizing === 'border-box') {
      minHeight = minHeight + paddingHeight + borderHeight;
    }

    height = Math.max(minHeight, height);
    style.minHeight = "".concat(minHeight, "px");
  }

  if (maxRows !== null) {
    var maxHeight = singleRowHeight * maxRows;

    if (boxSizing === 'border-box') {
      maxHeight = maxHeight + paddingHeight + borderHeight;
    }

    height = Math.min(maxHeight, height);
    style.maxHeight = "".concat(maxHeight, "px");
  }

  style.height = "".concat(height, "px");

  if (maxWidth) {
    style.maxWidth = "".concat(+maxWidth, "px");
  }

  return style;
}
// EXTERNAL MODULE: external "core-js/modules/es.array.reduce.js"
var es_array_reduce_js_ = __webpack_require__("b7ac");

// CONCATENATED MODULE: ./src/utils/util.js













var util_hasOwnProperty = Object.prototype.hasOwnProperty;
function noop() {}
function hasOwn(obj, key) {
  return util_hasOwnProperty.call(obj, key);
}

function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }

  return to;
}

function toObject(arr) {
  var res = {};

  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }

  return res;
}
var getValueByPath = function getValueByPath(object, prop) {
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;

  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }

    current = current[path];
  }

  return result;
};
function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');
  var keyArr = path.split('.');
  var i = 0;

  for (var len = keyArr.length; i < len - 1; ++i) {
    var key = keyArr[i];

    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }

      break;
    }
  }

  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj[keyArr[i]]
  };
}
/**
 * 原生ajax
 * add by zhangxiaogang 2017-09-27
 * @param {string} opt.method http连接的方式，包括POST和GET两种方式
 * @param {string} opt.url 发送请求的url
 * @param {boolean} opt.async 是否为异步请求，true为异步的，false为同步的
 * @param {object} opt.data 发送的参数，格式为对象类型
 * @param {object} opt.dataType 返回的数据格式，默认json，如果返回原生text格式请传入dataType:'text'

 * @param {function} opt.success ajax发送并接收成功调用的回调函数
 * @param {function} opt.error ajax请求失败的回调
 */

function ajax(opt) {
  opt = opt || {};
  opt.type = opt.method && opt.method.toUpperCase() || 'GET';
  opt.url = opt.url || '';
  opt.async = !!opt.async;
  opt.data = opt.data || opt.params || {};
  var xmlHttp = null;

  if (XMLHttpRequest) {
    xmlHttp = new XMLHttpRequest();
  } else {
    xmlHttp = new window.ActiveXObject('Microsoft.XMLHTTP');
  }

  var params = [];

  for (var key in opt.data) {
    params.push(key + '=' + opt.data[key]);
  }

  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState === 4) {
      if (xmlHttp.status === 200) {
        var resp = xmlHttp.responseText;

        if (opt.dataType !== 'text') {
          resp = JSON.parse(resp);
        }

        opt.success && opt.success(resp);
      } else {
        opt.error && opt.error(new Error(xmlHttp.statusText));
      }
    }
  };

  var postData = params.join('&');

  if (opt.type.toUpperCase() === 'POST') {
    xmlHttp.open(opt.type, opt.url, opt.async);
    xmlHttp.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8');

    if (opt.headers) {
      for (var c in opt.headers) {
        xmlHttp.setRequestHeader(c, opt.headers[c]);
      }
    }

    xmlHttp.send(postData);
  } else if (opt.type.toUpperCase() === 'GET') {
    var connector = ~opt.url.indexOf('?') ? '&' : '?';
    xmlHttp.open(opt.type, opt.url + (postData && connector) + postData, opt.async);
    xmlHttp.send(null);
  }
}
/**
 * 返回包含ajax功能的promise函数对象
 * add by zhangxiaogang 2017-09-27
 * @param {object} opt ajax请求传参
 */


function defaultPromise(opt) {
  if (Object.prototype.toString.call(opt) !== '[object Object]') return null;
  return new window.Promise(function (resolve, reject) {
    opt.success = resolve;
    opt.error = reject;
    ajax(opt);
  });
}
/**
 * 深度合并对象
 * add by zhangxiaogang 2018-05-04
 */

function objectMerge(to, from) {
  for (var key in from) {
    to[key] = to[key] && to[key].toString() === '[object Object]' ? objectMerge(to[key], from[key]) : to[key] = from[key];
  }

  return to;
} // TODO: use native Array.find, Array.findIndex when IE support is dropped

var arrayFindIndex = function arrayFindIndex(arr, pred) {
  for (var i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }

  return -1;
};
var arrayFind = function arrayFind(arr, pred) {
  var idx = arrayFindIndex(arr, pred);
  return idx !== -1 ? arr[idx] : undefined;
}; // coerce truthy value to array

var coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};
var generateId = function generateId() {
  return Math.floor(Math.random() * 10000);
};
/**
 * @desc 找到子组件中的目标组件
 * @author chenguanbin
 * @param {Object} context 父组件
 * @param {String} componentName 子组件名称
 */

var findComponentsDownward = function findComponentsDownward(context, componentName) {
  return context.$children.reduce(function (components, child) {
    if (child.$options.name === componentName) components.push(child);
    var foundChilds = findComponentsDownward(child, componentName);
    return components.concat(foundChilds);
  }, []);
};
/**
 * Check if the given variable is a function
 * @function
 * @author fanzhuohua
 * @argument {*} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */

function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
// CONCATENATED MODULE: ./src/utils/merge.js

/**
 * 合并对象
 * @param {Object} target 要合并到的对象
 * @returns {Object} 合并后的新对象
 */

/* harmony default export */ var merge = (function (target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    // 从第二个参数开始
    var source = arguments[i] || {}; // 获取该对象

    for (var prop in source) {
      if (hasOwn(source, prop)) {
        // 只处理不是从原型链上继承来的属性
        var value = source[prop];

        if (value !== undefined) {
          target[prop] = value; // 覆盖
        }
      }
    }
  }

  return target;
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=084ce9fc&
var mainvue_type_template_id_084ce9fc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"el-popover-wrap"},[_c('transition',{attrs:{"name":_vm.transition},on:{"after-leave":_vm.doDestroy}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled && _vm.showPopper),expression:"!disabled && showPopper"}],ref:"popper",staticClass:"el-popover",class:[_vm.popperClass],style:(_vm.popoverStyle)},[(_vm.title)?_c('div',{staticClass:"el-popover__title",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),(_vm.showContent)?_vm._t("default",[_vm._v(_vm._s(_vm.content))]):_vm._e()],2)]),_vm._t("reference")],2)}
var mainvue_type_template_id_084ce9fc_staticRenderFns = []


// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=084ce9fc&

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: external "core-js/modules/es.object.assign.js"
var es_object_assign_js_ = __webpack_require__("ad1b");

// CONCATENATED MODULE: ./src/utils/dom.js








/* istanbul ignore next */


var isServer = external_vue_default.a.prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);
/* istanbul ignore next */

var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */


var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};
/* istanbul ignore next */


var on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();
/* istanbul ignore next */

var off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();
/* istanbul ignore next */

var once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }

    off(el, event, listener);
  };

  on(el, event, listener);
};
/* istanbul ignore next */

function hasClass(el, cls) {
  if (!el || !cls) return false;

  if (cls.indexOf(' ') !== -1) {
    throw new Error('className should not contain space.');
  }

  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
}
/* istanbul ignore next */

function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else {
      if (!hasClass(el, clsName)) {
        curClass += ' ' + clsName;
      }
    }
  }

  if (!el.classList) {
    el.className = curClass;
  }
}
/* istanbul ignore next */

function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else {
      if (hasClass(el, clsName)) {
        curClass = curClass.replace(' ' + clsName + ' ', ' ');
      }
    }
  }

  if (!el.classList) {
    el.className = trim(curClass);
  }
}
/* istanbul ignore next */

var getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);

  if (styleName === 'float') {
    styleName = 'styleFloat';
  }

  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }

      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);

  if (styleName === 'float') {
    styleName = 'cssFloat';
  }

  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};
/* istanbul ignore next */

function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if (_typeof(styleName) === 'object') {
    for (var prop in styleName) {
      if (hasOwn(styleName, prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);

    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
}
/**
 * 查找最近的符合条件的祖先元素
 * @param {被查询的元素} element
 * @param {选择器} selector
 */

function closest(element, selector) {
  if (!element || !selector) return;
  var targetNode = null;

  var traverse = function traverse(element) {
    if (element === document) {
      return;
    }

    var nodes = element.parentNode.querySelectorAll(selector);

    if (nodes && nodes.length) {
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i] === element) {
          targetNode = element;
          return;
        }
      }
    }

    traverse(element.parentNode);
  };

  traverse(element);
  return targetNode;
}
/**
 * @desc 返回滚动条的滚动高度
 * @author chenguanbin
 * @param {Boolean} top 是否是获取顶部的左上角的Y坐标
 */

function getScroll(top) {
  var ret = window['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = window.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}
/**
 * @desc 返回当前页面相对于窗口显示区左上角的 X ，Y 的位置
 * @author chenguanbin
 * @param {Document} el 需要获取位置的元素
 * @param {Document} container 容器元素
 */

function getOffset(el, container) {
  container = container || document.body;
  var elRect = el.getBoundingClientRect();
  var containerRect = container.getBoundingClientRect();
  var clientTop = el.clientTop || container.clientTop || 0;
  var clientLeft = el.clientLeft || container.clientLeft || 0;
  var top, left;

  if (container === document.body) {
    top = getScroll(true);
    left = getScroll();
  } else {
    top = container.scrollTop - containerRect.top;
    left = container.scrollLeft - containerRect.left;
  }

  return {
    top: elRect.top + top - clientTop,
    left: elRect.left + left - clientLeft,
    right: elRect.right + left - clientLeft,
    bottom: elRect.bottom + top - clientTop
  };
}
// CONCATENATED MODULE: ./src/utils/popup/popup-manager.js










var hasModal = false;

var popup_manager_getModal = function getModal(id, multiModal) {
  if (external_vue_default.a.prototype.$isServer) return;
  var modalDom;

  if (multiModal) {
    modalDom = PopupManager.multiModalDom[id];
  } else {
    modalDom = PopupManager.modalDom;
  }

  if (modalDom) {
    hasModal = true;
  } else {
    hasModal = false;
    modalDom = document.createElement('div');

    if (multiModal) {
      PopupManager.multiModalDom[id] = modalDom;
    } else {
      PopupManager.modalDom = modalDom;
    }

    modalDom.addEventListener('touchmove', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
    modalDom.addEventListener('click', function () {
      PopupManager.doOnModalClick && PopupManager.doOnModalClick(id);
    });
  }

  return modalDom;
};

var instances = {};
var PopupManager = {
  multiModalDom: {},
  zIndex: 2000,
  modalFade: true,
  getInstance: function getInstance(id) {
    return instances[id];
  },
  register: function register(id, instance) {
    if (id && instance) {
      instances[id] = instance;
    }
  },
  deregister: function deregister(id) {
    if (id) {
      instances[id] = null;
      delete instances[id];
    }
  },
  nextZIndex: function nextZIndex() {
    return PopupManager.zIndex++;
  },
  modalStack: [],
  multiModalStack: {},
  doOnModalClick: function doOnModalClick(id) {
    var topItem;

    if (PopupManager.multiModalStack[id] !== undefined) {
      topItem = PopupManager.multiModalStack[id][PopupManager.multiModalStack[id].length - 1];
    } else {
      topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    }

    if (!topItem) return;
    var instance = PopupManager.getInstance(topItem.id);

    if (instance && instance.closeOnClickModal) {
      instance.close(topItem.id);
    }
  },
  openModal: function openModal(opts) {
    opts = Object.assign({
      multiModal: false
    }, opts); // id, zIndex, dom, modalClass, modalFade

    if (external_vue_default.a.prototype.$isServer) return;
    if (!opts.id || opts.zIndex === undefined) return;
    this.modalFade = opts.modalFade;
    var modalStack;

    if (opts.multiModal) {
      if (!this.multiModalStack[opts.id]) {
        this.multiModalStack[opts.id] = [];
      }

      modalStack = this.multiModalStack[opts.id];
    } else {
      modalStack = this.modalStack;
    }

    for (var i = 0, j = modalStack.length; i < j; i++) {
      var item = modalStack[i];

      if (item.id === opts.id) {
        return;
      }
    }

    var modalDom = popup_manager_getModal(opts.id, opts.multiModal);
    addClass(modalDom, 'v-modal');

    if (this.modalFade && !hasModal) {
      addClass(modalDom, 'v-modal-enter');
    }

    if (opts.modalClass) {
      var classArr = opts.modalClass.trim().split(/\s+/);
      classArr.forEach(function (item) {
        return addClass(modalDom, item);
      });
    }

    setTimeout(function () {
      removeClass(modalDom, 'v-modal-enter');
    }, 200);

    if (opts.dom && opts.dom.parentNode && opts.dom.parentNode.nodeType !== 11) {
      opts.dom.parentNode.appendChild(modalDom);
    } else {
      document.body.appendChild(modalDom);
    }

    if (opts.zIndex) {
      modalDom.style.zIndex = opts.zIndex;
    }

    modalDom.style.display = '';
    modalStack.push({
      id: opts.id,
      zIndex: opts.zIndex,
      modalClass: opts.modalClass
    });
  },
  closeModal: function closeModal(id) {
    var modalStack;

    if (this.multiModalStack[id] !== undefined) {
      modalStack = this.multiModalStack[id];
    } else {
      modalStack = this.modalStack;
    }

    var modalDom = popup_manager_getModal(id, PopupManager.multiModalStack[id] !== undefined);

    if (modalStack.length > 0) {
      var topItem = modalStack[modalStack.length - 1];

      if (topItem.id === id) {
        if (topItem.modalClass) {
          var classArr = topItem.modalClass.trim().split(/\s+/);
          classArr.forEach(function (item) {
            return removeClass(modalDom, item);
          });
        }

        modalStack.pop();

        if (modalStack.length > 0) {
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
        }
      } else {
        for (var i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1);
            break;
          }
        }
      }
    }

    if (modalStack.length === 0) {
      if (this.modalFade) {
        addClass(modalDom, 'v-modal-leave');
      }

      setTimeout(function () {
        if (modalStack.length === 0) {
          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
          modalDom.style.display = 'none';

          if (PopupManager.multiModalStack[id] !== undefined) {
            PopupManager.multiModalDom[id] = null;
          } else {
            PopupManager.modalDom = null;
          }
        }

        removeClass(modalDom, 'v-modal-leave');
      }, 200);
    }
  }
};

var popup_manager_getTopPopup = function getTopPopup() {
  if (external_vue_default.a.prototype.$isServer) return;

  if (PopupManager.modalStack.length > 0) {
    var topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topPopup) return;
    var instance = PopupManager.getInstance(topPopup.id);
    return instance;
  }
};

if (!external_vue_default.a.prototype.$isServer) {
  // handle `esc` key when the popup is shown
  window.addEventListener('keydown', function (event) {
    if (event.keyCode === 27) {
      var topPopup = popup_manager_getTopPopup();

      if (topPopup && topPopup.closeOnPressEscape) {
        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close();
      }
    }
  });
}

/* harmony default export */ var popup_manager = (PopupManager);
// CONCATENATED MODULE: ./src/utils/scrollbar-width.js

var scrollBarWidth;
/* harmony default export */ var scrollbar_width = (function (isChange) {
  if (external_vue_default.a.prototype.$isServer) return 0;

  if (!isChange) {
    // 防止鼠标缩放浏览器时scrollBarWidth不变化
    if (scrollBarWidth !== undefined && scrollBarWidth !== 0) {
      return scrollBarWidth;
    }
  }

  var outer = document.createElement('div');
  outer.className = 'el-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';
  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;
  return scrollBarWidth;
});
// CONCATENATED MODULE: ./src/utils/popup/index.js








var idSeed = 1;
var transitions = [];

var popup_hookTransition = function hookTransition(transition) {
  if (transitions.indexOf(transition) !== -1) return;

  var getVueInstance = function getVueInstance(element) {
    var instance = element.__vue__;

    if (!instance) {
      var textNode = element.previousSibling;

      if (textNode.__vue__) {
        instance = textNode.__vue__;
      }
    }

    return instance;
  };

  external_vue_default.a.transition(transition, {
    afterEnter: function afterEnter(el) {
      var instance = getVueInstance(el);

      if (instance) {
        instance.doAfterOpen && instance.doAfterOpen();
      }
    },
    afterLeave: function afterLeave(el) {
      var instance = getVueInstance(el);

      if (instance) {
        instance.doAfterClose && instance.doAfterClose();
      }
    }
  });
};

var popup_scrollBarWidth;

var getDOM = function getDOM(dom) {
  if (dom.nodeType === 3) {
    dom = dom.nextElementSibling || dom.nextSibling;
    getDOM(dom);
  }

  return dom;
};

/* harmony default export */ var popup = ({
  model: {
    prop: 'visible',
    event: 'visible-change'
  },
  props: {
    visible: {
      type: Boolean,
      "default": false
    },
    transition: {
      type: String,
      "default": ''
    },
    openDelay: {},
    closeDelay: {},
    zIndex: {},
    modal: {
      type: Boolean,
      "default": false
    },
    modalFade: {
      type: Boolean,
      "default": true
    },
    modalClass: {},
    modalAppendToBody: {
      type: Boolean,
      "default": false
    },
    lockScroll: {
      type: Boolean,
      "default": true
    },
    closeOnPressEscape: {
      type: Boolean,
      "default": false
    },
    closeOnClickModal: {
      type: Boolean,
      "default": false
    }
  },
  created: function created() {
    if (this.transition) {
      popup_hookTransition(this.transition);
    }
  },
  beforeMount: function beforeMount() {
    this._popupId = 'popup-' + idSeed++;
    popup_manager.register(this._popupId, this);
  },
  beforeDestroy: function beforeDestroy() {
    popup_manager.deregister(this._popupId);
    popup_manager.closeModal(this._popupId);

    if (this.modal && this.bodyOverflow !== null && this.bodyOverflow !== 'hidden') {
      document.body.style.overflow = this.bodyOverflow;
      document.body.style.width = this.bodyPaddingRight;
    }

    if (this.modal && this.htmlOverflow !== null && this.htmlOverflow !== 'hidden') {
      document.getElementsByTagName('html')[0].style.overflow = this.htmlOverflow;
    }

    this.bodyOverflow = null;
    this.bodyPaddingRight = null;
    this.htmlOverflow = null;
  },
  data: function data() {
    return {
      opened: false,
      bodyOverflow: null,
      bodyOverflowX: null,
      bodyOverflowY: null,
      htmlOverflow: null,
      bodyPaddingRight: null,
      rendered: false
    };
  },
  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        if (this._opening) return;

        if (!this.rendered) {
          this.rendered = true;
          external_vue_default.a.nextTick(function () {
            _this.open();
          });
        } else {
          this.open();
        }
      } else {
        this.close();
      }
    }
  },
  methods: {
    open: function open(options) {
      var _this2 = this;

      if (!this.rendered) {
        this.rendered = true;
        this.$emit('visible-change', true);
      }

      var props = merge({}, this.$props || this, options);

      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }

      clearTimeout(this._openTimer);
      var openDelay = Number(props.openDelay);

      if (openDelay > 0) {
        this._openTimer = setTimeout(function () {
          _this2._openTimer = null;

          _this2.doOpen(props);
        }, openDelay);
      } else {
        this.doOpen(props);
      }
    },
    doOpen: function doOpen(props) {
      if (this.$isServer) return;
      if (this.willOpen && !this.willOpen()) return;
      if (this.opened) return;
      this._opening = true;
      this.$emit('visible-change', true);
      var dom = getDOM(this.$el);
      var modal = props.modal;
      var zIndex = props.zIndex;

      if (zIndex) {
        popup_manager.zIndex = zIndex;
      }

      if (modal) {
        if (this._closing) {
          popup_manager.closeModal(this._popupId);
          this._closing = false;
        }

        popup_manager.openModal({
          id: this._popupId,
          zIndex: popup_manager.nextZIndex(),
          dom: this.modalAppendToBody ? undefined : dom,
          modalClass: props.modalClass,
          modalFade: props.modalFade
        });

        if (props.lockScroll) {
          if (!this.bodyOverflow) {
            this.bodyPaddingRight = document.body.style.width;
            this.bodyOverflow = document.body.style.overflow;
          }

          if (!this.htmlOverflow) {
            this.htmlOverflow = document.getElementsByTagName('html')[0].style.overflow;
          }

          popup_scrollBarWidth = scrollbar_width();
          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
          var bodyOverflowY = getStyle(document.body, 'overflowY');

          if (popup_scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll')) {
            document.body.style.width = "calc(100% - ".concat(popup_scrollBarWidth, "px)");
          }

          document.body.style.overflow = 'hidden';
        }
      }

      if (getComputedStyle(dom).position === 'static') {
        dom.style.position = 'absolute';
      }

      dom.style.zIndex = popup_manager.nextZIndex();
      this.opened = true;
      this.onOpen && this.onOpen();

      if (!this.transition) {
        this.doAfterOpen();
      }
    },
    doAfterOpen: function doAfterOpen() {
      this._opening = false;
    },
    close: function close() {
      var _this3 = this;

      if (this.willClose && !this.willClose()) return;

      if (this._openTimer !== null) {
        clearTimeout(this._openTimer);
        this._openTimer = null;
      }

      clearTimeout(this._closeTimer);
      var closeDelay = Number(this.closeDelay);

      if (closeDelay > 0) {
        this._closeTimer = setTimeout(function () {
          _this3._closeTimer = null;

          _this3.doClose();
        }, closeDelay);
      } else {
        this.doClose();
      }
    },
    doClose: function doClose() {
      var _this4 = this;

      this.$emit('visible-change', false);
      this._closing = true;
      this.onClose && this.onClose();

      if (this.lockScroll) {
        setTimeout(function () {
          if (_this4.modal && _this4.bodyOverflow !== 'hidden') {
            document.body.style.overflow = _this4.bodyOverflow;
            document.body.style.width = _this4.bodyPaddingRight;
          }

          if (_this4.modal && _this4.htmlOverflow !== 'hidden') {
            document.getElementsByTagName('html')[0].style.overflow = _this4.htmlOverflow;
          }

          _this4.bodyOverflow = null;
          _this4.bodyPaddingRight = null;
          _this4.htmlOverflow = null;
        }, 200);
      }

      this.opened = false;

      if (!this.transition) {
        this.doAfterClose();
      }
    },
    doAfterClose: function doAfterClose() {
      popup_manager.closeModal(this._popupId);
      this._closing = false;
    }
  }
});

// EXTERNAL MODULE: external "core-js/modules/es.function.bind.js"
var es_function_bind_js_ = __webpack_require__("6d2b");

// EXTERNAL MODULE: external "core-js/modules/es.object.define-property.js"
var es_object_define_property_js_ = __webpack_require__("9837");

// EXTERNAL MODULE: external "core-js/modules/es.object.get-own-property-descriptor.js"
var es_object_get_own_property_descriptor_js_ = __webpack_require__("6de0");

// EXTERNAL MODULE: external "core-js/modules/es.object.keys.js"
var es_object_keys_js_ = __webpack_require__("ea64");

// CONCATENATED MODULE: ./src/utils/popper.js
/**
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version {{version}}
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
//
// Cross module loader
// Supported: Node, AMD, Browser globals
//
// (function (root, factory) {
//     if (typeof define === 'function' && define.amd) {
//         // AMDR. Register as an anonymous module.
//         define(factory);
//     } else if (typeof module === 'object' && module.exports) {
//         // Node. Does not work with strict CommonJS, but
//         // only CommonJS-like environments that support module.exports,
//         // like Node.
//         module.exports = factory();
//     } else {
//         // Browser globals (root is window)
//         root.Popper = factory();
//     }
// }(this, function () {
 // var root = window;
// default options



















var DEFAULTS = {
  // placement of the popper
  placement: 'bottom',
  gpuAcceleration: true,
  // shift popper from its origin by the given amount of pixels (can be negative)
  offset: 0,
  // the element which will act as boundary of the popper
  boundariesElement: 'viewport',
  // amount of pixel used to define a minimum distance between the boundaries and the popper
  boundariesPadding: 5,
  // popper will try to prevent overflow following this order,
  // by default, then, it could overflow on the left and on top of the boundariesElement
  preventOverflowOrder: ['left', 'right', 'top', 'bottom'],
  // the behavior used by flip to change the placement of the popper
  flipBehavior: 'flip',
  arrowElement: '[x-arrow]',
  // list of functions used to modify the offsets before they are applied to the popper
  modifiers: ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle'],
  modifiersIgnored: [],
  forceAbsolute: false
};
/**
 * Create a new Popper.js instance
 * @constructor Popper
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement|Object} popper
 *      The HTML element used as popper, or a configuration used to generate the popper.
 * @param {String} [popper.tagName='div'] The tag name of the generated popper.
 * @param {Array} [popper.classNames=['popper']] Array of classes to apply to the generated popper.
 * @param {Array} [popper.attributes] Array of attributes to apply, specify `attr:value` to assign a value to it.
 * @param {HTMLElement|String} [popper.parent=window.document.body] The parent element, given as HTMLElement or as query string.
 * @param {String} [popper.content=''] The content of the popper, it can be text, html, or node; if it is not text, set `contentType` to `html` or `node`.
 * @param {String} [popper.contentType='text'] If `html`, the `content` will be parsed as HTML. If `node`, it will be appended as-is.
 * @param {String} [popper.arrowTagName='div'] Same as `popper.tagName` but for the arrow element.
 * @param {Array} [popper.arrowClassNames='popper__arrow'] Same as `popper.classNames` but for the arrow element.
 * @param {String} [popper.arrowAttributes=['x-arrow']] Same as `popper.attributes` but for the arrow element.
 * @param {Object} options
 * @param {String} [options.placement=bottom]
 *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -right),
 *      left(-start, -end)`
 *
 * @param {HTMLElement|String} [options.arrowElement='[x-arrow]']
 *      The DOM Node used as arrow for the popper, or a CSS selector used to get the DOM node. It must be child of
 *      its parent Popper. Popper.js will apply to the given element the style required to align the arrow with its
 *      reference element.
 *      By default, it will look for a child node of the popper with the `x-arrow` attribute.
 *
 * @param {Boolean} [options.gpuAcceleration=true]
 *      When this property is set to true, the popper position will be applied using CSS3 translate3d, allowing the
 *      browser to use the GPU to accelerate the rendering.
 *      If set to false, the popper will be placed using `top` and `left` properties, not using the GPU.
 *
 * @param {Number} [options.offset=0]
 *      Amount of pixels the popper will be shifted (can be negative).
 *
 * @param {String|Element} [options.boundariesElement='viewport']
 *      The element which will define the boundaries of the popper position, the popper will never be placed outside
 *      of the defined boundaries (except if `keepTogether` is enabled)
 *
 * @param {Number} [options.boundariesPadding=5]
 *      Additional padding for the boundaries
 *
 * @param {Array} [options.preventOverflowOrder=['left', 'right', 'top', 'bottom']]
 *      Order used when Popper.js tries to avoid overflows from the boundaries, they will be checked in order,
 *      this means that the last ones will never overflow
 *
 * @param {String|Array} [options.flipBehavior='flip']
 *      The behavior used by the `flip` modifier to change the placement of the popper when the latter is trying to
 *      overlap its reference element. Defining `flip` as value, the placement will be flipped on
 *      its axis (`right - left`, `top - bottom`).
 *      You can even pass an array of placements (eg: `['right', 'left', 'top']` ) to manually specify
 *      how alter the placement when a flip is needed. (eg. in the above example, it would first flip from right to left,
 *      then, if even in its new placement, the popper is overlapping its reference element, it will be moved to top)
 *
 * @param {Array} [options.modifiers=[ 'shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle']]
 *      List of functions used to modify the data before they are applied to the popper, add your custom functions
 *      to this array to edit the offsets and placement.
 *      The function should reflect the @params and @returns of preventOverflow
 *
 * @param {Array} [options.modifiersIgnored=[]]
 *      Put here any built-in modifier name you want to exclude from the modifiers list
 *      The function should reflect the @params and @returns of preventOverflow
 *
 * @param {Boolean} [options.removeOnDestroy=false]
 *      Set to true if you want to automatically remove the popper when you call the `destroy` method.
 */

function Popper(reference, popper, options) {
  this._reference = reference.jquery ? reference[0] : reference;
  this.state = {}; // if the popper variable is a configuration object, parse it to generate an HTMLElement
  // generate a default popper if is not defined

  var isNotDefined = typeof popper === 'undefined' || popper === null;
  var isConfig = popper && Object.prototype.toString.call(popper) === '[object Object]';

  if (isNotDefined || isConfig) {
    this._popper = this.parse(isConfig ? popper : {});
  } // otherwise, use the given HTMLElement as popper
  else {
      this._popper = popper.jquery ? popper[0] : popper;
    } // with {} we create a new object with the options inside it


  this._options = Object.assign({}, DEFAULTS, options); // refactoring modifiers' list

  this._options.modifiers = this._options.modifiers.map(function (modifier) {
    // remove ignored modifiers
    if (this._options.modifiersIgnored.indexOf(modifier) !== -1) return; // set the x-placement attribute before everything else because it could be used to add margins to the popper
    // margins needs to be calculated to get the correct popper offsets

    if (modifier === 'applyStyle') {
      this._popper.setAttribute('x-placement', this._options.placement);
    } // return predefined modifier identified by string or keep the custom one


    return this.modifiers[modifier] || modifier;
  }.bind(this)); // make sure to apply the popper position before any computation

  this.state.position = this._getPosition(this._popper, this._reference);
  popper_setStyle(this._popper, {
    position: this.state.position,
    top: 0
  }); // fire the first update to position the popper in the right place

  this.update(); // setup event listeners, they will take care of update the position in specific situations

  this._setupEventListeners();

  return this;
} //
// Methods
//

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */


Popper.prototype.destroy = function () {
  this._popper.removeAttribute('x-placement');

  this._popper.style.left = '';
  this._popper.style.position = '';
  this._popper.style.top = '';
  this._popper.style[getSupportedPropertyName('transform')] = '';

  this._removeEventListeners(); // remove the popper if user explicity asked for the deletion on destroy


  if (this._options.removeOnDestroy) {
    this._popper.remove();
  }

  return this;
};
/**
 * Updates the position of the popper, computing the new offsets and applying the new style
 * @method
 * @memberof Popper
 */


Popper.prototype.update = function () {
  var data = {
    instance: this,
    styles: {}
  }; // store placement inside the data object, modifiers will be able to edit `placement` if needed
  // and refer to _originalPlacement to know the original value

  data.placement = this._options.placement;
  data._originalPlacement = this._options.placement; // compute the popper and reference offsets and put them inside data.offsets

  data.offsets = this._getOffsets(this._popper, this._reference, data.placement); // get boundaries

  data.boundaries = this._getBoundaries(data, this._options.boundariesPadding, this._options.boundariesElement);
  data = this.runModifiers(data, this._options.modifiers);

  if (typeof this.state.updateCallback === 'function') {
    this.state.updateCallback(data);
  }
};
/**
 * If a function is passed, it will be executed after the initialization of popper with as first argument the Popper instance.
 * @method
 * @memberof Popper
 * @param {Function} callback
 */


Popper.prototype.onCreate = function (callback) {
  // the createCallbacks return as first argument the popper instance
  callback(this);
  return this;
};
/**
 * If a function is passed, it will be executed after each update of popper with as first argument the set of coordinates and informations
 * used to style popper and its arrow.
 * NOTE: it doesn't get fired on the first call of the `Popper.update()` method inside the `Popper` constructor!
 * @method
 * @memberof Popper
 * @param {Function} callback
 */


Popper.prototype.onUpdate = function (callback) {
  this.state.updateCallback = callback;
  return this;
};
/**
 * Helper used to generate poppers from a configuration file
 * @method
 * @memberof Popper
 * @param config {Object} configuration
 * @returns {HTMLElement} popper
 */


Popper.prototype.parse = function (config) {
  var defaultConfig = {
    tagName: 'div',
    classNames: ['popper'],
    attributes: [],
    parent: window.document.body,
    content: '',
    contentType: 'text',
    arrowTagName: 'div',
    arrowClassNames: ['popper__arrow'],
    arrowAttributes: ['x-arrow']
  };
  config = Object.assign({}, defaultConfig, config);
  var d = window.document;
  var popper = d.createElement(config.tagName);
  addClassNames(popper, config.classNames);
  addAttributes(popper, config.attributes);

  if (config.contentType === 'node') {
    popper.appendChild(config.content.jquery ? config.content[0] : config.content);
  } else if (config.contentType === 'html') {
    popper.innerHTML = config.content;
  } else {
    popper.textContent = config.content;
  }

  if (config.arrowTagName) {
    var arrow = d.createElement(config.arrowTagName);
    addClassNames(arrow, config.arrowClassNames);
    addAttributes(arrow, config.arrowAttributes);
    popper.appendChild(arrow);
  }

  var parent = config.parent.jquery ? config.parent[0] : config.parent; // if the given parent is a string, use it to match an element
  // if more than one element is matched, the first one will be used as parent
  // if no elements are matched, the script will throw an error

  if (typeof parent === 'string') {
    parent = d.querySelectorAll(config.parent);

    if (parent.length > 1) {
      console.warn('WARNING: the given `parent` query(' + config.parent + ') matched more than one element, the first one will be used');
    }

    if (parent.length === 0) {
      throw "ERROR: the given `parent` doesn't exists!";
    }

    parent = parent[0];
  } // if the given parent is a DOM nodes list or an array of nodes with more than one element,
  // the first one will be used as parent


  if (parent.length > 1 && parent instanceof Element === false) {
    console.warn('WARNING: you have passed as parent a list of elements, the first one will be used');
    parent = parent[0];
  } // append the generated popper to its parent


  parent.appendChild(popper);
  return popper;
  /**
   * Adds class names to the given element
   * @function
   * @ignore
   * @param {HTMLElement} target
   * @param {Array} classes
   */

  function addClassNames(element, classNames) {
    classNames.forEach(function (className) {
      element.classList.add(className);
    });
  }
  /**
   * Adds attributes to the given element
   * @function
   * @ignore
   * @param {HTMLElement} target
   * @param {Array} attributes
   * @example
   * addAttributes(element, [ 'data-info:foobar' ]);
   */


  function addAttributes(element, attributes) {
    attributes.forEach(function (attribute) {
      element.setAttribute(attribute.split(':')[0], attribute.split(':')[1] || '');
    });
  }
};
/**
 * Helper used to get the position which will be applied to the popper
 * @method
 * @memberof Popper
 * @param config {HTMLElement} popper element
 * @param reference {HTMLElement} reference element
 * @returns {String} position
 */


Popper.prototype._getPosition = function (popper, reference) {
  var container = getOffsetParent(reference);

  if (this._options.forceAbsolute) {
    return 'absolute';
  } // Decide if the popper will be fixed
  // If the reference element is inside a fixed context, the popper will be fixed as well to allow them to scroll together


  var isParentFixed = isFixed(reference, container);
  return isParentFixed ? 'fixed' : 'absolute';
};
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper
 * @access private
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */


Popper.prototype._getOffsets = function (popper, reference, placement) {
  placement = placement.split('-')[0];
  var popperOffsets = {};
  popperOffsets.position = this.state.position;
  var isParentFixed = popperOffsets.position === 'fixed'; //
  // Get reference element position
  //

  var referenceOffsets = getOffsetRectRelativeToCustomParent(reference, getOffsetParent(popper), isParentFixed); //
  // Get popper sizes
  //

  var popperRect = getOuterSizes(popper); //
  // Compute offsets of popper
  //
  // depending by the popper placement we have to compute its offsets slightly differently

  if (['right', 'left'].indexOf(placement) !== -1) {
    popperOffsets.top = referenceOffsets.top + referenceOffsets.height / 2 - popperRect.height / 2;

    if (placement === 'left') {
      popperOffsets.left = referenceOffsets.left - popperRect.width;
    } else {
      popperOffsets.left = referenceOffsets.right;
    }
  } else {
    popperOffsets.left = referenceOffsets.left + referenceOffsets.width / 2 - popperRect.width / 2;

    if (placement === 'top') {
      popperOffsets.top = referenceOffsets.top - popperRect.height;
    } else {
      popperOffsets.top = referenceOffsets.bottom;
    }
  } // Add width and height to our offsets object


  popperOffsets.width = popperRect.width;
  popperOffsets.height = popperRect.height;
  return {
    popper: popperOffsets,
    reference: referenceOffsets
  };
};
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper
 * @access private
 */


Popper.prototype._setupEventListeners = function () {
  // NOTE: 1 DOM access here
  this.state.updateBound = this.update.bind(this);
  window.addEventListener('resize', this.state.updateBound); // if the boundariesElement is window we don't need to listen for the scroll event

  if (this._options.boundariesElement !== 'window') {
    var target = getScrollParent(this._reference); // here it could be both `body` or `documentElement` thanks to Firefox, we then check both

    if (target === window.document.body || target === window.document.documentElement) {
      target = window;
    }

    target.addEventListener('scroll', this.state.updateBound);
  }
};
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper
 * @access private
 */


Popper.prototype._removeEventListeners = function () {
  // NOTE: 1 DOM access here
  window.removeEventListener('resize', this.state.updateBound);

  if (this._options.boundariesElement !== 'window') {
    var target = getScrollParent(this._reference); // here it could be both `body` or `documentElement` thanks to Firefox, we then check both

    if (target === window.document.body || target === window.document.documentElement) {
      target = window;
    }

    target.removeEventListener('scroll', this.state.updateBound);
  }

  this.state.updateBound = null;
};
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper
 * @access private
 * @param {Object} data - Object containing the property "offsets" generated by `_getOffsets`
 * @param {Number} padding - Boundaries padding
 * @param {Element} boundariesElement - Element used to define the boundaries
 * @returns {Object} Coordinates of the boundaries
 */


Popper.prototype._getBoundaries = function (data, padding, boundariesElement) {
  // NOTE: 1 DOM access here
  var boundaries = {};
  var width, height;

  if (boundariesElement === 'window') {
    var body = window.document.body;
    var html = window.document.documentElement;
    height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
    boundaries = {
      top: 0,
      right: width,
      bottom: height,
      left: 0
    };
  } else if (boundariesElement === 'viewport') {
    var offsetParent = getOffsetParent(this._popper);
    var scrollParent = getScrollParent(this._popper);
    var offsetParentRect = getOffsetRect(offsetParent); // Thanks the fucking native API, `document.body.scrollTop` & `document.documentElement.scrollTop`

    var getScrollTopValue = function getScrollTopValue(element) {
      return element == document.body ? Math.max(document.documentElement.scrollTop, document.body.scrollTop) : element.scrollTop;
    };

    var getScrollLeftValue = function getScrollLeftValue(element) {
      return element == document.body ? Math.max(document.documentElement.scrollLeft, document.body.scrollLeft) : element.scrollLeft;
    }; // if the popper is fixed we don't have to substract scrolling from the boundaries


    var scrollTop = data.offsets.popper.position === 'fixed' ? 0 : getScrollTopValue(scrollParent);
    var scrollLeft = data.offsets.popper.position === 'fixed' ? 0 : getScrollLeftValue(scrollParent);
    boundaries = {
      top: 0 - (offsetParentRect.top - scrollTop),
      right: window.document.documentElement.clientWidth - (offsetParentRect.left - scrollLeft),
      bottom: window.document.documentElement.clientHeight - (offsetParentRect.top - scrollTop),
      left: 0 - (offsetParentRect.left - scrollLeft)
    };
  } else {
    if (getOffsetParent(this._popper) === boundariesElement) {
      boundaries = {
        top: 0,
        left: 0,
        right: boundariesElement.clientWidth,
        bottom: boundariesElement.clientHeight
      };
    } else {
      boundaries = getOffsetRect(boundariesElement);
    }
  }

  boundaries.left += padding;
  boundaries.right -= padding;
  boundaries.top = boundaries.top + padding;
  boundaries.bottom = boundaries.bottom - padding;
  return boundaries;
};
/**
 * Loop trough the list of modifiers and run them in order, each of them will then edit the data object
 * @method
 * @memberof Popper
 * @access public
 * @param {Object} data
 * @param {Array} modifiers
 * @param {Function} ends
 */


Popper.prototype.runModifiers = function (data, modifiers, ends) {
  var modifiersToRun = modifiers.slice();

  if (ends !== undefined) {
    modifiersToRun = this._options.modifiers.slice(0, getArrayKeyIndex(this._options.modifiers, ends));
  }

  modifiersToRun.forEach(function (modifier) {
    if (popper_isFunction(modifier)) {
      data = modifier.call(this, data);
    }
  }.bind(this));
  return data;
};
/**
 * Helper used to know if the given modifier depends from another one.
 * @method
 * @memberof Popper
 * @param {String} requesting - name of requesting modifier
 * @param {String} requested - name of requested modifier
 * @returns {Boolean}
 */


Popper.prototype.isModifierRequired = function (requesting, requested) {
  var index = getArrayKeyIndex(this._options.modifiers, requesting);
  return !!this._options.modifiers.slice(0, index).filter(function (modifier) {
    return modifier === requested;
  }).length;
}; //
// Modifiers
//

/**
 * Modifiers list
 * @namespace Popper.modifiers
 * @memberof Popper
 * @type {Object}
 */


Popper.prototype.modifiers = {};
/**
 * Apply the computed styles to the popper element
 * @method
 * @memberof Popper.modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @returns {Object} The same data object
 */

Popper.prototype.modifiers.applyStyle = function (data) {
  // apply the final offsets to the popper
  // NOTE: 1 DOM access here
  var styles = {
    position: data.offsets.popper.position
  }; // round top and left to avoid blurry text

  var left = Math.round(data.offsets.popper.left);
  var top = Math.round(data.offsets.popper.top); // if gpuAcceleration is set to true and transform is supported, we use `translate3d` to apply the position to the popper
  // we automatically use the supported prefixed version if needed

  var prefixedProperty;

  if (this._options.gpuAcceleration && (prefixedProperty = getSupportedPropertyName('transform'))) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles.top = 0;
    styles.left = 0;
  } // othwerise, we use the standard `left` and `top` properties
  else {
      styles.left = left;
      styles.top = top;
    } // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!


  Object.assign(styles, data.styles);
  popper_setStyle(this._popper, styles); // set an attribute which will be useful to style the tooltip (use it to properly position its arrow)
  // NOTE: 1 DOM access here

  this._popper.setAttribute('x-placement', data.placement); // if the arrow modifier is required and the arrow style has been computed, apply the arrow style


  if (this.isModifierRequired(this.modifiers.applyStyle, this.modifiers.arrow) && data.offsets.arrow) {
    popper_setStyle(data.arrowElement, data.offsets.arrow);
  }

  return data;
};
/**
 * Modifier used to shift the popper on the start or end of its reference element side
 * @method
 * @memberof Popper.modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @returns {Object} The data object, properly modified
 */


Popper.prototype.modifiers.shift = function (data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftVariation = placement.split('-')[1]; // if shift shiftVariation is specified, run the modifier

  if (shiftVariation) {
    var reference = data.offsets.reference;
    var popper = getPopperClientRect(data.offsets.popper);
    var shiftOffsets = {
      y: {
        start: {
          top: reference.top
        },
        end: {
          top: reference.top + reference.height - popper.height
        }
      },
      x: {
        start: {
          left: reference.left
        },
        end: {
          left: reference.left + reference.width - popper.width
        }
      }
    };
    var axis = ['bottom', 'top'].indexOf(basePlacement) !== -1 ? 'x' : 'y';
    data.offsets.popper = Object.assign(popper, shiftOffsets[axis][shiftVariation]);
  }

  return data;
};
/**
 * Modifier used to make sure the popper does not overflows from it's boundaries
 * @method
 * @memberof Popper.modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @returns {Object} The data object, properly modified
 */


Popper.prototype.modifiers.preventOverflow = function (data) {
  var order = this._options.preventOverflowOrder;
  var popper = getPopperClientRect(data.offsets.popper);
  var check = {
    left: function left() {
      var left = popper.left;

      if (popper.left < data.boundaries.left) {
        left = Math.max(popper.left, data.boundaries.left);
      }

      return {
        left: left
      };
    },
    right: function right() {
      var left = popper.left;

      if (popper.right > data.boundaries.right) {
        left = Math.min(popper.left, data.boundaries.right - popper.width);
      }

      return {
        left: left
      };
    },
    top: function top() {
      var top = popper.top;

      if (popper.top < data.boundaries.top) {
        top = Math.max(popper.top, data.boundaries.top);
      }

      return {
        top: top
      };
    },
    bottom: function bottom() {
      var top = popper.top;

      if (popper.bottom > data.boundaries.bottom) {
        top = Math.min(popper.top, data.boundaries.bottom - popper.height);
      }

      return {
        top: top
      };
    }
  };
  order.forEach(function (direction) {
    data.offsets.popper = Object.assign(popper, check[direction]());
  });
  return data;
};
/**
 * Modifier used to make sure the popper is always near its reference
 * @method
 * @memberof Popper.modifiers
 * @argument {Object} data - The data object generated by _update method
 * @returns {Object} The data object, properly modified
 */


Popper.prototype.modifiers.keepTogether = function (data) {
  var popper = getPopperClientRect(data.offsets.popper);
  var reference = data.offsets.reference;
  var f = Math.floor;

  if (popper.right < f(reference.left)) {
    data.offsets.popper.left = f(reference.left) - popper.width;
  }

  if (popper.left > f(reference.right)) {
    data.offsets.popper.left = f(reference.right);
  }

  if (popper.bottom < f(reference.top)) {
    data.offsets.popper.top = f(reference.top) - popper.height;
  }

  if (popper.top > f(reference.bottom)) {
    data.offsets.popper.top = f(reference.bottom);
  }

  return data;
};
/**
 * Modifier used to flip the placement of the popper when the latter is starting overlapping its reference element.
 * Requires the `preventOverflow` modifier before it in order to work.
 * **NOTE:** This modifier will run all its previous modifiers everytime it tries to flip the popper!
 * @method
 * @memberof Popper.modifiers
 * @argument {Object} data - The data object generated by _update method
 * @returns {Object} The data object, properly modified
 */


Popper.prototype.modifiers.flip = function (data) {
  // check if preventOverflow is in the list of modifiers before the flip modifier.
  // otherwise flip would not work as expected.
  if (!this.isModifierRequired(this.modifiers.flip, this.modifiers.preventOverflow)) {
    console.warn('WARNING: preventOverflow modifier is required by flip modifier in order to work, be sure to include it before flip!');
    return data;
  }

  if (data.flipped && data.placement === data._originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';
  var flipOrder = [];

  if (this._options.flipBehavior === 'flip') {
    flipOrder = [placement, placementOpposite];
  } else {
    flipOrder = this._options.flipBehavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);
    var popperOffsets = getPopperClientRect(data.offsets.popper); // this boolean is used to distinguish right and bottom from top and left
    // they need different computations to get flipped

    var a = ['right', 'bottom'].indexOf(placement) !== -1; // using Math.floor because the reference offsets may contain decimals we are not going to consider here

    if (a && Math.floor(data.offsets.reference[placement]) > Math.floor(popperOffsets[placementOpposite]) || !a && Math.floor(data.offsets.reference[placement]) < Math.floor(popperOffsets[placementOpposite])) {
      // we'll use this boolean to detect any flip loop
      data.flipped = true;
      data.placement = flipOrder[index + 1];

      if (variation) {
        data.placement += '-' + variation;
      }

      data.offsets.popper = this._getOffsets(this._popper, this._reference, data.placement).popper;
      data = this.runModifiers(data, this._options.modifiers, this._flip);
    }
  }.bind(this));
  return data;
};
/**
 * Modifier used to add an offset to the popper, useful if you more granularity positioning your popper.
 * The offsets will shift the popper on the side of its reference element.
 * @method
 * @memberof Popper.modifiers
 * @argument {Object} data - The data object generated by _update method
 * @returns {Object} The data object, properly modified
 */


Popper.prototype.modifiers.offset = function (data) {
  var offset = this._options.offset;
  var popper = data.offsets.popper;

  if (data.placement.indexOf('left') !== -1) {
    popper.top -= offset;
  } else if (data.placement.indexOf('right') !== -1) {
    popper.top += offset;
  } else if (data.placement.indexOf('top') !== -1) {
    popper.left -= offset;
  } else if (data.placement.indexOf('bottom') !== -1) {
    popper.left += offset;
  }

  return data;
};
/**
 * Modifier used to move the arrows on the edge of the popper to make sure them are always between the popper and the reference element
 * It will use the CSS outer size of the arrow element to know how many pixels of conjuction are needed
 * @method
 * @memberof Popper.modifiers
 * @argument {Object} data - The data object generated by _update method
 * @returns {Object} The data object, properly modified
 */


Popper.prototype.modifiers.arrow = function (data) {
  var arrow = this._options.arrowElement; // if the arrowElement is a string, suppose it's a CSS selector

  if (typeof arrow === 'string') {
    arrow = this._popper.querySelector(arrow);
  } // if arrow element is not found, don't run the modifier


  if (!arrow) {
    return data;
  } // the arrow element must be child of its popper


  if (!this._popper.contains(arrow)) {
    console.warn('WARNING: `arrowElement` must be child of its popper element!');
    return data;
  } // arrow depends on keepTogether in order to work


  if (!this.isModifierRequired(this.modifiers.arrow, this.modifiers.keepTogether)) {
    console.warn('WARNING: keepTogether modifier is required by arrow modifier in order to work, be sure to include it before arrow!');
    return data;
  }

  var arrowStyle = {};
  var placement = data.placement.split('-')[0];
  var popper = getPopperClientRect(data.offsets.popper);
  var reference = data.offsets.reference;
  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
  var len = isVertical ? 'height' : 'width';
  var side = isVertical ? 'top' : 'left';
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowSize = getOuterSizes(arrow)[len]; //
  // extends keepTogether behavior making sure the popper and its reference have enough pixels in conjuction
  //
  // top/left side

  if (reference[opSide] - arrowSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowSize);
  } // bottom/right side


  if (reference[side] + arrowSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowSize - popper[opSide];
  } // compute center of the popper


  var center = reference[side] + reference[len] / 2 - arrowSize / 2;
  var sideValue = center - popper[side]; // zhuxiankang add at 2018/06/01
  // if placement is top or bottom,
  // poper's width is smaller than reference width
  // arrow's left is poper's center

  if (!isVertical && popper.width < reference.width) {
    // chenguanbin edit at 2019/06/18
    // 根据弹出框和响应元素的相对位置，决定尖角的位置
    // 左边对齐（top-start），右边对齐（top-end），否则（top）
    if (popper.left === reference.left) {
      sideValue = 24;
    } else if (popper.right === reference.right) {
      sideValue = popper.width - 56;
    } else {
      sideValue = (popper.width - arrowSize) / 2;
    }
  } // prevent arrow from being placed not contiguously to its popper


  sideValue = Math.max(Math.min(popper[len] - arrowSize - 3, sideValue), 3);
  arrowStyle[side] = sideValue;
  arrowStyle[altSide] = ''; // make sure to remove any old style from the arrow

  data.offsets.arrow = arrowStyle;
  data.arrowElement = arrow;
  return data;
}; //
// Helpers
//

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @function
 * @ignore
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */


function getOuterSizes(element) {
  // NOTE: 1 DOM access here
  var _display = element.style.display;
  var _visibility = element.style.visibility;
  element.style.display = 'block';
  element.style.visibility = 'hidden';
  var calcWidthToForceRepaint = element.offsetWidth; // original method

  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  }; // reset element styles

  element.style.display = _display;
  element.style.visibility = _visibility;
  return result;
}
/**
 * Get the opposite placement of the given one/
 * @function
 * @ignore
 * @argument {String} placement
 * @returns {String} flipped placement
 */


function getOppositePlacement(placement) {
  var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
/**
 * Given the popper offsets, generate an output similar to getBoundingClientRect
 * @function
 * @ignore
 * @argument {Object} popperOffsets
 * @returns {Object} ClientRect like output
 */


function getPopperClientRect(popperOffsets) {
  var offsets = Object.assign({}, popperOffsets);
  offsets.right = offsets.left + offsets.width;
  offsets.bottom = offsets.top + offsets.height;
  return offsets;
}
/**
 * Given an array and the key to find, returns its index
 * @function
 * @ignore
 * @argument {Array} arr
 * @argument keyToFind
 * @returns index or null
 */


function getArrayKeyIndex(arr, keyToFind) {
  var i = 0;
  var key;

  for (key in arr) {
    if (arr[key] === keyToFind) {
      return i;
    }

    i++;
  }

  return null;
}
/**
 * Get CSS computed property of the given element
 * @function
 * @ignore
 * @argument {Eement} element
 * @argument {String} property
 */


function getStyleComputedProperty(element, property) {
  // NOTE: 1 DOM access here
  var css = window.getComputedStyle(element, null);
  return css[property];
}
/**
 * Returns the offset parent of the given element
 * @function
 * @ignore
 * @argument {Element} element
 * @returns {Element} offset parent
 */


function getOffsetParent(element) {
  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  return offsetParent === window.document.body || !offsetParent ? window.document.documentElement : offsetParent;
}
/**
 * Returns the scrolling parent of the given element
 * @function
 * @ignore
 * @argument {Element} element
 * @returns {Element} offset parent
 */


function getScrollParent(element) {
  var parent = element.parentNode;

  if (!parent) {
    return element;
  }

  if (parent === window.document) {
    // Firefox puts the scrollTOp value on `documentElement` instead of `body`, we then check which of them is
    // greater than 0 and return the proper element
    if (window.document.body.scrollTop) {
      return window.document.body;
    } else {
      return window.document.documentElement;
    }
  } // Firefox want us to check `-x` and `-y` variations as well


  if (['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1) {
    // If the detected scrollParent is body, we perform an additional check on its parentNode
    // in this way we'll get body if the browser is Chrome-ish, or documentElement otherwise
    // fixes issue #65
    return parent;
  }

  return getScrollParent(element.parentNode);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @function
 * @ignore
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */


function isFixed(element) {
  if (element === window.document.body) {
    return false;
  }

  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }

  return element.parentNode ? isFixed(element.parentNode) : element;
}
/**
 * Set the style to the given popper
 * @function
 * @ignore
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles - Object with a list of properties and values which will be applied to the element
 */


function popper_setStyle(element, styles) {
  function is_numeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
  }

  Object.keys(styles).forEach(function (prop) {
    var unit = ''; // add unit if the value is numeric and is one of the following

    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && is_numeric(styles[prop])) {
      unit = 'px';
    }

    element.style[prop] = styles[prop] + unit;
  });
}
/**
 * Check if the given variable is a function
 * @function
 * @ignore
 * @argument {*} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */


function popper_isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get the position of the given element, relative to its offset parent
 * @function
 * @ignore
 * @param {Element} element
 * @return {Object} position - Coordinates of the element and its `scrollTop`
 */


function getOffsetRect(element) {
  var elementRect = {
    width: element.offsetWidth,
    height: element.offsetHeight,
    left: element.offsetLeft,
    top: element.offsetTop
  };
  elementRect.right = elementRect.left + elementRect.width;
  elementRect.bottom = elementRect.top + elementRect.height; // position

  return elementRect;
}
/**
 * Get bounding client rect of given element
 * @function
 * @ignore
 * @param {HTMLElement} element
 * @return {Object} client rect
 */


function getBoundingClientRect(element) {
  var rect = element.getBoundingClientRect(); // whether the IE version is lower than 11

  var isIE = navigator.userAgent.indexOf('MSIE') != -1; // fix ie document bounding top always 0 bug

  var rectTop = isIE && element.tagName === 'HTML' ? -element.scrollTop : rect.top;
  return {
    left: rect.left,
    top: rectTop,
    right: rect.right,
    bottom: rect.bottom,
    width: rect.right - rect.left,
    height: rect.bottom - rectTop
  };
}
/**
 * Given an element and one of its parents, return the offset
 * @function
 * @ignore
 * @param {HTMLElement} element
 * @param {HTMLElement} parent
 * @return {Object} rect
 */


function getOffsetRectRelativeToCustomParent(element, parent, fixed) {
  var elementRect = getBoundingClientRect(element);
  var parentRect = getBoundingClientRect(parent);

  if (fixed) {
    var scrollParent = getScrollParent(parent);
    parentRect.top += scrollParent.scrollTop;
    parentRect.bottom += scrollParent.scrollTop;
    parentRect.left += scrollParent.scrollLeft;
    parentRect.right += scrollParent.scrollLeft;
  }

  var rect = {
    top: elementRect.top - parentRect.top,
    left: elementRect.left - parentRect.left,
    bottom: elementRect.top - parentRect.top + elementRect.height,
    right: elementRect.left - parentRect.left + elementRect.width,
    width: elementRect.width,
    height: elementRect.height
  };
  return rect;
}
/**
 * Get the prefixed supported property name
 * @function
 * @ignore
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase)
 */


function getSupportedPropertyName(property) {
  var prefixes = ['', 'ms', 'webkit', 'moz', 'o'];

  for (var i = 0; i < prefixes.length; i++) {
    var toCheck = prefixes[i] ? prefixes[i] + property.charAt(0).toUpperCase() + property.slice(1) : property;

    if (typeof window.document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }

  return null;
}
/**
 * The Object.assign() method is used to copy the values of all enumerable own properties from one or more source
 * objects to a target object. It will return the target object.
 * This polyfill doesn't support symbol properties, since ES5 doesn't have symbols anyway
 * Source: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 * @function
 * @ignore
 */


if (!Object.assign) {
  Object.defineProperty(Object, 'assign', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function value(target) {
      if (target === undefined || target === null) {
        throw new TypeError('Cannot convert first argument to object');
      }

      var to = Object(target);

      for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];

        if (nextSource === undefined || nextSource === null) {
          continue;
        }

        nextSource = Object(nextSource);
        var keysArray = Object.keys(nextSource);

        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

          if (desc !== undefined && desc.enumerable) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }

      return to;
    }
  });
} // return Popper;


/* harmony default export */ var utils_popper = (Popper); // }));
// CONCATENATED MODULE: ./src/utils/vue-popper.js






 // import Popper from './popper';
// 这里注意要写成这种形式，否则webpack打包不识别externals，会打包进去
// 不要使用相对路径
// zhuxiankang add at 2019/01/08

 // const PopperJS = Vue.prototype.$isServer ? function () {} : popper;

var PopperJS = external_vue_default.a.prototype.$isServer ? function () {} : utils_popper;

var stop = function stop(e) {
  return e.stopPropagation();
};
/**
 * @param {HTMLElement} [reference=$refs.reference] - The reference element used to position the popper.
 * @param {HTMLElement} [popper=$refs.popper] - The HTML element used as popper, or a configuration used to generate the popper.
 * @param {String} [placement=button] - Placement of the popper accepted values: top(-start, -end), right(-start, -end), bottom(-start, -end), left(-start, -end)
 * @param {Number} [offset=0] - Amount of pixels the popper will be shifted (can be negative).
 * @param {Boolean} [visible=false] Visibility of the popup element.
 * @param {Boolean} [visible-arrow=false] Visibility of the arrow, no style.
 */


/* harmony default export */ var vue_popper = ({
  props: {
    placement: {
      type: String,
      "default": 'bottom'
    },
    boundariesPadding: {
      type: Number,
      "default": 5
    },
    reference: {},
    popper: {},
    offset: {
      "default": 0
    },
    value: Boolean,
    visibleArrow: Boolean,
    transition: String,
    appendToBody: {
      type: Boolean,
      "default": true
    },
    popperOptions: {
      type: Object,
      "default": function _default() {
        return {
          gpuAcceleration: false
        };
      }
    }
  },
  data: function data() {
    return {
      showPopper: false,
      currentPlacement: ''
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.showPopper = val;
        this.$emit('input', val);
      }
    },
    showPopper: function showPopper(val) {
      val ? this.updatePopper() : this.destroyPopper();
      this.$emit('input', val);
    }
  },
  methods: {
    createPopper: function createPopper() {
      var _this = this;

      if (this.$isServer) return;
      this.currentPlacement = this.currentPlacement || this.placement;

      if (!/^(top|bottom|left|right)(-start|-end)?$/g.test(this.currentPlacement)) {
        return;
      }

      var options = this.popperOptions;
      var popper = this.popperElm = this.popperElm || this.popper || this.$refs.popper;
      var reference = this.referenceElm || this.reference || this.$refs.reference;

      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
        reference = this.$slots.reference[0].elm;
      }

      if (!popper || !reference) return;
      if (this.visibleArrow) this.appendArrow(popper);
      if (this.appendToBody) document.body.appendChild(this.popperElm);

      if (this.popperJS && this.popperJS.destroy) {
        this.popperJS.destroy();
      }

      options.placement = this.currentPlacement;
      options.offset = this.offset;
      options.arrowOffset = this.arrowOffset;
      this.popperJS = new PopperJS(reference, popper, options);
      this.popperJS.onCreate(function () {
        _this.$emit('created', _this);

        _this.resetTransformOrigin();

        _this.$nextTick(_this.updatePopper);
      });

      if (typeof options.onUpdate === 'function') {
        this.popperJS.onUpdate(options.onUpdate);
      }

      this.popperJS._popper.style.zIndex = popup_manager.nextZIndex();
      this.popperElm.addEventListener('click', stop);
    },
    updatePopper: function updatePopper() {
      this.popperJS ? this.popperJS.update() : this.createPopper();
    },
    doDestroy: function doDestroy() {
      /* istanbul ignore if */
      if (this.showPopper || !this.popperJS) return;
      this.popperJS.destroy();
      this.popperJS = null;
    },
    destroyPopper: function destroyPopper() {
      if (this.popperJS) {
        this.resetTransformOrigin();
      }
    },
    resetTransformOrigin: function resetTransformOrigin() {
      var placementMap = {
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left'
      };

      var placement = this.popperJS._popper.getAttribute('x-placement').split('-')[0];

      var origin = placementMap[placement];
      this.popperJS._popper.style.transformOrigin = ['top', 'bottom'].indexOf(placement) > -1 ? "center ".concat(origin) : "".concat(origin, " center");
    },
    appendArrow: function appendArrow(element) {
      var hash;

      if (this.appended) {
        return;
      }

      this.appended = true;

      for (var item in element.attributes) {
        if (/^_v-/.test(element.attributes[item].name)) {
          hash = element.attributes[item].name;
          break;
        }
      }

      var arrow = document.createElement('div');

      if (hash) {
        arrow.setAttribute(hash, '');
      }

      arrow.setAttribute('x-arrow', '');
      arrow.className = 'popper__arrow';
      element.appendChild(arrow);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.doDestroy();

    if (this.popperElm && this.popperElm.parentNode === document.body) {
      this.popperElm.removeEventListener('click', stop);
      document.body.removeChild(this.popperElm);
    }
  },
  // call destroy in keep-alive mode
  deactivated: function deactivated() {
    this.$options.beforeDestroy[0].call(this);
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: 'ElPopover',
  mixins: [vue_popper],
  props: {
    trigger: {
      type: String,
      "default": 'click',
      validator: function validator(value) {
        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
      }
    },
    contentDelay: {
      type: Number,
      "default": 0
    },
    openDelay: {
      type: Number,
      "default": 0
    },
    title: {
      type: String,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    content: {
      type: String,
      "default": null
    },
    reference: {
      type: null,
      "default": null
    },
    popperClass: {
      type: String,
      "default": null
    },
    width: {
      type: null,
      "default": null
    },
    maxWidth: {
      type: null,
      "default": null
    },
    // 最大宽度
    showHtml: {
      // 是否直接显示HTML
      type: Boolean,
      "default": false
    },
    visibleArrow: {
      type: Boolean,
      "default": true
    },
    transition: {
      type: String,
      "default": 'fade-in-linear'
    },
    offsetPlacement: {
      type: Number,
      "default": 0
    }
  },
  data: function data() {
    return {
      showContent: true
    };
  },
  computed: {
    popoverStyle: function popoverStyle() {
      var ret = {};
      ret.width = (this.width + 'px').replace(/pxpx/, 'px');
      ret.maxWidth = (this.maxWidth + 'px').replace(/pxpx/, 'px');
      var gutter = 10; // 控件与元素间默认间距

      if (this.placement.indexOf('top') !== -1) {
        ret.marginBottom = this.offsetPlacement + gutter + 'px';
      } else if (this.placement.indexOf('bottom') !== -1) {
        ret.marginTop = this.offsetPlacement + gutter + 'px';
      } else if (this.placement.indexOf('left') !== -1) {
        ret.marginRight = this.offsetPlacement + gutter + 'px';
      } else if (this.placement.indexOf('right') !== -1) {
        ret.marginLeft = this.offsetPlacement + gutter + 'px';
      }

      return ret;
    }
  },
  watch: {
    showPopper: function showPopper(newVal) {
      newVal ? this.$emit('show') : this.$emit('hide');
    }
  },
  created: function created() {
    var _this = this;

    if (this.contentDelay) this.showContent = false;
    setTimeout(function () {
      _this.showContent = true;
    }, this.contentDelay);
  },
  mounted: function mounted() {
    var reference = this.reference || this.$refs.reference;
    var popper = this.popper || this.$refs.popper;

    if (!reference && this.$slots.reference && this.$slots.reference[0]) {
      reference = this.referenceElm = this.$slots.reference[0].elm;
    }

    if (this.trigger === 'click') {
      on(reference, 'click', this.doToggle);
      on(document, 'click', this.handleDocumentClick);
    } else if (this.trigger === 'hover') {
      on(reference, 'mouseenter', this.handleMouseEnter);
      on(popper, 'mouseenter', this.handleMouseEnter);
      on(reference, 'mouseleave', this.handleMouseLeave);
      on(popper, 'mouseleave', this.handleMouseLeave);
    } else if (this.trigger === 'focus') {
      var found = false;

      if ([].slice.call(reference.children).length) {
        var children = reference.childNodes;
        var len = children.length;

        for (var i = 0; i < len; i++) {
          if (children[i].nodeName === 'INPUT' || children[i].nodeName === 'TEXTAREA') {
            on(children[i], 'focus', this.doShow);
            on(children[i], 'blur', this.doClose);
            found = true;
            break;
          }
        }
      }

      if (found) return;

      if (reference.nodeName === 'INPUT' || reference.nodeName === 'TEXTAREA') {
        on(reference, 'focus', this.doShow);
        on(reference, 'blur', this.doClose);
      } else {
        on(reference, 'mousedown', this.doShow);
        on(reference, 'mouseup', this.doClose);
      }
    }
  },
  destroyed: function destroyed() {
    var reference = this.reference;
    off(reference, 'click', this.doToggle);
    off(reference, 'mouseup', this.doClose);
    off(reference, 'mousedown', this.doShow);
    off(reference, 'focus', this.doShow);
    off(reference, 'blur', this.doClose);
    off(reference, 'mouseleave', this.handleMouseLeave);
    off(reference, 'mouseenter', this.handleMouseEnter);
    off(document, 'click', this.handleDocumentClick);
  },
  methods: {
    doToggle: function doToggle() {
      this.showPopper = !this.showPopper;
    },
    doShow: function doShow() {
      this.showPopper = true;
    },
    doClose: function doClose() {
      this.showPopper = false;
    },
    handleMouseEnter: function handleMouseEnter() {
      var _this2 = this;

      clearTimeout(this._timer);

      if (this.openDelay) {
        this._timer = setTimeout(function () {
          _this2.showPopper = true;
        }, this.openDelay);
      } else {
        this.showPopper = true;
      }
    },
    handleMouseLeave: function handleMouseLeave() {
      var _this3 = this;

      clearTimeout(this._timer);
      this._timer = setTimeout(function () {
        _this3.showPopper = false;
      }, 200);
    },
    handleDocumentClick: function handleDocumentClick(e) {
      var reference = this.reference || this.$refs.reference;
      var popper = this.popper || this.$refs.popper;

      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
        reference = this.referenceElm = this.$slots.reference[0].elm;
      }

      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) {
        return;
      }

      this.showPopper = false;
    }
  }
});
// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/popover/src/main.vue





/* normalize component */

var main_component = normalizeComponent(
  src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_084ce9fc_render,
  mainvue_type_template_id_084ce9fc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var main = (main_component.exports);
// CONCATENATED MODULE: ./packages/popover/src/directive.js
/* harmony default export */ var directive = ({
  bind: function bind(el, binding, vnode) {
    vnode.context.$refs[binding.arg].$refs.reference = el;
  }
});
// CONCATENATED MODULE: ./packages/popover/index.js




external_vue_default.a.directive('popover', directive);
/* istanbul ignore next */

main.install = function (Vue) {
  Vue.directive('popover', directive);
  Vue.component(main.name, main);
};

main.directive = directive;
/* harmony default export */ var popover = (main);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var inputvue_type_script_lang_js_ = ({
  name: 'ElInput',
  components: {
    ElPopover: popover
  },
  mixins: [emitter],
  inheritAttrs: false,
  // 只有input/textrear支持原生属性
  componentName: 'ElInput',
  props: {
    value: {
      type: [String, Number],
      "default": null
    },
    placeholder: {
      type: String,
      "default": null
    },
    size: {
      type: String,
      "default": null
    },
    kind: {
      type: String,
      "default": null
    },
    resize: {
      type: String,
      "default": null
    },
    readonly: {
      type: Boolean,
      "default": null
    },
    autofocus: {
      type: Boolean,
      "default": null
    },
    icon: {
      type: String,
      "default": null
    },
    unselectable: {
      type: String,
      "default": null
    },
    clearable: {
      type: Boolean,
      "default": null
    },
    select: {
      type: Boolean,
      "default": null
    },
    suffixIcon: {
      type: String,
      "default": null
    },
    prefixIcon: {
      type: String,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    type: {
      type: String,
      "default": 'text'
    },
    name: {
      type: String,
      "default": null
    },
    count: {
      type: Number,
      "default": null
    },
    autosize: {
      type: [Boolean, Object],
      "default": false
    },
    rows: {
      type: Number,
      "default": 2
    },
    autoComplete: {
      type: String,
      "default": 'off'
    },
    form: {
      type: String,
      "default": null
    },
    maxlength: {
      type: Number,
      "default": null
    },
    minlength: {
      type: Number,
      "default": null
    },
    max: {
      type: null,
      "default": null
    },
    min: {
      type: null,
      "default": null
    },
    step: {
      type: null,
      "default": null
    },
    validateEvent: {
      type: Boolean,
      "default": true
    },
    onIconClick: {
      type: Function,
      "default": null
    },
    onMousedownClick: {
      type: Function,
      "default": null
    },
    onMouseupClick: {
      type: Function,
      "default": null
    },
    clearIconClick: {
      type: Function,
      "default": null
    },
    // 提示信息，设置了tips才能显示popover
    tips: {
      type: String,
      "default": null
    },
    // popover的最大宽度
    tipsMaxWidth: {
      type: null,
      "default": 480 // 交互规范表单项tip最大宽度480，超出换行

    },
    // popover出现的位置
    tipsPlacement: {
      type: String,
      "default": 'top-start'
    },
    // 出现位置的偏移量
    tipsOffset: {
      type: Number,
      "default": 0
    },
    // popover触发方式
    tipsTrigger: {
      type: String,
      "default": 'focus'
    },
    // popover触发方式
    tipsClass: {
      type: String,
      "default": ''
    },
    dataPicker: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      textareaRect: {},
      textareaCalcStyle: {},
      prefixOffset: null,
      suffixOffset: null,
      tipsDisabled: true,
      ie: {},
      // ie下的时间定时器
      ie9: false,
      // 判断是否是ie9
      isFormItem: false,
      // 是否为表单元素
      isFocus: false,
      isHover: false,
      isComposing: false,
      prefixWidth: null,
      suffixWidth: null
    };
  },
  computed: {
    inputStyle: function inputStyle() {
      return {
        paddingLeft: this.prefixWidth ? "".concat(this.prefixWidth + 8, "px") : null,
        paddingRight: this.suffixWidth ? "".concat(this.suffixWidth + (this.clearable ? 28 : 8), "px") : this.clearable ? '28px' : null
      };
    },
    validating: function validating() {
      return this.$parent.validateState === 'validating';
    },
    textareaStyle: function textareaStyle() {
      return merge({}, this.textareaCalcStyle, {// resize: this.resize === '' || this.autosize ? 'both' : this.resize
      });
    },
    isGroup: function isGroup() {
      return this.$slots.prepend || this.$slots.append;
    },
    valueLength: function valueLength() {
      if (this.value) {
        return this.value.length;
      }

      return 0;
    },
    nativeInputValue: function nativeInputValue() {
      return this.value === null || this.value === undefined ? '' : this.value;
    },
    total: function total() {
      var num = this.count - this.valueLength;

      if (num < 0) {
        return 0;
      }

      return this.count - this.valueLength || 0;
    }
  },
  watch: {
    value: function value(val) {
      this.$nextTick(this.resizeTextarea);

      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [val]);
      }
    }
  },
  created: function created() {
    this.$on('inputSelect', this.inputSelect);
  },
  mounted: function mounted() {
    if (this.type === 'textarea') {
      this.textareaRect = this.$refs.wrapper ? this.$refs.wrapper.getBoundingClientRect() : {};
      this.resizeTextarea();
    }

    if (this.$refs.prefix) {
      this.prefixWidth = this.$refs.prefix.getBoundingClientRect().width;
    }

    if (this.$refs.suffix) {
      this.suffixWidth = this.$refs.suffix.getBoundingClientRect().width;
    }

    if (this.isGroup) {
      this.prefixOffset = this.calcIconOffset('pre');
      this.suffixOffset = this.calcIconOffset('suf');
    } // ie9兼容


    if (navigator.appName === 'Microsoft Internet Explorer' && navigator.appVersion.split(';')[1].replace(/[ ]/g, '') === 'MSIE9.0' && !this.dataPicker) {
      this.ie9 = true;
    } // 影响switch beforeChange 事件 placeholder 可以为空
    // if (this.placeholder === '') {
    //   console.error('input的placeholder属性不能传空');
    // }


    this.isFormItem = !!this.findComponentUpward(this, 'ElFormItem');
  },
  methods: {
    /**
     * @author xuzilong
     * @desc 找到指定的父组件
     */
    findComponentUpward: function findComponentUpward(context, componentName) {
      var parent = context.$parent;
      var name = parent.$options.name;

      while (parent && (!name || [componentName].indexOf(name) < 0)) {
        parent = parent.$parent;
        if (parent) name = parent.$options.name;
      }

      return parent;
    },
    handleBlur: function handleBlur(event) {
      this.isFocus = false;
      this.$emit('blur', event);

      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
      }

      if (this.tipsTrigger === 'focus') {
        this.tipsDisabled = true;
      }

      if (this.ie9) {
        clearTimeout(this.ie); // ie9兼容
        // document.removeEventListener('selectionchange', this.handleInput, false);
      }
    },
    inputSelect: function inputSelect() {
      // TODO 这里不知道干啥用的，没改，请检查一下这里是否会有问题
      this.$refs.input.select();
    },
    resizeTextarea: function resizeTextarea() {
      if (this.$isServer) return;
      var autosize = this.autosize,
          type = this.type;
      if (!autosize || type !== 'textarea') return;
      var minRows = autosize.minRows;
      var maxRows = autosize.maxRows;
      var maxWidth = autosize.maxWidth;
      this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, this.textareaRect, minRows, maxRows, maxWidth);
    },
    handleMouseenter: function handleMouseenter() {
      this.isHover = true;
    },
    handleMouseout: function handleMouseout() {
      this.isHover = false;
    },
    handleFocus: function handleFocus(event) {
      this.isFocus = true;
      this.$emit('focus', event);

      if (this.tips && this.tipsTrigger === 'focus') {
        this.tipsDisabled = false;
      }

      if (this.ie9) {
        this.ie = setInterval(this.handleInput, 200); // ie9兼容
        // document.addEventListener('selectionchange', this.handleInput, false);
      }
    },
    handleCompositionStart: function handleCompositionStart() {
      this.isComposing = true;
    },
    handleCompositionEnd: function handleCompositionEnd(event) {
      this.isComposing = false;
      this.handleInput(event);
    },
    handleInput: function handleInput(event) {
      if (this.isComposing) return;
      var value = event.target.value;

      if (this.count && this.count < value.length) {
        value = value.substring(0, this.count);
        this.$refs.textarea.value = value;
      }

      if (value === this.nativeInputValue) return;
      this.$emit('input', value);
      this.$emit('change', value);
    },
    handleIconClick: function handleIconClick(event) {
      if (this.onIconClick) {
        this.onIconClick(event);
      }

      this.$emit('click', event);
    },
    handleMousedownClick: function handleMousedownClick(event) {
      if (this.onMousedownClick) {
        this.onMousedownClick(event);
      }
    },
    handleMouseupClick: function handleMouseupClick(event) {
      if (this.onMouseupClick) {
        this.onMouseupClick(event);
      }
    },
    handleClearClick: function handleClearClick(event) {
      if (!this.disabled) {
        if (this.clearIconClick) {
          this.clearIconClick(event);
        }

        this.deleteSelected(event);
        this.$emit('delete');
      }
    },
    deleteSelected: function deleteSelected(event) {
      event.stopPropagation();
      this.$emit('input', '');
      this.$emit('clear');
    },
    calcIconOffset: function calcIconOffset(place) {
      var pendantMap = {
        suf: 'append',
        pre: 'prepend'
      };
      var pendant = pendantMap[place];

      if (this.$slots[pendant]) {
        return {
          transform: "translateX(".concat(place === 'suf' ? '-' : '').concat(this.$el.querySelector(".el-input-group__".concat(pendant)).offsetWidth, "px)")
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/input/src/input.vue





/* normalize component */

var input_component = normalizeComponent(
  src_inputvue_type_script_lang_js_,
  inputvue_type_template_id_cc2eab2a_render,
  inputvue_type_template_id_cc2eab2a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var input = (input_component.exports);
// CONCATENATED MODULE: ./packages/input/index.js


/* istanbul ignore next */

input.install = function (Vue) {
  Vue.component(input.name, input);
};

/* harmony default export */ var packages_input = (input);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=7354a657&
var select_dropdownvue_type_template_id_7354a657_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-select-dropdown",class:[{ 'is-multiple': _vm.$parent.multiple }, _vm.popperClass],style:({ minWidth: _vm.minWidth, maxWidth: _vm.maxWidth })},[_vm._t("default")],2)}
var select_dropdownvue_type_template_id_7354a657_staticRenderFns = []


// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=7354a657&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var select_dropdownvue_type_script_lang_js_ = ({
  name: 'ElSelectDropdown',
  componentName: 'ElSelectDropdown',
  mixins: [vue_popper],
  props: {
    placement: {
      type: String,
      "default": 'bottom-start'
    },
    boundariesPadding: {
      type: null,
      "default": 0
    },
    appendToBody: {
      type: Boolean,
      "default": true
    },
    popperOptions: {
      type: null,
      "default": function _default() {
        return {
          forceAbsolute: true,
          gpuAcceleration: false
        };
      }
    }
  },
  data: function data() {
    return {
      minWidth: '',
      maxWidth: ''
    };
  },
  computed: {
    popperClass: function popperClass() {
      return this.$parent.popperClass;
    }
  },
  watch: {
    '$parent.inputWidth': function $parentInputWidth() {
      var inputWidth = this.$parent.$el.getBoundingClientRect().width;
      this.minWidth = inputWidth + 'px';
      this.maxWidth = (this.$parent.maxWidth || inputWidth) + 'px';
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.referenceElm = this.$parent.$refs.reference.$el;
    this.$parent.popperElm = this.popperElm = this.$el;
    this.$on('updatePopper', function () {
      if (_this.$parent.visible) _this.updatePopper();
    });
    this.$on('destroyPopper', this.destroyPopper);
  }
});
// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_select_dropdownvue_type_script_lang_js_ = (select_dropdownvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue





/* normalize component */

var select_dropdown_component = normalizeComponent(
  src_select_dropdownvue_type_script_lang_js_,
  select_dropdownvue_type_template_id_7354a657_render,
  select_dropdownvue_type_template_id_7354a657_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var select_dropdown = (select_dropdown_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=5a4bce75&
var optionvue_type_template_id_5a4bce75_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],ref:"dom",staticClass:"el-select-dropdown__item",class:{
    selected: _vm.itemSelected,
    'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
    'brand-font': _vm.created,
    radio: !_vm.parent.multiple,
    hover: _vm.parent.hoverIndex === _vm.index
  },attrs:{"title":_vm.showTitle ? _vm.currentLabel : ''},on:{"mouseenter":_vm.hoverItem,"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.selectOptionClick($event)}}},[(_vm.parent.multiple)?_c('span',{staticClass:"el-select_check-box-wrap"},[_c('el-checkbox',{ref:"checkbox",model:{value:(_vm.itemSelected),callback:function ($$v) {_vm.itemSelected=$$v},expression:"itemSelected"}})],1):_vm._e(),_vm._t("default",[(!_vm.showHtml)?_c('span',{class:{
        'brand-font': _vm.created
      }},[_vm._v(" "+_vm._s(_vm.currentLabel)+" ")]):_vm._e(),(_vm.showLabel && _vm.showHtml)?_c('span',{class:{
        'brand-font': _vm.created
      },domProps:{"innerHTML":_vm._s(_vm.showLabel)}}):_vm._e(),(!_vm.showLabel && _vm.showHtml)?_c('span',{class:{
        'brand-font': _vm.created
      },domProps:{"innerHTML":_vm._s(_vm.currentLabel)}}):_vm._e()])],2)}
var optionvue_type_template_id_5a4bce75_staticRenderFns = []


// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=5a4bce75&

// EXTERNAL MODULE: external "core-js/modules/es.regexp.constructor.js"
var es_regexp_constructor_js_ = __webpack_require__("86d1");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=6a53f62c&
var checkboxvue_type_template_id_6a53f62c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"el-checkbox",class:[
    _vm.border && _vm.checkboxSize ? 'el-checkbox--' + _vm.checkboxSize : '',
    { 'is-disabled': _vm.isDisabled },
    { 'is-bordered': _vm.border },
    { 'is-checked': _vm.isChecked }
  ],attrs:{"id":_vm.id,"aria-checked":_vm.indeterminate ? 'mixed' : _vm.isChecked,"aria-disabled":_vm.isDisabled,"role":"checkbox"}},[_c('span',{staticClass:"el-checkbox__input",class:{
      'is-disabled': _vm.isDisabled,
      'is-checked': _vm.isChecked && !_vm.indeterminate,
      'is-indeterminate': _vm.indeterminate,
      'is-focus': _vm.focus
    },attrs:{"aria-checked":"mixed"}},[_c('span',{staticClass:"el-checkbox__inner"},[_c('h-svg-icon',{attrs:{"size":14,"svgs":"ctrl_tick"}})],1),(_vm.trueLabel || _vm.falseLabel)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"el-checkbox__original",attrs:{"name":_vm.name,"disabled":_vm.isDisabled,"true-value":_vm.trueLabel,"false-value":_vm.falseLabel,"type":"checkbox","aria-hidden":"true"},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:_vm._q(_vm.model,_vm.trueLabel)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(_vm.trueLabel):(_vm.falseLabel);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.handleChange],"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"el-checkbox__original",attrs:{"disabled":_vm.isDisabled,"name":_vm.name,"type":"checkbox","aria-hidden":"true"},domProps:{"value":_vm.label,"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.label)>-1:(_vm.model)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.label,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.handleChange],"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}})]),(_vm.icon)?_c('span',{staticClass:"el-checkbox__icon"},[_c('i',{class:_vm.icon})]):_vm._e(),(_vm.$slots.default || _vm.label)?_c('span',{staticClass:"el-checkbox__label",attrs:{"title":_vm.titleLabel},on:{"mouseover":_vm.handleMouseover}},[_vm._t("default"),(!_vm.$slots.default && _vm.showLabel)?[_vm._v(" "+_vm._s(_vm.label)+" ")]:_vm._e()],2):_vm._e()])}
var checkboxvue_type_template_id_6a53f62c_staticRenderFns = []


// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=6a53f62c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/svg-icon/src/svg-icon.vue?vue&type=template&id=0215b44f&
var svg_iconvue_type_template_id_0215b44f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-svg-icon-wrapper",class:[_vm.offline && 'is-offline', _vm.active && 'is-active'],style:(_vm.wrapperStyle)},[(_vm.svgs || _vm.svgs.length)?_vm._l((_vm.icons),function(item,index){return _c('div',{key:index,staticClass:"h-svg-icon",class:[_vm.svgColors[index] && 'is-show-color', _vm.svgClasses[index]],style:({ color: _vm.svgColors[index] }),domProps:{"innerHTML":_vm._s(item)}})}):_vm._t("default")],2)}
var svg_iconvue_type_template_id_0215b44f_staticRenderFns = []


// CONCATENATED MODULE: ./packages/svg-icon/src/svg-icon.vue?vue&type=template&id=0215b44f&

// EXTERNAL MODULE: external "core-js/modules/es.array.includes.js"
var es_array_includes_js_ = __webpack_require__("85f7");

// EXTERNAL MODULE: external "core-js/modules/es.string.includes.js"
var es_string_includes_js_ = __webpack_require__("fd22");

// EXTERNAL MODULE: external "@babel/runtime/helpers/esm/unsupportedIterableToArray"
var unsupportedIterableToArray_ = __webpack_require__("61b7");
var unsupportedIterableToArray_default = /*#__PURE__*/__webpack_require__.n(unsupportedIterableToArray_);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js









function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = unsupportedIterableToArray_default()(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/svg-icon/src/svg-icon.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var svg_iconvue_type_script_lang_js_ = ({
  name: 'HSvgIcon',
  props: {
    svgs: {
      type: [String, Array],
      "default": ''
    },
    size: {
      type: [Number, String],
      "default": null
    },
    offline: {
      type: Boolean,
      "default": false
    },
    active: {
      type: Boolean,
      "default": false
    },
    colors: {
      type: [String, Array],
      "default": ''
    },
    classes: {
      type: [String, Array],
      "default": ''
    }
  },
  data: function data() {
    return {
      icons: this.svgs || this.svgs.length ? this.getIcons() : [],
      svgColors: this.colors || this.colors.length ? this.getColors() : [],
      svgClasses: this.classes || this.classes.length ? this.getClasses() : []
    };
  },
  computed: {
    wrapperStyle: function wrapperStyle() {
      if (this.size) return {
        'font-size': "".concat(parseInt(this.size), "px")
      };else return {};
    }
  },
  watch: {
    svgs: function svgs() {
      this.icons = this.getIcons();
    },
    colors: function colors() {
      this.svgColors = this.getColors();
    },
    classes: function classes() {
      this.svgClasses = this.getClasses();
    }
  },
  methods: {
    getIcons: function getIcons() {
      var iconsArray = [];

      if (Array.isArray(this.svgs)) {
        var _iterator = _createForOfIteratorHelper(this.svgs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var icon = _step.value;
            iconsArray.push(this.judgeSVGType(icon));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        iconsArray.push(this.judgeSVGType(this.svgs));
      }

      return iconsArray;
    },
    judgeSVGType: function judgeSVGType(icon) {
      if (icon["default"]) icon = icon["default"];

      if (icon.includes('</svg>') || icon.includes('.svg')) {
        // 为svg文件
        return icon;
      } else {
        return __webpack_require__("eb54")("./".concat(icon, ".svg"));
      }
    },
    getColors: function getColors() {
      var colorArray = [];

      if (Array.isArray(this.colors)) {
        var _iterator2 = _createForOfIteratorHelper(this.colors),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var color = _step2.value;
            colorArray.push(color);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } else {
        colorArray.push(this.colors);
      }

      return colorArray;
    },
    getClasses: function getClasses() {
      var classArray = [];

      if (Array.isArray(this.classes)) {
        var _iterator3 = _createForOfIteratorHelper(this.classes),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var className = _step3.value;
            classArray.push(className);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      } else {
        classArray.push(this.classes);
      }

      return classArray;
    }
  }
});
// CONCATENATED MODULE: ./packages/svg-icon/src/svg-icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_svg_iconvue_type_script_lang_js_ = (svg_iconvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/svg-icon/src/svg-icon.vue





/* normalize component */

var svg_icon_component = normalizeComponent(
  src_svg_iconvue_type_script_lang_js_,
  svg_iconvue_type_template_id_0215b44f_render,
  svg_iconvue_type_template_id_0215b44f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var svg_icon = (svg_icon_component.exports);
// CONCATENATED MODULE: ./packages/svg-icon/index.js


/* istanbul ignore next */

svg_icon.install = function (Vue) {
  Vue.component(svg_icon.name, svg_icon);
};

/* harmony default export */ var packages_svg_icon = (svg_icon);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
  name: 'ElCheckbox',
  components: {
    hSvgIcon: packages_svg_icon
  },
  mixins: [emitter],
  inject: {
    elForm: {
      "default": ''
    },
    elFormItem: {
      "default": ''
    }
  },
  componentName: 'ElCheckbox',
  props: {
    value: {
      type: [String, Number, Boolean],
      "default": undefined
    },
    label: {
      type: [String, Number, Boolean],
      "default": undefined
    },
    indeterminate: {
      type: Boolean,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": null
    },
    checked: {
      type: Boolean,
      "default": null
    },
    name: {
      type: String,
      "default": undefined
    },
    trueLabel: {
      type: [String, Number],
      "default": undefined
    },
    falseLabel: {
      type: [String, Number],
      "default": undefined
    },
    id: {
      type: String,
      "default": undefined
    }
    /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系 */
    ,
    controls: {
      type: String,
      "default": undefined
    }
    /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系 */
    ,
    border: {
      type: Boolean,
      "default": null
    },
    size: {
      type: String,
      "default": 'medium'
    },
    icon: {
      type: String,
      "default": undefined
    },
    showLabel: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      selfModel: false,
      focus: false,
      isLimitExceeded: false,
      titleLabel: ''
    };
  },
  computed: {
    model: {
      get: function get() {
        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
      },
      set: function set(val) {
        if (this.isGroup) {
          this.isLimitExceeded = false;
          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
          this.selfModel = val;
        }
      }
    },
    isChecked: function isChecked() {
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.model;
      } else if (Array.isArray(this.model)) {
        return this.model.indexOf(this.label) > -1;
      } else if (this.model !== null && this.model !== undefined) {
        return this.model === this.trueLabel;
      }

      return false;
    },
    isGroup: function isGroup() {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.componentName !== 'ElCheckboxGroup') {
          parent = parent.$parent;
        } else {
          this._checkboxGroup = parent; // eslint-disable-line

          return true;
        }
      }

      return false;
    },
    store: function store() {
      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
    },
    isDisabled: function isDisabled() {
      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    checkboxSize: function checkboxSize() {
      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
    }
  },
  watch: {
    value: function value(_value) {
      this.dispatch('ElFormItem', 'el.form.change', _value);
    }
  },
  created: function created() {
    this.checked && this.addToStore();
  },
  mounted: function mounted() {
    // 为indeterminate元素 添加aria-controls 属性
    if (this.indeterminate) {
      this.$el.setAttribute('aria-controls', this.controls);
    }
  },
  methods: {
    addToStore: function addToStore() {
      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
        this.model.push(this.label);
      } else {
        this.model = this.trueLabel || true;
      }
    },
    // 鼠标悬停显示Lable
    // 移除过滤条件，个人认为比较多余，就直接做成悬浮展示 xx 2020/5/29
    handleMouseover: function handleMouseover(e) {
      var t = e.target;

      if (t.tagName === 'SPAN') {
        // if (t.scrollWidth >= t.offsetWidth) {
        this.titleLabel = t.innerText; // } else {
        //   this.titleLabel = '';
        // }
      }
    },
    handleChange: function handleChange(ev) {
      var _this = this;

      if (this.isLimitExceeded) return;
      var value;

      if (ev.target.checked) {
        value = this.trueLabel === undefined ? true : this.trueLabel;
      } else {
        value = this.falseLabel === undefined ? false : this.falseLabel;
      }

      this.$emit('change', value, ev);
      this.$nextTick(function () {
        if (_this.isGroup) {
          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue





/* normalize component */

var checkbox_component = normalizeComponent(
  src_checkboxvue_type_script_lang_js_,
  checkboxvue_type_template_id_6a53f62c_render,
  checkboxvue_type_template_id_6a53f62c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_checkbox = (checkbox_component.exports);
// CONCATENATED MODULE: ./packages/checkbox/index.js


/* istanbul ignore next */

src_checkbox.install = function (Vue) {
  Vue.component(src_checkbox.name, src_checkbox);
};

/* harmony default export */ var packages_checkbox = (src_checkbox);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 // import ElTooltip from 'hui/packages/tooltip';



/* harmony default export */ var optionvue_type_script_lang_js_ = ({
  name: 'ElOption',
  components: {
    ElCheckbox: packages_checkbox
  },
  mixins: [emitter],
  componentName: 'ElOption',
  props: {
    value: {
      type: null,
      required: true
    },
    label: {
      type: [String, Number],
      "default": null
    },
    created: {
      type: Boolean,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    showHtml: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      index: -1,
      groupDisabled: false,
      visible: true,
      hitState: false,
      showTitle: false,
      showLabel: null
    };
  },
  computed: {
    isObject: function isObject() {
      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
    },
    currentLabel: function currentLabel() {
      return this.label || (this.isObject ? '' : this.value);
    },
    currentValue: function currentValue() {
      return this.value || this.label || '';
    },
    parent: function parent() {
      var result = this.$parent;

      while (!result.isSelect) {
        result = result.$parent;
      }

      return result;
    },
    itemSelected: {
      get: function get() {
        if (!this.parent.multiple) {
          return this.isEqual(this.value, this.parent.value);
        } else {
          return this.contains(this.parent.value, this.value);
        }
      },
      set: function set() {}
    },
    limitReached: function limitReached() {
      if (this.parent.multiple) {
        return !this.itemSelected && this.parent.value.length >= this.parent.multipleLimit && this.parent.multipleLimit > 0;
      } else {
        return false;
      }
    }
  },
  watch: {
    currentLabel: function currentLabel() {
      if (!this.created && !this.parent.remote) {
        this.dispatch('ElSelect', 'setSelected');
      }
    },
    value: function value() {
      if (!this.created && !this.parent.remote) {
        this.dispatch('ElSelect', 'setSelected');
      }
    }
  },
  created: function created() {
    this.parent.options.push(this);
    this.parent.cachedOptions.push(this);
    this.parent.optionsCount++;
    this.parent.filteredOptionsCount++;
    this.index = this.parent.options.indexOf(this);
    this.$on('queryChange', this.queryChange);
    this.$on('handleGroupDisabled', this.handleGroupDisabled);
    this.$on('resetIndex', this.resetIndex);
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('ElSelect', 'onOptionDestroy', this);
  },
  methods: {
    isEqual: function isEqual(a, b) {
      if (!this.isObject) {
        return a === b;
      } else {
        var valueKey = this.parent.valueKey;
        return getValueByPath(a, valueKey) === getValueByPath(b, valueKey);
      }
    },
    contains: function contains() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var target = arguments.length > 1 ? arguments[1] : undefined;

      if (!this.isObject) {
        return arr.indexOf(target) > -1;
      } else {
        var valueKey = this.parent.valueKey;
        return arr.some(function (item) {
          return getValueByPath(item, valueKey) === getValueByPath(target, valueKey);
        });
      }
    },
    handleGroupDisabled: function handleGroupDisabled(val) {
      this.groupDisabled = val;
    },
    hoverItem: function hoverItem() {
      this.showTitle = this.$refs.dom.clientWidth < this.$refs.dom.scrollWidth;

      if (!this.disabled && !this.groupDisabled) {
        this.parent.hoverIndex = this.parent.options.indexOf(this);
      }

      if (this.disabled) {
        this.parent.hoverIndex = -1;
      }
    },
    selectOptionClick: function selectOptionClick() {
      if (this.disabled !== true && this.groupDisabled !== true) {
        this.dispatch('ElSelect', 'handleOptionClick', this);
      }
    },
    queryChange: function queryChange(query) {
      // query 里如果有正则中的特殊字符，需要先将这些字符转义
      var parsedQuery = String(query).replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, '\\$1');
      this.visible = new RegExp(parsedQuery, 'i').test(this.currentLabel) || this.created;

      if (!this.visible) {
        this.parent.filteredOptionsCount--;
      } else {
        if (this.created) {
          this.showLabel = query;
          return;
        }

        if (parsedQuery) {
          this.showLabel = this.currentLabel.replace(new RegExp(parsedQuery, 'g'), "<font class='brand-font'>" + query + '</font>');
        } else {
          this.showLabel = null;
        }
      }
    },
    resetIndex: function resetIndex() {
      var _this = this;

      this.$nextTick(function () {
        _this.index = _this.parent.options.indexOf(_this);
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/select/src/option.vue





/* normalize component */

var option_component = normalizeComponent(
  src_optionvue_type_script_lang_js_,
  optionvue_type_template_id_5a4bce75_render,
  optionvue_type_template_id_5a4bce75_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_option = (option_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=template&id=a1768916&
var tagvue_type_template_id_a1768916_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.disableTransitions ? '' : 'el-zoom-in-center'}},[_c('span',{staticClass:"el-tag",class:[
      _vm.type ? 'el-tag--' + _vm.type : '',
      _vm.size ? ("el-tag--" + _vm.size) : '',
      _vm.maxWidth ? "el-tag--maxwidth" : '',
      { 'is-hit': _vm.hit },
      _vm.color ? 'el-tag--custom--color' : '',
      _vm.closable ? 'el-tag--closable' : ''
    ],style:([{ backgroundColor: _vm.color }]),attrs:{"title":_vm.title}},[_c('span',{class:[_vm.maxWidth ? "el-tag--maxwidth" : ''],style:([
        _vm.maxWidth ? { 'max-width': _vm.maxWidth, display: 'inline-block' } : ''
      ])},[_vm._t("default")],2),(_vm.closable)?_c('i',{staticClass:"el-tag__close h-icon-close",on:{"click":_vm.handleClose}}):_vm._e()])])}
var tagvue_type_template_id_a1768916_staticRenderFns = []


// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=template&id=a1768916&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var tagvue_type_script_lang_js_ = ({
  name: 'ElTag',
  props: {
    text: {
      type: String,
      "default": null
    },
    closable: {
      type: Boolean,
      "default": null
    },
    type: {
      type: String,
      "default": null
    },
    hit: {
      type: Boolean,
      "default": null
    },
    disableTransitions: {
      type: Boolean,
      "default": null
    },
    color: {
      type: String,
      "default": null
    },
    size: {
      type: String,
      "default": ''
    },
    maxWidth: {
      type: String,
      "default": '200px'
    },
    title: {
      type: String,
      "default": ''
    }
  },
  methods: {
    handleClose: function handleClose(event) {
      this.$emit('close', event);
    }
  }
});
// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tagvue_type_script_lang_js_ = (tagvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tag/src/tag.vue





/* normalize component */

var tag_component = normalizeComponent(
  src_tagvue_type_script_lang_js_,
  tagvue_type_template_id_a1768916_render,
  tagvue_type_template_id_a1768916_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tag = (tag_component.exports);
// CONCATENATED MODULE: ./packages/tag/index.js


/* istanbul ignore next */

tag.install = function (Vue) {
  Vue.component(tag.name, tag);
};

/* harmony default export */ var packages_tag = (tag);
// EXTERNAL MODULE: external "resize-observer-polyfill"
var external_resize_observer_polyfill_ = __webpack_require__("a1cc");
var external_resize_observer_polyfill_default = /*#__PURE__*/__webpack_require__.n(external_resize_observer_polyfill_);

// CONCATENATED MODULE: ./src/utils/resize-event.js






var resize_event_isServer = typeof window === 'undefined';
/* istanbul ignore next */

var resize_event_resizeHandler = function resizeHandler(entries) {
  var _iterator = _createForOfIteratorHelper(entries),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var entry = _step.value;
      var listeners = entry.target.__resizeListeners__ || [];

      if (listeners.length) {
        listeners.forEach(function (fn) {
          fn();
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
/* istanbul ignore next */


var resize_event_addResizeListener = function addResizeListener(element, fn) {
  if (resize_event_isServer) return;

  if (!element.__resizeListeners__) {
    element.__resizeListeners__ = [];
    element.__ro__ = new external_resize_observer_polyfill_default.a(resize_event_resizeHandler);

    element.__ro__.observe(element);
  }

  element.__resizeListeners__.push(fn);
};
/* istanbul ignore next */

var removeResizeListener = function removeResizeListener(element, fn) {
  if (!element || !element.__resizeListeners__) return;

  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);

  if (!element.__resizeListeners__.length) {
    element.__ro__.disconnect();
  }
};
// CONCATENATED MODULE: ./packages/scrollbar/src/util.js



var BAR_MAP = {
  vertical: {
    offset: 'offsetHeight',
    scroll: 'scrollTop',
    scrollSize: 'scrollHeight',
    size: 'height',
    paddingPosition: 'paddingBottom',
    key: 'vertical',
    axis: 'Y',
    client: 'clientY',
    direction: 'top'
  },
  horizontal: {
    offset: 'offsetWidth',
    scroll: 'scrollLeft',
    scrollSize: 'scrollWidth',
    size: 'width',
    paddingPosition: 'paddingRight',
    key: 'horizontal',
    axis: 'X',
    client: 'clientX',
    direction: 'left'
  }
};
function renderThumbStyle(_ref) {
  var size = _ref.size,
      bar = _ref.bar,
      minLength = _ref.minLength,
      railSize = _ref.railSize,
      percent = _ref.percent;
  var style = {};
  var translate;

  var _size = typeof size !== 'number' ? +size.replace('%', '') : minLength;

  if (railSize && railSize * _size / 100 < minLength) {
    var barSize = minLength;
    translate = "translate".concat(bar.axis, "(").concat((railSize - barSize) * percent / barSize * 100, "%)");
    style[bar.size] = barSize + 'px';
  } else {
    var _barSize = _size / 100 * railSize;

    translate = "translate".concat(bar.axis, "(").concat((railSize - _barSize) * percent / _barSize * 100, "%)");
    style[bar.size] = size;
  }

  style.transform = translate;
  style.msTransform = translate;
  style.webkitTransform = translate;
  return style;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/scrollbar/src/bar.vue?vue&type=script&lang=js&





/* istanbul ignore next */

/* harmony default export */ var barvue_type_script_lang_js_ = ({
  name: 'Bar',
  props: {
    vertical: {
      type: Boolean,
      "default": null
    },
    overflow: {
      type: String,
      "default": 'auto'
    },
    overflowX: {
      type: String,
      "default": 'auto'
    },
    overflowY: {
      type: String,
      "default": 'auto'
    },
    size: {
      type: [String, Number],
      "default": null
    },
    percent: {
      type: Number,
      "default": null
    },
    width: {
      type: Number,
      "default": null
    },
    opacity: {
      type: Number,
      "default": null
    },
    pieceOpacity: {
      type: Number,
      "default": null
    },
    color: {
      type: String,
      "default": null
    },
    pieceColor: {
      type: String,
      "default": null
    },
    minLength: {
      type: Number,
      "default": null
    }
  },
  data: function data() {
    return {
      isMousewheel: false,
      timer: null,
      prevEvent: null
    };
  },
  computed: {
    bar: function bar() {
      return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
    },
    wrap: function wrap() {
      return this.$parent.wrap;
    }
  },
  destroyed: function destroyed() {
    off(document, 'mouseup', this.mouseUpDocumentHandler);
  },
  methods: {
    handleMousewheel: function handleMousewheel() {
      var _this = this;

      if (this.isMousewheel) {
        return;
      }

      this.isMousewheel = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this.isMousewheel = false;
      }, 500);
    },
    handleMouseleave: function handleMouseleave() {
      this.isMousewheel = false;
    },
    clickThumbHandler: function clickThumbHandler(e) {
      this.prevEvent = e;
      this.startDrag(e);

      if (e.ctrlKey || e.button === 2) {
        return;
      }

      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
    },
    clickTrackHandler: function clickTrackHandler(e) {
      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$refs.rail[this.bar.offset];
      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    startDrag: function startDrag(e) {
      e.stopImmediatePropagation();
      this.cursorDown = true;
      on(document, 'mousemove', this.mouseMoveDocumentHandler);
      on(document, 'mouseup', this.mouseUpDocumentHandler);

      document.onselectstart = function () {
        return false;
      };
    },
    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
      if (this.prevEvent.clientX === e.clientX && this.prevEvent.clientY === e.clientY) {
        return;
      }

      if (this.cursorDown === false) return; // 防止选中滚动条的情况下拖动滚动条

      if (window.getSelection) {
        var selection = window.getSelection();

        if (selection.type === 'Range' && selection.getRangeAt(0).endContainer.className === 'el-scrollbar__thumb') {
          return;
        }
      }

      var prevPage = this[this.bar.axis];
      if (!prevPage) return;
      var offset = (this.$refs.rail.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$refs.rail[this.bar.offset];
      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    mouseUpDocumentHandler: function mouseUpDocumentHandler() {
      this.cursorDown = false;
      this[this.bar.axis] = 0;
      off(document, 'mousemove', this.mouseMoveDocumentHandler);
      document.onselectstart = null;
    },
    getBarStyle: function getBarStyle(type) {
      var style = {};
      var railSize = this.$refs.rail && this.$refs.rail.getBoundingClientRect()[this.bar.size];

      var setVisible = function setVisible() {
        style.visibility = 'visible';
      };

      if (type === 'bar') {
        var bar = this.bar,
            width = this.width,
            pieceColor = this.pieceColor,
            pieceOpacity = this.pieceOpacity,
            vertical = this.vertical,
            overflow = this.overflow,
            overflowX = this.overflowX,
            overflowY = this.overflowY;

        if (pieceOpacity) {
          style.opacity = pieceOpacity;
        }

        if (vertical && (overflowY === 'scroll' || overflow === 'scroll')) {
          setVisible();
        } else if (overflowX === 'scroll' || overflow === 'scroll') {
          setVisible();
        }

        if (width) {
          style[bar.key === 'horizontal' ? 'height' : 'width'] = width + 'px';
        }

        if (pieceColor) {
          style['background-color'] = pieceColor;
        } // const { _sizeMinheight, minLength } = this;
        // if (_sizeMinheight && _sizeMinheight !== 1) {
        //   // 修补滚动条放大后的影响，需要补上原有的2px
        //   style[this.bar.paddingPosition] =
        //     minLength * (1 - _sizeMinheight) + 2 + 'px';
        // }

      } else {
        var size = this.size,
            _bar = this.bar,
            color = this.color,
            opacity = this.opacity,
            percent = this.percent,
            minLength = this.minLength;
        if (opacity) style.opacity = opacity;
        if (color) style['background-color'] = color;
        Object.assign(style, renderThumbStyle.call(this, {
          size: size,
          bar: _bar,
          minLength: minLength,
          railSize: railSize,
          percent: percent
        }));
      }

      return style;
    }
  },
  render: function render() {
    var h = arguments[0];
    var bar = this.bar;
    return h("div", {
      "class": ['el-scrollbar__bar', 'is-' + bar.key, {
        'is-mousewheel': this.isMousewheel
      }],
      "on": {
        "mousewheel": this.handleMousewheel,
        "mouseleave": this.handleMouseleave,
        "mousedown": this.clickTrackHandler
      },
      "style": this.getBarStyle('bar')
    }, [h("div", {
      "ref": 'rail',
      "class": 'el-scrollbar__rail'
    }, [h("div", {
      "ref": 'thumb',
      "class": 'el-scrollbar__thumb',
      "on": {
        "mousedown": this.clickThumbHandler
      },
      "style": this.getBarStyle('thumb')
    })])]);
  }
});
// CONCATENATED MODULE: ./packages/scrollbar/src/bar.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_barvue_type_script_lang_js_ = (barvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/scrollbar/src/bar.vue
var bar_render, bar_staticRenderFns




/* normalize component */

var bar_component = normalizeComponent(
  src_barvue_type_script_lang_js_,
  bar_render,
  bar_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_bar = (bar_component.exports);
// EXTERNAL MODULE: external "throttle-debounce/throttle"
var throttle_ = __webpack_require__("1e79");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle_);

// CONCATENATED MODULE: ./src/utils/scroll-to.js


var scrollTo = function scrollTo(element, to, duration) {
  var isLeft = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var requestAnimationFrame = window.requestAnimationFrame || function requestAnimationFrameTimeout() {
    return setTimeout(arguments[0], 10);
  };

  var scrollDirection;

  if (isLeft) {
    scrollDirection = 'scrollLeft';
  } else {
    scrollDirection = 'scrollTop';
  } // jump to target if duration zero


  if (duration <= 0) {
    element[scrollDirection] = to;
    return;
  }

  var difference = to - element[scrollDirection];
  var perTick = difference / duration * 10;
  requestAnimationFrame(function () {
    element[scrollDirection] += perTick;
    if (element[scrollDirection] === to) return;
    scrollTo(element, to, duration - 10, isLeft);
  });
};

/* harmony default export */ var scroll_to = (scrollTo);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/scrollbar/src/main.vue?vue&type=script&lang=js&



// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js







/* istanbul ignore next */

/* harmony default export */ var scrollbar_src_mainvue_type_script_lang_js_ = ({
  name: 'ElScrollbar',
  components: {
    Bar: src_bar
  },
  props: {
    "native": {
      type: Boolean,
      "default": null
    },
    extrusion: {
      type: Boolean,
      "default": false
    },
    overflow: {
      type: String,
      "default": 'auto'
    },
    overflowX: {
      type: String,
      "default": 'auto'
    },
    overflowY: {
      type: String,
      "default": 'auto'
    },
    size: {
      type: Number,
      "default": 4
    },
    // 滚动条的宽度
    opacity: {
      type: Number,
      "default": 1
    },
    // 滚动条透明度
    pieceOpacity: {
      type: Number,
      "default": 1
    },
    // 轨道透明度
    color: {
      type: String,
      "default": null
    },
    // 滚动条颜色，支持16进制颜色、rgb和rgba
    pieceColor: {
      type: String,
      "default": null
    },
    // 轨道颜色，默认透明即同容器背景色，支持16进制颜色、rgb和rgba
    wrapClass: {
      type: [Object, String],
      "default": null
    },
    wrapStyle: {
      type: [Object, Array, String],
      "default": function _default() {}
    },
    viewClass: {
      type: [Object, String],
      "default": null
    },
    viewStyle: {
      type: [Object, Array, String],
      "default": function _default() {}
    },
    noresize: {
      type: Boolean,
      "default": false
    },
    // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
    tag: {
      type: String,
      "default": 'div'
    },
    minLength: {
      // 滚动条最小长度
      type: Number,
      "default": 24
    }
  },
  data: function data() {
    return {
      sizeWidth: this.minLength,
      sizeHeight: this.minLength,
      percentX: 0,
      percentY: 0,
      gutter: 0,
      position: null
    };
  },
  computed: {
    wrap: function wrap() {
      return this.$refs.wrap;
    },
    isDoubleScroll: function isDoubleScroll() {
      return this.showHorizontal && this.showVertical;
    },
    showHorizontal: function showHorizontal() {
      return this.overflow !== 'visible' && this.overflow !== 'hidden' && this.overflowX !== 'visible' && this.overflowX !== 'hidden' && this.sizeWidth !== this.minLength;
    },
    showVertical: function showVertical() {
      return this.overflow !== 'visible' && this.overflow !== 'hidden' && this.overflowY !== 'visible' && this.overflowY !== 'hidden' && this.sizeHeight !== this.minLength;
    }
  },
  mounted: function mounted() {
    if (this["native"]) return;
    this.$nextTick(this.update);

    if (!this.noresize) {
      resize_event_addResizeListener(this.$refs.wrap, this.throttleUpdate);
      resize_event_addResizeListener(this.$refs.resize, this.throttleUpdate);
    }

    this.position = getStyle(this.wrap, 'position');
  },
  beforeDestroy: function beforeDestroy() {
    if (this["native"]) return;

    if (!this.noresize) {
      removeResizeListener(this.$refs.wrap, this.throttleUpdate);
      removeResizeListener(this.$refs.resize, this.throttleUpdate);
    }
  },
  methods: {
    handleScroll: function handleScroll() {
      var wrap = this.wrap;
      var percentX = wrap.scrollLeft / (wrap.scrollWidth - wrap.clientWidth);
      var percentY = wrap.scrollTop / (wrap.scrollHeight - wrap.clientHeight);
      this.percentX = percentX;
      this.percentY = percentY;
      var scrollValue = {
        scrollLeft: wrap.scrollLeft,
        scrollTop: wrap.scrollTop,
        percentX: percentX,
        percentY: percentY
      };
      this.$emit('on-scrolling-x', scrollValue);
      this.$emit('on-scrolling-y', scrollValue);
      this.$emit('on-scrolling', scrollValue);
    },
    throttleUpdate: function throttleUpdate() {
      var _this = this;

      throttle_default()(500, function () {
        return _this.update(true);
      })();
    },
    update: function update(isThrottle) {
      var _this2 = this;

      this.$nextTick(function () {
        var wrap = _this2.wrap;
        if (!wrap) return;
        var heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
        var widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;
        _this2.sizeHeight = heightPercentage < 99 ? heightPercentage + '%' : _this2.minLength;
        _this2.sizeWidth = widthPercentage < 99 ? widthPercentage + '%' : _this2.minLength;

        _this2.$emit('on-scrollbar-x', _this2.showHorizontal);

        _this2.$emit('on-scrollbar-y', _this2.showVertical);
      });
    },
    setScroll: function setScroll() {
      var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 120;

      if (top > -1) {
        scroll_to(this.wrap, top, duration);
      }

      if (left > -1) {
        scroll_to(this.wrap, left, duration, true);
      }

      this.update();
    }
  },
  render: function render(h) {
    this.gutter = scrollbar_width(true);
    var style = this.wrapStyle;

    if (this.gutter) {
      var gutterWidth = "-".concat(this.gutter, "px");
      var gutterStyle = "margin-bottom: ".concat(gutterWidth, "; margin-right: ").concat(gutterWidth, ";");

      if (Array.isArray(this.wrapStyle)) {
        style = toObject(this.wrapStyle);
        style.marginRight = style.marginBottom = gutterWidth;
      } else if (typeof this.wrapStyle === 'string') {
        style += gutterStyle;
      } else {
        style = gutterStyle;
      }

      if (this.extrusion) {
        style += 'padding-right: 12px;';
      }
    }

    var view = h(this.tag, {
      "class": ['el-scrollbar__view', this.viewClass],
      style: this.viewStyle,
      ref: 'resize'
    }, this.$slots["default"]);
    var wrap = h("div", {
      "ref": 'wrap',
      "style": style,
      "on": {
        "scroll": this.handleScroll
      },
      "class": [this.wrapClass, 'el-scrollbar__wrap', this.gutter ? '' : 'el-scrollbar__wrap--hidden-default']
    }, [[view]]);
    var nodes;

    if (!this["native"]) {
      nodes = [wrap, h(src_bar, {
        "ref": 'horizontal',
        "directives": [{
          name: "show",
          value: this.showHorizontal
        }],
        "attrs": {
          "percent": this.percentX,
          "size": this.sizeWidth,
          "width": this.size + 8,
          "opacity": this.opacity,
          "pieceOpacity": this.pieceOpacity,
          "color": this.color,
          "pieceColor": this.pieceColor,
          "overflow": this.overflow,
          "overflowX": this.overflowX,
          "overflowY": this.overflowY,
          "minLength": this.minLength
        }
      }), h(src_bar, {
        "ref": 'vertical',
        "directives": [{
          name: "show",
          value: this.showVertical
        }],
        "attrs": {
          "vertical": true,
          "percent": this.percentY,
          "size": this.sizeHeight,
          "width": this.size + 8,
          "opacity": this.opacity,
          "pieceOpacity": this.pieceOpacity,
          "pieceColor": this.pieceColor,
          "color": this.color,
          "overflow": this.overflow,
          "overflowX": this.overflowX,
          "overflowY": this.overflowY,
          "minLength": this.minLength
        }
      })];
    } else {
      nodes = [h("div", {
        "ref": 'wrap',
        "class": [this.wrapClass, 'el-scrollbar__wrap'],
        "style": style
      }, [[view]])];
    }

    return h('div', {
      "class": ['el-scrollbar', {
        'is-double': this.isDoubleScroll,
        'has-gutter': this.gutter
      }]
    }, nodes);
  }
});
// CONCATENATED MODULE: ./packages/scrollbar/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_scrollbar_src_mainvue_type_script_lang_js_ = (scrollbar_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/scrollbar/src/main.vue
var main_render, main_staticRenderFns




/* normalize component */

var src_main_component = normalizeComponent(
  packages_scrollbar_src_mainvue_type_script_lang_js_,
  main_render,
  main_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_main = (src_main_component.exports);
// CONCATENATED MODULE: ./packages/scrollbar/index.js


/* istanbul ignore next */

src_main.install = function (Vue) {
  Vue.component(src_main.name, src_main);
};

/* harmony default export */ var scrollbar = (src_main);
// EXTERNAL MODULE: external "throttle-debounce/debounce"
var debounce_ = __webpack_require__("7435");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

// CONCATENATED MODULE: ./src/utils/clickoutside.js






var nodeList = [];
var ctx = '@@clickoutsideContext';
var startClick;
var seed = 0;
!external_vue_default.a.prototype.$isServer && on(document, 'mousedown', function (e) {
  return startClick = e;
});
!external_vue_default.a.prototype.$isServer && on(document, 'mouseup', function (e) {
  nodeList.forEach(function (node) {
    return node[ctx].documentHandler(e, startClick);
  });
});

function createDocumentHandler(el, binding, vnode, excludes) {
  return function () {
    var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) {
      return;
    }

    if (excludes && (excludes.includes(mousedown.target) || excludes.includes(mouseup.target))) {
      return;
    }

    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
      vnode.context[el[ctx].methodName]();
    } else {
      el[ctx].bindingFn && el[ctx].bindingFn();
    }
  };
}
/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */


/* harmony default export */ var clickoutside = ({
  bind: function bind(el, binding, vnode) {
    nodeList.push(el);
    var id = seed++;
    el[ctx] = {
      id: id,
      documentHandler: createDocumentHandler(el, binding, vnode, binding.value.excludes),
      methodName: binding.expression,
      bindingFn: typeof binding.value === 'function' ? binding.value : binding.value.fn
    };
  },
  update: function update(el, binding, vnode) {
    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode, binding.value.excludes);
    el[ctx].methodName = binding.expression;
    el[ctx].bindingFn = typeof binding.value === 'function' ? binding.value : binding.value.fn;
  },
  unbind: function unbind(el) {
    var len = nodeList.length;

    for (var i = 0; i < len; i++) {
      if (nodeList[i][ctx].id === el[ctx].id) {
        nodeList.splice(i, 1);
        break;
      }
    }

    delete el[ctx];
  }
});
// CONCATENATED MODULE: ./src/utils/scroll-into-view.js

function scrollIntoView(container, selected) {
  if (external_vue_default.a.prototype.$isServer) return;

  if (!selected) {
    container.scrollTop = 0;
    return;
  }

  var top = selected.offsetTop;
  var bottom = selected.offsetTop + selected.offsetHeight;
  var viewRectTop = container.scrollTop;
  var viewRectBottom = viewRectTop + container.clientHeight;

  if (top < viewRectTop) {
    container.scrollTop = top;
  } else if (bottom > viewRectBottom) {
    container.scrollTop = bottom - container.clientHeight;
  }
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
















//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var sizeMap = {
  large: 42,
  small: 30,
  mini: 22
};
/* harmony default export */ var selectvue_type_script_lang_js_ = ({
  name: 'ElSelect',
  components: {
    ElInput: packages_input,
    ElSelectMenu: select_dropdown,
    ElOption: src_option,
    ElTag: packages_tag,
    ElScrollbar: scrollbar
  },
  directives: {
    Clickoutside: clickoutside
  },
  mixins: [emitter, locale],
  componentName: 'ElSelect',
  props: {
    name: {
      type: String,
      "default": null
    },
    value: {
      type: [String, Number, Array, Object],
      required: true
    },
    size: {
      type: String,
      "default": null
    },
    clearable: {
      type: Boolean,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    readonly: {
      type: Boolean,
      "default": null
    },
    reserveKeyword: {
      type: Boolean,
      "default": null
    },
    clear: {
      type: Boolean,
      "default": null
    },
    filterable: {
      type: Boolean,
      "default": false
    },
    allowCreate: {
      type: Boolean,
      "default": null
    },
    loading: {
      type: Boolean,
      "default": null
    },
    popperClass: {
      type: String,
      "default": null
    },
    remote: {
      type: Boolean,
      "default": null
    },
    loadingText: {
      type: String,
      "default": null
    },
    noMatchText: {
      type: String,
      "default": null
    },
    kind: {
      type: String,
      "default": null
    },
    noDataText: {
      type: String,
      "default": null
    },
    remoteMethod: {
      type: Function,
      "default": null
    },
    filterMethod: {
      type: Function,
      "default": null
    },
    multiple: {
      type: Boolean,
      "default": null
    },
    multipleNowrap: {
      type: Boolean,
      "default": null
    },
    multipleLimit: {
      type: Number,
      "default": 0
    },
    maxWidth: {
      type: Number,
      "default": null
    },
    placeholder: {
      type: String,
      "default": function _default() {
        return Object(locale_["t"])('el.select.placeholder');
      }
    },
    defaultFirstOption: {
      type: Boolean,
      "default": null
    },
    valueKey: {
      type: String,
      "default": 'value'
    },
    collapseTags: {
      type: Boolean,
      "default": null
    },
    popperAppendToBody: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      options: [],
      cachedOptions: [],
      createdLabel: null,
      createdSelected: false,
      selected: this.multiple ? [] : {},
      isSelect: true,
      isClick: false,
      textWidth: 0,
      inputWidth: 0,
      inputWidthMin: 0,
      inputClear: false,
      cachedPlaceHolder: '',
      optionsCount: 0,
      filteredOptionsCount: 0,
      visible: false,
      selectedLabel: '',
      hoverIndex: -1,
      query: '',
      optionsAllDisabled: false,
      inputHovering: false,
      currentPlaceholder: '',
      isIE: false // 判断是否是ie

    };
  },
  computed: {
    showDropdown: function showDropdown() {
      // if (!this.multiple && this.search && this.query === '') {
      //   return false;
      // }
      return this.visible && this.emptyText !== false;
    },
    search: function search() {
      return this.filterable || this.remote;
    },
    criteria: function criteria() {
      return !this.disabled && this.inputHovering && ( // 单选清除 与 多选清除
      this.clear && !this.multiple && this.value !== undefined && this.value !== '' || this.clearable && this.multiple && Array.isArray(this.value) && this.value.length);
    },
    iconClass: function iconClass() {
      if (this.criteria) {
        return 'h-icon-close_f';
      } else {
        return 'h-icon-angle_down_sm';
      }
    },
    debounce: function debounce() {
      return this.remote ? 300 : 0;
    },
    emptyText: function emptyText() {
      if (this.loading) {
        return this.loadingText || this.t('el.select.loading');
      } else {
        if (this.remote && this.query === '' && this.options.length === 0) {
          return false;
        }

        if (this.options.length === 0) {
          return this.noDataText || this.t('el.select.noData');
        } else if (this.filterable && this.options.length > 0 && this.filteredOptionsCount === 0) {
          return this.noMatchText || this.t('el.select.noMatch');
        }
      }

      return null;
    },
    showNewOption: function showNewOption() {
      var _this = this;

      var hasExistingOption = this.options.filter(function (option) {
        return !option.created;
      }).some(function (option) {
        return option.currentLabel === _this.query;
      });
      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
    },
    selectSize: function selectSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    selectDisabled: function selectDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    collapseTagSize: function collapseTagSize() {
      return ['medium', 'small'].indexOf(this.selectSize) > -1 ? 'small' : 'medium';
    }
  },
  watch: {
    placeholder: function placeholder(val) {
      this.cachedPlaceHolder = this.currentPlaceholder = val;
    },
    value: function value(val) {
      if (this.multiple) {
        // this.resetInputHeight();
        if (val.length > 0 || this.$refs.input && this.query !== '') {
          this.currentPlaceholder = '';
        } else {
          this.currentPlaceholder = this.cachedPlaceHolder;
        }
      }

      this.setSelected(); // if (this.filterable && !this.multiple) {
      //   this.inputLength = 20;
      // }

      this.$emit('change', val, this);
      this.dispatch('ElFormItem', 'el.form.change', val);
    },
    query: function query(val) {
      var _this2 = this;

      if (this.remote || this.allowCreate) {
        // const newValue = val.trim();
        var newValue = val || val === 0 ? val.toString().trim() : val.trim();

        if (newValue !== val) {
          this.query = newValue;
          return;
        }
      }

      this.$nextTick(function () {
        if (_this2.visible) _this2.broadcast('ElSelectDropdown', 'updatePopper');
        _this2.textWidth = _this2.$refs.text.getBoundingClientRect().width;

        _this2.resetInputHeight();
      });
      this.hoverIndex = -1;

      if (this.remote && typeof this.remoteMethod === 'function') {
        this.hoverIndex = -1;
        this.remoteMethod(val, this.isClick);
        this.isClick = false;
        this.broadcast('ElOption', 'resetIndex');
      } else if (typeof this.filterMethod === 'function') {
        this.filterMethod(val);
        this.broadcast('ElOptionGroup', 'queryChange');
      } else {
        this.filteredOptionsCount = this.optionsCount;
        this.broadcast('ElOption', 'queryChange', val);
        this.broadcast('ElOptionGroup', 'queryChange');
      }

      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
        this.checkDefaultFirstOption();
      }
    },
    visible: function visible(val) {
      var _this3 = this;

      if (!val) {
        this.$refs.reference.$el.querySelector('input').blur();

        if (!this.criteria) {
          this.handleIconHide();
        }

        this.broadcast('ElSelectDropdown', 'destroyPopper');

        if (this.$refs.input) {
          this.$refs.input.blur();
        }

        this.query = '';
        this.selectedLabel = ''; // this.inputLength = 20;

        this.resetHoverIndex();
        this.$nextTick(function () {
          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
          }
        });

        if (!this.multiple) {
          if (this.selected) {
            if (this.filterable && this.allowCreate && this.createdSelected && this.createdOption) {
              this.selectedLabel = this.createdLabel;
            } else {
              this.selectedLabel = this.selected.currentLabel;
            }

            if (this.filterable) this.query = this.selectedLabel;
          }
        }
      } else {
        if (!this.criteria) {
          this.handleIconShow();
        }

        this.broadcast('ElSelectDropdown', 'updatePopper');

        if (this.filterable) {
          this.query = this.selectedLabel;

          if (this.multiple) {
            this.$refs.input.focus();
          } else {
            if (!this.remote) {
              this.broadcast('ElOption', 'queryChange', '');
              this.broadcast('ElOptionGroup', 'queryChange');
            }

            this.broadcast('ElInput', 'inputSelect');
          }
        }
      }

      this.$emit('visible-change', val);
    },
    options: function options(val) {
      if (this.$isServer) return;
      this.optionsAllDisabled = val.length === val.filter(function (item) {
        return item.disabled === true;
      }).length;

      if (this.multiple) {
        this.resetInputHeight();
      }

      var inputs = this.$el.querySelectorAll('input');

      if ([].indexOf.call(inputs, document.activeElement) === -1) {
        this.setSelected();
      }

      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
        this.checkDefaultFirstOption();
      }
    }
  },
  created: function created() {
    var _this4 = this;

    this.cachedPlaceHolder = this.currentPlaceholder = this.placeholder;

    if (this.multiple && !Array.isArray(this.value)) {
      this.$emit('input', []);
    }

    if (!this.multiple && Array.isArray(this.value)) {
      this.$emit('input', '');
    }

    this.setSelected();
    this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
      _this4.onInputChange();
    });
    this.$on('handleOptionClick', this.handleOptionSelect);
    this.$on('onOptionDestroy', this.onOptionDestroy);
    this.$on('setSelected', this.setSelected);
  },
  mounted: function mounted() {
    var _this5 = this;

    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
      this.currentPlaceholder = '';
    }

    resize_event_addResizeListener(this.$el, this.handleResize);

    if (this.remote && this.multiple) {
      this.resetInputHeight();
    }

    this.$nextTick(function () {
      if (_this5.$refs.reference && _this5.$refs.reference.$el) {
        _this5.inputWidth = _this5.$refs.reference.$el.getBoundingClientRect().width;
        _this5.textWidth = _this5.$refs.text.getBoundingClientRect().width;
      }
    }); // ie兼容

    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      this.isIE = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el && this.handleResize) {
      removeResizeListener(this.$el, this.handleResize);
    }
  },
  methods: {
    handleIconHide: function handleIconHide() {
      var icon = this.$el.querySelector('.el-input__suffix'); // if (icon && !this.search) {
      //   removeClass(icon, 'is-reverse');
      // }

      if (icon) {
        removeClass(icon, 'is-reverse');
      }
    },
    handleIconShow: function handleIconShow() {
      var icon = this.$el.querySelector('.el-input__suffix'); // if (icon && !hasClass(icon, 'h-icon-close_f') && !this.search) {
      //   addClass(icon, 'is-reverse');
      // }

      if (icon && !hasClass(icon, 'h-icon-close_f')) {
        addClass(icon, 'is-reverse');
      }
    },
    scrollToOption: function scrollToOption(option) {
      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;

      if (this.$refs.popper && target) {
        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
        scrollIntoView(menu, target);
      }
    },
    handleMenuEnter: function handleMenuEnter() {
      var _this6 = this;

      this.$nextTick(function () {
        return _this6.scrollToOption(_this6.selected);
      });
    },
    afterEnter: function afterEnter() {
      var _this7 = this;

      this.$nextTick(function () {
        return _this7.$refs.scrollbar.throttleUpdate();
      });
    },
    getOption: function getOption(value) {
      var option;
      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';

      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
        var cachedOption = this.cachedOptions[i];
        var isEqual = isObject ? getValueByPath(cachedOption.value, this.valueKey) === getValueByPath(value, this.valueKey) : cachedOption.value === value;

        if (isEqual) {
          option = cachedOption;
          break;
        }
      }

      if (option) return option; // 没匹配上就不显示了
      // const label = !isObject ? value : '';

      var label = '';
      var newOption = {
        value: value,
        currentLabel: label
      };

      if (this.multiple) {
        newOption.hitState = false;
      }

      return newOption;
    },
    setSelected: function setSelected() {
      var _this8 = this;

      if (!this.multiple) {
        var option = this.getOption(this.value);

        if (option.created) {
          this.createdLabel = option.currentLabel;
          this.createdSelected = true;
        } else {
          this.createdSelected = false;
        }

        this.selectedLabel = option.currentLabel;
        this.selected = option;
        if (this.filterable) this.query = this.selectedLabel;
        return;
      }

      var result = [];

      if (Array.isArray(this.value)) {
        this.value.forEach(function (value) {
          result.push(_this8.getOption(value));
        });
      }

      this.query = ''; // 再对选中的项进行过滤如果没有label则不显示 xx

      this.selected = result.filter(function (val) {
        return val.currentLabel !== '';
      });

      if (this.selected.length) {
        this.inputClear = true;
      } else {
        this.inputClear = false;
      }

      this.$nextTick(function () {
        _this8.resetInputHeight();
      });
    },
    handleFocus: function handleFocus() {
      if (!this.readonly) {
        this.visible = true;
        this.$emit('focus', event);
      }
    },
    // blur() {
    //   this.visible = false;
    //   this.$refs.reference.blur();
    // },
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
    },
    handleSearchClick: function handleSearchClick(event) {
      event.stopPropagation();
      this.$emit('search', this.value, this.query);
    },
    handleIconClick: function handleIconClick(event) {
      if (this.iconClass.indexOf('h-icon-search') > -1) {
        this.handleSearchClick(event);
      } else if (this.iconClass.indexOf('h-icon-close_f') > -1) {
        // this.deleteSelected(event);
        this.multiple && this.clearable ? this.deleteAllTag() : this.deleteSelected(event);
      } else {
        this.toggleMenu();
      }
    },
    handleMouseDown: function handleMouseDown(event) {
      if (event.target.tagName !== 'INPUT') return;

      if (this.visible) {
        this.handleClose();
        event.preventDefault();
      }
    },
    doDestroy: function doDestroy() {
      this.$refs.popper && this.$refs.popper.doDestroy();
      this.dropdownUl = null;
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
      if (!Array.isArray(this.selected)) return;
      var option = this.selected[this.selected.length - 1];
      if (!option) return;

      if (hit === true || hit === false) {
        option.hitState = hit;
        return hit;
      }

      option.hitState = !option.hitState;
      return option.hitState;
    },
    deletePrevTag: function deletePrevTag(e) {
      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
        var value = this.value.slice();
        value.pop();
        this.$emit('input', value);
      }
    },
    managePlaceholder: function managePlaceholder() {
      if (this.currentPlaceholder !== '') {
        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
      }
    },
    resetInputState: function resetInputState(e) {
      if (e.keyCode !== 8) this.toggleLastOptionHitState(false); // this.inputLength = this.$refs.input.value.length * 15 + 20;
      // this.resetInputHeight();
    },
    resetInputHeight: function resetInputHeight() {
      var _this9 = this;

      if (!this.multiple) return;
      this.$nextTick(function () {
        if (!_this9.$refs.reference) return;
        var inputChildNodes = _this9.$refs.reference.$el.childNodes;
        var input = [].filter.call(inputChildNodes, function (item) {
          return item.tagName === 'INPUT';
        })[0];
        var height = input.style.height;
        input.style.height = Math.max(_this9.$refs.tags.clientHeight, sizeMap[_this9.size] || 32) + 'px';

        if (_this9.isIE && height === input.style.height) {
          // ie下防止闪烁
          return;
        }

        if (_this9.visible && _this9.emptyText !== false) {
          _this9.broadcast('ElSelectDropdown', 'updatePopper');
        }
      });
    },
    resetHoverIndex: function resetHoverIndex() {
      var _this10 = this;

      setTimeout(function () {
        if (!_this10.multiple) {
          _this10.hoverIndex = _this10.options.indexOf(_this10.selected);
        } else {
          if (_this10.selected.length > 0) {
            _this10.hoverIndex = Math.min.apply(null, _this10.selected.map(function (item) {
              return _this10.options.indexOf(item);
            }));
          } else {
            _this10.hoverIndex = -1;
          }
        }
      }, 300);
    },
    handleOptionSelect: function handleOptionSelect(option) {
      var _this11 = this;

      if (this.multiple) {
        var value = this.value.slice();
        var optionIndex = this.getValueIndex(value, option.value);

        if (optionIndex > -1) {
          value.splice(optionIndex, 1);
        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
          value.push(option.value);
        } else {
          return;
        }

        this.$emit('input', value); // if (!this.searchArray.length && !this.reserveKeyword) {
        //   this.query = '';
        // }
        // if (option.created) {
        //   this.query = '';
        // }

        if (this.filterable) {
          this.$refs.input.focus();
        }
      } else {
        this.$emit('input', option.value);
        this.visible = false;
      }

      this.isClick = true;
      this.$nextTick(function () {
        return _this11.scrollToOption(option);
      });
    },
    getValueIndex: function getValueIndex() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var value = arguments.length > 1 ? arguments[1] : undefined;
      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';

      if (!isObject) {
        return arr.indexOf(value);
      } else {
        var valueKey = this.valueKey;
        var index = -1;
        arr.some(function (item, i) {
          if (getValueByPath(item, valueKey) === getValueByPath(value, valueKey)) {
            index = i;
            return true;
          }

          return false;
        });
        return index;
      }
    },
    toggleMenu: function toggleMenu() {
      // if (this.filterable && this.query === '' && this.visible) {
      //   return;
      // }
      if (!this.disabled && !this.readonly) {
        this.visible = !this.visible;
      }
    },
    hiddenMenu: function hiddenMenu() {
      this.visible = false;
    },
    navigateOptions: function navigateOptions(direction) {
      var _this12 = this;

      if (!this.visible) {
        this.visible = true;
        return;
      }

      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
      this.optionsAllDisabled = this.options.length === this.options.filter(function (item) {
        return item.disabled === true;
      }).length;

      if (!this.optionsAllDisabled) {
        if (direction === 'next') {
          this.hoverIndex++;

          if (this.hoverIndex === this.options.length) {
            this.hoverIndex = 0;
          }

          if (this.options[this.hoverIndex].disabled === true || this.options[this.hoverIndex].groupDisabled === true || !this.options[this.hoverIndex].visible) {
            this.navigateOptions('next');
          }
        }

        if (direction === 'prev') {
          this.hoverIndex--;

          if (this.hoverIndex < 0) {
            this.hoverIndex = this.options.length - 1;
          }

          if (this.options[this.hoverIndex].disabled === true || this.options[this.hoverIndex].groupDisabled === true || !this.options[this.hoverIndex].visible) {
            this.navigateOptions('prev');
          }
        }
      }

      this.$nextTick(function () {
        return _this12.scrollToOption(_this12.options[_this12.hoverIndex]);
      });
    },
    selectOption: function selectOption() {
      if (this.options[this.hoverIndex]) {
        this.handleOptionSelect(this.options[this.hoverIndex]);
      }
    },
    deleteSelected: function deleteSelected(event) {
      event.stopPropagation();
      this.$emit('input', '');
      this.visible = false;
      this.$emit('clear');
    },
    deleteAllTag: function deleteAllTag() {
      this.value.splice(0, this.selected.length);
      this.$emit('input', this.value);

      for (var i = 0; i < this.selected.length; i++) {
        this.$emit('remove-tag', this.selected[i]);
      }
    },
    deleteTag: function deleteTag(event, tag) {
      var index = this.selected.indexOf(tag);

      if (index > -1 && !this.disabled) {
        var value = this.value.slice();
        value.splice(index, 1);
        this.$emit('input', value);
        this.$emit('remove-tag', tag);
      }

      event.stopPropagation();
    },
    onInputChange: function onInputChange() {
      if (this.filterable) {
        this.query = this.selectedLabel;
      }
    },
    onOptionDestroy: function onOptionDestroy(option) {
      var index = this.options.indexOf(option);

      if (index > -1) {
        this.optionsCount--;
        this.filteredOptionsCount--;
        this.options.splice(index, 1);
      }

      this.broadcast('ElOption', 'resetIndex');
    },
    resetInputWidth: function resetInputWidth() {
      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
    },
    resetInputWidthMin: function resetInputWidthMin() {
      this.inputWidthMin = this.clearable ? 50 : 32;
    },
    handleResize: function handleResize() {
      this.resetInputWidth();
      this.resetInputWidthMin();
      if (this.multiple) this.resetInputHeight();
    },
    checkDefaultFirstOption: function checkDefaultFirstOption() {
      this.hoverIndex = -1;

      for (var i = 0; i !== this.options.length; ++i) {
        var option = this.options[i];

        if (this.query) {
          // pick first options that passes the filter
          if (!option.disabled && !option.groupDisabled && option.visible) {
            this.hoverIndex = i;
            break;
          }
        } else {
          // pick currently selected option
          if (option.itemSelected) {
            this.hoverIndex = i;
            break;
          }
        }
      }
    },
    getValueKey: function getValueKey(item) {
      var type = _typeof(item.value);

      if (type === 'number' || type === 'string') {
        return item.value;
      } else {
        return getValueByPath(item.value, this.valueKey);
      }
    },
    onScrollingX: function onScrollingX(s) {
      var scrollLeft = s.scrollLeft,
          percentX = s.percentX;
      this.$emit('on-scrolling-x', {
        scrollLeft: scrollLeft,
        percentX: percentX
      });
      this.$emit('on-scrolling', s);
    },
    onScrollingY: function onScrollingY(s) {
      var scrollTop = s.scrollTop,
          percentY = s.percentY;
      this.$emit('on-scrolling-y', {
        scrollTop: scrollTop,
        percentY: percentY
      });
      this.$emit('on-scrolling', s);
    }
  }
});
// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_selectvue_type_script_lang_js_ = (selectvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/select/src/select.vue





/* normalize component */

var select_component = normalizeComponent(
  src_selectvue_type_script_lang_js_,
  selectvue_type_template_id_ab079138_render,
  selectvue_type_template_id_ab079138_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_select = (select_component.exports);
// CONCATENATED MODULE: ./packages/select/index.js


/* istanbul ignore next */

src_select.install = function (Vue) {
  Vue.component(src_select.name, src_select);
};

/* harmony default export */ var packages_select = (src_select);
// CONCATENATED MODULE: ./packages/option/index.js


/* istanbul ignore next */

src_option.install = function (Vue) {
  Vue.component(src_option.name, src_option);
};

/* harmony default export */ var packages_option = (src_option);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=46c87a5e&
var buttonvue_type_template_id_46c87a5e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"el-button",class:[
    _vm.type ? 'el-button--' + _vm.type : '',
    _vm.size ? 'el-button--' + _vm.size : '',
    {
      'is-disabled': _vm.buttonDisabled,
      'is-loading': _vm.loading,
      'is-plain': _vm.plain,
      'is-radius': _vm.radius,
      'is-icon': _vm.icon || _vm.iconBorder,
      'is-icon-border': _vm.iconBorder,
      'is-icon-text': _vm.$slots.default && _vm.icon
    }
  ],style:({
    minWidth: _vm.minWidth && (_vm.minWidth + "px"),
    maxWidth: _vm.maxWidth && (_vm.maxWidth + "px")
  }),attrs:{"disabled":_vm.buttonDisabled || _vm.loading,"autofocus":_vm.autofocus,"type":_vm.nativeType,"title":_vm.labelTitle},on:{"click":_vm.handleClick,"mouseover":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleMouseover($event)}}},[(_vm.loading)?_c('el-load-icon',{staticClass:"h-icon-loading",on:{"click":_vm.handleInnerClick}}):_vm._e(),(_vm.icon && !_vm.loading)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.iconBorder && !_vm.loading)?_c('i',{class:_vm.iconBorder,on:{"click":_vm.handleInnerClick}}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()],1)}
var buttonvue_type_template_id_46c87a5e_staticRenderFns = []


// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=46c87a5e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
  name: 'ElButton',
  props: {
    minWidth: {
      type: Number,
      "default": null
    },
    maxWidth: {
      type: Number,
      "default": null
    },
    type: {
      type: String,
      "default": 'default'
    },
    size: {
      type: String,
      "default": null
    },
    icon: {
      type: String,
      "default": null
    },
    nativeType: {
      type: String,
      "default": 'button'
    },
    loading: {
      type: Boolean,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": null
    },
    iconBorder: {
      type: String,
      "default": null
    },
    plain: {
      type: Boolean,
      "default": null
    },
    autofocus: {
      type: Boolean,
      "default": null
    },
    radius: {
      type: Boolean,
      "default": null
    }
  },
  data: function data() {
    return {
      labelTitle: ''
    };
  },
  computed: {
    buttonDisabled: function buttonDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },
  methods: {
    handleInnerClick: function handleInnerClick(e) {
      if (this.disabled) {
        e.stopPropagation();
      }
    },
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    },
    handleMouseover: function handleMouseover(e) {
      var t = e.target; // 如果设置了默认的title就用默认的

      if (this.$attrs.title) return;
      this.labelTitle = t.scrollWidth > t.offsetWidth ? t.innerText : '';
    }
  }
});
// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/button/src/button.vue





/* normalize component */

var button_component = normalizeComponent(
  src_buttonvue_type_script_lang_js_,
  buttonvue_type_template_id_46c87a5e_render,
  buttonvue_type_template_id_46c87a5e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_button = (button_component.exports);
// CONCATENATED MODULE: ./packages/button/index.js


/* istanbul ignore next */

src_button.install = function (Vue) {
  Vue.component(src_button.name, src_button);
};

/* harmony default export */ var packages_button = (src_button);
// CONCATENATED MODULE: ./packages/pagination/src/pagination.js






















/* harmony default export */ var pagination = ({
  name: 'ElPagination',
  props: {
    pageSize: {
      type: Number,
      "default": 10
    },
    small: Boolean,
    extraSmall: Boolean,
    total: Number,
    pageCount: Number,
    pagerCount: {
      type: Number,
      validator: function validator(value) {
        return (value | 0) === value && value > 4 && value < 22 && value % 2 === 1;
      },
      "default": 7
    },
    currentPage: {
      type: Number,
      "default": 1
    },
    layout: {
      "default": 'prev, pager, next, jumper, ->, total'
    },
    pageSizes: {
      type: Array,
      "default": function _default() {
        return [10, 20, 30, 40, 50, 100];
      }
    },

    /**
     * 每页显示条目个数变化发请求前的钩子
     * add by yangzhini 2018-06-29
     * @param {Number} val    改变后的值
     * @param {Number} oldVal 改变前的值
     * @return {Boolean} 是否继续发请求
     * @example (val, oldVal) => true
     */
    beforeSizeChange: {
      type: Function,
      "default": function _default() {
        return true;
      }
    },

    /**
     * 分页跳转发请求前的钩子
     * add by yangzhini 2018-06-29
     * @param {Number} val    改变后的值
     * @param {Number} oldVal 改变前的值
     * @return {Boolean} 是否继续发请求
     * @example (val, oldVal) => true
     */
    beforeCurrentChange: {
      type: Function,
      "default": function _default() {
        return true;
      }
    },

    /**
     * 设置禁用
     * add by yangzhini 2018-09-06
     */
    disabled: {
      type: Boolean,
      "default": false
    },
    prevText: {
      type: String,
      "default": ''
    },
    nextText: {
      type: String,
      "default": ''
    },

    /**
     * 每页显示条数下拉框的类名
     * add by chenguanbin 2019-05-29
     */
    sizesPopperClass: {
      type: String,
      "default": ''
    }
  },
  data: function data() {
    return {
      internalCurrentPage: 1,
      internalPageSize: 0,
      popperClass: this.sizesPopperClass
    };
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var template = h("div", {
      "class": 'el-pagination'
    });
    var templateInner = h("div", {
      "class": 'el-pagination-wrapper'
    });
    var layout = this.layout || '';
    if (!layout) return;
    var TEMPLATE_MAP = {
      prev: h("prev"),
      jumper: h("jumper"),
      pager: h("pager", {
        "attrs": {
          "currentPage": this.internalCurrentPage,
          "pageCount": this.internalPageCount,
          "disabled": this.disabled,
          "pagerCount": this.pagerCount
        },
        "on": {
          "change": this.handleCurrentChange
        }
      }),
      // 增加HUI的表格分页组件类型 add by zhangxiaogang 2017-09-27
      huiPager: h("huiPager", {
        "attrs": {
          "currentPage": this.internalCurrentPage,
          "pageCount": this.internalPageCount
        },
        "on": {
          "goto": this.handleCurrentChange
        }
      }),
      miniPager: h("miniPager"),
      next: h("next"),
      first: h("first"),
      last: h("last"),
      sizes: h("sizes", {
        "attrs": {
          "pageSizes": this.pageSizes
        }
      }),
      slot: h("my-slot"),
      total: h("total")
    };
    var components = layout.split(',').map(function (item) {
      return item.trim();
    });
    var rightWrapper = h("div", {
      "class": 'el-pagination__rightwrapper'
    });
    var haveRightWrapper = false;

    if (this.small) {
      template.data["class"] += ' el-pagination--small';
    }

    var tableRightPageWrapper = null; // 如果是表格场景的分页，外层容器追加自定义class以便样式覆盖

    if (this.isForTable) {
      template.data["class"] += ' el-pagination--table';
      tableRightPageWrapper = h("div", {
        "class": 'el-pagination__tableRightPageWrapper'
      });
      tableRightPageWrapper.children = tableRightPageWrapper.children || [];
    }

    var insertTarget = this.isForTable ? templateInner : template; // https://github.com/vuejs/babel-plugin-transform-vue-jsx/issues/123

    insertTarget.children = insertTarget.children || [];
    template.children = template.children || [];
    rightWrapper.children = rightWrapper.children || [];
    components.forEach(function (compo) {
      if (compo === '->') {
        haveRightWrapper = true;
      } else {
        if (_this.isForTable && ['jumper', 'huiPager', 'prev', 'pager', 'next'].indexOf(compo) > -1) {
          tableRightPageWrapper.children.push(TEMPLATE_MAP[compo]);
        } else if (!haveRightWrapper) {
          insertTarget.children.push(TEMPLATE_MAP[compo]);
        } else {
          rightWrapper.children.push(TEMPLATE_MAP[compo]);
        }
      }
    });

    if (haveRightWrapper) {
      insertTarget.children.unshift(rightWrapper);
    }

    if (this.isForTable) {
      insertTarget.children.push(tableRightPageWrapper);
      template.children.push(insertTarget);
    }

    return template;
  },
  components: {
    MySlot: {
      render: function render() {
        return this.$parent.$slots["default"] ? this.$parent.$slots["default"][0] : '';
      }
    },
    // 跳转到第一页
    First: {
      render: function render() {
        var h = arguments[0];
        return h("button", {
          "attrs": {
            "type": 'button'
          },
          "class": ['btn-first', {
            disabled: this.$parent.disabled || this.$parent.internalCurrentPage <= 1
          }],
          "on": {
            "click": this.$parent.first
          }
        }, [h("i", {
          "class": 'el-icon h-icon-angle_line_left'
        })]);
      }
    },
    // 跳转到最后一页
    Last: {
      render: function render() {
        var h = arguments[0];
        return h("button", {
          "attrs": {
            "type": 'button'
          },
          "class": ['btn-last', {
            disabled: this.$parent.disabled || this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0
          }],
          "on": {
            "click": this.$parent.last
          }
        }, [h("i", {
          "class": 'el-icon h-icon-angle_line_right'
        })]);
      }
    },
    Prev: {
      render: function render() {
        var h = arguments[0];
        return h("button", {
          "attrs": {
            "type": 'button'
          },
          "class": ['btn-prev', {
            disabled: this.$parent.disabled || this.$parent.internalCurrentPage <= 1
          }],
          "on": {
            "click": this.$parent.prev
          }
        }, [this.$parent.prevText ? h("span", [this.$parent.prevText]) : h("i", {
          "class": 'el-icon h-icon-angle_left'
        })]);
      }
    },
    Next: {
      render: function render() {
        var h = arguments[0];
        return h("button", {
          "attrs": {
            "type": 'button'
          },
          "class": ['btn-next', {
            disabled: this.$parent.disabled || this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0
          }],
          "on": {
            "click": this.$parent.next
          }
        }, [this.$parent.nextText ? h("span", [this.$parent.nextText]) : h("i", {
          "class": 'el-icon h-icon-angle_right'
        })]);
      }
    },
    Sizes: {
      mixins: [locale],
      props: {
        pageSizes: Array
      },
      watch: {
        pageSizes: {
          immediate: true,
          handler: function handler(value) {
            if (Array.isArray(value)) {
              this.$parent.internalPageSize = value.indexOf(this.$parent.pageSize) > -1 ? this.$parent.pageSize : this.pageSizes[0];
            }
          }
        }
      },
      render: function render() {
        var _this2 = this;

        var h = arguments[0];
        var popperClass = "el-pagination__paged-select ".concat(this.$parent.popperClass);
        return h("span", {
          "class": 'el-pagination__sizes'
        }, [h("el-select", {
          "attrs": {
            "popper-class": popperClass,
            "value": this.$parent.internalPageSize,
            "disabled": this.$parent.disabled
          },
          "on": {
            "input": this.handleChange
          }
        }, [this.pageSizes.map(function (item) {
          return h("el-option", {
            "attrs": {
              "value": item,
              "label": item + ' ' + _this2.t('el.pagination.pagesize')
            }
          });
        })])]);
      },
      components: {
        ElSelect: packages_select,
        ElOption: packages_option
      },
      methods: {
        handleChange: function handleChange(val) {
          var _this3 = this;

          if (val !== this.$parent.internalPageSize) {
            var oldPageSize = this.$parent.internalPageSize;
            Promise.resolve(this.$parent.beforeSizeChange(val, oldPageSize)).then(function (allowed) {
              if (allowed) {
                _this3.$parent.internalPageSize = val = parseInt(val, 10);
              }
            });
          }
        }
      }
    },
    Jumper: {
      mixins: [locale],
      components: {
        ElInput: packages_input
      },
      data: function data() {
        return {
          oldValue: null,
          newValue: this.$parent.currentPage || 1
        };
      },
      watch: {
        '$parent.internalCurrentPage': function $parentInternalCurrentPage(v) {
          if (v) {
            this.newValue = v;
          }
        }
      },
      methods: {
        handleFocus: function handleFocus(event) {
          this.oldValue = +event.target.value;
        },
        handleBlur: function handleBlur(_ref) {
          var _this4 = this;

          var target = _ref.target;

          if (!target.value) {
            this.newValue = this.oldValue;
            target.value = this.oldValue;
          }

          this.reassignMaxValue(target); // 触发before-current-change  yangzhini  2018-12-10

          if (this.newValue !== this.$parent.internalCurrentPage) {
            this.$parent.currentChangeValid(this.newValue).then(function (allowed) {
              if (!allowed) {
                _this4.newValue = _this4.$parent.internalCurrentPage;
              }
            });
          }

          this.oldValue = null;
        },
        handleKeyUp: function handleKeyUp(event) {
          if (event.target.value === '') return;
          var val = +event.target.value; // 通过拖拽输入字符, 会出现'01'的情况

          event.target.value = val; // if (event.keyCode === 8 && !val) return;

          var key = event.key || '';
          var keyCode = event.keyCode || '';
          var isEnter = key && key === 'Enter' || keyCode && keyCode === 13;

          if (val && !isEnter) {
            if (val > this.$parent.internalPageCount) {
              this.newValue = this.$parent.internalPageCount || 1;
            } else {
              this.newValue = val;
            }

            event.target.value = this.newValue;
            this.oldValue = this.newValue;
          } else if (!isEnter) {
            this.newValue = this.oldValue;
            event.target.value = this.oldValue;
          }

          if (isEnter) {
            this.reassignMaxValue(event.target);
            this["goto"]();
          }
        },
        reassignMaxValue: function reassignMaxValue(target) {
          if (+target.value > this.$parent.internalPageCount) {
            target.value = this.$parent.internalPageCount; // 页码始终应大于0  zhangxiaogang  2017-12-21

            if (this.$parent.internalPageCount === 0) target.value = 1;
          }
        },
        "goto": function goto() {
          var temp = this.$parent.internalCurrentPage;
          this.handleBlur({
            target: {
              value: temp
            }
          });
        },
        handleInput: function handleInput(event) {
          event.target.value = event.target.value.replace(/[^\d]/g, '');
        }
      },

      /**
       * 增加了HUI表格分页控件的相关按钮
       * modify by zhangxiaogang 2017-09-27
       */
      render: function render() {
        var _this5 = this;

        var h = arguments[0];
        return h("span", {
          "class": 'el-pagination__jump'
        }, [!this.$parent.isForTable && this.t('el.pagination.goto'), h("el-input", {
          "class": 'el-pagination__editor',
          "attrs": {
            "min": 1,
            "disabled": this.$parent.disabled
          },
          "on": {
            "focus": this.handleFocus,
            "blur": this.handleBlur
          },
          "nativeOn": {
            "keyup": this.handleKeyUp,
            "input": this.handleInput
          },
          "model": {
            value: _this5.newValue,
            callback: function callback($$v) {
              _this5.newValue = $$v;
            }
          }
        }), this.$parent.isForTable && h("span", ["/\xA0", this.$parent.internalPageCount || 1, this.t('el.pagination.pageClassifier')]), !this.$parent.isForTable && this.t('el.pagination.pageClassifier'), this.$parent.isForTable && h("el-button", {
          "on": {
            "click": this["goto"]
          }
        }, [this.t('el.pagination.gotoBtn')])]);
      }
    },
    Total: {
      mixins: [locale],
      render: function render() {
        var h = arguments[0];
        return typeof this.$parent.total === 'number' ? h("span", {
          "class": 'el-pagination__total'
        }, [this.t('el.pagination.total', {
          total: this.$parent.total
        })]) : '';
      }
    },
    miniPager: {
      render: function render() {
        var h = arguments[0];
        return h("div", {
          "class": 'el-pagination__mini-pager'
        }, [h("div", {
          "class": 'el-pagination__mini-pager-num'
        }, [this.$parent.internalCurrentPage]), h("div", {
          "class": 'el-pagination__mini-pager-slash'
        }, [" / "]), h("div", {
          "class": 'el-pagination__mini-pager-max-num'
        }, [this.$parent.internalPageCount])]);
      }
    },

    /**
     * 增加HUI的表格分页组件
     * add by zhangxiaogang 2017-09-27
     */
    HuiPager: {
      mixins: [locale],
      render: function render() {
        var h = arguments[0];
        var vm = this;
        return this.pageCount > 1 ? h("ul", {
          "class": 'el-pagination__pager'
        }, [h("li", {
          "class": [this.preDisabled ? 'is-disabled' : '', 'h-icon-angle_line_left'],
          "on": {
            "click": function click() {
              vm.go('first');
            }
          }
        }), h("li", {
          "class": [this.preDisabled ? 'is-disabled' : '', 'h-icon-angle_left'],
          "on": {
            "click": function click() {
              vm.go(-1);
            }
          }
        }), h("li", {
          "class": [this.nexDisabled ? 'is-disabled' : '', 'h-icon-angle_right'],
          "on": {
            "click": function click() {
              vm.go(1);
            }
          }
        }), h("li", {
          "class": [this.nexDisabled ? 'is-disabled' : '', 'h-icon-angle_line_right'],
          "on": {
            "click": function click() {
              vm.go('last');
            }
          }
        })]) : '';
      },
      methods: {
        go: function go(val) {
          var _this6 = this;

          if (this.$parent.disabled) return; // 如果进行暴力测试极快速点击翻页可能会导致IE下input输入框中的数字持续变化，哪怕是松开了鼠标

          throttle_default()(100, function () {
            var currentPage = _this6.currentPage,
                pageCount = _this6.pageCount;

            if (currentPage === 1 && val === -1 || currentPage === pageCount && val === 1) {
              return;
            } // this.$parent.internalCurrentPage = val;


            var postVal = null;
            if (val === 'first') postVal = 1;else if (val === 'last') postVal = pageCount;else postVal = currentPage + val; // this.$parent.internalCurrentPage = postVal;

            _this6.$parent.currentChangeValid(postVal);
          })();
        }
      },
      computed: {
        preDisabled: function preDisabled() {
          return this.$parent.disabled || this.currentPage === 1;
        },
        nexDisabled: function nexDisabled() {
          return this.$parent.disabled || this.currentPage === this.pageCount;
        }
      },
      props: {
        currentPage: Number,
        pageCount: Number
      }
    },
    Pager: pager,
    ElButton: packages_button
  },
  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentChangeValid(val);
    },
    first: function first() {
      if (this.disabled) return;
      this.currentChangeValid(1);
    },
    last: function last() {
      if (this.disabled) return;
      this.currentChangeValid(this.internalPageCount);
    },
    prev: function prev() {
      if (this.disabled) return;
      var newVal = this.internalCurrentPage - 1;
      this.currentChangeValid(newVal);
    },
    next: function next() {
      if (this.disabled) return;
      var newVal = this.internalCurrentPage + 1;
      this.currentChangeValid(newVal);
    },
    currentChangeValid: function currentChangeValid(val) {
      var _this7 = this;

      return Promise.resolve(this.beforeCurrentChange(val, this.internalCurrentPage)).then(function (allowed) {
        if (allowed) {
          _this7.internalCurrentPage = _this7.getValidCurrentPage(val);
        }

        return allowed;
      });
    },
    getValidCurrentPage: function getValidCurrentPage(value) {
      value = parseInt(value, 10);
      var havePageCount = typeof this.internalPageCount === 'number';
      var resetValue;

      if (!havePageCount) {
        if (isNaN(value) || value < 1) resetValue = 1;
      } else {
        if (value < 1) {
          resetValue = 1;
        } else if (value > this.internalPageCount) {
          resetValue = this.internalPageCount;
        }
      }

      if (resetValue === undefined && isNaN(value)) {
        resetValue = 1;
      } else if (resetValue === 0) {
        resetValue = 1;
      }

      return resetValue === undefined ? value : resetValue;
    }
  },
  computed: {
    internalPageCount: function internalPageCount() {
      if (typeof this.total === 'number') {
        return Math.max(1, Math.ceil(this.total / this.internalPageSize));
      } else if (typeof this.pageCount === 'number') {
        return Math.max(1, this.pageCount);
      }

      return null;
    },
    // 标记是否是表格场景中的分页,以v1.2.0为界分前后两个版本
    isForTable: function isForTable() {
      var layoutNewTable = ['total', 'sizes', 'prev', 'pager', 'next', 'jumper'].join();
      var layout = this.layout.split(',').map(function (l) {
        return l.trim();
      });
      return layout.join() === layoutNewTable || this.layout.indexOf('huiPager') !== -1;
    }
  },
  watch: {
    currentPage: {
      immediate: true,
      handler: function handler(val) {
        this.internalCurrentPage = val;
      }
    },
    pageSize: {
      immediate: true,
      handler: function handler(val) {
        this.internalPageSize = val;
      }
    },
    internalPageSize: function internalPageSize(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.$emit('size-change', newVal, oldVal);
      }
    },
    internalCurrentPage: function internalCurrentPage(newVal, oldVal) {
      var _this8 = this;

      newVal = parseInt(newVal, 10);
      /* istanbul ignore if */

      if (isNaN(newVal)) {
        newVal = oldVal || 1;
      } else {
        newVal = this.getValidCurrentPage(newVal);
      }

      if (newVal !== undefined) {
        this.$nextTick(function () {
          _this8.internalCurrentPage = newVal;

          if (oldVal !== newVal) {
            _this8.$emit('update:currentPage', newVal);

            _this8.$emit('current-change', _this8.internalCurrentPage, oldVal);
          }
        });
      } else {
        this.$emit('update:currentPage', newVal);
        this.$emit('current-change', this.internalCurrentPage, oldVal);
      }
    },
    internalPageCount: function internalPageCount(newVal) {
      /* istanbul ignore if */
      var oldPage = this.internalCurrentPage;

      if (newVal > 0 && oldPage === 0) {
        this.internalCurrentPage = 1;
      } else if (oldPage > newVal) {
        this.internalCurrentPage = newVal === 0 ? 1 : newVal;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/pagination/index.js


/* istanbul ignore next */

pagination.install = function (Vue) {
  Vue.component(pagination.name, pagination);
};

/* harmony default export */ var packages_pagination = (pagination);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=template&id=c6a43fa2&
var componentvue_type_template_id_c6a43fa2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"dialog-fade"},on:{"after-enter":_vm.afterEnter,"after-leave":_vm.afterLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-dialog__wrapper",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleWrapperClick($event)}}},[_c('div',{ref:"dialog",staticClass:"el-dialog",class:[_vm.sizeClass, _vm.customClass],style:(_vm.style)},[_c('div',{staticClass:"el-dialog__header"},[_vm._t("title",[_c('span',{staticClass:"el-dialog__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),(_vm.showClose)?_c('button',{staticClass:"el-dialog__headerbtn",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.handleClose}},[_c('i',{staticClass:"el-dialog__close el-icon h-icon-close"})]):_vm._e()],2),(_vm.rendered)?_c('div',{staticClass:"el-dialog__body"},[(_vm.areaIsArray && !_vm.noScrollbar)?_c('el-scrollbar',{ref:"scrollbar",attrs:{"wrap-class":"el-dialog-scrollbar__wrap"}},[_c('div',{staticClass:"el-dialog__body-wrapper"},[_vm._t("default")],2)]):_c('div',{staticClass:"el-dialog__body-wrapper"},[_vm._t("default")],2)],1):_vm._e(),(_vm.$slots.footer)?_c('div',{staticClass:"el-dialog__footer"},[_vm._t("footer")],2):_vm._e()])])])}
var componentvue_type_template_id_c6a43fa2_staticRenderFns = []


// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=template&id=c6a43fa2&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var componentvue_type_script_lang_js_ = ({
  name: 'ElDialog',
  components: {
    ElScrollbar: scrollbar
  },
  mixins: [popup, emitter],
  props: {
    title: {
      type: String,
      "default": ''
    },
    modal: {
      type: Boolean,
      "default": true
    },
    modalAppendToBody: {
      type: Boolean,
      "default": true
    },

    /**
     * 弹窗嵌套时需传入参数
     * add by yinzhixing  2018-03-09
     */
    appendToBody: {
      type: Boolean,
      "default": true
    },
    closeOnClickModal: {
      type: Boolean,
      "default": false
    },
    closeOnPressEscape: {
      type: Boolean,
      "default": false
    },
    showClose: {
      type: Boolean,
      "default": true
    },
    size: {
      type: String,
      "default": 'small'
    },
    customClass: {
      type: String,
      "default": ''
    },
    top: {
      type: String,
      "default": '15%'
    },

    /**
     * 传入数组则表示指定宽高，传入一个数值则表示只指定宽度,
     * 且传入了该参数则自动忽略size
     * add by zhangxiaogang  2017-09-28
     */
    area: {
      type: [Array, Number],
      "default": null
    },
    noScrollbar: {
      type: Boolean,
      "default": false
    },
    beforeClose: {
      type: Function,
      "default": null
    }
  },
  data: function data() {
    return {
      closed: false
    };
  },
  computed: {
    sizeClass: function sizeClass() {
      return this.area ? '' : "el-dialog--".concat(this.size);
    },
    areaIsArray: function areaIsArray() {
      return Array.isArray(this.area);
    },
    style: function style() {
      var area = this.area,
          areaIsArray = this.areaIsArray;
      var top = this.top;
      var styleArr = [];

      if (top === 'middle') {
        top = '50%';
      }

      styleArr.push(this.size === 'full' ? '' : "top: ".concat(top));

      if (areaIsArray) {
        if (area.length === 2) {
          styleArr.push("width: ".concat(area[0], "px;height: ").concat(area[1], "px;"));
          styleArr.push("margin-left: ".concat(-area[0] / 2, "px"));
        } else {
          throw new Error('The area parameter passed to the dialog component must be 2! If it is an array.');
        }
      } else if (area) {
        styleArr.push("width: ".concat(area, "px"));
        styleArr.push("margin-left: ".concat(-area / 2, "px"));
      } else {
        switch (this.size) {
          case 'tiny':
            styleArr.push('margin-left: -15%');
            break;

          case 'small':
            styleArr.push('margin-left: -25%');
            break;

          case 'large':
            styleArr.push('margin-left: -45%');
            break;

          case 'full':
            styleArr.push('margin-left: -50%');
            break;
        }
      }

      return styleArr.join(';');
    }
  },
  watch: {
    visible: function visible(val) {
      var _this = this;

      this.$emit('update:visible', val);

      if (val) {
        this.closed = false;
        this.$emit('open');
        this.$el.addEventListener('scroll', this.updatePopper);
        window.addEventListener('resize', this.setStyle);
        this.$nextTick(function () {
          // 替换之前hui的打开dialog调整scrollTop的方法，调整为修改自定义滚动条 xx
          if (_this.$refs.scrollbar) _this.$refs.scrollbar.setScroll(0, 0); // this.$refs.dialog.scrollTop = 0;

          _this.setStyle();
        });

        if (this.appendToBody) {
          document.body.appendChild(this.$el);
        }
      } else {
        this.$el.removeEventListener('scroll', this.updatePopper);
        window.removeEventListener('resize', this.setStyle);
        if (!this.closed) this.$emit('close');
      }
    }
  },
  mounted: function mounted() {
    if (this.visible) {
      this.rendered = true;
      this.open();

      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  },
  destroyed: function destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    afterLeave: function afterLeave() {
      this.$emit('closed');
    },
    afterEnter: function afterEnter() {
      this.$emit('opened');
    },
    handleWrapperClick: function handleWrapperClick() {
      if (!this.closeOnClickModal) return;
      this.handleClose();
    },
    handleClose: function handleClose() {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide);
      } else {
        this.hide();
      }
    },
    hide: function hide(cancel) {
      if (cancel !== false) {
        this.$emit('update:visible', false);
        this.$emit('visible-change', false);
        this.$emit('close');
        this.closed = true;
      }
    },
    updatePopper: function updatePopper() {
      this.broadcast('ElSelectDropdown', 'updatePopper');
      this.broadcast('ElDropdownMenu', 'updatePopper');
    },
    setStyle: function setStyle() {
      var elDialog = this.$el.querySelector('.el-dialog');
      var h = Number(window.getComputedStyle(elDialog).getPropertyValue('height').replace('px', ''));
      var hw = Number(window.getComputedStyle(this.$el).getPropertyValue('height').replace('px', ''));

      if (h) {
        if (this.top === 'middle') {
          if (hw < h) {
            // 56px 由 dialog.scss margin-bottom 得到
            elDialog.style.marginTop = "".concat(-h / 2 + (h - hw) / 2 + 56, "px");
          } else {
            elDialog.style.marginTop = "".concat(-h / 2, "px");
          }
        }

        if (this.areaIsArray) {
          // 设置内容区高度
          var dialogBody = this.$el.querySelector('.el-dialog__body');
          var dialogFooterLength = 56;

          if (!this.$el.querySelector('.el-dialog__footer')) {
            dialogFooterLength = 0;
          }

          dialogBody.style.cssText = "height: ".concat(h - 36 - dialogFooterLength, "px;box-sizing: border-box");
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_componentvue_type_script_lang_js_ = (componentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/dialog/src/component.vue





/* normalize component */

var component_component = normalizeComponent(
  src_componentvue_type_script_lang_js_,
  componentvue_type_template_id_c6a43fa2_render,
  componentvue_type_template_id_c6a43fa2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_component = (component_component.exports);
// CONCATENATED MODULE: ./packages/dialog/index.js


/* istanbul ignore next */

src_component.install = function (Vue) {
  Vue.component(src_component.name, src_component);
};

/* harmony default export */ var dialog = (src_component);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=3230463c&
var autocompletevue_type_template_id_3230463c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.close),expression:"close"}],staticClass:"el-autocomplete",class:[_vm.kind ? 'el-input--' + _vm.kind : '']},[_c('el-input',_vm._b({ref:"input",attrs:{"clearable":_vm.clearable,"maxlength":_vm.maxlength,"minlength":_vm.minlength,"tips":_vm.tips,"tips-max-width":_vm.tipsMaxWidth,"tips-placement":_vm.tipsPlacement,"tips-offset":_vm.tipsOffset,"tips-trigger":_vm.tipsTrigger,"tips-class":_vm.tipsClass},on:{"clear":_vm.clearValue,"change":_vm.handleChange,"focus":_vm.handleFocus,"blur":_vm.handleBlur},nativeOn:{"compositionstart":function($event){return _vm.handleComposition($event)},"compositionupdate":function($event){return _vm.handleComposition($event)},"compositionend":function($event){return _vm.handleComposition($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.highlight(_vm.highlightedIndex - 1)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.highlight(_vm.highlightedIndex + 1)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleKeyEnter($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.close($event)}]}},'el-input',_vm.$props,false),[(_vm.$slots.prefix)?_c('template',{slot:"prefix"},[_vm._t("prefix")],2):_vm._e(),(_vm.$slots.suffix)?_c('template',{slot:"suffix"},[_vm._t("suffix")],2):_vm._e(),(_vm.$slots.prepend)?_c('template',{slot:"prepend"},[_vm._t("prepend")],2):_vm._e(),(_vm.$slots.append)?_c('template',{slot:"append"},[_vm._t("append")],2):_vm._e()],2),_c('el-autocomplete-suggestions',{ref:"suggestions",class:[_vm.popperClass ? _vm.popperClass : ''],attrs:{"props":_vm.props,"suggestions":_vm.suggestions,"loading":_vm.loading,"append-to-body":_vm.popperAppendToBody,"placement":"bottom-start"}},[(_vm.$slots.content)?_c('template',{slot:"content"},[_vm._t("content")],2):_vm._e(),(_vm.$slots.bottom)?_c('template',{slot:"bottom"},[_vm._t("bottom")],2):_vm._e()],2)],1)}
var autocompletevue_type_template_id_3230463c_staticRenderFns = []


// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=3230463c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=dee52044&
var autocomplete_suggestionsvue_type_template_id_dee52044_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"after-enter":_vm.afterEnter,"after-leave":_vm.doDestroy}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"el-autocomplete-suggestion",class:{ 'is-loading': _vm.parent.loading },style:({ width: _vm.dropdownWidth })},[_c('el-scrollbar',{ref:"scrollbar",attrs:{"is-small":true,"tag":"ul","wrap-class":"el-autocomplete-suggestion__wrap","view-class":"el-autocomplete-suggestion__list"}},[(_vm.$slots.content)?[_vm._t("content")]:_vm._e(),(_vm.parent.loading)?_c('li',{staticClass:"el-autocomplete__nodata"},[_c('el-load-icon')],1):_vm._e(),(_vm.showNoMatch)?_c('div',{class:{ 'el-autocomplete__nodata': _vm.showNoMatch }},[_vm._v(" "+_vm._s(_vm.noMatch)+" ")]):_vm._e(),(!_vm.parent.loading && !_vm.$slots.content)?_c('div',[_vm._l((_vm.suggestions),function(item,index){return [(!_vm.parent.customItem)?_c('li',{key:index,staticClass:"el-autocomplete-suggestion__item",class:{ highlighted: _vm.itemSelected(item) },on:{"click":function($event){return _vm.select(item)}}},[_vm._v(" "+_vm._s(item[_vm.props.value] || item)+" ")]):_c(_vm.parent.customItem,{key:index,tag:"component",staticClass:"el-autocomplete-suggestion__item",attrs:{"select":_vm.select,"item":item,"index":index},on:{"click":function($event){return _vm.select(item)}}})]})],2):_vm._e()],2),(_vm.$slots.bottom)?[_vm._t("bottom")]:_vm._e()],2)])}
var autocomplete_suggestionsvue_type_template_id_dee52044_staticRenderFns = []


// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=dee52044&

// EXTERNAL MODULE: ./node_modules/timers-browserify/main.js
var timers_browserify_main = __webpack_require__("5118");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var autocomplete_suggestionsvue_type_script_lang_js_ = ({
  components: {
    ElScrollbar: scrollbar
  },
  mixins: [vue_popper, emitter],
  componentName: 'ElAutocompleteSuggestions',
  props: {
    props: {
      type: Object,
      "default": function _default() {
        return {
          label: 'value',
          value: 'value'
        };
      }
    },
    suggestions: {
      type: Array,
      "default": null
    }
  },
  data: function data() {
    return {
      parent: this.$parent,
      dropdownWidth: '',
      noMatch: Object(locale_["t"])('el.cascader.noMatch'),
      showNoMatch: false
    };
  },
  watch: {
    suggestions: function suggestions(newValue, oldValue) {
      var _this = this;

      // 来延缓空文字提示的时间
      if (newValue.length) {
        this.showNoMatch = false;
      } else {
        if (this.parent.suggestionVisible) {
          Object(timers_browserify_main["setTimeout"])(function () {
            _this.showNoMatch = true;
          }, 100);
        }
      }
    }
  },
  mounted: function mounted() {
    this.$parent.popperElm = this.popperElm = this.$el;
    this.referenceElm = this.$parent.$refs.input.$refs.input;
  },
  created: function created() {
    var _this2 = this;

    this.$on('visible', function (val, inputWidth) {
      _this2.dropdownWidth = inputWidth + 'px';
      _this2.showPopper = val;
    });
  },
  methods: {
    isEqual: function isEqual(a, b) {
      if (!this.isObject) {
        return a === b;
      } else {
        var valueKey = this.parent.valueKey;
        return getValueByPath(a, valueKey) === getValueByPath(b, valueKey);
      }
    },
    itemSelected: function itemSelected(value) {
      return this.isEqual(value, this.parent.lastValue);
    },
    select: function select(item) {
      this.dispatch('ElAutocomplete', 'item-click', item);
    },
    afterEnter: function afterEnter() {
      var _this3 = this;

      this.$nextTick(function () {
        return _this3.$refs.scrollbar.throttleUpdate();
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_autocomplete_suggestionsvue_type_script_lang_js_ = (autocomplete_suggestionsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue





/* normalize component */

var autocomplete_suggestions_component = normalizeComponent(
  src_autocomplete_suggestionsvue_type_script_lang_js_,
  autocomplete_suggestionsvue_type_template_id_dee52044_render,
  autocomplete_suggestionsvue_type_template_id_dee52044_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var autocomplete_suggestions = (autocomplete_suggestions_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var autocompletevue_type_script_lang_js_ = ({
  name: 'ElAutocomplete',
  components: {
    ElInput: packages_input,
    ElAutocompleteSuggestions: autocomplete_suggestions
  },
  directives: {
    Clickoutside: clickoutside
  },
  mixins: [emitter],
  componentName: 'ElAutocomplete',
  props: {
    props: {
      type: Object,
      "default": function _default() {
        return {
          value: 'value',
          label: 'value'
        };
      }
    },
    popperClass: {
      type: String,
      "default": ''
    },
    placeholder: {
      type: String,
      "default": ''
    },
    clearable: {
      type: String,
      "default": ''
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    name: {
      type: String,
      "default": ''
    },
    kind: {
      type: String,
      "default": ''
    },
    clearIconClick: {
      type: Function,
      "default": null
    },
    size: {
      type: String,
      "default": ''
    },
    value: {
      type: String,
      "default": ''
    },
    autofocus: {
      type: Boolean,
      "default": false
    },
    fetchSuggestions: {
      type: Function,
      "default": null
    },
    triggerOnFocus: {
      type: Boolean,
      "default": true
    },
    customItem: {
      type: String,
      "default": ''
    },
    icon: {
      type: String,
      "default": ''
    },
    onIconClick: {
      type: Function,
      "default": null
    },
    debounce: {
      type: Number,
      "default": 300
    },
    maxlength: {
      type: Number,
      "default": null
    },
    minlength: {
      type: Number,
      "default": null
    },
    // 提示信息，设置了tips才能显示popover
    tips: {
      type: String,
      "default": null
    },
    // popover的最大宽度
    tipsMaxWidth: {
      type: null,
      "default": null
    },
    // popover出现的位置
    tipsPlacement: {
      type: String,
      "default": 'top-start'
    },
    // 出现位置的偏移量
    tipsOffset: {
      type: Number,
      "default": 0
    },
    // popover触发方式
    tipsTrigger: {
      type: String,
      "default": 'focus'
    },
    // popover触发方式
    tipsClass: {
      type: String,
      "default": ''
    },
    popperAppendToBody: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      activated: false,
      isOnComposition: false,
      suggestions: [],
      lastValue: {
        type: String,
        "default": ''
      },
      loading: false,
      highlightedIndex: -1,
      ie: false // 判断是否是ie

    };
  },
  computed: {
    suggestionVisible: function suggestionVisible() {
      var suggestions = this.suggestions;
      var isValidData = Array.isArray(suggestions); // 非激活情况下且suggestions为空数组时不显示建议

      var noSuggestion = !this.value.length && !this.suggestions.length && !this.triggerOnFocus;
      return !noSuggestion && isValidData && this.activated;
    }
  },
  watch: {
    suggestionVisible: function suggestionVisible(val) {
      if (val) {
        this.$refs.suggestions.showNoMatch = false;
      }

      this.$emit('visible', this.suggestionVisible);
      this.broadcast('ElAutocompleteSuggestions', 'visible', [val, this.$refs.input.$refs.input.offsetWidth]);
    }
  },
  mounted: function mounted() {
    var _this = this;

    // ie兼容
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      this.ie = true;
    }

    this.debouncedGetData = debounce_default()(this.debounce, function (val) {
      if (_this.isOnComposition || !_this.triggerOnFocus && !val) {
        return;
      }

      _this.getData(val);
    });
    this.$on('item-click', function (item) {
      _this.select(item);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.suggestions.$destroy();
  },
  methods: {
    clearValue: function clearValue() {
      if (!this.disabled) {
        // if (this.clearIconClick) {
        //   this.clearIconClick(event);
        // }
        this.$emit('input', '');
        this.activated = false;
        this.suggestions = [];
      }
    },
    getData: function getData(queryString) {
      var _this2 = this;

      this.loading = true;
      this.fetchSuggestions(queryString, function (suggestions) {
        if (Array.isArray(suggestions)) {
          _this2.suggestions = suggestions;
        } else {
          console.error('autocomplete suggestions must be an array');
        }

        _this2.loading = false;
      });
    },
    handleComposition: function handleComposition(event) {
      if (event.type === 'compositionend') {
        this.isOnComposition = false;
        this.handleChange(event.target.value);
      } else {
        this.isOnComposition = true;
      }
    },
    handleChange: function handleChange(value, fromWrap) {
      this.activated = true;
      this.$emit('input', value);
      this.debouncedGetData(value);
      this.index++;
      this.lastValue = value;

      if (this.isOnComposition || !this.triggerOnFocus && !value) {
        this.suggestions = [];
      }
    },
    handleFocus: function handleFocus(event) {
      if (this.triggerOnFocus) {
        this.activated = true;
      }

      if (this.triggerOnFocus || this.value) {
        this.debouncedGetData(this.value);
      }

      this.$emit('focus', event);
    },
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
    },
    close: function close(e) {
      this.activated = false;
      this.suggestions = [];
    },
    handleKeyEnter: function handleKeyEnter(e) {
      if (this.suggestionVisible && this.highlightedIndex >= 0 && this.highlightedIndex < this.suggestions.length) {
        e.preventDefault();
        this.select(this.suggestions[this.highlightedIndex]);
      }
    },
    select: function select(item, index) {
      var _this3 = this;

      this.lastValue = item;
      this.activated = false;
      this.$emit('input', item[this.props.value] || item);
      this.$emit('select', item);
      this.$nextTick(function (_) {
        _this3.suggestions = [];
      });
    },
    highlight: function highlight(index) {
      if (!this.suggestionVisible || this.loading) {
        return;
      }

      if (index < 0) index = 0;

      if (index >= this.suggestions.length) {
        index = this.suggestions.length - 1;
      }

      var suggestion = this.$refs.suggestions.$el.querySelector('.el-autocomplete-suggestion__wrap');
      var suggestionList = suggestion.querySelectorAll('.el-autocomplete-suggestion__list li');
      var highlightItem = suggestionList[index];
      var scrollTop = suggestion.scrollTop;
      var offsetTop = highlightItem.offsetTop;

      if (offsetTop + highlightItem.scrollHeight > scrollTop + suggestion.clientHeight) {
        suggestion.scrollTop += highlightItem.scrollHeight;
      }

      if (offsetTop < scrollTop) {
        suggestion.scrollTop -= highlightItem.scrollHeight;
      }

      this.highlightedIndex = index;
    }
  }
});
// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_autocompletevue_type_script_lang_js_ = (autocompletevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue





/* normalize component */

var autocomplete_component = normalizeComponent(
  src_autocompletevue_type_script_lang_js_,
  autocompletevue_type_template_id_3230463c_render,
  autocompletevue_type_template_id_3230463c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var autocomplete = (autocomplete_component.exports);
// CONCATENATED MODULE: ./packages/autocomplete/index.js


/* istanbul ignore next */

autocomplete.install = function (Vue) {
  Vue.component(autocomplete.name, autocomplete);
};

/* harmony default export */ var packages_autocomplete = (autocomplete);
// CONCATENATED MODULE: ./src/mixins/migrating.js



/**
 * Show migrating guide in browser console.
 *
 * Usage:
 * import Migrating from 'element-ui/src/mixins/migrating';
 *
 * mixins: [Migrating]
 *
 * add getMigratingConfig method for your component.
 *  getMigratingConfig() {
 *    return {
 *      props: {
 *        'allow-no-selection': 'allow-no-selection is removed.',
 *        'selection-mode': 'selection-mode is removed.'
 *      },
 *      events: {
 *        selectionchange: 'selectionchange is renamed to selection-change.'
 *      }
 *    };
 *  },
 */

/* harmony default export */ var migrating = ({
  mounted: function mounted() {
    if (true) return;
    if (!this.$vnode) return;

    var _this$getMigratingCon = this.getMigratingConfig(),
        _this$getMigratingCon2 = _this$getMigratingCon.props,
        props = _this$getMigratingCon2 === void 0 ? {} : _this$getMigratingCon2,
        _this$getMigratingCon3 = _this$getMigratingCon.events,
        events = _this$getMigratingCon3 === void 0 ? {} : _this$getMigratingCon3;

    var _this$$vnode = this.$vnode,
        data = _this$$vnode.data,
        componentOptions = _this$$vnode.componentOptions;
    var definedProps = data.attrs || {};
    var definedEvents = componentOptions.listeners || {};

    for (var propName in definedProps) {
      if (hasOwn(definedProps, propName) && props[propName]) {
        console.warn("[Element Migrating][".concat(this.$options.name, "][Attribute]: ").concat(props[propName]));
      }
    }

    for (var eventName in definedEvents) {
      if (hasOwn(definedEvents, eventName) && events[eventName]) {
        console.warn("[Element Migrating][".concat(this.$options.name, "][Event]: ").concat(events[eventName]));
      }
    }
  },
  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {},
        events: {}
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=cd3e904a&
var button_groupvue_type_template_id_cd3e904a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-button-group"},[_vm._t("default")],2)}
var button_groupvue_type_template_id_cd3e904a_staticRenderFns = []


// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=cd3e904a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
//
//
//
//
//

/**
 * button
 * @module components/basic/menu
 * @desc 用于按钮组
 * @param {string} label - 名称
 */
/* harmony default export */ var button_groupvue_type_script_lang_js_ = ({
  name: 'ElButtonGroup'
});
// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_button_groupvue_type_script_lang_js_ = (button_groupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/button/src/button-group.vue





/* normalize component */

var button_group_component = normalizeComponent(
  src_button_groupvue_type_script_lang_js_,
  button_groupvue_type_template_id_cd3e904a_render,
  button_groupvue_type_template_id_cd3e904a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var button_group = (button_group_component.exports);
// CONCATENATED MODULE: ./packages/button-group/index.js


/* istanbul ignore next */

button_group.install = function (Vue) {
  Vue.component(button_group.name, button_group);
};

/* harmony default export */ var packages_button_group = (button_group);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&














/* harmony default export */ var dropdownvue_type_script_lang_js_ = ({
  name: 'ElDropdown',
  componentName: 'ElDropdown',
  directives: {
    Clickoutside: clickoutside
  },
  components: {
    ElButton: packages_button,
    ElButtonGroup: packages_button_group
  },
  mixins: [emitter, migrating],
  provide: function provide() {
    return {
      dropdown: this
    };
  },
  props: {
    trigger: {
      type: String,
      "default": 'hover'
    },
    type: {
      type: String,
      "default": ''
    },
    size: {
      type: String,
      "default": ''
    },
    splitButton: {
      type: Boolean,
      "default": null
    },
    hideOnClick: {
      type: Boolean,
      "default": true
    },
    placement: {
      type: String,
      "default": 'bottom-end'
    },
    visibleArrow: {
      type: Boolean,
      "default": true
    },
    showTimeout: {
      type: Number,
      "default": 250
    },
    hideTimeout: {
      type: Number,
      "default": 150
    },
    hideOnClickOutside: {
      type: Boolean,
      "default": true
    },
    isItemKeyEnterShow: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      timeout: null,
      visible: false,
      triggerElm: null,
      menuItems: null,
      menuItemsArray: null,
      dropdownElm: null,
      focusing: false,
      listId: "dropdown-menu-".concat(generateId())
    };
  },
  computed: {
    dropdownSize: function dropdownSize() {
      return this.size || (this.$ELEMENT || {}).size;
    }
  },
  watch: {
    visible: function visible(val) {
      this.broadcast('ElDropdownMenu', 'visible', val);
      this.$emit('visible-change', val);
    },
    focusing: function focusing(val) {
      var selfDefine = this.$el.querySelector('.el-dropdown-selfdefine');

      if (selfDefine) {
        // 自定义
        if (val) {
          selfDefine.className += ' focusing';
        } else {
          selfDefine.className = selfDefine.className.replace('focusing', '');
        }
      }
    }
  },
  mounted: function mounted() {
    this.$on('menu-item-click', this.handleMenuItemClick);
    this.initEvent();
    this.initAria();
  },
  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'menu-align': 'menu-align is renamed to placement.'
        }
      };
    },
    show: function show() {
      var _this = this;

      if (this.triggerElm.disabled) return;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this.visible = true;
      }, this.trigger === 'click' ? 0 : this.showTimeout);
    },
    hide: function hide() {
      var _this2 = this;

      if (this.triggerElm.disabled) return;
      this.removeTabindex();
      this.resetTabindex(this.triggerElm);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this2.visible = false;
      }, this.trigger === 'click' ? 0 : this.hideTimeout);
    },
    handleClick: function handleClick() {
      if (this.triggerElm.disabled) return;

      if (this.visible) {
        this.hide();
      } else {
        this.show();
      }
    },
    clickOutside: function clickOutside() {
      if (this.hideOnClickOutside) {
        this.hide();
      }
    },
    handleTriggerKeyDown: function handleTriggerKeyDown(ev) {
      var keyCode = ev.keyCode;

      if ([38, 40].indexOf(keyCode) > -1) {
        // up/down
        this.removeTabindex();
        this.resetTabindex(this.menuItems[0]);
        this.menuItems[0].focus();
        ev.preventDefault();
        ev.stopPropagation();
      } else if (keyCode === 13) {
        // space enter选中
        this.handleClick();
      } else if ([9, 27].indexOf(keyCode) > -1) {
        // tab || esc
        this.hide();
      }
    },
    handleItemKeyDown: function handleItemKeyDown(ev) {
      var keyCode = ev.keyCode;
      var target = ev.target;
      var currentIndex = this.menuItemsArray.indexOf(target);
      var max = this.menuItemsArray.length - 1;
      var nextIndex;

      if ([38, 40].indexOf(keyCode) > -1) {
        // up/down
        if (keyCode === 38) {
          // up
          nextIndex = currentIndex !== 0 ? currentIndex - 1 : 0;
        } else {
          // down
          nextIndex = currentIndex < max ? currentIndex + 1 : max;
        }

        this.removeTabindex();
        this.resetTabindex(this.menuItems[nextIndex]);
        this.menuItems[nextIndex].focus();
        ev.preventDefault();
        ev.stopPropagation();
      } else if (keyCode === 13) {
        // enter选中
        this.triggerElm.focus();
        target.click(); // item回车是否隐藏，默认false

        if (this.hideOnClick && !this.isItemKeyEnterShow) {
          // click关闭
          this.visible = false;
        }
      } else if ([9, 27].indexOf(keyCode) > -1) {
        // tab // esc
        this.hide();
        this.triggerElm.focus();
      }
    },
    resetTabindex: function resetTabindex(ele) {
      // 下次tab时组件聚焦元素
      this.removeTabindex();
      ele.setAttribute('tabindex', '0'); // 下次期望的聚焦元素
    },
    removeTabindex: function removeTabindex() {
      this.triggerElm.setAttribute('tabindex', '-1');
      this.menuItemsArray.forEach(function (item) {
        item.setAttribute('tabindex', '-1');
      });
    },
    initAria: function initAria() {
      this.dropdownElm.setAttribute('id', this.listId);
      this.triggerElm.setAttribute('aria-haspopup', 'list');
      this.triggerElm.setAttribute('aria-controls', this.listId);
      this.menuItems = this.dropdownElm.querySelectorAll("[tabindex='-1']");
      this.menuItemsArray = Array.prototype.slice.call(this.menuItems);

      if (!this.splitButton) {
        // 自定义
        this.triggerElm.setAttribute('role', 'button');
        this.triggerElm.setAttribute('tabindex', '0');
        this.triggerElm.setAttribute('class', (this.triggerElm.getAttribute('class') || '') + ' el-dropdown-selfdefine'); // 控制
      }
    },
    initEvent: function initEvent() {
      var _this3 = this;

      var trigger = this.trigger,
          show = this.show,
          hide = this.hide,
          handleClick = this.handleClick,
          splitButton = this.splitButton,
          handleTriggerKeyDown = this.handleTriggerKeyDown,
          handleItemKeyDown = this.handleItemKeyDown;
      this.triggerElm = splitButton ? this.$refs.trigger.$el : this.$slots["default"][0].elm;
      var dropdownElm = this.dropdownElm = this.$slots.dropdown[0].elm;
      this.triggerElm.addEventListener('keydown', handleTriggerKeyDown); // triggerElm keydown

      dropdownElm.addEventListener('keydown', handleItemKeyDown, true); // item keydown
      // 控制自定义元素的样式

      if (!splitButton) {
        this.triggerElm.addEventListener('focus', function () {
          _this3.focusing = true;
        });
        this.triggerElm.addEventListener('blur', function () {
          _this3.focusing = false;
        });
        this.triggerElm.addEventListener('click', function () {
          _this3.focusing = false;
        });
      }

      if (trigger === 'hover') {
        this.triggerElm.addEventListener('mouseenter', show);
        this.triggerElm.addEventListener('mouseleave', hide);
        dropdownElm.addEventListener('mouseenter', show);
        dropdownElm.addEventListener('mouseleave', hide);
      } else if (trigger === 'click') {
        this.triggerElm.addEventListener('click', handleClick);
      }
    },
    handleMenuItemClick: function handleMenuItemClick(command, instance) {
      if (this.hideOnClick) {
        this.visible = false;
      }

      this.$emit('command', command, instance);
    },
    focus: function focus() {
      this.triggerElm.focus && this.triggerElm.focus();
    }
  },
  render: function render() {
    var _this4 = this;

    var h = arguments[0];
    var hide = this.hide,
        clickOutside = this.clickOutside,
        splitButton = this.splitButton,
        type = this.type,
        dropdownSize = this.dropdownSize;

    var handleMainButtonClick = function handleMainButtonClick(event) {
      _this4.$emit('click', event);

      hide();
    };

    var triggerElm = !splitButton ? this.$slots["default"] : h("el-button-group", [h("el-button", {
      "attrs": {
        "type": type,
        "size": dropdownSize
      },
      "nativeOn": {
        "click": handleMainButtonClick
      }
    }, [this.$slots["default"]]), h("el-button", {
      "ref": 'trigger',
      "attrs": {
        "type": type,
        "size": dropdownSize
      },
      "class": 'el-dropdown__caret-button'
    }, [h("i", {
      "class": 'el-dropdown__icon h-icon-angle_down_sm'
    })])]);
    return h("div", {
      "class": 'el-dropdown',
      "directives": [{
        name: "clickoutside",
        value: clickOutside
      }]
    }, [triggerElm, this.$slots.dropdown]);
  }
});
// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_dropdownvue_type_script_lang_js_ = (dropdownvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue
var dropdown_render, dropdown_staticRenderFns




/* normalize component */

var dropdown_component = normalizeComponent(
  src_dropdownvue_type_script_lang_js_,
  dropdown_render,
  dropdown_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var dropdown = (dropdown_component.exports);
// CONCATENATED MODULE: ./packages/dropdown/index.js


/* istanbul ignore next */

dropdown.install = function (Vue) {
  Vue.component(dropdown.name, dropdown);
};

/* harmony default export */ var packages_dropdown = (dropdown);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=7cb22fe0&
var dropdown_menuvue_type_template_id_7cb22fe0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"after-leave":_vm.doDestroy}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"el-dropdown-menu el-popper",class:[_vm.size && ("el-dropdown-menu--" + _vm.size)]},[_vm._t("default")],2)])}
var dropdown_menuvue_type_template_id_7cb22fe0_staticRenderFns = []


// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=7cb22fe0&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var dropdown_menuvue_type_script_lang_js_ = ({
  name: 'ElDropdownMenu',
  componentName: 'ElDropdownMenu',
  mixins: [vue_popper],
  props: {
    visibleArrow: {
      type: Boolean,
      "default": false
    },
    offset: {
      type: Number,
      "default": 0
    }
  },
  data: function data() {
    return {
      size: this.dropdown.dropdownSize
    };
  },
  inject: ['dropdown'],
  watch: {
    'dropdown.placement': {
      immediate: true,
      handler: function handler(val) {
        this.currentPlacement = val;
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$on('updatePopper', function () {
      if (_this.showPopper) _this.updatePopper();
    });
    this.$on('visible', function (val) {
      _this.showPopper = val;
    });
  },
  mounted: function mounted() {
    this.$parent.popperElm = this.popperElm = this.$el;
    this.referenceElm = this.$parent.$el;
  }
});
// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_dropdown_menuvue_type_script_lang_js_ = (dropdown_menuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue





/* normalize component */

var dropdown_menu_component = normalizeComponent(
  src_dropdown_menuvue_type_script_lang_js_,
  dropdown_menuvue_type_template_id_7cb22fe0_render,
  dropdown_menuvue_type_template_id_7cb22fe0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var dropdown_menu = (dropdown_menu_component.exports);
// CONCATENATED MODULE: ./packages/dropdown-menu/index.js


/* istanbul ignore next */

dropdown_menu.install = function (Vue) {
  Vue.component(dropdown_menu.name, dropdown_menu);
};

/* harmony default export */ var packages_dropdown_menu = (dropdown_menu);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=634e0f7e&
var dropdown_itemvue_type_template_id_634e0f7e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"el-dropdown-menu__item",class:{
    'is-disabled': _vm.disabled,
    'el-dropdown-menu__item--divided': _vm.divided
  },attrs:{"aria-disabled":_vm.disabled,"tabindex":_vm.disabled ? null : -1},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var dropdown_itemvue_type_template_id_634e0f7e_staticRenderFns = []


// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=634e0f7e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var dropdown_itemvue_type_script_lang_js_ = ({
  name: 'ElDropdownItem',
  mixins: [emitter],
  props: {
    command: {
      type: null,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    divided: {
      type: Boolean,
      "default": null
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.dispatch('ElDropdown', 'menu-item-click', [this.command, this]);
    }
  }
});
// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_dropdown_itemvue_type_script_lang_js_ = (dropdown_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue





/* normalize component */

var dropdown_item_component = normalizeComponent(
  src_dropdown_itemvue_type_script_lang_js_,
  dropdown_itemvue_type_template_id_634e0f7e_render,
  dropdown_itemvue_type_template_id_634e0f7e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var dropdown_item = (dropdown_item_component.exports);
// CONCATENATED MODULE: ./packages/dropdown-item/index.js


/* istanbul ignore next */

dropdown_item.install = function (Vue) {
  Vue.component(dropdown_item.name, dropdown_item);
};

/* harmony default export */ var packages_dropdown_item = (dropdown_item);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu.vue?vue&type=template&id=001d4c1c&
var menuvue_type_template_id_001d4c1c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu-collapse-transition',[_c('ul',{key:+_vm.collapse,staticClass:"el-menu",class:{
      'el-menu--horizontal': _vm.mode === 'horizontal',
      'el-menu--collapse': _vm.collapse
    }},[_vm._t("menu-top"),(_vm.collapseBtn)?_c('li',{staticClass:"el-menu--colloase-btn",on:{"click":_vm.collapseMenu}},[_c('div',{staticClass:"el-submenu__title"},[_c('i',{staticClass:"el-menu-icon h-icon-menu_leftbar"})])]):_vm._e(),_vm._t("default")],2)])}
var menuvue_type_template_id_001d4c1c_staticRenderFns = []


// CONCATENATED MODULE: ./packages/menu/src/menu.vue?vue&type=template&id=001d4c1c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu.vue?vue&type=script&lang=js&











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var menuvue_type_script_lang_js_ = ({
  name: 'ElMenu',
  componentName: 'ElMenu',
  components: {
    'el-menu-collapse-transition': {
      functional: true,
      render: function render(createElement, context) {
        var data = {
          props: {
            mode: 'out-in'
          },
          on: {
            beforeEnter: function beforeEnter(el) {
              el.style.opacity = 0.2;
            },
            enter: function enter(el) {
              addClass(el, 'el-opacity-transition');
              el.style.opacity = 1;
            },
            afterEnter: function afterEnter(el) {
              removeClass(el, 'el-opacity-transition');
              el.style.opacity = '';
            },
            beforeLeave: function beforeLeave(el) {
              if (!el.dataset) el.dataset = {};

              if (hasClass(el, 'el-menu--collapse')) {
                removeClass(el, 'el-menu--collapse');
                el.dataset.oldOverflow = el.style.overflow;
                el.dataset.scrollWidth = el.scrollWidth;
                addClass(el, 'el-menu--collapse');
              }

              el.style.width = el.scrollWidth + 'px';
              el.style.overflow = 'hidden';
            },
            leave: function leave(el) {
              if (!hasClass(el, 'el-menu--collapse')) {
                addClass(el, 'horizontal-collapse-transition');
                el.style.width = '48px';
              } else {
                addClass(el, 'horizontal-collapse-transition');
                el.style.width = el.dataset.scrollWidth + 'px';
              }
            },
            afterLeave: function afterLeave(el) {
              removeClass(el, 'horizontal-collapse-transition');

              if (hasClass(el, 'el-menu--collapse')) {
                el.style.width = el.dataset.scrollWidth + 'px';
              } else {
                el.style.width = '48px';
              }

              el.style.overflow = el.dataset.oldOverflow;
            }
          }
        };
        return createElement('transition', data, context.children);
      }
    }
  },
  mixins: [emitter],
  provide: function provide() {
    return {
      rootMenu: this
    };
  },
  props: {
    mode: {
      type: String,
      "default": 'vertical'
    },
    defaultActive: {
      type: String,
      "default": ''
    },
    defaultOpeneds: {
      type: Array,
      "default": null
    },
    // theme: {
    //   type: String,
    //   default: 'light'
    // },
    uniqueOpened: {
      type: Boolean,
      "default": null
    },
    router: {
      type: Boolean,
      "default": null
    },
    menuTrigger: {
      type: String,
      "default": 'hover'
    },
    collapse: {
      type: Boolean,
      "default": null
    },
    collapseBtn: {
      type: Boolean,
      "default": null
    },
    collapseBtnClick: {
      type: Function,
      "default": null
    },
    noIcon: {
      type: Boolean,
      "default": false
    },
    wrapScroll: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      activeIndex: this.defaultActive,
      openedMenus: this.defaultOpeneds ? this.defaultOpeneds.slice(0) : [],
      openedCollapseMenus: [],
      // 打开的子菜单
      items: {},
      submenus: {}
    };
  },
  watch: {
    defaultActive: function defaultActive(value) {
      var item = this.items[value];

      if (item) {
        this.activeIndex = item.index;
        this.initOpenedMenu();
      } else {
        this.activeIndex = '';
      }
    },
    defaultOpeneds: function defaultOpeneds(value) {
      this.openedMenus = value;
    },
    collapse: function collapse(value) {
      if (value) {
        this.openedMenus = [];
        this.openedCollapseMenus = [];
        this.$emit('fold');
      } else {
        this.$emit('unfold');
      }
    }
  },
  mounted: function mounted() {
    this.initOpenedMenu();
    this.$on('item-click', this.handleItemClick);
    this.$on('submenu-click', this.handleSubmenuClick);
  },
  methods: {
    addItem: function addItem(item) {
      this.$set(this.items, item.index, item);
    },
    removeItem: function removeItem(item) {
      delete this.items[item.index];
    },
    addSubmenu: function addSubmenu(item) {
      this.$set(this.submenus, item.index, item);
    },
    removeSubmenu: function removeSubmenu(item) {
      delete this.submenus[item.index];
    },
    openMenu: function openMenu(index, indexPath) {
      var openedMenus = this.openedMenus;
      if (openedMenus.indexOf(index) !== -1) return; // 将不在该菜单路径下的其余菜单收起

      if (this.uniqueOpened) {
        this.openedMenus = openedMenus.filter(function (index) {
          return indexPath.indexOf(index) !== -1;
        });
      }

      this.openedMenus.push(index);
    },
    closeMenu: function closeMenu(index) {
      var i = this.openedMenus.indexOf(index);

      if (i !== -1) {
        this.openedMenus.splice(i, 1);
      }
    },
    // 关闭所有展开的子菜单
    closeCollapseMenu: function closeCollapseMenu() {
      var _this = this;

      this.openedCollapseMenus.forEach(function (index) {
        var i = _this.openedMenus.indexOf(index);

        if (i !== -1) {
          _this.openedMenus.splice(i, 1);
        }
      });
      this.openedCollapseMenus.length = 0;
    },
    handleSubmenuClick: function handleSubmenuClick(submenu) {
      var index = submenu.index,
          indexPath = submenu.indexPath;
      var isOpened = this.openedMenus.indexOf(index) !== -1;

      if (isOpened) {
        this.closeMenu(index);
        this.$emit('close', index, indexPath);
      } else {
        this.openMenu(index, indexPath);
        this.$emit('open', index, indexPath);
      }
    },
    handleItemClick: function handleItemClick(item) {
      var index = item.index,
          indexPath = item.indexPath;
      this.activeIndex = item.index;
      this.$emit('select', index, indexPath, item);

      if (this.mode === 'horizontal' || this.collapse) {
        this.openedMenus = [];
      }

      if (this.router) {
        this.routeToItem(item, function (error) {
          if (error) {
            // vue-router 3.1.0+ push/replace cause NavigationDuplicated error
            if (error.name === 'NavigationDuplicated') return;
            console.error(error);
          }
        });
      }
    },
    // 初始化展开菜单
    initOpenedMenu: function initOpenedMenu() {
      var _this2 = this;

      var index = this.activeIndex;
      var activeItem = this.items[index];
      if (!activeItem || this.mode === 'horizontal' || this.collapse) return;
      var indexPath = activeItem.indexPath; // 展开该菜单项的路径上所有子菜单

      indexPath.forEach(function (index) {
        var submenu = _this2.submenus[index];
        submenu && _this2.openMenu(index, submenu.indexPath);
      });
    },
    routeToItem: function routeToItem(item, onError) {
      var route = item.route || item.index;

      try {
        this.$router.push(route, function () {}, onError);
      } catch (e) {
        console.error(e);
      }
    },
    collapseMenu: function collapseMenu() {
      // 由于 prop 是单向绑定的，需要通过调用外部事件来完成
      this.$emit('click-collapse');

      if (this.wrapScroll) {
        this.closeCollapseMenu();
        var $wraps = document.querySelectorAll('body > .el-menu-collapse-wrap');

        var _iterator = _createForOfIteratorHelper($wraps),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var $wrap = _step.value;
            document.body.removeChild($wrap);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    },
    open: function open(index) {
      var _this3 = this;

      var indexPath = this.submenus[index.toString()].indexPath;
      indexPath.forEach(function (i) {
        return _this3.openMenu(i, indexPath);
      });
    },
    close: function close(index) {
      this.closeMenu(index.toString());
    }
  }
});
// CONCATENATED MODULE: ./packages/menu/src/menu.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_menuvue_type_script_lang_js_ = (menuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/menu/src/menu.vue





/* normalize component */

var menu_component = normalizeComponent(
  src_menuvue_type_script_lang_js_,
  menuvue_type_template_id_001d4c1c_render,
  menuvue_type_template_id_001d4c1c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_menu = (menu_component.exports);
// CONCATENATED MODULE: ./packages/menu/index.js


/* istanbul ignore next */

src_menu.install = function (Vue) {
  Vue.component(src_menu.name, src_menu);
};

/* harmony default export */ var packages_menu = (src_menu);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/submenu.vue?vue&type=template&id=2a4169e9&
var submenuvue_type_template_id_2a4169e9_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{
    'el-submenu': true,
    'is-active': _vm.active,
    'is-opened': _vm.opened,
    'is-disabled': _vm.disabled
  },on:{"mouseenter":_vm.handleMouseenter,"mouseleave":_vm.handleMouseleave}},[_c('div',{ref:"submenu-title",staticClass:"el-submenu__title",style:(_vm.paddingStyle),attrs:{"title":!_vm.rootMenu.collapse && !_vm.disabled && (_vm.isIe || _vm.textEllipsis) && _vm.title},on:{"click":_vm.handleClick}},[(_vm.$slots.icon)?_c('i',{staticClass:"el-menu-icon is-slot"},[_vm._t("icon")],2):(_vm.icon)?_c('i',{staticClass:"el-menu-icon",class:_vm.icon}):_vm._e(),(_vm.$slots.title)?_c('span',{staticClass:"el-submenu__title--text"},[_vm._t("title")],2):_c('span',{staticClass:"el-submenu__title--text"},[_vm._v(_vm._s(_vm.title))]),_c('i',{class:{
        'el-submenu__icon-arrow': true,
        'h-icon-angle_down_sm':
          _vm.rootMenu.mode === 'horizontal' ||
          (_vm.rootMenu.mode === 'vertical' && !_vm.rootMenu.collapse),
        'h-icon-angle_right_sm':
          _vm.rootMenu.mode === 'vertical' && _vm.rootMenu.collapse
      }})]),(_vm.rootMenu.mode === 'horizontal')?[_c('transition',{attrs:{"name":_vm.menuTransitionName}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.opened),expression:"opened"}],staticClass:"el-menu"},[_vm._t("default")],2)])]:(_vm.rootMenu.mode === 'vertical' && _vm.rootMenu.collapse)?[_c('transition',{attrs:{"name":_vm.menuTransitionName}},[(!_vm.rootMenu.wrapScroll)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.opened),expression:"opened"}],staticClass:"el-menu"},[(_vm.title && _vm.level === 1)?_c('li',{staticClass:"el-submenu__collpase-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("default")],2):_c('el-menu-collapse',{directives:[{name:"show",rawName:"v-show",value:(_vm.opened),expression:"opened"}],ref:"collapseMenu",attrs:{"root-menu":_vm.rootMenu},on:{"mouse-enter":_vm.handleMouseenter,"leave-collapse":_vm.leaveCollapse}},[(_vm.title && _vm.level === 1)?_c('li',{staticClass:"el-submenu__collpase-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("default")],2)],1)]:_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.opened),expression:"opened"}],staticClass:"el-menu"},[_vm._t("default")],2)])],2)}
var submenuvue_type_template_id_2a4169e9_staticRenderFns = []


// CONCATENATED MODULE: ./packages/menu/src/submenu.vue?vue&type=template&id=2a4169e9&

// CONCATENATED MODULE: ./src/transitions/collapse-transition.js

/* harmony default export */ var collapse_transition = ({
  name: 'ElCollapseTransition',
  functional: true,
  render: function render(h, _ref) {
    var children = _ref.children;
    var data = {
      on: {
        beforeEnter: function beforeEnter(el) {
          addClass(el, 'collapse-transition');
          if (!el.dataset) el.dataset = {};
          el.dataset.oldPaddingTop = el.style.paddingTop;
          el.dataset.oldPaddingBottom = el.style.paddingBottom;
          el.style.height = '0';
          el.style.paddingTop = 0;
          el.style.paddingBottom = 0;
        },
        enter: function enter(el) {
          el.dataset.oldOverflow = el.style.overflow;

          if (el.scrollHeight !== 0) {
            el.style.height = el.scrollHeight + 'px';
            el.style.paddingTop = el.dataset.oldPaddingTop;
            el.style.paddingBottom = el.dataset.oldPaddingBottom;
          } else {
            el.style.height = '';
            el.style.paddingTop = el.dataset.oldPaddingTop;
            el.style.paddingBottom = el.dataset.oldPaddingBottom;
          }

          el.style.overflow = 'hidden';
        },
        afterEnter: function afterEnter(el) {
          // for safari: remove class then reset height is necessary
          removeClass(el, 'collapse-transition');
          el.style.height = '';
          el.style.overflow = el.dataset.oldOverflow;
        },
        beforeLeave: function beforeLeave(el) {
          if (!el.dataset) el.dataset = {};
          el.dataset.oldPaddingTop = el.style.paddingTop;
          el.dataset.oldPaddingBottom = el.style.paddingBottom;
          el.dataset.oldOverflow = el.style.overflow;
          el.style.height = el.scrollHeight + 'px';
          el.style.overflow = 'hidden';
        },
        leave: function leave(el) {
          if (el.scrollHeight !== 0) {
            // for safari: add class after set height, or it will jump to zero height suddenly, weired
            addClass(el, 'collapse-transition');
            el.style.height = 0;
            el.style.paddingTop = 0;
            el.style.paddingBottom = 0;
          }
        },
        afterLeave: function afterLeave(el) {
          removeClass(el, 'collapse-transition');
          el.style.height = '';
          el.style.overflow = el.dataset.oldOverflow;
          el.style.paddingTop = el.dataset.oldPaddingTop;
          el.style.paddingBottom = el.dataset.oldPaddingBottom;
        }
      }
    };
    return h('transition', data, children);
  }
});
// CONCATENATED MODULE: ./packages/menu/src/menu-mixin.js

/* harmony default export */ var menu_mixin = ({
  computed: {
    indexPath: function indexPath() {
      var path = [this.index];
      var parent = this.$parent;

      while (parent.$options.componentName !== 'ElMenu') {
        if (parent.index) {
          path.unshift(parent.index);
        }

        parent = parent.$parent;
      }

      return path;
    },
    rootMenu: function rootMenu() {
      var parent = this.$parent;

      while (parent && parent.$options.componentName !== 'ElMenu') {
        parent = parent.$parent;
      }

      return parent;
    },
    parentMenu: function parentMenu() {
      var parent = this.$parent;

      while (parent && ['ElMenu', 'ElSubmenu'].indexOf(parent.$options.componentName) === -1) {
        parent = parent.$parent;
      }

      return parent;
    },
    paddingStyle: function paddingStyle() {
      if (this.rootMenu.mode !== 'vertical') return {};
      var gutter = 12;
      var parent = this.$parent;

      if (this.rootMenu.collapse || !parent) {
        return {};
      } else {
        if (parent.$options.componentName === 'ElMenu') {
          gutter = this.icon || this.$slots.icon ? 12 : 24; // 第一层菜单左侧间距
        } else {
          gutter = 48; // 第一层子菜单左侧间距，和第一层菜单齐平

          parent = parent.$parent;

          while (parent && parent.$options.componentName !== 'ElMenu') {
            // 子菜单每层缩进 16px
            if (parent.$options.componentName === 'ElSubmenu') {
              gutter += 16;
            }

            parent = parent.$parent;
          }
        }

        return {
          paddingLeft: gutter + 'px'
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/submenu.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var HIDE_TIME = 20;
/* harmony default export */ var submenuvue_type_script_lang_js_ = ({
  name: 'ElSubmenu',
  componentName: 'ElSubmenu',
  components: {
    ElCollapseTransition: collapse_transition
  },
  mixins: [menu_mixin, emitter],
  props: {
    index: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    title: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      ieIe: false,
      timeout: null,
      items: {},
      submenus: {},
      collapseEl: null,
      // 折叠元素
      textEllipsis: false,
      level: 1,
      hideTimer: null
    };
  },
  computed: {
    menuTransitionName: function menuTransitionName() {
      return this.rootMenu.collapse ? 'el-zoom-in-left' : 'el-zoom-in-top';
    },
    opened: function opened() {
      return this.rootMenu.openedMenus.indexOf(this.index) > -1;
    },
    active: {
      cache: false,
      get: function get() {
        var isActive = false;
        var submenus = this.submenus;
        var items = this.items;
        Object.keys(items).forEach(function (index) {
          if (items[index].active) {
            isActive = true;
          }
        });
        Object.keys(submenus).forEach(function (index) {
          if (submenus[index].active) {
            isActive = true;
          }
        });
        return isActive;
      }
    }
  },
  watch: {
    opened: function opened(val) {
      var rootMenu = this.rootMenu;

      if (rootMenu.menuTrigger === 'hover' && rootMenu.mode === 'horizontal') {
        var index = this.index,
            indexPath = this.indexPath;
        val ? rootMenu.$emit('open', index, indexPath) : rootMenu.$emit('close', index, indexPath);
      }
    }
  },
  created: function created() {
    // 获取上级子菜单
    var $subMenu = this.rootMenu.wrapScroll ? this.$parent.$parent : this.$parent; // 第一个子菜单level为1，嵌套子菜单递增

    this.level = $subMenu.level ? $subMenu.level + 1 : 1;
    this.parentMenu.addSubmenu(this);
    this.rootMenu.addSubmenu(this);
  },
  mounted: function mounted() {
    resize_event_addResizeListener(this.$el, this.setTextEllipsis);

    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      this.isIe = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.parentMenu.removeSubmenu(this);
    this.rootMenu.removeSubmenu(this);
    removeResizeListener(this.$el, this.setTextEllipsis);
  },
  methods: {
    addItem: function addItem(item) {
      this.$set(this.items, item.index, item);
    },
    removeItem: function removeItem(item) {
      delete this.items[item.index];
    },
    addSubmenu: function addSubmenu(item) {
      this.$set(this.submenus, item.index, item);
    },
    removeSubmenu: function removeSubmenu(item) {
      delete this.submenus[item.index];
    },
    handleClick: function handleClick() {
      var rootMenu = this.rootMenu;

      if (rootMenu.menuTrigger === 'hover' && rootMenu.mode === 'horizontal' || rootMenu.collapse && rootMenu.mode === 'vertical' || this.disabled) {
        return;
      }

      this.dispatch('ElMenu', 'submenu-click', this);
    },
    handleMouseenter: function handleMouseenter(event) {
      var rootMenu = this.rootMenu;

      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical' || this.disabled) {
        return;
      }

      var fromElement = event.fromElement || event.originalTarget; // 若从滚动条移动到菜单（菜单使用滚动条控件的情况）

      if (closest(fromElement, '.el-scrollbar__bar') || closest(fromElement, '.el-scrollbar__thumb')) {
        this.rootMenu.closeCollapseMenu();
      } // 打开菜单


      clearTimeout(this.hideTimer);
      this.rootMenu.openMenu(this.index, this.indexPath); // 属性 wrapScroll 为 true，且不存在 collapseEl
      // 或者存在 collapseEl，但收缩菜单未打开（解决菜单会重叠问题）

      if (rootMenu.wrapScroll && this.$refs.collapseMenu && !this.collapseEl || this.collapseEl && this.rootMenu.openedCollapseMenus.indexOf(this.index) === -1) {
        // 加载收缩菜单
        this.collapseEl = this.$refs.collapseMenu.loadCollapseMenu();

        if (this.rootMenu.openedCollapseMenus.indexOf(this.index) === -1) {
          // 将index加入到子菜单数组中
          this.rootMenu.openedCollapseMenus.push(this.index);
        }
      }
    },
    handleMouseleave: function handleMouseleave(event) {
      var _this = this;

      var rootMenu = this.rootMenu;
      var activeIndex = this.index;

      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical') {
        return;
      } // 关闭菜单


      this.hideTimer = setTimeout(function () {
        _this.rootMenu.closeMenu(activeIndex);
      }, HIDE_TIME);

      if (rootMenu.wrapScroll) {
        // 处理firefox兼容性（chrome 为 toElement，firefox 为 relatedTarget）
        var toElement = event.toElement || event.relatedTarget; // 若移动到自身的子菜单上

        if (this.$refs.collapseMenu && closest(toElement, '.el-menu-collapse-wrap') === this.$refs.collapseMenu.$el) {
          return;
        } // 若移动到滚动条上（菜单使用滚动条控件的情况）


        if (closest(toElement, '.el-scrollbar__bar') || closest(toElement, '.el-scrollbar__thumb')) {
          return;
        }
      } // 关闭收缩菜单


      if (rootMenu.wrapScroll) this.emitHideCollapse();
    },
    // 鼠标离开子菜单后
    leaveCollapse: function leaveCollapse(event) {
      var _this2 = this;

      var toElement = event.toElement || event.relatedTarget;
      var activeIndex = this.index; // 若鼠标没有回到菜单，则关闭所有子菜单

      if (closest(toElement, '.el-menu') == null && closest(toElement, '.el-menu-collapse-wrap') === null) {
        this.rootMenu.closeCollapseMenu();
      } // 若鼠标没回到父菜单，则关闭当前子菜单


      if (closest(toElement, '.el-submenu') !== this.$el) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this2.rootMenu.closeMenu(activeIndex);

          _this2.emitHideCollapse();
        }, 100);
      }
    },
    // 触发隐藏折叠菜单事件
    emitHideCollapse: function emitHideCollapse() {
      this.rootMenu.$emit('hide-collapse', this.collapseEl);
      this.collapseEl = null;
    },

    /**
     * @desc 判断文本是否超长，超长则显示省略号
     * @author chenguanbin
     */
    setTextEllipsis: function setTextEllipsis() {
      var $text = this.$el.querySelector('.el-submenu__title--text');
      if (!$text || !$text.parentNode) return;
      var gutter = 84; // 菜单项左右的间距

      this.textEllipsis = $text.offsetWidth > $text.parentNode.offsetWidth - gutter;
    }
  }
});
// CONCATENATED MODULE: ./packages/menu/src/submenu.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_submenuvue_type_script_lang_js_ = (submenuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/menu/src/submenu.vue





/* normalize component */

var submenu_component = normalizeComponent(
  src_submenuvue_type_script_lang_js_,
  submenuvue_type_template_id_2a4169e9_render,
  submenuvue_type_template_id_2a4169e9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var submenu = (submenu_component.exports);
// CONCATENATED MODULE: ./packages/submenu/index.js


/* istanbul ignore next */

submenu.install = function (Vue) {
  Vue.component(submenu.name, submenu);
};

/* harmony default export */ var packages_submenu = (submenu);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=template&id=d193f2b6&
var menu_itemvue_type_template_id_d193f2b6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"el-menu-item",class:{
    'is-active': _vm.active,
    'is-disabled': _vm.disabled
  },style:(_vm.paddingStyle),attrs:{"title":_vm.rootMenu.mode === 'vertical' &&
      !_vm.rootMenu.collapse &&
      !_vm.disabled &&
      (_vm.isIe || _vm.textEllipsis) &&
      _vm.$slots.default &&
      _vm.$slots.default[0].text},on:{"click":_vm.handleClick}},[(_vm.parentMenu === _vm.rootMenu && _vm.rootMenu.collapse)?_c('el-tooltip',{attrs:{"effect":"dark","placement":"right","popper-class":"tooltip-for-menu-item"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v(" "+_vm._s(_vm.$slots.default[0].text)+" ")]),_c('div',{staticClass:"el-menu-item__collapse"},[(_vm.$slots.icon)?_c('i',{staticClass:"el-menu-icon is-slot"},[_vm._t("icon")],2):(_vm.icon)?_c('i',{staticClass:"el-menu-icon",class:_vm.icon}):_vm._e(),_c('span',{staticClass:"el-menu-item--text"},[_vm._t("default")],2)])]):[(_vm.$slots.icon)?_c('i',{staticClass:"el-menu-icon is-slot"},[_vm._t("icon")],2):(_vm.icon)?_c('i',{staticClass:"el-menu-icon",class:_vm.icon}):_vm._e(),_c('span',{staticClass:"el-menu-item--text"},[_vm._t("default")],2)]],2)}
var menu_itemvue_type_template_id_d193f2b6_staticRenderFns = []


// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=template&id=d193f2b6&

// CONCATENATED MODULE: ./packages/tooltip/src/main.js










/* harmony default export */ var tooltip_src_main = ({
  name: 'ElTooltip',
  mixins: [vue_popper],
  props: {
    openDelay: {
      type: Number,
      "default": 0
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    manual: {
      type: Boolean,
      "default": null
    },
    effect: {
      type: String,
      "default": 'light'
    },
    popperClass: {
      type: String,
      "default": null
    },
    content: {
      type: String,
      "default": null
    },
    visibleArrow: {
      "default": true
    },
    transition: {
      type: String,
      "default": 'el-fade-in-linear'
    },
    popperOptions: {
      "default": function _default() {
        return {
          boundariesPadding: 10,
          gpuAcceleration: false
        };
      }
    },
    enterable: {
      type: Boolean,
      "default": false
    },
    debounceClosable: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      focusing: false
    };
  },
  watch: {
    disabled: function disabled(val) {
      if (!val) return;
      this.showPopper = false;
    },
    focusing: function focusing(val) {
      if (val) {
        addClass(this.referenceElm, 'focusing');
      } else {
        removeClass(this.referenceElm, 'focusing');
      }
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    if (this.$isServer) return;
    this.popperVM = new external_vue_default.a({
      data: {
        node: ''
      },
      render: function render() {
        return this.node;
      }
    }).$mount();
    this.debounceClose = debounce_default()(200, function () {
      return _this.handleClosePopper();
    });
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];

    if (this.popperVM) {
      this.popperVM.node = h("transition", {
        "attrs": {
          "name": this.transition
        },
        "on": {
          "afterLeave": this.doDestroy
        }
      }, [h("div", {
        "on": {
          "mouseleave": function mouseleave() {
            _this2.setExpectedState(false);

            _this2.debounceClosable ? _this2.debounceClose() : _this2.handleClosePopper(); // this.hide();
          },
          "mouseenter": function mouseenter() {
            _this2.setExpectedState(true);
          }
        },
        "ref": 'popper',
        "directives": [{
          name: "show",
          value: !this.disabled && this.showPopper
        }],
        "class": ['el-tooltip__popper', 'is-' + this.effect, this.popperClass]
      }, [this.$slots.content || this.content])]);
    }

    if (!this.$slots["default"] || !this.$slots["default"].length) {
      return this.$slots["default"];
    }

    this.firstElement = this.getFirstElement();
    if (!this.firstElement) return null;
    var data = this.firstElement.data = this.firstElement.data || {};
    data.staticClass = this.addTooltipClass(data.staticClass);
    return this.firstElement;
  },
  mounted: function mounted() {
    var _this3 = this;

    this.referenceElm = this.$el;
    if (!this.firstElement) return this.firstElement;
    this.referenceElm = this.$el;

    if (this.$el.nodeType === 1) {
      this.$el.setAttribute('aria-describedby', this.tooltipId);
      this.$el.setAttribute('tabindex', this.tabindex);
      on(this.referenceElm, 'mouseenter', this.show);
      on(this.referenceElm, 'mouseleave', this.hide);
      on(this.referenceElm, 'focus', function () {
        if (!_this3.$slots["default"] || !_this3.$slots["default"].length) {
          _this3.handleFocus();

          return;
        }

        var instance = _this3.$slots["default"][0].componentInstance;

        if (instance && instance.focus) {
          instance.focus();
        } else {
          _this3.handleFocus();
        }
      });
      on(this.referenceElm, 'blur', this.handleBlur);
      on(this.referenceElm, 'click', this.removeFocusing);
    } // fix issue https://github.com/ElemeFE/element/issues/14424


    if (this.value && this.popperVM) {
      this.popperVM.$nextTick(function () {
        if (_this3.value) {
          _this3.updatePopper();
        }
      });
    }
  },
  destroyed: function destroyed() {
    var reference = this.referenceElm;

    if (reference.nodeType === 1) {
      off(reference, 'mouseenter', this.show);
      off(reference, 'mouseleave', this.hide);
      off(reference, 'focus', this.handleFocus);
      off(reference, 'blur', this.handleBlur);
      off(reference, 'click', this.removeFocusing);
    }
  },
  methods: {
    show: function show() {
      this.setExpectedState(true);
      this.handleShowPopper();
    },
    hide: function hide() {
      this.setExpectedState(false);
      this.debounceClose();
    },
    handleFocus: function handleFocus() {
      this.focusing = true;
      this.show();
    },
    handleBlur: function handleBlur() {
      this.focusing = false;
      this.hide();
    },
    removeFocusing: function removeFocusing() {
      this.focusing = false;
    },
    addTooltipClass: function addTooltipClass(prev) {
      if (!prev) {
        return 'el-tooltip';
      } else {
        return 'el-tooltip ' + prev.replace('el-tooltip', '');
      }
    },
    concatClass: function concatClass(a, b) {
      if (a && a.indexOf(b) > -1) return a;
      return a ? b ? a + ' ' + b : a : b || '';
    },
    handleShowPopper: function handleShowPopper() {
      var _this4 = this;

      if (!this.expectedState || this.manual) return;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this4.showPopper = true;
      }, this.openDelay);
    },
    handleClosePopper: function handleClosePopper() {
      if (this.enterable && this.expectedState || this.manual) return;
      clearTimeout(this.timeout);
      this.showPopper = false;
    },
    setExpectedState: function setExpectedState(expectedState) {
      this.expectedState = expectedState;
    },
    getFirstElement: function getFirstElement() {
      var slots = this.$slots["default"];
      if (!Array.isArray(slots)) return null;
      var element = null;

      for (var index = 0; index < slots.length; index++) {
        if (slots[index] && slots[index].tag) {
          element = slots[index];
        }
      }

      return element;
    }
  }
});
// CONCATENATED MODULE: ./packages/tooltip/index.js


/* istanbul ignore next */

tooltip_src_main.install = function (Vue) {
  Vue.component(tooltip_src_main.name, tooltip_src_main);
};

/* harmony default export */ var packages_tooltip = (tooltip_src_main);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var menu_itemvue_type_script_lang_js_ = ({
  name: 'ElMenuItem',
  componentName: 'ElMenuItem',
  components: {
    ElTooltip: packages_tooltip
  },
  mixins: [menu_mixin, emitter],
  props: {
    index: {
      type: String,
      required: true
    },
    route: {
      type: Object,
      required: false,
      "default": null
    },
    disabled: {
      type: Boolean,
      required: false,
      "default": false
    },
    icon: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      isIe: false,
      textEllipsis: false
    };
  },
  computed: {
    active: function active() {
      return this.index === this.rootMenu.activeIndex;
    }
  },
  created: function created() {
    this.parentMenu.addItem(this);
    this.rootMenu.addItem(this);
  },
  mounted: function mounted() {
    resize_event_addResizeListener(this.$el, this.setTextEllipsis);

    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      this.isIe = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.parentMenu.removeItem(this);
    this.rootMenu.removeItem(this);
    removeResizeListener(this.$el, this.setTextEllipsis);
  },
  methods: {
    handleClick: function handleClick() {
      if (!this.disabled) {
        this.dispatch('ElMenu', 'item-click', this);
        this.$emit('click', this);
      }
    },
    setTextEllipsis: function setTextEllipsis() {
      var $text = this.$el.querySelector('.el-menu-item--text');
      if (!$text || !$text.parentNode) return;
      var gutter = 60; // 菜单项左右的间距

      this.textEllipsis = $text.offsetWidth > $text.parentNode.offsetWidth - gutter;
    }
  }
});
// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_menu_itemvue_type_script_lang_js_ = (menu_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue





/* normalize component */

var menu_item_component = normalizeComponent(
  src_menu_itemvue_type_script_lang_js_,
  menu_itemvue_type_template_id_d193f2b6_render,
  menu_itemvue_type_template_id_d193f2b6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var menu_item = (menu_item_component.exports);
// CONCATENATED MODULE: ./packages/menu-item/index.js


/* istanbul ignore next */

menu_item.install = function (Vue) {
  Vue.component(menu_item.name, menu_item);
};

/* harmony default export */ var packages_menu_item = (menu_item);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=template&id=5aa50268&
var menu_item_groupvue_type_template_id_5aa50268_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"el-menu-item-group"},[_c('div',{staticClass:"el-menu-item-group__title",style:({ paddingLeft: _vm.levelPadding + 'px' })},[(!_vm.$slots.title)?[_vm._v(" "+_vm._s(_vm.title)+" ")]:_vm._t("title")],2),_c('ul',[_vm._t("default")],2)])}
var menu_item_groupvue_type_template_id_5aa50268_staticRenderFns = []


// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=template&id=5aa50268&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var menu_item_groupvue_type_script_lang_js_ = ({
  name: 'ElMenuItemGroup',
  componentName: 'ElMenuItemGroup',
  inject: ['rootMenu'],
  props: {
    title: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      paddingLeft: 10
    };
  },
  computed: {
    levelPadding: function levelPadding() {
      var padding = 10;
      var subPadding = 26; // 子菜单额外缩进距离

      var parent = this.$parent; // 无图标

      if (!this.icon) {
        padding = 22;
        subPadding = 0;
      }

      if (this.rootMenu.collapse) return 16;

      while (parent && parent.$options.componentName !== 'ElMenu') {
        if (parent.$options.componentName === 'ElSubmenu') {
          padding += 10;
        }

        parent = parent.$parent; // 增加子菜单的缩进距离

        if (parent && parent.$options.componentName === 'ElMenu') {
          padding += subPadding;
        }
      }

      padding === 10 && (padding = 10);
      return padding;
    }
  }
});
// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_menu_item_groupvue_type_script_lang_js_ = (menu_item_groupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue





/* normalize component */

var menu_item_group_component = normalizeComponent(
  src_menu_item_groupvue_type_script_lang_js_,
  menu_item_groupvue_type_template_id_5aa50268_render,
  menu_item_groupvue_type_template_id_5aa50268_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var menu_item_group = (menu_item_group_component.exports);
// CONCATENATED MODULE: ./packages/menu-item-group/index.js


/* istanbul ignore next */

menu_item_group.install = function (Vue) {
  Vue.component(menu_item_group.name, menu_item_group);
};

/* harmony default export */ var packages_menu_item_group = (menu_item_group);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-collapse.vue?vue&type=template&id=644c54df&
var menu_collapsevue_type_template_id_644c54df_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-menu-collapse-wrap",staticStyle:{"transition":"all .2s"},on:{"mouseenter":_vm.handleMouseenter,"mouseleave":_vm.handleMouseleave}},[_c('ul',{staticClass:"el-menu",class:{ 'el-menu--dark': _vm.rootMenu.theme === 'dark' }},[_vm._t("default")],2)])}
var menu_collapsevue_type_template_id_644c54df_staticRenderFns = []


// CONCATENATED MODULE: ./packages/menu/src/menu-collapse.vue?vue&type=template&id=644c54df&

// CONCATENATED MODULE: ./packages/menu/src/util.js





/**
 * 返回当前页面相对于窗口显示区左上角的 X ，Y 的位置
 * @author chenguanbin
 * @param {boolean} [top] 是否是获取顶部的左上角的Y坐标
 */
var util_getScroll = function getScroll(top) {
  var ret = window['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = window.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
};
/**
 * 返回目标节点在容器中的位置
 * @author chenguanbin
 * @param {HTMLElement} [element] 需要获取位置的元素
 * @param {HTMLElement} [container = document.body] 容器元素
 */

var util_getOffset = function getOffset(element) {
  var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
  var elRect = element.getBoundingClientRect();
  var containerRect = container.getBoundingClientRect();
  var clientTop = element.clientTop || container.clientTop || 0;
  var clientLeft = element.clientLeft || container.clientLeft || 0;
  var top, left;

  if (container === document.body) {
    top = util_getScroll(true);
    left = util_getScroll();
  } else {
    top = container.scrollTop - containerRect.top;
    left = container.scrollLeft - containerRect.left;
  }

  return {
    top: elRect.top + top - clientTop,
    left: elRect.left + left - clientLeft,
    right: elRect.right + left - clientLeft,
    bottom: elRect.bottom + top - clientTop
  };
};
/**
 * 获取折叠子菜单的高度
 * @param {HTMLElement} submenu 子菜单
 */

var getCollapseHeight = function getCollapseHeight(submenu) {
  var cHeight = 0;

  var traverse = function traverse(el) {
    var childNodes = Array.prototype.slice.call(el.childNodes);
    childNodes.forEach(function (node) {
      var nodeName = node.nodeName;
      var className = node.className;

      if (nodeName === 'LI' && className.indexOf('el-menu-item-group') !== -1) {
        cHeight += 32;
        traverse(node);
      } else if (nodeName === 'LI' && (className.indexOf('el-menu-item') !== -1 || className.indexOf('el-submenu') !== -1)) {
        cHeight += 40;
      } else if (nodeName === 'UL') {
        traverse(node);
      }
    });
  };

  traverse(submenu);
  return cHeight;
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-collapse.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var menu_collapsevue_type_script_lang_js_ = ({
  name: 'ElMenuCollapse',
  componentName: 'ElMenuCollapse',
  props: {
    rootMenu: {
      type: Object,
      "default": null
    }
  },
  data: function data() {
    return {
      open: false
    };
  },
  mounted: function mounted() {},
  methods: {
    handleMouseenter: function handleMouseenter(event) {
      this.$emit('mouse-enter', event);
    },
    handleMouseleave: function handleMouseleave(event) {
      var toElement = event.toElement || event.relatedTarget; // 若鼠标未移动到子菜单上，则触发事件

      if (closest(toElement, '.el-menu-collapse-wrap') === null) {
        this.$emit('leave-collapse', event);
      }
    },
    loadCollapseMenu: function loadCollapseMenu() {
      var _this = this;

      var isExistNode = false;
      var nodes = Array.prototype.slice.call(document.body.childNodes); // 判断节点是否已经添加到body下

      if (nodes && nodes.length) {
        nodes.forEach(function (node) {
          if (node === _this.$el) {
            isExistNode = true;
          }
        });
      } // 若节点未添加到body下


      if (!isExistNode) {
        document.body.appendChild(this.$el);
      } // 每次打开重新计算位置


      var parent = this.$parent.$el;
      var parentOffset = util_getOffset(parent); // 父节点距离页面顶部的距离

      var parentClientTop = parent.getBoundingClientRect().top; // 父节点相对于浏览器左上角的距离

      var collapseHeight = getCollapseHeight(this.$el.childNodes[0]); // 折叠菜单高度

      var clientHeight = document.body.clientHeight; // 页面的可视高度

      var wrapScrollTop = document.getElementsByTagName('html')[0].scrollTop || document.body.scrollTop; // 外层滚动条的滚动距离（html/body）(在HUIdemo网站上该值会过大)

      var gutter = 0; // top值偏移量
      // 若底部控件不足，则向上偏移

      if (parentClientTop + collapseHeight >= clientHeight) {
        gutter = parentClientTop + collapseHeight - clientHeight + wrapScrollTop + 2;
      } // 计算折叠子菜单的 top/left 值


      this.$el.style.top = parentOffset.top - gutter + 'px';
      this.$el.style.left = parentOffset.left + parent.offsetWidth + 'px';
      setTimeout(function () {
        _this.rootMenu.$emit('show-collapse', _this.$el);
      }, 300);
      return this.$el;
    }
  }
});
// CONCATENATED MODULE: ./packages/menu/src/menu-collapse.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_menu_collapsevue_type_script_lang_js_ = (menu_collapsevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/menu/src/menu-collapse.vue





/* normalize component */

var menu_collapse_component = normalizeComponent(
  src_menu_collapsevue_type_script_lang_js_,
  menu_collapsevue_type_template_id_644c54df_render,
  menu_collapsevue_type_template_id_644c54df_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var menu_collapse = (menu_collapse_component.exports);
// CONCATENATED MODULE: ./packages/menu-collapse/index.js


/* istanbul ignore next */

menu_collapse.install = function (Vue) {
  Vue.component(menu_collapse.name, menu_collapse);
};

/* harmony default export */ var packages_menu_collapse = (menu_collapse);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=19c4dade&
var input_numbervue_type_template_id_19c4dade_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'el-input-number',
    _vm.inputNumberSize ? 'el-input-number--' + _vm.inputNumberSize : '',
    { 'is-disabled': _vm.inputNumberDisabled },
    { 'is-without-controls': !_vm.controls },
    { 'is-controls-right': _vm.controlsAtRight }
  ],on:{"dragstart":function($event){$event.preventDefault();}}},[(_vm.controls)?_c('el-button',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.decrease),expression:"decrease"}],staticClass:"el-decrease  el-input-number__decrease ",class:{ 'is-disabled': _vm.minDisabled },attrs:{"disabled":_vm.disabled,"icon":"h-icon-angle_down","size":"mini"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.decrease($event)}}}):_vm._e(),(_vm.controls)?_c('el-button',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.increase),expression:"increase"}],staticClass:"el-increase el-input-number__increase",class:{ 'is-disabled': _vm.maxDisabled },attrs:{"disabled":_vm.disabled,"icon":"h-icon-angle_up","size":"mini"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.increase($event)}}}):_vm._e(),_c('el-input',{ref:"input",attrs:{"value":_vm.displayValue,"placeholder":_vm.placeholder,"disabled":_vm.inputNumberDisabled,"size":_vm.inputNumberSize,"name":_vm.name,"label":_vm.label},on:{"blur":_vm.handleBlur,"focus":_vm.handleFocus,"input":_vm.handleInput,"change":_vm.handleInputChange},nativeOn:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.increase($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.decrease($event)}]}},[(_vm.$slots.suffix)?_c('template',{slot:"suffix"},[_vm._t("suffix")],2):_vm._e()],2)],1)}
var input_numbervue_type_template_id_19c4dade_staticRenderFns = []


// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=19c4dade&

// EXTERNAL MODULE: external "core-js/modules/es.number.to-fixed.js"
var es_number_to_fixed_js_ = __webpack_require__("ccb3");

// EXTERNAL MODULE: external "core-js/modules/es.number.to-precision.js"
var es_number_to_precision_js_ = __webpack_require__("f655");

// CONCATENATED MODULE: ./src/directives/repeat-click.js



/* harmony default export */ var repeat_click = ({
  bind: function bind(el, binding, vnode) {
    var interval = null;
    var startTime;

    var handler = function handler() {
      return vnode.context[binding.expression].apply();
    };

    var clear = function clear() {
      if (new Date() - startTime < 100) {
        handler();
      }

      clearInterval(interval);
      interval = null;
    };

    on(el, 'mousedown', function (e) {
      if (e.button !== 0) return;
      startTime = new Date();
      once(document, 'mouseup', clear);
      clearInterval(interval);
      interval = setInterval(handler, 100);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var input_numbervue_type_script_lang_js_ = ({
  name: 'ElInputNumber',
  directives: {
    repeatClick: repeat_click
  },
  components: {
    ElInput: packages_input
  },
  props: {
    step: {
      type: Number,
      "default": 1
    },
    stepStrictly: {
      type: Boolean,
      "default": false
    },
    max: {
      type: Number,
      "default": Infinity
    },
    min: {
      type: Number,
      "default": 0
    },
    value: {
      type: null,
      "default": 0
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    size: {
      type: String,
      "default": ''
    },
    controls: {
      type: Boolean,
      "default": true
    },
    controlsPosition: {
      type: String,
      "default": ''
    },
    name: {
      type: String,
      "default": ''
    },
    label: {
      type: String,
      "default": ''
    },
    placeholder: {
      type: String,
      "default": ''
    },
    precision: {
      type: Number,
      validator: function validator(val) {
        return val >= 0 && val === parseInt(val, 10);
      },
      "default": 0
    }
  },
  data: function data() {
    return {
      currentValue: 0,
      userInput: null
    };
  },
  computed: {
    // 最小值时禁用decrease按钮
    minDisabled: function minDisabled() {
      return this._decrease(this.value, this.step) < this.min;
    },
    // 最大值时禁用increase按钮
    maxDisabled: function maxDisabled() {
      return this._increase(this.value, this.step) > this.max;
    },
    // 精度
    numPrecision: function numPrecision() {
      var value = this.value,
          step = this.step,
          getPrecision = this.getPrecision,
          precision = this.precision;
      var stepPrecision = getPrecision(step);

      if (precision !== undefined) {
        // 如果步长的小数位比 value的小数位数还长，警告并返回vaulue小数位
        if (stepPrecision > precision) {
          console.warn('[HUI Warn][InputNumber]precision should not be less than the decimal places of step');
        }

        return precision;
      } else {
        // 步长精度和value精度，返回更精准的
        return Math.max(getPrecision(value), stepPrecision);
      }
    },
    controlsAtRight: function controlsAtRight() {
      return this.controls && this.controlsPosition === 'right';
    },
    inputNumberSize: function inputNumberSize() {
      return this.size;
    },
    inputNumberDisabled: function inputNumberDisabled() {
      return this.disabled;
    },
    // 显示的值
    displayValue: function displayValue() {
      if (this.userInput !== null) {
        return this.userInput;
      }

      var currentValue = this.currentValue;

      if (typeof currentValue === 'number') {
        if (this.stepStrictly) {
          var stepPrecision = this.getPrecision(this.step);
          var precisionFactor = Math.pow(10, stepPrecision);
          currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
        } // 修正小数点位数


        if (this.precision !== undefined) {
          currentValue = currentValue.toFixed(this.precision);
        }
      }

      return currentValue;
    }
  },
  watch: {
    // 传入的值
    value: {
      immediate: true,
      handler: function handler(value) {
        var newVal = value === undefined ? value : Number(value);

        if (newVal !== undefined) {
          if (isNaN(newVal)) {
            return;
          }

          if (this.stepStrictly) {
            var stepPrecision = this.getPrecision(this.step);
            var precisionFactor = Math.pow(10, stepPrecision);
            newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
          }

          if (this.precision !== undefined) {
            newVal = this.toPrecision(newVal, this.precision);
          }
        }

        if (newVal >= this.max) newVal = this.max;
        if (newVal <= this.min) newVal = this.min;
        this.currentValue = newVal; // this.userInput = null;

        this.$emit('input', newVal);
      }
    }
  },
  mounted: function mounted() {
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('role', 'spinbutton');
    innerInput.setAttribute('aria-valuemax', this.max);
    innerInput.setAttribute('aria-valuemin', this.min);
    innerInput.setAttribute('aria-valuenow', this.currentValue);
    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
  },
  updated: function updated() {
    if (!this.$refs || !this.$refs.input) return;
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('aria-valuenow', this.currentValue);
  },
  methods: {
    // 转化精度
    toPrecision: function toPrecision(num, precision) {
      if (precision === undefined) precision = this.numPrecision;
      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
    },
    // 计算精度
    getPrecision: function getPrecision(value) {
      if (value === undefined) return 0;
      var valueString = value.toString();
      var dotPosition = valueString.indexOf('.');
      var precision = 0; // 计算小数点后有几位

      if (dotPosition !== -1) {
        precision = valueString.length - dotPosition - 1;
      }

      return precision;
    },
    _increase: function _increase(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
      var precisionFactor = Math.pow(10, this.numPrecision); // Solve the accuracy problem of JS decimal calculation by converting the value to integer.

      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
    },
    _decrease: function _decrease(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
      var precisionFactor = Math.pow(10, this.numPrecision);
      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
    },
    increase: function increase() {
      if (this.inputNumberDisabled || this.maxDisabled) return;
      var value = this.value || 0;

      var newVal = this._increase(value, this.step);

      this.setCurrentValue(newVal);
    },
    decrease: function decrease() {
      if (this.inputNumberDisabled || this.minDisabled) return;
      var value = this.value || 0;

      var newVal = this._decrease(value, this.step);

      this.setCurrentValue(newVal);
    },
    handleBlur: function handleBlur(event) {
      this.userInput = null;
      this.$emit('blur', event);
    },
    handleFocus: function handleFocus(event) {
      this.$emit('focus', event);
    },
    setCurrentValue: function setCurrentValue(newVal) {
      var oldVal = this.currentValue;

      if (typeof newVal === 'number' && this.precision !== undefined) {
        newVal = this.toPrecision(newVal, this.precision);
      }

      if (newVal >= this.max) newVal = this.max;
      if (newVal <= this.min) newVal = this.min;
      if (oldVal === newVal) return; // this.userInput = null;

      this.$emit('input', newVal);
      this.$emit('change', newVal, oldVal);
      this.currentValue = newVal;
    },
    handleInput: function handleInput(value) {
      this.userInput = value;
    },
    handleInputChange: function handleInputChange(value) {
      // 如果用户什么都没有输入，默认用最小值 xx
      var newVal = value === '' ? this.min : Number(value);

      if (!isNaN(newVal) || value === '') {
        this.setCurrentValue(newVal);
      } // this.userInput = null;

    }
  }
});
// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_input_numbervue_type_script_lang_js_ = (input_numbervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue





/* normalize component */

var input_number_component = normalizeComponent(
  src_input_numbervue_type_script_lang_js_,
  input_numbervue_type_template_id_19c4dade_render,
  input_numbervue_type_template_id_19c4dade_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var input_number = (input_number_component.exports);
// CONCATENATED MODULE: ./packages/input-number/index.js


/* istanbul ignore next */

input_number.install = function (Vue) {
  Vue.component(input_number.name, input_number);
};

/* harmony default export */ var packages_input_number = (input_number);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/ip-input/src/ip-input.vue?vue&type=template&id=507361fe&
var ip_inputvue_type_template_id_507361fe_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popover',{ref:"popoverInput",attrs:{"content":_vm.tips,"max-width":_vm.tipsMaxWidth,"placement":_vm.tipsPlacement,"show-html":true,"offset-placement":_vm.tipsOffset,"value":_vm.tipsVisible,"effect":"effect","trigger":"manual","popper-class":"\n    el-popover__for-input el-popover__for-input-form\n  "}},[_c('div',{staticClass:"h-ip-input",class:{
      'is-focus': _vm.focused,
      'is-disabled': _vm.disabled
    },style:(_vm.styleObj),attrs:{"slot":"reference"},slot:"reference"},_vm._l((4),function(i){return _c('el-input',{key:i,ref:'input_' + i,refInFor:true,staticClass:"h-ip-input__verse",style:({ width: _vm.itemWidth }),attrs:{"maxlength":3,"disabled":_vm.disabled},on:{"change":function($event){return _vm.updateValue($event, i)},"focus":_vm.handleFocus,"blur":_vm.handleBlur},nativeOn:{"keyup":function($event){return _vm.onInputKeyup($event, i)},"paste":function($event){$event.preventDefault();return _vm.onPaste($event, i)}},model:{value:(_vm.ipArr[i - 1]),callback:function ($$v) {_vm.$set(_vm.ipArr, i - 1, $$v)},expression:"ipArr[i - 1]"}})}),1)])}
var ip_inputvue_type_template_id_507361fe_staticRenderFns = []


// CONCATENATED MODULE: ./packages/ip-input/src/ip-input.vue?vue&type=template&id=507361fe&

// EXTERNAL MODULE: external "core-js/modules/es.array.every.js"
var es_array_every_js_ = __webpack_require__("5225");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/ip-input/src/ip-input.vue?vue&type=script&lang=js&












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 获取当前输入框的焦点位置 by liumeng6
function getRange(el) {
  var ret = {};

  if (el.setSelectionRange) {
    ret.begin = el.selectionStart;
    ret.end = el.selectionEnd;
    ret.result = el.value.substring(ret.begin, ret.end);
  }

  el.focus();
  return ret;
}

/* harmony default export */ var ip_inputvue_type_script_lang_js_ = ({
  name: 'HIpInput',
  props: {
    value: {
      type: String,
      "default": ''
    },
    width: {
      type: String,
      "default": '100%'
    },
    itemWidth: {
      type: String,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    // 提示信息，设置了tips才能显示popover
    tips: {
      type: String,
      "default": null
    },
    // popover的最大宽度
    tipsMaxWidth: {
      type: [String, Number],
      "default": null
    },
    // popover出现的位置
    tipsPlacement: {
      type: String,
      "default": 'top'
    },
    // 出现位置的偏移量
    tipsOffset: {
      type: Number,
      "default": 0
    }
  },
  data: function data() {
    return {
      ipArr: (this.value || '').split('.'),
      tipsVisible: false,
      focused: false
    };
  },
  computed: {
    styleObj: function styleObj() {
      return {
        width: this.width
      };
    }
  },
  watch: {
    value: function value(val) {
      this.ipArr = val.split('.');
    }
  },
  methods: {
    updateValue: function updateValue(val, index) {
      var _this = this;

      this.$nextTick(function () {
        if (/^\D*$/.test(val)) {
          // 输入的内容都是非数字时，输入框置空
          val = '';
        } else {
          if (!/^\d*$/.test(val)) {
            // 去除非数字的字符
            val = parseInt(val.replace(/[^\d]/g, ''));
          } else {
            // 超过255默认显示255
            val = parseInt(val) > 255 ? 255 : parseInt(val);
          } // 当不处于第四个输入框，且当前输入框满三位时，自动获取下一个焦点


          if (index < 4 && "".concat(val).length >= 3) {
            var inputEl = _this.$el.getElementsByTagName('input')[index];

            _this._setCursorPosition(inputEl, 0);
          }
        }

        _this.ipArr.splice(index - 1, 1, val); // 如果ip都为空，则返回空字符串，如果ip不为空，则返回ip字符串


        _this.$emit('input', _this.ipArr.every(function (ip) {
          return ip === '';
        }) ? '' : _this.ipArr.join('.'));
      });
    },

    /**
     * @author liumeng6
     * @date 2017-12-11 15:50:48
     * @desc input按键监听
     */
    onInputKeyup: function onInputKeyup(event, index) {
      var keyCode = event.keyCode || event.which;
      var value = event.target.value;
      var arrIndex = index - 1; // 值在数组中的顺序 即从0开始

      var ip = this.ipArr[arrIndex]; // 处理键盘监听，8 为退格键，37 为left箭头，39 为right箭头，110 为数字键盘上的小数点，190为控制键上的小数点，229为中文数字键盘上小数点

      if (keyCode === 8 || keyCode === 37) {
        if ((value.length === 0 || getRange(event.target).end === 0) && arrIndex > 0) {
          var inputEl = this.$el.getElementsByTagName('input')[arrIndex - 1];

          this._setCursorPosition(inputEl, inputEl.value.length, event);
        }
      } else if (keyCode === 39) {
        // 按下右箭头，要光标在最后的时候才聚焦下一个
        if (getRange(event.target).end !== value.length) return;

        if (arrIndex < 3 && ip !== undefined) {
          var _inputEl = this.$el.getElementsByTagName('input')[arrIndex + 1];

          this._setCursorPosition(_inputEl, 0, event);
        }
      } else if (keyCode === 110 || keyCode === 190 || keyCode === 229 && (event.code === 'NumpadDecimal' || event.code === 'Period')) {
        if (!value.length) return; // 输入小数点或数字键盘上的句号能跳转

        if (arrIndex < 3 && ip !== undefined) {
          var _inputEl2 = this.$el.getElementsByTagName('input')[arrIndex + 1];

          this._setCursorPosition(_inputEl2, 0, event);
        }
      }
    },

    /**
     * @desc 设置输入框光标位置
     * @author chenguanbin
     * @param {Document} inputEl 设置光标的IP框
     * @param {Number} index 光标位置
     */
    _setCursorPosition: function _setCursorPosition(inputEl, index, event) {
      if (inputEl.setSelectionRange) inputEl.setSelectionRange(index, index);
      inputEl.select(); // 解决缺陷：IE浏览器下一定概率出现，IP输入框按退格键，当前一位是3位数时，无法退回到上一个输入框的问题
      // 原因：IE下先执行了键盘的退格事件，再执行前一个输入框的focus，这样会触发前一个输入框的change事件，导致焦点重新回到原输入框。（正确事件顺序：focus - 退格 - change）
      // 解决：focus事件后阻止后续事件的执行，这样就不会执行键盘的退格事件和输入框的change事件

      event && event.preventDefault();
    },

    /**
     * @author liumeng6
     * @date 2017-12-11 15:50:17
     * @desc ip粘贴事件
     */
    onPaste: function onPaste(event, index) {
      var _this2 = this;

      var arrayIndex = index - 1; // `ie`和`chrome`兼容

      var pasteText = event.clipboardData ? event.clipboardData.getData('text/plain').trim() : window.clipboardData.getData('text').trim();

      if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(pasteText)) {
        var segments = pasteText.split('.');
        segments.forEach(function (segment, i) {
          var value = Number(segment);

          if (arrayIndex + i < 4 && !isNaN(value) && value >= 0 && value <= 255) {
            _this2.ipArr.splice(arrayIndex + i, 1, value);

            _this2.$emit('input', _this2.ipArr.join('.'));
          }
        });
        this.$emit('input', this.ipArr.every(function (ip) {
          return ip === '';
        }) ? '' : this.ipArr.join('.'));
      }
    },

    /**
     * @author liumeng6
     * @date 2018-09-05 10:45:33
     * @desc 处理焦点事件
     */
    handleFocus: function handleFocus() {
      this.focused = true;

      if (this.tips) {
        this.tipsVisible = true;
      }
    },

    /**
     * @author liumeng6
     * @date 2018-09-05 11:10:06
     * @desc 处理失焦事件
     */
    handleBlur: function handleBlur() {
      this.focused = false;

      if (this.tips) {
        this.tipsVisible = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/ip-input/src/ip-input.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_ip_inputvue_type_script_lang_js_ = (ip_inputvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/ip-input/src/ip-input.vue





/* normalize component */

var ip_input_component = normalizeComponent(
  src_ip_inputvue_type_script_lang_js_,
  ip_inputvue_type_template_id_507361fe_render,
  ip_inputvue_type_template_id_507361fe_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ip_input = (ip_input_component.exports);
// CONCATENATED MODULE: ./packages/ip-input/index.js



ip_input.install = function (Vue) {
  Vue.component(ip_input.name, ip_input);
};

/* harmony default export */ var packages_ip_input = (ip_input);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=3d775734&
var radiovue_type_template_id_3d775734_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"el-radio",class:[
    _vm.radioSize ? 'el-radio--' + _vm.radioSize : '',
    { 'is-disabled': _vm.isDisabled },
    { 'is-focus': _vm.focus },
    { 'is-checked': _vm.model === _vm.label }
  ],attrs:{"aria-checked":_vm.model === _vm.label,"aria-disabled":_vm.isDisabled,"tabindex":_vm.tabIndex,"role":"radio"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.stopPropagation();$event.preventDefault();_vm.model = _vm.isDisabled ? _vm.model : _vm.label}}},[_c('span',{staticClass:"el-radio__input",class:{
      'is-disabled': _vm.isDisabled,
      'is-checked': _vm.model === _vm.label
    }},[_c('span',{staticClass:"el-radio__inner"}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],ref:"radio",staticClass:"el-radio__original",attrs:{"name":_vm.name,"disabled":_vm.isDisabled,"type":"radio","tabindex":"-1"},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false},"change":[function($event){_vm.model=_vm.label},_vm.handleChange]}})]),(_vm.icon)?_c('span',{staticClass:"el-radio__icon"},[_c('i',{class:_vm.icon})]):_vm._e(),_c('span',{staticClass:"el-radio__label"},[_vm._t("default"),(!_vm.$slots.default)?[_vm._v(" "+_vm._s(_vm.label)+" ")]:_vm._e()],2)])}
var radiovue_type_template_id_3d775734_staticRenderFns = []


// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=3d775734&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var radiovue_type_script_lang_js_ = ({
  name: 'ElRadio',
  mixins: [emitter],
  componentName: 'ElRadio',
  props: {
    value: {
      type: null,
      "default": null
    },
    label: {
      type: null,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    name: {
      type: String,
      "default": null
    },
    plain: {
      type: Boolean,
      "default": null
    },
    size: {
      type: String,
      "default": null
    },
    icon: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      focus: false,
      titleLabel: ''
    };
  },
  computed: {
    isGroup: function isGroup() {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.componentName !== 'ElRadioGroup') {
          parent = parent.$parent;
        } else {
          // this._radioGroup = parent;
          return true;
        }
      }

      return false;
    },
    model: {
      get: function get() {
        return this.isGroup ? this._radioGroup.value : this.value;
      },
      set: function set(val) {
        if (this.isGroup) {
          this.dispatch('ElRadioGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
        }

        this.$refs.radio && (this.$refs.radio.checked = this.model === this.label);
      }
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    radioSize: function radioSize() {
      var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
    },
    isDisabled: function isDisabled() {
      return this.isGroup ? this._radioGroup.disabled || this.disabled : this.disabled;
    },
    tabIndex: function tabIndex() {
      return !this.isDisabled ? this.isGroup ? this.model === this.label ? 0 : -1 : 0 : -1;
    }
  },
  created: function created() {
    if (this.$parent.$options.componentName === 'ElRadioGroup') {
      this._radioGroup = this.$parent;
    }
  },
  methods: {
    handleChange: function handleChange() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('change', _this.model);

        _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_radiovue_type_script_lang_js_ = (radiovue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/radio/src/radio.vue





/* normalize component */

var radio_component = normalizeComponent(
  src_radiovue_type_script_lang_js_,
  radiovue_type_template_id_3d775734_render,
  radiovue_type_template_id_3d775734_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_radio = (radio_component.exports);
// CONCATENATED MODULE: ./packages/radio/index.js

/* istanbul ignore next */

src_radio.install = function (Vue) {
  Vue.component('el-radio', src_radio);
};

/* harmony default export */ var packages_radio = (src_radio);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=template&id=c51cef24&
var radio_groupvue_type_template_id_c51cef24_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-radio-group"},[_vm._t("default")],2)}
var radio_groupvue_type_template_id_c51cef24_staticRenderFns = []


// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=template&id=c51cef24&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
//
//
//
//
//

/* harmony default export */ var radio_groupvue_type_script_lang_js_ = ({
  name: 'ElRadioGroup',
  componentName: 'ElRadioGroup',
  mixins: [emitter],
  props: {
    value: {
      type: null,
      "default": null
    },
    size: {
      type: String,
      "default": null
    },
    fill: {
      type: String,
      "default": null
    },
    textColor: {
      type: String,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    type: {
      type: String,
      "default": 'default'
    }
  },
  watch: {
    value: function value(_value) {
      this.$emit('change', _value);
      this.dispatch('ElFormItem', 'el.form.change', [this.value]);
    }
  }
});
// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_radio_groupvue_type_script_lang_js_ = (radio_groupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue





/* normalize component */

var radio_group_component = normalizeComponent(
  src_radio_groupvue_type_script_lang_js_,
  radio_groupvue_type_template_id_c51cef24_render,
  radio_groupvue_type_template_id_c51cef24_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var radio_group = (radio_group_component.exports);
// CONCATENATED MODULE: ./packages/radio-group/index.js


/* istanbul ignore next */

radio_group.install = function (Vue) {
  Vue.component(radio_group.name, radio_group);
};

/* harmony default export */ var packages_radio_group = (radio_group);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=template&id=557dc4ec&
var radio_buttonvue_type_template_id_557dc4ec_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"el-radio-button",class:[
    _vm.size ? 'el-radio-button--' + _vm.size : '',
    { 'is-checked': _vm.value === _vm.label },
    { 'is-disabled': _vm.isDisabled },
    { 'is-simple': _vm.isSimple }
  ]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"el-radio-button__orig-radio",attrs:{"name":_vm.name,"disabled":_vm.isDisabled,"type":"radio"},domProps:{"value":_vm.label,"checked":_vm._q(_vm.value,_vm.label)},on:{"change":function($event){_vm.value=_vm.label}}}),_c('span',{staticClass:"el-radio-button__inner",style:({ 'max-width': _vm.maxWidth + 'px' }),attrs:{"title":_vm.titleLabel},on:{"mouseover":_vm.handleMouseover}},[_vm._t("default"),(!_vm.$slots.default)?[_vm._v(" "+_vm._s(_vm.label)+" ")]:_vm._e()],2)])}
var radio_buttonvue_type_template_id_557dc4ec_staticRenderFns = []


// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=template&id=557dc4ec&

// EXTERNAL MODULE: external "core-js/modules/es.array.fill.js"
var es_array_fill_js_ = __webpack_require__("d096");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var radio_buttonvue_type_script_lang_js_ = ({
  name: 'ElRadioButton',
  props: {
    maxWidth: {
      type: Number,
      "default": 192
    },
    label: {
      type: null,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    name: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      titleLabel: '',
      isIE: false
    };
  },
  computed: {
    isSimple: function isSimple() {
      return this._radioGroup.type === 'simple';
    },
    value: {
      get: function get() {
        return this._radioGroup.value;
      },
      set: function set(value) {
        this._radioGroup.$emit('input', value);
      }
    },
    _radioGroup: function _radioGroup() {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.componentName !== 'ElRadioGroup') {
          parent = parent.$parent;
        } else {
          return parent;
        }
      }

      return false;
    },
    activeStyle: function activeStyle() {
      return {
        backgroundColor: this._radioGroup.fill || '',
        borderColor: this._radioGroup.fill || '',
        boxShadow: this._radioGroup.fill ? "-1px 0 0 0 ".concat(this._radioGroup.fill) : '',
        color: this._radioGroup.textColor || ''
      };
    },
    size: function size() {
      return this._radioGroup.size;
    },
    isDisabled: function isDisabled() {
      return this.disabled || this._radioGroup.disabled;
    }
  },
  mounted: function mounted() {
    // ie兼容
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      this.isIE = true;
    }
  },
  methods: {
    handleMouseover: function handleMouseover(e) {
      var t = e.target;

      if (t.tagName === 'SPAN') {
        if (t.scrollWidth > t.clientWidth || this.isIE) {
          this.titleLabel = t.innerText;
        } else {
          this.titleLabel = '';
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_radio_buttonvue_type_script_lang_js_ = (radio_buttonvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue





/* normalize component */

var radio_button_component = normalizeComponent(
  src_radio_buttonvue_type_script_lang_js_,
  radio_buttonvue_type_template_id_557dc4ec_render,
  radio_buttonvue_type_template_id_557dc4ec_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var radio_button = (radio_button_component.exports);
// CONCATENATED MODULE: ./packages/radio-button/index.js


/* istanbul ignore next */

radio_button.install = function (Vue) {
  Vue.component(radio_button.name, radio_button);
};

/* harmony default export */ var packages_radio_button = (radio_button);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=fb482068&
var checkbox_buttonvue_type_template_id_fb482068_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"el-checkbox-button",class:[
    _vm.size ? 'el-checkbox-button--' + _vm.size : '',
    { 'is-disabled': _vm.isDisabled },
    { 'is-checked': _vm.isChecked },
    { 'is-focus': _vm.focus },
    { 'is-simple': _vm.isSimple }
  ],attrs:{"aria-checked":_vm.isChecked,"aria-disabled":_vm.isDisabled,"role":"checkbox"}},[(_vm.trueLabel || _vm.falseLabel)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"el-checkbox-button__orig-checkbox",attrs:{"name":_vm.name,"disabled":_vm.isDisabled,"true-value":_vm.trueLabel,"false-value":_vm.falseLabel,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:_vm._q(_vm.model,_vm.trueLabel)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(_vm.trueLabel):(_vm.falseLabel);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.handleChange],"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"el-checkbox-button__orig-checkbox",attrs:{"name":_vm.name,"disabled":_vm.isDisabled,"type":"checkbox"},domProps:{"value":_vm.label,"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.label)>-1:(_vm.model)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.label,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.handleChange],"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}}),(_vm.$slots.default || _vm.label)?_c('span',{staticClass:"el-checkbox-button__inner",style:(_vm.isChecked ? _vm.activeStyle : null)},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2):_vm._e()])}
var checkbox_buttonvue_type_template_id_fb482068_staticRenderFns = []


// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=fb482068&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var checkbox_buttonvue_type_script_lang_js_ = ({
  name: 'ElCheckboxButton',
  mixins: [emitter],
  inject: {
    elForm: {
      "default": ''
    },
    elFormItem: {
      "default": ''
    }
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      "default": undefined
    },
    label: {
      type: [String, Number, Boolean],
      "default": undefined
    },
    disabled: {
      type: Boolean,
      "default": null
    },
    checked: {
      type: Boolean,
      "default": null
    },
    name: {
      type: String,
      "default": undefined
    },
    trueLabel: {
      type: [String, Number],
      "default": undefined
    },
    falseLabel: {
      type: [String, Number],
      "default": undefined
    }
  },
  data: function data() {
    return {
      selfModel: false,
      focus: false,
      isLimitExceeded: false
    };
  },
  computed: {
    isSimple: function isSimple() {
      return this._checkboxGroup.type === 'simple';
    },
    model: {
      get: function get() {
        return this._checkboxGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
      },
      set: function set(val) {
        if (this._checkboxGroup) {
          this.isLimitExceeded = false;
          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
        } else if (this.value !== undefined) {
          this.$emit('input', val);
        } else {
          this.selfModel = val;
        }
      }
    },
    isChecked: function isChecked() {
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.model;
      } else if (Array.isArray(this.model)) {
        return this.model.indexOf(this.label) > -1;
      } else if (this.model !== null && this.model !== undefined) {
        return this.model === this.trueLabel;
      }

      return false;
    },
    _checkboxGroup: function _checkboxGroup() {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.componentName !== 'ElCheckboxGroup') {
          parent = parent.$parent;
        } else {
          return parent;
        }
      }

      return false;
    },
    store: function store() {
      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
    },
    activeStyle: function activeStyle() {
      return {
        backgroundColor: this._checkboxGroup.fill || '',
        borderColor: this._checkboxGroup.fill || '',
        color: this._checkboxGroup.textColor || '',
        'box-shadow': '-1px 0 0 0 ' + this._checkboxGroup.fill
      };
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    size: function size() {
      return this._checkboxGroup.checkboxGroupSize || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    isDisabled: function isDisabled() {
      return this._checkboxGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
    }
  },
  created: function created() {
    this.checked && this.addToStore();
  },
  methods: {
    addToStore: function addToStore() {
      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
        this.model.push(this.label);
      } else {
        this.model = this.trueLabel || true;
      }
    },
    handleChange: function handleChange(ev) {
      var _this = this;

      if (this.isLimitExceeded) return;
      var value;

      if (ev.target.checked) {
        value = this.trueLabel === undefined ? true : this.trueLabel;
      } else {
        value = this.falseLabel === undefined ? false : this.falseLabel;
      }

      this.$emit('change', value, ev);
      this.$nextTick(function () {
        if (_this._checkboxGroup) {
          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_checkbox_buttonvue_type_script_lang_js_ = (checkbox_buttonvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue





/* normalize component */

var checkbox_button_component = normalizeComponent(
  src_checkbox_buttonvue_type_script_lang_js_,
  checkbox_buttonvue_type_template_id_fb482068_render,
  checkbox_buttonvue_type_template_id_fb482068_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var checkbox_button = (checkbox_button_component.exports);
// CONCATENATED MODULE: ./packages/checkbox-button/index.js


/* istanbul ignore next */

checkbox_button.install = function (Vue) {
  Vue.component(checkbox_button.name, checkbox_button);
};

/* harmony default export */ var packages_checkbox_button = (checkbox_button);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=20b7d66c&
var checkbox_groupvue_type_template_id_20b7d66c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-checkbox-group",class:{ 'el-checkbox-group--vertical': _vm.vertical },attrs:{"role":"group","aria-label":"checkbox-group"}},[_vm._t("default")],2)}
var checkbox_groupvue_type_template_id_20b7d66c_staticRenderFns = []


// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=20b7d66c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&


/* harmony default export */ var checkbox_groupvue_type_script_lang_js_ = ({
  name: 'ElCheckboxGroup',
  componentName: 'ElCheckboxGroup',
  mixins: [emitter],
  inject: {
    elFormItem: {
      "default": ''
    }
  },
  props: {
    value: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      "default": null
    },
    min: {
      type: Number,
      "default": 0
    },
    max: {
      type: Number,
      "default": Infinity
    },
    size: {
      type: String,
      "default": 'medium'
    },
    fill: {
      type: String,
      "default": undefined
    },
    textColor: {
      type: String,
      "default": undefined
    },
    type: {
      type: String,
      "default": 'default'
    },
    vertical: {
      type: Boolean,
      "default": false
    }
  },
  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    checkboxGroupSize: function checkboxGroupSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    }
  },
  watch: {
    value: function value(_value) {
      this.dispatch('ElFormItem', 'el.form.change', [_value]);
    }
  }
});
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_checkbox_groupvue_type_script_lang_js_ = (checkbox_groupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue





/* normalize component */

var checkbox_group_component = normalizeComponent(
  src_checkbox_groupvue_type_script_lang_js_,
  checkbox_groupvue_type_template_id_20b7d66c_render,
  checkbox_groupvue_type_template_id_20b7d66c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var checkbox_group = (checkbox_group_component.exports);
// CONCATENATED MODULE: ./packages/checkbox-group/index.js


/* istanbul ignore next */

checkbox_group.install = function (Vue) {
  Vue.component(checkbox_group.name, checkbox_group);
};

/* harmony default export */ var packages_checkbox_group = (checkbox_group);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=template&id=0e65da72&
var componentvue_type_template_id_0e65da72_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"el-switch",class:[
    _vm.size ? 'el-switch--' + _vm.size : '',
    {
      'is-disabled': _vm.disabled,
      'is-checked': _vm.checked
    }
  ]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.disabled),expression:"disabled"}],staticClass:"el-switch__mask"}),_c('div',{staticClass:"el-switch__label el-switch__label--left",class:[!_vm.checked ? 'is-active' : '']},[(_vm.inactiveIconClass)?_c('i',{class:[_vm.inactiveIconClass]}):_vm._e(),(_vm.inactiveText)?_c('span',[_vm._v(" "+_vm._s(_vm.inactiveText)+" ")]):_vm._e()]),_c('input',{ref:"input",staticClass:"el-switch__input",class:{ 'allow-focus': _vm.allowFocus },attrs:{"name":_vm.name,"true-value":_vm.activeValue,"false-value":_vm.inactiveValue,"disabled":_vm.disabled,"type":"checkbox"},on:{"change":_vm.handleChange,"focus":_vm.handleFocus,"blur":_vm.handleBlur}}),_c('span',{ref:"core",staticClass:"el-switch__core",style:({ width: _vm.coreWidth + 'px' }),on:{"click":_vm.setFocus}},[_c('span',{staticClass:"el-switch__button",style:({ transform: _vm.transform })})]),_c('div',{staticClass:"el-switch__label el-switch__label--right",class:[_vm.checked ? 'is-active' : '']},[(_vm.activeIconClass)?_c('i',{class:[_vm.activeIconClass]}):_vm._e(),(_vm.activeText)?_c('span',[_vm._v(" "+_vm._s(_vm.activeText)+" ")]):_vm._e()]),(_vm.instruction)?_c('span',{staticClass:"el-switch__instruction"},[_vm._v(" "+_vm._s(_vm.instruction)+" ")]):_vm._e()])}
var componentvue_type_template_id_0e65da72_staticRenderFns = []


// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=template&id=0e65da72&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var switch_src_componentvue_type_script_lang_js_ = ({
  name: 'ElSwitch',
  props: {
    value: {
      type: [Boolean, String, Number],
      "default": false
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    width: {
      type: Number,
      "default": 0
    },
    activeText: {
      type: String,
      "default": ''
    },
    inactiveText: {
      type: String,
      "default": ''
    },
    activeIconClass: {
      type: String,
      "default": ''
    },
    inactiveIconClass: {
      type: String,
      "default": ''
    },
    size: {
      type: String,
      "default": 'medium'
    },
    instruction: {
      type: String,
      "default": null
    },
    activeColor: {
      type: String,
      "default": ''
    },
    inactiveColor: {
      type: String,
      "default": ''
    },
    activeValue: {
      type: [Boolean, String, Number],
      "default": true
    },
    inactiveValue: {
      type: [Boolean, String, Number],
      "default": false
    },
    name: {
      type: String,
      "default": ''
    },
    allowFocus: {
      type: Boolean,
      "default": false
    },
    beforeChange: {
      type: Function,
      "default": null
    }
  },
  data: function data() {
    return {
      coreWidth: this.width
    };
  },
  computed: {
    checked: function checked() {
      return this.value === this.activeValue;
    },
    transform: function transform() {
      if (this.size === 'small') {
        return this.checked ? "translate(".concat(this.coreWidth - 18, "px, 1px)") : 'translate(2px, 1px)';
      } else if (this.size === 'mini') {
        return this.checked ? "translate(".concat(this.coreWidth - 14, "px, 1px)") : 'translate(2px, 1px)';
      }

      return this.checked ? "translate(".concat(this.coreWidth - 22, "px, 1px)") : 'translate(2px, 1px)';
    }
  },
  watch: {
    checked: function checked() {
      this.$refs.input.checked = this.checked;

      if (this.activeColor || this.inactiveColor) {
        this.setBackgroundColor();
      }
    }
  },
  created: function created() {
    if (!~[this.activeValue, this.inactiveValue].indexOf(this.value)) {
      this.$emit('input', this.inactiveValue);
    }
  },
  mounted: function mounted() {
    /* istanbul ignore if */
    if (this.width === 0) {
      this.coreWidth = 48;

      if (this.size === 'medium') {
        this.coreWidth = 48;
      } else if (this.size === 'small') {
        this.coreWidth = 40;
      } else if (this.size === 'mini') {
        this.coreWidth = 32;
      }
    }

    if (this.activeColor || this.inactiveColor) {
      this.setBackgroundColor();
    }

    this.$refs.input.checked = this.checked;
  },
  methods: {
    handleChange: function handleChange() {
      var _this = this;

      // 判断是否存在beforeChange
      if (this.beforeChange) {
        this.beforeChange(this.checked ? this.activeValue : this.inactiveValue, function () {
          _this.change();
        });
      } else {
        this.change();
      }
    },
    change: function change() {
      var _this2 = this;

      this.$emit('input', !this.checked ? this.activeValue : this.inactiveValue);
      this.$emit('change', !this.checked ? this.activeValue : this.inactiveValue);
      this.$nextTick(function () {
        // set input's checked property
        // in case parent refuses to change component's value
        _this2.$refs.input.checked = _this2.checked;
      });
    },
    setBackgroundColor: function setBackgroundColor() {
      var newColor = this.checked ? this.activeColor : this.inactiveColor;
      this.$refs.core.style.borderColor = newColor;
      this.$refs.core.style.backgroundColor = newColor;
    },
    setFocus: function setFocus() {
      // set focus on input
      if (this.allowFocus) {
        this.$refs.input.focus();
      }
    },
    handleBlur: function handleBlur(event) {
      if (this.allowFocus) {
        this.$emit('blur', event);
      }
    },
    handleFocus: function handleFocus(event) {
      if (this.allowFocus) {
        this.$emit('focus', event);
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_switch_src_componentvue_type_script_lang_js_ = (switch_src_componentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/switch/src/component.vue





/* normalize component */

var src_component_component = normalizeComponent(
  packages_switch_src_componentvue_type_script_lang_js_,
  componentvue_type_template_id_0e65da72_render,
  componentvue_type_template_id_0e65da72_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var switch_src_component = (src_component_component.exports);
// CONCATENATED MODULE: ./packages/switch/index.js


/* istanbul ignore next */

switch_src_component.install = function (Vue) {
  Vue.component(switch_src_component.name, switch_src_component);
};

/* harmony default export */ var packages_switch = (switch_src_component);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=template&id=1ed2d12f&
var option_groupvue_type_template_id_1ed2d12f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"el-select-group__wrap"},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-select-group__title"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('li',[_c('ul',{staticClass:"el-select-group"},[_vm._t("default")],2)])])}
var option_groupvue_type_template_id_1ed2d12f_staticRenderFns = []


// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=template&id=1ed2d12f&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var option_groupvue_type_script_lang_js_ = ({
  name: 'ElOptionGroup',
  mixins: [emitter],
  componentName: 'ElOptionGroup',
  props: {
    label: {
      type: String,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      visible: true
    };
  },
  watch: {
    disabled: function disabled(val) {
      this.broadcast('ElOption', 'handleGroupDisabled', val);
    }
  },
  created: function created() {
    this.$on('queryChange', this.queryChange);
  },
  mounted: function mounted() {
    if (this.disabled) {
      this.broadcast('ElOption', 'handleGroupDisabled', this.disabled);
    }
  },
  methods: {
    queryChange: function queryChange() {
      this.visible = this.$children && Array.isArray(this.$children) && this.$children.some(function (option) {
        return option.visible === true;
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_option_groupvue_type_script_lang_js_ = (option_groupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/select/src/option-group.vue





/* normalize component */

var option_group_component = normalizeComponent(
  src_option_groupvue_type_script_lang_js_,
  option_groupvue_type_template_id_1ed2d12f_render,
  option_groupvue_type_template_id_1ed2d12f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var option_group = (option_group_component.exports);
// CONCATENATED MODULE: ./packages/option-group/index.js


/* istanbul ignore next */

option_group.install = function (Vue) {
  Vue.component(option_group.name, option_group);
};

/* harmony default export */ var packages_option_group = (option_group);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=template&id=213d02c1&
var tablevue_type_template_id_213d02c1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-table",class:{
    'el-table--fit': _vm.fit,
    'el-table--striped': _vm.stripe,
    'el-table--border': _vm.border,
    'el-table--group': _vm.isGroup,
    'el-table--fluid-height': _vm.maxHeight,
    'el-table--enable-row-hover': !_vm.store.states.isComplex,
    'el-table--enable-row-transition':
      (_vm.store.states.data || []).length !== 0 &&
      (_vm.store.states.data || []).length < 100
  },on:{"mouseleave":function($event){return _vm.handleMouseLeave($event)}}},[_c('div',{ref:"hiddenColumns",staticClass:"hidden-columns"},[_vm._t("default")],2),(_vm.showHeader)?_c('div',{ref:"headerWrapper",staticClass:"el-table__header-wrapper"},[_c('table-header',{style:({ width: _vm.bodyWidth }),attrs:{"store":_vm.store,"default-sort":_vm.defaultSort}})],1):_vm._e(),_c('div',{ref:"bodyWrapper",staticClass:"el-table__body-wrapper",style:([_vm.bodyHeight])},[(_vm.isShowScrollbar)?_c('el-scrollbar',{ref:"tableScrollbar",attrs:{"overflow":_vm.alwaysShowBar || _vm.isFixBarScrollShow ? 'scroll' : 'auto',"overflow-x":_vm.niceScroll === 'vertical' ? 'hidden' : 'auto',"wrap-class":"el-table-scrollbar__wrap","view-class":"el-table-scrollbar__view","wrap-style":_vm.wrapStyle,"view-style":[{ width: _vm.bodyWidth }]},on:{"on-scrolling-x":_vm.onScrollingX,"on-scrolling-y":_vm.onScrollingY}},[_c('table-body',{style:({ width: _vm.bodyWidth }),attrs:{"context":_vm.context,"store":_vm.store,"stripe":_vm.stripe,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle,"highlight":_vm.highlightCurrentRow}}),(_vm.isShowEmptyText)?_c('div',{staticClass:"el-table__empty-block",style:({ width: _vm.bodyWidth })},[_c('span',{staticClass:"el-table__empty-text"},[_vm._t("empty",[_vm._v(" "+_vm._s(_vm.emptyText || _vm.t('el.table.emptyText'))+" ")])],2)]):_vm._e()],1):[_c('table-body',{style:({ width: _vm.bodyWidth }),attrs:{"context":_vm.context,"store":_vm.store,"stripe":_vm.stripe,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle,"highlight":_vm.highlightCurrentRow}}),(_vm.isShowEmptyText)?_c('div',{staticClass:"el-table__empty-block",style:({ width: _vm.bodyWidth })},[_c('span',{staticClass:"el-table__empty-text"},[_vm._t("empty",[_vm._v(" "+_vm._s(_vm.emptyText || _vm.t('el.table.emptyText'))+" ")])],2)]):_vm._e()],(_vm.isShowLoading)?_vm._t("loading",[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isShowLoading),expression:"isShowLoading"}],staticClass:"el-table__loading"})]):_vm._e()],2),(_vm.showSummary)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data && _vm.data.length > 0),expression:"data && data.length > 0"}],ref:"footerWrapper",staticClass:"el-table__footer-wrapper"},[_c('table-footer',{style:({ width: _vm.bodyWidth }),attrs:{"store":_vm.store,"border":_vm.border,"sum-text":_vm.sumText || _vm.t('el.table.sumText'),"summary-method":_vm.summaryMethod,"default-sort":_vm.defaultSort}})],1):_vm._e(),(_vm.fixedColumns.length > 0)?_c('div',{ref:"fixedWrapper",staticClass:"el-table__fixed",style:([{ width: _vm.fixedWidth }, _vm.fixedHeight]),on:{"mouseenter":function($event){$event.stopPropagation();_vm.isFixBarScrollShow = true},"mouseleave":function($event){$event.stopPropagation();_vm.isFixBarScrollShow = false}}},[(_vm.showHeader)?_c('div',{ref:"fixedHeaderWrapper",staticClass:"el-table__fixed-header-wrapper"},[_c('table-header',{style:({ width: _vm.fixedWidth }),attrs:{"store":_vm.store,"fixed":"left"}})],1):_vm._e(),_c('div',{ref:"fixedBodyWrapper",staticClass:"el-table__fixed-body-wrapper",style:([_vm.fixedBodyHeight])},[_c('table-body',{style:({ width: _vm.fixedWidth }),attrs:{"store":_vm.store,"stripe":_vm.stripe,"highlight":_vm.highlightCurrentRow,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle,"fixed":"left"}})],1),(_vm.showSummary)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data && _vm.data.length > 0),expression:"data && data.length > 0"}],ref:"fixedFooterWrapper",staticClass:"el-table__fixed-footer-wrapper"},[_c('table-footer',{style:({ width: _vm.fixedWidth }),attrs:{"border":_vm.border,"sum-text":_vm.sumText || _vm.t('el.table.sumText'),"summary-method":_vm.summaryMethod,"store":_vm.store,"fixed":"left"}})],1):_vm._e()]):_vm._e(),(_vm.fixedColumns.length > 0)?_c('div',{staticClass:"el-table__fixed-box-shadow el-table__fixed-box-shadow-left",style:([
      {
        width: _vm.fixedWidth,
        height: _vm.fixedShadowHeight
      }
    ])}):_vm._e(),(_vm.rightFixedColumns.length > 0)?_c('div',{ref:"rightFixedWrapper",staticClass:"el-table__fixed-right",style:([
      { width: _vm.rightFixedWidth },
      {
        right: _vm.border ? _vm.layout.gutterWidth : (_vm.layout.gutterWidth || 1) + 'px'
      },
      _vm.fixedHeight
    ]),on:{"mouseenter":function($event){$event.stopPropagation();_vm.isFixBarScrollShow = true},"mouseleave":function($event){$event.stopPropagation();_vm.isFixBarScrollShow = false}}},[(_vm.showHeader)?_c('div',{ref:"rightFixedHeaderWrapper",staticClass:"el-table__fixed-header-wrapper"},[_c('table-header',{style:({ width: _vm.rightFixedWidth }),attrs:{"store":_vm.store,"fixed":"right"}})],1):_vm._e(),_c('div',{ref:"rightFixedBodyWrapper",staticClass:"el-table__fixed-body-wrapper",style:([_vm.fixedBodyHeight])},[_c('table-body',{style:({ width: _vm.rightFixedWidth }),attrs:{"store":_vm.store,"stripe":_vm.stripe,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle,"highlight":_vm.highlightCurrentRow,"fixed":"right"}})],1),(_vm.showSummary)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data && _vm.data.length > 0),expression:"data && data.length > 0"}],ref:"rightFixedFooterWrapper",staticClass:"el-table__fixed-footer-wrapper"},[_c('table-footer',{style:({ width: _vm.rightFixedWidth }),attrs:{"border":_vm.border,"sum-text":_vm.sumText || _vm.t('el.table.sumText'),"summary-method":_vm.summaryMethod,"store":_vm.store,"fixed":"right"}})],1):_vm._e()]):_vm._e(),(_vm.rightFixedColumns.length > 0)?_c('div',{staticClass:"el-table__fixed-box-shadow el-table__fixed-box-shadow-right",style:([
      {
        width: _vm.rightFixedWidth,
        height: _vm.fixedShadowHeight
      }
    ])}):_vm._e(),(_vm.rightFixedColumns.length > 0)?_c('div',{staticClass:"el-table__fixed-right-patch",style:({ width: '0', height: _vm.layout.headerHeight + 'px' })}):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resizeProxyVisible),expression:"resizeProxyVisible"}],ref:"resizeProxy",staticClass:"el-table__column-resize-proxy"})])}
var tablevue_type_template_id_213d02c1_staticRenderFns = []


// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=template&id=213d02c1&

// EXTERNAL MODULE: external "@babel/runtime/helpers/esm/arrayWithoutHoles"
var arrayWithoutHoles_ = __webpack_require__("3732");
var arrayWithoutHoles_default = /*#__PURE__*/__webpack_require__.n(arrayWithoutHoles_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/esm/iterableToArray"
var iterableToArray_ = __webpack_require__("f906");
var iterableToArray_default = /*#__PURE__*/__webpack_require__.n(iterableToArray_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/esm/nonIterableSpread"
var nonIterableSpread_ = __webpack_require__("efd2");
var nonIterableSpread_default = /*#__PURE__*/__webpack_require__.n(nonIterableSpread_);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return arrayWithoutHoles_default()(arr) || iterableToArray_default()(arr) || unsupportedIterableToArray_default()(arr) || nonIterableSpread_default()();
}
// EXTERNAL MODULE: external "core-js/modules/es.set.js"
var es_set_js_ = __webpack_require__("8535");

// EXTERNAL MODULE: external "core-js/modules/es.string.fixed.js"
var es_string_fixed_js_ = __webpack_require__("7df0");

// EXTERNAL MODULE: external "core-js/modules/es.array.sort.js"
var es_array_sort_js_ = __webpack_require__("4c07");

// EXTERNAL MODULE: external "core-js/modules/es.string.match.js"
var es_string_match_js_ = __webpack_require__("c74c");

// CONCATENATED MODULE: ./packages/table/src/util.js










var getCell = function getCell(event) {
  var cell = event.target;

  while (cell && cell.tagName.toUpperCase() !== 'HTML') {
    if (cell.tagName.toUpperCase() === 'TD') {
      return cell;
    }

    cell = cell.parentNode;
  }

  return null;
};

var util_isObject = function isObject(obj) {
  return obj !== null && _typeof(obj) === 'object';
};

var util_orderBy = function orderBy(array, sortKey, reverse, sortMethod, defaultSortMethod) {
  if (typeof reverse === 'string') {
    reverse = reverse === 'descending' ? -1 : 1;
  }

  if (!sortKey && !sortMethod) {
    return array;
  }

  var order = reverse && reverse < 0 ? -1 : 1; // sort on a copy to avoid mutating original array

  return array.slice().sort(sortMethod ? function (a, b) {
    return sortMethod(a, b) ? order : -order;
  } : function (a, b) {
    if (sortKey !== '$key') {
      if (util_isObject(a) && '$value' in a) a = a.$value;
      if (util_isObject(b) && '$value' in b) b = b.$value;
    }

    a = util_isObject(a) ? getValueByPath(a, sortKey) : a;
    b = util_isObject(b) ? getValueByPath(b, sortKey) : b;
    if (!defaultSortMethod) return a === b ? 0 : a > b ? order : -order;
    return defaultSortMethod(a, b) ? order : -order;
  });
};
var getColumnById = function getColumnById(table, columnId) {
  var column = null;
  (table.columns || []).forEach(function (item) {
    if (item.id === columnId) {
      column = item;
    }
  });
  return column;
};
var getColumnByCell = function getColumnByCell(table, cell) {
  var matches = (cell.className || '').match(/el-table_[^\s]+/gm);

  if (matches) {
    return getColumnById(table, matches[0]);
  }

  return null;
};
var isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
var mousewheel = function mousewheel(element, callback) {
  if (element && element.addEventListener) {
    element.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', callback);
  }
};
var normalizeWheel = function normalizeWheel(event) {
  // Reasonable defaults
  var PIXEL_STEP = 10;
  var LINE_HEIGHT = 40;
  var PAGE_HEIGHT = 800; // spinX, spinY, pixelX, pixelY

  var sX = 0;
  var sY = 0;
  var pX = 0;
  var pY = 0; // Legacy

  if ('detail' in event) {
    sY = event.detail;
  }

  if ('wheelDelta' in event) {
    sY = -event.wheelDelta / 120;
  }

  if ('wheelDeltaY' in event) {
    sY = -event.wheelDeltaY / 120;
  }

  if ('wheelDeltaX' in event) {
    sX = -event.wheelDeltaX / 120;
  } // side scrolling on FF with DOMMouseScroll


  if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
    sX = sY;
    sY = 0;
  }

  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;

  if ('deltaY' in event) {
    pY = event.deltaY;
  }

  if ('deltaX' in event) {
    pX = event.deltaX;
  }

  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode === 1) {
      // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {
      // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  } // Fall-back if spin cannot be determined


  if (pX && !sX) {
    sX = pX < 1 ? -1 : 1;
  }

  if (pY && !sY) {
    sY = pY < 1 ? -1 : 1;
  }

  return {
    spinX: sX,
    spinY: sY,
    pixelX: pX,
    pixelY: pY
  };
};
var getRowIdentity = function getRowIdentity(row, rowKey) {
  if (!row) throw new Error('row is required when get row identity');

  if (typeof rowKey === 'string') {
    if (rowKey.indexOf('.') < 0) {
      return row[rowKey];
    }

    var key = rowKey.split('.');
    var current = row;

    for (var i = 0; i < key.length; i++) {
      current = current[key[i]];
    }

    return current;
  } else if (typeof rowKey === 'function') {
    return rowKey(row);
  }
};
// CONCATENATED MODULE: ./packages/table/src/table-store.js






















var table_store_sortData = function sortData(data, states) {
  var sortingColumn = states.sortingColumn;

  if (!sortingColumn || typeof sortingColumn.sortable === 'string') {
    return data;
  }

  return util_orderBy(data, states.sortProp, states.sortOrder, sortingColumn.sortMethod, states.defaultSortMethod);
};

var table_store_getKeysMap = function getKeysMap(array, rowKey) {
  var arrayMap = {};
  (array || []).forEach(function (row, index) {
    arrayMap[getRowIdentity(row, rowKey)] = {
      row: row,
      index: index
    };
  });
  return arrayMap;
};

var toggleRowSelection = function toggleRowSelection(states, row, selected) {
  var changed = false;
  var selection = states.selection;
  var index = selection.indexOf(row);

  if (typeof selected === 'undefined') {
    if (index === -1) {
      selection.push(row);
      changed = true;
    } else {
      selection.splice(index, 1);
      changed = true;
    }
  } else {
    if (selected && index === -1) {
      selection.push(row);
      changed = true;
    } else if (!selected && index > -1) {
      selection.splice(index, 1);
      changed = true;
    }
  }

  return changed;
};

var toggleRowExpanded = function toggleRowExpanded(states, row, expanded) {
  var changed = false;
  var expandRows = states.expandRows;

  if (typeof expanded !== 'undefined') {
    var index = expandRows.indexOf(row);

    if (expanded) {
      if (index === -1) {
        expandRows.push(row);
        changed = true;
      }
    } else {
      if (index !== -1) {
        expandRows.splice(index, 1);
        changed = true;
      }
    }
  } else {
    var _index = expandRows.indexOf(row);

    if (_index === -1) {
      expandRows.push(row);
      changed = true;
    } else {
      expandRows.splice(_index, 1);
      changed = true;
    }
  }

  return changed;
};

var table_store_TableStore = function TableStore(table) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!table) {
    throw new Error('Table is required.');
  }

  this.table = table;
  this.states = {
    rowKey: null,
    _columns: [],
    originColumns: [],
    columns: [],
    fixedColumns: [],
    rightFixedColumns: [],
    fixedLeafColumns: [],
    rightFixedLeafColumns: [],
    isComplex: false,
    _data: null,
    filteredData: null,
    data: null,
    sortingColumn: null,
    sortProp: null,
    sortOrder: null,
    isAllSelected: false,
    selection: [],
    reserveSelection: false,
    selectable: null,
    currentRow: null,
    hoverRow: null,
    filters: {},
    expandRows: [],
    defaultExpandAll: false,
    defaultSortMethod: null,
    rowsHeight: [],
    rowHeight: 36
  };

  for (var prop in initialState) {
    if (hasOwn(initialState, prop) && hasOwn(this.states, prop)) {
      this.states[prop] = initialState[prop];
    }
  }
};

table_store_TableStore.prototype.mutations = {
  setData: function setData(states, data) {
    var _this = this;

    var dataInstanceChanged = states._data !== data;
    states._data = data;
    Object.keys(states.filters).forEach(function (columnId) {
      var values = states.filters[columnId];
      if (!values || values.length === 0) return;
      var column = getColumnById(_this.states, columnId);

      if (column && column.filterMethod) {
        data = data.filter(function (row) {
          return values.some(function (value) {
            return column.filterMethod.call(null, value, row);
          });
        });
      }
    });
    states.filteredData = data;
    states.data = table_store_sortData(data || [], states); // states.data.forEach((item) => {
    //   if (!item.$extra) {
    //     Object.defineProperty(item, '$extra', {
    //       value: {},
    //       enumerable: false
    //     });
    //   }
    // });

    this.updateCurrentRow();

    if (!states.reserveSelection) {
      if (dataInstanceChanged) {
        this.clearSelection();
      } else {
        this.cleanSelection();
      }

      this.updateAllSelected();
    } else {
      var rowKey = states.rowKey;

      if (rowKey) {
        var selection = states.selection;
        var selectedMap = table_store_getKeysMap(selection, rowKey);
        states.data.forEach(function (row) {
          var rowId = getRowIdentity(row, rowKey);
          var rowInfo = selectedMap[rowId];

          if (rowInfo) {
            selection[rowInfo.index] = row;
          }
        });
        this.updateAllSelected();
      } else {
         false && false;
      }
    }

    var defaultExpandAll = states.defaultExpandAll;

    if (defaultExpandAll) {
      this.states.expandRows = (states.data || []).slice(0);
    }

    this.getTableRowsHeight();
  },
  changeSortCondition: function changeSortCondition(states) {
    states.data = table_store_sortData(states.filteredData || states._data || [], states);
    this.table.$emit('sort-change', {
      column: this.states.sortingColumn,
      prop: this.states.sortProp,
      order: this.states.sortOrder
    }); // Vue.nextTick(() => this.table.updateScrollY());
  },
  filterChange: function filterChange(states, options) {
    var _this2 = this;

    var column = options.column,
        silent = options.silent;
    var values = options.values;

    if (values && !Array.isArray(values)) {
      values = [values];
    }

    var prop = column.property;
    var filters = {};

    if (prop) {
      states.filters[column.id] = values;
      filters[column.columnKey || column.id] = values;
    }

    var data = states._data;
    Object.keys(states.filters).forEach(function (columnId) {
      var values = states.filters[columnId];
      if (!values || values.length === 0) return;
      var column = getColumnById(_this2.states, columnId);

      if (column && column.filterMethod) {
        data = data.filter(function (row) {
          return values.some(function (value) {
            return column.filterMethod.call(null, value, row, column);
          });
        });
      }
    });
    states.filteredData = data;
    states.data = table_store_sortData(data, states);

    if (!silent) {
      this.table.$emit('filter-change', filters);
    }
  },
  insertColumn: function insertColumn(states, column, index, parent) {
    var array = states._columns;

    if (parent) {
      array = parent.children;
      if (!array) array = parent.children = [];
    }

    if (typeof index !== 'undefined') {
      array.splice(index, 0, column);
    } else {
      array.push(column);
    }

    if (column.type === 'selection') {
      states.selectable = column.selectable;
      states.reserveSelection = column.reserveSelection;
    }

    if (this.table.$ready) {
      this.updateColumns(); // hack for dynamics insert column

      this.scheduleLayout();
    }
  },
  removeColumn: function removeColumn(states, column, parent) {
    var array = states._columns;

    if (parent) {
      array = parent.children;
      if (!array) array = parent.children = [];
    }

    if (array) {
      array.splice(array.indexOf(column), 1);
    }

    if (this.table.$ready) {
      this.updateColumns(); // hack for dynamics remove column

      this.scheduleLayout();
    }
  },
  setHoverRow: function setHoverRow(states, row) {
    states.hoverRow = row;
  },
  setCurrentRow: function setCurrentRow(states, row) {
    var oldCurrentRow = states.currentRow;
    states.currentRow = row;

    if (oldCurrentRow !== row) {
      this.table.$emit('current-change', row, oldCurrentRow);
    }
  },
  rowSelectedChanged: function rowSelectedChanged(states, row) {
    var changed = toggleRowSelection(states, row);
    var selection = states.selection;

    if (changed) {
      var table = this.table;
      table.$emit('selection-change', selection);
      var isCurrentSelect = selection.indexOf(row) !== -1;
      table.$emit('select', selection, row, isCurrentSelect);
    }

    this.updateAllSelected();
  },
  toggleAllSelection: debounce_default()(10, function (states) {
    var data = states.data || [];
    var value = !states.isAllSelected;
    var selection = this.states.selection;
    var selectionChanged = false;
    data.forEach(function (item, index) {
      if (states.selectable) {
        if (states.selectable.call(null, item, index) && toggleRowSelection(states, item, value)) {
          selectionChanged = true;
        }
      } else {
        if (toggleRowSelection(states, item, value)) {
          selectionChanged = true;
        }
      }
    });
    var table = this.table;

    if (selectionChanged) {
      table.$emit('selection-change', selection);
    }

    table.$emit('select-all', selection, value);
    states.isAllSelected = value;
  })
};

var doFlattenColumns = function doFlattenColumns(columns) {
  var result = [];
  columns.forEach(function (column) {
    if (column.children) {
      result.push.apply(result, doFlattenColumns(column.children));
    } else {
      result.push(column);
    }
  });
  return result;
};

table_store_TableStore.prototype.getTableRowsHeight = function () {
  var _this3 = this;

  if (!this.states.isComplex && !this.table.isVirtualScroll) return;
  if (!this.table.$ready) return external_vue_default.a.nextTick(function () {
    return _this3.getTableRowsHeight();
  });

  if (this.table.isVirtualScroll && "production" === 'production') {
    // 虚拟滚动在生产环境下只取第一行高度来得到行高以减少性能消耗
    // 开发环境下取所有行的高度，且行高不固定时做控制台的提示
    var row = this.table.bodyWrapper.querySelector('tbody > tr.el-table__row');

    if (row) {
      this.states.rowsHeight = [row.clientHeight];
      this.states.rowHeight = row.clientHeight;
    }
  } else {
    var rows = this.table.bodyWrapper.querySelectorAll('tbody > tr.el-table__row');

    if (rows.length) {
      var rowsHeight = [];

      for (var i = 0; i < rows.length; ++i) {
        var tr = rows[i];
        rowsHeight.push(tr.clientHeight);
      }

      this.states.rowsHeight = rowsHeight;
      this.states.rowHeight = this.getRowHeight();
    }
  }
};

table_store_TableStore.prototype.getRowHeight = function () {
  var distinct = _toConsumableArray(new Set(this.states.rowsHeight));

  var isRowsHeightEqual = distinct.length === 1;

  if (this.table.isVirtualScroll && !isRowsHeightEqual) {
     false && false;
  }

  return distinct[0];
};

table_store_TableStore.prototype.updateColumns = function () {
  var states = this.states;

  var _columns = states._columns || [];

  states.fixedColumns = _columns.filter(function (column) {
    return column.fixed === true || column.fixed === 'left';
  });
  states.rightFixedColumns = _columns.filter(function (column) {
    return column.fixed === 'right';
  });

  if (states.fixedColumns.length > 0 && _columns[0] && _columns[0].type === 'selection' && !_columns[0].fixed) {
    _columns[0].fixed = true;
    states.fixedColumns.unshift(_columns[0]);
  }

  var notFixedColumns = _columns.filter(function (column) {
    return !column.fixed;
  });

  states.originColumns = [].concat(states.fixedColumns).concat(notFixedColumns).concat(states.rightFixedColumns);
  var leafColumns = doFlattenColumns(notFixedColumns);
  states.fixedLeafColumns = doFlattenColumns(states.fixedColumns);
  states.rightFixedLeafColumns = doFlattenColumns(states.rightFixedColumns);
  states.columns = [].concat(states.fixedLeafColumns).concat(leafColumns).concat(states.rightFixedLeafColumns);
  states.isComplex = states.fixedColumns.length > 0 || states.rightFixedColumns.length > 0;
  this.getTableRowsHeight();
};

table_store_TableStore.prototype.isSelected = function (row) {
  return (this.states.selection || []).indexOf(row) > -1;
};

table_store_TableStore.prototype.clearSelection = function () {
  var states = this.states;
  states.isAllSelected = false;
  var oldSelection = states.selection;
  states.selection = [];

  if (oldSelection.length > 0) {
    this.table.$emit('selection-change', states.selection);
  }
};

table_store_TableStore.prototype.setExpandRowKeys = function (rowKeys) {
  var expandRows = [];
  var data = this.states.data;
  var rowKey = this.states.rowKey;
  if (!rowKey) throw new Error('[Table] prop row-key should not be empty.');
  var keysMap = table_store_getKeysMap(data, rowKey);
  rowKeys.forEach(function (key) {
    var info = keysMap[key];

    if (info) {
      expandRows.push(info.row);
    }
  });
  this.states.expandRows = expandRows;
};

table_store_TableStore.prototype.toggleRowSelection = function (row, selected) {
  var changed = toggleRowSelection(this.states, row, selected);

  if (changed) {
    this.table.$emit('selection-change', this.states.selection);
  }
};

table_store_TableStore.prototype.toggleRowExpanded = function (row, expanded) {
  var changed = toggleRowExpanded(this.states, row, expanded);

  if (changed) {
    this.table.$emit('expand-change', row, this.states.expandRows);
  }
};

table_store_TableStore.prototype.cleanSelection = function () {
  var selection = this.states.selection || [];
  var data = this.states.data;
  var rowKey = this.states.rowKey;
  var deleted;

  if (rowKey) {
    deleted = [];
    var selectedMap = table_store_getKeysMap(selection, rowKey);
    var dataMap = table_store_getKeysMap(data, rowKey);

    for (var key in selectedMap) {
      if (hasOwn(selectedMap, key) && !dataMap[key]) {
        deleted.push(selectedMap[key].row);
      }
    }
  } else {
    deleted = selection.filter(function (item) {
      return data.indexOf(item) === -1;
    });
  }

  deleted.forEach(function (deletedItem) {
    selection.splice(selection.indexOf(deletedItem), 1);
  });

  if (deleted.length) {
    this.table.$emit('selection-change', selection);
  }
};

table_store_TableStore.prototype.updateAllSelected = function () {
  var states = this.states;
  var selection = states.selection,
      rowKey = states.rowKey,
      selectable = states.selectable,
      data = states.data;

  if (!data || data.length === 0) {
    states.isAllSelected = false;
    return;
  }

  var selectedMap;

  if (rowKey) {
    selectedMap = table_store_getKeysMap(states.selection, rowKey);
  }

  var isSelected = function isSelected(row) {
    if (selectedMap) {
      return !!selectedMap[getRowIdentity(row, rowKey)];
    } else {
      return selection.indexOf(row) !== -1;
    }
  };

  var isAllSelected = true;
  var selectedCount = 0;

  for (var i = 0, j = data.length; i < j; i++) {
    var item = data[i];

    if (selectable) {
      var isRowSelectable = selectable(item, i);

      if (isRowSelectable) {
        if (!isSelected(item)) {
          isAllSelected = false;
          break;
        } else {
          selectedCount++;
        }
      }
    } else {
      if (!isSelected(item)) {
        isAllSelected = false;
        break;
      } else {
        selectedCount++;
      }
    }
  }

  if (selectedCount === 0) isAllSelected = false;
  states.isAllSelected = isAllSelected;
};

table_store_TableStore.prototype.scheduleLayout = function (dragResize) {
  this.table.debouncedLayout(dragResize);
};

table_store_TableStore.prototype.setCurrentRowKey = function (key) {
  var states = this.states;
  var rowKey = states.rowKey;
  if (!rowKey) throw new Error('[Table] row-key should not be empty.');
  var data = states.data || [];
  var keysMap = table_store_getKeysMap(data, rowKey);
  var info = keysMap[key];

  if (info) {
    states.currentRow = info.row;
  }
};

table_store_TableStore.prototype.updateCurrentRow = function () {
  var states = this.states;
  var table = this.table;
  var data = states.data || [];
  var oldCurrentRow = states.currentRow;

  if (data.indexOf(oldCurrentRow) === -1) {
    states.currentRow = null;

    if (states.currentRow !== oldCurrentRow) {
      table.$emit('current-change', null, oldCurrentRow);
    }
  }
};

table_store_TableStore.prototype.commit = function (name) {
  var mutations = this.mutations;

  if (mutations[name]) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    mutations[name].apply(this, [this.states].concat(args));
  } else {
    throw new Error("Action not found: ".concat(name));
  }
};

/* harmony default export */ var table_store = (table_store_TableStore);
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js


function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
// CONCATENATED MODULE: ./packages/table/src/table-layout.js











 // import scrollbarWidth from 'hui/src/utils/scrollbar-width';



var table_layout_TableLayout = /*#__PURE__*/function () {
  function TableLayout(options) {
    _classCallCheck(this, TableLayout);

    this.observers = [];
    this.table = null;
    this.store = null;
    this.columns = null;
    this.fit = true;
    this.showHeader = true;
    this.height = null; // this.scrollX = false;
    // this.scrollY = false;

    this.bodyWidth = null;
    this.fixedWidth = null;
    this.fixedBodyTop = null; // 固定列时计算header高度

    this.rightFixedWidth = null;
    this.tableHeight = null;
    this.headerHeight = 36; // Table Header Height

    this.footerHeight = 0; // Table Footer Height
    // this.viewportHeight = null; // Table Height - Scroll Bar Height （same with tableHeight）

    this.bodyHeight = null; // Table Height - Table Header Height

    this.fixedBodyHeight = null; // Table Height - Table Header Height - Scroll Bar Height

    this.dragFlexWidth = 0; // 记录拖拽可调节宽度

    this.hasDragged = false; // 记录是否拖拽过

    for (var name in options) {
      if (hasOwn(options, name)) {
        this[name] = options[name];
      }
    }

    if (!this.table) {
      throw new Error('table is required for Table Layout');
    }

    if (!this.store) {
      throw new Error('store is required for Table Layout');
    }
  }

  _createClass(TableLayout, [{
    key: "setHeight",
    value: function setHeight(value) {
      var _this = this;

      var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'height';
      var el = this.table.$el;

      if (typeof value === 'string' && /^\d+$/.test(value)) {
        value = Number(value);
      }

      this.height = value;

      if (!el && (value || value === 0)) {
        return external_vue_default.a.nextTick(function () {
          return _this.setHeight(value, prop);
        });
      }

      if (typeof value === 'number') {
        el.style[prop] = value + 'px';
        this.updateHeight();
      } else if (typeof value === 'string') {
        el.style[prop] = value;
        this.updateHeight();
      }
    }
  }, {
    key: "setMaxHeight",
    value: function setMaxHeight(value) {
      return this.setHeight(value, 'max-height');
    }
  }, {
    key: "updateHeight",
    value: function updateHeight() {
      var _this2 = this;

      if (!this.table.$ready) return external_vue_default.a.nextTick(function () {
        return _this2.updateHeight();
      });
      var _this$table$$refs = this.table.$refs,
          headerWrapper = _this$table$$refs.headerWrapper,
          appendWrapper = _this$table$$refs.appendWrapper,
          footerWrapper = _this$table$$refs.footerWrapper;
      this.appendHeight = appendWrapper ? appendWrapper.offsetHeight : 0;
      if (this.showHeader && !headerWrapper) return; // fix issue (https://github.com/ElemeFE/element/pull/16956)

      var headerTrElm = headerWrapper ? headerWrapper.querySelector('.el-table__header tr') : null;
      var noneHeader = this.headerDisplayNone(headerTrElm);
      var headerHeight = this.headerHeight = !this.showHeader ? 0 : headerWrapper.offsetHeight;

      if (this.showHeader && !noneHeader && headerWrapper.offsetWidth > 0 && (this.table.columns || []).length > 0 && headerHeight < 2) {
        return external_vue_default.a.nextTick(function () {
          return _this2.updateHeight();
        });
      }

      var tableHeight = this.tableHeight = this.table.$el.clientHeight;
      var footerHeight = this.footerHeight = footerWrapper ? footerWrapper.offsetHeight : 0;

      if (this.height !== null) {
        this.bodyHeight = tableHeight - headerHeight - footerHeight + (footerWrapper ? 1 : 0);
      }

      this.fixedBodyHeight = tableHeight - headerHeight - footerHeight + (footerWrapper ? 1 : 0);
    }
  }, {
    key: "headerDisplayNone",
    value: function headerDisplayNone(elm) {
      if (!elm) return true;
      var headerChild = elm;

      while (headerChild.tagName !== 'DIV') {
        if (getComputedStyle(headerChild).display === 'none') {
          return true;
        }

        headerChild = headerChild.parentElement;
      }

      return false;
    }
  }, {
    key: "getFlattenColumns",
    value: function getFlattenColumns() {
      var flattenColumns = [];
      var columns = this.table.columns;
      columns.forEach(function (column) {
        if (column.isColumnGroup) {
          flattenColumns.push.apply(flattenColumns, column.columns);
        } else {
          flattenColumns.push(column);
        }
      });
      return flattenColumns;
    }
  }, {
    key: "update",
    value: function update(dragResize) {
      var fit = this.fit;
      var hasDragged = this.hasDragged = this.hasDragged || dragResize; // const columns = this.table.columns;

      var bodyWidth = this.table.$el.clientWidth || this.bodyWidth;
      var bodyMinWidth = 0;
      var flattenColumns = this.getFlattenColumns(); // 兼容没有设置 column 的场景

      if (!flattenColumns.length) return;
      var flexColumns = flattenColumns.filter(function (column) {
        return typeof column.width !== 'number';
      });

      if (fit) {
        // 存在列没有设置 width 为 number 的场景（width为百分比或者没有设置）
        if (flexColumns.length > 0 && !hasDragged) {
          flattenColumns.forEach(function (column) {
            if (typeof column.width === 'number') {
              bodyMinWidth += column.width;
            }
          });
          var remainWidth = bodyWidth - bodyMinWidth;
          var percent = 0;
          flexColumns.forEach(function (column) {
            if (/%$/.test(column.width)) {
              percent = Number(column.width.replace(/%$/, '')) / 100;
              var realWidth = remainWidth * percent >= column.minWidth ? remainWidth * percent : column.minWidth;
              column.realWidth = realWidth;
              bodyMinWidth += realWidth;
            } else {
              bodyMinWidth += column.minWidth || 80;
            }
          });
          flexColumns = flexColumns.filter(function (column) {
            return !/%$/.test(column.width);
          }); // DON'T HAVE SCROLL BAR

          if (bodyMinWidth < bodyWidth && flexColumns.length) {
            var totalFlexWidth = bodyWidth - bodyMinWidth;

            if (flexColumns.length === 1) {
              flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth;
            } else {
              var allColumnsWidth = flexColumns.reduce(function (prev, column) {
                return prev + (column.minWidth || 80);
              }, 0);
              var flexWidthPerPixel = totalFlexWidth / allColumnsWidth;
              var noneFirstWidth = 0;
              flexColumns.forEach(function (column, index) {
                if (index === 0) return;
                var flexWidth = Math.floor((column.minWidth || 80) * flexWidthPerPixel);
                noneFirstWidth += flexWidth;
                column.realWidth = (column.minWidth || 80) + flexWidth;
              });
              flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth - noneFirstWidth;
            }
          } else {
            // HAVE HORIZONTAL SCROLL BAR
            flexColumns.forEach(function (column) {
              column.realWidth = column.minWidth;
            });
          }

          this.bodyWidth = Math.max(bodyMinWidth, bodyWidth);
        } else {
          // 1.flexColumns.length === 0 即各列宽度均被设置为 number 时
          // 2.hasDragged = true 用户对列宽进行了拖拽操作
          // 拖动
          flattenColumns.forEach(function (column) {
            bodyMinWidth += column.realWidth;
          });

          if (bodyMinWidth - bodyWidth >= this.dragFlexWidth) {
            flattenColumns[flattenColumns.length - 1].realWidth = flattenColumns[flattenColumns.length - 1].realWidth - this.dragFlexWidth;
            this.bodyWidth = bodyMinWidth - this.dragFlexWidth;
            this.dragFlexWidth = 0;
          } else if (bodyMinWidth - bodyWidth < this.dragFlexWidth && bodyMinWidth > bodyWidth) {
            var flexWidth = bodyMinWidth - bodyWidth;
            flattenColumns[flattenColumns.length - 1].realWidth = flattenColumns[flattenColumns.length - 1].realWidth - flexWidth;
            this.bodyWidth = bodyWidth;
            this.dragFlexWidth -= flexWidth;
          } else {
            flattenColumns[flattenColumns.length - 1].realWidth = flattenColumns[flattenColumns.length - 1].realWidth + bodyWidth - bodyMinWidth;
            this.dragFlexWidth += bodyWidth - bodyMinWidth;
            this.bodyWidth = bodyWidth;
          }
        } // if (this.table.$refs.tableScrollbar) {
        //   this.table.$refs.tableScrollbar.$refs.resize.style.width =
        //     this.bodyWidth + 'px';
        // }


        this.table.resizeState.width = this.bodyWidth;
      } else {
        flattenColumns.forEach(function (column) {
          if (!column.width && !column.minWidth) {
            column.realWidth = 80;
          } else {
            column.realWidth = column.width || column.minWidth;
          }

          bodyMinWidth += column.realWidth;
        });
        this.bodyWidth = bodyMinWidth;
      }

      var fixedColumns = this.store.states.fixedColumns;

      if (fixedColumns.length > 0) {
        var fixedWidth = 0;
        fixedColumns.forEach(function (column) {
          fixedWidth += column.realWidth;
        });
        this.fixedWidth = fixedWidth;
      }

      var rightFixedColumns = this.store.states.rightFixedColumns;

      if (rightFixedColumns.length > 0) {
        var rightFixedWidth = 0;
        rightFixedColumns.forEach(function (column) {
          rightFixedWidth += column.realWidth;
        });
        this.rightFixedWidth = rightFixedWidth;
      }

      var $header = this.table.$el.querySelector('.el-table__header-wrapper');
      this.fixedBodyTop = $header ? window.getComputedStyle($header).getPropertyValue('height') : 0;
      this.notifyObservers();
    }
  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      this.observers.push(observer);
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      var index = this.observers.indexOf(observer);

      if (index !== -1) {
        this.observers.splice(index, 1);
      }
    }
  }, {
    key: "notifyObservers",
    value: function notifyObservers() {
      var _this3 = this;

      var observers = this.observers;
      observers.forEach(function (observer) {
        observer.onColumnsChange(_this3);
      });
    }
  }]);

  return TableLayout;
}();

/* harmony default export */ var table_layout = (table_layout_TableLayout);
// EXTERNAL MODULE: external "core-js/modules/es.array.find.js"
var es_array_find_js_ = __webpack_require__("0d58");

// EXTERNAL MODULE: external "core-js/modules/es.object.define-properties.js"
var es_object_define_properties_js_ = __webpack_require__("16b9");

// EXTERNAL MODULE: external "core-js/modules/es.object.get-own-property-descriptors.js"
var es_object_get_own_property_descriptors_js_ = __webpack_require__("7664");

// EXTERNAL MODULE: external "@babel/runtime/helpers/esm/defineProperty"
var defineProperty_ = __webpack_require__("04f7");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js











function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
// CONCATENATED MODULE: ./packages/table/src/layout-observer.js


/* harmony default export */ var layout_observer = ({
  created: function created() {
    this.tableLayout.addObserver(this);
  },
  destroyed: function destroyed() {
    this.tableLayout.removeObserver(this);
  },
  computed: {
    tableLayout: function tableLayout() {
      var layout = this.layout;

      if (!layout && this.table) {
        layout = this.table.layout;
      }

      if (!layout) {
        throw new Error('Can not find table layout.');
      }

      return layout;
    }
  },
  mounted: function mounted() {
    this.onColumnsChange(this.tableLayout);
  },
  updated: function updated() {
    if (this.__updated__) return;
    this.onColumnsChange(this.tableLayout);
    this.__updated__ = true;
  },
  methods: {
    onColumnsChange: function onColumnsChange(layout) {
      var cols = this.$el.querySelectorAll('colgroup > col');
      if (!cols.length) return;
      var flattenColumns = layout.getFlattenColumns();
      var columnsMap = {};
      flattenColumns.forEach(function (column) {
        columnsMap[column.id] = column;
      });

      for (var i = 0, j = cols.length; i < j; i++) {
        var col = cols[i];
        var name = col.getAttribute('name');
        var column = columnsMap[name];

        if (column) {
          var w = column.realWidth || column.width;
          if (w < 36) w = 36;
          col.setAttribute('width', w);
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/table/src/table-body.js




















/* harmony default export */ var table_body = ({
  name: 'ElTableBody',
  mixins: [layout_observer],
  components: {
    ElCheckbox: packages_checkbox,
    ElTooltip: packages_tooltip
  },
  props: {
    store: {
      required: true
    },
    stripe: {
      type: Boolean,
      "default": null
    },
    context: {},
    rowClassName: [String, Function],
    rowStyle: [Object, Function],
    fixed: String,
    highlight: {
      type: Boolean,
      "default": null
    }
  },
  render: function render(h) {
    var _this = this;

    return h("table", {
      "class": 'el-table__body',
      "attrs": {
        "cellspacing": '0',
        "cellpadding": '0',
        "border": '0'
      }
    }, [h("colgroup", [this._l(this.columns, function (column) {
      return h("col", {
        "attrs": {
          "name": column.id
        }
      });
    })]), h("tbody", [this._l(this.data, function (row, _$index) {
      // modify by zhangxiaogang
      var renderExpanded = _this.table.renderExpanded || _this.table.$parent.renderExpanded;
      var $index = _$index + _this.startIndex;
      return [h("tr", {
        "style": _this.getRowStyle(row, $index),
        "key": _this.table.rowKey ? _this.getKeyOfRow(row, $index) : $index,
        "on": {
          "dblclick": function dblclick($event) {
            return _this.handleDoubleClick($event, row);
          },
          "click": function click($event) {
            return _this.handleClick($event, row, $index);
          },
          "contextmenu": function contextmenu($event) {
            return _this.handleContextMenu($event, row);
          },
          "mouseenter": function mouseenter() {
            return _this.handleMouseEnter($index);
          },
          "mouseleave": function mouseleave() {
            return _this.handleMouseLeave();
          }
        },
        "class": [_this.getRowClass(row, $index)]
      }, [_this._l(_this.columns, function (column, _cellIndex) {
        var cellIndex = column.cellIndex || _cellIndex;

        var _this$getSpan = _this.getSpan(row, column, $index, cellIndex),
            rowspan = _this$getSpan.rowspan,
            colspan = _this$getSpan.colspan;

        if (!rowspan && !colspan) {
          return '';
        } else {
          if (rowspan === 1 && colspan === 1) {
            return h("td", {
              "style": _this.getCellStyle($index, cellIndex, row, column),
              "class": _this.getCellClass($index, cellIndex, row, column),
              "on": {
                "mouseenter": function mouseenter($event) {
                  return _this.handleCellMouseEnter($event, row);
                },
                "mouseleave": _this.handleCellMouseLeave
              }
            }, [column.renderCell.call(_this._renderProxy, h, {
              row: row,
              column: column,
              $index: $index,
              store: _this.store,
              _self: _this.context || _this.table.$vnode.context
            })]);
          } else {
            return h("td", {
              "style": _this.getCellStyle($index, cellIndex, row, column),
              "class": _this.getCellClass($index, cellIndex, row, column),
              "attrs": {
                "rowspan": rowspan,
                "colspan": colspan
              },
              "on": {
                "mouseenter": function mouseenter($event) {
                  return _this.handleCellMouseEnter($event, row);
                },
                "mouseleave": _this.handleCellMouseLeave
              }
            }, [column.renderCell.call(_this._renderProxy, h, {
              row: row,
              column: column,
              $index: $index,
              store: _this.store,
              _self: _this.context || _this.table.$vnode.context
            })]);
          }
        }
      })]), _this.store.states.expandRows.indexOf(row) > -1 ? h("tr", {
        "class": {
          'is-hidden': _this.fixed
        }
      }, [h("td", {
        "attrs": {
          "colspan": _this.columns.length
        },
        "class": 'el-table__expanded-cell'
      }, [renderExpanded ? renderExpanded(h, {
        row: row,
        $index: $index,
        store: _this.store
      }) : ''])]) : ''];
    }).concat(this.table.$slots.append).concat(h("el-tooltip", {
      "attrs": {
        "placement": 'top',
        "content": this.tooltipContent
      },
      "ref": 'tooltip'
    }))])]);
  },
  watch: {
    scrollViewStyle: {
      handler: function handler(style) {
        var _this2 = this;

        if (!this.isVirtualScroll) return;

        if (!this.table.$refs.bodyWrapper) {
          this.$nextTick(function () {
            _this2.setScrollViewStyle(style);
          });
        } else {
          this.setScrollViewStyle(style);
        } // 修复虚拟滚动下固定列错位的问题


        if (this.fixed) {
          this.$nextTick(function () {
            _this2.setFixedBodyStyle(style);
          });
        }
      },
      immediate: true
    },

    /**
     * modified by zhangxiaogang
     * date: 2018-05-09
     * todo: 合并行列的表格hover需要关联变化，故改写此处逻辑
     */
    'store.states.hoverRow': function storeStatesHoverRow(newVal) {
      if (!this.store.states.isComplex) return;
      var el = this.$el;
      if (!el) return;
      var rows = el.querySelectorAll('tbody > tr.el-table__row');
      var oldRow = el.querySelector('tbody > tr.el-table__row.hover-row');
      var newRow = newVal !== 0 && !newVal ? null : rows[newVal - this.startIndex];

      if (oldRow) {
        removeClass(oldRow, 'hover-row');
      }

      if (newRow) {
        addClass(newRow, 'hover-row');
      }
      /* const setHover = (index, flag) => {
        const row = rows[index];
        flag ? addClass(row, 'hover-row') : removeClass(row, 'hover-row');
      };
      if (!Array.isArray(newVal)) newVal = [newVal];
      if (!Array.isArray(oldVal)) oldVal = [oldVal];
      [newVal, oldVal].forEach((vv, i) => {
        vv.forEach((v) => {
          !isNaN(v) && setHover(v, i === 0);
        });
      }); */

    },
    'store.states.currentRow': function storeStatesCurrentRow(newVal, oldVal) {
      if (!this.highlight) return;
      var el = this.$el;
      if (!el) return;
      var data = this.store.states.data;
      var rows = el.querySelectorAll('tbody > tr.el-table__row');
      var oldRow = rows[data.indexOf(oldVal)];
      var newRow = rows[data.indexOf(newVal)];

      if (oldRow) {
        removeClass(oldRow, 'current-row');
      } else if (rows) {
        [].forEach.call(rows, function (row) {
          return removeClass(row, 'current-row');
        });
      }

      if (newRow) {
        addClass(newRow, 'current-row');
      }
    }
  },
  computed: {
    table: function table() {
      if (!this.$parent.columns) {
        return this.$parent.$parent;
      }

      return this.$parent;
    },
    scrollTop: function scrollTop() {
      return this.table.scrollTop;
    },
    isVirtualScroll: function isVirtualScroll() {
      return this.table.isVirtualScroll;
    },
    rowHeight: function rowHeight() {
      return this.store.states.rowHeight;
    },
    clientHeight: function clientHeight() {
      return Number(this.table.height) || Number(this.table.maxHeight) || this.table.bodyWrapperHeight;
    },
    scrollState: function scrollState() {
      var scrollTop = this.scrollTop,
          clientHeight = this.clientHeight;
      return {
        start: scrollTop,
        end: scrollTop + clientHeight
      };
    },
    count: function count() {
      return this.store.states.data.length;
    },
    startIndex: function startIndex() {
      var rowHeight = this.rowHeight,
          scrollState = this.scrollState,
          isVirtualScroll = this.isVirtualScroll,
          columnsCount = this.columnsCount;
      if (!isVirtualScroll || !columnsCount || !this.count) return 0;
      var index = Math.floor(scrollState.start / rowHeight);
      index < 0 && (index = 0);
      return index;
    },
    endIndex: function endIndex() {
      var rowHeight = this.rowHeight,
          scrollState = this.scrollState,
          count = this.count,
          isVirtualScroll = this.isVirtualScroll;
      if (!isVirtualScroll) return count;
      var index = Math.ceil(scrollState.end / rowHeight);
      index > count - 1 && (index = count - 1);
      return index;
    },
    viewMarginTop: function viewMarginTop() {
      return this.startIndex * this.rowHeight;
    },
    viewMarginBottom: function viewMarginBottom() {
      return (this.count - 1 - this.endIndex) * this.rowHeight;
    },
    scrollViewStyle: function scrollViewStyle() {
      var isVirtualScroll = this.isVirtualScroll,
          viewMarginTop = this.viewMarginTop,
          viewMarginBottom = this.viewMarginBottom;
      return isVirtualScroll ? {
        marginTop: "".concat(viewMarginTop, "px"),
        marginBottom: "".concat(viewMarginBottom, "px")
      } : {};
    },
    data: function data() {
      return this.isVirtualScroll ? this.store.states.data.slice(this.startIndex, this.endIndex + 1) : this.store.states.data;
    },
    columnsCount: function columnsCount() {
      return this.store.states.columns.length;
    },
    leftFixedLeafCount: function leftFixedLeafCount() {
      return this.store.states.fixedLeafColumns.length;
    },
    rightFixedLeafCount: function rightFixedLeafCount() {
      return this.store.states.rightFixedLeafColumns.length;
    },
    columns: function columns() {
      if (this.fixed === true || this.fixed === 'left') {
        return this.store.states.fixedLeafColumns;
      } else if (this.fixed === 'right') {
        // 固定列优化后，右侧固定列索引需要计算 add by yangzhini 2020-04-17
        var _this$store$states = this.store.states,
            columns = _this$store$states.columns,
            rightFixedLeafColumns = _this$store$states.rightFixedLeafColumns;
        var bIndex = columns.length - rightFixedLeafColumns.length;
        return rightFixedLeafColumns.map(function (col, cellIndex) {
          return _objectSpread2(_objectSpread2({}, col), {}, {
            cellIndex: bIndex + cellIndex
          });
        });
      }

      return this.store.states.columns;
    }
  },
  data: function data() {
    return {
      tooltipContent: ''
    };
  },
  created: function created() {
    this.activateTooltip = debounce_default()(50, function (tooltip) {
      return tooltip.handleShowPopper();
    });
  },
  methods: {
    setScrollViewStyle: function setScrollViewStyle(style) {
      var scrollView = this.table.$refs.bodyWrapper.querySelector('.el-table-scrollbar__view');
      Object.assign(scrollView.style, style);
    },
    setFixedBodyStyle: function setFixedBodyStyle(style) {
      Object.assign(this.$el.style, style);
    },
    getKeyOfRow: function getKeyOfRow(row, index) {
      var rowKey = this.table.rowKey;

      if (rowKey) {
        return getRowIdentity(row, rowKey);
      }

      return index;
    },
    getSpan: function getSpan(row, column, rowIndex, columnIndex) {
      var rowspan = 1;
      var colspan = 1;
      var fn = this.table.spanMethod;

      if (typeof fn === 'function') {
        var result = fn({
          row: row,
          column: column,
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });

        if (Array.isArray(result)) {
          rowspan = result[0];
          colspan = result[1];
        } else if (_typeof(result) === 'object') {
          rowspan = result.rowspan;
          colspan = result.colspan;
        }
      }

      return {
        rowspan: rowspan,
        colspan: colspan
      };
    },
    getRowStyle: function getRowStyle(row, rowIndex) {
      var rowStyle = this.table.rowStyle;

      if (typeof rowStyle === 'function') {
        rowStyle = rowStyle({
          row: row,
          rowIndex: rowIndex
        });
      }

      if (this.fixed) {
        var rowHeight = this.isVirtualScroll ? this.store.states.rowHeight : this.store.states.rowsHeight[rowIndex];
        var fixedRowStyle = {
          height: "".concat(rowHeight, "px")
        };

        if (!rowStyle) {
          return fixedRowStyle;
        }

        if (typeof rowStyle === 'string') {
          return "height:".concat(rowHeight, "px;").concat(rowStyle);
        }

        if (_typeof(rowStyle) === 'object') {
          return _objectSpread2(_objectSpread2({}, rowStyle), fixedRowStyle);
        }
      }

      return rowStyle || null;
    },
    getRowClass: function getRowClass(row, rowIndex) {
      var classes = ['el-table__row'];

      if (this.stripe && rowIndex % 2 === 1) {
        classes.push('el-table__row--striped');
      }

      var rowClassName = this.table.rowClassName;

      if (typeof rowClassName === 'string') {
        classes.push(rowClassName);
      } else if (typeof rowClassName === 'function') {
        classes.push(rowClassName({
          row: row,
          rowIndex: rowIndex
        }));
      }

      if (this.store.states.expandRows.indexOf(row) > -1) {
        classes.push('expanded');
      }

      if (this.isRowUnselectable(row, rowIndex)) {
        classes.push('disabled');
      }

      return classes.join(' ');
    },
    getCellStyle: function getCellStyle(rowIndex, columnIndex, row, column) {
      var cellStyle = this.table.cellStyle;

      if (typeof cellStyle === 'function') {
        return cellStyle({
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        });
      }

      return cellStyle;
    },
    getCellClass: function getCellClass(rowIndex, columnIndex, row, column) {
      var classes = [column.id, column.align, column.className];
      var cellClassName = this.table.cellClassName;

      if (typeof cellClassName === 'string') {
        classes.push(cellClassName);
      } else if (typeof cellClassName === 'function') {
        classes.push(cellClassName({
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        }));
      }

      return classes.join(' ');
    },

    /**
     * add by zhangxiaogang
     * 2018-05-09
     * 如果有合并行的单元格，鼠标处于合并的单元格，则该单元格所跨的行全部要处于hover状态
     * 鼠标离开，则状态对应改变
     * {@param} cell:单元格td的dom
     * {@param} flag:'enter'表示进入，'leave'表示离开
     **/
    setRowspanTrHoverState: function setRowspanTrHoverState(cell) {
      var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'enter';
      var allRow = this.$el.querySelectorAll('tbody > tr.el-table__row');
      var rowspan = cell.getAttribute('rowspan'); // 鼠标不再合并的单元格上直接中止

      if (rowspan === null) return; // 当前单元格所在行的序号

      var start = [].slice.call(allRow).indexOf(cell.parentNode);
      rowspan = +rowspan; // rowspan == 0表示从当前行一直都末尾都合并
      // rowspan == 1无意义，等同于未合并

      if (rowspan > 1 || rowspan === 0) {
        var end = rowspan > 0 ? rowspan + start - 1 : allRow.length - start;

        while (start <= end) {
          flag === 'enter' ? addClass(allRow[start], 'hover-row') : removeClass(allRow[start], 'hover-row');
          start++;
        }
      }
    },
    handleCellMouseEnter: function handleCellMouseEnter(event, row) {
      var _this3 = this;

      // const tdValue = event.target.innerText;
      var table = this.table;
      var cell = getCell(event);

      if (cell) {
        var column = getColumnByCell(table, cell);
        var hoverState = table.hoverState = {
          cell: cell,
          column: column,
          row: row
        };
        table.$emit('cell-mouse-enter', hoverState.row, hoverState.column, hoverState.cell, event);
        this.$nextTick(function () {
          _this3.setRowspanTrHoverState(cell);
        });
      }

      var cellChild = event.target.querySelector('.cell');
      var labelChild = event.target.querySelector('.label');
      var labelItem = labelChild || cellChild;
      /**
       * IE 下当 labelItem.getBoundingClientRect().width 为小数时
       * clientWidth 根据实际宽度四舍五入，而 scrollWidth 比 clientWidth 大 1px
       * 故存在内容未溢出而显示 title 的情况
       * 此处暂时不做兼容处理
       * add by yangzhini 2019-05-14
       **/

      if (labelItem.clientWidth < labelItem.scrollWidth) {
        if (hasClass(cellChild, 'el-tooltip')) {
          var tooltip = this.$refs.tooltip;
          this.tooltipContent = cell.innerText.trim();
          tooltip.referenceElm = cell;
          tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
          tooltip.doDestroy();
          tooltip.setExpectedState(true);
          this.activateTooltip(tooltip);
        } else if (hasClass(cellChild, 'show-overflow-title')) {
          cell.setAttribute('title', cell.innerText.trim());
        }
      } else if (cell.getAttribute('title')) {
        cell.removeAttribute('title');
      }
    },
    handleCellMouseLeave: function handleCellMouseLeave(event) {
      var _this4 = this;

      var tooltip = this.$refs.tooltip;

      if (tooltip) {
        tooltip.setExpectedState(false);
        tooltip.handleClosePopper();
      }

      var cell = getCell(event);
      if (!cell) return;
      var oldHoverState = this.table.hoverState;
      this.table.$emit('cell-mouse-leave', oldHoverState.row, oldHoverState.column, oldHoverState.cell, event);
      this.$nextTick(function () {
        _this4.setRowspanTrHoverState(cell, 'leave');
      });
    },

    /**
     * modified by zhangxiaogang
     * date: 2018-05-09
     * todo: 合并行列的表格hover需要关联变化，故改写此处逻辑
     */
    handleMouseEnter: function handleMouseEnter(index) {
      this.store.commit('setHoverRow', index);
    },
    handleMouseLeave: function handleMouseLeave() {
      this.store.commit('setHoverRow', null);
    },
    handleContextMenu: function handleContextMenu(event, row) {
      this.handleEvent(event, row, 'contextmenu');
    },
    handleDoubleClick: function handleDoubleClick(event, row) {
      this.handleEvent(event, row, 'dblclick');
    },
    handleClick: function handleClick(event, row, $index) {
      if (!this.isRowUnselectable(row, $index)) {
        this.store.commit('setCurrentRow', row);
        this.handleEvent(event, row, 'click');
      }
    },
    isRowUnselectable: function isRowUnselectable(row, $index) {
      var radioColumn = this.columns.find(function (col) {
        return col.type === 'radio';
      });
      return radioColumn && radioColumn.selectable && !radioColumn.selectable.call(null, row, $index);
    },
    handleEvent: function handleEvent(event, row, name) {
      var table = this.table;
      var cell = getCell(event);
      var column;

      if (cell) {
        column = getColumnByCell(table, cell);

        if (column) {
          table.$emit("cell-".concat(name), row, column, cell, event);
        }
      }

      table.$emit("row-".concat(name), row, event, column);
    },
    handleExpandClick: function handleExpandClick(row) {
      this.store.toggleRowExpanded(row);
    }
  }
});
// EXTERNAL MODULE: external "core-js/modules/es.object.values.js"
var es_object_values_js_ = __webpack_require__("e01a");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=template&id=002dd4ca&
var filter_panelvue_type_template_id_002dd4ca_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"}},[(_vm.multiple)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"el-table-filter el-popper"},[_c('div',{staticClass:"el-table-filter__content"},[_c('el-checkbox-group',{staticClass:"el-table-filter__checkbox-group",model:{value:(_vm.filteredValue),callback:function ($$v) {_vm.filteredValue=$$v},expression:"filteredValue"}},_vm._l((_vm.filters),function(filter){return _c('el-checkbox',{key:filter.value,attrs:{"label":filter.value}},[_vm._v(" "+_vm._s(filter.text)+" ")])}),1)],1),_c('div',{staticClass:"el-table-filter__bottom"},[_c('button',{class:{ 'is-disabled': _vm.filteredValue.length === 0 },attrs:{"disabled":_vm.filteredValue.length === 0},on:{"click":_vm.handleConfirm}},[_vm._v(" "+_vm._s(_vm.t('el.table.confirmFilter'))+" ")]),_c('button',{on:{"click":_vm.handleReset}},[_vm._v(" "+_vm._s(_vm.t('el.table.resetFilter'))+" ")])])]):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"el-table-filter"},[_c('ul',{staticClass:"el-table-filter__list"},[_c('li',{staticClass:"el-table-filter__list-item",class:{ 'is-active': !_vm.filterValue },on:{"click":function($event){return _vm.handleSelect(null)}}},[_vm._v(" "+_vm._s(_vm.t('el.table.clearFilter'))+" ")]),_vm._l((_vm.filters),function(filter){return _c('li',{key:filter.value,staticClass:"el-table-filter__list-item",class:{ 'is-active': _vm.isActive(filter) },attrs:{"label":filter.value},on:{"click":function($event){return _vm.handleSelect(filter.value)}}},[_vm._v(" "+_vm._s(filter.text)+" ")])})],2)])])}
var filter_panelvue_type_template_id_002dd4ca_staticRenderFns = []


// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=template&id=002dd4ca&

// CONCATENATED MODULE: ./packages/table/src/dropdown.js




var dropdowns = [];
!external_vue_default.a.prototype.$isServer && document.addEventListener('click', function (event) {
  dropdowns.forEach(function (dropdown) {
    var target = event.target;
    if (!dropdown || !dropdown.$el) return;

    if (target === dropdown.$el || dropdown.$el.contains(target)) {
      return;
    }

    dropdown.handleOutsideClick && dropdown.handleOutsideClick(event);
  });
});
/* harmony default export */ var src_dropdown = ({
  open: function open(instance) {
    if (instance) {
      dropdowns.push(instance);
    }
  },
  close: function close(instance) {
    var index = dropdowns.indexOf(instance);

    if (index !== -1) {
      dropdowns.splice(instance, 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var filter_panelvue_type_script_lang_js_ = ({
  name: 'ElTableFilterPanel',
  directives: {
    Clickoutside: clickoutside
  },
  components: {
    ElCheckbox: packages_checkbox,
    ElCheckboxGroup: packages_checkbox_group
  },
  mixins: [vue_popper, locale],
  props: {
    placement: {
      type: String,
      "default": 'bottom-end'
    },
    visibleArrow: {
      type: Boolean,
      "default": true
    }
  },
  customRender: function customRender() {
    var h = this.$createElement;
    return h("div", {
      "class": 'el-table-filter'
    }, [h("div", {
      "class": 'el-table-filter__content'
    }), h("div", {
      "class": 'el-table-filter__bottom'
    }, [h("button", {
      "on": {
        "click": this.handleConfirm
      }
    }, [this.t('el.table.confirmFilter')]), h("button", {
      "on": {
        "click": this.handleReset
      }
    }, [this.t('el.table.resetFilter')])])]);
  },
  data: function data() {
    return {
      table: null,
      cell: null,
      column: null
    };
  },
  computed: {
    filters: function filters() {
      return this.column && this.column.filters;
    },
    filterValue: {
      get: function get() {
        return (this.column.filteredValue || [])[0];
      },
      set: function set(value) {
        if (this.filteredValue) {
          if (typeof value !== 'undefined' && value !== null) {
            this.filteredValue.splice(0, 1, value);
          } else {
            this.filteredValue.splice(0, 1);
          }
        }
      }
    },
    filteredValue: {
      get: function get() {
        if (this.column) {
          return this.column.filteredValue || [];
        }

        return [];
      },
      set: function set(value) {
        if (this.column) {
          this.column.filteredValue = value;
        }
      }
    },
    multiple: function multiple() {
      if (this.column) {
        return this.column.filterMultiple;
      }

      return true;
    }
  },
  watch: {
    showPopper: function showPopper(val) {
      if (val === true && parseInt(this.popperJS._popper.style.zIndex, 10) < popup_manager.zIndex) {
        this.popperJS._popper.style.zIndex = popup_manager.nextZIndex();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.popperElm = this.$el;
    this.referenceElm = this.cell.querySelector('.el-table__column-filter-trigger');
    this.table.bodyWrapper.addEventListener('scroll', function () {
      _this.updatePopper();
    });
    this.$watch('showPopper', function (value) {
      if (_this.column) _this.column.filterOpened = value;

      if (value) {
        src_dropdown.open(_this);
      } else {
        src_dropdown.close(_this);
      }
    });
  },
  methods: {
    isActive: function isActive(filter) {
      return filter.value === this.filterValue;
    },
    handleOutsideClick: function handleOutsideClick() {
      this.showPopper = false;
    },
    handleConfirm: function handleConfirm() {
      this.confirmFilter(this.filteredValue);
      this.handleOutsideClick();
    },
    handleReset: function handleReset() {
      this.filteredValue = [];
      this.confirmFilter(this.filteredValue);
      this.handleOutsideClick();
    },
    handleSelect: function handleSelect(filterValue) {
      this.filterValue = filterValue;

      if (typeof filterValue !== 'undefined' && filterValue !== null) {
        this.confirmFilter(this.filteredValue);
      } else {
        this.confirmFilter([]);
      }

      this.handleOutsideClick();
    },
    confirmFilter: function confirmFilter(filteredValue) {
      this.table.store.commit('filterChange', {
        column: this.column,
        values: filteredValue
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_filter_panelvue_type_script_lang_js_ = (filter_panelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue





/* normalize component */

var filter_panel_component = normalizeComponent(
  src_filter_panelvue_type_script_lang_js_,
  filter_panelvue_type_template_id_002dd4ca_render,
  filter_panelvue_type_template_id_002dd4ca_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var filter_panel = (filter_panel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/selection-panel.vue?vue&type=template&id=a1b429d6&
var selection_panelvue_type_template_id_a1b429d6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"el-table-selection"},[_c('ul',{staticClass:"el-table-selection__list"},_vm._l((_vm.selections),function(selection){return _c('li',{key:selection.value,staticClass:"el-table-selection__list-item",attrs:{"label":selection.value},on:{"click":function($event){return _vm.handleSelect(selection.value)}}},[_vm._v(" "+_vm._s(selection.text)+" ")])}),0)])])}
var selection_panelvue_type_template_id_a1b429d6_staticRenderFns = []


// CONCATENATED MODULE: ./packages/table/src/selection-panel.vue?vue&type=template&id=a1b429d6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/selection-panel.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selection_panelvue_type_script_lang_js_ = ({
  name: 'ElTableSelectionPanel',
  mixins: [vue_popper],
  props: {
    placement: {
      type: String,
      "default": 'bottom-start'
    }
  },
  data: function data() {
    return {
      table: null,
      target: null,
      column: null
    };
  },
  computed: {
    selections: function selections() {
      return this.column && this.column.selections;
    }
  },
  watch: {
    showPopper: function showPopper(val) {
      if (val === true && parseInt(this.popperJS._popper.style.zIndex, 10) < popup_manager.zIndex) {
        this.popperJS._popper.style.zIndex = popup_manager.nextZIndex();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.popperElm = this.$el;
    this.referenceElm = this.target;
    this.table.bodyWrapper.addEventListener('scroll', function () {
      _this.updatePopper();
    });
    on(this.referenceElm, 'mouseenter', this.handleMouseEnter);
    on(this.popperElm, 'mouseenter', this.handleMouseEnter);
    on(this.referenceElm, 'mouseleave', this.handleMouseLeave);
    on(this.popperElm, 'mouseleave', this.handleMouseLeave);
  },
  destroyed: function destroyed() {
    off(this.referenceElm, 'mouseenter', this.handleMouseEnter);
    off(this.popperElm, 'mouseenter', this.handleMouseEnter);
    off(this.referenceElm, 'mouseleave', this.handleMouseLeave);
    off(this.popperElm, 'mouseleave', this.handleMouseLeave);
  },
  methods: {
    handleSelect: function handleSelect(selectedValue) {
      var selection = this.column.selections.find(function (selection) {
        return selection.value === selectedValue;
      });

      if (selection && selection.onClick) {
        selection.onClick();
      }

      this.showPopper = false;
    },
    handleMouseEnter: function handleMouseEnter() {
      clearTimeout(this._timer);
      this.showPopper = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      var _this2 = this;

      this._timer = setTimeout(function () {
        _this2.showPopper = false;
      }, 200);
    }
  }
});
// CONCATENATED MODULE: ./packages/table/src/selection-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_selection_panelvue_type_script_lang_js_ = (selection_panelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/table/src/selection-panel.vue





/* normalize component */

var selection_panel_component = normalizeComponent(
  src_selection_panelvue_type_script_lang_js_,
  selection_panelvue_type_template_id_a1b429d6_render,
  selection_panelvue_type_template_id_a1b429d6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var selection_panel = (selection_panel_component.exports);
// CONCATENATED MODULE: ./packages/table/src/table-header.js

















var getAllColumns = function getAllColumns(columns) {
  var result = [];
  columns.forEach(function (column) {
    if (column.children) {
      result.push(column);
      result.push.apply(result, getAllColumns(column.children));
    } else {
      result.push(column);
    }
  });
  return result;
};

var convertToRows = function convertToRows(originColumns) {
  var maxLevel = 1;

  var traverse = function traverse(column, parent) {
    if (parent) {
      column.level = parent.level + 1;

      if (maxLevel < column.level) {
        maxLevel = column.level;
      }
    }

    if (column.children) {
      var colSpan = 0;
      column.children.forEach(function (subColumn) {
        traverse(subColumn, column);
        colSpan += subColumn.colSpan;
      });
      column.colSpan = colSpan;
    } else {
      column.colSpan = 1;
    }
  };

  originColumns.forEach(function (column) {
    column.level = 1;
    traverse(column);
  });
  var rows = [];

  for (var i = 0; i < maxLevel; i++) {
    rows.push([]);
  }

  var allColumns = getAllColumns(originColumns);
  allColumns.forEach(function (column) {
    if (!column.children) {
      column.rowSpan = maxLevel - column.level + 1;
    } else {
      column.rowSpan = 1;
    }

    rows[column.level - 1].push(column);
  });
  return rows;
}; // function parseToDOM(str) {
//     const div = document.createElement('div');
//     if (typeof str === 'string') {
//         div.innerHTML = str;
//     }
//     return <div />;
// }


/* harmony default export */ var table_header = ({
  name: 'ElTableHeader',
  mixins: [layout_observer],
  render: function render(h) {
    var _this = this;

    var originColumns = this.store.states.originColumns;
    var columnRows = convertToRows(originColumns, this.columns); // 是否拥有多级表头

    var isGroup = columnRows.length > 1;
    if (isGroup) this.$parent.isGroup = true;
    return h("table", {
      "class": 'el-table__header',
      "attrs": {
        "cellspacing": '0',
        "cellpadding": '0',
        "border": '0'
      }
    }, [h("colgroup", [this._l(this.columns, function (column) {
      return h("col", {
        "attrs": {
          "name": column.id
        }
      });
    })]), h("thead", [this._l(columnRows, function (columns, rowIndex) {
      return h("tr", {
        "style": _this.getHeaderRowStyle(rowIndex),
        "class": _this.getHeaderRowClass(rowIndex)
      }, [_this._l(columns, function (column, cellIndex) {
        return h("th", {
          "attrs": {
            "colspan": column.colSpan,
            "rowspan": column.rowSpan
          },
          "on": {
            "mousemove": function mousemove($event) {
              return _this.handleMouseMove($event, column, cellIndex);
            },
            "mouseout": _this.handleMouseOut,
            "mousedown": function mousedown($event) {
              return _this.handleMouseDown($event, column);
            },
            "mouseenter": function mouseenter($event) {
              return _this.handleCellMouseEnter($event, column);
            },
            "click": function click($event) {
              return _this.handleHeaderClick($event, column);
            }
          },
          "style": _this.getHeaderCellStyle(rowIndex, cellIndex, columns, column),
          "class": _this.getHeaderCellClass(rowIndex, cellIndex, columns, column)
        }, [h("div", {
          "class": ['cell', column.filteredValue && column.filteredValue.length > 0 ? 'highlight' : '', column.labelClassName, {
            'show-header-overflow': _this.store.table.showHeaderOverflow
          }]
        }, [column.renderHeader ? column.renderHeader.call(_this._renderProxy, h, {
          column: column,
          $index: cellIndex,
          store: _this.store,
          _self: _this.$parent.$vnode.context
        }) : column.hasSlotHeader() ? column.slotHeader.call(_this._renderProxy, h, {
          column: column,
          $index: cellIndex,
          store: _this.store,
          _self: _this.$parent.$vnode.context
        }) : column.ishtml ? h('span', {
          domProps: {
            innerHTML: column.label
          }
        }) : (column.sortable || column.filterable) && _this.store.table.showHeaderOverflow ? h("span", {
          "class": ['has-icon-right', {
            'double-icon': column.sortable && column.filterable
          }]
        }, [column.label]) : h("div", {
          "class": 'label'
        }, [column.label]), column.sortable ? h("span", {
          "class": 'caret-wrapper',
          "on": {
            "click": function click($event) {
              return _this.handleSortClick($event, column);
            }
          }
        }, [h("i", {
          "class": 'sort-caret ascending',
          "on": {
            "click": function click($event) {
              return _this.handleSortClick($event, column, 'ascending');
            }
          }
        }), h("i", {
          "class": 'sort-caret descending',
          "on": {
            "click": function click($event) {
              return _this.handleSortClick($event, column, 'descending');
            }
          }
        })]) : '', column.filterable ? h("span", {
          "class": 'el-table__column-filter-trigger',
          "on": {
            "click": function click($event) {
              return _this.handleFilterClick($event, column);
            }
          }
        }, [h("i", {
          "class": ['h-icon-filter', column.filteredValue && column.filteredValue.length > 0 ? 'h-icon-filter_f' : '', column.filterOpened ? 'filter-opened' : '']
        })]) : '', column.selections ? h("span", {
          "class": 'el-table__column-selection-icon',
          "on": {
            "mouseenter": function mouseenter($event) {
              return _this.handleSelectionMouseEnter($event, column);
            }
          }
        }, [h("i", {
          "class": 'h-icon-angle_down_sm'
        })]) : ''])]);
      })]);
    })])]);
  },
  props: {
    fixed: String,
    store: {
      required: true
    },
    defaultSort: {
      type: Object,
      "default": function _default() {
        return {
          prop: '',
          order: ''
        };
      }
    }
  },
  components: {
    ElCheckbox: packages_checkbox,
    ElTag: packages_tag
  },
  computed: {
    table: function table() {
      return this.$parent;
    },
    isAllSelected: function isAllSelected() {
      return this.store.states.isAllSelected;
    },
    columnsCount: function columnsCount() {
      return this.store.states.columns.length;
    },
    leftFixedLeafCount: function leftFixedLeafCount() {
      return this.store.states.fixedLeafColumns.length;
    },
    rightFixedLeafCount: function rightFixedLeafCount() {
      return this.store.states.rightFixedLeafColumns.length;
    },
    columns: function columns() {
      return this.store.states.columns;
    }
  },
  created: function created() {
    this.filterPanels = {};
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.defaultSort.prop) {
      var states = this.store.states;
      states.sortProp = this.defaultSort.prop;
      states.sortOrder = this.defaultSort.order || 'ascending';
      this.$nextTick(function () {
        for (var i = 0, length = _this2.columns.length; i < length; i++) {
          var column = _this2.columns[i];

          if (column.property === states.sortProp) {
            column.order = states.sortOrder;
            states.sortingColumn = column;
            break;
          }
        }

        if (states.sortingColumn) {
          _this2.store.commit('changeSortCondition');
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    var panels = this.filterPanels;

    for (var prop in panels) {
      if (hasOwn(panels, prop) && panels[prop]) {
        panels[prop].$destroy(true);
      }
    }

    if (this.selectionPanel) {
      this.selectionPanel.$destroy(true);
    }
  },
  methods: {
    isCellHidden: function isCellHidden(index, columns) {
      if (this.fixed === true || this.fixed === 'left') {
        return index >= this.leftFixedLeafCount;
      } else if (this.fixed === 'right') {
        var before = 0;

        for (var i = 0; i < index; i++) {
          before += columns[i].colSpan;
        }

        return before < this.columnsCount - this.rightFixedLeafCount;
      } else {
        return index < this.leftFixedLeafCount || index >= this.columnsCount - this.rightFixedLeafCount;
      }
    },
    getHeaderRowStyle: function getHeaderRowStyle(rowIndex) {
      var headerRowStyle = this.table.headerRowStyle;

      if (typeof headerRowStyle === 'function') {
        return headerRowStyle({
          rowIndex: rowIndex
        });
      }

      return headerRowStyle;
    },
    getHeaderRowClass: function getHeaderRowClass(rowIndex) {
      var classes = [];
      var headerRowClassName = this.table.headerRowClassName;

      if (typeof headerRowClassName === 'string') {
        classes.push(headerRowClassName);
      } else if (typeof headerRowClassName === 'function') {
        classes.push(headerRowClassName({
          rowIndex: rowIndex
        }));
      }

      return classes.join(' ');
    },
    getHeaderCellStyle: function getHeaderCellStyle(rowIndex, columnIndex, row, column) {
      var headerCellStyle = this.table.headerCellStyle;

      if (typeof headerCellStyle === 'function') {
        return headerCellStyle({
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        });
      }

      return headerCellStyle;
    },
    getHeaderCellClass: function getHeaderCellClass(rowIndex, columnIndex, row, column) {
      var classes = [column.id, column.order, column.headerAlign, column.className, column.labelClassName];

      if (rowIndex === 0 && this.isCellHidden(columnIndex, row)) {
        classes.push('is-hidden');
      }

      if (!column.children) {
        classes.push('is-leaf');
      }

      if (column.sortable) {
        classes.push('is-sortable');
      }

      if (column.filterable) {
        classes.push('is-filterable');
      }

      var headerCellClassName = this.table.headerCellClassName;

      if (typeof headerCellClassName === 'string') {
        classes.push(headerCellClassName);
      } else if (typeof headerCellClassName === 'function') {
        classes.push(headerCellClassName({
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        }));
      }

      return classes.join(' ');
    },
    toggleAllSelection: function toggleAllSelection() {
      this.store.commit('toggleAllSelection');
    },
    handleFilterClick: function handleFilterClick(event, column) {
      event.stopPropagation();
      var target = event.target;
      var cell = target;

      while (cell.tagName !== 'TH') {
        cell = cell.parentNode;
      }

      var table = this.$parent;
      var filterPanel = this.filterPanels[column.id];

      if (filterPanel && column.filterOpened) {
        filterPanel.showPopper = false;
        return;
      }

      if (!filterPanel) {
        filterPanel = new external_vue_default.a(filter_panel);
        this.filterPanels[column.id] = filterPanel;

        if (column.filterPlacement) {
          filterPanel.placement = column.filterPlacement;
        }

        filterPanel.table = table;
        filterPanel.cell = cell;
        filterPanel.column = column;
        !this.$isServer && filterPanel.$mount(document.createElement('div'));
      }

      this.closeAllFilterPanel();
      setTimeout(function () {
        filterPanel.showPopper = true;
      }, 16);
    },
    closeAllFilterPanel: function closeAllFilterPanel() {
      Object.values(this.filterPanels).forEach(function (panel) {
        panel.showPopper = false;
      });
    },
    handleSelectionMouseEnter: function handleSelectionMouseEnter(event, column) {
      event.stopPropagation();
      var target = event.target;
      var table = this.$parent;
      var selectionPanel = this.selectionPanel;

      if (!selectionPanel) {
        selectionPanel = new external_vue_default.a(selection_panel);
        this.selectionPanel = selectionPanel;
        selectionPanel.table = table;
        selectionPanel.target = target;
        selectionPanel.column = column;
        !this.$isServer && selectionPanel.$mount(document.createElement('div'));
      }

      setTimeout(function () {
        selectionPanel.showPopper = true;
      }, 16);
    },
    handleHeaderClick: function handleHeaderClick(event, column) {
      if (column.sortable) {
        this.handleSortClick(event, column);
      } else if (column.filters) {
        this.handleFilterClick(event, column);
      }

      this.$parent.$emit('header-click', column, event);
    },
    handleMouseDown: function handleMouseDown(event, column) {
      var _this3 = this;

      if (this.$isServer) return;
      if (column.children && column.children.length > 0) return;
      /* istanbul ignore if */

      if (this.draggingColumn) {
        this.dragging = true;
        this.$parent.resizeProxyVisible = true;
        var table = this.$parent;
        var tableEl = table.$el;
        var tableLeft = tableEl.getBoundingClientRect().left;
        var columnEl = this.$el.querySelector("th.".concat(column.id));
        var columnRect = columnEl.getBoundingClientRect();
        var minLeft = columnRect.left - tableLeft + 30;
        addClass(columnEl, 'noclick');
        this.dragState = {
          startMouseLeft: event.clientX,
          startLeft: columnRect.right - tableLeft,
          startColumnLeft: columnRect.left - tableLeft,
          tableLeft: tableLeft
        };
        var resizeProxy = table.$refs.resizeProxy;
        resizeProxy.style.left = this.dragState.startLeft + 'px';

        document.onselectstart = function () {
          return false;
        };

        document.ondragstart = function () {
          return false;
        };

        var handleMouseMove = function handleMouseMove(event) {
          var deltaLeft = event.clientX - _this3.dragState.startMouseLeft;
          var proxyLeft = _this3.dragState.startLeft + deltaLeft;
          resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px';
        };

        var handleMouseUp = function handleMouseUp() {
          if (_this3.dragging) {
            var _this3$dragState = _this3.dragState,
                startColumnLeft = _this3$dragState.startColumnLeft,
                startLeft = _this3$dragState.startLeft;
            var finalLeft = parseInt(resizeProxy.style.left, 10);
            var columnWidth = finalLeft - startColumnLeft;

            if (column.minWidth && columnWidth < column.minWidth) {
              columnWidth = column.minWidth;
            }

            column.width = column.realWidth = columnWidth;
            table.$emit('header-dragend', column.width, startLeft - startColumnLeft, column, event);

            _this3.store.scheduleLayout(true);

            document.body.style.cursor = '';
            _this3.dragging = false;
            _this3.draggingColumn = null;
            _this3.dragState = {};
            table.resizeProxyVisible = false;
          }

          document.removeEventListener('mousemove', handleMouseMove);
          document.removeEventListener('mouseup', handleMouseUp);
          document.onselectstart = null;
          document.ondragstart = null;
          setTimeout(function () {
            removeClass(columnEl, 'noclick');
          }, 0);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
      }
    },
    handleMouseMove: function handleMouseMove(event, column, cellIndex) {
      if (column.children && column.children.length > 0) return;
      var target = event.target;

      while (target && target.tagName !== 'TH') {
        target = target.parentNode;
      } // 最后一列不可拖拽


      if (cellIndex === this.columns.length - 1) return;
      if (!column || !column.resizable) return;

      if (!this.dragging) {
        var rect = target.getBoundingClientRect();

        if (rect.width > 12 && rect.right - event.pageX < 8) {
          target.style.cursor = 'col-resize';
          this.draggingColumn = column;
        } else if (!this.dragging) {
          target.style.cursor = '';
          this.draggingColumn = null;
        }
      }
    },
    handleMouseOut: function handleMouseOut() {
      if (this.$isServer) return;
      document.body.style.cursor = '';
    },

    /**
     * 当showHeaderOverflow为true时，为header设置title
     *  add by yangzhini 2018-08-03
     **/
    handleCellMouseEnter: function handleCellMouseEnter(event, column) {
      // const tdValue = event.target.innerText;
      var cell = event.target;

      while (cell && cell.tagName.toUpperCase() !== 'HTML') {
        if (cell.tagName.toUpperCase() === 'TH') {
          break;
        }

        cell = cell.parentNode;
      }

      var cellChild = event.target.querySelector('.cell');
      var labelChild = event.target.querySelector('.label');
      var labelItem = labelChild || cellChild;

      if (column.sortable || column.filterable) {
        labelItem = cellChild.querySelector('.has-icon-right');
      }
      /**
       * IE 下当 labelItem.getBoundingClientRect().width 为小数时
       * clientWidth 根据实际宽度四舍五入，而 scrollWidth 比 clientWidth 大 1px
       * 故存在内容未溢出而显示 title 的情况
       * 此处暂时不做兼容处理
       * add by yangzhini 2019-05-14
       **/


      if (labelItem.clientWidth < labelItem.scrollWidth) {
        if (hasClass(cellChild, 'show-header-overflow')) {
          cell.setAttribute('title', cell.innerText.trim());
        }
      } else if (cell.getAttribute('title')) {
        cell.removeAttribute('title');
      }
    },
    toggleOrder: function toggleOrder(order) {
      return !order ? 'ascending' : order === 'ascending' ? 'descending' : null;
    },
    handleSortClick: function handleSortClick(event, column, givenOrder) {
      event.stopPropagation();
      var order = givenOrder || this.toggleOrder(column.order);
      var target = event.target;

      while (target && target.tagName !== 'TH') {
        target = target.parentNode;
      }

      if (target && target.tagName === 'TH') {
        if (hasClass(target, 'noclick')) {
          removeClass(target, 'noclick');
          return;
        }
      }

      if (!column.sortable) return;
      var states = this.store.states;
      var sortProp = states.sortProp;
      var sortOrder;
      var sortingColumn = states.sortingColumn;

      if (sortingColumn !== column) {
        if (sortingColumn) {
          sortingColumn.order = null;
        }

        states.sortingColumn = column;
        sortProp = column.property;
      }

      if (!order) {
        sortOrder = column.order = null;
        states.sortingColumn = null;
        sortProp = null;
      } else {
        sortOrder = column.order = order;
      }

      states.sortProp = sortProp;
      states.sortOrder = sortOrder;
      this.store.commit('changeSortCondition');
    }
  },
  data: function data() {
    return {
      draggingColumn: null,
      dragging: false,
      dragState: {}
    };
  }
});
// CONCATENATED MODULE: ./packages/table/src/table-footer.js











/* harmony default export */ var table_footer = ({
  name: 'ElTableFooter',
  mixins: [layout_observer],
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var sums = [];
    this.columns.forEach(function (column, index) {
      if (index === 0) {
        sums[index] = _this.sumText;
        return;
      }

      var values = _this.store.states.data.map(function (item) {
        return Number(item[column.property]);
      });

      var precisions = [];
      var notNumber = true;
      values.forEach(function (value) {
        if (!isNaN(value)) {
          notNumber = false;
          var decimal = ('' + value).split('.')[1];
          precisions.push(decimal ? decimal.length : 0);
        }
      });
      var precision = Math.max.apply(null, precisions);

      if (!notNumber) {
        sums[index] = values.reduce(function (prev, curr) {
          var value = Number(curr);

          if (!isNaN(value)) {
            return parseFloat((prev + curr).toFixed(Math.min(precision, 20)));
          } else {
            return prev;
          }
        }, 0);
      } else {
        sums[index] = '';
      }
    });
    return h("table", {
      "class": 'el-table__footer',
      "attrs": {
        "cellspacing": '0',
        "cellpadding": '0',
        "border": '0'
      }
    }, [h("colgroup", [this._l(this.columns, function (column) {
      return h("col", {
        "attrs": {
          "name": column.id
        }
      });
    })]), h("tbody", [h("tr", [this._l(this.columns, function (column, cellIndex) {
      return h("td", {
        "attrs": {
          "colspan": column.colSpan,
          "rowspan": column.rowSpan
        },
        "class": [column.id, column.headerAlign, column.className || '', !column.children ? 'is-leaf' : '', column.labelClassName]
      }, [h("div", {
        "class": ['cell', column.labelClassName]
      }, [_this.summaryMethod ? _this.summaryMethod({
        columns: _this.columns,
        data: _this.store.states.data
      })[cellIndex] : sums[cellIndex]])]);
    })])])]);
  },
  props: {
    fixed: String,
    store: {
      required: true
    },
    summaryMethod: Function,
    sumText: String,
    border: Boolean,
    defaultSort: {
      type: Object,
      "default": function _default() {
        return {
          prop: '',
          order: ''
        };
      }
    }
  },
  computed: {
    table: function table() {
      return this.$parent;
    },
    isAllSelected: function isAllSelected() {
      return this.store.states.isAllSelected;
    },
    columnsCount: function columnsCount() {
      return this.store.states.columns.length;
    },
    // leftFixedLeafCount() {
    //   return this.store.states.fixedLeafColumns.length;
    // },
    // rightFixedLeafCount() {
    //   return this.store.states.rightFixedLeafColumns.length;
    // },
    columns: function columns() {
      if (this.fixed === true || this.fixed === 'left') {
        return this.store.states.fixedLeafColumns;
      } else if (this.fixed === 'right') {
        return this.store.states.rightFixedLeafColumns;
      }

      return this.store.states.columns;
    }
  },
  methods: {// isCellHidden(index, columns) {
    //   if (this.fixed === true || this.fixed === 'left') {
    //     return index >= this.leftFixedLeafCount;
    //   } else if (this.fixed === 'right') {
    //     let before = 0;
    //     for (let i = 0; i < index; i++) {
    //       before += columns[i].colSpan;
    //     }
    //     return before < this.columnsCount - this.rightFixedLeafCount;
    //   } else {
    //     return (
    //       index < this.leftFixedLeafCount ||
    //       index >= this.columnsCount - this.rightFixedLeafCount
    //     );
    //   }
    // }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=script&lang=js&











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import ElCheckbox from 'hui/packages/checkbox';











var tableIdSeed = 1;
/* harmony default export */ var tablevue_type_script_lang_js_ = ({
  name: 'ElTable',
  components: {
    TableHeader: table_header,
    TableFooter: table_footer,
    TableBody: table_body,
    // ElCheckbox,
    ElScrollbar: scrollbar
  },
  mixins: [locale],
  props: {
    data: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    width: {
      type: [String, Number],
      "default": null
    },
    height: {
      type: [String, Number],
      "default": null
    },
    maxHeight: {
      type: [String, Number],
      "default": null
    },
    fit: {
      type: Boolean,
      "default": true
    },
    stripe: {
      type: Boolean,
      "default": null
    },
    border: {
      type: Boolean,
      "default": null
    },
    rowKey: {
      type: [String, Function],
      "default": null
    },
    context: {
      type: null,
      "default": null
    },
    showHeader: {
      type: Boolean,
      "default": true
    },
    showSummary: {
      type: Boolean,
      "default": null
    },
    sumText: {
      type: String,
      "default": null
    },
    summaryMethod: {
      type: Function,
      "default": null
    },
    rowClassName: {
      type: [String, Function],
      "default": null
    },
    rowStyle: {
      type: [Object, Function],
      "default": null
    },
    cellClassName: {
      type: [String, Function],
      "default": null
    },
    cellStyle: {
      type: [Object, Function],
      "default": null
    },
    headerRowClassName: {
      type: [String, Function],
      "default": null
    },
    headerRowStyle: {
      type: [Object, Function],
      "default": null
    },
    headerCellClassName: {
      type: [String, Function],
      "default": null
    },
    headerCellStyle: {
      type: [Object, Function],
      "default": null
    },
    highlightCurrentRow: {
      type: Boolean,
      "default": null
    },
    currentRowKey: {
      type: [String, Number],
      "default": null
    },
    emptyText: {
      type: String,
      "default": null
    },
    expandRowKeys: {
      type: Array,
      "default": null
    },
    defaultExpandAll: {
      type: Boolean,
      "default": null
    },
    defaultSort: {
      type: Object,
      "default": function _default() {
        return {
          prop: '',
          order: ''
        };
      }
    },
    // 设置默认的排序规则 add by yangzhini 2019-04-18
    defaultSortMethod: {
      type: Function,
      "default": null
    },
    alwaysShowBar: {
      type: Boolean,
      "default": null
    },
    // 始终显示滚动条还是鼠标移入才显示
    forceScroll: {
      // 在不指定高度和最大高度时是否强制美化滚动条，如果是，则需要指定表格外部容器高度
      type: [Boolean, String],
      "default": false
    },
    showLoading: {
      // 分页请求时是否显示加载中
      type: Boolean,
      "default": true
    },
    spanMethod: {
      type: Function,
      "default": null
    },
    showHeaderOverflow: {
      // 当header中内容过长被隐藏时显示title add by yangzhini 2018-08-02
      type: Boolean,
      "default": true
    },
    showOverflowTooltip: {
      type: Boolean,
      "default": null
    },
    showOverflowTitle: {
      // 默认单元格内容溢出时隐藏，展示title modify by yangzhini 2019-03-21
      type: Boolean,
      "default": true
    },
    // 设置是否开启虚拟滚动 add by yangzhini 2019-09-05
    enableVirtualScroll: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    var store = new table_store(this, {
      rowKey: this.rowKey,
      defaultExpandAll: this.defaultExpandAll,
      defaultSortMethod: this.defaultSortMethod
    });
    var layout = new table_layout({
      store: store,
      table: this,
      fit: this.fit,
      showHeader: this.showHeader
    });
    return {
      store: store,
      layout: layout,
      renderExpanded: null,
      resizeProxyVisible: false,
      isShowLoading: false,

      /* 外部传入的force-scroll原本是boolean型，
       * 现改为boolean和string均可，
       * 那么以前的force-scroll直接写个属性名的方式声明布尔型会导致传入undefined
       * 为了兼容已有项目，这里声明内部变量予以拦截
       * */
      niceScroll: true,

      /**
       * 移动到el-table__fixed也出现滚动条，为了不影响alwaysShowBar；新增一个参数控制
       */
      isFixBarScrollShow: false,
      // fixedShadowHeight: '',
      resizeState: {
        width: null,
        height: null
      },
      // 是否拥有多级表头
      isGroup: false,
      scrollTop: 0,
      bodyWrapperHeight: 1080
    };
  },
  computed: {
    bodyWrapper: function bodyWrapper() {
      return this.$refs.bodyWrapper;
    },
    shouldUpdateHeight: function shouldUpdateHeight() {
      return this.height || this.maxHeight || this.fixedColumns.length > 0 || this.rightFixedColumns.length > 0;
    },
    selection: function selection() {
      return this.store.states.selection;
    },
    columns: function columns() {
      return this.store.states.columns;
    },
    tableData: function tableData() {
      return this.store.states.data;
    },
    fixedColumns: function fixedColumns() {
      return this.store.states.fixedColumns || [];
    },
    rightFixedColumns: function rightFixedColumns() {
      return this.store.states.rightFixedColumns;
    },
    wrapStyle: function wrapStyle() {
      var style = [];

      if (this.maxHeight) {
        var _maxHeight = this.maxHeight;

        if (typeof _maxHeight === 'string') {
          _maxHeight = +_maxHeight.replace('px', '');
        }

        style = [{
          'max-height': (this.showHeader ? _maxHeight - this.layout.headerHeight - this.layout.footerHeight : _maxHeight - this.layout.footerHeight) + 'px'
        }];
      }

      return style;
    },
    bodyHeight: function bodyHeight() {
      var style = {};

      if (this.height) {
        style = {
          height: this.layout.bodyHeight ? this.layout.bodyHeight + 'px' : ''
        };
      } else if (this.maxHeight) {
        var _maxHeight = this.maxHeight;

        if (typeof _maxHeight === 'string') {
          _maxHeight = +_maxHeight.replace('px', '');
        }

        style = {
          'max-height': (this.showHeader ? _maxHeight - this.layout.headerHeight - this.layout.footerHeight : _maxHeight - this.layout.footerHeight) + 'px'
        }; // this.setScrollStyle();
      } else if (this.niceScroll && this.niceScroll !== 'horizontal') {
        // 兼容 IE 下纵向无法滚动的问题
        style = {
          'flex-basis': '100%',
          'min-height': '0'
        };
      }

      return style;
    },
    bodyWidth: function bodyWidth() {
      var bodyWidth = this.layout.bodyWidth;
      return bodyWidth ? bodyWidth + 'px' : '';
    },
    fixedWidth: function fixedWidth() {
      var fixedWidth = this.layout.fixedWidth;
      return fixedWidth ? fixedWidth + 'px' : '';
    },
    rightFixedWidth: function rightFixedWidth() {
      var rightFixedWidth = this.layout.rightFixedWidth;
      return rightFixedWidth ? rightFixedWidth + 'px' : '';
    },
    fixedBodyHeight: function fixedBodyHeight() {
      var style = {};

      if (this.height || this.niceScroll) {
        style = {
          height: this.layout.fixedBodyHeight ? this.layout.fixedBodyHeight + 'px' : ''
        };
      } else if (this.maxHeight) {
        var _maxHeight = this.maxHeight;

        if (typeof _maxHeight === 'string') {
          _maxHeight = +_maxHeight.replace('px', '');
        }

        if (this.showHeader) {
          _maxHeight -= this.layout.headerHeight;
        }

        _maxHeight -= this.layout.footerHeight;
        style = {
          'max-height': _maxHeight + 'px'
        };
      }

      style.top = this.layout.headerHeight + 'px';
      return style;
    },
    fixedHeight: function fixedHeight() {
      var style = {};

      if (this.maxHeight) {
        style = {
          bottom: 0
        };
      } else {
        style = {
          height: this.layout.tableHeight ? this.layout.tableHeight + 'px' : ''
        };
      }

      return style;
    },
    fixedShadowHeight: function fixedShadowHeight() {
      var tableHeight = this.layout.tableHeight;
      return tableHeight ? tableHeight + 'px' : '';
    },
    isShowScrollbar: function isShowScrollbar() {
      var isShow = this.height || this.maxHeight || !!this.niceScroll;
      return !!isShow;
    },
    isVirtualScroll: function isVirtualScroll() {
      return this.isShowScrollbar && this.enableVirtualScroll && this.niceScroll !== 'horizontal';
    },
    isShowEmptyText: function isShowEmptyText() {
      var empty = !this.isShowLoading && (!this.data || this.data.length === 0 || !this.tableData || this.tableData.length === 0);
      empty && this.fixEmptyScrollViewHeight();
      return empty;
    }
  },
  watch: {
    height: {
      immediate: true,
      handler: function handler(value) {
        this.layout.setHeight(value);
        this.setScrollStyle();
      }
    },
    maxHeight: {
      immediate: true,
      handler: function handler(value) {
        this.layout.setMaxHeight(value);
        this.setScrollStyle();
      }
    },
    currentRowKey: {
      immediate: true,
      handler: function handler(value) {
        var _this = this;

        if (!this.rowKey) return;
        this.$nextTick(function () {
          _this.store.setCurrentRowKey(value);
        });
      }
    },
    data: {
      immediate: true,
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this.store.commit('setData', val);

        if (this.$ready) {
          this.doLayout();
          this.$refs.tableScrollbar && this.$refs.tableScrollbar.update();
        }
      }
    },
    expandRowKeys: {
      immediate: true,
      handler: function handler(newVal) {
        if (newVal) {
          this.store.setExpandRowKeys(newVal);
        }
      }
    },
    isShowEmptyText: function isShowEmptyText(v) {
      v && this.fixEmptyScrollViewHeight();
    },
    columns: function columns(c, p) {
      /**
       * modify by zhangxiaogang
       * 2018-06-07
       * info: 当列宽自适应时，且列个数由少到多会出现宽度分布不均匀的问题，
       *    此情况下将realWidth重置为初始化状态即可
       */
      if (p.length > 0 && p.length !== c.length) {
        this.columns.forEach(function (column) {
          column.realWidth = column.width || column.minWidth;
        });
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.tableId = 'el-table_' + tableIdSeed + '_'; // this.debouncedLayout = debounce(50, () => this.doLayout());

    this.debouncedLayout = debounce_default()(50, function (debouncedLayout) {
      return _this2.doLayout(debouncedLayout);
    });
    this.niceScroll = this.forceScroll;

    if (this.niceScroll === '') {
      this.niceScroll = true;
    }
  },
  destroyed: function destroyed() {
    if (this.resizeListener) {
      removeResizeListener(this.$el, this.resizeListener);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.bindEvents();

      _this3.doLayout(); // 在 nextTick 调用是为了修复 IE 下无法获取 bodyWidth 的问题   add by yangzhini  2020-05-11

    });
    this.store.updateColumns();
    this.resizeState = {
      width: this.$el.offsetWidth,
      height: this.$el.offsetHeight
    }; // init filters

    this.columns.forEach(function (column) {
      if (column.filteredValue && column.filteredValue.length) {
        _this3.store.commit('filterChange', {
          column: column,
          values: column.filteredValue,
          silent: true
        });
      }
    });
    this.$ready = true;
    this.setScrollStyle();
  },
  methods: {
    setCurrentRow: function setCurrentRow(row) {
      this.store.commit('setCurrentRow', row);
    },
    toggleRowSelection: function toggleRowSelection(row, selected) {
      this.store.toggleRowSelection(row, selected);
      this.store.updateAllSelected();
    },
    toggleRowExpanded: function toggleRowExpanded(row, expanded) {
      this.store.toggleRowExpanded(row, expanded);
    },
    clearSelection: function clearSelection() {
      this.store.clearSelection();
    },
    handleMouseLeave: function handleMouseLeave() {
      this.store.commit('setHoverRow', null);
      if (this.hoverState) this.hoverState = null;
    },
    // updateScrollY() {
    //   this.layout.updateScrollY();
    // },

    /**
     * scrollbar的横向滚动事件
     * add by zhangxiaogang 2017-09-27
     * @param {Object} s {scrollLeft: wrap.scrollLeft, scrollTop: wrap.scrollTop} 滚动条上下边距距离
     */
    onScrollingX: function onScrollingX(s) {
      // 触发用户传入的滚动和横向滚动事件 (若有)
      var _this$$refs = this.$refs,
          headerWrapper = _this$$refs.headerWrapper,
          footerWrapper = _this$$refs.footerWrapper;
      var scrollLeft = s.scrollLeft,
          percentX = s.percentX;
      if (headerWrapper) headerWrapper.scrollLeft = s.scrollLeft;
      if (footerWrapper) footerWrapper.scrollLeft = s.scrollLeft;
      this.$emit('on-scrolling-x', scrollLeft, percentX);
      this.$emit('on-scrolling', s);
    },

    /**
     * scrollbar的纵向滚动事件
     * add by zhangxiaogang 2017-09-27
     * @param {Object} s {scrollLeft: wrap.scrollLeft, scrollTop: wrap.scrollTop} 滚动条上下边距距离
     */
    onScrollingY: function onScrollingY(s) {
      // 触发用户传入的滚动和纵向滚动事件 (若有)
      var _this$$refs2 = this.$refs,
          fixedBodyWrapper = _this$$refs2.fixedBodyWrapper,
          rightFixedBodyWrapper = _this$$refs2.rightFixedBodyWrapper;
      var scrollTop = s.scrollTop,
          percentY = s.percentY;

      if (this.isVirtualScroll) {
        this.scrollTop = scrollTop;
         false && false;
      }

      if (fixedBodyWrapper) fixedBodyWrapper.scrollTop = s.scrollTop;
      if (rightFixedBodyWrapper) rightFixedBodyWrapper.scrollTop = s.scrollTop;
      this.$emit('on-scrolling-y', scrollTop, percentY);
      this.$emit('on-scrolling', s);
    },
    bindEvents: function bindEvents() {
      var _this4 = this;

      var _this$$refs3 = this.$refs,
          fixedBodyWrapper = _this$$refs3.fixedBodyWrapper,
          rightFixedBodyWrapper = _this$$refs3.rightFixedBodyWrapper;
      /**
       * modify by yangzhini
       * 2019-02-13
       * info: 修复固定列区域鼠标上下滚动无效的问题
       */

      var scrollFixedBodyWrapper = function scrollFixedBodyWrapper(event) {
        var data = normalizeWheel(event);
        var wrap = _this4.$refs.tableScrollbar.$refs.wrap;

        if (Math.abs(data.spinY) > 0) {
          var currentScrollTop = wrap.scrollTop;

          if (data.pixelY < 0 && currentScrollTop !== 0) {
            event.preventDefault();
          }

          if (data.pixelY > 0 && wrap.scrollHeight - wrap.clientHeight > currentScrollTop) {
            event.preventDefault();
          }

          wrap.scrollTop += Math.ceil(data.pixelY / 5);
        } else {
          wrap.scrollLeft += Math.ceil(data.pixelX / 5);
        }
      };

      if (fixedBodyWrapper) {
        mousewheel(fixedBodyWrapper, throttle_default()(16, scrollFixedBodyWrapper));
      }

      if (rightFixedBodyWrapper) {
        mousewheel(rightFixedBodyWrapper, throttle_default()(16, scrollFixedBodyWrapper));
      }

      if (this.fit) {
        resize_event_addResizeListener(this.$el, this.resizeListener);
      }
    },
    resizeListener: function resizeListener() {
      if (!this.$ready) return;
      var shouldUpdateLayout = false;
      var el = this.$el;
      var _this$resizeState = this.resizeState,
          oldWidth = _this$resizeState.width,
          oldHeight = _this$resizeState.height;
      var width = el.offsetWidth;

      if (oldWidth !== width) {
        shouldUpdateLayout = true;
      }

      var height = el.offsetHeight;

      if ((this.height || this.shouldUpdateHeight) && oldHeight !== height) {
        shouldUpdateLayout = true;
      }

      if (shouldUpdateLayout) {
        this.resizeState.width = width;
        this.resizeState.height = height;
        this.doLayout();
      }
    },
    doLayout: function doLayout(dragResize) {
      var _this5 = this;

      this.layout.update(dragResize);

      if (this.shouldUpdateHeight) {
        this.layout.updateHeight();
      }

      if (this.isVirtualScroll || this.store.states.isComplex) {
        this.$nextTick(function () {
          // 虚拟滚动：获取可视区域高度并更新行高数据
          _this5.bodyWrapperHeight = _this5.$refs.bodyWrapper ? _this5.$refs.bodyWrapper.clientHeight : 1080;

          _this5.store.getTableRowsHeight();
        });
      }
    },

    /**
     * 获取表格当前渲染的数据
     * add by zhangxiaogang 2017-11-28
     * @param {Number} index 行号，从0开始，不传则获取全部数据
     */
    getData: function getData(index) {
      var d = this.data;

      if (typeof index === 'undefined' || isNaN(index)) {
        return d;
      } else if (index > d.length - 1) {
        // 大于数组长度则倒序查找
        var l = d.length - 1;
        var i = index % l;
        return d[l - i];
      } else {
        return d[index];
      }
    },

    /**
     * 更新表格指定行的数据，index指定起始行，再根据data长度决定更新哪些行
     * add by zhangxiaogang 2017-11-28
     * @param {Array, Object} data 要更新的数据，可以是数组也可以是对象，数组则表示更新多行，对象则表示只更新一行
     * @param {Number} index 要更新的起始行号，从0开始
     */
    setData: function setData(data) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (!Array.isArray(data) && {}.toString.call(data) !== '[object Object]') {
        throw new Error('table func setDate first arguments type must be Array or Object');
      }

      if ({}.toString.call(data) === '[object Object]') {
        data = [data];
      }

      var d = this.data;
      var l = d.length - 1;

      if (isNaN(index)) {
        index = 0;
      } else if (index > l) {
        // 大于数组长度则倒序查找
        var i = index % l;
        index = l - i;
      }

      d.splice.apply(d, [index, data.length].concat(_toConsumableArray(data)));
    },

    /**
     * 处理多场景下的美化滚动条
     */
    setScrollStyle: function setScrollStyle() {
      var _this6 = this;

      // 指定了max-height时滚动条容器对应加上max-height
      this.$nextTick(function () {
        var scrollWrap = _this6.$el.querySelector('.el-table-scrollbar__wrap');

        if (!scrollWrap) return;
        /**
         * 没有指定高度也无最大高度，让表格自适应外部容器高度且内容超出时美化滚动条
         * zhangxiaogang  2017-11-7
         */

        if (!_this6.height && !_this6.maxHeight && _this6.niceScroll) {
          // 仅横向滚动，纵向自适应无滚动
          if (_this6.niceScroll === 'horizontal') {
            var $tableTixed = _this6.$el.querySelector('.el-table__fixed');

            var $tableTixedRight = _this6.$el.querySelector('.el-table__fixed-right');

            if ($tableTixed) {
              $tableTixed.style.overflow = 'hidden';
            }

            if ($tableTixedRight) {
              $tableTixedRight.style.overflow = 'hidden';
            }

            return;
          }

          _this6.$el.style.height = '100%'; // 修复在chrome下能滚动却不显示滚动条的问题

          scrollWrap.style.overflow = 'hidden';
          setTimeout(function () {
            scrollWrap.style.overflow = 'visible';
          }, 0);
        }
      });
    },
    fixEmptyScrollViewHeight: function fixEmptyScrollViewHeight() {
      var _this7 = this;

      this.$nextTick(function () {
        var scrollView = _this7.$el.querySelector('.el-table-scrollbar__view');

        if (scrollView) {
          scrollView.style.height = '100%';
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tablevue_type_script_lang_js_ = (tablevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/table/src/table.vue





/* normalize component */

var table_component = normalizeComponent(
  src_tablevue_type_script_lang_js_,
  tablevue_type_template_id_213d02c1_render,
  tablevue_type_template_id_213d02c1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_table = (table_component.exports);
// CONCATENATED MODULE: ./packages/table/index.js


/* istanbul ignore next */

src_table.install = function (Vue) {
  Vue.component(src_table.name, src_table);
};

/* harmony default export */ var packages_table = (src_table);
// CONCATENATED MODULE: ./packages/table/src/table-column.js











var columnIdSeed = 1;
var defaults = {
  "default": {
    order: ''
  },
  selection: {
    width: 40,
    minWidth: 40,
    realWidth: 40,
    order: '',
    className: 'el-table-column--selection'
  },
  radio: {
    width: 40,
    minWidth: 40,
    realWidth: 40,
    order: '',
    className: 'el-table-column--radio'
  },
  expand: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ''
  },
  index: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ''
  }
};
var forced = {
  selection: {
    renderHeader: function renderHeader(h, _ref) {
      var store = _ref.store;
      return h("el-checkbox", {
        "nativeOn": {
          "click": this.toggleAllSelection
        },
        "attrs": {
          "value": this.isAllSelected,
          "indeterminate": !store.states.isAllSelected && store.states.selection.length > 0
        }
      });
    },
    renderCell: function renderCell(h, _ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          store = _ref2.store,
          $index = _ref2.$index;
      return h("el-checkbox", {
        "nativeOn": {
          "click": function click(event) {
            return event.stopPropagation();
          }
        },
        "attrs": {
          "value": store.isSelected(row),
          "disabled": column.selectable ? !column.selectable.call(null, row, $index) : false
        },
        "on": {
          "input": function input() {
            store.commit('rowSelectedChanged', row);
          }
        }
      });
    },
    sortable: false,
    resizable: false
  },
  radio: {
    renderHeader: function renderHeader() {
      return '';
    },
    renderCell: function renderCell(h, _ref3) {
      var row = _ref3.row,
          column = _ref3.column,
          store = _ref3.store,
          $index = _ref3.$index;
      return h("el-radio", {
        "nativeOn": {
          "click": function click(event) {
            return event.stopPropagation();
          }
        },
        "attrs": {
          "value": store.states.currentRow,
          "disabled": column.selectable ? !column.selectable.call(null, row, $index) : false,
          "label": row
        },
        "on": {
          "input": function input() {
            store.commit('setCurrentRow', row);
          }
        }
      }, [h("span")]);
    },
    sortable: false,
    resizable: false
  },
  index: {
    renderHeader: function renderHeader(h, _ref4) {
      var column = _ref4.column;
      return column.label || '#';
    },
    renderCell: function renderCell(h, _ref5) {
      var $index = _ref5.$index;
      return h("span", [$index + 1]);
    },
    sortable: false
  },
  expand: {
    renderHeader: function renderHeader() {
      return '';
    },
    renderCell: function renderCell(h, _ref6, proxy, allowExpand) {
      var row = _ref6.row,
          store = _ref6.store;
      if (!allowExpand) return;
      var expanded = store.states.expandRows.indexOf(row) > -1;
      return h("div", {
        "class": 'el-table__expand-icon ' + (expanded ? 'el-table__expand-icon--expanded' : ''),
        "on": {
          "click": function click() {
            return proxy.handleExpandClick(row);
          }
        }
      }, [h("i", {
        "class": 'el-icon h-icon-angle_right_sm'
      })]);
    },
    sortable: false,
    resizable: false,
    className: 'el-table__expand-column'
  }
};

var table_column_getDefaultColumn = function getDefaultColumn(type, options) {
  var column = {};
  merge(column, defaults[type || 'default']);

  for (var name in options) {
    if (hasOwn(options, name)) {
      var value = options[name];

      if (typeof value !== 'undefined') {
        column[name] = value;
      }
    }
  }

  if (type === 'selection' && options.selections) {
    column.width = 64;
    column.minWidth = 64;
    column.realWidth = 64;
  }

  if (!column.minWidth) {
    column.minWidth = 80;
  }

  column.realWidth = column.width || column.minWidth;
  return column;
};

var table_column_DEFAULT_RENDER_CELL = function DEFAULT_RENDER_CELL(h, _ref7) {
  var row = _ref7.row,
      column = _ref7.column;
  var property = column.property;
  var value = property && getPropByPath(row, property).v;

  if (column && column.formatter) {
    return column.formatter(row, column, value);
  }

  return !value && value !== 0 ? '--' : value;
};

/* harmony default export */ var table_column = ({
  name: 'ElTableColumn',
  props: {
    type: {
      type: String,
      "default": 'default'
    },
    label: String,
    className: String,
    labelClassName: String,
    property: String,
    prop: String,
    width: {},
    minWidth: {},
    renderHeader: Function,
    sortable: {
      type: [String, Boolean],
      "default": false
    },
    sortMethod: Function,
    resizable: {
      type: Boolean,
      "default": true
    },
    context: {},
    columnKey: String,
    align: String,
    headerAlign: String,
    showOverflowTooltip: Boolean,
    showOverflowTitle: Boolean,
    fixed: [Boolean, String],
    formatter: Function,
    selectable: Function,
    reserveSelection: Boolean,
    selections: Array,
    filterMethod: Function,
    filteredValue: Array,
    filters: Array,
    filterPlacement: String,
    filterMultiple: {
      type: Boolean,
      "default": true
    },
    ishtml: Boolean,
    allowExpand: {
      type: Function,
      "default": function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      isSubColumn: false,
      columns: []
    };
  },
  beforeCreate: function beforeCreate() {
    this.row = {};
    this.column = {};
    this.$index = 0;
  },
  components: {
    ElCheckbox: packages_checkbox,
    ElRadio: packages_radio,
    ElTag: packages_tag
  },
  computed: {
    owner: function owner() {
      var parent = this.$parent;

      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }

      return parent;
    }
  },
  created: function created() {
    var _this = this;

    var h = this.$createElement;
    this.customRender = this.$options.render;

    this.$options.render = function (h) {
      return h('div', _this.$slots["default"]);
    };

    this.columnId = (this.$parent.tableId || this.$parent.columnId + '_') + 'column_' + columnIdSeed++;
    var parent = this.$parent;
    var owner = this.owner;
    this.isSubColumn = owner !== parent;
    var type = this.type;
    var width = this.width;

    if (width !== undefined) {
      // width = parseInt(width, 10);
      // if (isNaN(width)) {
      //   width = null;
      // }
      if (!/%$/.test(width)) {
        width = parseInt(width, 10);

        if (isNaN(width)) {
          width = null;
        }
      }
    }

    var minWidth = this.minWidth;

    if (minWidth !== undefined) {
      minWidth = parseInt(minWidth, 10);

      if (isNaN(minWidth)) {
        minWidth = 51;
        if (this.sortable === '' || this.sortable) minWidth += 24;
        if (this.filters || this.filterMethod) minWidth += 32;
      }
    } else {
      minWidth = 51;
      if (this.sortable === '' || this.sortable) minWidth += 24;
      if (this.filters || this.filterMethod) minWidth += 32;
    }

    var isColumnGroup = false;

    var _self = this;

    var column = table_column_getDefaultColumn(type, {
      id: this.columnId,
      columnKey: this.columnKey,
      label: this.label,
      className: this.className,
      labelClassName: this.labelClassName,
      property: this.prop || this.property,
      type: type,
      renderCell: null,
      renderHeader: this.renderHeader,
      minWidth: minWidth,
      width: width,
      isColumnGroup: isColumnGroup,
      context: this.context,
      align: this.align ? 'is-' + this.align : null,
      headerAlign: this.headerAlign ? 'is-' + this.headerAlign : this.align ? 'is-' + this.align : null,
      sortable: this.sortable === '' ? true : this.sortable,
      sortMethod: this.sortMethod,
      resizable: this.resizable,
      showOverflowTooltip: this.owner.store.table.showOverflowTooltip || this.showOverflowTooltip,
      showOverflowTitle: this.owner.store.table.showOverflowTitle || this.showOverflowTitle,
      formatter: this.formatter,
      selectable: this.selectable,
      reserveSelection: this.reserveSelection,
      selections: this.selections,
      fixed: this.fixed === '' ? true : this.fixed,
      filterMethod: this.filterMethod,
      filters: this.filters,
      filterable: this.filters || this.filterMethod,
      filterMultiple: this.filterMultiple,
      filterOpened: false,
      filteredValue: this.filteredValue || [],
      filterPlacement: this.filterPlacement || '',
      ishtml: this.ishtml,
      allowExpand: this.allowExpand,
      slotHeader: function slotHeader(h, data) {
        if (!_self.$scopedSlots.header) return;
        return _self.$scopedSlots.header(data);
      },
      hasSlotHeader: function hasSlotHeader() {
        if (!_self.$scopedSlots.header) return false;
        return true;
      }
    });
    merge(column, forced[type] || {});
    this.columnConfig = column;
    var renderCell = column.renderCell;

    if (type === 'expand') {
      owner.renderExpanded = function (h, data) {
        return _self.$scopedSlots["default"] ? _self.$scopedSlots["default"](data) : _self.$slots["default"];
      };

      column.renderCell = function (h, data) {
        var allowExpand = column.allowExpand && column.allowExpand(data.row, data.$index);
        return h("div", {
          "class": 'cell'
        }, [renderCell(h, data, this._renderProxy, allowExpand)]);
      };

      return;
    }

    column.renderCell = function (h, data) {
      var tooltipWidth = data.column.realWidth;

      if (!tooltipWidth) {
        if (/%$/.test(data.column.width)) {
          tooltipWidth = data.column.width;
        } else {
          tooltipWidth = data.column.width + 'px';
        }
      } else {
        tooltipWidth += 'px';
      } // 未来版本移除


      if (_self.$vnode.data.inlineTemplate) {
        renderCell = function renderCell() {
          data._self = _self.context || data._self;

          if (Object.prototype.toString.call(data._self) === '[object Object]') {
            for (var prop in data._self) {
              if (!hasOwn(data, prop)) {
                data[prop] = data._self[prop];
              }
            }
          } // 静态内容会缓存到 _staticTrees 内，不改的话获取的静态数据就不是内部 context


          data._staticTrees = _self._staticTrees;
          data.$options.staticRenderFns = _self.$options.staticRenderFns;
          return _self.customRender.call(data);
        };
      } else if (_self.$scopedSlots["default"]) {
        renderCell = function renderCell() {
          return _self.$scopedSlots["default"](data);
        };

        if (!_self.showOverflowTooltip && !_self.showOverflowTitle) {
          return h("div", {
            "class": 'cell'
          }, [renderCell(h, data)]);
        }
      }

      if (!renderCell) {
        renderCell = table_column_DEFAULT_RENDER_CELL;
      }

      return column.showOverflowTooltip ? h("div", {
        "class": 'cell el-tooltip'
      }, [h("div", {
        "class": 'label'
      }, [renderCell(h, data)])]) : column.showOverflowTitle ? h("div", {
        "class": 'cell show-overflow-title'
      }, [h("div", {
        "class": 'label'
      }, [renderCell(h, data)])]) : h("div", {
        "class": 'cell'
      }, [renderCell(h, data)]);
    };
  },
  destroyed: function destroyed() {
    if (!this.$parent) return;
    var parent = this.$parent;
    this.owner.store.commit('removeColumn', this.columnConfig, this.isSubColumn ? parent.columnConfig : null);
  },
  watch: {
    label: function label(newVal) {
      if (this.columnConfig) {
        this.columnConfig.label = newVal;
      }
    },
    prop: function prop(newVal) {
      if (this.columnConfig) {
        this.columnConfig.property = newVal;
      }
    },
    property: function property(newVal) {
      if (this.columnConfig) {
        this.columnConfig.property = newVal;
      }
    },
    filters: function filters(newVal) {
      if (this.columnConfig) {
        this.columnConfig.filters = newVal;
      }
    },
    filteredValue: function filteredValue(newVal) {
      if (this.columnConfig) {
        this.columnConfig.filteredValue = newVal;
        this.owner.store.commit('filterChange', {
          column: this.columnConfig,
          values: newVal,
          silent: true
        });
      }
    },
    filterMultiple: function filterMultiple(newVal) {
      if (this.columnConfig) {
        this.columnConfig.filterMultiple = newVal;
      }
    },
    align: function align(newVal) {
      if (this.columnConfig) {
        this.columnConfig.align = newVal ? 'is-' + newVal : null;

        if (!this.headerAlign) {
          this.columnConfig.headerAlign = newVal ? 'is-' + newVal : null;
        }
      }
    },
    headerAlign: function headerAlign(newVal) {
      if (this.columnConfig) {
        this.columnConfig.headerAlign = 'is-' + (newVal || this.align);
      }
    },
    width: function width(newVal) {
      if (this.columnConfig) {
        this.columnConfig.width = newVal;
        this.owner.store.scheduleLayout();
      }
    },
    minWidth: function minWidth(newVal) {
      if (this.columnConfig) {
        this.columnConfig.minWidth = newVal;
        this.owner.store.scheduleLayout();
      }
    },
    fixed: function fixed(newVal) {
      if (this.columnConfig) {
        this.columnConfig.fixed = newVal;
        this.owner.store.scheduleLayout();
      }
    },
    sortable: function sortable(newVal) {
      if (this.columnConfig) {
        this.columnConfig.sortable = newVal;
      }
    }
  },
  mounted: function mounted() {
    var owner = this.owner;
    var parent = this.$parent;
    var columnIndex;

    if (!this.isSubColumn) {
      columnIndex = [].indexOf.call(parent.$refs.hiddenColumns.children, this.$el);
    } else {
      columnIndex = [].indexOf.call(parent.$el.children, this.$el);
    }

    owner.store.commit('insertColumn', this.columnConfig, columnIndex, this.isSubColumn ? parent.columnConfig : null);
  }
});
// CONCATENATED MODULE: ./packages/table-column/index.js


/* istanbul ignore next */

table_column.install = function (Vue) {
  Vue.component(table_column.name, table_column);
};

/* harmony default export */ var packages_table_column = (table_column);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/h-paged-table/src/paged-table.vue?vue&type=template&id=1297e08a&
var paged_tablevue_type_template_id_1297e08a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-paged-table"},[_c('div',{staticClass:"el-paged-table__table"},[_vm._t("default",null,{"data":_vm.tableData})],2),_c('el-pagination',{staticClass:"el-paged-table__pagination",attrs:{"page-sizes":_vm.pageSizes,"page-size":_vm.pagination.pageSize,"total":_vm.pagination.total,"page-count":_vm.pagination.pageCount,"current-page":_vm.pagination.currentPage,"layout":_vm.layout,"before-current-change":_vm.beforeCurrentChange,"before-size-change":_vm.beforeSizeChange},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)}
var paged_tablevue_type_template_id_1297e08a_staticRenderFns = []


// CONCATENATED MODULE: ./packages/h-paged-table/src/paged-table.vue?vue&type=template&id=1297e08a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/h-paged-table/src/paged-table.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var paged_tablevue_type_script_lang_js_ = ({
  name: 'HPagedTable',
  props: {
    /**
     * 构建 url 的函数
     * 当 props 的 fetch 未提供时，url 必填（为函数）
     * @param  {Number} pageSize    每页几条
     * @param  {Number} currentPage 第几页
     * @return {String} url 地址
     * @example (pageSize, currentPage, reloadOpt) => `https://api.example.com/items?perPage=${pageSize}&page=${currentPage}`
     */
    url: {
      type: [Function, String],
      "default": ''
    },

    /**
     * 自定义请求函数
     * @param  {String} url         当前 url（由 props 的 url 返回的字符串）
     * @param  {Number} pageSize    每页几条
     * @param  {Number} currentPage 第几页
     * @param  {*} reloadOpt        调用 reload 方法时传进来的参数
     * @return {Promise<*>} 一个 Promise 对象，then 里接到的值为响应返回的数据
     * @example (url, pageSize, currentPage, reloadOpt) => axios.get(url)
     */
    fetch: {
      type: Function,
      "default": function _default(url) {
        return defaultPromise({
          url: url
        });
      }
    },

    /**
     * 当前是否正在请求
     */
    loading: {
      type: Boolean,
      "default": false
    },

    /**
     * 分页跳转发请求前的钩子
     * @param {Number} val    改变后的值
     * @param {Number} oldVal 改变前的值
     * @return {Boolean} 是否继续发请求
     * @example (val, oldVal) => true
     */
    beforeCurrentChange: {
      type: Function,
      "default": function _default() {
        return true;
      }
    },

    /**
     * 每页显示条目个数变化发请求前的钩子
     * @param {Number} val    改变后的值
     * @param {Number} oldVal 改变前的值
     * @return {Boolean} 是否继续发请求
     * @example (val, oldVal) => true
     */
    beforeSizeChange: {
      type: Function,
      "default": function _default() {
        return true;
      }
    },

    /**
     * 获取表格数据的函数
     * @param {*} json 响应返回的数据
     * @return {Array} ElTable 的 props 中 data 所需的数据
     * @example (json) => json.items
     */
    data: {
      type: Function,
      required: true
    },

    /**
     * 获取总条目数的函数
     * @param {*} json 响应返回的数据
     * @return {Number} ElPagination 的 props 中 total 所需的数据
     * @example (json) => json.total
     */
    total: {
      type: Function,
      "default": function _default() {
        return 0;
      }
    },

    /**
     * 获取总页数的函数
     * @param {*} json 响应返回的数据
     * @return {Number} ElPagination 的 props 中 page-count 所需的数据
     * @example (json) => json.pageCount
     */
    pageCount: {
      type: Function,
      "default": function _default() {
        return 0;
      }
    },
    // 以下为 ElPagination 的 props
    layout: {
      type: String,
      "default": 'total, sizes, prev, pager, next, jumper'
    },
    pageSize: {
      type: Number,
      "default": 10
    },
    pageSizes: {
      type: Array,
      "default": function _default() {
        return [10, 20, 30, 40, 50, 100];
      }
    },
    // 用于用户对当前页的设置 add by yangzhini 2018-11-30
    currentPage: {
      type: Number,
      "default": 1
    }
  },
  data: function data() {
    return {
      tableData: [],
      pagination: {
        pageSize: this.pageSize || this.pageSizes[0] || 10,
        total: 0,
        pageCount: 0,
        currentPage: this.currentPage || 1
      }
    };
  },
  watch: {
    pageSize: function pageSize(val) {
      this.pagination.pageSize = val;
    },
    currentPage: function currentPage(val) {
      this.pagination.currentPage = val;
    }
  },
  mounted: function mounted() {
    this.jump();
  },
  methods: {
    /**
     * 重新加载表格
     * @public
     */
    reload: function reload(opt) {
      return this.jump(opt);
    },
    jump: function jump(reloadOpt) {
      var _this = this;

      this.$emit('update:loading', true);
      var _this$pagination = this.pagination,
          pageSize = _this$pagination.pageSize,
          currentPage = _this$pagination.currentPage;
      var url = typeof this.url === 'string' ? this.url : this.url(pageSize, currentPage, reloadOpt);
      return this.fetch(url, pageSize, currentPage, reloadOpt).then(function (json) {
        _this.pagination.total = _this.total(json);
        _this.pagination.pageCount = _this.pageCount(json);
        _this.tableData = _this.data(json);

        _this.$emit('fetch-success', json);
      })["catch"](function (err) {
        return _this.$emit('fetch-error', err);
      }).then(function () {
        return _this.$emit('update:loading', false);
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.$emit('size-change', val);
      this.jump();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.$emit('update:currentPage', val);
      this.$emit('current-change', val);
      this.jump();
    }
  }
});
// CONCATENATED MODULE: ./packages/h-paged-table/src/paged-table.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_paged_tablevue_type_script_lang_js_ = (paged_tablevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/h-paged-table/src/paged-table.vue





/* normalize component */

var paged_table_component = normalizeComponent(
  src_paged_tablevue_type_script_lang_js_,
  paged_tablevue_type_template_id_1297e08a_render,
  paged_tablevue_type_template_id_1297e08a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var paged_table = (paged_table_component.exports);
// CONCATENATED MODULE: ./packages/h-paged-table/index.js


/* istanbul ignore next */

paged_table.install = function (Vue) {
  Vue.component(paged_table.name, paged_table);
};

/* harmony default export */ var h_paged_table = (paged_table);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=template&id=3face8f0&
var pickervue_type_template_id_3face8f0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.ranged)?_c('el-input',_vm._b({directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.handleClose),expression:"handleClose"}],ref:"reference",staticClass:"el-date-editor",class:'el-date-editor--' + _vm.type,attrs:{"readonly":!_vm.editable || _vm.readonly || _vm.type === 'dates',"disabled":_vm.pickerDisabled,"size":_vm.pickerSize,"name":_vm.name,"placeholder":_vm.placeholder,"value":_vm.displayValue,"title":_vm.displayValue,"validate-event":false},on:{"focus":_vm.handleFocus},nativeOn:{"mouseenter":function($event){return _vm.handleMouseEnter($event)},"mouseleave":function($event){_vm.showClose = false},"keydown":function($event){return _vm.handleKeydown($event)},"change":function($event){return _vm.handleChange($event)},"input":function($event){return _vm.handleInput($event)}}},'el-input',_vm.firstInputId,false),[_c('i',{staticClass:"el-input__icon el-date-editor__icon",class:[_vm.showClose ? _vm.clearIcon : _vm.triggerClass],attrs:{"slot":"suffix"},on:{"click":_vm.handleClickSuffixIcon},slot:"suffix"})]):_c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.handleClose),expression:"handleClose"}],ref:"reference",staticClass:"el-date-editor el-range-editor el-input__inner",class:[
    'el-date-editor--' + _vm.type,
    _vm.pickerSize ? ("el-date-editor--" + _vm.pickerSize) : '',
    _vm.pickerDisabled ? 'is-disabled' : '',
    _vm.pickerVisible ? 'is-active' : ''
  ],on:{"click":_vm.handleFocus,"keydown":_vm.handleKeydown,"mouseenter":_vm.handleMouseEnter,"mouseleave":function($event){_vm.showClose = false}}},[_c('input',_vm._b({staticClass:"el-range-input",attrs:{"placeholder":_vm.startPlaceholder,"disabled":_vm.pickerDisabled,"readonly":!_vm.editable || _vm.readonly,"name":_vm.name && _vm.name[0],"autocomplete":"off"},domProps:{"value":_vm.displayValue && _vm.displayValue[0]},on:{"input":_vm.handleStartInput,"change":_vm.handleStartChange,"focus":_vm.handleFocus}},'input',_vm.firstInputId,false)),_vm._t("range-separator",[_c('span',{staticClass:"el-range-separator"},[_vm._v(_vm._s(_vm.rangeSeparator))])]),_c('input',_vm._b({staticClass:"el-range-input",attrs:{"placeholder":_vm.endPlaceholder,"disabled":_vm.pickerDisabled,"readonly":!_vm.editable || _vm.readonly,"name":_vm.name && _vm.name[1],"autocomplete":"off"},domProps:{"value":_vm.displayValue && _vm.displayValue[1]},on:{"input":_vm.handleEndInput,"change":_vm.handleEndChange,"focus":_vm.handleFocus}},'input',_vm.secondInputId,false)),_c('span',{staticClass:"el-input__suffix"},[_c('span',{staticClass:"el-input__suffix-inner"},[_c('i',{staticClass:"el-input__icon el-range__icon el-date-editor__icon",class:[_vm.showClose ? _vm.clearIcon : _vm.triggerClass],on:{"click":_vm.handleClickSuffixIcon}})])])],2)}
var pickervue_type_template_id_3face8f0_staticRenderFns = []


// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=template&id=3face8f0&

// EXTERNAL MODULE: external "core-js/modules/es.string.search.js"
var es_string_search_js_ = __webpack_require__("1c32");

// CONCATENATED MODULE: ./src/utils/date.js
/* Modified from https://github.com/taylorhakes/fecha
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 Taylor Hakes
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 *     The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 *     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/*eslint-disable*/
// 把 YYYY-MM-DD 改成了 yyyy-MM-dd

/**
 * Parse or format dates
 * @class fecha
 */













var fecha = {};
var token = /d{1,4}|Mo|MM?M?M?|yy(?:yy)?|S{1,3}|do|W[o|W]?|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
var twoDigits = /\d\d?/;
var threeDigits = /\d{3}/;
var fourDigits = /\d{4}/;
var word = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;

var date_noop = function noop() {};

function shorten(arr, sLen) {
  var newArr = [];

  for (var i = 0, len = arr.length; i < len; i++) {
    newArr.push(arr[i].substr(0, sLen));
  }

  return newArr;
}

function monthUpdate(arrName) {
  return function (d, v, i18n) {
    var index = i18n[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());

    if (~index) {
      d.month = index;
    }
  };
}

function pad(val, len) {
  val = String(val);
  len = len || 2;

  while (val.length < len) {
    val = '0' + val;
  }

  return val;
}

var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var monthNamesShort = shorten(monthNames, 3);
var dayNamesShort = shorten(dayNames, 3);
fecha.i18n = {
  dayNamesShort: dayNamesShort,
  dayNames: dayNames,
  monthNamesShort: monthNamesShort,
  monthNames: monthNames,
  amPm: ['am', 'pm'],
  oFn: function oFn(D, i18nKey) {
    var reg = /(\$o){1}/;
    var isOrdinal = reg.test(Object(locale_["t"])(i18nKey, D));
    return isOrdinal ? D + ['th', 'st', 'nd', 'rd'][D % 10 > 3 ? 0 : (D - D % 10 !== 10) * D % 10] : Object(locale_["t"])(i18nKey, {
      num: D
    });
  }
};

fecha.isDate = function (date) {
  if (date === null || date === undefined) return false;
  if (isNaN(new Date(date).getTime())) return false;
  if (Array.isArray(date)) return false; // deal with `new Date([ new Date() ]) -> new Date()`

  return true;
};

fecha.getWeekNumber = function (src) {
  if (fecha.isDate(src)) {
    var date = new Date(new Date(src).getTime());
    date.setHours(0, 0, 0, 0); // Thursday in current week decides the year.

    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7); // January 4 is always in week 1.

    var week1 = new Date(date.getFullYear(), 0, 4); // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
    // Rounding should be fine for Daylight Saving Time. Its shift should never be more than 12 hours.

    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
  } else {
    return null;
  }
};

var formatFlags = {
  W: function W(dateObj) {
    var week = fecha.getWeekNumber(dateObj);
    return week;
  },
  WW: function WW(dateObj) {
    var week = fecha.getWeekNumber(dateObj);
    return week < 10 ? '0' + week : week;
  },
  D: function D(dateObj) {
    return dateObj.getDay();
  },
  DD: function DD(dateObj) {
    return pad(dateObj.getDay());
  },
  d: function d(dateObj) {
    return dateObj.getDate();
  },
  dd: function dd(dateObj) {
    return pad(dateObj.getDate());
  },
  ddd: function ddd(dateObj, i18n) {
    return i18n.dayNamesShort[dateObj.getDay()];
  },
  dddd: function dddd(dateObj, i18n) {
    return i18n.dayNames[dateObj.getDay()];
  },
  M: function M(dateObj) {
    return dateObj.getMonth() + 1;
  },
  MM: function MM(dateObj) {
    return pad(dateObj.getMonth() + 1);
  },
  MMM: function MMM(dateObj, i18n) {
    return i18n.monthNamesShort[dateObj.getMonth()];
  },
  MMMM: function MMMM(dateObj, i18n) {
    return i18n.monthNames[dateObj.getMonth()];
  },
  yy: function yy(dateObj) {
    return String(dateObj.getFullYear()).substr(2);
  },
  yyyy: function yyyy(dateObj) {
    return dateObj.getFullYear();
  },
  h: function h(dateObj) {
    return dateObj.getHours() % 12 || 12;
  },
  hh: function hh(dateObj) {
    return pad(dateObj.getHours() % 12 || 12);
  },
  H: function H(dateObj) {
    return dateObj.getHours();
  },
  HH: function HH(dateObj) {
    return pad(dateObj.getHours());
  },
  m: function m(dateObj) {
    return dateObj.getMinutes();
  },
  mm: function mm(dateObj) {
    return pad(dateObj.getMinutes());
  },
  s: function s(dateObj) {
    return dateObj.getSeconds();
  },
  ss: function ss(dateObj) {
    return pad(dateObj.getSeconds());
  },
  S: function S(dateObj) {
    return Math.round(dateObj.getMilliseconds() / 100);
  },
  SS: function SS(dateObj) {
    return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
  },
  SSS: function SSS(dateObj) {
    return pad(dateObj.getMilliseconds(), 3);
  },
  a: function a(dateObj, i18n) {
    return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
  },
  A: function A(dateObj, i18n) {
    return dateObj.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase();
  },
  ZZ: function ZZ(dateObj) {
    var o = dateObj.getTimezoneOffset();
    return (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4);
  },
  "do": function _do(dateObj, i18n) {
    return i18n.oFn(dateObj.getDate(), 'el.datepicker.dayOrdinal');
  },
  Mo: function Mo(dateObj, i18n) {
    return i18n.oFn(dateObj.getMonth() + 1, 'el.datepicker.monthOrdinal');
  },
  Wo: function Wo(dateObj, i18n) {
    var week = fecha.getWeekNumber(dateObj);
    return i18n.oFn(week, 'el.datepicker.weekOrdinal');
  }
};
var parseFlags = {
  d: [twoDigits, function (d, v) {
    d.day = v;
  }],
  M: [twoDigits, function (d, v) {
    d.month = v - 1;
  }],
  yy: [twoDigits, function (d, v) {
    var da = new Date(),
        cent = +('' + da.getFullYear()).substr(0, 2);
    d.year = '' + (v > 68 ? cent - 1 : cent) + v;
  }],
  h: [twoDigits, function (d, v) {
    d.hour = v;
  }],
  m: [twoDigits, function (d, v) {
    d.minute = v;
  }],
  s: [twoDigits, function (d, v) {
    d.second = v;
  }],
  yyyy: [fourDigits, function (d, v) {
    d.year = v;
  }],
  S: [/\d/, function (d, v) {
    d.millisecond = v * 100;
  }],
  SS: [/\d{2}/, function (d, v) {
    d.millisecond = v * 10;
  }],
  SSS: [threeDigits, function (d, v) {
    d.millisecond = v;
  }],
  D: [twoDigits, date_noop],
  ddd: [word, date_noop],
  MMM: [word, monthUpdate('monthNamesShort')],
  MMMM: [word, monthUpdate('monthNames')],
  a: [word, function (d, v, i18n) {
    var val = v.toLowerCase();

    if (val === i18n.amPm[0]) {
      d.isPm = false;
    } else if (val === i18n.amPm[1]) {
      d.isPm = true;
    }
  }],
  ZZ: [/[\+\-]\d\d:?\d\d/, function (d, v) {
    var parts = (v + '').match(/([\+\-]|\d\d)/gi),
        minutes;

    if (parts) {
      minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
      d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
    }
  }]
};
parseFlags.DD = parseFlags.D;
parseFlags.dddd = parseFlags.ddd;
parseFlags["do"] = parseFlags.dd = parseFlags.d;
parseFlags.mm = parseFlags.m;
parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
parseFlags.MM = parseFlags.M;
parseFlags.ss = parseFlags.s;
parseFlags.A = parseFlags.a; // Some common format strings

fecha.masks = {
  "default": 'ddd MMM dd yyyy HH:mm:ss',
  shortDate: 'M/D/yy',
  mediumDate: 'MMM d, yyyy',
  longDate: 'MMMM d, yyyy',
  fullDate: 'dddd, MMMM d, yyyy',
  shortTime: 'HH:mm',
  mediumTime: 'HH:mm:ss',
  longTime: 'HH:mm:ss.SSS'
};
/***
 * Format a date
 * @method format
 * @param {Date|number} dateObj
 * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
 */

fecha.format = function (dateObj, mask, i18nSettings) {
  var i18n = i18nSettings || fecha.i18n;

  if (typeof dateObj === 'number') {
    dateObj = new Date(dateObj);
  }

  if (Object.prototype.toString.call(dateObj) !== '[object Date]' || isNaN(dateObj.getTime())) {
    throw new Error('Invalid Date in fecha.format');
  }

  mask = fecha.masks[mask] || mask || fecha.masks['default'];
  return mask.replace(token, function ($0) {
    return $0 in formatFlags ? formatFlags[$0](dateObj, i18n) : $0.slice(1, $0.length - 1);
  });
};

var isRangeIn = function isRangeIn(str, min, max) {
  var num = +str;

  if (num <= max && num >= min) {
    return true;
  }

  return false;
};
/**
 * Parse a date string into an object, changes - into /
 * @method parse
 * @param {string} dateStr Date string
 * @param {string} format Date parse format
 * @returns {Date|boolean}
 */


fecha.parse = function (dateStr, format, i18nSettings) {
  var i18n = i18nSettings || fecha.i18n;

  if (typeof format !== 'string') {
    throw new Error('Invalid format in fecha.parse');
  }

  format = fecha.masks[format] || format; // Avoid regular expression denial of service, fail early for really long strings
  // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS

  if (dateStr.length > 1000) {
    return false;
  }

  var isValid = true;
  var dateInfo = {};
  format.replace(token, function ($0) {
    if (parseFlags[$0]) {
      var info = parseFlags[$0];
      var index = dateStr.search(info[0]);

      if (!~index) {
        isValid = false;
      } else {
        dateStr.replace(info[0], function (result) {
          info[1](dateInfo, result, i18n);
          dateStr = dateStr.substr(index + result.length);
          return result;
        });
      }
    }

    return parseFlags[$0] ? '' : $0.slice(1, $0.length - 1);
  });

  if (!isValid) {
    return false;
  }

  if (dateInfo.hour && !isRangeIn(dateInfo.hour, 0, 23)) {
    return false;
  }

  if (dateInfo.minute && !isRangeIn(dateInfo.minute, 0, 59)) {
    return false;
  }

  if (dateInfo.second && !isRangeIn(dateInfo.second, 0, 59)) {
    return false;
  }

  var today = new Date();

  if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12) {
    dateInfo.hour = +dateInfo.hour + 12;
  } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
    dateInfo.hour = 0;
  }

  var date;

  if (dateInfo.timezoneOffset != null) {
    dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
    date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
  } else {
    date = new Date(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0);
  }

  return date;
};

/* harmony default export */ var utils_date = (fecha);
// CONCATENATED MODULE: ./packages/date-picker/src/util/index.js

















var util_isEmpty = function isEmpty(val) {
  if (typeof val === 'string') {
    return val.trim() === '';
  }

  return typeof val === 'undefined' || val === null;
};
var isString = function isString(val) {
  return typeof val === 'string' || val instanceof String;
};
var WEEKS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
var MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
var DEFAULT_FORMATS = {
  date: 'yyyy/MM/dd',
  month: 'yyyy/MM',
  datetime: 'yyyy/MM/dd HH:mm:ss',
  time: 'HH:mm:ss',
  week: 'yyyy/MM/dd$',
  timerange: 'HH:mm:ss',
  daterange: 'yyyy/MM/dd',
  monthrange: 'yyyy/MM',
  datetimerange: 'yyyy/MM/dd HH:mm:ss',
  year: 'yyyy'
};

var DATE_FORMATTER = function DATE_FORMATTER(value, format) {
  if (format === 'timestamp') return value.getTime();
  return util_formatDate(value, format);
};

var DATE_PARSER = function DATE_PARSER(text, format) {
  if (format === 'timestamp') return new Date(Number(text));
  return util_parseDate(text, format);
};

var RANGE_FORMATTER = function RANGE_FORMATTER(value, format) {
  if (Array.isArray(value) && value.length === 2) {
    var start = value[0];
    var end = value[1];

    if (start && end) {
      return [DATE_FORMATTER(start, format), DATE_FORMATTER(end, format)];
    }
  }

  return '';
};

var RANGE_PARSER = function RANGE_PARSER(array, format, separator) {
  if (!Array.isArray(array)) {
    array = array.split(separator);
  }

  if (array.length === 2) {
    var range1 = array[0];
    var range2 = array[1];
    return [DATE_PARSER(range1, format), DATE_PARSER(range2, format)];
  }

  return [];
};

var TYPE_VALUE_RESOLVER_MAP = {
  "default": {
    formatter: function formatter(value) {
      if (util_isEmpty(value)) {
        return '';
      }

      return '' + value;
    },
    parser: function parser(text) {
      if (text === undefined || text === '') return null;
      return text;
    }
  },
  week: {
    formatter: function formatter(value, format) {
      var week = utils_date.getWeekNumber(value);
      var trueDate;

      if (Array.isArray(value)) {
        trueDate = new Date(value[0]);
      } else {
        trueDate = new Date(value);
      }

      var month = trueDate.getMonth();
      var showWeek = /W/.test(format);
      var isRange = /\${1}$/.test(format);

      if (isRange) {
        format = format.replace(/\${1}$/, '');
      }

      if (showWeek && week === 1 && month === 11) {
        trueDate.setHours(0, 0, 0, 0);
        trueDate.setDate(trueDate.getDate() + 3 - (trueDate.getDay() + 6) % 7);
      }

      var date = util_formatDate(trueDate, format);
      var endDate = util_formatDate(nextDate(trueDate, 6), format);

      if (!showWeek && isRange) {
        return "".concat(date, " - ").concat(endDate);
      } else {
        return date;
      }
    },
    parser: function parser(text, format) {
      return TYPE_VALUE_RESOLVER_MAP.date.parser(text, format);
    }
  },
  date: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  datetime: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  daterange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  monthrange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  datetimerange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  timerange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  time: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  month: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  year: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  number: {
    formatter: function formatter(value) {
      if (util_isEmpty(value)) {
        return '';
      }

      return '' + value;
    },
    parser: function parser(text) {
      var result = Number(text);

      if (!isNaN(text)) {
        return result;
      } else {
        return null;
      }
    }
  },
  dates: {
    formatter: function formatter(value, format) {
      return value.map(function (date) {
        return DATE_FORMATTER(date, format);
      });
    },
    parser: function parser(value, format) {
      return (typeof value === 'string' ? value.split(', ') : value).map(function (date) {
        return date instanceof Date ? date : DATE_PARSER(date, format);
      });
    }
  }
};
var validateFormatType = function validateFormatType(value, format) {
  switch (true) {
    case isDateObject(value):
      return true;

    case typeof value === 'number' && format === 'timestamp':
      {
        return true;
      }

    case typeof value === 'string':
      {
        var valueArr = value.split('');
        var formatArr = format.split('');
        var _char = ['y', 'M', 'd', 'H', 'h', 'm', 's'];
        var formatLength = 0;
        var valueLength = 0;
        valueArr.forEach(function (str) {
          if (isInteger(+str) && str.trim() !== '') {
            valueLength++;
          }
        });
        formatArr.forEach(function (str) {
          if (_char.includes(str)) {
            formatLength++;
          }
        });
        return formatLength === valueLength;
      }

    default:
      return true;
  }
};

var util_getI18nSettings = function getI18nSettings() {
  return {
    dayNamesShort: WEEKS.map(function (week) {
      return Object(locale_["t"])("el.datepicker.weeks.".concat(week));
    }),
    dayNames: WEEKS.map(function (week) {
      return Object(locale_["t"])("el.datepicker.weeks.".concat(week));
    }),
    monthNamesShort: MONTHS.map(function (month) {
      return Object(locale_["t"])("el.datepicker.months.".concat(month));
    }),
    monthNames: MONTHS.map(function (month, index) {
      return Object(locale_["t"])("el.datepicker.month".concat(index + 1));
    }),
    amPm: utils_date.i18n.amPm,
    oFn: utils_date.i18n.oFn
  };
};

var newArray = function newArray(start, end) {
  var result = [];

  for (var i = start; i <= end; i++) {
    result.push(i);
  }

  return result;
};

var isDate = utils_date.isDate;
var getWeekNumber = utils_date.getWeekNumber;
var toDate = function toDate(date) {
  return isDate(date) ? new Date(date) : util_now();
};
var isDateObject = function isDateObject(val) {
  return val instanceof Date;
};
var util_formatDate = function formatDate(date, format) {
  format = format || 'yyyy/MM/dd';

  if (typeof date === 'string') {
    return date;
  } else if (isDate(date)) {
    date = new Date(date);
  } else if (!date) {
    return '';
  }

  return utils_date.format(date, format, util_getI18nSettings());
};
var util_parseDate = function parseDate(string, format) {
  format = format || 'yyyy/MM/dd';

  if (validateFormatType(string, format)) {
    return utils_date.parse(string, format, util_getI18nSettings());
  } else {
    return false;
  }
};
var getDayCountOfMonth = function getDayCountOfMonth(year, month) {
  if (month === 3 || month === 5 || month === 8 || month === 10) {
    return 30;
  }

  if (month === 1) {
    if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
      return 29;
    } else {
      return 28;
    }
  }

  return 31;
};
var setYear = function setYear(date, _year) {
  return changeYearMonthAndClampDate(date, _year, date.getMonth());
};
var setMonth = function setMonth(date, _month) {
  return changeYearMonthAndClampDate(date, date.getFullYear(), _month);
};
var setDate = function setDate(date, _date) {
  date.setDate(_date);
  return new Date(date);
};
var clearDate = function clearDate(date) {
  return new Date(date.getFullYear(), date.getMonth());
};
var clearTime = function clearTime(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};
var clearMinutes = function clearMinutes(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours());
};
var clearSeconds = function clearSeconds(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
};
var clearMilliseconds = function clearMilliseconds(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
};
var timeToNowDate = function timeToNowDate(date) {
  var now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
};
var getDayCountOfYear = function getDayCountOfYear(year) {
  var isLeapYear = year % 400 === 0 || year % 100 !== 0 && year % 4 === 0;
  return isLeapYear ? 366 : 365;
};
var getFirstDayOfMonth = function getFirstDayOfMonth(date) {
  var temp = new Date(date.getTime());
  temp.setDate(1);
  return temp.getDay();
}; // see: https://stackoverflow.com/questions/3674539/incrementing-a-date-in-javascript
// {prev, next} Date should work for Daylight Saving Time
// Adding 24 * 60 * 60 * 1000 does not work in the above scenario

var prevDate = function prevDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount);
};
var nextDate = function nextDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
};
var getStartDateOfMonth = function getStartDateOfMonth(year, month) {
  var result = new Date(year, month, 1);
  var day = result.getDay();
  return prevDate(result, day);
};
var getRangeHours = function getRangeHours(ranges) {
  var hours = [];
  var disabledHours = [];
  (ranges || []).forEach(function (range) {
    var value = range.map(function (date) {
      return date.getHours();
    });
    disabledHours = disabledHours.concat(newArray(value[0], value[1]));
  });

  if (disabledHours.length) {
    for (var i = 0; i < 24; i++) {
      hours[i] = disabledHours.indexOf(i) === -1;
    }
  } else {
    for (var _i = 0; _i < 24; _i++) {
      hours[_i] = false;
    }
  }

  return hours;
};

function setRangeData(arr, start, end, disabled) {
  for (var i = start; i < end; i++) {
    arr[i] = disabled;
  }
}

var util_getRange = function getRange(type, ranges, date) {
  if (type === 'hours') {
    return getRangeHours(ranges);
  }

  var list = [];

  for (var i = 0; i < 60; i++) {
    list[i] = true;
  }

  if (!date) {
    return list;
  }

  var isMinutes = type === 'minutes';
  var dateTimestamp = isMinutes ? +clearMinutes(timeToNowDate(date)) : +clearSeconds(timeToNowDate(date));

  if (ranges.length > 0) {
    ranges.forEach(function (range) {
      var start = range[0];
      var end = range[1];
      var startList = isMinutes ? start.getMinutes() : start.getSeconds();
      var endList = isMinutes ? end.getMinutes() : end.getSeconds();
      var startTimestamp = isMinutes ? +clearMinutes(timeToNowDate(start)) : +clearSeconds(timeToNowDate(start));
      var endTimestamp = isMinutes ? +clearMinutes(timeToNowDate(end)) : +clearSeconds(timeToNowDate(end));

      if (startTimestamp === dateTimestamp && endTimestamp !== dateTimestamp) {
        setRangeData(list, startList, 60, false);
      } else if (startTimestamp === dateTimestamp && endTimestamp === dateTimestamp) {
        setRangeData(list, startList, endList + 1, false);
      } else if (startTimestamp !== dateTimestamp && endTimestamp === dateTimestamp) {
        setRangeData(list, 0, endList + 1, false);
      } else if (startTimestamp < dateTimestamp && endTimestamp > dateTimestamp) {
        setRangeData(list, 0, 60, false);
      }
    });
  } else {
    setRangeData(list, 0, 60, false);
  }

  return list;
};
var range = function range(n) {
  // see https://stackoverflow.com/questions/3746725/create-a-javascript-array-containing-1-n
  return Array.apply(null, {
    length: n
  }).map(function (_, n) {
    return n;
  });
};
var dateMergeTime = function dateMergeTime(from, to) {
  if (isDate(from) && isDate(to)) {
    from = new Date(from);
    to = new Date(to);
    return new Date(from.getFullYear(), from.getMonth(), from.getDate(), to.getHours(), to.getMinutes(), to.getSeconds(), to.getMilliseconds());
  }

  return to;
};
var modifyDate = function modifyDate(date, y, m, d) {
  return new Date(y, m, d, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
};
var modifyTime = function modifyTime(date, h, m, s) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), h, m, s, date.getMilliseconds());
};
var modifyWithTimeString = function modifyWithTimeString(date, time) {
  if (date === null) {
    return date;
  }

  if (!time) {
    return modifyTime(date, 0, 0, 0);
  }

  time = util_parseDate(time, 'HH:mm:ss');
  return modifyTime(date, time.getHours(), time.getMinutes(), time.getSeconds());
};
var util_limitTimeRange = function limitTimeRange(date, ranges) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'HH:mm:ss';
  // TODO: refactory a more elegant solution
  if (ranges.length === 0) return date;

  var normalizeDate = function normalizeDate(date) {
    return utils_date.parse(utils_date.format(date, format), format);
  };

  var ndate = normalizeDate(date);
  var nranges = ranges.map(function (range) {
    return range.map(normalizeDate);
  });

  if (nranges.some(function (nrange) {
    return ndate >= nrange[0] && ndate <= nrange[1];
  })) {
    return date;
  }

  var minDate = nranges[0][0];
  var maxDate = nranges[0][0];
  nranges.forEach(function (nrange) {
    minDate = new Date(Math.min(nrange[0], minDate));
    maxDate = new Date(Math.max(nrange[1], minDate));
  });
  var ret = ndate < minDate ? minDate : maxDate; // preserve Year/Month/Date

  return modifyDate(ret, date.getFullYear(), date.getMonth(), date.getDate());
};
var timeWithinRange = function timeWithinRange(date, selectableRange, format) {
  var limitedDate = util_limitTimeRange(date, selectableRange, format);
  return limitedDate.getTime() === date.getTime();
};
var changeYearMonthAndClampDate = function changeYearMonthAndClampDate(date, year, month) {
  // clamp date to the number of days in `year`, `month`
  // eg: (2010-1-31, 2010, 2) => 2010-2-28
  var monthDate = Math.min(date.getDate(), getDayCountOfMonth(year, month));
  return modifyDate(date, year, month, monthDate);
};
var util_prevMonth = function prevMonth(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  return month === 0 ? changeYearMonthAndClampDate(date, year - 1, 11) : changeYearMonthAndClampDate(date, year, month - 1);
};
var util_nextMonth = function nextMonth(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  return month === 11 ? changeYearMonthAndClampDate(date, year + 1, 0) : changeYearMonthAndClampDate(date, year, month + 1);
};
var util_prevYear = function prevYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var year = date.getFullYear();
  var month = date.getMonth();
  return changeYearMonthAndClampDate(date, year - amount, month);
};
var util_nextYear = function nextYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var year = date.getFullYear();
  var month = date.getMonth();
  return changeYearMonthAndClampDate(date, year + amount, month);
};
var extractDateFormat = function extractDateFormat(format) {
  return format.replace(/\W?m{1,2}|\W?ZZ/g, '').replace(/\W?h{1,2}|\W?s{1,3}|\W?a/gi, '').trim();
};
var extractTimeFormat = function extractTimeFormat(format) {
  return format.replace(/\W?D{1,2}|\W?do|\W?d{1,4}|\W?M{1,4}|\W?y{2,4}/g, '').trim();
};
var isInteger = function isInteger(val) {
  return typeof val === 'number' && val % 1 === 0;
};
var formatAsFormatAndType = function formatAsFormatAndType(value, customFormat, type) {
  if (util_isEmpty(value)) {
    return null;
  }

  var formatter = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP["default"]).formatter;
  var format = customFormat || DEFAULT_FORMATS[type];
  return formatter(value, format);
};
var parseAsFormatAndType = function parseAsFormatAndType(value, customFormat, type) {
  var rangeSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '-';

  if (util_isEmpty(value)) {
    return null;
  }

  var parser = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP["default"]).parser;
  var format = customFormat || DEFAULT_FORMATS[type];
  format = format && format.replace(/-/g, '/');

  if (validateFormatType(value, format)) {
    return parser(value, format, rangeSeparator);
  } else {
    return null;
  }
};
var getTimestamp = function getTimestamp(time) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'clearTime';

  if (typeof time === 'number' || typeof time === 'string') {
    return type === 'clearTime' ? clearTime(new Date(time)).getTime() : clearDate(new Date(time)).getTime();
  } else if (time instanceof Date) {
    return type === 'clearTime' ? clearTime(time).getTime() : clearDate(time).getTime();
  } else {
    return NaN;
  }
};
var util_now = function now() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'clearTime';

  if (type === 'clearTime') {
    return clearTime(new Date());
  } else {
    return clearDate(new Date());
  }
};
var dateValidator = function dateValidator(val) {
  var condition = function condition(item) {
    return isDate(item) || isString(item) || util_isEmpty(item);
  };

  return util_isEmpty(val) || condition(val) || Array.isArray(val) && val.every(condition);
};
var isEmptyDate = function isEmptyDate(val) {
  var condition = function condition(item) {
    return util_isEmpty(item);
  };

  return condition(val) || Array.isArray(val) && val.every(condition);
};
var MIN_TIME = util_parseDate('00:00:00', 'HH:mm:ss');
var MAX_TIME = util_parseDate('23:59:59', 'HH:mm:ss');
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=script&lang=js&















//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var NewPopper = {
  props: {
    appendToBody: vue_popper.props.appendToBody,
    offset: vue_popper.props.offset,
    boundariesPadding: vue_popper.props.boundariesPadding,
    arrowOffset: vue_popper.props.arrowOffset
  },
  methods: vue_popper.methods,
  data: function data() {
    return merge({
      visibleArrow: false
    }, vue_popper.data);
  },
  beforeDestroy: vue_popper.beforeDestroy
};
var PLACEMENT_MAP = {
  left: 'bottom-start',
  center: 'bottom',
  right: 'bottom-end'
};
var HAVE_TRIGGER_TYPES = ['date', 'datetime', 'time', 'time-select', 'week', 'month', 'year', 'daterange', 'monthrange', 'timerange', 'datetimerange', 'dates'];
/*
 * Considers:
 *   1. Date object
 *   2. date string
 *   3. array of 1 or 2
 */

var valueEquals = function valueEquals(a, b) {
  // considers Date object and string
  var dateEquals = function dateEquals(a, b) {
    var aIsDate = a instanceof Date;
    var bIsDate = b instanceof Date;

    if (aIsDate && bIsDate) {
      return a.getTime() === b.getTime();
    }

    if (!aIsDate && !bIsDate) {
      return a === b;
    }

    return false;
  };

  var aIsArray = a instanceof Array;
  var bIsArray = b instanceof Array;

  if (aIsArray && bIsArray) {
    if (a.length !== b.length) {
      return false;
    }

    return a.every(function (item, index) {
      return dateEquals(item, b[index]);
    });
  }

  if (!aIsArray && !bIsArray) {
    return dateEquals(a, b);
  }

  return false;
};

var pickervue_type_script_lang_js_stringValidator = function stringValidator(val) {
  // either: String, Array of String, null / undefined
  return util_isEmpty(val) || isString(val) || Array.isArray(val) && val.length === 2 && val.every(isString);
};

/* harmony default export */ var pickervue_type_script_lang_js_ = ({
  components: {
    ElInput: packages_input
  },
  directives: {
    Clickoutside: clickoutside
  },
  mixins: [emitter, NewPopper],
  inject: {
    elForm: {
      "default": ''
    },
    elFormItem: {
      "default": ''
    }
  },
  props: {
    size: {
      type: String,
      "default": null
    },
    format: {
      type: String,
      "default": null
    },
    valueFormat: {
      type: String,
      "default": null
    },
    readonly: {
      type: Boolean,
      "default": null
    },
    placeholder: {
      type: String,
      "default": null
    },
    startPlaceholder: {
      type: String,
      "default": null
    },
    endPlaceholder: {
      type: String,
      "default": null
    },
    prefixIcon: {
      type: String,
      "default": null
    },
    clearIcon: {
      type: String,
      "default": 'h-icon-close_f'
    },
    id: {
      "default": '',
      validator: pickervue_type_script_lang_js_stringValidator
    },
    name: {
      "default": '',
      validator: pickervue_type_script_lang_js_stringValidator
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    clearable: {
      type: Boolean,
      "default": true
    },
    popperClass: {
      type: String,
      "default": null
    },
    editable: {
      type: Boolean,
      "default": true
    },
    align: {
      type: String,
      "default": 'left'
    },
    value: {
      "default": null,
      validator: dateValidator
    },
    defaultValue: {
      "default": null,
      validator: dateValidator
    },
    defaultTime: {
      "default": null,
      validator: dateValidator
    },
    rangeSeparator: {
      type: String,
      "default": '-'
    },
    pickerOptions: {
      type: Object,
      "default": function _default() {}
    },
    unlinkPanels: {
      type: Boolean,
      "default": true
    },
    unlinkRange: {
      type: Boolean,
      "default": true
    },
    validateEvent: {
      type: Boolean,
      "default": true
    },
    unlink: {
      type: Boolean,
      "default": null
    }
  },
  data: function data() {
    return {
      pickerVisible: false,
      showClose: false,
      userInput: null,
      valueOnOpen: null,
      // value when picker opens, used to determine whether to emit change
      unwatchPickerOptions: null,
      changeInput: true,
      preConfirmValue: null,
      calcValue: null
    };
  },
  computed: {
    ranged: function ranged() {
      return this.type.indexOf('range') > -1;
    },
    refInput: function refInput() {
      if (this.reference) {
        return [].slice.call(this.reference.querySelectorAll('input'));
      }

      return [];
    },
    valueIsEmpty: function valueIsEmpty() {
      var val = this.value;

      if (Array.isArray(val)) {
        for (var i = 0, len = val.length; i < len; i++) {
          if (val[i]) {
            return false;
          }
        }
      } else {
        if (val) {
          return false;
        }
      }

      return true;
    },
    triggerClass: function triggerClass() {
      return this.prefixIcon || (this.type === 'time' || this.type === 'time-select' || this.type === 'timerange' ? 'h-icon-clock' : 'h-icon-calendar');
    },
    selectionMode: function selectionMode() {
      if (this.type === 'week') {
        return 'week';
      } else if (this.type === 'month') {
        return 'month';
      } else if (this.type === 'year') {
        return 'year';
      } else if (this.type === 'dates') {
        return 'dates';
      }

      return 'day';
    },
    haveTrigger: function haveTrigger() {
      if (typeof this.showTrigger !== 'undefined') {
        return this.showTrigger;
      }

      return HAVE_TRIGGER_TYPES.indexOf(this.type) !== -1;
    },
    displayValue: function displayValue() {
      var formattedValue = formatAsFormatAndType(this.preConfirmValue, this.format, this.type);
      var userInput = this.userInput;

      var isTrueValue = function isTrueValue() {
        if (Array.isArray(formattedValue) && !util_isEmpty(formattedValue[0]) && !util_isEmpty(formattedValue[1])) {
          return true;
        }

        return !util_isEmpty(formattedValue);
      };

      if (Array.isArray(userInput) && isTrueValue()) {
        return [userInput[0] || formattedValue && formattedValue[0] || '', userInput[1] || formattedValue && formattedValue[1] || ''];
      } else if (userInput) {
        return userInput;
      } else if (isTrueValue()) {
        return this.type === 'dates' ? formattedValue.join(', ') : formattedValue;
      } else {
        return '';
      }
    },
    parsedValue: function parsedValue() {
      if (!this.calcValue) return this.calcValue; // component value is not set

      if (this.type === 'time-select') {
        // time-select does not require parsing, this might change in next major version
        return this.value.length !== 5 ? this.calcValue : this.value;
      }

      var valueIsDateObject = isDateObject(this.calcValue) || Array.isArray(this.calcValue) && this.calcValue.every(isDateObject);

      if (valueIsDateObject) {
        return this.calcValue;
      }

      if (this.valueFormat) {
        var formatValue = parseAsFormatAndType(this.calcValue, this.valueFormat, this.type, this.rangeSeparator);

        if (!util_isEmpty(formatValue)) {
          return formatValue;
        } else {
          return this.calcValue;
        }
      } // NOTE: deal with common but incorrect usage, should remove in next major version
      // user might provide string / timestamp without value-format, coerce them into date (or array of date)


      return Array.isArray(this.calcValue) ? this.calcValue.map(function (val) {
        return toDate(val);
      }) : toDate(this.calcValue);
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    pickerSize: function pickerSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    pickerDisabled: function pickerDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    firstInputId: function firstInputId() {
      var obj = {};
      var id;

      if (this.ranged) {
        id = this.id && this.id[0];
      } else {
        id = this.id;
      }

      if (id) obj.id = id;
      return obj;
    },
    secondInputId: function secondInputId() {
      var obj = {};
      var id;

      if (this.ranged) {
        id = this.id && this.id[1];
      }

      if (id) obj.id = id;
      return obj;
    }
  },
  watch: {
    pickerVisible: function pickerVisible(val) {
      if (this.readonly || this.pickerDisabled) return;

      if (val) {
        this.showPicker();
        this.valueOnOpen = Array.isArray(this.value) ? _toConsumableArray(this.value) : this.value;
      } else {
        this.hidePicker();
        this.userInput = null;

        if (this.validateEvent) {
          this.dispatch('ElFormItem', 'el.form.blur');
        }

        this.$emit('blur', this.formatToValue(this.calcValue), this.displayValue);
        this.blur();
      }
    },
    parsedValue: {
      immediate: true,
      handler: function handler(val) {
        if (this.picker && val) {
          this.picker.value = val;
        }
      }
    },
    defaultValue: function defaultValue(val) {
      // NOTE: should eventually move to jsx style picker + panel ?
      if (this.picker) {
        this.picker.defaultValue = val;
      }
    },
    value: function value(val, oldVal) {
      if (!valueEquals(val, oldVal) && !this.pickerVisible && this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', val);

        if (!valueEquals(this.formatToValue(this.preConfirmValue), val)) {
          this.preConfirmValue = val;
        }

        if (!valueEquals(this.formatToValue(this.calcValue), val)) {
          this.calcValue = val;
        }
      }
    },
    preConfirmValue: function preConfirmValue(val, oldVal) {
      if (!valueEquals(val, this.value)) {
        this.$emit('input', this.formatToValue(val), this.displayValue);
      }
    },
    calcValue: function calcValue(val, oldVal) {
      if (!valueEquals(val, this.preConfirmValue) && this.isValidValue(val) && this.pickerVisible) {
        this.emitChange(val);
      }
    }
  },
  created: function created() {
    // init
    var val = this.value;

    if (typeof val === 'number') {
      this.calcValue = new Date(val);
    } else if (typeof val === 'string') {
      this.calcValue = this.replaceDate(val);
    } else {
      this.calcValue = val;
    }

    this.preConfirmValue = val; // vue-popper

    this.popperOptions = {
      boundariesPadding: 0,
      gpuAcceleration: false
    };
    this.placement = PLACEMENT_MAP[this.align] || PLACEMENT_MAP.left;
    this.$on('fieldReset', this.handleFieldReset);
  },
  mounted: function mounted() {
    this.setReference();
  },
  methods: {
    setReference: function setReference() {
      var reference = this.$refs.reference;
      this.reference = reference.$el || reference;
    },
    replaceDate: function replaceDate(value) {
      return value.replace(/-/g, '/');
    },
    focus: function focus() {
      if (window) {
        window.focus();
      }

      this.handleFocus();
      this.refInput[0].focus();
    },
    blur: function blur() {
      this.refInput.forEach(function (input) {
        return input.blur();
      });
    },
    formatToValue: function formatToValue(value) {
      if (typeof value === 'number') {
        value = new Date(value);
      }

      if (util_isEmpty(value)) {
        return '';
      }

      var isParsed = isDateObject(value) || Array.isArray(value) && value.every(isDateObject);

      if (this.valueFormat && isParsed) {
        var formatValue = formatAsFormatAndType(value, this.valueFormat, this.type);
        return util_isEmpty(formatValue) ? value : formatValue;
      } else {
        return value;
      }
    },
    // {parse, formatTo} String deals with user input
    parseString: function parseString(value) {
      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
      return parseAsFormatAndType(value, this.format, type);
    },
    formatToString: function formatToString(value) {
      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
      return formatAsFormatAndType(value, this.format, type);
    },
    handleMouseEnter: function handleMouseEnter() {
      if (this.readonly || this.pickerDisabled) return;

      if (!this.valueIsEmpty && this.clearable) {
        this.showClose = true;
      }
    },
    handleInput: function handleInput(event) {
      var _this = this;

      var val = event.target.value;
      this.$nextTick(function () {
        _this.userInput = val;

        if (val && _this.picker) {
          var parseDate = _this.parseString(val);

          if (parseDate) {
            _this.picker.value = parseDate;

            if (_this.isValidValue(parseDate)) {
              _this.emitInput(parseDate);
            }
          }
        }
      });
    },
    handleChange: function handleChange(event) {
      var val = event.target.value;
      this.userInput = val;
    },
    handleStartInput: function handleStartInput(event) {
      var val = event.target.value;
      var preConfirmValue = this.preConfirmValue && this.preConfirmValue[0];
      var parseValue = this.parseString(val);
      var isTimerange = this.type === 'timerange';

      if (parseValue && this.picker) {
        var value = isTimerange ? modifyDate(parseValue, preConfirmValue.getFullYear(), preConfirmValue.getMonth(), preConfirmValue.getDate()) : parseValue;
        var newValue = [value, this.picker.value && this.picker.value[1]];
        this.picker.value = newValue;

        if (this.isValidValue(newValue)) {
          this.emitInput(newValue);
        }
      }
    },
    handleEndInput: function handleEndInput(event) {
      var val = event.target.value;
      var preConfirmValue = this.preConfirmValue && this.preConfirmValue[1];
      var parseValue = this.parseString(val);
      var isTimerange = this.type === 'timerange';

      if (parseValue && this.picker) {
        var value = isTimerange ? modifyDate(parseValue, preConfirmValue.getFullYear(), preConfirmValue.getMonth(), preConfirmValue.getDate()) : parseValue;
        var newValue = [this.picker.value && this.picker.value[0], value];
        this.picker.value = newValue;

        if (this.isValidValue(newValue)) {
          this.emitInput(newValue);
        }
      }
    },
    handleStartChange: function handleStartChange(event) {
      var val = event.target.value;

      if (this.userInput) {
        this.userInput = [val, this.userInput[1]];
      } else {
        this.userInput = [val, null];
      }
    },
    handleEndChange: function handleEndChange(event) {
      var val = event.target.value;

      if (this.userInput) {
        this.userInput = [this.userInput[0], val];
      } else {
        this.userInput = [null, val];
      }
    },
    handleClickSuffixIcon: function handleClickSuffixIcon(event) {
      if (this.showClose) {
        this.handleClickIcon(event);
      } else {
        this.handleFocus();
      }
    },
    handleClickIcon: function handleClickIcon(event) {
      if (this.readonly || this.pickerDisabled) return;
      this.valueOnOpen = this.value;
      event.stopPropagation();
      this.emitInput(null);
      this.showClose = false;

      if (this.picker && typeof this.picker.handleClear === 'function') {
        this.picker.handleClear();
      }
    },
    handleClose: function handleClose() {
      if (!this.pickerVisible) return;
      this.pickerVisible = false;
    },
    handleFieldReset: function handleFieldReset(initialValue) {
      this.userInput = initialValue === '' ? null : initialValue;
    },
    handleFocus: function handleFocus() {
      if (!this.editable) {
        this.blur();
      }

      var type = this.type;

      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
        this.pickerVisible = true;
      }

      this.$emit('focus', this.formatToValue(this.calcValue), this.displayValue);
    },
    handleKeydown: function handleKeydown(event) {
      var _this2 = this;

      var keyCode = event.keyCode; // ESC

      if (keyCode === 27) {
        this.pickerVisible = false;
        event.stopPropagation();
        return;
      } // Tab


      if (keyCode === 9) {
        if (!this.ranged) {
          this.pickerVisible = this.picker.visible = false;
          this.blur();
          event.stopPropagation();
        } else {
          // user may change focus between two input
          setTimeout(function () {
            if (_this2.refInput.indexOf(document.activeElement) === -1) {
              _this2.pickerVisible = false;

              _this2.blur();

              event.stopPropagation();
            }
          }, 0);
        }

        return;
      } // Enter


      if (keyCode === 13) {
        if (this.userInput === '' || this.isValidValue(this.parseString(this.displayValue))) {
          this.pickerVisible = this.picker.visible = false;
          this.blur();
        }

        event.stopPropagation();
        return;
      }

      if (this.refInput[0] === document.activeElement) {
        event.stopPropagation();
        return;
      } // delegate other keys to panel


      if (this.picker && this.picker.handleKeydown) {
        this.picker.handleKeydown(event);
      }
    },
    hidePicker: function hidePicker() {
      if (this.picker) {
        var emitValue;

        if (this.userInput === '') {
          emitValue = null;
        } else if (!this.userInput && this.picker.unlink) {
          this.calcValue = this.preConfirmValue;
          emitValue = this.calcValue;
        } else {
          this.preConfirmValue = this.calcValue;
          emitValue = this.preConfirmValue;
        }

        this.emitInput(emitValue);
        this.pickerVisible = false;
        this.picker.visible = false;
        this.destroyPopper();
      }
    },
    showPicker: function showPicker() {
      var _this3 = this;

      if (this.$isServer) return;
      this.setReference();

      if (!this.picker) {
        this.mountPicker();
      }

      this.$nextTick(function () {
        _this3.picker.value = _this3.parsedValue;

        _this3.resetView();

        _this3.pickerVisible = true;
        _this3.picker.visible = true;

        _this3.updatePopper();

        _this3.picker.adjustSpinners && _this3.picker.adjustSpinners();
      });
    },
    mountPicker: function mountPicker() {
      var _this4 = this;

      var specialUnlinkTypes = ['year', 'month', 'time'];
      this.picker = new external_vue_default.a(this.panel).$mount();

      if (Object.keys(this.$slots).length) {
        this.picker.$slots = this.$slots;
      }

      if (Object.keys(this.$scopedSlots).length) {
        this.picker.$scopedSlots = this.$scopedSlots;
      }

      this.picker.defaultValue = this.defaultValue;
      this.picker.defaultTime = this.defaultTime;
      this.picker.popperClass = this.popperClass;
      this.popperElm = this.picker.$el;
      this.picker.width = this.reference.getBoundingClientRect().width;
      this.picker.showTime = this.type === 'datetime' || this.type === 'datetimerange';
      this.picker.type = this.type;
      this.picker.selectionMode = this.selectionMode;
      this.picker.unlinkPanels = this.unlinkPanels;
      this.picker.arrowControl = this.arrowControl || this.timeArrowControl || false; // HUI custom

      this.picker.unlink = this.unlink === null ? !specialUnlinkTypes.includes(this.type) : this.unlink;
      this.picker.unlinkRange = this.unlinkRange;
      this.picker.isRange = this.isRange;
      this.picker.startPlaceholder = this.startPlaceholder;
      this.picker.endPlaceholder = this.endPlaceholder;
      this.picker.displayValue = this.displayValue;
      this.$watch('format', function (format) {
        _this4.picker.format = format;
      });

      var updateOptions = function updateOptions() {
        var options = _this4.pickerOptions;

        if (options && options.selectableRange) {
          var ranges = options.selectableRange;
          var parser = TYPE_VALUE_RESOLVER_MAP.datetimerange.parser;
          var format = DEFAULT_FORMATS.timerange;
          ranges = Array.isArray(ranges) ? ranges : [ranges];
          _this4.picker.selectableRange = ranges.map(function (range) {
            return parser(range, format, _this4.rangeSeparator);
          });
        }

        for (var option in options) {
          if (hasOwn(options, option) && // 忽略 time-picker 的该配置项
          option !== 'selectableRange') {
            _this4.picker[option] = options[option];
          }
        } // main format must prevail over undocumented pickerOptions.format


        if (_this4.format) {
          _this4.picker.format = _this4.format;
        }
      };

      updateOptions();
      this.unwatchPickerOptions = this.$watch('pickerOptions', function () {
        return updateOptions();
      }, {
        deep: true
      });
      this.$el.appendChild(this.picker.$el);
      this.picker.$on('dodestroy', this.doDestroy);
      this.picker.$on('pick', function () {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var changeInput = arguments.length > 2 ? arguments[2] : undefined;
        _this4.calcValue = date;

        if (changeInput !== undefined) {
          _this4.changeInput = changeInput;
        } else {
          _this4.changeInput = !visible;
        }

        if (_this4.changeInput) {
          _this4.emitChange(date);
        }

        if (!visible || _this4.changeInput) {
          _this4.emitInput(date);
        }

        _this4.picker.visible = visible;
        _this4.pickerVisible = visible;
      });
      this.picker.$on('select-range', function (start, end, pos) {
        if (_this4.refInput.length === 0 || !_this4.pickerVisible) return;

        if (!pos || pos === 'min') {
          _this4.refInput[0].setSelectionRange(start, end);

          _this4.refInput[0].focus();
        } else if (pos === 'max') {
          _this4.refInput[1].setSelectionRange(start, end);

          _this4.refInput[1].focus();
        }
      });
    },
    unmountPicker: function unmountPicker() {
      if (this.picker) {
        this.picker.$destroy();
        this.picker.$off();
        this.doDestroy();

        if (typeof this.unwatchPickerOptions === 'function') {
          this.unwatchPickerOptions();
        }

        this.picker.$el.parentNode.removeChild(this.picker.$el);
      }
    },
    emitChange: function emitChange(val, forceEmit) {
      // determine user real change only
      if (!valueEquals(val, this.preConfirmValue) && !valueEquals(val, this.valueOnOpen) || forceEmit) {
        this.$emit('change', this.formatToValue(val), this.displayValue);
        this.valueOnOpen = val;

        if (this.validateEvent) {
          this.dispatch('ElFormItem', 'el.form.change', val);
        }
      }
    },
    emitInput: function emitInput(val) {
      this.userInput = null;

      if (!valueEquals(this.preConfirmValue, val)) {
        this.calcValue = val;
        this.preConfirmValue = val;
      }
    },
    isValidValue: function isValidValue(value) {
      if (!this.picker) {
        this.mountPicker();
      }

      if (this.picker.isValidValue) {
        return value && this.picker.isValidValue(value);
      } else {
        return true;
      }
    },
    resetView: function resetView() {
      this.picker.resetView && this.picker.resetView();
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_pickervue_type_script_lang_js_ = (pickervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue





/* normalize component */

var picker_component = normalizeComponent(
  src_pickervue_type_script_lang_js_,
  pickervue_type_template_id_3face8f0_render,
  pickervue_type_template_id_3face8f0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var picker = (picker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=template&id=2aab2f3f&
var datevue_type_template_id_2aab2f3f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-bottom"},on:{"after-enter":_vm.handleEnter,"after-leave":_vm.handleLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-picker-panel el-date-picker el-popper",class:[
      {
        'has-sidebar': _vm.hasSidebar,
        'has-time': _vm.showTime
      },
      _vm.popperClass
    ]},[_c('div',{staticClass:"el-picker-panel__body-wrapper"},[_vm._t("sidebar"),(_vm.shortcuts)?_c('div',{staticClass:"el-picker-panel__sidebar"},_vm._l((_vm.shortcuts),function(shortcut,key){return _c('button',{key:key,staticClass:"el-picker-panel__shortcut",attrs:{"type":"button"},domProps:{"textContent":_vm._s(shortcut.text)},on:{"click":function($event){return _vm.handleShortcutClick(shortcut)}}})}),0):_vm._e(),_c('div',{staticClass:"el-picker-panel__body"},[(_vm.currentView !== 'time')?_c('div',{ref:"pickerHeader",staticClass:"el-date-picker__header",class:{
            'el-date-picker__header--bordered':
              _vm.currentView === 'year' || _vm.currentView === 'month'
          }},[_c('button',{staticClass:"el-picker-panel__icon-btn el-date-picker__prev-btn h-icon-angles_left_sm",attrs:{"aria-label":_vm.t("el.datepicker.prevYear"),"type":"button"},on:{"click":_vm.prevYear}}),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentView === 'date' || _vm.currentView === 'month'),expression:"currentView === 'date' || currentView === 'month'"}],staticClass:"el-picker-panel__icon-btn el-date-picker__prev-btn h-icon-angle_left_sm",attrs:{"aria-label":_vm.t("el.datepicker.prevMonth"),"type":"button"},on:{"click":_vm.prevMonth}}),_c('span',{staticClass:"el-picker-panel__header-label-wrapper",class:[("is-" + _vm.currentView), { 'is-en': _vm.isEn }]},[_c('span',{staticClass:"el-picker-panel__header-label",class:{ active: _vm.currentView === 'year' },attrs:{"title":_vm.yearLabel,"role":"button"},domProps:{"textContent":_vm._s(_vm.yearLabel)},on:{"click":_vm.showYearPicker}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentView === 'date' || _vm.currentView === 'month'),expression:"currentView === 'date' || currentView === 'month'"}],staticClass:"el-picker-panel__header-label",class:{ active: _vm.currentView === 'month' },attrs:{"title":_vm.monthLabel,"role":"button"},domProps:{"textContent":_vm._s(_vm.monthLabel)},on:{"click":_vm.showMonthPicker}})]),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentView === 'date' || _vm.currentView === 'month'),expression:"currentView === 'date' || currentView === 'month'"}],staticClass:"el-picker-panel__icon-btn el-date-picker__next-btn h-icon-angle_right_sm",attrs:{"aria-label":_vm.t("el.datepicker.nextMonth"),"type":"button"},on:{"click":_vm.nextMonth}}),_c('button',{staticClass:"el-picker-panel__icon-btn el-date-picker__next-btn h-icon-angles_right_sm",attrs:{"aria-label":_vm.t("el.datepicker.nextYear"),"type":"button"},on:{"click":_vm.nextYear}})]):_vm._e(),_c('div',{staticClass:"el-picker-panel__content",class:{
            'has-modal': _vm.visibleDateTable,
            'is-time-picker': _vm.timePickerVisible
          }},[(_vm.visibleDateTable)?_c('date-table',{ref:"dateTable",attrs:{"unlink":_vm.unlink,"selection-mode":_vm.selectionMode,"first-day-of-week":_vm.firstDayOfWeek,"value":_vm.value,"default-value":_vm.defaultValue ? new Date(_vm.defaultValue) : null,"date":_vm.date,"disabled-date":_vm.disabledDate},on:{"pick":_vm.handleDatePick},scopedSlots:_vm._u([{key:!!(_vm.$slots.date || _vm.$scopedSlots.date) ? 'date' : null,fn:function(data){return [_vm._t("date",null,null,data)]}}],null,true)}):_vm._e(),(_vm.currentView === 'year')?_c('year-table',{ref:"yearTable",attrs:{"unlink":_vm.unlink,"value":_vm.value,"default-value":_vm.defaultValue ? new Date(_vm.defaultValue) : null,"date":_vm.date,"disabled-date":_vm.disabledDate},on:{"pick":_vm.handleYearPick},scopedSlots:_vm._u([{key:!!(_vm.$slots.year || _vm.$scopedSlots.year) ? 'year' : null,fn:function(data){return [_vm._t("year",null,null,data)]}}],null,true)}):_vm._e(),(_vm.currentView === 'month')?_c('month-table',{ref:"monthTable",attrs:{"unlink":_vm.unlink,"value":_vm.value,"default-value":_vm.defaultValue ? new Date(_vm.defaultValue) : null,"date":_vm.date,"disabled-date":_vm.disabledDate},on:{"pick":_vm.handleMonthPick},scopedSlots:_vm._u([{key:!!(_vm.$slots.month || _vm.$scopedSlots.month) ? 'month' : null,fn:function(data){return [_vm._t("month",null,null,data)]}}],null,true)}):_vm._e(),(_vm.showTime)?_c('div',{staticClass:"el-date-picker__time-header"},[_c('span',{staticClass:"el-date-picker__editor-wrap"},[_c('span',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:({
                  fn: _vm.handleTimePickClose,
                  excludes: _vm.$refs.changeToNow ? [_vm.$refs.changeToNow.$el] : []
                }),expression:"{\n                  fn: handleTimePickClose,\n                  excludes: $refs.changeToNow ? [$refs.changeToNow.$el] : []\n                }"}]},[_c('el-input',{ref:"input",attrs:{"placeholder":_vm.t('el.datepicker.selectTime'),"value":_vm.visibleTime},on:{"focus":function($event){_vm.timePickerVisible = true},"blur":_vm.handleVisibleTimeBlur,"input":function (val) { return (_vm.userInputTime = val); },"change":_vm.handleVisibleTimeChange}}),_c('time-picker',{ref:"timepicker",attrs:{"time-arrow-control":_vm.arrowControl,"visible":_vm.timePickerVisible,"unlink":false},on:{"pick":_vm.handleTimePick,"mounted":_vm.proxyTimePickerDataProperties,"select-range":_vm.setSelectionRange}})],1)])]):_vm._e()],1)])],2),(_vm.visibleFooter)?_c('div',{staticClass:"el-picker-panel__footer"},[(_vm.hasSidebar)?_c('span',{staticClass:"el-picker-panel__footer-message"},[_c('span',{domProps:{"textContent":_vm._s(_vm.visibleDate)}}),(_vm.showTime)?_c('span',{domProps:{"textContent":_vm._s(_vm.visibleTime)}}):_vm._e()]):_c('span',{staticClass:"el-picker-panel__footer-message"}),(_vm.selectionMode !== 'dates' && !_vm.disabledNow)?_c('el-button',{ref:"changeToNow",staticClass:"el-picker-panel__link-btn el-picker-panel__now",class:{
          'el-picker-panel-btn__today': !_vm.hasSidebar
        },domProps:{"textContent":_vm._s(_vm.t(_vm.nowI18nKey))},on:{"click":_vm.changeToNow}}):_vm._e(),_c('el-button',{staticClass:"el-picker-panel__link-btn",attrs:{"disabled":_vm.btnDisabled,"type":"primary"},domProps:{"textContent":_vm._s(_vm.t('el.datepicker.confirm'))},on:{"click":_vm.confirm}})],1):_vm._e()])])}
var datevue_type_template_id_2aab2f3f_staticRenderFns = []


// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=template&id=2aab2f3f&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=template&id=74b68b78&
var timevue_type_template_id_74b68b78_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.type === 'datetime' ? 'el-zoom-in-bottom' : 'el-zoom-in-top'},on:{"after-leave":function($event){return _vm.$emit('dodestroy')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-time-panel el-popper",class:("el-time-panel__" + _vm.type + (_vm.popperClass ? ' ' + _vm.popperClass : ''))},[_c('div',{staticClass:"el-time-panel__content",class:{ 'has-seconds': _vm.showSeconds }},[_c('time-spinner',{ref:"spinner",attrs:{"unlink-range":_vm.unlinkRange,"arrow-control":_vm.useArrow,"show-seconds":_vm.showSeconds,"am-pm-mode":_vm.amPmMode,"date":_vm.date,"is-empty":_vm.isEmpty,"visible":_vm.visible},on:{"change":_vm.handleChange,"select-range":_vm.setSelectionRange}})],1),(_vm.unlink)?_c('div',{staticClass:"el-time-panel__footer"},[_c('el-button',{staticClass:"el-time-panel__btn",class:{ confirm: !_vm.disabled },attrs:{"disabled":_vm.isEmpty,"type":"primary"},domProps:{"textContent":_vm._s(_vm.t('el.datepicker.confirm'))},on:{"click":_vm.handleConfirm}})],1):_vm._e()])])}
var timevue_type_template_id_74b68b78_staticRenderFns = []


// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=template&id=74b68b78&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=35d7f5b9&
var time_spinnervue_type_template_id_35d7f5b9_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-time-spinner",class:{ 'has-seconds': _vm.showSeconds }},[(!_vm.arrowControl)?[_c('el-scrollbar',{ref:"hours",staticClass:"el-time-spinner__wrapper",attrs:{"wrap-style":"max-height: inherit;","view-class":"el-time-spinner__list","tag":"ul"},nativeOn:{"mouseenter":function($event){return _vm.emitSelectRange('hours')}}},_vm._l((_vm.hoursList),function(disabled,hour){return _c('li',{key:hour,staticClass:"el-time-spinner__item",class:{ active: hour === _vm.hours && !_vm.isEmpty, disabled: disabled },domProps:{"textContent":_vm._s(
            ('0' + (_vm.amPmMode ? hour % 12 || 12 : hour)).slice(-2) + _vm.amPm(hour)
          )},on:{"click":function($event){return _vm.handleClick('hours', {
              value: hour,
              disabled: disabled,
              active: hour === _vm.hours && !_vm.isEmpty
            })}}})}),0),_c('el-scrollbar',{ref:"minutes",staticClass:"el-time-spinner__wrapper",attrs:{"wrap-style":"max-height: inherit;","view-class":"el-time-spinner__list","tag":"ul"},nativeOn:{"mouseenter":function($event){return _vm.emitSelectRange('minutes')}}},_vm._l((_vm.minutesList),function(disabled,key){return _c('li',{key:key,staticClass:"el-time-spinner__item",class:{
            active: key === _vm.minutes && !_vm.isEmpty,
            disabled: disabled
          },domProps:{"textContent":_vm._s(('0' + key).slice(-2))},on:{"click":function($event){return _vm.handleClick('minutes', {
              value: key,
              disabled: disabled,
              active: key === _vm.minutes && !_vm.isEmpty
            })}}})}),0),_c('el-scrollbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSeconds),expression:"showSeconds"}],ref:"seconds",staticClass:"el-time-spinner__wrapper",attrs:{"wrap-style":"max-height: inherit;","view-class":"el-time-spinner__list","tag":"ul"},nativeOn:{"mouseenter":function($event){return _vm.emitSelectRange('seconds')}}},_vm._l((_vm.secondsList),function(disabled,key){return _c('li',{key:key,staticClass:"el-time-spinner__item",class:{
            active: key === _vm.seconds && !_vm.isEmpty,
            disabled: disabled
          },domProps:{"textContent":_vm._s(('0' + key).slice(-2))},on:{"click":function($event){return _vm.handleClick('seconds', {
              value: key,
              disabled: disabled,
              active: key === _vm.seconds && !_vm.isEmpty
            })}}})}),0)]:_vm._e(),(_vm.arrowControl)?[_c('div',{staticClass:"el-time-spinner__wrapper is-arrow",on:{"mouseenter":function($event){return _vm.emitSelectRange('hours')}}},[_c('i',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.decrease),expression:"decrease"}],staticClass:"el-time-spinner__arrow h-icon-angle-sm-up"}),_c('i',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.increase),expression:"increase"}],staticClass:"el-time-spinner__arrow h-icon-angle_down_sm"}),_c('ul',{ref:"hours",staticClass:"el-time-spinner__list"},_vm._l((_vm.arrowHourList),function(hour,key){return _c('li',{key:key,staticClass:"el-time-spinner__item",class:{ active: hour === _vm.hours, disabled: _vm.hoursList[hour] },domProps:{"textContent":_vm._s(
              hour === undefined
                ? ''
                : ('0' + (_vm.amPmMode ? hour % 12 || 12 : hour)).slice(-2) +
                  _vm.amPm(hour)
            )}})}),0)]),_c('div',{staticClass:"el-time-spinner__wrapper is-arrow",on:{"mouseenter":function($event){return _vm.emitSelectRange('minutes')}}},[_c('i',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.decrease),expression:"decrease"}],staticClass:"el-time-spinner__arrow h-icon-angle-sm-up"}),_c('i',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.increase),expression:"increase"}],staticClass:"el-time-spinner__arrow h-icon-angle_down_sm\n"}),_c('ul',{ref:"minutes",staticClass:"el-time-spinner__list"},_vm._l((_vm.arrowMinuteList),function(minute,key){return _c('li',{key:key,staticClass:"el-time-spinner__item",class:{ active: minute === _vm.minutes },domProps:{"textContent":_vm._s(minute === undefined ? '' : ('0' + minute).slice(-2))}})}),0)]),(_vm.showSeconds)?_c('div',{staticClass:"el-time-spinner__wrapper is-arrow",on:{"mouseenter":function($event){return _vm.emitSelectRange('seconds')}}},[_c('i',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.decrease),expression:"decrease"}],staticClass:"el-time-spinner__arrow h-icon-angle-sm-up"}),_c('i',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.increase),expression:"increase"}],staticClass:"el-time-spinner__arrow h-icon-angle_down_sm"}),_c('ul',{ref:"seconds",staticClass:"el-time-spinner__list"},_vm._l((_vm.arrowSecondList),function(second,key){return _c('li',{key:key,staticClass:"el-time-spinner__item",class:{ active: second === _vm.seconds },domProps:{"textContent":_vm._s(second === undefined ? '' : ('0' + second).slice(-2))}})}),0)]):_vm._e()]:_vm._e()],2)}
var time_spinnervue_type_template_id_35d7f5b9_staticRenderFns = []


// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=35d7f5b9&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var time_spinnervue_type_script_lang_js_ = ({
  components: {
    ElScrollbar: scrollbar
  },
  directives: {
    repeatClick: repeat_click
  },
  mixins: [locale],
  props: {
    date: {
      "default": null,
      validator: dateValidator
    },
    defaultValue: {
      "default": null,
      validator: dateValidator
    },
    // reserved for future use
    showSeconds: {
      type: Boolean,
      "default": true
    },
    arrowControl: {
      type: Boolean,
      "default": false
    },
    amPmMode: {
      type: String,
      "default": '' // 'a': am/pm; 'A': AM/PM

    },
    visible: {
      type: Boolean,
      "default": false
    },
    isEmpty: {
      type: Boolean,
      "default": true
    },
    unlinkRange: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      selectableRange: [],
      currentScrollbar: null
    };
  },
  computed: {
    internalDate: function internalDate() {
      return toDate(this.date);
    },
    hours: function hours() {
      return this.internalDate.getHours();
    },
    minutes: function minutes() {
      return this.internalDate.getMinutes();
    },
    seconds: function seconds() {
      return this.internalDate.getSeconds();
    },
    hoursList: function hoursList() {
      return util_getRange('hours', this.selectableRange);
    },
    minutesList: function minutesList() {
      return util_getRange('minutes', this.selectableRange, this.internalDate);
    },
    secondsList: function secondsList() {
      return util_getRange('seconds', this.selectableRange, this.internalDate);
    },
    arrowHourList: function arrowHourList() {
      var hours = this.hours;
      return [hours > 0 ? hours - 1 : undefined, hours, hours < 23 ? hours + 1 : undefined];
    },
    arrowMinuteList: function arrowMinuteList() {
      var minutes = this.minutes;
      return [minutes > 0 ? minutes - 1 : undefined, minutes, minutes < 59 ? minutes + 1 : undefined];
    },
    arrowSecondList: function arrowSecondList() {
      var seconds = this.seconds;
      return [seconds > 0 ? seconds - 1 : undefined, seconds, seconds < 59 ? seconds + 1 : undefined];
    }
  },
  methods: {
    increase: function increase() {
      this.scrollDown(1);
    },
    decrease: function decrease() {
      this.scrollDown(-1);
    },
    modifyDateField: function modifyDateField(type, value) {
      var data;

      switch (type) {
        case 'hours':
          data = modifyTime(this.internalDate, value, this.minutes, this.seconds);
          break;

        case 'minutes':
          data = modifyTime(this.internalDate, this.hours, value, this.seconds);
          break;

        case 'seconds':
          data = modifyTime(this.internalDate, this.hours, this.minutes, value);
          break;
      }

      if (this.selectableRange.length > 0) {
        var start = this.selectableRange[0][0];
        var end = this.selectableRange[0][1];
        var dataHours = data.getHours();
        var dataMinutes = data.getMinutes();
        var dataSeconds = data.getSeconds();
        var startHours = start.getHours();
        var startMinutes = start.getMinutes();
        var startSeconds = start.getSeconds();
        var endHours = end.getHours();
        var endMinutes = end.getMinutes();
        var endSeconds = end.getSeconds();

        if (dataHours === startHours && dataMinutes < startMinutes) {
          data.setMinutes(startMinutes);
          this.adjustSpinner('minutes', startMinutes, 120);
          data.setSeconds(startSeconds);
          this.adjustSpinner('seconds', startSeconds, 120);
        } else if (dataHours === startHours && dataMinutes === startMinutes && dataSeconds < startSeconds) {
          data.setSeconds(startSeconds);
          this.adjustSpinner('seconds', startSeconds, 120);
        }

        if (dataHours === endHours && dataMinutes > endMinutes) {
          data.setMinutes(endMinutes);
          this.adjustSpinner('minutes', endMinutes, 120);
          data.setSeconds(endSeconds);
          this.adjustSpinner('seconds', endSeconds, 120);
        } else if (dataHours === endHours && dataMinutes === endMinutes && dataSeconds > endSeconds) {
          data.setSeconds(endSeconds);
          this.adjustSpinner('seconds', endSeconds, 120);
        }
      }

      this.$emit('change', data);
    },
    handleClick: function handleClick(type, _ref) {
      var _this = this;

      var value = _ref.value,
          disabled = _ref.disabled,
          active = _ref.active;

      if (!disabled) {
        if (type === 'hours') {
          if (isDate(this.internalDate)) {
            var hours = modifyTime(this.internalDate, value, this.minutes, this.seconds);

            if (hours.getHours() !== value) {
              this.$message({
                message: this.t('el.datepicker.dstInfo'),
                type: 'info'
              });
            }

            value = hours.getHours();
          }
        }

        this.modifyDateField(type, value);
        this.$nextTick(function () {
          _this.adjustSpinner('hours', _this.hours, 120);

          _this.adjustSpinner('minutes', _this.minutes, 120);

          _this.adjustSpinner('seconds', _this.seconds, 120);

          _this.emitSelectRange(type);
        });
      }
    },
    emitSelectRange: function emitSelectRange(type) {
      if (this.visible) {
        if (type === 'hours') {
          this.$emit('select-range', 0, 2);
        } else if (type === 'minutes') {
          this.$emit('select-range', 3, 5);
        } else if (type === 'seconds') {
          this.$emit('select-range', 6, 8);
        }

        this.currentScrollbar = type;
      }
    },
    // NOTE: used by datetime / date-range panel
    //       renamed from adjustScrollTop
    //       should try to refactory it
    adjustSpinners: function adjustSpinners() {
      this.adjustSpinner('hours', this.hours);
      this.adjustSpinner('minutes', this.minutes);
      this.adjustSpinner('seconds', this.seconds);
    },
    adjustCurrentSpinner: function adjustCurrentSpinner(type) {
      this.adjustSpinner(type, this[type], 120);
    },
    adjustSpinner: function adjustSpinner(type, value) {
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      if (this.arrowControl) return;
      var el = this.$refs[type];

      if (el) {
        el.setScroll(value * this.typeItemHeight(type), 0, duration);
      }
    },
    scrollDown: function scrollDown(step) {
      var _this2 = this;

      if (!this.currentScrollbar) {
        this.emitSelectRange('hours');
      }

      var label = this.currentScrollbar;
      var hoursList = this.hoursList;
      var now = this[label]; // HUI fix circulation

      if (this.currentScrollbar === 'hours') {
        if (now === 0 && step < 0) {
          return;
        } else if (now === 23 && step > 0) {
          return;
        }
      } else {
        if (now === 0 && step < 0) {
          return;
        } else if (now === 59 && step > 0) {
          return;
        }
      }

      if (this.currentScrollbar === 'hours') {
        var total = Math.abs(step);
        step = step > 0 ? 1 : -1;
        var length = hoursList.length;

        while (length-- && total) {
          now = (now + step + hoursList.length) % hoursList.length;

          if (hoursList[now]) {
            continue;
          }

          total--;
        }

        if (hoursList[now]) return;
      } else {
        now = (now + step + 60) % 60;
      }

      this.modifyDateField(label, now);
      this.adjustSpinner(label, now);
      this.$nextTick(function () {
        _this2.emitSelectRange(_this2.currentScrollbar);
      });
    },
    amPm: function amPm(hour) {
      var shouldShowAmPm = this.amPmMode.toLowerCase() === 'a';
      if (!shouldShowAmPm) return '';
      var isCapital = this.amPmMode === 'A';
      var content = hour < 12 ? ' am' : ' pm';
      if (isCapital) content = content.toUpperCase();
      return content;
    },
    typeItemHeight: function typeItemHeight(type) {
      return this.$refs[type].$el.querySelector('li').offsetHeight;
    },
    scrollBarHeight: function scrollBarHeight(type) {
      return this.$refs[type].$el.offsetHeight;
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
 /* harmony default export */ var basic_time_spinnervue_type_script_lang_js_ = (time_spinnervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue





/* normalize component */

var time_spinner_component = normalizeComponent(
  basic_time_spinnervue_type_script_lang_js_,
  time_spinnervue_type_template_id_35d7f5b9_render,
  time_spinnervue_type_template_id_35d7f5b9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var time_spinner = (time_spinner_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var timevue_type_script_lang_js_ = ({
  components: {
    TimeSpinner: time_spinner,
    ElButton: packages_button
  },
  mixins: [locale],
  props: {
    visible: {
      type: Boolean,
      "default": false
    },
    timeArrowControl: {
      type: Boolean,
      "default": false
    },
    unlinkRange: {
      type: Boolean,
      "default": true
    },
    unlink: {
      type: Boolean,
      "default": true
    },
    timeType: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      popperClass: '',
      format: 'HH:mm:ss',
      value: util_now(),
      defaultValue: null,
      date: util_now(),
      selectableRange: [],
      selectionRange: [0, 2],
      disabled: false,
      arrowControl: false,
      needInitAdjust: true,
      type: 'datetime'
    };
  },
  computed: {
    showSeconds: function showSeconds() {
      return (this.format || '').indexOf('ss') !== -1;
    },
    useArrow: function useArrow() {
      return this.arrowControl || this.timeArrowControl || false;
    },
    amPmMode: function amPmMode() {
      if ((this.format || '').indexOf('A') !== -1) return 'A';
      if ((this.format || '').indexOf('a') !== -1) return 'a';
      return '';
    },
    isEmpty: function isEmpty() {
      return !this.defaultValue && util_isEmpty(this.value);
    }
  },
  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.$nextTick(function () {
          _this.adjustSpinners();

          _this.$refs.spinner.emitSelectRange('hours');
        });
      } else {
        this.needInitAdjust = true;

        if (util_isEmpty(this.value)) {
          this.$emit('pick', this.isEmpty ? null : this.date, false, !this.unlink);
        }
      }
    },
    value: function value(newVal, oldVal) {
      var _this2 = this;

      this.date = this.getTime();

      if (this.visible && this.needInitAdjust) {
        this.needInitAdjust = false;
      }

      this.$nextTick(function () {
        _this2.adjustChangeSpinners(newVal, oldVal);
      });
    },
    selectableRange: function selectableRange(val) {
      this.$refs.spinner.selectableRange = val;
    },
    defaultValue: function defaultValue(val) {
      if (util_isEmpty(this.value)) {
        this.date = toDate(val);
      }
    }
  },
  mounted: function mounted() {
    this.$emit('mounted');
  },
  methods: {
    adjustChangeSpinners: function adjustChangeSpinners(newVal, oldVal) {
      if (this.adjustCurrentSpinner && isDate(newVal) && isDate(oldVal)) {
        this.changeInput = true;

        if (newVal.getHours() !== oldVal.getHours()) {
          this.adjustCurrentSpinner('hours');
        } else if (newVal.getMinutes() !== oldVal.getMinutes()) {
          this.adjustCurrentSpinner('minutes');
        } else if (newVal.getSeconds() !== oldVal.getSeconds()) {
          this.adjustCurrentSpinner('seconds');
        }
      }
    },
    handleClear: function handleClear() {
      this.date = toDate(this.defaultValue);
      this.$emit('input', null);
      this.$emit('pick', null);
    },
    getDefaultValue: function getDefaultValue() {
      return toDate(this.defaultValue);
    },
    getTime: function getTime() {
      var value = isDate(this.value) ? this.value : this.getDefaultValue();
      return util_limitTimeRange(value, this.selectableRange, this.format);
    },
    handleChange: function handleChange(date) {
      // this.visible avoids edge cases, when use scrolls during panel closing animation
      if (this.visible) {
        this.date = clearMilliseconds(date);
        this.$emit('pick', this.date, true, !this.unlink);
      }
    },
    setSelectionRange: function setSelectionRange(start, end) {
      this.$emit('select-range', start, end, this.timeType);
      this.selectionRange = [start, end];
    },
    handleConfirm: function handleConfirm() {
      var date = clearMilliseconds(util_limitTimeRange(this.date, this.selectableRange, this.format));
      this.$emit('pick', date, false);
    },
    handleKeydown: function handleKeydown(event) {
      var keyCode = event.keyCode;
      var mapping = {
        38: -1,
        40: 1,
        37: -1,
        39: 1
      }; // Left or Right

      if (keyCode === 37 || keyCode === 39) {
        var step = mapping[keyCode];
        this.changeSelectionRange(step);
        event.preventDefault();
        return;
      } // Up or Down


      if (keyCode === 38 || keyCode === 40) {
        var _step = mapping[keyCode];
        this.$refs.spinner.scrollDown(_step);
        event.preventDefault();
      }
    },
    isValidValue: function isValidValue(date) {
      return timeWithinRange(date, this.selectableRange, this.format);
    },
    adjustSpinners: function adjustSpinners() {
      return this.$refs.spinner.adjustSpinners();
    },
    adjustCurrentSpinner: function adjustCurrentSpinner(type) {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$refs.spinner.adjustCurrentSpinner(type);
      });
    },
    changeSelectionRange: function changeSelectionRange(step) {
      var list = [0, 3].concat(this.showSeconds ? [6] : []);
      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
      var index = list.indexOf(this.selectionRange[0]);
      var next = (index + step + list.length) % list.length;
      this.$refs.spinner.emitSelectRange(mapping[next]);
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
 /* harmony default export */ var panel_timevue_type_script_lang_js_ = (timevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue





/* normalize component */

var time_component = normalizeComponent(
  panel_timevue_type_script_lang_js_,
  timevue_type_template_id_74b68b78_render,
  timevue_type_template_id_74b68b78_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var panel_time = (time_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=0a00b475&
var year_tablevue_type_template_id_0a00b475_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"el-year-table"},[_c('tbody',_vm._l((_vm.rows),function(row,rowKey){return _c('tr',{key:rowKey},_vm._l((row),function(cell,cellKey){return _c('td',{key:cellKey,class:_vm.getCellStyle(cell),on:{"click":function($event){return _vm.handleYearTableClick(cell)}}},[(_vm.$slots.year || _vm.$scopedSlots.year)?_vm._t("year",null,null,_vm.buildData(cell)):_c('span',{staticClass:"cell",domProps:{"textContent":_vm._s(cell.value)}})],2)}),0)}),0)])}
var year_tablevue_type_template_id_0a00b475_staticRenderFns = []


// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=0a00b475&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var year_tablevue_type_script_lang_js_datesInYear = function datesInYear(year) {
  var numOfDays = getDayCountOfYear(year);
  var firstDay = new Date(year, 0, 1);
  return range(numOfDays).map(function (n) {
    return nextDate(firstDay, n);
  });
};

/* harmony default export */ var year_tablevue_type_script_lang_js_ = ({
  props: {
    disabledDate: {
      type: Function,
      "default": function _default() {
        return false;
      }
    },
    defaultValue: {
      "default": null,
      validator: dateValidator
    },
    date: {
      "default": null,
      validator: dateValidator
    },
    value: {
      "default": null,
      validator: dateValidator
    },
    unlink: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      lastRow: null,
      lastColumn: null
    };
  },
  computed: {
    startYear: function startYear() {
      return Math.floor(this.date.getFullYear() / 10) * 10;
    },
    rows: function rows() {
      var _this = this;

      // TODO: refactory rows / getCellClasses
      var rows = [[], [], []];
      var disabledDate = this.disabledDate;
      var today = new Date();

      for (var i = 0; i < 3; i++) {
        var row = rows[i];

        var _loop = function _loop(j) {
          var cell = row[j];

          if (!cell) {
            cell = {
              row: i,
              column: j,
              type: 'normal'
            };
          }

          var index = _this.getIndex(i, j);

          var year = _this.startYear + +index - 1;
          cell.value = year;
          var isToday = today.getFullYear() === year;

          if (isToday) {
            cell.type = 'today';
          }

          if (+index === 0) {
            cell.type = 'prev-year';
          }

          if (+index === 11) {
            cell.type = 'next-year';
          }

          cell.disabled = year_tablevue_type_script_lang_js_datesInYear(year).every(disabledDate);
          cell.selected = arrayFindIndex(coerceTruthyValueToArray(_this.value), function (date) {
            return date.getFullYear() === year;
          }) >= 0;

          _this.$set(row, j, cell);
        };

        for (var j = 0; j < 4; j++) {
          _loop(j);
        }
      }

      return rows;
    }
  },
  methods: {
    buildData: function buildData(cell) {
      var _this2 = this;

      var data = {};
      var openKeys = ['value', 'type', 'disabled', 'selected'];
      openKeys.forEach(function (item) {
        data[item] = cell[item]; // 特殊处理 date

        var value = toDate(_this2.value);
        var date = new Date(value.getFullYear(), 1, 1, 0, 0, 0);
        data.date = date;
      });
      return data;
    },
    cellMatchesDate: function cellMatchesDate(cell, date) {
      var value = new Date(date);
      return cell.value === value.getFullYear();
    },
    getIndex: function getIndex(row, column) {
      return row * 4 + column;
    },
    getCellStyle: function getCellStyle(cell) {
      var _this3 = this;

      var style = {};
      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];
      style[cell.type] = true;
      style["default"] = defaultValue.some(function (date) {
        return _this3.cellMatchesDate(cell, date);
      });
      style.disabled = cell.disabled;
      style.selected = cell.selected;
      style.today = cell.type === 'today';
      return style;
    },
    handleYearTableClick: function handleYearTableClick(cell) {
      if (cell.disabled) {
        return;
      }

      this.$emit('pick', cell.value);
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
 /* harmony default export */ var basic_year_tablevue_type_script_lang_js_ = (year_tablevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue





/* normalize component */

var year_table_component = normalizeComponent(
  basic_year_tablevue_type_script_lang_js_,
  year_tablevue_type_template_id_0a00b475_render,
  year_tablevue_type_template_id_0a00b475_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var year_table = (year_table_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=7ec52025&
var month_tablevue_type_template_id_7ec52025_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"el-month-table"},[_c('tbody',_vm._l((_vm.rows),function(row,rowKey){return _c('tr',{key:rowKey},_vm._l((row),function(cell,cellKey){return _c('td',{key:cellKey,class:_vm.getCellStyle(cell),on:{"click":function($event){return _vm.handleMonthTableClick(cell)},"mousemove":function($event){return _vm.handleMouseMove(cell)}}},[(_vm.$slots.month || _vm.$scopedSlots.month)?_vm._t("month",null,null,_vm.buildData(cell)):_c('span',{staticClass:"cell",domProps:{"textContent":_vm._s(cell.value + 1)}})],2)}),0)}),0)])}
var month_tablevue_type_template_id_7ec52025_staticRenderFns = []


// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=7ec52025&

// CONCATENATED MODULE: ./packages/date-picker/src/mixins/range.js

/* harmony default export */ var mixins_range = ({
  computed: {
    showPrompt: function showPrompt() {
      if (typeof this.customValidation === 'function' && this.minDate && this.maxDate) {
        return this.customValidation(this.minDate, this.maxDate);
      }

      return true;
    },
    prompt: function prompt() {
      if (this.showAbnormalInfo) {
        return locale_default.a.t('el.datepicker.abnormalInfo');
      }

      return this.customPrompt;
    },
    disabledConfirm: function disabledConfirm() {
      if (this.showAbnormalInfo || !this.showPrompt) {
        return true;
      }

      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]));
    },
    isUnlinkRange: function isUnlinkRange() {
      if (!this.unlink) {
        return false;
      }

      return this.unlinkRange;
    }
  },
  methods: {
    emitRange: function emitRange(_ref) {
      var newDate = _ref.newDate,
          opts = _ref.opts;

      if (this.unlinkRange) {
        if (this.tableType === 'min') {
          if (newDate < this.maxDate || this.minDate === null && this.maxDate === null || this.unlinkRange) {
            this.$emit('pick', {
              minDate: newDate,
              maxDate: this.maxDate
            }, opts);
          } else {
            this.$emit('pick', {
              minDate: null,
              maxDate: this.maxDate
            }, opts);
          }
        } else {
          if (newDate > this.minDate || this.minDate === null && this.maxDate === null || this.unlinkRange) {
            this.$emit('pick', {
              minDate: this.minDate,
              maxDate: newDate
            }, opts);
          } else {
            this.$emit('pick', {
              minDate: this.minDate,
              maxDate: null
            }, opts);
          }
        }
      } else {
        if (!this.rangeState.selecting) {
          this.$emit('pick', {
            minDate: newDate,
            maxDate: null
          }, opts);
          this.rangeState.selecting = true;
        } else {
          if (newDate >= this.minDate) {
            this.$emit('pick', {
              minDate: this.minDate,
              maxDate: newDate
            }, opts);
          } else {
            this.$emit('pick', {
              minDate: newDate,
              maxDate: this.minDate
            }, opts);
          }

          this.rangeState.selecting = false;
        }
      }
    }
  },
  data: function data() {
    return {
      customValidation: function customValidation() {
        return true;
      },
      customPrompt: locale_default.a.t('el.datepicker.abnormalInfo')
    };
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* 月份 i18n
el.datepicker.months.jan
el.datepicker.months.feb
el.datepicker.months.mar
el.datepicker.months.apr
el.datepicker.months.may
el.datepicker.months.jun
el.datepicker.months.jul
el.datepicker.months.aug
el.datepicker.months.sep
el.datepicker.months.oct
el.datepicker.months.nov
el.datepicker.months.dec
 */




var month_tablevue_type_script_lang_js_datesInMonth = function datesInMonth(year, month) {
  var numOfDays = getDayCountOfMonth(year, month);
  var firstDay = new Date(year, month, 1);
  return range(numOfDays).map(function (n) {
    return nextDate(firstDay, n);
  });
};

/* harmony default export */ var month_tablevue_type_script_lang_js_ = ({
  mixins: [mixins_range],
  props: {
    disabledDate: {
      type: null,
      "default": function _default() {
        return false;
      }
    },
    minDate: {
      type: null,
      "default": null
    },
    maxDate: {
      type: null,
      "default": null
    },
    defaultValue: {
      "default": null,
      validator: dateValidator
    },
    date: {
      "default": util_now('clearDate'),
      validator: dateValidator
    },
    value: {
      "default": null,
      validator: dateValidator
    },
    selectionMode: {
      type: String,
      "default": 'month'
    },
    rangeState: {
      type: Object,
      "default": function _default() {
        return {
          endDate: null,
          selecting: false
        };
      }
    },
    unlinkRange: {
      type: Boolean,
      "default": true
    },
    tableType: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      lastRow: null,
      lastColumn: null
    };
  },
  computed: {
    customValidationResult: function customValidationResult() {
      if (typeof this.customValidation === 'function') {
        var disabledMaxDate = new Date(this.maxDate);
        disabledMaxDate.setHours(0);
        disabledMaxDate.setMinutes(0);
        disabledMaxDate.setSeconds(0);
        return this.customValidation(new Date(this.minDate), disabledMaxDate);
      }

      return true;
    },
    rows: function rows() {
      var _this = this;

      // TODO: refactory rows / getCellClasses
      var rows = [[], []];
      var disabledDate = this.disabledDate;
      var year = this.date.getFullYear();

      var selectedDate = function selectedDate(cell, month) {
        return arrayFindIndex(coerceTruthyValueToArray(_this.value), function (date) {
          return date.getFullYear() === year && date.getMonth() === month;
        }) >= 0;
      };

      for (var i = 0; i < 2; i++) {
        var row = rows[i];

        for (var j = 0; j < 6; j++) {
          var cell = row[j];

          if (!cell) {
            cell = {
              row: i,
              column: j,
              type: 'normal',
              inRange: false,
              start: false,
              end: false,
              tableType: this.tableType
            };
          }

          var index = this.getIndex(i, j);
          var time = clearDate(new Date(this.date.getFullYear(), index)).getTime();
          cell.inRange = time >= this.getMonthstamp(this.minDate) && time <= this.getMonthstamp(this.maxDate);
          cell.start = this.minDate && time === this.getMonthstamp(this.minDate);
          cell.end = this.maxDate && time === this.getMonthstamp(this.maxDate);
          var isToday = time === this.getMonthstamp(util_now('clearDate'));

          if (isToday) {
            cell.type = 'today';
          }

          cell.value = index;
          cell.disabled = month_tablevue_type_script_lang_js_datesInMonth(year, index).every(disabledDate);
          cell.selected = selectedDate(cell, cell.value);
          this.$set(row, j, cell);
        }
      }

      return rows;
    }
  },
  watch: {
    'rangeState.endDate': function rangeStateEndDate(newVal) {
      this.markRange(this.minDate, newVal);
    },
    minDate: function minDate(newVal, oldVal) {
      if (this.getMonthstamp(newVal) !== this.getMonthstamp(oldVal)) {
        this.markRange(this.minDate, this.maxDate);
      }
    },
    maxDate: function maxDate(newVal, oldVal) {
      if (this.getMonthstamp(newVal) !== this.getMonthstamp(oldVal)) {
        this.markRange(this.minDate, this.maxDate);
      }
    }
  },
  methods: {
    buildData: function buildData(cell) {
      var _this2 = this;

      var data = {};
      var openKeys = ['value', 'type', 'disabled', 'selected'];
      openKeys.forEach(function (item) {
        data[item] = cell[item]; // 特殊处理 date

        var value = toDate(_this2.value);
        var date = new Date(value.getFullYear(), value.getMonth(), 1, 0, 0, 0);
        data.date = date;
      });
      return data;
    },
    getMonthstamp: function getMonthstamp(date) {
      return getTimestamp(date, 'clearDate');
    },
    getIndex: function getIndex(row, column) {
      return row * 6 + column;
    },
    cellMatchesDate: function cellMatchesDate(cell, date) {
      var value = new Date(date);
      return this.date.getFullYear() === value.getFullYear() && +cell.value === value.getMonth();
    },
    markRange: function markRange(minDate, maxDate) {
      minDate = this.getMonthstamp(minDate);
      maxDate = this.getMonthstamp(maxDate) || (this.unlinkRange ? NaN : minDate);

      if (!this.unlinkRange) {
        var _ref = [Math.min(minDate, maxDate), Math.max(minDate, maxDate)];
        minDate = _ref[0];
        maxDate = _ref[1];
      }

      var rows = this.rows;

      for (var i = 0, k = rows.length; i < k; i++) {
        var row = rows[i];

        for (var j = 0, l = row.length; j < l; j++) {
          var cell = row[j];
          var index = this.getIndex(i, j);
          var time = new Date(this.date.getFullYear(), index).getTime();
          cell.inRange = minDate && time >= minDate && time <= maxDate;
          cell.start = minDate && time === minDate;
          cell.end = maxDate && time === maxDate;
        }
      }
    },
    handleMouseMove: function handleMouseMove(cell) {
      if (!this.rangeState.selecting) {
        return;
      }

      var row = cell.row;
      var column = cell.column; // can not select disabled date

      if (cell.disabled) {
        return;
      } // only update rangeState when mouse moves to a new cell
      // this avoids frequent Date object creation and improves performance


      if (row !== this.lastRow || column !== this.lastColumn) {
        this.lastRow = row;
        this.lastColumn = column;
        this.$emit('changerange', {
          minDate: this.minDate,
          maxDate: this.maxDate,
          rangeState: {
            selecting: true,
            endDate: this.getMonthOfCell(this.getIndex(row, column))
          }
        });
      }
    },
    getCellStyle: function getCellStyle(cell) {
      var _this3 = this;

      var style = {};
      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];
      style[cell.type] = true;
      style["default"] = defaultValue.some(function (date) {
        return _this3.cellMatchesDate(cell, date);
      });
      style.disabled = cell.disabled;
      style.selected = cell.selected;
      style.today = cell.type === 'today';

      if (cell.start && (this.unlinkRange ? this.tableType !== 'max' : true)) {
        style['start-date'] = true;
      }

      if (cell.end && (this.unlinkRange ? this.tableType !== 'min' : true)) {
        style['end-date'] = true;
      }

      if (cell.inRange && !this.unlinkRange) {
        style['in-range'] = true;
      }

      return style;
    },
    getMonthOfCell: function getMonthOfCell(month) {
      var year = this.date.getFullYear();
      return new Date(year, month, 1);
    },
    handleMonthTableClick: function handleMonthTableClick(cell) {
      if (cell.disabled) {
        return;
      }

      var column = cell.column;
      var row = cell.row;
      var month = this.getIndex(row, column);
      var newDate = this.getMonthOfCell(month);
      var opts = {
        type: this.tableType,
        cell: cell
      };

      if (this.selectionMode === 'range') {
        this.emitRange({
          newDate: newDate,
          opts: opts
        });
      } else {
        this.$emit('pick', month);
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
 /* harmony default export */ var basic_month_tablevue_type_script_lang_js_ = (month_tablevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue





/* normalize component */

var month_table_component = normalizeComponent(
  basic_month_tablevue_type_script_lang_js_,
  month_tablevue_type_template_id_7ec52025_render,
  month_tablevue_type_template_id_7ec52025_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var month_table = (month_table_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=1ed2f364&
var date_tablevue_type_template_id_1ed2f364_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"el-date-table el-date-table__week"},[(_vm.showWeekNumber)?_c('div',[_vm._v(" "+_vm._s(_vm.t('el.datepicker.week'))+" ")]):_vm._e(),_vm._l((_vm.WEEKS),function(week,key){return _c('div',{key:key,staticClass:"el-date-table__week-cell",domProps:{"textContent":_vm._s(_vm.t('el.datepicker.weeks.' + week))}})})],2),_c('table',{staticClass:"el-date-table el-date-table__calendar",class:{
      'is-week-mode': _vm.selectionMode === 'week',
      'is-unlink': _vm.unlinkRange
    },attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('tbody',_vm._l((_vm.rows),function(row,key){return _c('tr',{key:key,staticClass:"el-date-table__row",class:{
          selected: _vm.isWeekActive(row[1])
        }},_vm._l((row),function(cell,rowKey){return _c('td',{key:rowKey,class:_vm.getCellClasses(cell),on:{"click":function($event){return _vm.handleClick(cell)},"mousemove":function($event){return _vm.handleMouseMove(cell)}}},[(_vm.$slots.date || _vm.$scopedSlots.date)?_vm._t("date",null,null,_vm.buildData(cell)):_c('span',{staticClass:"cell",domProps:{"textContent":_vm._s(cell.value)}})],2)}),0)}),0)])])}
var date_tablevue_type_template_id_1ed2f364_staticRenderFns = []


// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=1ed2f364&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // remove the first element that satisfies `pred` from arr
// return a new array if modification occurs
// return the original array otherwise

var date_tablevue_type_script_lang_js_removeFromArray = function removeFromArray(arr, pred) {
  var idx = typeof pred === 'function' ? arrayFindIndex(arr, pred) : arr.indexOf(pred);
  return idx >= 0 ? [].concat(_toConsumableArray(arr.slice(0, idx)), _toConsumableArray(arr.slice(idx + 1))) : arr;
};

var _WEEKS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
/* harmony default export */ var date_tablevue_type_script_lang_js_ = ({
  mixins: [locale, mixins_range],
  props: {
    firstDayOfWeek: {
      "default": 1,
      type: Number,
      validator: function validator(val) {
        return val >= 1 && val <= 7;
      }
    },
    minDate: {
      type: null,
      "default": null
    },
    maxDate: {
      type: null,
      "default": null
    },
    defaultValue: {
      "default": null,
      validator: dateValidator
    },
    date: {
      "default": null,
      validator: dateValidator
    },
    value: {
      "default": null,
      validator: dateValidator
    },
    selectionMode: {
      type: String,
      "default": 'day'
    },
    showWeekNumber: {
      type: Boolean,
      "default": false
    },
    disabledDate: {
      type: Function,
      "default": function _default() {
        return false;
      }
    },
    rangeState: {
      type: null,
      "default": function _default() {
        return {
          endDate: null,
          selecting: false
        };
      }
    },
    tableType: {
      type: String,
      "default": null
    },
    unlinkRange: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      lastRow: null,
      lastColumn: null
    };
  },
  computed: {
    offsetDay: function offsetDay() {
      var week = this.firstDayOfWeek; // 周日为界限，左右偏移的天数，3217654 例如周一就是 -1，目的是调整前两行日期的位置

      return week > this.firstDayOfMonth ? 7 - week : -week;
    },
    WEEKS: function WEEKS() {
      var week = this.firstDayOfWeek;
      return _WEEKS.concat(_WEEKS).slice(week, week + 7);
    },
    year: function year() {
      return this.date.getFullYear();
    },
    month: function month() {
      return this.date.getMonth();
    },
    monthDate: function monthDate() {
      return this.date.getDate();
    },
    startDate: function startDate() {
      return getStartDateOfMonth(this.year, this.month);
    },
    firstDayOfMonth: function firstDayOfMonth() {
      var date = new Date(this.year, this.month, 1);
      return getFirstDayOfMonth(date);
    },
    rows: function rows() {
      var _this = this;

      // TODO: refactory rows / getCellClasses
      var rows = [[], [], [], [], [], []];
      var date = new Date(this.year, this.month, 1);
      var day = getFirstDayOfMonth(date); // day of first day

      var selectionMode = this.selectionMode;
      var dateCountOfMonth = getDayCountOfMonth(date.getFullYear(), date.getMonth());
      var dateCountOfLastMonth = getDayCountOfMonth(date.getFullYear(), date.getMonth() === 0 ? 11 : date.getMonth() - 1);

      var selectedDate = function selectedDate(cell, cellDate) {
        if (_this.selectionMode === 'dates') {
          return !!arrayFind(coerceTruthyValueToArray(_this.value), function (date) {
            return clearTime(date).getTime() === clearTime(cellDate).getTime();
          });
        } else if (selectionMode === 'day') {
          return (cell.type === 'normal' || cell.type === 'today') && _this.cellMatchesDate(cell, _this.value);
        } else {
          return false;
        }
      };

      var offset = this.offsetDay;
      var count = 1;
      var startDate = this.startDate;
      var disabledDate = this.disabledDate;

      for (var i = 0; i < 6; i++) {
        var row = rows[i];

        if (this.showWeekNumber) {
          if (!row[0]) {
            row[0] = {
              type: 'week',
              value: getWeekNumber(nextDate(startDate, i * 7 + 1))
            };
          }
        }

        for (var j = 0; j < 7; j++) {
          var cell = row[this.showWeekNumber ? j + 1 : j];

          if (!cell) {
            cell = {
              row: i,
              column: j,
              type: 'normal',
              inRange: false,
              start: false,
              end: false,
              tableType: this.tableType
            };
          }

          cell.type = 'normal';
          var index = i * 7 + j;
          var time = nextDate(startDate, index - offset).getTime();
          cell.inRange = time >= getTimestamp(this.minDate) && time <= getTimestamp(this.maxDate);
          cell.start = this.minDate && time === getTimestamp(this.minDate);
          cell.end = this.maxDate && time === getTimestamp(this.maxDate);
          var isToday = time === getTimestamp(util_now());

          if (isToday) {
            cell.type = 'today';
          }

          if (i >= 0 && i <= 1) {
            if (j + i * 7 >= day + offset) {
              cell.value = count++;
            } else {
              cell.value = dateCountOfLastMonth - (day + offset - j % 7) + 1 + i * 7;
              cell.type = 'prev-month';
            }
          } else {
            if (count <= dateCountOfMonth) {
              cell.value = count++;
            } else {
              cell.value = count++ - dateCountOfMonth;
              cell.type = 'next-month';
            }
          }

          var cellDate = new Date(time);
          cell.disabled = disabledDate(cellDate);
          cell.selected = selectedDate(cell, cellDate);
          this.$set(row, this.showWeekNumber ? j + 1 : j, cell);
        }

        if (this.selectionMode === 'week') {
          var start = this.showWeekNumber ? 1 : 0;
          var end = this.showWeekNumber ? 7 : 6;
          var isWeekActive = this.isWeekActive(row[start + 1]);
          row[start].inRange = isWeekActive;
          row[start].start = isWeekActive;
          row[end].inRange = isWeekActive;
          row[end].end = isWeekActive;
        }
      }

      return rows;
    },
    weekDate: function weekDate() {
      var date = util_now();
      var startDate = this.startDate;
      var offset = this.offsetDay;
      this.rows.forEach(function (item) {
        item.forEach(function (cell) {
          if (cell.start) {
            date = nextDate(startDate, cell.row * 7 - offset);
          }
        });
      });
      return date;
    }
  },
  watch: {
    'rangeState.endDate': function rangeStateEndDate(newVal) {
      this.markRange(this.minDate, newVal);
    },
    minDate: function minDate(newVal, oldVal) {
      if (getTimestamp(newVal) !== getTimestamp(oldVal)) {
        this.markRange(this.minDate, this.maxDate);
      }
    },
    maxDate: function maxDate(newVal, oldVal) {
      if (getTimestamp(newVal) !== getTimestamp(oldVal)) {
        this.markRange(this.minDate, this.maxDate);
      }
    }
  },
  methods: {
    buildData: function buildData(cell) {
      var _this2 = this;

      var data = {};
      var openKeys = ['value', 'type', 'disabled', 'selected'];
      openKeys.forEach(function (item) {
        data[item] = cell[item]; // 特殊处理 date

        var value = toDate(_this2.value);
        var date = new Date(value.getFullYear(), value.getMonth(), value.getDate(), 0, 0, 0);
        data.date = date;
      });
      return data;
    },
    cellMatchesDate: function cellMatchesDate(cell, date) {
      var value = new Date(date);
      return this.year === value.getFullYear() && this.month === value.getMonth() && +cell.value === value.getDate();
    },
    getCellClasses: function getCellClasses(cell) {
      var _this3 = this;

      var style = {};
      var selectionMode = this.selectionMode;
      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];
      style[cell.type] = true;
      style["default"] = cell.type === 'normal' && defaultValue.some(function (date) {
        return _this3.cellMatchesDate(cell, date);
      });
      style.disabled = cell.disabled;
      style.selected = cell.selected;

      if (selectionMode === 'week') {
        if (cell.start) {
          style['start-date'] = true;
        }

        if (cell.end) {
          style['end-date'] = true;
        }
      } else if (cell.type === 'normal' || cell.type === 'today') {
        if (cell.start && (this.unlinkRange ? this.tableType !== 'max' : true)) {
          style['start-date'] = true;
        }

        if (cell.end && (this.unlinkRange ? this.tableType !== 'min' : true)) {
          style['end-date'] = true;
        }

        if (cell.inRange && !this.unlinkRange) {
          style['in-range'] = true;
        }
      }

      return style;
    },
    getDateOfCell: function getDateOfCell(row, column) {
      var offsetFromStart = row * 7 + (column - (this.showWeekNumber ? 1 : 0)) - this.offsetDay;
      return nextDate(this.startDate, offsetFromStart);
    },
    isWeekActive: function isWeekActive(cell) {
      if (this.selectionMode !== 'week') return false;
      var newDate = new Date(this.year, this.month, 1);
      var year = newDate.getFullYear();
      var month = newDate.getMonth();

      if (cell.type === 'prev-month') {
        newDate = setYear(newDate, month === 0 ? year - 1 : year);
        newDate = setMonth(newDate, month === 0 ? 11 : month - 1);
      }

      if (cell.type === 'next-month') {
        newDate = setYear(newDate, month === 11 ? year + 1 : year);
        newDate = setMonth(newDate, month === 11 ? 0 : month + 1);
      }

      newDate = setDate(newDate, parseInt(cell.value, 10));

      if (isDate(this.value)) {
        var dayOffset = (this.value.getDay() - this.firstDayOfWeek + 7) % 7 - 1;
        var weekDate = prevDate(this.value, dayOffset);
        return weekDate.getTime() === newDate.getTime();
      }

      return false;
    },
    markRange: function markRange(minDate, maxDate) {
      minDate = getTimestamp(minDate);
      maxDate = getTimestamp(maxDate) || (this.unlinkRange ? NaN : minDate);

      if (!this.unlinkRange) {
        var _ref = [Math.min(minDate, maxDate), Math.max(minDate, maxDate)];
        minDate = _ref[0];
        maxDate = _ref[1];
      }

      var startDate = this.startDate;
      var rows = this.rows;

      for (var i = 0, k = rows.length; i < k; i++) {
        var row = rows[i];

        for (var j = 0, l = row.length; j < l; j++) {
          if (this.showWeekNumber && j === 0) continue;
          var cell = row[j];
          var index = i * 7 + j + (this.showWeekNumber ? -1 : 0);
          var time = nextDate(startDate, index - this.offsetDay).getTime();
          cell.inRange = minDate && time >= minDate && time <= maxDate;
          cell.start = minDate && time === minDate;
          cell.end = maxDate && time === maxDate;
        }
      }
    },
    handleMouseMove: function handleMouseMove(cell) {
      // can not select disabled date
      if (!this.rangeState.selecting || cell.disabled || this.unlinkRange) {
        return;
      } // HUI modification


      var row = cell.row;
      var column = cell.column; // only update rangeState when mouse moves to a new cell
      // this avoids frequent Date object creation and improves performance

      if (row !== this.lastRow || column !== this.lastColumn) {
        this.lastRow = row;
        this.lastColumn = column;
        this.$emit('changerange', {
          minDate: this.minDate,
          maxDate: this.maxDate,
          rangeState: {
            selecting: true,
            endDate: this.getDateOfCell(row, column)
          }
        });
      }
    },
    handleClick: function handleClick(cell) {
      // HUI modification
      var row = cell.row;
      var column = this.selectionMode === 'week' ? 1 : cell.column;
      if (cell.disabled || cell.type === 'week') return;
      var newDate = this.getDateOfCell(row, column);
      var opts = {
        type: this.tableType,
        cell: cell
      };

      if (this.selectionMode === 'range') {
        this.emitRange({
          newDate: newDate,
          opts: opts
        });
      } else if (this.selectionMode === 'day') {
        this.$emit('pick', newDate, opts);
      } else if (this.selectionMode === 'week') {
        var weekNumber = getWeekNumber(newDate);
        this.$emit('pick', {
          year: newDate.getFullYear(),
          week: weekNumber,
          date: prevDate(newDate)
        }, opts);
      } else if (this.selectionMode === 'dates') {
        var value = this.value || [];
        var newValue = cell.selected ? date_tablevue_type_script_lang_js_removeFromArray(value, function (date) {
          return date.getTime() === newDate.getTime();
        }) : [].concat(_toConsumableArray(value), [newDate]);
        this.$emit('pick', newValue, opts);
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
 /* harmony default export */ var basic_date_tablevue_type_script_lang_js_ = (date_tablevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue





/* normalize component */

var date_table_component = normalizeComponent(
  basic_date_tablevue_type_script_lang_js_,
  date_tablevue_type_template_id_1ed2f364_render,
  date_tablevue_type_template_id_1ed2f364_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var date_table = (date_table_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var datevue_type_script_lang_js_ = ({
  directives: {
    Clickoutside: clickoutside
  },
  components: {
    TimePicker: panel_time,
    YearTable: year_table,
    MonthTable: month_table,
    DateTable: date_table,
    ElInput: packages_input,
    ElButton: packages_button
  },
  mixins: [locale],
  data: function data() {
    return {
      closeOnClickModal: true,
      popperClass: '',
      date: util_now(),
      time: null,
      value: '',
      defaultValue: null,
      // use getDefaultValue() for time computation
      defaultTime: null,
      showTime: false,
      selectionMode: 'day',
      type: '',
      shortcuts: '',
      visible: false,
      currentView: 'date',
      disabledDate: function disabledDate() {
        return false;
      },
      selectableRange: [],
      firstDayOfWeek: 1,
      showWeekNumber: false,
      timePickerVisible: false,
      format: '',
      arrowControl: false,
      userInputDate: null,
      userInputTime: null,
      unlink: true,
      displayValue: ''
    };
  },
  computed: {
    isEn: function isEn() {
      var reg = /^[a-zA-Z]+$/;
      return reg.test(this.monthLabel);
    },
    btnDisabled: function btnDisabled() {
      if (!!this.value && this.disabledDate(this.value)) {
        return true;
      }

      return !this.value;
    },
    transitionName: function transitionName() {
      return false;
    },
    nowI18nKey: function nowI18nKey() {
      switch (this.selectionMode) {
        case 'year':
          return 'el.datepicker.currentYear';

        case 'month':
          return 'el.datepicker.currentMonth';

        case 'week':
          return 'el.datepicker.currentWeek';

        case 'day':
          if (this.type === 'datetime') {
            return 'el.datepicker.now';
          } else {
            return 'el.datepicker.today';
          }

        default:
          return 'el.datepicker.now';
      }
    },
    hasSidebar: function hasSidebar() {
      return this.$slots.sidebar || this.shortcuts;
    },
    visibleFooter: function visibleFooter() {
      return this.unlink || this.showTime;
    },
    year: function year() {
      return this.date.getFullYear();
    },
    month: function month() {
      return this.date.getMonth();
    },
    week: function week() {
      return getWeekNumber(this.date);
    },
    monthDate: function monthDate() {
      return this.date.getDate();
    },
    visibleDateTable: function visibleDateTable() {
      return this.currentView === 'date' || this.selectionMode === 'day' || this.selectionMode === 'dates' || this.selectionMode === 'week';
    },
    visibleTime: function visibleTime() {
      if (this.userInputTime !== null) {
        return this.userInputTime;
      }

      var time = toDate(this.time);

      if (this.time) {
        return formatAsFormatAndType(time, this.timeFormat, this.type);
      } else {
        return this.defaultTime || '';
      }
    },
    visibleDate: function visibleDate() {
      if (this.userInputDate !== null) {
        return this.userInputDate;
      } else {
        return formatAsFormatAndType(this.value || this.defaultValue, this.dateFormat, this.type);
      }
    },
    yearLabel: function yearLabel() {
      var yearTranslation = this.t('el.datepicker.year');

      if (this.currentView === 'year') {
        var startYear = Math.floor(this.year / 10) * 10;

        if (yearTranslation) {
          return startYear + yearTranslation + ' - ' + (startYear + 9) + yearTranslation;
        }

        return startYear + ' - ' + (startYear + 9);
      }

      return this.year + yearTranslation;
    },
    monthLabel: function monthLabel() {
      return this.t("el.datepicker.month".concat(this.month + 1));
    },
    timeFormat: function timeFormat() {
      if (this.format) {
        return extractTimeFormat(this.format);
      } else {
        return 'HH:mm:ss';
      }
    },
    dateFormat: function dateFormat() {
      if (this.format) {
        return extractDateFormat(this.format);
      } else {
        return 'yyyy/MM/dd';
      }
    },
    refInput: function refInput() {
      if (this.$refs.input.$el) {
        return [].slice.call(this.$refs.input.$el.querySelectorAll('input'))[0];
      }

      return [];
    },
    disabledNow: function disabledNow() {
      return !((!this.disabledDate || !this.disabledDate(util_now())) && this.checkDateWithinRange(util_now()));
    },
    weekOffsetDay: function weekOffsetDay() {
      var week = this.firstDayOfWeek;
      return week > this.date.getDay() ? 7 - week : -week;
    }
  },
  watch: {
    visible: function visible(val) {
      if (!val) {
        this.closeModal();
      } else {
        if (this.selectionMode === 'month') {
          this.currentView = 'month';
        } else if (this.selectionMode === 'year') {
          this.currentView = 'year';
        } else {
          this.currentView = 'date';
        }
      }
    },
    showTime: function showTime(val) {
      var _this = this;

      /* istanbul ignore if */
      if (!val) return;
      this.$nextTick(function () {
        var inputElm = _this.$refs.input.$el;

        if (inputElm) {
          _this.pickerWidth = inputElm.getBoundingClientRect().width + 10;
        }
      });
    },
    value: function value(newVal, oldVal) {
      if (this.selectionMode === 'dates' && this.value) return;

      if (isDate(newVal)) {
        this.date = this.type === 'datetime' ? new Date(newVal) : clearTime(newVal);

        if (this.$refs.timepicker && isDate(oldVal)) {
          this.$refs.timepicker.adjustCurrentSpinner('hours');
          this.$refs.timepicker.adjustCurrentSpinner('minutes');
          this.$refs.timepicker.adjustCurrentSpinner('seconds');
        }
      } else {
        this.date = this.getDefaultValue();
      }

      this.time = newVal;
    },
    defaultValue: function defaultValue(val) {
      if (!isDate(this.value)) {
        this.resetView();
      }
    },
    defaultTime: function defaultTime(val) {
      if (!isDate(this.value)) {
        this.resetView();
      }
    },
    timePickerVisible: function timePickerVisible(val) {
      var _this2 = this;

      if (val) {
        if (this.defaultTime) {
          this.time = this.getTime();
        }

        this.$nextTick(function () {
          return _this2.$refs.timepicker.adjustSpinners();
        });
        this.openModal(this.$refs.pickerHeader);
      } else {
        if (!this.time) {
          this.time = this.getTime();
        }

        this.closeModal();
      }
    },
    selectionMode: function selectionMode(newVal) {
      if (newVal === 'month') {
        /* istanbul ignore next */
        if (this.currentView !== 'year' || this.currentView !== 'month') {
          this.currentView = 'month';
        }
      } else if (newVal === 'dates') {
        this.currentView = 'date';
      }
    },
    currentView: function currentView(val) {
      if (val === 'date') {
        this.closeModal();
      }
    }
  },
  beforeMount: function beforeMount() {
    this._popupId = "popup-date-".concat(this._uid);
    popup_manager.register(this._popupId, this);
  },
  beforeDestroy: function beforeDestroy() {
    popup_manager.deregister(this._popupId);
    popup_manager.closeModal(this._popupId);
  },
  methods: {
    proxyTimePickerDataProperties: function proxyTimePickerDataProperties() {
      var _this3 = this;

      var format = function format(timeFormat) {
        _this3.$refs.timepicker.format = timeFormat;
      };

      var value = function value(_value) {
        _this3.$refs.timepicker.value = _value;
      };

      var time = function time(_time) {
        _this3.$refs.timepicker.date = _time;
      };

      var selectableRange = function selectableRange(_selectableRange) {
        _this3.$refs.timepicker.selectableRange = _selectableRange;
      };

      var defaultValue = function defaultValue(_defaultValue) {
        _this3.$refs.timepicker.defaultValue = _defaultValue;
      };

      this.$watch('timeFormat', format);
      this.$watch('value', value);
      this.$watch('time', time);
      this.$watch('selectableRange', selectableRange);
      this.$watch('defaultValue', defaultValue);
      this.$watch('defaultTime', defaultValue);
      format(this.timeFormat);
      value(this.value);
      time(this.time);
      selectableRange(this.selectableRange);
      defaultValue(this.defaultValue || this.defaultTime);
    },
    handleClear: function handleClear() {
      this.date = this.getDefaultValue();
      this.time = null;
      this.emit(null);
    },
    emit: function emit(value) {
      var _this4 = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (util_isEmpty(value)) {
        this.$emit.apply(this, ['pick', value].concat(args));
      } else if (Array.isArray(value)) {
        var dates = value.map(function (date) {
          return _this4.showTime ? clearMilliseconds(date) : clearTime(date);
        });
        this.$emit.apply(this, ['pick', dates].concat(args));
      } else {
        this.$emit.apply(this, ['pick', this.showTime ? clearMilliseconds(value) : clearTime(value)].concat(args));
      }

      this.userInputDate = null;
      this.userInputTime = null;
    },
    openModal: function openModal(dom) {
      popup_manager.openModal({
        id: this._popupId,
        zIndex: 10,
        dom: dom,
        modalClass: '',
        modalFade: true,
        multiModal: true
      });
    },
    closeModal: function closeModal() {
      popup_manager.closeModal(this._popupId);
    },
    close: function close() {
      this.currentView = 'date';
      this.closeModal();
    },
    showYearPicker: function showYearPicker() {
      var _this5 = this;

      this.currentView = 'year';

      if (this.selectionMode !== 'year' && this.selectionMode !== 'month') {
        this.$nextTick(function () {
          _this5.openModal(_this5.$refs.yearTable.$el);
        });
      }
    },
    showMonthPicker: function showMonthPicker() {
      var _this6 = this;

      this.currentView = 'month';

      if (this.selectionMode !== 'year' && this.selectionMode !== 'month') {
        this.$nextTick(function () {
          _this6.openModal(_this6.$refs.monthTable.$el);
        });
      }
    },
    setValue: function setValue(emit) {
      if (this.value && this.selectionMode !== 'dates') {
        this.value = this.date;
      }

      if (emit) {
        this.emit(this.value, true);
      }
    },
    prevMonth: function prevMonth() {
      this.date = util_prevMonth(this.date);
      this.setValue(true);
    },
    nextMonth: function nextMonth() {
      this.date = util_nextMonth(this.date);
      this.setValue(true);
    },
    prevYear: function prevYear() {
      if (this.currentView === 'year') {
        this.date = util_prevYear(this.date, 10);
      } else {
        this.date = util_prevYear(this.date);
      }

      this.setValue(true);
    },
    nextYear: function nextYear() {
      if (this.currentView === 'year') {
        this.date = util_nextYear(this.date, 10);
      } else {
        this.date = util_nextYear(this.date);
      }

      this.setValue(true);
    },
    handleShortcutClick: function handleShortcutClick(shortcut) {
      if (shortcut.onClick) {
        shortcut.onClick(this);
      }

      this.closeModal();
    },
    handleTimePick: function handleTimePick(value, visible) {
      if (visible) {
        if (isDate(value)) {
          var newDate = !util_isEmpty(this.date) ? modifyTime(this.date, value.getHours(), value.getMinutes(), value.getSeconds()) : modifyTime(this.date, value.getHours(), value.getMinutes(), value.getSeconds());
          this.time = newDate;

          if (this.date) {
            this.emit(newDate, true, false);
          }
        } else {
          this.emit(value, true, false);
        }
      }
    },
    handleTimePickClose: function handleTimePickClose() {
      this.timePickerVisible = false;
    },
    handleYearPick: function handleYearPick(year) {
      if (this.selectionMode === 'year') {
        this.date = modifyDate(this.date, year, 0, 1);
        this.emit(this.date, this.visibleFooter);
      } else {
        this.date = setYear(this.date, year); // TODO: should emit intermediate value ??

        if (this.selectionMode === 'month') {
          this.currentView = 'month';
        } else {
          this.currentView = 'date';
        }

        this.emit(this.date, true);
      }

      this.setValue();
      this.closeModal();
    },
    handleMonthPick: function handleMonthPick(month) {
      if (this.selectionMode === 'month') {
        this.date = modifyDate(this.date, this.year, month, 1);
        this.emit(this.date, this.visibleFooter);
      } else {
        this.date = setMonth(this.date, month); // TODO: should emit intermediate value ??

        this.currentView = 'date';
        this.emit(this.date, true);
      }

      this.setValue();
      this.closeModal();
    },
    handleDatePick: function handleDatePick(value) {
      if (this.selectionMode === 'day') {
        var newDate = this.date ? modifyDate(this.date, value.getFullYear(), value.getMonth(), value.getDate()) : modifyWithTimeString(value, this.defaultTime); // change default time while out of selectableRange

        if (!this.checkDateWithinRange(newDate)) {
          newDate = modifyDate(this.selectableRange[0][0], value.getFullYear(), value.getMonth(), value.getDate());
        }

        if (util_isEmpty(this.time)) {
          this.time = this.getTime();
        }

        this.date = newDate;
        this.emit(this.date, this.visibleFooter);
      } else if (this.selectionMode === 'week') {
        this.emit(value.date, this.visibleFooter);
      } else if (this.selectionMode === 'dates') {
        this.emit(value, true); // set false to keep panel open
      }
    },
    changeToNow: function changeToNow() {
      var _this7 = this;

      // NOTE: not a permanent solution
      //       consider disable "now" button in the future
      if (!this.disabledNow) {
        var _now = new Date();

        this.date = _now;
        this.time = _now;

        if (this.type === 'week') {
          var week = this.date.getDay();
          var dayOffset = week + this.weekOffsetDay;
          this.date = prevDate(this.date, dayOffset);
        }

        if (this.timePickerVisible) {
          this.$nextTick(function () {
            return _this7.$refs.timepicker.adjustSpinners();
          });
        }

        this.emit(this.date, true, false);
      }
    },
    confirm: function confirm() {
      if (this.selectionMode === 'dates') {
        this.emit(this.value, false, true);
      } else {
        // value were emitted in handle{Date,Time}Pick, nothing to update here
        // deal with the scenario where: user opens the picker, then confirm without doing anything
        this.emit(this.getTime(), false, true);
      }
    },
    getSingleValue: function getSingleValue() {
      var value = this.value;

      if (Array.isArray(value)) {
        value = value[this.value.length - 1];
      }

      return value;
    },
    getTime: function getTime() {
      var value = this.getSingleValue();
      var newValue = value || this.getDefaultValue();

      if (this.time) {
        newValue = dateMergeTime(newValue, this.time);
      }

      if (this.selectionMode === 'week') {
        newValue = this.$refs.dateTable.weekDate;
      }

      return newValue;
    },
    getDate: function getDate() {
      if (this.type === 'datetime') {
        return this.getTime();
      } else {
        return clearTime(this.getTime());
      }
    },
    resetView: function resetView() {
      this.date = this.getDate();
      this.time = isDate(this.value) ? this.getTime() : null;
    },
    handleEnter: function handleEnter() {
      document.body.addEventListener('keydown', this.handleKeydown);
    },
    handleLeave: function handleLeave() {
      this.$emit('dodestroy');
      document.body.removeEventListener('keydown', this.handleKeydown);
    },
    handleKeydown: function handleKeydown(event) {
      if (this.selectionMode === 'dates') {
        return;
      }

      var keyCode = event.keyCode;
      var list = [38, 40, 37, 39];

      if (this.showTime && this.timePickerVisible) {
        this.$refs.timepicker.handleKeydown(event);
      }

      if (this.visible && !this.timePickerVisible) {
        if (list.indexOf(keyCode) !== -1) {
          this.handleKeyControl(keyCode);
          event.stopPropagation();
          event.preventDefault();
        }

        if (keyCode === 13 && this.userInputDate === null && this.userInputTime === null) {
          // Enter
          this.emit(this.date, false);
        }
      }
    },
    setSelectionRange: function setSelectionRange(start, end) {
      this.refInput.setSelectionRange(start, end);
      this.refInput.focus();
    },
    handleKeyControl: function handleKeyControl(keyCode) {
      var mapping = {
        year: {
          38: -4,
          40: 4,
          37: -1,
          39: 1,
          offset: function offset(date, step) {
            return setYear(date, date.getFullYear() + step);
          }
        },
        month: {
          38: -6,
          40: 6,
          37: -1,
          39: 1,
          offset: function offset(date, step) {
            return setMonth(date, date.getMonth() + step);
          }
        },
        week: {
          38: -1,
          40: 1,
          37: -1,
          39: 1,
          offset: function offset(date, step) {
            return setDate(date, date.getDate() + step * 7);
          }
        },
        day: {
          38: -7,
          40: 7,
          37: -1,
          39: 1,
          offset: function offset(date, step) {
            return setDate(date, date.getDate() + step);
          }
        }
      };
      var mode = this.selectionMode;
      var year = 3.1536e10;
      var now = this.date.getTime();
      var newDate = new Date(this.date.getTime());

      while (Math.abs(now - newDate.getTime()) <= year) {
        var map = mapping[mode];
        map.offset(newDate, map[keyCode]);

        if (this.disabledDate(newDate)) {
          continue;
        }

        this.date = newDate;
        this.emit(newDate, true);
        break;
      }
    },
    handleVisibleTimeBlur: function handleVisibleTimeBlur() {
      this.userInputTime = null;
    },
    handleVisibleTimeChange: function handleVisibleTimeChange(value) {
      var time = util_parseDate(value, this.timeFormat);

      if (time && this.checkDateWithinRange(time)) {
        this.time = modifyDate(time, this.year, this.month, this.monthDate);
        this.userInputTime = null;
        this.$refs.timepicker.value = this.time;
        this.emit(this.time, true, false);
      }
    },
    // handleVisibleDateChange(value) {
    //   const date = parseDate(value, this.dateFormat);
    //   if (date) {
    //     if (
    //       typeof this.disabledDate === 'function' &&
    //       this.disabledDate(date)
    //     ) {
    //       return;
    //     }
    //     this.date = modifyTime(
    //       date,
    //       this.date.getHours(),
    //       this.date.getMinutes(),
    //       this.date.getSeconds()
    //     );
    //     this.userInputDate = null;
    //     this.resetView();
    //     this.emit(this.date, true);
    //   }
    // },
    isValidValue: function isValidValue(value) {
      var _this8 = this;

      if (Array.isArray(value)) {
        return value.every(function (item) {
          return isDate(item) && !_this8.disabledDate(item);
        });
      } else {
        return isDate(value) && !this.disabledDate(value) && this.checkDateWithinRange(value);
      }
    },
    getDatesValue: function getDatesValue() {
      var value = this.value;

      if (Array.isArray(value)) {
        value = value[this.value.length - 1];
      }

      return value;
    },
    getDefaultValue: function getDefaultValue() {
      var nowDate = util_now();

      if (this.selectionMode === 'dates') {
        nowDate = this.getDatesValue() || nowDate;
      } // if default-value is set, return it
      // otherwise, return now (the moment this method gets called)


      return this.defaultValue ? modifyWithTimeString(clearTime(toDate(this.defaultValue)), this.defaultTime) : modifyWithTimeString(nowDate, this.defaultTime);
    },
    checkDateWithinRange: function checkDateWithinRange(date) {
      return this.selectableRange.length > 0 ? timeWithinRange(date, this.selectableRange, this.format || 'HH:mm:ss') : true;
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
 /* harmony default export */ var panel_datevue_type_script_lang_js_ = (datevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue





/* normalize component */

var date_component = normalizeComponent(
  panel_datevue_type_script_lang_js_,
  datevue_type_template_id_2aab2f3f_render,
  datevue_type_template_id_2aab2f3f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var panel_date = (date_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=7776d8c0&
var date_rangevue_type_template_id_7776d8c0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-bottom"},on:{"after-enter":_vm.handleEnter,"after-leave":_vm.handleLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-picker-panel el-date-range-picker el-popper",class:[
      {
        'has-sidebar': _vm.$slots.sidebar || _vm.shortcuts,
        'has-time': _vm.showTime
      },
      _vm.popperClass
    ]},[_c('div',{staticClass:"el-picker-panel__body-wrapper"},[_vm._t("sidebar"),(_vm.shortcuts)?_c('div',{staticClass:"el-picker-panel__sidebar"},_vm._l((_vm.shortcuts),function(shortcut,key){return _c('button',{key:key,staticClass:"el-picker-panel__shortcut",attrs:{"type":"button"},domProps:{"textContent":_vm._s(shortcut.text)},on:{"click":function($event){return _vm.handleShortcutClick(shortcut)}}})}),0):_vm._e(),_c('div',{staticClass:"el-picker-panel__body is-date-range"},[_c('div',{staticClass:"el-picker-panel__content el-date-range-picker__content is-left"},[_c('p',{staticClass:"el-date-range-picker__title",domProps:{"textContent":_vm._s(_vm.t('el.datepicker.startTime'))}}),_c('div',{ref:"leftPickerHeader",staticClass:"el-date-range-picker__header"},[_c('button',{staticClass:"el-picker-panel__icon-btn h-icon-angles_left_sm",attrs:{"type":"button"},on:{"click":_vm.leftPrevYear}}),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.leftCurrentView !== 'year'),expression:"leftCurrentView !== 'year'"}],staticClass:"el-picker-panel__icon-btn h-icon-angle_left_sm",attrs:{"type":"button"},on:{"click":_vm.leftPrevMonth}}),(_vm.isUnlinkRange)?_c('span',{staticClass:"el-picker-panel__header-label-wrapper",class:[("is-" + _vm.leftCurrentView), { 'is-en': _vm.isEn }]},[_c('span',{staticClass:"el-picker-panel__header-label",attrs:{"title":_vm.leftYearLabel,"role":"button"},domProps:{"textContent":_vm._s(_vm.leftYearLabel)},on:{"click":function($event){return _vm.showYearPicker('left')}}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
                  _vm.leftCurrentView === 'date' || _vm.leftCurrentView === 'month'
                ),expression:"\n                  leftCurrentView === 'date' || leftCurrentView === 'month'\n                "}],staticClass:"el-picker-panel__header-label",attrs:{"title":_vm.leftMonthLabel,"role":"button"},domProps:{"textContent":_vm._s(_vm.leftMonthLabel)},on:{"click":function($event){return _vm.showMonthPicker('left')}}})]):_c('span',{staticClass:"el-picker-panel__header-label",domProps:{"textContent":_vm._s(_vm.leftLabel)}}),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.leftCurrentView !== 'year'),expression:"leftCurrentView !== 'year'"}],staticClass:"el-picker-panel__icon-btn h-icon-angle_right_sm",class:{
                'is-disabled': !_vm.enableMonthArrow,
                'is-hide': !_vm.unlinkPanels && _vm.leftCurrentView === 'date'
              },attrs:{"disabled":!_vm.enableMonthArrow,"type":"button"},on:{"click":_vm.leftNextMonth}}),_c('button',{staticClass:"el-picker-panel__icon-btn h-icon-angles_right_sm",class:{
                'is-disabled': !_vm.enableMonthArrow,
                'is-hide': !_vm.unlinkPanels && _vm.leftCurrentView === 'date'
              },attrs:{"disabled":!_vm.enableMonthArrow,"type":"button"},on:{"click":_vm.leftNextYear}})]),_c('div',{staticClass:"el-picker-panel__content has-modal"},[_c('date-table',{attrs:{"date":_vm.leftDate,"unlink-range":_vm.isUnlinkRange,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate,"first-day-of-week":_vm.firstDayOfWeek,"selection-mode":"range","table-type":"min"},on:{"changerange":_vm.handleChangeRange,"pick":_vm.handleRangePick},scopedSlots:_vm._u([{key:!!(_vm.$slots.date || _vm.$scopedSlots.date) ? 'date' : null,fn:function(data){return [_vm._t("date",null,null,data)]}}],null,true)}),(_vm.leftCurrentView === 'year')?_c('year-table',{ref:"leftYearTable",attrs:{"date":_vm.leftDate,"value":_vm.minDate,"default-value":_vm.defaultValue ? _vm.getDefaultValue(_vm.defaultValue) : null,"disabled-date":_vm.disabledDate},on:{"pick":_vm.handleLeftYearPick},scopedSlots:_vm._u([{key:!!(_vm.$slots.year || _vm.$scopedSlots.year) ? 'year' : null,fn:function(data){return [_vm._t("year",null,null,data)]}}],null,true)}):_vm._e(),(_vm.leftCurrentView === 'month')?_c('month-table',{ref:"leftMonthTable",attrs:{"date":_vm.leftDate,"value":_vm.minDate,"disabled-date":_vm.disabledDate},on:{"pick":_vm.handleLeftMonthPick},scopedSlots:_vm._u([{key:!!(_vm.$slots.month || _vm.$scopedSlots.month) ? 'month' : null,fn:function(data){return [_vm._t("month",null,null,data)]}}],null,true)}):_vm._e()],1)]),_c('div',{staticClass:"el-picker-panel__content el-date-range-picker__content is-right"},[_c('p',{staticClass:"el-date-range-picker__title",domProps:{"textContent":_vm._s(_vm.t('el.datepicker.endTime'))}}),_c('div',{ref:"rightPickerHeader",staticClass:"el-date-range-picker__header"},[_c('button',{staticClass:"el-picker-panel__icon-btn h-icon-angles_left_sm",class:{
                'is-disabled': !_vm.enableMonthArrow,
                'is-hide': !_vm.unlinkPanels && _vm.rightCurrentView === 'date'
              },attrs:{"disabled":!_vm.enableMonthArrow,"type":"button"},on:{"click":_vm.rightPrevYear}}),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.rightCurrentView !== 'year'),expression:"rightCurrentView !== 'year'"}],staticClass:"el-picker-panel__icon-btn h-icon-angle_left_sm",class:{
                'is-disabled': !_vm.enableMonthArrow,
                'is-hide': !_vm.unlinkPanels && _vm.rightCurrentView === 'date'
              },attrs:{"disabled":!_vm.enableMonthArrow,"type":"button"},on:{"click":_vm.rightPrevMonth}}),(_vm.isUnlinkRange)?_c('span',{staticClass:"el-picker-panel__header-label-wrapper",class:[("is-" + _vm.rightCurrentView), { 'is-en': _vm.isEn }]},[_c('span',{staticClass:"el-picker-panel__header-label",attrs:{"title":_vm.rightYearLabel,"role":"button"},domProps:{"textContent":_vm._s(_vm.rightYearLabel)},on:{"click":function($event){return _vm.showYearPicker('right')}}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(
                  _vm.rightCurrentView === 'date' || _vm.rightCurrentView === 'month'
                ),expression:"\n                  rightCurrentView === 'date' || rightCurrentView === 'month'\n                "}],staticClass:"el-picker-panel__header-label",attrs:{"title":_vm.rightMonthLabel,"role":"button"},domProps:{"textContent":_vm._s(_vm.rightMonthLabel)},on:{"click":function($event){return _vm.showMonthPicker('right')}}})]):_c('span',{staticClass:"el-picker-panel__header-label",domProps:{"textContent":_vm._s(_vm.rightLabel)}}),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.rightCurrentView !== 'year'),expression:"rightCurrentView !== 'year'"}],staticClass:"el-picker-panel__icon-btn h-icon-angle_right_sm",attrs:{"type":"button"},on:{"click":_vm.rightNextMonth}}),_c('button',{staticClass:"el-picker-panel__icon-btn h-icon-angles_right_sm",attrs:{"type":"button"},on:{"click":_vm.rightNextYear}})]),_c('div',{staticClass:"el-picker-panel__content has-modal"},[_c('date-table',{attrs:{"date":_vm.rightDate,"unlink-range":_vm.isUnlinkRange,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate,"first-day-of-week":_vm.firstDayOfWeek,"selection-mode":"range","table-type":"max"},on:{"changerange":_vm.handleChangeRange,"pick":_vm.handleRangePick},scopedSlots:_vm._u([{key:!!(_vm.$slots.date || _vm.$scopedSlots.date) ? 'date' : null,fn:function(data){return [_vm._t("date",null,null,data)]}}],null,true)}),(_vm.rightCurrentView === 'year')?_c('year-table',{ref:"rightYearTable",attrs:{"date":_vm.rightDate,"value":_vm.maxDate,"default-value":_vm.defaultValue ? _vm.getDefaultValue(_vm.defaultValue) : null,"disabled-date":_vm.disabledDate},on:{"pick":_vm.handleRightYearPick},scopedSlots:_vm._u([{key:!!(_vm.$slots.year || _vm.$scopedSlots.year) ? 'year' : null,fn:function(data){return [_vm._t("year",null,null,data)]}}],null,true)}):_vm._e(),(_vm.rightCurrentView === 'month')?_c('month-table',{ref:"rightMonthTable",attrs:{"date":_vm.rightDate,"value":_vm.maxDate,"disabled-date":_vm.disabledDate},on:{"pick":_vm.handleRightMonthPick},scopedSlots:_vm._u([{key:!!(_vm.$slots.month || _vm.$scopedSlots.month) ? 'month' : null,fn:function(data){return [_vm._t("month",null,null,data)]}}],null,true)}):_vm._e()],1)]),(_vm.showTime)?_c('div',{staticClass:"el-date-range-picker__time-header"},[_c('span',{staticClass:"el-date-range-picker__editors-wrap is-left"},[_c('span',{staticClass:"el-date-range-picker__time-picker-wrap"},[_c('span',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:({
                  fn: _vm.handleMinTimeClose,
                  excludes: _vm.$refs.changeToNow ? [_vm.$refs.changeToNow.$el] : []
                }),expression:"{\n                  fn: handleMinTimeClose,\n                  excludes: $refs.changeToNow ? [$refs.changeToNow.$el] : []\n                }"}]},[_c('el-input',{ref:"minInput",staticClass:"el-date-range-picker__editor",attrs:{"disabled":_vm.rangeState.selecting,"placeholder":_vm.t('el.datepicker.startTime'),"value":_vm.minVisibleTime},on:{"focus":function($event){_vm.minTimePickerVisible = true},"blur":function($event){return _vm.handleVisibleTimeBlur('min')},"input":function (val) { return _vm.handleTimeInput(val, 'min'); },"change":function (val) { return _vm.handleTimeChange(val, 'min'); }}}),_c('time-picker',{ref:"minTimePicker",attrs:{"unlink-range":_vm.unlink,"unlink":false,"time-arrow-control":_vm.arrowControl,"visible":_vm.minTimePickerVisible,"time-type":"min"},on:{"pick":_vm.handleMinTimePick,"mounted":function($event){return _vm.proxyTimePickerDataProperties('min')},"select-range":_vm.setSelectionRange}})],1)])]),_c('span',{staticClass:"el-date-range-picker__editors-wrap is-right"},[_c('span',{staticClass:"el-date-range-picker__time-picker-wrap"},[_c('span',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:({
                  fn: _vm.handleMaxTimeClose,
                  excludes: _vm.$refs.changeToNow ? [_vm.$refs.changeToNow.$el] : []
                }),expression:"{\n                  fn: handleMaxTimeClose,\n                  excludes: $refs.changeToNow ? [$refs.changeToNow.$el] : []\n                }"}]},[_c('el-input',{ref:"maxInput",staticClass:"el-date-range-picker__editor",attrs:{"disabled":_vm.rangeState.selecting,"placeholder":_vm.t('el.datepicker.endTime'),"value":_vm.maxVisibleTime},on:{"focus":function($event){_vm.maxTimePickerVisible = true},"blur":function($event){return _vm.handleVisibleTimeBlur('max')},"input":function (val) { return _vm.handleTimeInput(val, 'max'); },"change":function (val) { return _vm.handleTimeChange(val, 'max'); }}}),_c('time-picker',{ref:"maxTimePicker",attrs:{"unlink-range":_vm.unlink,"unlink":false,"time-arrow-control":_vm.arrowControl,"visible":_vm.maxTimePickerVisible,"time-type":"max"},on:{"pick":_vm.handleMaxTimePick,"mounted":function($event){return _vm.proxyTimePickerDataProperties('max')},"select-range":_vm.setSelectionRange}})],1)])])]):_vm._e()])],2),(_vm.unlink || _vm.showTime)?_c('div',{staticClass:"el-picker-panel__footer"},[(!_vm.showPrompt || _vm.showAbnormalInfo)?_c('span',{staticClass:"el-picker-panel__footer-message is-warning",attrs:{"title":_vm.prompt},domProps:{"textContent":_vm._s(_vm.prompt)}}):(
          _vm.minVisibleDate !== '' &&
            _vm.minVisibleTime !== '' &&
            _vm.maxVisibleDate !== '' &&
            _vm.maxVisibleTime !== ''
        )?_c('span',{staticClass:"el-picker-panel__footer-message"},[_c('span',{domProps:{"textContent":_vm._s(_vm.minVisibleDate)}}),(_vm.showTime)?_c('span',{domProps:{"textContent":_vm._s(_vm.minVisibleTime)}}):_vm._e(),_c('span',{domProps:{"textContent":_vm._s(_vm.rangeSeparator)}}),_c('span',{domProps:{"textContent":_vm._s(_vm.maxVisibleDate)}}),(_vm.showTime)?_c('span',{domProps:{"textContent":_vm._s(_vm.maxVisibleTime)}}):_vm._e()]):_c('span',{staticClass:"el-picker-panel__footer-message"}),(!_vm.disabledNow)?_c('el-button',{ref:"changeToNow",staticClass:"el-picker-panel__link-btn el-picker-panel__now",domProps:{"textContent":_vm._s(_vm.t('el.datepicker.today'))},on:{"click":_vm.changeToNow}}):_vm._e(),_c('el-button',{staticClass:"el-picker-panel__link-btn",attrs:{"disabled":_vm.disabledConfirm,"type":"primary"},domProps:{"textContent":_vm._s(_vm.t('el.datepicker.confirm'))},on:{"click":function($event){return _vm.handleConfirm(false)}}})],1):_vm._e()])])}
var date_rangevue_type_template_id_7776d8c0_staticRenderFns = []


// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=7776d8c0&

// EXTERNAL MODULE: external "@babel/runtime/helpers/esm/arrayWithHoles"
var arrayWithHoles_ = __webpack_require__("94a6");
var arrayWithHoles_default = /*#__PURE__*/__webpack_require__.n(arrayWithHoles_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/esm/iterableToArrayLimit"
var iterableToArrayLimit_ = __webpack_require__("84a7");
var iterableToArrayLimit_default = /*#__PURE__*/__webpack_require__.n(iterableToArrayLimit_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/esm/nonIterableRest"
var nonIterableRest_ = __webpack_require__("b684");
var nonIterableRest_default = /*#__PURE__*/__webpack_require__.n(nonIterableRest_);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return arrayWithHoles_default()(arr) || iterableToArrayLimit_default()(arr, i) || unsupportedIterableToArray_default()(arr, i) || nonIterableRest_default()();
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var date_rangevue_type_script_lang_js_calcDefaultValue = function calcDefaultValue(defaultValue) {
  if (Array.isArray(defaultValue)) {
    return [toDate(defaultValue[0]), toDate(defaultValue[1])];
  } else if (defaultValue) {
    return [toDate(defaultValue), nextDate(toDate(defaultValue), 1)];
  } else {
    return [util_now(), nextDate(util_now(), 1)];
  }
};

/* harmony default export */ var date_rangevue_type_script_lang_js_ = ({
  directives: {
    Clickoutside: clickoutside
  },
  components: {
    TimePicker: panel_time,
    DateTable: date_table,
    ElInput: packages_input,
    ElButton: packages_button,
    YearTable: year_table,
    MonthTable: month_table
  },
  mixins: [locale, mixins_range],
  data: function data() {
    return {
      closeOnClickModal: true,
      popperClass: '',
      value: [],
      defaultValue: null,
      defaultTime: null,
      minDate: util_now(),
      maxDate: util_now(),
      leftDate: util_now(),
      rightDate: util_now(),
      rangeState: {
        endDate: null,
        selecting: false,
        row: null,
        column: null
      },
      showTime: false,
      shortcuts: '',
      visible: '',
      disabledDate: function disabledDate() {
        return false;
      },
      firstDayOfWeek: 1,
      minTimePickerVisible: false,
      maxTimePickerVisible: false,
      format: '',
      arrowControl: false,
      unlinkPanels: false,
      unlink: true,
      unlinkRange: true,
      dateUserInput: {
        min: null,
        max: null
      },
      timeUserInput: {
        min: null,
        max: null
      },
      rangeSeparator: '-',
      startPlaceholder: '',
      endPlaceholder: '',
      leftCurrentView: 'date',
      rightCurrentView: 'date',
      leftFirstVisibleTime: true,
      rightFirstVisibleTime: true,
      selectableRange: []
    };
  },
  computed: {
    isEn: function isEn() {
      var reg = /^[a-zA-Z]+$/;
      return reg.test(this.leftMonthLabel) || reg.test(this.rightMonthLabel);
    },
    now: function now() {
      return util_now();
    },
    calcMinDate: function calcMinDate() {
      var minDate = this.minDate || date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
      return toDate(minDate);
    },
    calcMaxDate: function calcMaxDate() {
      var maxDate = this.maxDate || date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[1];
      return toDate(maxDate);
    },
    disabledNow: function disabledNow() {
      var start = dateMergeTime(this.now, MIN_TIME);
      var end = dateMergeTime(this.now, MAX_TIME);
      return this.disabledDate(start) || this.disabledDate(end);
    },
    leftLabel: function leftLabel() {
      return this.leftDate.getFullYear() + this.t('el.datepicker.year') + ' ' + this.t("el.datepicker.month".concat(this.leftDate.getMonth() + 1));
    },
    rightLabel: function rightLabel() {
      return this.rightDate.getFullYear() + this.t('el.datepicker.year') + ' ' + this.t("el.datepicker.month".concat(this.rightDate.getMonth() + 1));
    },
    leftYearLabel: function leftYearLabel() {
      var yearTranslation = this.t('el.datepicker.year');

      if (this.leftCurrentView === 'year') {
        var startYear = Math.floor(this.leftDate.getFullYear() / 10) * 10;

        if (yearTranslation) {
          return startYear + yearTranslation + ' - ' + (startYear + 9) + yearTranslation;
        }

        return startYear + ' - ' + (startYear + 9);
      }

      return (this.leftCurrentView === 'year' ? this.calcMinDate.getFullYear() : this.leftYearVal) + yearTranslation;
    },
    leftMonthLabel: function leftMonthLabel() {
      return this.t("el.datepicker.month".concat(this.leftDate.getMonth() + 1));
    },
    rightYearLabel: function rightYearLabel() {
      var yearTranslation = this.t('el.datepicker.year');

      if (this.rightCurrentView === 'year') {
        var startYear = Math.floor(this.rightDate.getFullYear() / 10) * 10;

        if (yearTranslation) {
          return startYear + ' ' + yearTranslation + ' - ' + (startYear + 9) + yearTranslation;
        }

        return startYear + ' - ' + (startYear + 9);
      }

      return (this.rightCurrentView === 'year' ? this.calcMaxDate.getFullYear() : this.rightYearVal) + yearTranslation;
    },
    rightMonthLabel: function rightMonthLabel() {
      return this.t("el.datepicker.month".concat(this.rightDate.getMonth() + 1));
    },
    leftYearVal: function leftYearVal() {
      return this.leftDate.getFullYear();
    },
    leftMonthVal: function leftMonthVal() {
      return this.leftDate.getMonth();
    },
    leftDateVal: function leftDateVal() {
      return this.leftDate.getDate();
    },
    rightYearVal: function rightYearVal() {
      return this.rightDate.getFullYear();
    },
    rightMonthVal: function rightMonthVal() {
      return this.rightDate.getMonth();
    },
    rightDateVal: function rightDateVal() {
      return this.rightDate.getDate();
    },
    minVisibleDate: function minVisibleDate() {
      if (this.dateUserInput.min !== null) {
        return this.dateUserInput.min;
      }

      if (this.minDate) {
        return util_formatDate(this.minDate, this.dateFormat);
      }

      return '';
    },
    maxVisibleDate: function maxVisibleDate() {
      if (this.dateUserInput.max !== null) {
        return this.dateUserInput.max;
      }

      if (this.maxDate) {
        return util_formatDate(this.maxDate || this.minDate, this.dateFormat);
      }

      return '';
    },
    minVisibleTime: function minVisibleTime() {
      if (this.timeUserInput.min !== null) {
        return this.timeUserInput.min;
      } else if (util_isEmpty(this.minDate) && this.leftFirstVisibleTime && !this.defaultTime) {
        return '';
      } else if (this.leftDate) {
        return util_formatDate(this.leftDate, this.timeFormat);
      }

      return '';
    },
    maxVisibleTime: function maxVisibleTime() {
      if (this.timeUserInput.max !== null) {
        return this.timeUserInput.max;
      } else if (util_isEmpty(this.maxDate) && this.rightFirstVisibleTime && !this.defaultTime) {
        return '';
      } else if (this.rightDate) {
        return util_formatDate(this.rightDate, this.timeFormat);
      }

      return '';
    },
    timeFormat: function timeFormat() {
      if (this.format) {
        return extractTimeFormat(this.format);
      } else {
        return 'HH:mm:ss';
      }
    },
    dateFormat: function dateFormat() {
      if (this.format) {
        return extractDateFormat(this.format);
      } else {
        return 'yyyy/MM/dd';
      }
    },
    enableMonthArrow: function enableMonthArrow() {
      if (!this.unlink) {
        var _nextMonth = (this.leftMonthVal + (this.unlink ? 0 : 1)) % 12;

        var yearOffset = this.leftMonthVal + (this.unlink ? 0 : 1) >= 12 ? 1 : 0;
        return this.isUnlinkRange && toDate(this.leftYearVal + yearOffset, _nextMonth) < toDate(this.rightYearVal, this.rightMonthVal);
      } else {
        return true;
      }
    },
    enableYearArrow: function enableYearArrow() {
      return this.isUnlinkRange && this.rightYearVal * 12 + this.rightMonthVal - (this.leftYearVal * 12 + this.leftMonthVal + (this.unlink ? 0 : 1)) >= 12 || this.leftCurrentView === 'year';
    },
    showAbnormalInfo: function showAbnormalInfo() {
      if (this.isUnlinkRange && this.minDate && this.maxDate) {
        if (this.showTime) {
          return clearMilliseconds(this.minDate).getTime() > clearMilliseconds(this.maxDate).getTime();
        } else {
          return clearTime(this.minDate).getTime() > clearTime(this.maxDate).getTime();
        }
      }

      return false;
    },
    minRefInput: function minRefInput() {
      if (this.$refs.minInput.$el) {
        return [].slice.call(this.$refs.minInput.$el.querySelectorAll('input'))[0];
      }

      return [];
    },
    maxRefInput: function maxRefInput() {
      if (this.$refs.maxInput.$el) {
        return [].slice.call(this.$refs.maxInput.$el.querySelectorAll('input'))[0];
      }

      return [];
    },
    minTimeEmpty: function minTimeEmpty() {
      if (!this.isUnlinkRange) {
        return false;
      }

      return isEmptyDate(this.value) && isEmptyDate(this.defaultTime);
    },
    maxTimeEmpty: function maxTimeEmpty() {
      if (!this.isUnlinkRange) {
        return false;
      }

      return isEmptyDate(this.value) && isEmptyDate(this.defaultTime);
    },
    emitDate: function emitDate() {
      return [this.leftDate, this.rightDate];
    }
  },
  watch: {
    visible: function visible(val) {
      if (!val) {
        this.closeModal();
      }
    },
    minDate: function minDate(val) {
      this.dateUserInput.min = null;
      this.timeUserInput.min = null;

      if (isDate(val) && this.$refs.minTimePicker) {
        this.$refs.minTimePicker.date = val;
        this.$refs.minTimePicker.value = val;
      }
    },
    maxDate: function maxDate(val) {
      this.dateUserInput.max = null;
      this.timeUserInput.max = null;

      if (isDate(val) && this.$refs.maxTimePicker) {
        this.$refs.maxTimePicker.date = val;
        this.$refs.maxTimePicker.value = val;
      }
    },
    minTimePickerVisible: function minTimePickerVisible(val) {
      var _this = this;

      if (val) {
        this.$refs.minTimePicker.date = this.minDate || this.leftDate;
        this.$refs.minTimePicker.value = this.minDate || this.leftDate;
        this.$nextTick(function () {
          _this.$refs.minTimePicker.adjustSpinners();

          _this.openModal(_this._popupLeftId, _this.$refs.leftPickerHeader, 'is-time');
        });
      } else {
        popup_manager.closeModal(this._popupLeftId);
      }
    },
    maxTimePickerVisible: function maxTimePickerVisible(val) {
      var _this2 = this;

      if (val) {
        this.$refs.maxTimePicker.date = this.maxDate || this.rightDate;
        this.$refs.maxTimePicker.value = this.maxDate || this.rightDate;
        this.$nextTick(function () {
          _this2.$refs.maxTimePicker.adjustSpinners();

          _this2.openModal(_this2._popupRightId, _this2.$refs.rightPickerHeader, 'is-time');
        });
      } else {
        popup_manager.closeModal(this._popupRightId);
      }
    },
    value: function value(newVal) {
      if (!newVal) {
        this.minDate = this.now;
        this.maxDate = this.now;
      } else if (Array.isArray(newVal)) {
        this.minDate = toDate(newVal[0]);
        this.maxDate = toDate(newVal[1]);
      }

      this.leftDate = this.calcMinDate;
      this.rightDate = this.getDefaultRightDate(this.calcMaxDate);
    },
    defaultValue: function defaultValue(val) {
      if (!Array.isArray(this.value)) {
        var _calcDefaultValue = date_rangevue_type_script_lang_js_calcDefaultValue(val),
            _calcDefaultValue2 = _slicedToArray(_calcDefaultValue, 2),
            leftDate = _calcDefaultValue2[0],
            rightDate = _calcDefaultValue2[1];

        this.leftDate = leftDate;
        this.rightDate = this.getDefaultRightDate(rightDate);
      }
    }
  },
  beforeMount: function beforeMount() {
    this._popupLeftId = "popup-date-range-left-".concat(this._uid);
    this._popupRightId = "popup-date-range-right-".concat(this._uid);
    popup_manager.register(this._popupLeftId, this);
    popup_manager.register(this._popupRightId, this);
  },
  beforeDestroy: function beforeDestroy() {
    popup_manager.deregister(this._popupLeftId, this);
    popup_manager.deregister(this._popupRightId, this);
    this.closeModal();
  },
  methods: {
    getDefaultValue: function getDefaultValue(val) {
      return date_rangevue_type_script_lang_js_calcDefaultValue(val);
    },
    proxyTimePickerDataProperties: function proxyTimePickerDataProperties(type) {
      var _this3 = this;

      var ref = type === 'min' ? 'minTimePicker' : 'maxTimePicker';

      var format = function format(timeFormat) {
        _this3.$refs[ref].format = timeFormat;
      };

      var selectableRange = function selectableRange(_selectableRange) {
        _this3.$refs[ref].selectableRange = _selectableRange;
      };

      this.$watch('timeFormat', format);
      this.$watch('selectableRange', selectableRange);
      format(this.timeFormat);
      selectableRange(this.selectableRange);
    },
    getDefaultRightDate: function getDefaultRightDate(val) {
      var minDateYear = this.calcMinDate.getFullYear();
      var minDateMonth = this.calcMinDate.getMonth();
      var maxDateYear = this.calcMaxDate.getFullYear();
      var maxDateMonth = this.calcMaxDate.getMonth();
      var toNext = minDateYear === maxDateYear && minDateMonth === maxDateMonth;

      if (!this.isUnlinkRange && toNext) {
        return util_nextMonth(val);
      } else {
        return val;
      }
    },
    handleLeftYearPick: function handleLeftYearPick(year) {
      this.leftDate = setYear(this.leftDate, year);
      this.leftCurrentView = 'date';
      this.setLeftValue();
      this.emit(this.emitDate, true);
      popup_manager.closeModal(this._popupLeftId);
    },
    handleLeftMonthPick: function handleLeftMonthPick(month) {
      this.leftDate = setYear(this.leftDate, this.leftDate.getFullYear());
      this.leftDate = setMonth(this.leftDate, month);
      this.leftCurrentView = 'date';
      this.setLeftValue();
      this.emit(this.emitDate, true);
      popup_manager.closeModal(this._popupLeftId);
    },
    handleRightYearPick: function handleRightYearPick(year) {
      this.rightDate = setYear(this.rightDate, year);
      this.rightCurrentView = 'date';
      this.setRightValue();
      this.emit(this.emitDate, true);
      popup_manager.closeModal(this._popupRightId);
    },
    handleRightMonthPick: function handleRightMonthPick(month) {
      this.rightDate = setYear(this.rightDate, this.rightDate.getFullYear());
      this.rightDate = setMonth(this.rightDate, month);
      this.rightCurrentView = 'date';
      this.setRightValue();
      this.emit(this.emitDate, true);
      popup_manager.closeModal(this._popupRightId);
    },
    openModal: function openModal(id, dom, cls) {
      popup_manager.openModal({
        id: id,
        zIndex: 10,
        dom: dom,
        modalClass: cls,
        modalFade: true,
        multiModal: true
      });
    },
    closeLeftModal: function closeLeftModal() {
      popup_manager.closeModal(this._popupLeftId);
      this.leftCurrentView = 'date';
    },
    closeRightModal: function closeRightModal() {
      popup_manager.closeModal(this._popupRightId);
      this.rightCurrentView = 'date';
    },
    closeModal: function closeModal() {
      this.closeLeftModal();
      this.closeRightModal();
    },
    close: function close(id) {
      if (id.indexOf('popup-date-range-left') !== -1) {
        this.leftCurrentView = 'date';
      } else {
        this.rightCurrentView = 'date';
      }

      popup_manager.closeModal(id);
    },
    showYearPicker: function showYearPicker(pos) {
      var _this4 = this;

      if (pos === 'left') {
        this.closeRightModal();
        this.leftCurrentView = 'year';
        this.$nextTick(function () {
          _this4.openModal(_this4._popupLeftId, _this4.$refs.leftYearTable.$el, 'is-year');
        });
      } else {
        this.closeLeftModal();
        this.rightCurrentView = 'year';
        this.$nextTick(function () {
          _this4.openModal(_this4._popupRightId, _this4.$refs.rightYearTable.$el, 'is-year');
        });
      }
    },
    showMonthPicker: function showMonthPicker(pos) {
      var _this5 = this;

      if (pos === 'left') {
        this.closeRightModal();
        this.leftCurrentView = 'month';
        this.$nextTick(function () {
          _this5.openModal(_this5._popupLeftId, _this5.$refs.leftMonthTable.$el, 'is-month');
        });
      } else {
        this.closeLeftModal();
        this.rightCurrentView = 'month';
        this.$nextTick(function () {
          _this5.openModal(_this5._popupRightId, _this5.$refs.rightMonthTable.$el, 'is-month');
        });
      }
    },
    changeToNow: function changeToNow() {
      this.closeModal();
      var start = dateMergeTime(this.now, MIN_TIME);
      var end = dateMergeTime(this.now, MAX_TIME);
      this.minDate = start;
      this.leftDate = start;
      this.maxDate = end;
      this.rightDate = end;
      this.handleMinTimeClose();
      this.handleMaxTimeClose();
      this.emit([start, end], true);
    },
    // HUI reserved
    handleClear: function handleClear() {
      this.minDate = null;
      this.maxDate = null;
      this.leftDate = this.calcMinDate;
      this.rightDate = this.getDefaultRightDate(this.calcMaxDate);
      this.emit(null);
    },
    handleChangeRange: function handleChangeRange(val) {
      this.minDate = val.minDate;
      this.maxDate = val.maxDate;
      this.rangeState = val.rangeState;
    },

    /**
     * 预留手动输入日期逻辑
     */
    // handleDateInput(value, type) {
    //   this.dateUserInput[type] = value;
    //   const parsedValue = parseDate(value, this.dateFormat);
    //   if (parsedValue) {
    //     if (
    //       typeof this.disabledDate === 'function' &&
    //       this.disabledDate(toDate(parsedValue))
    //     ) {
    //       return;
    //     }
    //     if (type === 'min') {
    //       this.minDate = modifyDate(
    //         this.minDate || toDate(),
    //         parsedValue.getFullYear(),
    //         parsedValue.getMonth(),
    //         parsedValue.getDate()
    //       );
    //       this.leftDate = toDate(parsedValue);
    //       if (!this.isUnlinkRange) {
    //         this.rightDate = this.unlink
    //           ? this.leftDate
    //           : nextMonth(this.leftDate);
    //       }
    //     } else {
    //       this.maxDate = modifyDate(
    //         this.maxDate || toDate(),
    //         parsedValue.getFullYear(),
    //         parsedValue.getMonth(),
    //         parsedValue.getDate()
    //       );
    //       this.rightDate = toDate(parsedValue);
    //       if (!this.isUnlinkRange) {
    //         this.leftDate = prevMonth(parsedValue);
    //       }
    //     }
    //   }
    // },
    // handleDateChange(value, type) {
    //   const parsedValue = parseDate(value, this.dateFormat);
    //   if (parsedValue) {
    //     if (type === 'min') {
    //       this.minDate = modifyDate(
    //         this.minDate,
    //         parsedValue.getFullYear(),
    //         parsedValue.getMonth(),
    //         parsedValue.getDate()
    //       );
    //       if (this.minDate > this.maxDate) {
    //         this.maxDate = this.minDate;
    //       }
    //     } else {
    //       this.maxDate = modifyDate(
    //         this.maxDate,
    //         parsedValue.getFullYear(),
    //         parsedValue.getMonth(),
    //         parsedValue.getDate()
    //       );
    //       if (this.maxDate < this.minDate) {
    //         this.minDate = this.maxDate;
    //       }
    //     }
    //   }
    // },
    handleTimeInput: function handleTimeInput(value, type) {
      var _this6 = this;

      var parsedValue = util_parseDate(value, this.timeFormat);

      if (parsedValue) {
        this.timeUserInput[type] = value;

        if (type === 'min') {
          this.minDate = toDate(this.minDate);
          this.minDate = modifyTime(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
          this.$nextTick(function () {
            return _this6.$refs.minTimePicker.adjustSpinners();
          });
        } else {
          this.maxDate = toDate(this.maxDate);
          this.maxDate = modifyTime(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
          this.$nextTick(function () {
            return _this6.$refs.maxTimePicker.adjustSpinners();
          });
        }
      }
    },
    handleTimeChange: function handleTimeChange(value, type) {
      var parsedValue = util_parseDate(value, this.timeFormat);

      if (parsedValue) {
        if (type === 'min') {
          this.minDate = toDate(this.minDate);
          this.minDate = modifyTime(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());

          if (!this.isUnlinkRange && this.minDate > this.maxDate) {
            this.maxDate = this.minDate;
          }

          this.$refs.minTimePicker.value = this.minDate;
          this.leftDate = this.minDate;
        } else {
          this.maxDate = toDate(this.maxDate);
          this.maxDate = modifyTime(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());

          if (!this.isUnlinkRange && this.maxDate < this.minDate) {
            this.minDate = this.maxDate;
          }

          this.$refs.maxTimePicker.value = this.maxDate;
          this.rightDate = this.maxDate;
        }
      }
    },
    handleVisibleTimeBlur: function handleVisibleTimeBlur(type) {
      this.timeUserInput[type] = null;
    },
    handleRangePick: function handleRangePick(val, _ref) {
      var type = _ref.type,
          cell = _ref.cell;
      this.closeModal();
      var defaultTime = this.defaultTime || [];
      this.onPick && this.onPick(val);
      var minDate = modifyWithTimeString(val.minDate, defaultTime[0]);
      var maxDate = modifyWithTimeString(val.maxDate, defaultTime[1]);
      var leftDate = minDate ? modifyDate(this.leftDate, minDate.getFullYear(), minDate.getMonth(), minDate.getDate()) : this.leftDate;
      var rightDate = maxDate ? modifyDate(this.rightDate, maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate()) : this.rightDate;

      if (this.isUnlinkRange) {
        this.leftDate = leftDate;
        this.rightDate = rightDate;

        if (type === 'min') {
          if (!this.minTimeEmpty) {
            minDate = dateMergeTime(setDate(leftDate, minDate.getDate()), leftDate);
          } else {
            minDate = setDate(leftDate, minDate.getDate());
          }

          this.minDate = minDate;
        } else {
          if (!this.maxTimeEmpty) {
            maxDate = dateMergeTime(setDate(rightDate, maxDate.getDate()), rightDate);
          } else {
            maxDate = setDate(rightDate, maxDate.getDate());
          }

          this.maxDate = maxDate;
        }
      } else {
        if (this.maxDate === maxDate && this.minDate === minDate) {
          return;
        }

        this.minDate = minDate;
        this.maxDate = maxDate;
      }

      if (!this.isUnlinkRange && this.showTime) {
        return;
      }

      this.handleConfirm(!!this.unlink);
    },
    handleShortcutClick: function handleShortcutClick(shortcut) {
      if (shortcut.onClick) {
        shortcut.onClick(this);
      }
    },
    handleMinTimeClose: function handleMinTimeClose() {
      this.minTimePickerVisible = false;
    },
    handleMinTimePick: function handleMinTimePick(value, visible, first) {
      this.leftFirstVisibleTime = false;
      var leftDate = this.minDate || this.leftDate;

      if (value) {
        var newVal = modifyTime(leftDate, value.getHours(), value.getMinutes(), value.getSeconds());

        if (this.minDate) {
          this.minDate = newVal;
        }

        this.leftDate = newVal;
      }

      if (!first) {
        this.minTimePickerVisible = visible;
      }

      if (!this.isUnlinkRange) {
        if (!this.maxDate || this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
          this.maxDate = toDate(this.minDate);
        }
      }

      this.emit(this.emitDate, true);
    },
    handleMaxTimePick: function handleMaxTimePick(value, visible, first) {
      this.rightFirstVisibleTime = false;
      var rightDate = this.maxDate || this.rightDate;

      if (value) {
        var newVal = modifyTime(rightDate, value.getHours(), value.getMinutes(), value.getSeconds());

        if (this.maxDate) {
          this.maxDate = newVal;
        }

        this.rightDate = newVal;
      }

      if (!first) {
        this.maxTimePickerVisible = visible;
      }

      if (!this.isUnlinkRange) {
        if (this.maxDate && this.minDate && this.minDate.getTime() > this.maxDate.getTime()) {
          this.minDate = toDate(this.maxDate);
        }
      }

      this.emit(this.emitDate, true);
    },
    handleMaxTimeClose: function handleMaxTimeClose() {
      this.maxTimePickerVisible = false;
    },
    // leftPrev*, rightNext* need to take care of `unlinkPanels`
    setLeftValue: function setLeftValue() {
      if (this.minDate) {
        this.minDate = this.leftDate;
      }
    },
    setRightValue: function setRightValue() {
      if (this.maxDate) {
        this.maxDate = this.rightDate;
      }
    },
    leftPrevYear: function leftPrevYear() {
      if (this.leftCurrentView === 'year') {
        this.leftDate = util_prevYear(this.leftDate, 10);
      } else {
        this.leftDate = util_prevYear(this.leftDate);

        if (!this.isUnlinkRange) {
          this.rightDate = util_nextMonth(this.leftDate);
        }
      }

      this.setLeftValue();
      this.emit(this.emitDate, true);
    },
    leftPrevMonth: function leftPrevMonth() {
      this.leftDate = util_prevMonth(this.leftDate);

      if (!this.isUnlinkRange) {
        this.rightDate = util_nextMonth(this.leftDate);
      }

      this.setLeftValue();
      this.emit(this.emitDate, true);
    },
    // leftNext*, rightPrev* are called when `unlinkPanels` is true
    leftNextYear: function leftNextYear() {
      if (this.leftCurrentView === 'year') {
        this.leftDate = util_nextYear(this.leftDate, 10);
      } else {
        this.leftDate = util_nextYear(this.leftDate);
      }

      this.setLeftValue();
      this.emit(this.emitDate, true);
    },
    leftNextMonth: function leftNextMonth() {
      this.leftDate = util_nextMonth(this.leftDate);
      this.setLeftValue();
      this.emit(this.emitDate, true);
    },
    rightNextYear: function rightNextYear() {
      if (this.rightCurrentView === 'year') {
        this.rightDate = util_nextYear(this.rightDate, 10);
      } else {
        if (!this.isUnlinkRange) {
          this.leftDate = util_nextYear(this.leftDate);
          this.rightDate = util_nextMonth(this.leftDate);
        } else {
          this.rightDate = util_nextYear(this.rightDate);
        }
      }

      this.setRightValue();
      this.emit(this.emitDate, true);
    },
    rightNextMonth: function rightNextMonth() {
      if (!this.isUnlinkRange) {
        this.leftDate = util_nextMonth(this.leftDate);
        this.rightDate = util_nextMonth(this.leftDate);
      } else {
        this.rightDate = util_nextMonth(this.rightDate);
      }

      this.setRightValue();
      this.emit(this.emitDate, true);
    },
    rightPrevYear: function rightPrevYear() {
      if (this.rightCurrentView === 'year') {
        this.rightDate = util_prevYear(this.rightDate, 10);
      } else {
        this.rightDate = util_prevYear(this.rightDate);
      }

      this.setRightValue();
      this.emit(this.emitDate, true);
    },
    rightPrevMonth: function rightPrevMonth() {
      this.rightDate = util_prevMonth(this.rightDate);
      this.setRightValue();
      this.emit(this.emitDate, true);
    },
    handleConfirm: function handleConfirm() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var date = [this.minDate, this.maxDate];

      if (this.isValidValue(date)) {
        this.$emit('pick', date, visible);
      }
    },
    emit: function emit(value) {
      if (!isEmptyDate(this.value)) {
        if (isEmptyDate(value)) {
          this.$emit('pick', null);
        } else {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          this.$emit.apply(this, ['pick', value].concat(args));
        }
      }
    },
    isValidValue: function isValidValue(value) {
      return Array.isArray(value) && value && value[0] && value[1] && isDate(value[0]) && isDate(value[1]) && (this.showTime ? clearMilliseconds(value[0]).getTime() <= clearMilliseconds(value[1]).getTime() : clearTime(value[0]).getTime() <= clearTime(value[1]).getTime()) && !this.disabledDate(value[0]) && !this.disabledDate(value[1]);
    },
    resetView: function resetView() {
      var _this7 = this;

      this.leftFirstVisibleTime = true;
      this.rightFirstVisibleTime = true;

      if (this.minDate && this.maxDate === null) {
        this.rangeState.selecting = false;
      }

      this.$nextTick(function () {
        if (isEmptyDate(_this7.value)) {
          _this7.minDate = null;
          _this7.maxDate = null;
          var defaultValue = _this7.defaultValue;
          var defaultTime = _this7.defaultTime;

          if (defaultValue) {
            var _calcDefaultValue3 = date_rangevue_type_script_lang_js_calcDefaultValue(defaultValue),
                _calcDefaultValue4 = _slicedToArray(_calcDefaultValue3, 2),
                leftDate = _calcDefaultValue4[0],
                rightDate = _calcDefaultValue4[1];

            _this7.minDate = leftDate;
            _this7.maxDate = rightDate;
            _this7.leftDate = leftDate;
            _this7.rightDate = rightDate;
          }

          _this7.leftDate = _this7.calcMinDate;
          _this7.rightDate = _this7.getDefaultRightDate(_this7.calcMaxDate);

          if (defaultTime) {
            _this7.leftDate = modifyWithTimeString(_this7.leftDate, defaultTime[0]);
            _this7.rightDate = modifyWithTimeString(_this7.rightDate, defaultTime[1]);
          }
        } else {
          _this7.minDate = toDate(_this7.value[0]);
          _this7.maxDate = toDate(_this7.value[1]);
          _this7.leftDate = _this7.calcMinDate;
          _this7.rightDate = _this7.getDefaultRightDate(_this7.calcMaxDate);
        }
      });
    },
    handleEnter: function handleEnter() {
      document.body.addEventListener('keydown', this.handleKeydown);
    },
    handleLeave: function handleLeave() {
      this.$emit('dodestroy');
      document.body.removeEventListener('keydown', this.handleKeydown);
    },
    handleKeydown: function handleKeydown(event) {
      if (this.showTime) {
        if (this.minTimePickerVisible) {
          this.$refs.minTimePicker.handleKeydown(event);
        }

        if (this.maxTimePickerVisible) {
          this.$refs.maxTimePicker.handleKeydown(event);
        }
      }
    },
    setSelectionRange: function setSelectionRange(start, end, pos) {
      if (pos === 'min') {
        this.minRefInput.setSelectionRange(start, end);
        this.minRefInput.focus();
      } else {
        this.maxRefInput.setSelectionRange(start, end);
        this.maxRefInput.focus();
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
 /* harmony default export */ var panel_date_rangevue_type_script_lang_js_ = (date_rangevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue





/* normalize component */

var date_range_component = normalizeComponent(
  panel_date_rangevue_type_script_lang_js_,
  date_rangevue_type_template_id_7776d8c0_render,
  date_rangevue_type_template_id_7776d8c0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var date_range = (date_range_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=5cbdcb1c&
var month_rangevue_type_template_id_5cbdcb1c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"after-leave":function($event){return _vm.$emit('dodestroy')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-picker-panel el-date-range-picker el-popper",class:[
      {
        'has-sidebar': _vm.$slots.sidebar || _vm.shortcuts
      },
      _vm.popperClass
    ]},[_c('div',{staticClass:"el-picker-panel__body-wrapper"},[_vm._t("sidebar"),(_vm.shortcuts)?_c('div',{staticClass:"el-picker-panel__sidebar"},_vm._l((_vm.shortcuts),function(shortcut,key){return _c('button',{key:key,staticClass:"el-picker-panel__shortcut",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleShortcutClick(shortcut)}}},[_vm._v(" "+_vm._s(shortcut.text)+" ")])}),0):_vm._e(),_c('div',{staticClass:"el-picker-panel__body is-month-range"},[_c('div',{staticClass:"el-picker-panel__content el-date-range-picker__content is-left"},[_c('p',{staticClass:"el-date-range-picker__title",domProps:{"textContent":_vm._s(_vm.t('el.datepicker.startTime'))}}),_c('div',{staticClass:"el-date-range-picker__header"},[_c('button',{staticClass:"el-picker-panel__icon-btn h-icon-angles_left_sm",attrs:{"type":"button"},on:{"click":_vm.leftPrevYear}}),_c('span',{staticClass:"el-picker-panel__header-label-wrapper",class:[("is-" + _vm.leftCurrentView)]},[_c('span',{staticClass:"el-picker-panel__header-label",domProps:{"textContent":_vm._s(_vm.leftLabel)},on:{"click":function($event){return _vm.showYearPicker('left')}}})]),(_vm.unlinkPanels)?_c('button',{staticClass:"el-picker-panel__icon-btn h-icon-angles_right_sm",class:{ 'is-disabled': !_vm.enableYearArrow },attrs:{"disabled":!_vm.enableYearArrow,"type":"button"},on:{"click":_vm.leftNextYear}}):_vm._e()]),(_vm.leftCurrentView === 'month')?_c('month-table',{attrs:{"date":_vm.leftDate,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"value":_vm.minDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate,"unlink-range":_vm.isUnlinkRange,"selection-mode":"range","table-type":"min"},on:{"changerange":_vm.handleChangeRange,"pick":_vm.handleRangePick}}):_vm._e(),_c('div',{staticClass:"el-picker-panel__content has-modal"},[(_vm.leftCurrentView === 'year')?_c('year-table',{ref:"leftYearTable",attrs:{"date":_vm.leftDate,"value":_vm.minDate,"default-value":_vm.defaultValue ? new Date(_vm.defaultValue) : null,"disabled-date":_vm.disabledDate},on:{"pick":_vm.handleLeftYearPick}}):_vm._e()],1)],1),_c('div',{staticClass:"el-picker-panel__content el-date-range-picker__content is-right"},[_c('p',{staticClass:"el-date-range-picker__title",domProps:{"textContent":_vm._s(_vm.t('el.datepicker.endTime'))}}),_c('div',{staticClass:"el-date-range-picker__header"},[(_vm.unlinkPanels)?_c('button',{staticClass:"el-picker-panel__icon-btn h-icon-angles_left_sm",class:{ 'is-disabled': !_vm.enableYearArrow },attrs:{"disabled":!_vm.enableYearArrow,"type":"button"},on:{"click":_vm.rightPrevYear}}):_vm._e(),_c('span',{staticClass:"el-picker-panel__header-label-wrapper",class:[("is-" + _vm.rightCurrentView)]},[_c('span',{staticClass:"el-picker-panel__header-label",domProps:{"textContent":_vm._s(_vm.rightLabel)},on:{"click":function($event){return _vm.showYearPicker('right')}}})]),_c('button',{staticClass:"el-picker-panel__icon-btn h-icon-angles_right_sm",attrs:{"type":"button"},on:{"click":_vm.rightNextYear}})]),(_vm.rightCurrentView === 'month')?_c('month-table',{attrs:{"date":_vm.rightDate,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"value":_vm.maxDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate,"unlink-range":_vm.isUnlinkRange,"selection-mode":"range","table-type":"max"},on:{"changerange":_vm.handleChangeRange,"pick":_vm.handleRangePick}}):_vm._e(),_c('div',{staticClass:"el-picker-panel__content has-modal"},[(_vm.rightCurrentView === 'year')?_c('year-table',{ref:"rightYearTable",attrs:{"date":_vm.rightDate,"value":_vm.maxDate,"default-value":_vm.defaultValue ? new Date(_vm.defaultValue) : null,"disabled-date":_vm.disabledDate},on:{"pick":_vm.handleRightYearPick}}):_vm._e()],1)],1)]),(_vm.unlink)?_c('div',{staticClass:"el-picker-panel__footer"},[(!_vm.showPrompt || _vm.showAbnormalInfo)?_c('span',{staticClass:"el-picker-panel__footer-message is-warning",attrs:{"title":_vm.prompt},domProps:{"textContent":_vm._s(_vm.prompt)}}):(_vm.minVisibleMonth !== '' && _vm.maxVisibleMonth !== '')?_c('span',{staticClass:"el-picker-panel__footer-message"},[_c('span',{domProps:{"textContent":_vm._s(_vm.minVisibleMonth)}}),_c('span',{domProps:{"textContent":_vm._s(_vm.rangeSeparator)}}),_c('span',{domProps:{"textContent":_vm._s(_vm.maxVisibleMonth)}})]):_c('span',{staticClass:"el-picker-panel__footer-message"}),_c('el-button',{staticClass:"el-picker-panel__link-btn",attrs:{"disabled":_vm.disabledConfirm,"type":"primary"},domProps:{"textContent":_vm._s(_vm.t('el.datepicker.confirm'))},on:{"click":function($event){return _vm.handleConfirm(false)}}})],1):_vm._e()],2)])])}
var month_rangevue_type_template_id_5cbdcb1c_staticRenderFns = []


// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=5cbdcb1c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var month_rangevue_type_script_lang_js_calcDefaultValue = function calcDefaultValue(defaultValue) {
  if (Array.isArray(defaultValue)) {
    return [new Date(defaultValue[0]), new Date(defaultValue[1])];
  } else if (defaultValue) {
    return [new Date(defaultValue), util_nextMonth(new Date(defaultValue))];
  } else {
    return [util_now('clearDate'), util_nextMonth(util_now('clearDate'))];
  }
};

/* harmony default export */ var month_rangevue_type_script_lang_js_ = ({
  directives: {
    Clickoutside: clickoutside
  },
  components: {
    MonthTable: month_table,
    YearTable: year_table
  },
  mixins: [locale, mixins_range],
  data: function data() {
    return {
      popperClass: '',
      value: [],
      defaultValue: null,
      defaultTime: null,
      minDate: util_now('clearDate'),
      maxDate: util_now('clearDate'),
      leftDate: util_now('clearDate'),
      rightDate: util_now('clearDate'),
      rangeState: {
        endDate: null,
        selecting: false,
        row: null,
        column: null
      },
      shortcuts: '',
      visible: '',
      disabledDate: function disabledDate() {
        return false;
      },
      format: 'yyyy/MM',
      arrowControl: false,
      unlinkPanels: false,
      unlink: true,
      unlinkRange: true,
      rangeSeparator: '-',
      leftCurrentView: 'month',
      rightCurrentView: 'month'
    };
  },
  computed: {
    now: function now() {
      return util_now('clearDate');
    },
    calcMinDate: function calcMinDate() {
      var minDate = this.minDate || month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
      return toDate(minDate);
    },
    calcMaxDate: function calcMaxDate() {
      var maxDate = this.maxDate || month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[1];
      return toDate(maxDate);
    },
    btnDisabled: function btnDisabled() {
      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]));
    },
    leftLabel: function leftLabel() {
      return this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year');
    },
    rightLabel: function rightLabel() {
      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year');
    },
    leftYear: function leftYear() {
      return this.leftDate.getFullYear();
    },
    rightYear: function rightYear() {
      return this.rightDate.getFullYear() === this.leftDate.getFullYear() ? this.leftDate.getFullYear() + 1 : this.rightDate.getFullYear();
    },
    enableYearArrow: function enableYearArrow() {
      if (!this.unlink) {
        return this.unlinkPanels && this.rightYear > this.leftYear + 1;
      } else {
        return true;
      }
    },
    minVisibleMonth: function minVisibleMonth() {
      if (this.minDate) {
        return util_formatDate(this.minDate, this.format);
      }

      return '';
    },
    maxVisibleMonth: function maxVisibleMonth() {
      if (this.maxDate) {
        return util_formatDate(this.maxDate, this.format);
      }

      return '';
    },
    showAbnormalInfo: function showAbnormalInfo() {
      if (this.isUnlinkRange) {
        if (this.minDate && this.maxDate && clearTime(this.minDate).getTime() > clearTime(this.maxDate).getTime()) {
          return true;
        }
      }

      return false;
    }
  },
  watch: {
    visible: function visible(val) {
      if (!val) {
        this.leftCurrentView = 'month';
        this.rightCurrentView = 'month';
      }
    },
    value: function value(newVal) {
      if (!newVal) {
        this.minDate = this.now;
        this.maxDate = this.now;
      } else if (Array.isArray(newVal)) {
        this.minDate = toDate(newVal[0]);
        this.maxDate = toDate(newVal[1]);
      }

      this.leftDate = this.calcMinDate;
      this.rightDate = this.getDefaultRightDate(this.calcMaxDate);
    },
    defaultValue: function defaultValue(val) {
      if (!Array.isArray(this.value)) {
        var _calcDefaultValue = month_rangevue_type_script_lang_js_calcDefaultValue(val),
            _calcDefaultValue2 = _slicedToArray(_calcDefaultValue, 2),
            leftDate = _calcDefaultValue2[0],
            rightDate = _calcDefaultValue2[1];

        this.leftDate = leftDate;
        this.rightDate = this.getDefaultRightDate(rightDate);
      }
    }
  },
  methods: {
    getDefaultRightDate: function getDefaultRightDate(val) {
      var minDateYear = this.calcMinDate.getFullYear();
      var maxDateYear = this.calcMaxDate.getFullYear();
      var toNext = minDateYear === maxDateYear;

      if (!this.isUnlinkRange && toNext) {
        return util_nextYear(val);
      } else {
        return val;
      }
    },
    handleLeftYearPick: function handleLeftYearPick(year) {
      this.leftDate = setYear(this.leftDate, year);
      this.leftCurrentView = 'month';
    },
    handleRightYearPick: function handleRightYearPick(year) {
      this.rightDate = setYear(this.rightDate, year);
      this.rightCurrentView = 'month';
    },
    showYearPicker: function showYearPicker(pos) {
      if (this.isUnlinkRange) {
        if (pos === 'left') {
          this.leftCurrentView = 'year';
        } else {
          this.rightCurrentView = 'year';
        }
      }
    },
    handleClear: function handleClear() {
      this.minDate = null;
      this.maxDate = null;
      this.leftDate = this.calcMinDate;
      this.rightDate = this.getDefaultRightDate(this.calcMaxDate);
      this.$emit('pick', null);
    },
    handleChangeRange: function handleChangeRange(val) {
      this.minDate = val.minDate;
      this.maxDate = val.maxDate;
      this.rangeState = val.rangeState;
    },
    handleRangePick: function handleRangePick(val, _ref) {
      var type = _ref.type,
          cell = _ref.cell;
      var defaultTime = this.defaultTime || [];
      var minDate = modifyWithTimeString(val.minDate, defaultTime[0]);
      var maxDate = modifyWithTimeString(val.maxDate, defaultTime[1]);

      if (this.isUnlinkRange) {
        if (type === 'min') {
          this.minDate = minDate;
          this.leftDate = minDate;
        } else {
          this.maxDate = maxDate;
          this.rightDate = maxDate;
        }
      } else {
        if (this.maxDate === maxDate && this.minDate === minDate) {
          return;
        }

        this.onPick && this.onPick(val);
        this.maxDate = maxDate;
        this.minDate = minDate;
      }

      this.handleConfirm(!!this.unlink);
    },
    handleShortcutClick: function handleShortcutClick(shortcut) {
      if (shortcut.onClick) {
        shortcut.onClick(this);
      }
    },
    // leftPrev*, rightNext* need to take care of `unlinkPanels`
    leftPrevYear: function leftPrevYear() {
      this.leftDate = util_prevYear(this.leftDate);

      if (!this.unlinkPanels) {
        this.rightDate = util_prevYear(this.rightDate);
      }
    },
    rightNextYear: function rightNextYear() {
      if (!this.unlinkPanels) {
        this.leftDate = util_nextYear(this.leftDate);
      }

      this.rightDate = util_nextYear(this.rightDate);
    },
    // leftNext*, rightPrev* are called when `unlinkPanels` is true
    leftNextYear: function leftNextYear() {
      this.leftDate = util_nextYear(this.leftDate);
    },
    rightPrevYear: function rightPrevYear() {
      this.rightDate = util_prevYear(this.rightDate);
    },
    handleConfirm: function handleConfirm() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isValidValue([this.minDate, this.maxDate])) {
        this.$emit('pick', [this.minDate, this.maxDate], visible);
      }
    },
    isValidValue: function isValidValue(value) {
      return Array.isArray(value) && value && value[0] && value[1] && isDate(value[0]) && isDate(value[1]) && clearDate(value[0]).getTime() <= clearDate(value[1]).getTime() && !this.disabledDate(value[0]) && !this.disabledDate(value[1]);
    },
    resetView: function resetView() {
      var _this = this;

      this.$nextTick(function () {
        if (isEmptyDate(_this.value)) {
          _this.minDate = null;
          _this.maxDate = null;
          var defaultValue = _this.defaultValue;

          if (defaultValue) {
            var _calcDefaultValue3 = month_rangevue_type_script_lang_js_calcDefaultValue(defaultValue),
                _calcDefaultValue4 = _slicedToArray(_calcDefaultValue3, 2),
                leftDate = _calcDefaultValue4[0],
                rightDate = _calcDefaultValue4[1];

            _this.minDate = leftDate;
            _this.maxDate = rightDate;
            _this.leftDate = leftDate;
            _this.rightDate = rightDate;
          }

          _this.leftDate = _this.calcMinDate;
          _this.rightDate = _this.getDefaultRightDate(_this.calcMaxDate);
        } else {
          _this.minDate = toDate(_this.value[0]);
          _this.maxDate = toDate(_this.value[1]);
          _this.leftDate = _this.calcMinDate;
          _this.rightDate = _this.getDefaultRightDate(_this.calcMaxDate);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
 /* harmony default export */ var panel_month_rangevue_type_script_lang_js_ = (month_rangevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue





/* normalize component */

var month_range_component = normalizeComponent(
  panel_month_rangevue_type_script_lang_js_,
  month_rangevue_type_template_id_5cbdcb1c_render,
  month_rangevue_type_template_id_5cbdcb1c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var month_range = (month_range_component.exports);
// CONCATENATED MODULE: ./packages/date-picker/src/picker/date-picker.js





var date_picker_getPanel = function getPanel(type) {
  if (type === 'daterange' || type === 'datetimerange') {
    return date_range;
  } else if (type === 'monthrange') {
    return month_range;
  }

  return panel_date;
};

/* harmony default export */ var date_picker = ({
  mixins: [picker],
  name: 'ElDatePicker',
  props: {
    type: {
      type: String,
      "default": 'date'
    },
    timeArrowControl: {
      type: Boolean,
      "default": false
    }
  },
  watch: {
    type: function type(_type) {
      if (this.picker) {
        this.unmountPicker();
        this.panel = date_picker_getPanel(_type);
        this.mountPicker();
      } else {
        this.panel = date_picker_getPanel(_type);
      }
    }
  },
  created: function created() {
    this.panel = date_picker_getPanel(this.type);
  }
});
// CONCATENATED MODULE: ./packages/date-picker/index.js


/* istanbul ignore next */

date_picker.install = function install(Vue) {
  Vue.component(date_picker.name, date_picker);
};

/* harmony default export */ var packages_date_picker = (date_picker);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=6d8cb233&
var time_selectvue_type_template_id_6d8cb233_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-bottom"},on:{"before-enter":_vm.handleMenuEnter,"after-leave":function($event){return _vm.$emit('dodestroy')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],ref:"popper",staticClass:"el-picker-panel time-select el-popper",class:_vm.popperClass,style:({ width: _vm.width + 'px' })},[_c('el-scrollbar',{attrs:{"noresize":"","wrap-class":"el-picker-panel__content"}},_vm._l((_vm.items),function(item){return _c('div',{key:item.value,staticClass:"time-select-item",class:{
          selected: _vm.value === item.value,
          disabled: item.disabled,
          default: item.value === _vm.defaultValue
        },attrs:{"disabled":item.disabled},domProps:{"textContent":_vm._s(item.value)},on:{"click":function($event){return _vm.handleClick(item)}}})}),0)],1)])}
var time_selectvue_type_template_id_6d8cb233_staticRenderFns = []


// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=6d8cb233&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var parseTime = function parseTime(time) {
  var values = (time || '').split(':');

  if (values.length >= 2) {
    var hours = parseInt(values[0], 10);
    var minutes = parseInt(values[1], 10);
    return {
      hours: hours,
      minutes: minutes
    };
  }
  /* istanbul ignore next */


  return null;
};

var compareTime = function compareTime(time1, time2) {
  var value1 = parseTime(time1);
  var value2 = parseTime(time2);
  var minutes1 = value1.minutes + value1.hours * 60;
  var minutes2 = value2.minutes + value2.hours * 60;

  if (minutes1 === minutes2) {
    return 0;
  }

  return minutes1 > minutes2 ? 1 : -1;
};

var formatTime = function formatTime(time) {
  return (time.hours < 10 ? '0' + time.hours : time.hours) + ':' + (time.minutes < 10 ? '0' + time.minutes : time.minutes);
};

var nextTime = function nextTime(time, step) {
  var timeValue = parseTime(time);
  var stepValue = parseTime(step);
  var next = {
    hours: timeValue.hours,
    minutes: timeValue.minutes
  };
  next.minutes += stepValue.minutes;
  next.hours += stepValue.hours;
  next.hours += Math.floor(next.minutes / 60);
  next.minutes = next.minutes % 60;
  return formatTime(next);
};

/* harmony default export */ var time_selectvue_type_script_lang_js_ = ({
  components: {
    ElScrollbar: scrollbar
  },
  data: function data() {
    return {
      popperClass: '',
      start: '09:00',
      end: '18:00',
      step: '00:30',
      value: '',
      defaultValue: '',
      visible: false,
      minTime: '',
      maxTime: '',
      width: 0,
      range: []
    };
  },
  computed: {
    items: function items() {
      var _this = this;

      var start = this.start;
      var end = this.end;
      var step = this.step;
      var result = [];

      if (start && end && step) {
        (function () {
          var current = start;

          while (compareTime(current, end) <= 0) {
            if (_this.range.length) {
              (function () {
                var isInRange = true;
                (_this.range || []).forEach(function (range) {
                  var ranges = range.split('-');
                  isInRange = isInRange && (compareTime(current, ranges[0]) < 0 || compareTime(current, ranges[1]) > 0);
                });
                result.push({
                  value: current,
                  disabled: compareTime(current, _this.minTime || '-1:-1') <= 0 || compareTime(current, _this.maxTime || '100:100') >= 0 || isInRange
                });
              })();
            } else {
              result.push({
                value: current,
                disabled: compareTime(current, _this.minTime || '-1:-1') <= 0 || compareTime(current, _this.maxTime || '100:100') >= 0
              });
            }

            current = nextTime(current, step);
          }
        })();
      }

      return result;
    }
  },
  watch: {
    value: function value(val) {
      var _this2 = this;

      if (!val) return;
      this.$nextTick(function () {
        return _this2.scrollToOption();
      });
    }
  },
  methods: {
    handleClick: function handleClick(item) {
      if (!item.disabled) {
        this.$emit('pick', item.value);
      }
    },
    handleClear: function handleClear() {
      this.$emit('pick', null);
    },
    scrollToOption: function scrollToOption() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.selected';
      var menu = this.$refs.popper.querySelector('.el-picker-panel__content');
      scrollIntoView(menu, menu.querySelector(selector));
    },
    handleMenuEnter: function handleMenuEnter() {
      var _this3 = this;

      var selected = this.items.map(function (item) {
        return item.value;
      }).indexOf(this.value) !== -1;
      var hasDefault = this.items.map(function (item) {
        return item.value;
      }).indexOf(this.defaultValue) !== -1;
      var option = selected && '.selected' || hasDefault && '.default' || '.time-select-item:not(.disabled)';
      this.$nextTick(function () {
        return _this3.scrollToOption(option);
      });
    },
    scrollDown: function scrollDown(step) {
      var items = this.items;
      var length = items.length;
      var total = items.length;
      var index = items.map(function (item) {
        return item.value;
      }).indexOf(this.value);

      while (total--) {
        index = (index + step + length) % length;

        if (!items[index].disabled) {
          this.$emit('pick', items[index].value, true);
          return;
        }
      }
    },
    isValidValue: function isValidValue(date) {
      return this.items.filter(function (item) {
        return !item.disabled;
      }).map(function (item) {
        return item.value;
      }).indexOf(date) !== -1;
    },
    handleKeydown: function handleKeydown(event) {
      var keyCode = event.keyCode;

      if (keyCode === 38 || keyCode === 40) {
        var mapping = {
          40: 1,
          38: -1
        };
        var offset = mapping[keyCode.toString()];
        this.scrollDown(offset);
        event.stopPropagation();
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
 /* harmony default export */ var panel_time_selectvue_type_script_lang_js_ = (time_selectvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue





/* normalize component */

var time_select_component = normalizeComponent(
  panel_time_selectvue_type_script_lang_js_,
  time_selectvue_type_template_id_6d8cb233_render,
  time_selectvue_type_template_id_6d8cb233_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var time_select = (time_select_component.exports);
// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-select.js


/* harmony default export */ var picker_time_select = ({
  mixins: [picker],
  name: 'ElTimeSelect',
  componentName: 'ElTimeSelect',
  props: {
    type: {
      type: String,
      "default": 'time-select'
    }
  },
  beforeCreate: function beforeCreate() {
    this.panel = time_select;
  }
});
// CONCATENATED MODULE: ./packages/time-select/index.js


/* istanbul ignore next */

picker_time_select.install = function (Vue) {
  Vue.component(picker_time_select.name, picker_time_select);
};

/* harmony default export */ var packages_time_select = (picker_time_select);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=db43242c&
var time_rangevue_type_template_id_db43242c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-bottom"},on:{"after-leave":function($event){return _vm.$emit('dodestroy')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-time-range-picker el-picker-panel el-popper",class:_vm.popperClass},[_c('div',{staticClass:"el-time-range-picker__content"},[_c('div',{staticClass:"el-time-range-picker__cell"},[_c('div',{staticClass:"el-time-range-picker__header",domProps:{"textContent":_vm._s(_vm.t('el.datepicker.startTime'))}}),_c('div',{staticClass:"el-time-range-picker__body el-time-panel__content",class:{ 'has-seconds': _vm.showSeconds, 'is-arrow': _vm.arrowControl }},[_c('time-spinner',{ref:"minSpinner",attrs:{"is-empty":_vm.isTimeEmpty,"show-seconds":_vm.showSeconds,"am-pm-mode":_vm.amPmMode,"arrow-control":_vm.arrowControl,"date":_vm.minDate},on:{"change":_vm.handleMinChange,"select-range":_vm.setMinSelectionRange}})],1)]),_c('div',{staticClass:"el-time-range-picker__cell"},[_c('div',{staticClass:"el-time-range-picker__header",domProps:{"textContent":_vm._s(_vm.t('el.datepicker.endTime'))}}),_c('div',{staticClass:"el-time-range-picker__body el-time-panel__content",class:{ 'has-seconds': _vm.showSeconds, 'is-arrow': _vm.arrowControl }},[_c('time-spinner',{ref:"maxSpinner",attrs:{"is-empty":_vm.isTimeEmpty,"unlink-range":_vm.unlinkRange,"show-seconds":_vm.showSeconds,"am-pm-mode":_vm.amPmMode,"arrow-control":_vm.arrowControl,"date":_vm.maxDate},on:{"change":_vm.handleMaxChange,"select-range":_vm.setMaxSelectionRange}})],1)])]),_c('div',{staticClass:"el-picker-panel__footer"},[(!_vm.showPrompt || _vm.showAbnormalInfo)?_c('span',{staticClass:"el-picker-panel__footer-message is-warning",attrs:{"title":_vm.prompt},domProps:{"textContent":_vm._s(_vm.prompt)}}):(_vm.minVisibleTime !== '' && _vm.maxVisibleTime !== '')?_c('span',{staticClass:"el-picker-panel__footer-message"},[_c('span',{domProps:{"textContent":_vm._s(_vm.minVisibleTime)}}),_c('span',{domProps:{"textContent":_vm._s(_vm.rangeSeparator)}}),_c('span',{domProps:{"textContent":_vm._s(_vm.maxVisibleTime)}})]):_c('span',{staticClass:"el-picker-panel__footer-message"}),_c('el-button',{staticClass:"el-time-panel__btn confirm",attrs:{"disabled":_vm.showAbnormalInfo || _vm.isTimeEmpty,"type":"primary"},domProps:{"textContent":_vm._s(_vm.t('el.datepicker.confirm'))},on:{"click":function($event){return _vm.handleConfirm()}}})],1)])])}
var time_rangevue_type_template_id_db43242c_staticRenderFns = []


// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=db43242c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var time_rangevue_type_script_lang_js_minTimeOfDay = function minTimeOfDay(date) {
  return modifyDate(MIN_TIME, date.getFullYear(), date.getMonth(), date.getDate());
};

var time_rangevue_type_script_lang_js_maxTimeOfDay = function maxTimeOfDay(date) {
  return modifyDate(MAX_TIME, date.getFullYear(), date.getMonth(), date.getDate());
}; // increase time by amount of milliseconds, but within the range of day


var advanceTime = function advanceTime(date, amount) {
  return new Date(Math.min(date.getTime() + amount, time_rangevue_type_script_lang_js_maxTimeOfDay(date).getTime()));
};

/* harmony default export */ var time_rangevue_type_script_lang_js_ = ({
  components: {
    TimeSpinner: time_spinner,
    ElButton: packages_button
  },
  mixins: [locale, mixins_range],
  data: function data() {
    return {
      popperClass: '',
      minDate: util_now(),
      maxDate: util_now(),
      value: [],
      defaultValue: null,
      format: 'HH:mm:ss',
      rangeSeparator: '-',
      visible: false,
      selectionRange: [0, 2],
      arrowControl: false,
      isRange: false,
      unlink: true,
      unlinkRange: true,
      selectableRange: []
    };
  },
  computed: {
    showSeconds: function showSeconds() {
      return (this.format || '').indexOf('ss') !== -1;
    },
    offset: function offset() {
      return this.showSeconds ? 11 : 8;
    },
    spinner: function spinner() {
      return this.selectionRange[0] < this.offset ? this.$refs.minSpinner : this.$refs.maxSpinner;
    },
    showAbnormalInfo: function showAbnormalInfo() {
      if (this.isTimeEmpty) {
        return false;
      }

      return this.minDate.getTime() > this.maxDate.getTime();
    },
    amPmMode: function amPmMode() {
      if ((this.format || '').indexOf('A') !== -1) return 'A';
      if ((this.format || '').indexOf('a') !== -1) return 'a';
      return '';
    },
    minVisibleTime: function minVisibleTime() {
      if (!this.isTimeEmpty) {
        return util_formatDate(this.minDate, this.format);
      }

      return '';
    },
    maxVisibleTime: function maxVisibleTime() {
      if (!this.isTimeEmpty) {
        return util_formatDate(this.maxDate, this.format);
      }

      return '';
    },
    isTimeEmpty: function isTimeEmpty() {
      if (!this.isUnlinkRange) {
        return false;
      }

      return isEmptyDate(this.value) && isEmptyDate(this.defaultTime);
    }
  },
  watch: {
    value: function value(_value) {
      if (Array.isArray(_value)) {
        var defaultDate = util_now();

        if (!this.unlinkRange) {
          defaultDate = advanceTime(util_now(), 60 * 60 * 1000);
        }

        this.minDate = isDate(_value[0]) ? new Date(_value[0]) : defaultDate;
        this.maxDate = isDate(_value[1]) ? new Date(_value[1]) : defaultDate;
      } else {
        if (Array.isArray(this.defaultValue)) {
          this.minDate = new Date(this.defaultValue[0]);
          this.maxDate = new Date(this.defaultValue[1]);
        } else if (this.defaultValue) {
          this.minDate = new Date(this.defaultValue);
          this.maxDate = advanceTime(new Date(this.defaultValue), 60 * 60 * 1000);
        } else {
          this.minDate = util_now();

          if (!this.unlinkRange) {
            this.maxDate = advanceTime(util_now(), 60 * 60 * 1000);
          } else {
            this.maxDate = util_now();
          }
        }
      }

      if (this.isValidValue(_value) && !this.unlinkRange) {
        if (this.$refs.minSpinner) {
          this.$refs.minSpinner.selectableRange = [[time_rangevue_type_script_lang_js_minTimeOfDay(_value[0]), _value[1]]];
        }

        if (this.$refs.maxSpinner) {
          this.$refs.maxSpinner.selectableRange = [[_value[0], time_rangevue_type_script_lang_js_maxTimeOfDay(_value[1])]];
        }
      }
    },
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.$nextTick(function () {
          _this.$refs.minSpinner.emitSelectRange('hours');

          _this.adjustSpinners();
        });
      }
    },
    selectableRange: function selectableRange(val) {
      this.$refs.minSpinner.selectableRange = val;
      this.$refs.maxSpinner.selectableRange = val;
    }
  },
  methods: {
    handleClear: function handleClear() {
      this.$emit('pick', null);
    },
    handleCancel: function handleCancel() {
      this.$emit('pick', this.oldValue);
    },
    handleMinChange: function handleMinChange(date) {
      this.minDate = clearMilliseconds(date);
      this.handleChange();
    },
    handleMaxChange: function handleMaxChange(date) {
      this.maxDate = clearMilliseconds(date);
      this.handleChange();
    },
    handleChange: function handleChange() {
      if (this.isValidValue([this.minDate, this.maxDate])) {
        this.$emit('pick', [this.minDate, this.maxDate], this.arrowControl || this.isRange ? true : !this.isUnlinkRange);
      }
    },
    setMinSelectionRange: function setMinSelectionRange(start, end) {
      this.$emit('select-range', start, end, 'min');
      this.selectionRange = [start, end];
    },
    setMaxSelectionRange: function setMaxSelectionRange(start, end) {
      this.$emit('select-range', start, end, 'max');
      this.selectionRange = [start + this.offset, end + this.offset];
    },
    handleConfirm: function handleConfirm() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var minSelectableRange = this.$refs.minSpinner.selectableRange;
      var maxSelectableRange = this.$refs.maxSpinner.selectableRange;
      this.minDate = util_limitTimeRange(this.minDate, minSelectableRange, this.format);
      this.maxDate = util_limitTimeRange(this.maxDate, maxSelectableRange, this.format);
      this.$emit('pick', [this.minDate, this.maxDate], visible);
    },
    adjustSpinners: function adjustSpinners() {
      this.$refs.minSpinner.adjustSpinners();
      this.$refs.maxSpinner.adjustSpinners();
    },
    adjustCurrentSpinner: function adjustCurrentSpinner(type, pos) {
      var _this2 = this;

      this.$nextTick(function () {
        if (pos === 'min') {
          _this2.$refs.minSpinner.adjustCurrentSpinner(type);
        } else {
          _this2.$refs.maxSpinner.adjustCurrentSpinner(type);
        }
      });
    },
    changeSelectionRange: function changeSelectionRange(step) {
      var list = this.showSeconds ? [0, 3, 6, 11, 14, 17] : [0, 3, 8, 11];
      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
      var index = list.indexOf(this.selectionRange[0]);
      var next = (index + step + list.length) % list.length;
      var half = list.length / 2;

      if (next < half) {
        this.$refs.minSpinner.emitSelectRange(mapping[next]);
      } else {
        this.$refs.maxSpinner.emitSelectRange(mapping[next - half]);
      }
    },
    isValidValue: function isValidValue(value) {
      return Array.isArray(value) && timeWithinRange(this.minDate, this.$refs.minSpinner.selectableRange) && timeWithinRange(this.maxDate, this.$refs.maxSpinner.selectableRange);
    },
    handleKeydown: function handleKeydown(event) {
      var keyCode = event.keyCode;
      var mapping = {
        38: -1,
        40: 1,
        37: -1,
        39: 1
      }; // Left or Right

      if (keyCode === 37 || keyCode === 39) {
        var step = mapping[keyCode];
        this.changeSelectionRange(step);
        event.preventDefault();
        return;
      } // Up or Down


      if (keyCode === 38 || keyCode === 40) {
        var _step = mapping[keyCode];
        this.spinner.scrollDown(_step);
        event.preventDefault();
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
 /* harmony default export */ var panel_time_rangevue_type_script_lang_js_ = (time_rangevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue





/* normalize component */

var time_range_component = normalizeComponent(
  panel_time_rangevue_type_script_lang_js_,
  time_rangevue_type_template_id_db43242c_render,
  time_rangevue_type_template_id_db43242c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var time_range = (time_range_component.exports);
// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-picker.js



/* harmony default export */ var time_picker = ({
  mixins: [picker],
  name: 'ElTimePicker',
  props: {
    isRange: {
      type: Boolean,
      "default": false
    },
    arrowControl: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      type: ''
    };
  },
  watch: {
    isRange: function isRange(_isRange) {
      if (this.picker) {
        this.unmountPicker();
        this.type = _isRange ? 'timerange' : 'time';
        this.panel = _isRange ? time_range : panel_time;
        this.mountPicker();
      } else {
        this.type = _isRange ? 'timerange' : 'time';
        this.panel = _isRange ? time_range : panel_time;
      }
    }
  },
  created: function created() {
    this.type = this.isRange ? 'timerange' : 'time';
    this.panel = this.isRange ? time_range : panel_time;
  }
});
// CONCATENATED MODULE: ./packages/time-picker/index.js


/* istanbul ignore next */

time_picker.install = function (Vue) {
  Vue.component(time_picker.name, time_picker);
};

/* harmony default export */ var packages_time_picker = (time_picker);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=template&id=287f79c2&
var mainvue_type_template_id_287f79c2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"msgbox-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-message-box__wrapper",attrs:{"tabindex":"-1"},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleWrapperClick($event)}}},[_c('div',{staticClass:"el-message-box",class:[_vm.customClass, _vm.sizeClass]},[_c('div',{staticClass:"el-message-box__content"},[_c('div',{staticClass:"el-message-box__container"},[_c('h-feedback-icon',{staticClass:"el-message-box__status",attrs:{"icon-name":_vm.typeClass}}),(_vm.title)?_c('div',{staticClass:"el-message-box__titleWrapper",style:({
              'margin-top': !_vm.typeClass || _vm.message !== '' ? '0' : '8px'
            })},[_c('div',{staticClass:"el-message-box__title",style:({
                'margin-left': _vm.typeClass ? '56px' : '0',
                'min-height': _vm.message ? '' : '48px'
              })},[(!_vm.dangerouslyUseHTMLString)?_c('span',[_vm._v(_vm._s(_vm.title))]):_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})])]):_vm._e(),(_vm.message !== '')?_c('div',{staticClass:"el-message-box__message",style:({
              'margin-left': _vm.typeClass ? '56px' : '0',
              'margin-top': _vm.title ? '4px' : '0'
            })},[_vm._t("default",[_c('el-scrollbar',[(!_vm.dangerouslyUseHTMLString)?_c('p',[_vm._v(" "+_vm._s(_vm.message)+" ")]):_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])])],2):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInput),expression:"showInput"}],staticClass:"el-message-box__input"},[_c('el-input',{ref:"input",attrs:{"type":_vm.inputType,"placeholder":_vm.inputPlaceholder},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleAction('confirm')}},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}}),_c('div',{staticClass:"el-message-box__errormsg",style:({
                visibility: !!_vm.editorErrorMessage ? 'visible' : 'hidden'
              })},[_vm._v(" "+_vm._s(_vm.editorErrorMessage)+" ")])],1)],1)]),_c('div',{staticClass:"el-message-box__btns"},[(_vm.buttons)?_c('div',_vm._l((_vm.buttons),function(item,index){return _c('el-button',{key:index,attrs:{"type":item.type},nativeOn:{"click":function($event){return _vm.handleAction(item.action)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1):_c('div',[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showConfirmButton),expression:"showConfirmButton"}],ref:"confirm",class:[_vm.confirmButtonClasses],attrs:{"loading":_vm.confirmButtonLoading},nativeOn:{"click":function($event){return _vm.handleAction('confirm')}}},[_vm._v(" "+_vm._s(_vm.confirmButtonText || _vm.t('el.messagebox.confirm'))+" ")]),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCancelButton),expression:"showCancelButton"}],class:[_vm.cancelButtonClasses],attrs:{"loading":_vm.cancelButtonLoading},nativeOn:{"click":function($event){return _vm.handleAction('cancel')}}},[_vm._v(" "+_vm._s(_vm.cancelButtonText || _vm.t('el.messagebox.cancel'))+" ")])],1)])])])])}
var mainvue_type_template_id_287f79c2_staticRenderFns = []


// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=template&id=287f79c2&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var typeMap = {
  success: 'feedback_success_lg',
  info: 'feedback_info_lg',
  warning: 'feedback_warning_lg',
  question: 'feedback_question_lg',
  error: 'feedback_error_lg'
};
var mainvue_type_script_lang_js_sizeMap = {
  small: 'small',
  middle: 'middle',
  large: 'large'
};
/* harmony default export */ var message_box_src_mainvue_type_script_lang_js_ = ({
  components: {
    ElInput: packages_input,
    ElButton: packages_button
  },
  mixins: [popup, locale],
  props: {
    modal: {
      type: Boolean,
      "default": true
    },
    lockScroll: {
      type: Boolean,
      "default": true
    },
    showClose: {
      type: Boolean,
      "default": true
    },
    closeOnClickModal: {
      type: Boolean,
      "default": true
    },
    closeOnPressEscape: {
      type: Boolean,
      "default": true
    },
    closeOnHashChange: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      uid: 1,
      title: undefined,
      message: '',
      type: '',
      size: '',
      customClass: '',
      showInput: false,
      inputValue: null,
      inputPlaceholder: '',
      inputType: 'text',
      inputPattern: null,
      inputValidator: null,
      inputErrorMessage: '',
      showConfirmButton: true,
      showCancelButton: false,
      action: '',
      confirmButtonText: '',
      cancelButtonText: '',
      confirmButtonLoading: false,
      cancelButtonLoading: false,
      confirmButtonClass: '',
      confirmButtonDisabled: false,
      cancelButtonClass: '',
      editorErrorMessage: null,
      callback: null,
      dangerouslyUseHTMLString: false,
      buttons: null
    };
  },
  computed: {
    typeClass: function typeClass() {
      return this.type && typeMap[this.type] ? "h-icon-".concat(typeMap[this.type]) : '';
    },
    sizeClass: function sizeClass() {
      return this.size && mainvue_type_script_lang_js_sizeMap[this.size] ? "el-message-box--".concat(mainvue_type_script_lang_js_sizeMap[this.size]) : 'el-message-box--small';
    },
    confirmButtonClasses: function confirmButtonClasses() {
      return "el-button--primary ".concat(this.confirmButtonClass);
    },
    cancelButtonClasses: function cancelButtonClasses() {
      return "".concat(this.cancelButtonClass);
    }
  },
  watch: {
    inputValue: {
      immediate: true,
      handler: function handler(val) {
        var _this = this;

        this.$nextTick(function () {
          if (_this.$type === 'prompt' && val !== null) {
            _this.validate();
          }
        });
      }
    },
    visible: function visible(val) {
      var _this2 = this;

      if (val) this.uid++;

      if (this.$type === 'alert' || this.$type === 'confirm') {
        this.$nextTick(function () {
          if (_this2.$refs.confirm) {
            _this2.$refs.confirm.$el.focus();
          }
        });
      }

      if (this.$type !== 'prompt') return;

      if (val) {
        setTimeout(function () {
          if (_this2.$refs.input && _this2.$refs.input.$el) {
            _this2.$refs.input.$el.querySelector('input').focus();
          }
        }, 500);
      } else {
        this.editorErrorMessage = '';
        removeClass(this.$refs.input.$el.querySelector('input'), 'invalid');
      }
    }
  },
  mounted: function mounted() {
    if (this.closeOnHashChange) {
      window.addEventListener('hashchange', this.close);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.closeOnHashChange) {
      window.removeEventListener('hashchange', this.close);
    }
  },
  methods: {
    getSafeClose: function getSafeClose() {
      var _this3 = this;

      var currentId = this.uid;
      return function () {
        _this3.$nextTick(function () {
          if (currentId === _this3.uid) _this3.doClose();
        });
      };
    },
    doClose: function doClose() {
      var _this4 = this;

      if (!this.visible) return;
      this.visible = false;
      this._closing = true;
      this.onClose && this.onClose();

      if (this.lockScroll) {
        setTimeout(function () {
          if (_this4.modal && _this4.bodyOverflow !== 'hidden') {
            document.body.style.overflow = _this4.bodyOverflow;
            document.body.style.width = _this4.bodyPaddingRight;
          }

          _this4.bodyOverflow = null;
          _this4.bodyPaddingRight = null;
        }, 200);
      }

      this.opened = false;

      if (!this.transition) {
        this.doAfterClose();
      }

      if (this.action) this.callback(this.action, this);
    },
    handleWrapperClick: function handleWrapperClick() {
      if (this.closeOnClickModal) {
        this.handleAction('cancel');
      }
    },
    handleAction: function handleAction(action) {
      if (this.$type === 'prompt' && action === 'confirm' && !this.validate()) {
        return;
      }

      this.action = action;

      if (typeof this.beforeClose === 'function') {
        this.close = this.getSafeClose();
        this.beforeClose(action, this, this.close);
      } else {
        this.doClose();
      }
    },
    validate: function validate() {
      if (this.$type === 'prompt') {
        var inputPattern = this.inputPattern;

        if (inputPattern && !inputPattern.test(this.inputValue || '')) {
          this.editorErrorMessage = this.inputErrorMessage || Object(locale_["t"])('el.messagebox.error');
          addClass(this.$refs.input.$el.querySelector('input'), 'invalid');
          return false;
        }

        var inputValidator = this.inputValidator;

        if (typeof inputValidator === 'function') {
          var validateResult = inputValidator(this.inputValue);

          if (validateResult === false) {
            this.editorErrorMessage = this.inputErrorMessage || Object(locale_["t"])('el.messagebox.error');
            addClass(this.$refs.input.$el.querySelector('input'), 'invalid');
            return false;
          }

          if (typeof validateResult === 'string') {
            this.editorErrorMessage = validateResult;
            return false;
          }
        }
      }

      this.editorErrorMessage = '';
      removeClass(this.$refs.input.$el.querySelector('input'), 'invalid');
      return true;
    }
  }
});
// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_message_box_src_mainvue_type_script_lang_js_ = (message_box_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/message-box/src/main.vue





/* normalize component */

var message_box_src_main_component = normalizeComponent(
  packages_message_box_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_287f79c2_render,
  mainvue_type_template_id_287f79c2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var message_box_src_main = (message_box_src_main_component.exports);
// CONCATENATED MODULE: ./src/utils/vdom.js



function isVNode(node) {
  return _typeof(node) === 'object' && hasOwn(node, 'componentOptions');
}
function getFirstComponentChild(children) {
  return children && children.filter(function (c) {
    return c && c.tag;
  })[0];
}
// CONCATENATED MODULE: ./packages/message-box/src/main.js









var main_defaults = {
  title: undefined,
  message: '',
  type: '',
  size: '',
  showInput: false,
  showClose: true,
  modalFade: true,
  lockScroll: true,
  closeOnClickModal: false,
  closeOnPressEscape: false,
  closeOnHashChange: true,
  inputValue: null,
  inputPlaceholder: '',
  inputType: 'text',
  inputPattern: null,
  inputValidator: null,
  inputErrorMessage: '',
  showConfirmButton: true,
  showCancelButton: false,
  confirmButtonPosition: 'right',
  confirmButtonHighlight: false,
  cancelButtonHighlight: false,
  confirmButtonText: '',
  cancelButtonText: '',
  confirmButtonClass: '',
  cancelButtonClass: '',
  customClass: '',
  beforeClose: null,
  dangerouslyUseHTMLString: false,
  buttons: null,
  onConfirm: null,
  onCancel: null
};
var MessageBoxConstructor = external_vue_default.a.extend(message_box_src_main);
var currentMsg, main_instance;
var msgQueue = [];

var defaultCallback = function defaultCallback(action) {
  if (currentMsg) {
    var callback = currentMsg.callback;

    if (typeof callback === 'function') {
      if (main_instance.showInput) {
        callback(main_instance.inputValue, action);
      } else {
        callback(action);
      }
    }

    if (currentMsg.resolve) {
      if (action !== 'cancel') {
        if (main_instance.showInput) {
          currentMsg.resolve({
            value: main_instance.inputValue,
            action: action
          });
        } else {
          currentMsg.resolve(action);
        }

        if (typeof currentMsg.options.onConfirm === 'function') {
          if (main_instance.showInput) {
            currentMsg.options.onConfirm({
              value: main_instance.inputValue,
              action: action
            });
          } else {
            currentMsg.options.onConfirm(action);
          }
        }
      } else if (currentMsg.reject) {
        if (typeof currentMsg.options.onCancel === 'function') {
          currentMsg.options.onCancel(action);
        } else {
          currentMsg.reject(action);
        }
      }
    }
  }
};

var initInstance = function initInstance() {
  main_instance = new MessageBoxConstructor({
    el: document.createElement('div')
  });
  main_instance.callback = defaultCallback;
};

var main_showNextMsg = function showNextMsg() {
  if (!main_instance) {
    initInstance();
  }

  main_instance.action = '';

  if (!main_instance.visible || main_instance.closeTimer) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift();
      var options = currentMsg.options;

      for (var prop in options) {
        if (hasOwn(options, prop)) {
          main_instance[prop] = options[prop];
        }
      } // 如果msgbox默认没有使用title属性，则应该赋值title为空


      if (!options.title) {
        main_instance.title = '';
      }

      if (options.callback === undefined) {
        main_instance.callback = defaultCallback;
      }

      var oldCb = main_instance.callback;

      main_instance.callback = function (action, instance) {
        oldCb(action, instance);
        showNextMsg();
      };

      if (isVNode(main_instance.message)) {
        main_instance.$slots["default"] = [main_instance.message];
        main_instance.message = null;
      } else {
        delete main_instance.$slots["default"];
      }

      ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape', 'closeOnHashChange'].forEach(function (prop) {
        if (main_instance[prop] === undefined) {
          main_instance[prop] = true;
        }
      });
      document.body.appendChild(main_instance.$el);
      external_vue_default.a.nextTick(function () {
        main_instance.visible = true;
      });
    }
  }
};

var main_MessageBox = function MessageBox(options, callback) {
  if (external_vue_default.a.prototype.$isServer) return;

  if (typeof options === 'string' || isVNode(options)) {
    options = {
      message: options
    };

    if (typeof arguments[1] === 'string') {
      options.title = arguments[1];
    }

    if (arguments[2]) {
      options.type = arguments[2];
    }
  } else if (options.callback && !callback) {
    callback = options.callback;
  }

  if (typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      // eslint-disable-line
      msgQueue.push({
        options: merge({}, main_defaults, MessageBox.defaults, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      });
      main_showNextMsg();
    });
  } else {
    msgQueue.push({
      options: merge({}, main_defaults, MessageBox.defaults, options),
      callback: callback
    });
    main_showNextMsg();
  }
};

main_MessageBox.setDefaults = function (defaults) {
  main_MessageBox.defaults = defaults;
};

main_MessageBox.alert = function (message, title, options) {
  if (_typeof(title) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }

  return main_MessageBox(merge({
    title: title,
    message: message,
    $type: 'alert'
  }, options));
};

main_MessageBox.confirm = function (title, options) {
  if (_typeof(title) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }

  return main_MessageBox(merge({
    title: title,
    $type: 'confirm',
    type: 'question',
    showCancelButton: true
  }, options));
};

main_MessageBox.prompt = function (message, title, options) {
  if (_typeof(title) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }

  return main_MessageBox(merge({
    title: title,
    message: message,
    showCancelButton: true,
    showInput: true,
    $type: 'prompt'
  }, options));
};

main_MessageBox.close = function () {
  main_instance.doClose();
  main_instance.visible = false;
  msgQueue = [];
  currentMsg = null;
};

/* harmony default export */ var packages_message_box_src_main = (main_MessageBox);

// CONCATENATED MODULE: ./packages/message-box/index.js

/* harmony default export */ var message_box = (packages_message_box_src_main);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=cda05f40&
var breadcrumbvue_type_template_id_cda05f40_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-breadcrumb"},[_vm._t("default")],2)}
var breadcrumbvue_type_template_id_cda05f40_staticRenderFns = []


// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=cda05f40&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&

//
//
//
//
//
/* harmony default export */ var breadcrumbvue_type_script_lang_js_ = ({
  name: 'ElBreadcrumb',
  provide: function provide() {
    return {
      breadcrumb: this
    };
  },
  props: {
    separator: {
      type: String,
      "default": '/'
    },
    separatorClass: {
      type: String,
      "default": 'h-icon-angle_right_sm'
    },
    // 面包屑子项最大宽度
    itemMaxWidth: {
      type: [String, Number],
      "default": null
    }
  }
});
// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_breadcrumbvue_type_script_lang_js_ = (breadcrumbvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue





/* normalize component */

var breadcrumb_component = normalizeComponent(
  src_breadcrumbvue_type_script_lang_js_,
  breadcrumbvue_type_template_id_cda05f40_render,
  breadcrumbvue_type_template_id_cda05f40_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var breadcrumb = (breadcrumb_component.exports);
// CONCATENATED MODULE: ./packages/breadcrumb/index.js


/* istanbul ignore next */

breadcrumb.install = function (Vue) {
  Vue.component(breadcrumb.name, breadcrumb);
};

/* harmony default export */ var packages_breadcrumb = (breadcrumb);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=86f45202&
var breadcrumb_itemvue_type_template_id_86f45202_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'el-breadcrumb__item',
    _vm.to ? '' : 'el-breadcrumb__item__unclickable'
  ]},[(_vm.type === 'dropdown')?_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-start"},on:{"command":_vm.gotoBread}},[_c('el-button',{staticClass:"el-breadcrumb__item__omit",attrs:{"type":"iconButton","icon":"h-icon-more_hori"}}),_c('el-dropdown-menu',{staticClass:"el-breadcrumb__dropdown__menu",attrs:{"slot":"dropdown","type":_vm.type},slot:"dropdown"},[_vm._t("default")],2)],1):(_vm.type === 'tooltip')?_c('el-popover',{attrs:{"placement":"top","trigger":"hover","effect":"light","popper-class":"el-tooltip__contain--breadcrumb"}},[_c('el-button',{staticClass:"el-breadcrumb__item__omit",attrs:{"slot":"reference","type":"iconButton","icon":"h-icon-more_hori"},slot:"reference"}),_c('el-breadcrumb',{attrs:{"item-max-width":_vm.subMaxWidth}},[_vm._t("default")],2)],1):_c('span',{ref:"link",staticClass:"el-breadcrumb__item__inner",style:({ 'max-width': _vm.linkMaxWidth }),attrs:{"title":_vm.linkTitle,"role":"link"}},[_vm._t("default")],2),_c('span',{class:['el-breadcrumb__separator', _vm.separatorClass]},[_vm._v(" "+_vm._s(_vm.separator)+" ")])],1)}
var breadcrumb_itemvue_type_template_id_86f45202_staticRenderFns = []


// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=86f45202&

// EXTERNAL MODULE: external "core-js/modules/es.string.link.js"
var es_string_link_js_ = __webpack_require__("d08f");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var breadcrumb_itemvue_type_script_lang_js_ = ({
  name: 'ElBreadcrumbItem',
  inject: ['breadcrumb'],
  props: {
    to: {
      type: null,
      "default": null
    },
    replace: {
      type: Boolean,
      "default": null
    },
    type: {
      type: String,
      "default": ''
    },
    // 面包屑子项最大宽度
    maxWidth: {
      type: [String, Number],
      "default": null
    },
    // 被收起的面包屑子项最大宽度
    subMaxWidth: {
      type: [String, Number],
      "default": null
    }
  },
  data: function data() {
    return {
      separator: '',
      separatorClass: '',
      ellipsisItems: [],
      linkTitle: ''
    };
  },
  computed: {
    // 子项最大宽度，优先级：自身 maxWidth > 父级 itemMaxWidth
    linkMaxWidth: function linkMaxWidth() {
      if (this.maxWidth) return "".concat(parseInt(this.maxWidth), "px");else if (this.breadcrumb.itemMaxWidth) return "".concat(parseInt(this.breadcrumb.itemMaxWidth), "px");else return null;
    }
  },
  mounted: function mounted() {
    var _this = this;

    // let self = this;
    this.separator = this.breadcrumb.separatorClass.length ? '' : this.breadcrumb.separator;
    this.separatorClass = this.breadcrumb.separatorClass || 'h-icon-angle_right_sm';

    if (this.to) {
      var link = this.$refs.link;
      link.addEventListener('click', function () {
        var to = _this.to,
            $router = _this.$router;
        if (!to || !$router) return;
        _this.replace ? $router.replace(to) : $router.push(to);
      });
    } // 若设置了最大宽度，默认显示 title


    if (this.linkMaxWidth && this.$refs.link) this.linkTitle = this.$refs.link.innerText;
  },
  methods: {
    gotoBread: function gotoBread(to) {
      var $router = this.$router;
      if (!to || !$router) return;
      this.replace ? $router.replace(to) : $router.push(to);
    }
  }
});
// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_breadcrumb_itemvue_type_script_lang_js_ = (breadcrumb_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue





/* normalize component */

var breadcrumb_item_component = normalizeComponent(
  src_breadcrumb_itemvue_type_script_lang_js_,
  breadcrumb_itemvue_type_template_id_86f45202_render,
  breadcrumb_itemvue_type_template_id_86f45202_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var breadcrumb_item = (breadcrumb_item_component.exports);
// CONCATENATED MODULE: ./packages/breadcrumb-item/index.js


/* istanbul ignore next */

breadcrumb_item.install = function (Vue) {
  Vue.component(breadcrumb_item.name, breadcrumb_item);
};

/* harmony default export */ var packages_breadcrumb_item = (breadcrumb_item);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=template&id=6a6ff7f2&
var formvue_type_template_id_6a6ff7f2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"el-form",class:[
    _vm.gridLayout ? 'el-form--grid-layout' : '',
    _vm.labelPosition ? 'el-form--label-' + _vm.labelPosition : '',
    _vm.messagePosition !== 'bottom' ? 'el-form--error-' + _vm.messagePosition : '',
    _vm.textForm ? 'text-form' : '',
    { 'el-form--inline': _vm.inline }
  ]},[_vm._t("default")],2)}
var formvue_type_template_id_6a6ff7f2_staticRenderFns = []


// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=template&id=6a6ff7f2&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=script&lang=js&









//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var formvue_type_script_lang_js_ = ({
  name: 'ElForm',
  componentName: 'ElForm',
  provide: function provide() {
    return {
      elForm: this
    };
  },
  props: {
    model: {
      type: Object,
      "default": null
    },
    rules: {
      type: Object,
      "default": null
    },
    labelPosition: {
      type: String,
      "default": null
    },
    labelWidth: {
      type: String,
      "default": null
    },
    labelSuffix: {
      type: String,
      "default": ''
    },
    inline: {
      type: Boolean,
      "default": null
    },
    showMessage: {
      type: Boolean,
      "default": true
    },
    // 内容区域宽度
    contentWidth: {
      type: String,
      "default": null
    },
    // 错误提示的位置(bottom/right)
    messagePosition: {
      type: String,
      "default": 'bottom'
    },
    // 标签和内容栅格布局
    gridLayout: {
      type: Boolean,
      "default": null
    },
    labelGrid: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    contentGrid: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    // 标签过长是否显示省略号
    labelOverflowTitle: {
      type: Boolean,
      "default": true
    },
    gutter: {
      type: Number,
      "default": null
    },
    textForm: {
      type: Boolean,
      "default": null
    },
    // rules 变化时是否进行校验
    validateOnRuleChange: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      fields: []
    };
  },
  watch: {
    rules: function rules() {
      if (this.validateOnRuleChange) {
        this.validate(function () {});
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$on('el.form.addField', function (field) {
      if (field) {
        _this.fields.push(field);
      }
    });
    /* istanbul ignore next */

    this.$on('el.form.removeField', function (field) {
      if (field.prop) {
        _this.fields.splice(_this.fields.indexOf(field), 1);
      }
    });
  },
  methods: {
    focusFirstField: function focusFirstField() {
      var _iterator = _createForOfIteratorHelper(this.fields),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;

          if (field.validateState === 'error') {
            field.focusField();
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    resetFields: function resetFields() {
      var isEmpty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.model) {
         false && // eslint-disable-next-line
        false;
        return;
      }

      var _iterator2 = _createForOfIteratorHelper(this.fields),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var field = _step2.value;
          field.resetField(isEmpty);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    },
    resetValidates: function resetValidates() {
      if (!this.model) {
         false && false;
        return;
      }

      var _iterator3 = _createForOfIteratorHelper(this.fields),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var field = _step3.value;
          field.resetValidate();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    },
    resetValidate: function resetValidate(prop) {
      if (!this.model) {
         false && false;
        return;
      }

      var field = this.fields.filter(function (field) {
        return field.prop === prop;
      })[0];

      if (!field) {
        throw new Error('must call validateField with valid prop string!');
      }

      field.resetValidate();
    },
    validate: function validate(callback) {
      var _this2 = this;

      if (!this.model) {
        console.warn('[HUI Warn][Form]model is required for validate to work!');
        return;
      }

      var promise; // if no callback, return promise

      if (typeof callback !== 'function' && window.Promise) {
        promise = new window.Promise(function (resolve, reject) {
          callback = function callback(valid) {
            valid ? resolve(valid) : reject(valid);
          };
        });
      }

      var valid = true;
      var count = 0;

      if (this.fields.length === 0 && callback) {
        callback(valid);
      }

      var invalidFields = {};
      this.fields.forEach(function (field) {
        field.validate('', function (message, field) {
          if (message) {
            valid = false;
          }

          invalidFields = merge({}, invalidFields, field);

          if (typeof callback === 'function' && ++count === _this2.fields.length) {
            callback(valid, invalidFields);
          }
        });
      });

      if (promise) {
        return promise;
      }
    },
    validateField: function validateField(prop, cb) {
      var field = this.fields.filter(function (field) {
        return field.prop === prop;
      })[0];

      if (!field) {
        throw new Error('must call validateField with valid prop string!');
      }

      field.validate('', cb);
    }
  }
});
// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_formvue_type_script_lang_js_ = (formvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/form/src/form.vue





/* normalize component */

var form_component = normalizeComponent(
  src_formvue_type_script_lang_js_,
  formvue_type_template_id_6a6ff7f2_render,
  formvue_type_template_id_6a6ff7f2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_form = (form_component.exports);
// CONCATENATED MODULE: ./packages/form/index.js


/* istanbul ignore next */

src_form.install = function (Vue) {
  Vue.component(src_form.name, src_form);
};

/* harmony default export */ var packages_form = (src_form);
// EXTERNAL MODULE: external "async-validator"
var external_async_validator_ = __webpack_require__("3ee4");
var external_async_validator_default = /*#__PURE__*/__webpack_require__.n(external_async_validator_);

// CONCATENATED MODULE: ./packages/col/src/col.js






/* harmony default export */ var src_col = ({
  name: 'ElCol',
  props: {
    span: {
      type: Number,
      "default": 24
    },
    tag: {
      type: String,
      "default": 'div'
    },
    offset: Number,
    pull: Number,
    push: Number,
    xs: [Number, Object],
    sm: [Number, Object],
    md: [Number, Object],
    lg: [Number, Object],
    xl: [Number, Object]
  },
  computed: {
    gutter: function gutter() {
      var parent = this.$parent;

      while (parent && parent.$options.componentName !== 'ElRow') {
        parent = parent.$parent;
      }

      return parent ? parent.gutter : 0;
    }
  },
  render: function render(h) {
    var _this = this;

    var classList = [];
    var style = {};

    if (this.gutter) {
      style.paddingLeft = this.gutter / 2 + 'px';
      style.paddingRight = style.paddingLeft;
    }

    ['span', 'offset', 'pull', 'push'].forEach(function (prop) {
      if (_this[prop]) {
        classList.push(prop !== 'span' ? "el-col-".concat(prop, "-").concat(_this[prop]) : "el-col-".concat(_this[prop]));
      }
    });
    ['xs', 'sm', 'md', 'lg', 'xl'].forEach(function (size) {
      if (typeof _this[size] === 'number') {
        classList.push("el-col-".concat(size, "-").concat(_this[size]));
      } else if (_typeof(_this[size]) === 'object') {
        var props = _this[size];
        Object.keys(props).forEach(function (prop) {
          classList.push(prop !== 'span' ? "el-col-".concat(size, "-").concat(prop, "-").concat(props[prop]) : "el-col-".concat(size, "-").concat(props[prop]));
        });
      }
    });
    return h(this.tag, {
      "class": ['el-col', classList],
      style: style
    }, this.$slots["default"]);
  }
});
// CONCATENATED MODULE: ./packages/col/index.js


/* istanbul ignore next */

src_col.install = function (Vue) {
  Vue.component(src_col.name, src_col);
};

/* harmony default export */ var packages_col = (src_col);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=script&lang=js&




















/* harmony default export */ var form_itemvue_type_script_lang_js_ = ({
  name: 'ElFormItem',
  componentName: 'ElFormItem',
  inject: ['elForm'],
  components: {
    ElTooltip: packages_tooltip,
    ElCol: packages_col
  },
  mixins: [emitter],
  props: {
    label: {
      type: String,
      "default": ''
    },
    labelWidth: {
      type: String,
      "default": null
    },
    prop: {
      type: String,
      "default": null
    },
    required: {
      type: Boolean,
      "default": undefined
    },
    // 必填选项显示在文字右侧
    requiredRight: {
      type: Boolean
    },
    rules: {
      type: [Object, Array],
      "default": null
    },
    error: {
      type: String,
      "default": null
    },
    validateStatus: {
      type: String,
      "default": null
    },
    showMessage: {
      type: Boolean,
      "default": true
    },
    description: {
      type: String,
      "default": ''
    },
    descriptionRender: {
      type: Function,
      "default": null
    },
    // 内容区域宽度(会覆盖父组件的 contentWidth)
    contentWidth: {
      type: String,
      "default": null
    },
    introduction: {
      type: String,
      "default": ''
    },
    introductionIcon: {
      type: String,
      "default": 'h-icon-help'
    },
    introductionPlacement: {
      type: String,
      "default": 'bottom'
    },
    introductionClass: {
      type: String,
      "default": ''
    },
    itemGroup: {
      type: Boolean,
      "default": false
    },
    labelGrid: {
      type: Object,
      "default": null
    },
    contentGrid: {
      type: Object,
      "default": null
    },
    // 标签过长是否显示省略号
    labelOverflowTitle: {
      type: Boolean,
      "default": true
    },
    // 禁用时，将不再显示必填标识
    disabled: {
      type: Boolean,
      "default": false
    },
    beforeValidate: {
      type: Function,
      "default": null
    },
    showEllipsis: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      validateState: '',
      validateMessage: '',
      validateDisabled: false,
      validator: {},
      // 标签过长时显示的title
      labelTitle: ''
    };
  },
  computed: {
    // 表单项 style 样式
    itemStyle: function itemStyle() {
      var ret = {};
      var defaultGutter = 20; // 默认间距为20px

      if (!this.form.gutter) return ret;
      ret.marginBottom = this.validateState !== 'error' ? "".concat(this.form.gutter, "px") : "".concat(this.form.gutter - defaultGutter, "px");
      return ret;
    },
    labelStyle: function labelStyle() {
      var ret = {}; // 设置标签在上方或者栅格布局，label-width 将失效

      if (this.form.labelPosition === 'top' || this.form.gridLayout) return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;

      if (labelWidth) {
        ret.width = labelWidth;
      }

      return ret;
    },
    labelTextStyle: function labelTextStyle() {
      var ret = {};
      var width = 0; // 表单项必填时，高亮红星占9px

      if (this.isRequired() || this.required || this.requiredRight) width += 9; // 有介绍信息时，图标占26px

      if (this.introduction) width += 26;
      if (width) ret.maxWidth = "calc(100% - ".concat(width, "px)");
      return ret;
    },
    contentStyle: function contentStyle() {
      var ret = {}; // 设置栅格布局，content-width 将失效

      if (this.form.gridLayout) return ret;
      var label = this.label;
      var contentWidth = this.contentWidth || this.form.contentWidth;

      if (contentWidth) {
        ret.width = contentWidth;
      }

      if (this.form.labelPosition === 'top' || this.form.inline) return ret;
      if (!label && !this.labelWidth && this.isNested) return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;

      if (labelWidth) {
        ret.marginLeft = labelWidth;
      }

      return ret;
    },
    // 错误信息的样式
    errorStyle: function errorStyle() {
      var ret = {};
      var labelWidth = this.labelWidth || this.form.labelWidth;
      var contentWidth = this.contentWidth || this.form.contentWidth;
      var label = this.label; // 判断错误信息出现在底部还是右侧

      if (this.form.messagePosition === 'right') {
        ret.position = 'absolute';

        if (!label && !this.labelWidth && this.isNested) {
          ret.left = parseInt(contentWidth, 10) + 8 + 'px';
        } else {
          ret.left = parseInt(labelWidth, 10) + parseInt(contentWidth, 10) + 8 + 'px';
        } // 错误信息出现在右侧时，top值设置6px


        ret.top = '6px';
      } else {// if (!label && !this.labelWidth && this.isNested) {
        //   ret.left = '0';
        // } else {
        //   ret.left = labelWidth;
        // }
      }

      return ret;
    },
    _labelGrid: function _labelGrid() {
      return this.labelGrid || this.form.labelGrid;
    },
    _contentGrid: function _contentGrid() {
      return this.contentGrid || this.form.contentGrid;
    },
    _labelOverflowTitle: function _labelOverflowTitle() {
      if (!this.labelOverflowTitle) return false;
      return this.form.labelOverflowTitle;
    },
    // 是否是嵌套的item
    isNested: function isNested() {
      var parent = this.$parent;
      var parentName = parent.$options.componentName;

      while (parentName !== 'ElFormItem') {
        parent = parent.$parent;
        if (!parent || !parent.$options) break;
        parentName = parent.$options.componentName;
      }

      if (parentName === 'ElFormItem') return true;else return false;
    },
    form: function form() {
      var parent = this.$parent;
      var parentName = parent.$options.componentName;

      while (parentName !== 'ElForm') {
        parent = parent.$parent;
        parentName = parent.$options.componentName;
      }

      return parent;
    },
    fieldValue: {
      cache: false,
      get: function get() {
        var model = this.form.model;

        if (!model || !this.prop) {
          return;
        }

        var path = this.prop;

        if (path.indexOf(':') !== -1) {
          path = path.replace(/:/, '.');
        }

        return getPropByPath(model, path, true).v;
      }
    }
  },
  watch: {
    error: function error(value) {
      this.validateMessage = value;
      this.validateState = value ? 'error' : '';
    },
    validateStatus: function validateStatus(value) {
      this.validateState = value;
    }
  },
  mounted: function mounted() {
    if (this.prop) {
      this.dispatch('ElForm', 'el.form.addField', [this]);
      var initialValue = this.fieldValue;

      if (Array.isArray(initialValue)) {
        initialValue = [].concat(initialValue);
      }

      Object.defineProperty(this, 'initialValue', {
        value: initialValue
      });
      var rules = this.getRules();

      if (rules.length || this.required !== undefined) {
        this.$on('el.form.blur', this.onFieldBlur);
        this.$on('el.form.change', this.onFieldChange);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('ElForm', 'el.form.removeField', [this]);
  },
  methods: {
    isRequired: function isRequired() {
      var rules = this.getRules();
      var isRequired = false;

      if (rules && rules.length) {
        rules.every(function (rule) {
          if (rule.required) {
            isRequired = true;
            return false;
          }

          return true;
        });
      }

      return isRequired;
    },
    focusField: function focusField() {
      var elInput = findComponentsDownward(this, 'ElInput')[0];

      if (elInput) {
        elInput.$el.querySelector('input') && elInput.$el.querySelector('input').focus();
        elInput.$el.querySelector('textarea') && elInput.$el.querySelector('textarea').focus();
      }
    },
    validate: function validate(trigger) {
      var _this = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      this.validateDisabled = false;
      var rules = this.getFilteredRule(trigger);

      if ((!rules || rules.length === 0) && this.required === undefined) {
        callback();
        return true;
      }

      var todo = function todo() {
        _this.validateState = 'validating';
        var descriptor = {};
        descriptor[_this.prop] = rules;
        var validator = new external_async_validator_default.a(descriptor);
        var model = {}; // 获取所有字段的值

        var _iterator = _createForOfIteratorHelper(_this.form.fields),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var field = _step.value;
            model[field.prop] = field.fieldValue;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        validator.validate(model, {
          firstFields: true
        }, function (errors, invalidFields) {
          _this.validateState = !errors ? 'success' : 'error';
          _this.validateMessage = errors ? errors[0].message : '';
          callback(_this.validateMessage, invalidFields);
          _this.elForm && _this.elForm.$emit('validate', _this.prop, !errors);
        });
      };

      if (this.beforeValidate) {
        var result = this.beforeValidate(this.fieldValue, rules);
        if (result === false) return;
        if (result === undefined) result = true;
        Promise.resolve(result).then(function (allowed) {
          if (allowed) {
            todo();
          }
        });
      } else {
        todo();
      }
    },
    resetField: function resetField() {
      var isEmpty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.validateState = '';
      this.validateMessage = '';
      var model = this.form.model;
      var value = this.fieldValue;
      var path = this.prop;

      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.');
      }

      var prop = getPropByPath(model, path, true);

      if (Array.isArray(value)) {
        this.validateDisabled = true;
        prop.o[prop.k] = isEmpty ? [] : [].concat(this.initialValue);
      } else {
        this.validateDisabled = true;
        prop.o[prop.k] = isEmpty ? '' : this.initialValue;
      }
    },
    resetValidate: function resetValidate() {
      this.validateState = '';
      this.validateMessage = '';
      this.validateDisabled = false;
    },
    getRules: function getRules() {
      var formRules = this.form.rules;
      var selfRules = this.rules;
      var requiredRule = this.required !== undefined ? {
        required: !!this.required
      } : [];
      formRules = formRules ? formRules[this.prop] : [];
      return [].concat(selfRules || formRules || []).concat(requiredRule);
    },
    getFilteredRule: function getFilteredRule(trigger) {
      var rules = this.getRules();
      return rules.filter(function (rule) {
        return !rule.trigger || rule.trigger.indexOf(trigger) !== -1;
      });
    },
    onFieldBlur: function onFieldBlur() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.validate('blur');
      });
    },
    onFieldChange: function onFieldChange() {
      var _this3 = this;

      if (this.validateDisabled) {
        this.validateDisabled = false;
        return;
      }

      this.$nextTick(function () {
        _this3.validate('change');
      });
    },
    hoverLabel: function hoverLabel() {
      var t = this.$refs.formLabelText;
      this.labelTitle = t.clientWidth < t.scrollWidth ? t.innerText : '';
    },

    /**
     * @desc 获取 content 的断点
     * @param {String} grid 断点值，如xs、sm、md、lg、xl
     */
    getContentGrid: function getContentGrid(grid) {
      if (!this._contentGrid[grid]) return;
      var result = typeof this._contentGrid[grid] === 'number' ? {
        span: this._contentGrid[grid],
        offset: this._labelGrid[grid]
      } : this._contentGrid[grid];
      return result;
    }
  },
  render: function render(h) {
    var labelCls = {
      'el-form-item__label': true,
      'text-wrap': !this._labelOverflowTitle // 若设置文字超长不显示省略号

    }; // 表格标签：label

    var labelElm = h("label", {
      "attrs": {
        "for": this.prop,
        "title": this.labelTitle
      },
      "class": labelCls,
      "style": this.labelStyle,
      "on": {
        "mouseenter": this.hoverLabel
      }
    }, [h("i", {
      "class": 'el-form-item__required'
    }, ["*"]), h("span", {
      "ref": 'formLabelText',
      "class": 'el-form-item__label-text',
      "style": this.labelTextStyle
    }, [this.$slots.label || this.label + this.form.labelSuffix]), h("i", {
      "class": 'el-form-item__required-right'
    }, ["*"])]); // 介绍文字

    var introElm = h("el-tooltip", {
      "attrs": {
        "content": this.$slots.introduction ? '' : this.introduction,
        "placement": this.introductionPlacement,
        "popper-class": this.introductionClass
      }
    }, [h("template", {
      "slot": 'content'
    }, [this.$slots.introduction]), h("i", {
      "class": ['el-form-item__introduction', this.introductionIcon]
    })]);

    if (this.introduction !== '' || this.$slots.introduction) {
      this.form.labelPosition === 'top' ? labelElm.children.push(introElm) : labelElm.children.splice(0, 0, introElm);
    } // 表格内容：content


    var contentElm = h("div", {
      "class": 'el-form-item__content',
      "style": this.contentStyle
    }, [this.$slots["default"]]);
    var errorCls = {
      'el-form-item__error': true,
      'el-form-item__ellipsis': this.showEllipsis
    }; // 错误信息

    var errorElm = h("transition", {
      "attrs": {
        "name": 'form-error-zoom'
      }
    }, [h("div", {
      "attrs": {
        "title": this.showEllipsis ? this.validateMessage : ''
      },
      "class": errorCls,
      "style": this.errorStyle
    }, [this.validateMessage])]);

    if (this.validateState === 'error' && this.showMessage && this.form.showMessage) {
      contentElm.children.push(errorElm);
    } // 描述信息


    var descElm = h("div", {
      "class": 'el-form-item__description'
    });

    if (this.description !== '') {
      descElm.children = [h("span", [this.description])];
      contentElm.children.push(descElm);
    }

    if (this.descriptionRender) {
      descElm.children = [this.descriptionRender.call(this._renderProxy, h)];
      contentElm.children.push(descElm);
    } // 使用栅格布局


    if (this.form.gridLayout) {
      labelElm = h("el-col", {
        "attrs": {
          "xs": this._labelGrid.xs,
          "sm": this._labelGrid.sm,
          "md": this._labelGrid.md,
          "lg": this._labelGrid.lg,
          "xl": this._labelGrid.xl
        }
      }, [labelElm]); // 没有 label，则内容进行偏移

      contentElm = this.$slots.label || this.label ? h("el-col", {
        "attrs": {
          "xs": this._contentGrid.xs,
          "sm": this._contentGrid.sm,
          "md": this._contentGrid.md,
          "lg": this._contentGrid.lg,
          "xl": this._contentGrid.xl
        }
      }, [contentElm]) : h("el-col", {
        "attrs": {
          "xs": this.getContentGrid('xs'),
          "sm": this.getContentGrid('sm'),
          "md": this.getContentGrid('md'),
          "lg": this.getContentGrid('lg'),
          "xl": this.getContentGrid('xl')
        }
      }, [contentElm]);
    }

    var cls = {
      'el-form-item': true,
      'is-item-group': this.itemGroup,
      'is-error': this.validateState === 'error',
      'is-validating': this.validateState === 'validating',
      'is-required': (this.isRequired() || this.required) && // 后续默认定规定位置，考虑把requiredRight属性移除
      !this.requiredRight && this.form.labelPosition !== 'top' && !this.disabled,
      'is-required-right': (this.isRequired() || this.required) && (this.requiredRight || this.form.labelPosition === 'top') && !this.disabled,
      'has-introduction': this.introduction !== '',
      'has-description': this.description !== '' || this.descriptionRender
    };
    return this.label || this.$slots.label ? h("div", {
      "class": cls,
      "style": this.itemStyle
    }, [labelElm, contentElm]) : h("div", {
      "class": cls,
      "style": this.itemStyle
    }, [contentElm]);
  }
});
// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_form_itemvue_type_script_lang_js_ = (form_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/form/src/form-item.vue
var form_item_render, form_item_staticRenderFns




/* normalize component */

var form_item_component = normalizeComponent(
  src_form_itemvue_type_script_lang_js_,
  form_item_render,
  form_item_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var form_item = (form_item_component.exports);
// CONCATENATED MODULE: ./packages/form-item/index.js


/* istanbul ignore next */

form_item.install = function (Vue) {
  Vue.component(form_item.name, form_item);
};

/* harmony default export */ var packages_form_item = (form_item);
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// EXTERNAL MODULE: external "@vue/babel-helper-vue-jsx-merge-props"
var babel_helper_vue_jsx_merge_props_ = __webpack_require__("5a5e");
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=template&id=54a01e74&
var tab_barvue_type_template_id_54a01e74_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-tabs__active-bar",class:("is-" + (_vm.rootTabs.tabPosition)),style:(_vm.barStyle)})}
var tab_barvue_type_template_id_54a01e74_staticRenderFns = []


// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=template&id=54a01e74&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//

/* harmony default export */ var tab_barvue_type_script_lang_js_ = ({
  name: 'TabBar',
  props: {
    tabs: {
      type: Array,
      "default": function _default() {
        return [];
      }
    }
  },
  inject: ['rootTabs'],
  computed: {
    barStyle: {
      get: function get() {
        var _this = this;

        var style = {};
        var offset = 0;
        var tabSize = 0;
        var sizeName = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
        var sizeDir = sizeName === 'width' ? 'x' : 'y';

        var firstUpperCase = function firstUpperCase(str) {
          return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
            return L.toUpperCase();
          });
        }; // 此处取走了index, 因下面的语句块并未使用到Index


        this.tabs.every(function (tab) {
          var $el = arrayFind(_this.$parent.$refs.tabs || [], function (t) {
            return t.id.replace('tab-', '') === tab.paneName;
          });

          if (!$el) {
            return false;
          }

          if (!tab.active) {
            offset += $el["client".concat(firstUpperCase(sizeName))];
            return true;
          } else {
            tabSize = $el["client".concat(firstUpperCase(sizeName))]; // if (sizeName === 'width' && this.tabs.length > 1) {
            //   tabSize -= index === 0 || index === this.tabs.length - 1 ? 0 : 24;
            // }

            return false;
          }
        });

        if (sizeName === 'width' && offset !== 0) {// offset += 24;
        }

        var transform = "translate".concat(firstUpperCase(sizeDir), "(").concat(offset, "px)");
        style[sizeName] = tabSize + 'px';
        style.transform = transform;
        style.msTransform = transform;
        style.webkitTransform = transform;
        return style;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tab_barvue_type_script_lang_js_ = (tab_barvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue





/* normalize component */

var tab_bar_component = normalizeComponent(
  src_tab_barvue_type_script_lang_js_,
  tab_barvue_type_template_id_54a01e74_render,
  tab_barvue_type_template_id_54a01e74_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tab_bar = (tab_bar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&











function tab_navvue_type_script_lang_js_noop() {}

var tab_navvue_type_script_lang_js_firstUpperCase = function firstUpperCase(str) {
  return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
    return L.toUpperCase();
  });
};

/* harmony default export */ var tab_navvue_type_script_lang_js_ = ({
  name: 'TabNav',
  components: {
    TabBar: tab_bar
  },
  inject: ['rootTabs'],
  props: {
    panes: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    currentName: {
      type: String,
      "default": ''
    },
    editable: {
      type: Boolean,
      "default": null
    },
    onTabClick: {
      type: Function,
      "default": tab_navvue_type_script_lang_js_noop
    },
    onScrollStatusChange: {
      type: Function,
      "default": tab_navvue_type_script_lang_js_noop
    },
    onTabRemove: {
      type: Function,
      "default": tab_navvue_type_script_lang_js_noop
    },
    type: {
      type: String,
      "default": ''
    },
    stretch: {
      type: Boolean,
      "default": null
    },
    labelMaxWidth: {
      type: Number,
      "default": 192
    },
    fixWidth: {
      type: Number,
      "default": null
    }
  },
  data: function data() {
    return {
      scrollable: true,
      navOffset: 0,
      isFocus: false,
      focusable: true,
      scrollableNext: false,
      scrollablePrev: false
    };
  },
  computed: {
    navStyle: function navStyle() {
      var dir = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'X' : 'Y';
      return {
        transform: "translate".concat(dir, "(-").concat(this.navOffset, "px)")
      };
    },
    sizeName: function sizeName() {
      return ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
    }
  },
  watch: {
    scrollable: function scrollable(value) {
      this.onScrollStatusChange(!!value);
    }
  },
  updated: function updated() {
    this.update();
  },
  mounted: function mounted() {
    var _this = this;

    resize_event_addResizeListener(this.$el, this.update);
    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    window.addEventListener('blur', this.windowBlurHandler);
    window.addEventListener('focus', this.windowFocusHandler);
    setTimeout(function () {
      _this.scrollToActiveTab();
    }, 0);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el && this.update) removeResizeListener(this.$el, this.update);
    document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
    window.removeEventListener('blur', this.windowBlurHandler);
    window.removeEventListener('focus', this.windowFocusHandler);
  },
  methods: {
    scrollPrev: function scrollPrev() {
      var containerSize = this.$refs.navScroll["offset".concat(tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName))];
      var currentOffset = this.navOffset;

      if (!currentOffset) {
        this.scrollable && this.scrollablePrev && this.$nextTick(function () {
          this.scrollablePrev = false;
          this.$set(this.scrollable, 'prev', false);
        });
        return;
      }

      var newOffset = currentOffset > containerSize ? currentOffset - containerSize : 0;
      this.navOffset = newOffset;
    },
    scrollNext: function scrollNext() {
      var navSize = this.$refs.nav["offset".concat(tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName))];
      var containerSize = this.$refs.navScroll["offset".concat(tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName))];
      var currentOffset = this.navOffset;

      if (navSize - currentOffset <= containerSize) {
        this.scrollable && this.scrollableNext && this.$nextTick(function () {
          this.scrollableNext = false;
          this.$set(this.scrollable, 'next', false);
        });
        return;
      }

      var newOffset = navSize - currentOffset > containerSize * 2 ? currentOffset + containerSize : navSize - containerSize;
      this.navOffset = newOffset;
    },
    scrollToActiveTab: function scrollToActiveTab() {
      if (!this.scrollable) return;
      var nav = this.$refs.nav;
      var activeTab = this.$el.querySelector('.is-active');
      if (!activeTab) return;
      var navScroll = this.$refs.navScroll;
      var isHorizontal = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1;
      var activeTabBounding = activeTab.getBoundingClientRect();
      var navScrollBounding = navScroll.getBoundingClientRect();
      var maxOffset = isHorizontal ? nav.offsetWidth - navScrollBounding.width : nav.offsetHeight - navScrollBounding.height;
      var currentOffset = this.navOffset;
      var newOffset = currentOffset;

      if (isHorizontal) {
        if (activeTabBounding.left < navScrollBounding.left) {
          newOffset = currentOffset - (navScrollBounding.left - activeTabBounding.left);
        }

        if (activeTabBounding.right > navScrollBounding.right) {
          newOffset = currentOffset + activeTabBounding.right - navScrollBounding.right;
        }
      } else {
        if (activeTabBounding.top < navScrollBounding.top) {
          newOffset = currentOffset - (navScrollBounding.top - activeTabBounding.top);
        }

        if (activeTabBounding.bottom > navScrollBounding.bottom) {
          newOffset = currentOffset + (activeTabBounding.bottom - navScrollBounding.bottom);
        }
      }

      newOffset = Math.max(newOffset, 0);
      this.navOffset = Math.min(newOffset, maxOffset);
    },
    update: function update() {
      if (!this.$refs.nav) return;
      var sizeName = this.sizeName;
      var navSize = this.$refs.nav["offset".concat(tab_navvue_type_script_lang_js_firstUpperCase(sizeName))];
      var containerSize = this.$refs.navScroll["offset".concat(tab_navvue_type_script_lang_js_firstUpperCase(sizeName))];
      var currentOffset = this.navOffset; // 出现滚动条就加入双向箭头

      if (containerSize < navSize) {
        var _currentOffset = this.navOffset;
        this.scrollable = this.scrollable || {};
        this.scrollablePrev = _currentOffset;
        this.scrollableNext = _currentOffset + containerSize < navSize;

        if (navSize - _currentOffset < containerSize) {
          this.navOffset = navSize - containerSize;
        }
      } else {
        this.scrollable = false;

        if (currentOffset > 0) {
          this.navOffset = 0;
        }
      }
    },
    changeTab: function changeTab(e) {
      var keyCode = e.keyCode;
      var nextIndex;
      var currentIndex, tabList;

      if ([37, 38, 39, 40].indexOf(keyCode) !== -1) {
        // 左右上下键更换tab
        tabList = e.currentTarget.querySelectorAll('[role=tab]');
        currentIndex = Array.prototype.indexOf.call(tabList, e.target);
      } else {
        return;
      }

      if (keyCode === 37 || keyCode === 38) {
        // left
        if (currentIndex === 0) {
          // first
          nextIndex = tabList.length - 1;
        } else {
          nextIndex = currentIndex - 1;
        }
      } else {
        // right
        if (currentIndex < tabList.length - 1) {
          // not last
          nextIndex = currentIndex + 1;
        } else {
          nextIndex = 0;
        }
      }

      tabList[nextIndex].focus(); // 改变焦点元素

      tabList[nextIndex].click(); // 选中下一个tab

      this.setFocus();
    },
    setFocus: function setFocus() {
      if (this.focusable) {
        this.isFocus = true;
      }
    },
    removeFocus: function removeFocus() {
      this.isFocus = false;
    },
    visibilityChangeHandler: function visibilityChangeHandler() {
      var _this2 = this;

      var visibility = document.visibilityState;

      if (visibility === 'hidden') {
        this.focusable = false;
      } else if (visibility === 'visible') {
        setTimeout(function () {
          _this2.focusable = true;
        }, 50);
      }
    },
    windowBlurHandler: function windowBlurHandler() {
      this.focusable = false;
    },
    windowFocusHandler: function windowFocusHandler() {
      var _this3 = this;

      setTimeout(function () {
        _this3.focusable = true;
      }, 50);
    }
  },
  render: function render() {
    var _this4 = this;

    var h = arguments[0];
    var type = this.type,
        panes = this.panes,
        editable = this.editable,
        stretch = this.stretch,
        onTabClick = this.onTabClick,
        onTabRemove = this.onTabRemove,
        navStyle = this.navStyle,
        scrollable = this.scrollable,
        scrollableNext = this.scrollableNext,
        scrollablePrev = this.scrollablePrev,
        scrollNext = this.scrollNext,
        scrollPrev = this.scrollPrev,
        changeTab = this.changeTab,
        setFocus = this.setFocus,
        removeFocus = this.removeFocus;
    var scrollBtn = scrollable ? [// <span
    //   class={['el-tabs__nav-prev', scrollable.prev ? '' : 'is-disabled']}
    //   on-click={scrollPrev}
    // >
    //   <i class="h-icon-angle_left" />
    // </span>
    h("div", {
      "class": 'el-tabs__nav-prev'
    }, [h("el-button", {
      "attrs": {
        "type": 'iconButton',
        "icon": this.rootTabs.tabPosition.indexOf('o') > 0 ? 'h-icon-angle_left' : 'h-icon-angle_up',
        "disabled": !scrollablePrev
      },
      "on": {
        "click": scrollPrev
      }
    })]), h("div", {
      "class": 'el-tabs__nav-next'
    }, [h("el-button", {
      "attrs": {
        "type": 'iconButton',
        "icon": this.rootTabs.tabPosition.indexOf('o') > 0 ? 'h-icon-angle_right' : 'h-icon-angle_down',
        "disabled": !scrollableNext
      },
      "on": {
        "click": scrollNext
      }
    })]) // <span
    //   class={['el-tabs__nav-next', scrollable.next ? '' : 'is-disabled']}
    //   on-click={scrollNext}
    // >
    //   <i class="h-icon-angle_right" />
    // </span>
    ] : null;
    var notTheOnlyOne = panes.length !== 1;

    var tabs = this._l(panes, function (pane, index) {
      var _ref;

      var tabName = pane.name || pane.index || index;
      var closable = pane.isClosable || editable;
      pane.index = "".concat(index);
      var btnClose = closable && notTheOnlyOne ? h("el-button", {
        "attrs": {
          "icon": 'h-icon-close_sm'
        },
        "on": {
          "click": function click(ev) {
            onTabRemove(pane, ev);
          }
        }
      }) : null;
      var fixWidth = _this4.fixWidth;
      var labelMaxWidth = pane.labelMaxWidth || _this4.labelMaxWidth;
      var tabSpanStyle = closable && notTheOnlyOne ? "max-width: ".concat(fixWidth ? fixWidth - 50 : labelMaxWidth && labelMaxWidth - 50, "px;overflow: hidden;display: inline-block;vertical-align: middle;text-overflow: ellipsis;white-space: nowrap;") : '';
      var tabLabelContent = pane.labelIcon ? h("i", {
        "class": ['el-tabs__item--icon', pane.labelIcon]
      }) : h("span", {
        "style": tabSpanStyle,
        "attrs": {
          "title": pane.label
        }
      }, [pane.$slots.label || pane.label]);
      var tabindex = pane.active ? 0 : -1;
      return h("div", {
        "class": (_ref = {
          'el-tabs__item': true
        }, _defineProperty(_ref, "is-".concat(_this4.rootTabs.tabPosition), true), _defineProperty(_ref, 'is-active', pane.active), _defineProperty(_ref, 'is-disabled', pane.disabled), _defineProperty(_ref, 'is-closable', closable && notTheOnlyOne), _defineProperty(_ref, 'is-focus', _this4.isFocus), _ref),
        "attrs": {
          "id": "tab-".concat(tabName),
          "aria-controls": "pane-".concat(tabName),
          "role": 'tab',
          "aria-selected": pane.active,
          "tabindex": tabindex
        },
        "key": "tab-".concat(tabName),
        "ref": 'tabs',
        "refInFor": true,
        "style": {
          'min-width': fixWidth && "".concat(fixWidth, "px"),
          'max-width': fixWidth ? "".concat(fixWidth, "px") : labelMaxWidth && "".concat(labelMaxWidth, "px")
        },
        "on": {
          "focus": function focus() {
            setFocus();
          },
          "blur": function blur() {
            removeFocus();
          },
          "click": function click(ev) {
            removeFocus();
            onTabClick(pane, tabName, ev);
          },
          "keydown": function keydown(ev) {
            if (closable && (ev.keyCode === 46 || ev.keyCode === 8)) {
              onTabRemove(pane, ev);
            }
          }
        }
      }, [tabLabelContent, btnClose]);
    });

    return h("div", {
      "class": ['el-tabs__nav-wrap', scrollable ? 'is-scrollable' : '', "is-".concat(this.rootTabs.tabPosition)]
    }, [scrollBtn, h("div", {
      "class": ['el-tabs__nav-scroll'],
      "ref": 'navScroll'
    }, [h("div", {
      "class": ['el-tabs__nav', "is-".concat(this.rootTabs.tabPosition), stretch && ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'is-stretch' : ''],
      "ref": 'nav',
      "style": navStyle,
      "attrs": {
        "role": 'tablist'
      },
      "on": {
        "keydown": changeTab
      }
    }, [!type ? h("tab-bar", {
      "attrs": {
        "tabs": panes
      }
    }) : null, tabs])])]);
  }
});
// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tab_navvue_type_script_lang_js_ = (tab_navvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue
var tab_nav_render, tab_nav_staticRenderFns




/* normalize component */

var tab_nav_component = normalizeComponent(
  src_tab_navvue_type_script_lang_js_,
  tab_nav_render,
  tab_nav_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tab_nav = (tab_nav_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tabs.vue?vue&type=script&lang=js&









/* harmony default export */ var tabsvue_type_script_lang_js_ = ({
  name: 'ElTabs',
  components: {
    TabNav: tab_nav
  },
  props: {
    type: {
      type: String,
      "default": ''
    },
    activeName: {
      type: String,
      "default": ''
    },
    closable: {
      type: Boolean,
      "default": null
    },
    addable: {
      type: Boolean,
      "default": null
    },
    value: {
      type: String,
      "default": ''
    },
    editable: {
      type: Boolean,
      "default": null
    },
    tabPosition: {
      type: String,
      "default": 'top'
    },
    beforeLeave: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    },
    beforeRemove: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    },
    stretch: {
      type: Boolean,
      "default": null
    },
    labelMaxWidth: {
      type: Number,
      "default": 192
    },
    fixWidth: {
      type: Number,
      "default": null
    },
    size: {
      type: String,
      "default": 'medium'
    }
  },
  provide: function provide() {
    return {
      rootTabs: this
    };
  },
  data: function data() {
    return {
      currentName: this.value || this.activeName,
      panes: [],
      isButtonGroup: false
    };
  },
  watch: {
    activeName: function activeName(value) {
      this.setCurrentName(value);
    },
    value: function value(_value) {
      this.setCurrentName(_value);
    },
    currentName: function currentName() {
      var _this = this;

      if (this.$refs.nav) {
        this.$nextTick(function () {
          _this.$refs.nav.$nextTick(function () {
            _this.scrollToActiveTab();
          });
        });
      }
    }
  },
  created: function created() {
    if (!this.currentName) {
      this.setCurrentName('0');
    }

    this.$on('tab-nav-update', this.calcPaneInstances.bind(null, true));
  },
  mounted: function mounted() {
    this.calcPaneInstances();
  },
  updated: function updated() {
    this.calcPaneInstances();
  },
  methods: {
    calcPaneInstances: function calcPaneInstances() {
      var _this2 = this;

      var isForceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.$slots["default"]) {
        var paneSlots = this.$slots["default"].filter(function (vnode) {
          return vnode.tag && vnode.componentOptions && vnode.componentOptions.Ctor.options.name === 'ElTabPane';
        }); // update indeed

        var panes = paneSlots.map(function (_ref) {
          var componentInstance = _ref.componentInstance;
          return componentInstance;
        });
        var panesChanged = !(panes.length === this.panes.length && panes.every(function (pane, index) {
          return pane === _this2.panes[index];
        }));

        if (isForceUpdate || panesChanged) {
          this.panes = panes;
        }
      } else if (this.panes.length !== 0) {
        this.panes = [];
      }
    },
    handleTabClick: function handleTabClick(tab, tabName, event) {
      var _this3 = this;

      if (tab.disabled) return;
      this.setCurrentName(tabName, function () {
        _this3.$emit('tab-click', tab, event);
      });
    },
    handleTabRemove: function handleTabRemove(pane, ev) {
      var _this4 = this;

      if (pane.disabled) return;
      ev.stopPropagation();

      var hdRemove = function hdRemove() {
        _this4.$emit('edit', pane.name, 'remove');

        _this4.$emit('tab-remove', pane.name);
      };

      var before = this.beforeRemove(pane.name);

      if (before && before.then) {
        before.then(function () {
          hdRemove();
        });
      } else {
        hdRemove();
      }
    },
    handleTabAdd: function handleTabAdd() {
      this.$emit('edit', null, 'add');
      this.$emit('tab-add');
    },
    setCurrentName: function setCurrentName(value, cb) {
      var _this5 = this;

      var changeCurrentName = function changeCurrentName() {
        _this5.currentName = value;

        _this5.$emit('input', value);

        cb && cb();
      };

      if (this.currentName !== value && this.beforeLeave) {
        var before = this.beforeLeave(value, this.currentName);

        if (before && before.then) {
          before.then(function () {
            changeCurrentName();
            _this5.$refs.nav && _this5.$refs.nav.removeFocus();
          });
        } else if (before !== false) {
          changeCurrentName();
        }
      } else {
        changeCurrentName();
      }
    },
    scrollChange: function scrollChange(value) {
      this.isButtonGroup = value;
    },
    scrollToActiveTab: function scrollToActiveTab() {
      this.$refs.nav.scrollToActiveTab();
    }
  },
  render: function render() {
    var _ref2;

    var h = arguments[0];
    var type = this.type,
        handleTabClick = this.handleTabClick,
        handleTabRemove = this.handleTabRemove,
        handleTabAdd = this.handleTabAdd,
        currentName = this.currentName,
        panes = this.panes,
        editable = this.editable,
        addable = this.addable,
        tabPosition = this.tabPosition,
        size = this.size,
        stretch = this.stretch,
        labelMaxWidth = this.labelMaxWidth,
        fixWidth = this.fixWidth,
        scrollChange = this.scrollChange;
    var newButton = editable || addable ? // <span
    // class="el-tabs__new-tab"
    // on-click={handleTabAdd}
    // tabindex="0"
    // on-keydown={ev => {
    //   if (ev.keyCode === 13) {
    //     handleTabAdd();
    //   }
    // }}
    // >
    //   <i class="h-icon-add" />
    // </span>
    h("div", {
      "class": {
        'el-tabs__new-tab': true,
        isButtonGroup: this.isButtonGroup
      }
    }, [h("el-button", {
      "attrs": {
        "type": 'iconButton',
        "icon": 'h-icon-add',
        "tabindex": '0'
      },
      "on": {
        "click": handleTabAdd,
        "keydown": function keydown(ev) {
          if (ev.keyCode === 13) {
            handleTabAdd();
          }
        }
      }
    })]) : null;
    var navData = {
      props: {
        currentName: currentName,
        onTabClick: handleTabClick,
        onTabRemove: handleTabRemove,
        onScrollStatusChange: scrollChange,
        editable: editable,
        type: type,
        panes: panes,
        stretch: stretch,
        labelMaxWidth: labelMaxWidth,
        fixWidth: fixWidth
      },
      ref: 'nav'
    };
    var header = h("div", {
      "class": ['el-tabs__header', "el-tabs--".concat(size), "is-".concat(tabPosition)]
    }, [h("tab-nav", babel_helper_vue_jsx_merge_props_default()([{}, navData])), newButton]);
    var panels = h("div", {
      "class": 'el-tabs__content'
    }, [this.$slots["default"]]);
    return h("div", {
      "class": (_ref2 = {
        'el-tabs': true,
        'el-tabs--card': type === 'card'
      }, _defineProperty(_ref2, "el-tabs--".concat(tabPosition), true), _defineProperty(_ref2, 'el-tabs--border-card', type === 'border-card'), _ref2)
    }, [tabPosition !== 'bottom' ? [header, panels] : [panels, header]]);
  }
});
// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tabsvue_type_script_lang_js_ = (tabsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue
var tabs_render, tabs_staticRenderFns




/* normalize component */

var tabs_component = normalizeComponent(
  src_tabsvue_type_script_lang_js_,
  tabs_render,
  tabs_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_tabs = (tabs_component.exports);
// CONCATENATED MODULE: ./packages/tabs/index.js


/* istanbul ignore next */

src_tabs.install = function (Vue) {
  Vue.component(src_tabs.name, src_tabs);
};

/* harmony default export */ var packages_tabs = (src_tabs);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=template&id=5f7288f8&
var tab_panevue_type_template_id_5f7288f8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.lazy || _vm.loaded || _vm.active)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"el-tab-pane",attrs:{"id":("pane-" + _vm.paneName),"aria-hidden":!_vm.active,"aria-labelledby":("tab-" + _vm.paneName),"role":"tabpanel"}},[_vm._t("default")],2):_vm._e()}
var tab_panevue_type_template_id_5f7288f8_staticRenderFns = []


// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=template&id=5f7288f8&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var tab_panevue_type_script_lang_js_ = ({
  name: 'ElTabPane',
  componentName: 'ElTabPane',
  props: {
    label: {
      type: String,
      "default": ''
    },
    labelIcon: {
      type: String,
      "default": ''
    },
    labelContent: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    },
    name: {
      type: String,
      "default": ''
    },
    closable: {
      type: Boolean,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    lazy: {
      type: Boolean,
      "default": null
    },
    labelMaxWidth: {
      type: Number,
      "default": 0
    }
  },
  data: function data() {
    return {
      index: null,
      loaded: false
    };
  },
  computed: {
    isClosable: function isClosable() {
      return this.closable || this.$parent.closable;
    },
    active: function active() {
      return this.$parent.currentName === (this.name || this.index);
    },
    paneName: function paneName() {
      return this.name || this.index;
    }
  },
  watch: {
    label: function label() {
      this.$parent.$forceUpdate();
    },
    'this.$parent.currentName': function this$parentCurrentName(val) {
      if (val === (this.name || this.index)) this.loaded = true;
    }
  },
  updated: function updated() {
    this.$parent.$emit('tab-nav-update');
  }
});
// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tab_panevue_type_script_lang_js_ = (tab_panevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue





/* normalize component */

var tab_pane_component = normalizeComponent(
  src_tab_panevue_type_script_lang_js_,
  tab_panevue_type_template_id_5f7288f8_render,
  tab_panevue_type_template_id_5f7288f8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tab_pane = (tab_pane_component.exports);
// CONCATENATED MODULE: ./packages/tab-pane/index.js


/* istanbul ignore next */

tab_pane.install = function (Vue) {
  Vue.component(tab_pane.name, tab_pane);
};

/* harmony default export */ var packages_tab_pane = (tab_pane);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=template&id=05ac4e3d&
var treevue_type_template_id_05ac4e3d_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.wrapContainer,{ref:"scrollbar",tag:"component",attrs:{"wrap-class":"el-tree-scrollbar__wrap","view-class":"el-tree-scrollbar__view"},on:{"on-scrolling-x":_vm.onScrollingX,"on-scrolling-y":_vm.onScrollingY}},[_c('div',{staticClass:"el-tree",class:{
      'el-tree--highlight-current': _vm.highlightCurrent,
      'is-moving': _vm.moveConfig.moveFlag,
      'has-border': _vm.border
    }},[_vm._l((_vm.root.childNodes),function(child){return _c('el-tree-node',{key:_vm.getNodeKey(child),attrs:{"node":child,"props":_vm.defaultProps,"render-after-expand":_vm.renderAfterExpand,"render-when-expand":_vm.renderWhenExpand,"render-content":_vm.renderContent},on:{"node-expand":_vm.handleNodeExpand,"node-collapse":_vm.handleNodeCollapse}})}),(!_vm.root.childNodes || _vm.root.childNodes.length === 0 || !_vm.root.visible)?_c('div',{staticClass:"el-tree__empty-block"},[(_vm.$scopedSlots.empty)?_vm._t("empty"):_c('span',{staticClass:"el-tree__empty-text"},[_vm._v(" "+_vm._s(_vm.emptyText)+" ")])],2):_vm._e(),(_vm.moveConfig.moveFlag)?_c('div',{staticClass:"el-tree__move-block",style:(_vm.moveBlockStyle)},[_c('div',{staticClass:"el-tree-node__content",domProps:{"innerHTML":_vm._s(_vm.moveConfig.nodeHtml)}})]):_vm._e(),(_vm.moveConfig.moveFlag && _vm.moveConfig.arrowFlag)?_c('div',{staticClass:"el-tree__move-arrow",style:({
        top: _vm.moveConfig.arrowTop + 'px',
        left: _vm.moveConfig.arrowLeft + 'px'
      })}):_vm._e()],2)])}
var treevue_type_template_id_05ac4e3d_staticRenderFns = []


// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=template&id=05ac4e3d&

// EXTERNAL MODULE: external "core-js/modules/es.object.create.js"
var es_object_create_js_ = __webpack_require__("ed0f");

// CONCATENATED MODULE: ./packages/tree/src/model/util.js









var NODE_KEY = '$treeNodeId';
var markNodeData = function markNodeData(node, data) {
  if (data[NODE_KEY]) return;
  Object.defineProperty(data, NODE_KEY, {
    value: node.id,
    enumerable: false,
    configurable: false,
    writable: false
  });
};
var getNodeKey = function getNodeKey(key, data) {
  if (!key) return data[NODE_KEY];
  return data[key] || data.key;
};
/**
 * 判断传入的对象是否为数组
 * @author chenguanbin
 * @param {Object} [object] 传入的对象
 */

var util_isArray = function isArray(object) {
  return object && _typeof(object) === 'object' && Array === object.constructor;
};
/**
 * 返回当前页面相对于窗口显示区左上角的 X ，Y 的位置
 * @author chenguanbin
 * @param {boolean} [top] 是否是获取顶部的左上角的Y坐标
 */

var model_util_getScroll = function getScroll(top) {
  var ret = window['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = window.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
};
/**
 * 返回目标节点在容器中的位置
 * @author chenguanbin
 * @param {HTMLElement} [element] 需要获取位置的元素
 * @param {HTMLElement} [container = document.body] 容器元素
 */

var model_util_getOffset = function getOffset(element) {
  var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
  var elRect = element.getBoundingClientRect();
  var containerRect = container.getBoundingClientRect();
  var clientTop = element.clientTop || container.clientTop || 0;
  var clientLeft = element.clientLeft || container.clientLeft || 0;
  var top, left;

  if (container === document.body) {
    top = model_util_getScroll(true);
    left = model_util_getScroll();
  } else {
    top = container.scrollTop - containerRect.top;
    left = container.scrollLeft - containerRect.left;
  }

  return {
    top: elRect.top + top - clientTop,
    left: elRect.left + left - clientLeft,
    right: elRect.right + left - clientLeft,
    bottom: elRect.bottom + top - clientTop
  };
};
/**
 * 格式化数据，将简单格式数据转化为tree需要使用的格式
 * @param {Array} treeData 树节点数据
 * @param {String} nodeKey 节点Key
 * @param {String} parentKey 父节点Key
 */

var formatData = function formatData(treeData, nodeKey, parentKey) {
  var dataClone = JSON.parse(JSON.stringify(treeData)); // 将数据进行深度克隆，避免污染源数据

  var nodeIds = dataClone.map(function (item) {
    return item[nodeKey];
  }); // 所有ID的数组

  var target = []; // 目标数据

  var childNodes = []; // 除根节点以外的数据
  // 将根节点加入到target，其余节点加入到childNodes

  treeData.forEach(function (item) {
    if (nodeIds.indexOf(item[parentKey]) === -1) {
      target.push(item);
    } else {
      childNodes.push(item);
    }
  }); // 按照父节点key进行分组

  var groupNodes = getGruopNodes(childNodes, parentKey);

  var traverse = function traverse(parent) {
    for (var pId in groupNodes) {
      if (pId.toString() === parent[nodeKey].toString()) {
        parent.children = groupNodes[pId].nodes;
        groupNodes[pId].nodes.forEach(function (item) {
          traverse(item);
        });
      }
    }
  };

  target.forEach(function (item) {
    traverse(item);
  });
  return target;
};
/**
 * 数据按照父节点ID进行分组
 * @param {Array} childNodes 除根节点以外的数据
 * @param {String} parentKey 父节点Key
 */

var getGruopNodes = function getGruopNodes(childNodes, parentKey) {
  var groups = {};
  childNodes.forEach(function (item) {
    var pId = item[parentKey];

    if (groups[pId]) {
      groups[pId].nodes.push(item);
    } else {
      groups[pId] = {
        nodes: new Array(item)
      };
    }
  });
  return groups;
};
/**
 * 判断传入对象的类型
 * @param {传入的对象} obj
 */


var getType = function getType(obj) {
  // tostring会返回对应不同的标签的构造函数
  var toString = Object.prototype.toString;
  var map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };

  if (obj instanceof Element) {
    return 'element';
  }

  return map[toString.call(obj)];
};
/**
 * 对象深度拷贝
 * @param {传入的对象} data
 */

var deepClone = function deepClone(data) {
  var type = getType(data);
  var obj;

  if (type === 'array') {
    obj = [];
  } else if (type === 'object') {
    obj = {};
  } else {
    // 不再具有下一层次
    return data;
  }

  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]));
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = deepClone(data[key]);
    }
  }

  return obj;
};
// CONCATENATED MODULE: ./packages/tree/src/model/node.js












var getChildState = function getChildState(node) {
  var all = true;
  var none = true;
  var allWithoutDisable = true;
  var noneWithoutDisable = true;
  var allDisabled = true;

  for (var i = 0, j = node.length; i < j; i++) {
    var n = node[i];

    if (n.checked !== true || n.indeterminate) {
      all = false;

      if (!n.disabled) {
        allWithoutDisable = false;
      }
    }

    if (n.checked !== false || n.indeterminate) {
      none = false;

      if (!n.disabled) {
        noneWithoutDisable = false;
      }
    }

    if (!n.disabled) {
      allDisabled = false;
    }

    if (!getChildState(n.childNodes).allWithoutDisable) {
      allWithoutDisable = false;
    }
  }

  return {
    all: all,
    none: none,
    allDisabled: allDisabled,
    allWithoutDisable: allWithoutDisable,
    noneWithoutDisable: noneWithoutDisable,
    half: !all && !none
  };
};

var reInitChecked = function reInitChecked(node) {
  if (node.childNodes.length === 0 || node.disabled) return;

  var _getChildState = getChildState(node.childNodes),
      all = _getChildState.all,
      none = _getChildState.none,
      half = _getChildState.half;

  if (all) {
    node.checked = true;
    node.indeterminate = false;
  } else if (half) {
    node.checked = false;
    node.indeterminate = true;
  } else if (none) {
    node.checked = false;
    node.indeterminate = false;
  }

  var parent = node.parent;
  if (!parent || parent.level === 0) return;

  if (!node.store.checkStrictly) {
    reInitChecked(parent);
  }
}; // const initLazyLoadChild = node => {
//   const childNodes = node.childNodes;
//   if (node.checked) {
//     for (let i = 0, j = childNodes.length; i < j; i++) {
//       const child = childNodes[i];
//       if (!child.disabled) {
//         child.checked = true;
//       }
//     }
//   }
//   const parent = node.parent;
//   if (!parent || parent.level === 0) return;
//   reInitChecked(parent);
// };


var getPropertyFromData = function getPropertyFromData(node, prop) {
  var props = node.store.props;
  var data = node.data || {};
  var config = props[prop];

  if (typeof config === 'function') {
    return config(data, node);
  } else if (typeof config === 'string') {
    return data[config];
  } else if (typeof config === 'undefined') {
    return '';
  }
};

var nodeIdSeed = 0;

var node_Node = /*#__PURE__*/function () {
  function Node(options) {
    _classCallCheck(this, Node);

    this.id = nodeIdSeed++;
    this.text = null;
    this.checked = false;
    this.indeterminate = false;
    this.data = null;
    this.expanded = false;
    this.parent = null;
    this.visible = true;
    this.cacheExpanded = null;
    this.filtering = false;

    for (var name in options) {
      if (hasOwn(options, name)) {
        this[name] = options[name];
      }
    } // internal


    this.level = 0;
    this.loaded = false;
    this.childNodes = [];
    this.loading = false;

    if (this.parent) {
      this.level = this.parent.level + 1;
    }

    var store = this.store;

    if (!store) {
      throw new Error('[Node]store is required!');
    }

    store.registerNode(this);
    var props = store.props;

    if (props && typeof props.isLeaf !== 'undefined') {
      var isLeaf = getPropertyFromData(this, 'isLeaf');

      if (typeof isLeaf === 'boolean') {
        this.isLeafByUser = isLeaf;
      }
    }

    if (store.lazy !== true && this.data || this.data && options.loadedBeforeMove && options.loadedChildren) {
      this.setData(this.data, options.loadedChildren);

      if (store.defaultExpandAll) {
        this.expanded = true;
      }
    } else if (this.level > 0 && store.lazy && store.defaultExpandAll) {
      this.expand();
    }

    if (!this.data) return;
    var defaultExpandedKeys = store.defaultExpandedKeys;
    var key = store.key;

    if (key && defaultExpandedKeys && defaultExpandedKeys.indexOf(this.key) !== -1) {
      this.expand(null, store.autoExpandParent);
    }

    if (key && (store.currentNodeKey || store.currentNodeKey === 0) && this.key === store.currentNodeKey) {
      store.currentNode = this;
    }

    if (store.lazy) {
      store._initDefaultCheckedNode(this);
    }

    this.updateLeafState();
  }

  _createClass(Node, [{
    key: "setData",
    value: function setData(data, loadedChildren) {
      if (!Array.isArray(data)) {
        markNodeData(this, data);
      }

      this.data = data;
      this.childNodes = [];
      var children;

      if (loadedChildren) {
        children = loadedChildren;
      } else if (this.level === 0 && this.data instanceof Array) {
        children = this.data;
      } else {
        children = getPropertyFromData(this, 'children') || [];
      }

      for (var i = 0, j = children.length; i < j; i++) {
        this.insertChild({
          data: children[i]
        });
      }
    }
  }, {
    key: "insertChild",
    value: function insertChild(child, index, isSetLeafFalse, loadedBeforeMove, loadedChildren) {
      if (!child) throw new Error('insertChild error: child is required.');

      if (!(child instanceof Node)) {
        merge(child, {
          parent: this,
          store: this.store,
          loadedBeforeMove: loadedBeforeMove,
          loadedChildren: loadedChildren
        });
        child = new Node(child);
      }

      child.level = this.level + 1;

      if (typeof index === 'undefined' || index < 0) {
        this.childNodes.push(child);
      } else {
        this.childNodes.splice(index, 0, child);
      }

      this.updateLeafState(isSetLeafFalse); // isSetLeafFalse && (this.loaded = true);
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(child, ref, loadedBeforeMove, loadedChildren) {
      var index;

      if (ref) {
        index = this.childNodes.indexOf(ref);
      }

      this.insertChild(child, index, null, loadedBeforeMove, loadedChildren);
    }
  }, {
    key: "insertAfter",
    value: function insertAfter(child, ref, loadedBeforeMove, loadedChildren) {
      var index;

      if (ref) {
        index = this.childNodes.indexOf(ref);
        if (index !== -1) index += 1;
      }

      this.insertChild(child, index, null, loadedBeforeMove, loadedChildren);
    }
  }, {
    key: "removeChild",
    value: function removeChild(child) {
      var index = this.childNodes.indexOf(child);

      if (index > -1) {
        this.store && this.store.deregisterNode(child);
        child.parent = null;
        this.childNodes.splice(index, 1);
      }

      this.updateLeafState();
    }
  }, {
    key: "removeChildByData",
    value: function removeChildByData(data) {
      var targetNode = null;
      this.childNodes.forEach(function (node) {
        if (node.data === data) {
          targetNode = node;
        }
      });

      if (targetNode) {
        this.removeChild(targetNode);
      }
    }
  }, {
    key: "expand",
    value: function expand(callback, expandParent) {
      var _this = this;

      var done = function done() {
        if (expandParent) {
          var parent = _this.parent;

          while (parent.level > 0) {
            parent.expanded = true;
            parent = parent.parent;
          }
        }

        _this.expanded = true;
        if (callback) callback();
      };

      if (this.shouldLoadData()) {
        this.loadNode(done);
      } else {
        if (this.store.lazy === true && this.store.load && this.loadedBeforeMove) {
          this.isLeaf = true;
        }

        done();
      }
    }
  }, {
    key: "loadNode",
    value: function loadNode(done) {
      var _this2 = this;

      this.loadData(function (data) {
        if (data instanceof Array) {
          if (_this2.checked) {
            _this2.setChecked(true, true);
          } else if (!_this2.store.checkStrictly) {
            reInitChecked(_this2);
          }

          done && done();
        }
      });
    }
  }, {
    key: "doCreateChildren",
    value: function doCreateChildren(array) {
      var _this3 = this;

      var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      array.forEach(function (item) {
        _this3.insertChild(merge({
          data: item
        }, defaultProps));
      });
    }
  }, {
    key: "collapse",
    value: function collapse() {
      this.expanded = false;
    }
  }, {
    key: "shouldLoadData",
    value: function shouldLoadData() {
      return this.store.lazy === true && this.store.load && !this.loaded && !this.isLeaf && !this.loadedBeforeMove;
    }
  }, {
    key: "updateLeafState",
    value: function updateLeafState(isSetLeafFalse) {
      if (isSetLeafFalse) {
        this.isLeaf = false;
        return;
      }

      if (this.store.lazy === true && this.loaded !== true && typeof this.isLeafByUser !== 'undefined') {
        this.isLeaf = this.isLeafByUser;
        return;
      }

      var childNodes = this.childNodes;

      if (!this.store.lazy || this.store.lazy === true && this.loaded === true) {
        this.isLeaf = !childNodes || childNodes.length === 0;
        return;
      }

      this.isLeaf = false;
    }
  }, {
    key: "setChecked",
    value: function setChecked(value, deep, recursion, passValue) {
      var _this4 = this;

      var rootOnly = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var _getChildState2 = getChildState(this.childNodes),
          all = _getChildState2.all,
          allWithoutDisable = _getChildState2.allWithoutDisable,
          allDisabled = _getChildState2.allDisabled,
          noneWithoutDisable = _getChildState2.noneWithoutDisable; // 这里有个奇葩的处理，这个针对checkbox在半选情况下无法正确返回checked状态的问题
      // 比如存在父节点a, 子节点a-1、a-2、a-3（禁用），
      // 当勾选a-1和a-2后，勾选父节点a时会发现页面无响应（由于a-3（禁用）的影响）
      // 原因是勾选a-1和a-2后，父节点a在checkbox内部依然是未勾选状态
      // 这边判断此情况的逻辑是
      // 1.非叶子节点
      // 2.非联动勾选的节点
      // 3.子节点不全是禁用


      if (!this.isLeaf && !recursion && !allDisabled && !this.store.checkStrictly) {
        if (noneWithoutDisable && this.checked === false && value === false) {
          // 1.非禁用的子节点全不勾选
          // 2.当前checkbox返回的勾选状态是false
          // 3.当前也不是勾选状态
          value = true;
        } else if (!all && allWithoutDisable) {
          // 非禁用的子节点勾选，禁用的没勾
          value = false;
        }
      }

      this.indeterminate = value === 'half';
      this.checked = value === true;
      if (this.store.checkStrictly) return;

      if (!(this.shouldLoadData() && !this.store.checkDescendants)) {
        // if (!this.isLeaf && !all && allWithoutDisable) {
        //   this.checked = false;
        //   value = false;
        // }
        var handleDescendants = function handleDescendants() {
          if (deep) {
            var childNodes = _this4.childNodes;

            for (var i = 0, j = childNodes.length; i < j; i++) {
              var child = childNodes[i];
              passValue = passValue || value !== false;

              if (!child.disabled) {
                child.setChecked(passValue, deep, true, passValue);
              }
            }

            var _getChildState3 = getChildState(childNodes),
                half = _getChildState3.half,
                _all = _getChildState3.all,
                _allDisabled = _getChildState3.allDisabled;

            if (!_all && !_allDisabled) {
              _this4.checked = _all;
              _this4.indeterminate = half;
            }
          }
        };

        if (this.shouldLoadData()) {
          // Only work on lazy load data.
          this.loadData(function () {
            handleDescendants();
            reInitChecked(_this4);
          }, {
            checked: value !== false
          });
          return;
        } else {
          if (!this.disabled) {
            handleDescendants();
          }
        }
      }

      var parent = this.parent;
      if (!parent || parent.level === 0) return;

      if (!recursion && !rootOnly) {
        reInitChecked(parent);
      }
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      // this is data
      var data = this.data;
      if (!data) return null;
      var props = this.store.props;
      var children = 'children';

      if (props) {
        children = props.children || 'children';
      }

      if (data[children] === undefined) {
        data[children] = null;
      }

      return data[children];
    }
  }, {
    key: "updateChildren",
    value: function updateChildren() {
      var _this5 = this;

      var newData = this.getChildren() || [];
      var oldData = this.childNodes.map(function (node) {
        return node.data;
      });
      var newDataMap = {};
      var newNodes = [];
      newData.forEach(function (item, index) {
        if (item[NODE_KEY]) {
          newDataMap[item[NODE_KEY]] = {
            index: index,
            data: item
          };
        } else {
          newNodes.push({
            index: index,
            data: item
          });
        }
      });
      oldData.forEach(function (item) {
        if (!newDataMap[item[NODE_KEY]]) _this5.removeChildByData(item);
      });
      newNodes.forEach(function (_ref) {
        var index = _ref.index,
            data = _ref.data;

        _this5.insertChild({
          data: data
        }, index);
      });
      this.updateLeafState();
    }
  }, {
    key: "loadData",
    value: function loadData(callback) {
      var _this6 = this;

      var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.store.lazy === true && this.store.load && !this.loaded && (!this.loading || Object.keys(defaultProps).length)) {
        this.loading = true;

        var resolve = function resolve(children) {
          _this6.loaded = true;
          _this6.loading = false;
          _this6.childNodes = [];

          _this6.doCreateChildren(children, defaultProps);

          _this6.updateLeafState();

          if (callback) {
            callback.call(_this6, children);
          }
        };

        this.store.load(this, resolve);
      } else {
        if (callback) {
          callback.call(this);
        }
      }
    }
  }, {
    key: "svgIcon",
    get: function get() {
      return getPropertyFromData(this, 'svgIcon');
    }
  }, {
    key: "svgIconOffline",
    get: function get() {
      return getPropertyFromData(this, 'svgIconOffline');
    }
  }, {
    key: "svgIconColor",
    get: function get() {
      return getPropertyFromData(this, 'svgIconColor');
    }
  }, {
    key: "svgIconColorActive",
    get: function get() {
      return getPropertyFromData(this, 'svgIconColorActive');
    }
  }, {
    key: "svgIconRequire",
    get: function get() {
      return getPropertyFromData(this, 'svgIconRequire');
    }
  }, {
    key: "label",
    get: function get() {
      return getPropertyFromData(this, 'label');
    }
  }, {
    key: "key",
    get: function get() {
      var nodeKey = this.store.key;
      if (this.data) return this.data[nodeKey];
      return null;
    }
  }, {
    key: "disabled",
    get: function get() {
      return getPropertyFromData(this, 'disabled');
    }
  }, {
    key: "icon",
    get: function get() {
      return getPropertyFromData(this, 'icon');
    }
  }, {
    key: "selectable",
    get: function get() {
      var selectable = getPropertyFromData(this, 'selectable');
      return typeof selectable === 'boolean' ? selectable : true;
    }
  }]);

  return Node;
}();


// CONCATENATED MODULE: ./packages/tree/src/model/tree-store.js




















var tree_store_TreeStore = /*#__PURE__*/function () {
  function TreeStore(options) {
    var _this = this;

    _classCallCheck(this, TreeStore);

    this.currentNode = null;
    this.currentNodeKey = null;

    for (var option in options) {
      if (hasOwn(options, option)) {
        this[option] = options[option];
      }
    }

    this.nodesMap = {};
    this.root = new node_Node({
      data: this.data,
      store: this
    });

    if (this.lazy && this.load) {
      var loadFn = this.load;
      loadFn(this.root, function (data) {
        // this.root.doCreateChildren(data);
        if (_this.simpleData) data = formatData(data, _this.key, _this.parentKey);

        _this._initLazyNode(_this.root, data);

        _this._initDefaultCheckedNodes();
      });
    } else {
      this._initDefaultCheckedNodes();
    }
  }

  _createClass(TreeStore, [{
    key: "_initLazyNode",
    value: function _initLazyNode(node, data) {
      node.doCreateChildren(data);

      var _iterator = _createForOfIteratorHelper(data),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item[this.props.children] && item[this.props.children].length) {
            var _node = this.getNode(item);

            _node.loaded = true;

            this._initLazyNode(_node, item[this.props.children]);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "filter",
    value: function filter(value, keepAlive) {
      var filterNodeMethod = this.filterNodeMethod;

      var traverse = function traverse(node) {
        var childNodes = node.root ? node.root.childNodes : node.childNodes;
        childNodes.forEach(function (child) {
          child.visible = filterNodeMethod.call(child, value, child.data, child);
          traverse(child);
        });

        if (!node.visible && childNodes.length) {
          var allHidden = true;
          childNodes.forEach(function (child) {
            if (child.visible) allHidden = false;
          });

          if (node.root) {
            node.root.visible = allHidden === false;
          } else {
            node.visible = allHidden === false;
          }
        }

        if (!node.isLeaf) {
          if (node.filtering === false && !keepAlive) {
            node.cacheExpanded = node.expanded;
            node.filtering = true;
          }

          node.root ? node.root.expand() : node.expand();

          if (keepAlive) {
            node.filtering = false;
            !node.cacheExpanded && node.collapse && node.collapse();
          }
        }
      };

      traverse(this);
    }
  }, {
    key: "setData",
    value: function setData(newVal) {
      var instanceChanged = newVal !== this.root.data;
      this.root.setData(newVal);

      if (instanceChanged) {
        this._initDefaultCheckedNodes();
      }
    }
  }, {
    key: "getNode",
    value: function getNode(data) {
      var key = _typeof(data) !== 'object' ? data : getNodeKey(this.key, data);
      return this.nodesMap[key];
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(data, refData) {
      var refNode = this.getNode(refData);
      refNode.parent.insertBefore({
        data: data
      }, refNode);
    }
  }, {
    key: "insertAfter",
    value: function insertAfter(data, refData) {
      var refNode = this.getNode(refData);
      refNode.parent.insertAfter({
        data: data
      }, refNode);
    }
  }, {
    key: "remove",
    value: function remove(data) {
      var _this2 = this;

      if (!Array.isArray(data)) data = [data];
      data.forEach(function (d) {
        var node = _this2.getNode(d);

        node && node.parent.removeChild(node);
      });
    }
  }, {
    key: "append",
    value: function append(data, parentData) {
      var parentNode = parentData ? this.getNode(parentData) : this.root;

      if (parentNode) {
        if (!Array.isArray(data)) data = [data];
        data.forEach(function (d) {
          parentNode.insertChild({
            data: d
          });
        });
      }
    }
  }, {
    key: "reload",
    value: function reload(data, done) {
      var _this3 = this;

      if (this.lazy && this.load) {
        if (!Array.isArray(data)) data = [data];
        var l = data.length - 1;
        data.forEach(function (d, i) {
          var node = _this3.getNode(d);

          if (node) {
            node.loaded = false;
            node.loadNode(i === l && done);
          }
        });
      }
    }
    /**
     * 将节点移动到目标节点的子节点
     * @author chenguanbin
     * @param {Object} [data] 被移动节点的数据对象
     * @param {Object} [targetData] 目标节点的数据对象
     * @param {String} [position] 节点被移动到目标节点的位置: inner(目标节点内) prev(目标节点之前) next(目标节点之后)
     */

  }, {
    key: "move",
    value: function move(data, targetData, position) {
      var node = this.getNode(data);
      var targetNode = targetData ? this.getNode(targetData) : this.root; // 移除节点数据

      if (node) {
        var parentNodeData = node.parent.data;

        if (!util_isArray(parentNodeData)) {
          parentNodeData = parentNodeData.children || [];
        }

        for (var i = 0; i < parentNodeData.length; i++) {
          if (parentNodeData[i] === data) {
            parentNodeData.splice(i, 1);
            break;
          }
        }

        node.parent.removeChild(node);
      }

      var loadedBeforeMove = node.loaded;
      var loadedChildren = node.childNodes.map(function (n) {
        return n.data;
      }); // 添加节点数据到目标节点

      if (targetNode) {
        if (position === 'inner') {
          targetNode.insertChild({
            data: data
          }, undefined, true, loadedBeforeMove, loadedChildren);
        } else if (position === 'prev') {
          targetNode.parent.insertBefore({
            data: data
          }, targetNode, loadedBeforeMove, loadedChildren);
        } else if (position === 'next') {
          targetNode.parent.insertAfter({
            data: data
          }, targetNode, loadedBeforeMove, loadedChildren);
        }

        this._moveData(data, targetNode, position);

        return this.getNode(data);
      }
    }
    /**
     * 移动数据
     * @author chenguanbin
     * @param {Object} [data] 被移动节点的数据对象
     * @param {Object} [targetNode] 目标节点
     * @param {String} [position] 节点被移动到目标节点的位置: inner(目标节点内) prev(目标节点之前) next(目标节点之后)
     */

  }, {
    key: "_moveData",
    value: function _moveData(data, targetNode, position) {
      // 分为：移动到节点之中、移动到节点前后
      if (position === 'inner') {
        if (!targetNode.data.children) {
          targetNode.data.children = [];
        }

        targetNode.data.children.push(data);
      } else {
        var pNodeData = targetNode.parent.data;

        if (!util_isArray(pNodeData)) {
          pNodeData = pNodeData.children || [];
        }

        for (var i = 0; i < pNodeData.length; i++) {
          if (pNodeData[i] === targetNode.data) {
            position === 'prev' ? pNodeData.splice(i, 0, data) : pNodeData.splice(i + 1, 0, data);
            break;
          }
        }
      }
    }
  }, {
    key: "_initDefaultCheckedNodes",
    value: function _initDefaultCheckedNodes() {
      var _this4 = this;

      var defaultCheckedKeys = this.defaultCheckedKeys || [];
      var nodesMap = this.nodesMap;
      defaultCheckedKeys.forEach(function (checkedKey) {
        var node = nodesMap[checkedKey];

        if (node) {
          node.setChecked(true, !_this4.checkStrictly);
        }
      });
    }
  }, {
    key: "_initDefaultCheckedNode",
    value: function _initDefaultCheckedNode(node) {
      var defaultCheckedKeys = this.defaultCheckedKeys || [];

      if (defaultCheckedKeys.indexOf(node.key) !== -1) {
        node.setChecked(true, !this.checkStrictly, this.lazy);
      } else if (node.parent && !this.checkStrictly) {
        node.setChecked(node.parent.checked, !this.checkStrictly, this.lazy);
      }
    }
  }, {
    key: "setDefaultCheckedKey",
    value: function setDefaultCheckedKey(newVal) {
      if (newVal !== this.defaultCheckedKeys) {
        this.defaultCheckedKeys = newVal;

        this._initDefaultCheckedNodes();
      }
    }
  }, {
    key: "registerNode",
    value: function registerNode(node) {
      var key = this.key;
      if (!key || !node || !node.data) return;
      var nodeKey = node.key;
      if (nodeKey !== undefined) this.nodesMap[node.key] = node;
    }
  }, {
    key: "deregisterNode",
    value: function deregisterNode(node) {
      var key = this.key;
      if (!key || !node || !node.data) return;
      delete this.nodesMap[node.key];
    }
    /**
     * 获取选中节点方法
     * 增加选中半选的判断，默认不获取  xiangxiao3 2017/9/26
     * @param {boolean} [leafOnly=false] 仅返回被选中的叶子节点
     * @param {boolean} [checkedOnly=true] 仅返回半选状态的节点
     * @returns 被选中的节点
     * @memberof TreeStore
     */

  }, {
    key: "getCheckedNodes",
    value: function getCheckedNodes() {
      var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var checkedOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var checkedNodes = [];

      var traverse = function traverse(node) {
        var childNodes = node.root ? node.root.childNodes : node.childNodes;
        childNodes.forEach(function (child) {
          // 1、leafOnly=false，且节点选中
          // 2、leafOnly=true，且节点是叶子节点，且节点选中
          // 3、checkedOnly=false，且节点半选
          if (!leafOnly && child.checked || leafOnly && child.isLeaf && child.checked || !checkedOnly && child.indeterminate) {
            checkedNodes.push(child.data);
          }

          traverse(child);
        });
      };

      traverse(this);
      return checkedNodes;
    }
    /**
     * 获取选中节点的key值
     * 增加选中半选的判断，默认不获取  xiangxiao3 2017/9/26
     * @param {boolean} [leafOnly=false] 仅返回被选中的叶子节点
     * @param {boolean} [checkedOnly=true] 仅返回半选状态的节点
     * @returns 被选中节点的key值
     * @memberof TreeStore
     */

  }, {
    key: "getCheckedKeys",
    value: function getCheckedKeys() {
      var _this5 = this;

      var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var checkedOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return this.getCheckedNodes(leafOnly, checkedOnly).map(function (data) {
        return (data || {})[_this5.key];
      });
    }
    /**
     * 返回目前半选中的节点所组成的数组
     */

  }, {
    key: "getHalfCheckedNodes",
    value: function getHalfCheckedNodes() {
      var nodes = [];

      var traverse = function traverse(node) {
        var childNodes = node.root ? node.root.childNodes : node.childNodes;
        childNodes.forEach(function (child) {
          if (child.indeterminate) {
            nodes.push(child.data);
          }

          traverse(child);
        });
      };

      traverse(this);
      return nodes;
    }
    /**
     * 返回目前半选中的节点的 key 所组成的数组
     */

  }, {
    key: "getHalfCheckedKeys",
    value: function getHalfCheckedKeys() {
      var _this6 = this;

      return this.getHalfCheckedNodes().map(function (data) {
        return (data || {})[_this6.key];
      });
    }
  }, {
    key: "_getAllNodes",
    value: function _getAllNodes() {
      var allNodes = [];
      var nodesMap = this.nodesMap;

      for (var nodeKey in nodesMap) {
        if (hasOwn(nodesMap, nodeKey)) {
          allNodes.push(nodesMap[nodeKey]);
        }
      }

      return allNodes;
    } // updateChildren(key, data) {
    //   const node = this.nodesMap[key];
    //   if (!node) return;
    //   const childNodes = node.childNodes;
    //   for (let i = childNodes.length - 1; i >= 0; i--) {
    //     const child = childNodes[i];
    //     this.remove(child.data);
    //   }
    //   for (let i = 0, j = data.length; i < j; i++) {
    //     const child = data[i];
    //     this.append(child, node.data);
    //   }
    // }

  }, {
    key: "_setCheckedKeys",
    value: function _setCheckedKeys(key) {
      var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var checkedKeys = arguments.length > 2 ? arguments[2] : undefined;
      var rootOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var allNodes = this._getAllNodes().sort(function (a, b) {
        return b.level - a.level;
      });

      var cache = Object.create(null);
      var keys = Object.keys(checkedKeys);
      allNodes.forEach(function (node) {
        return node.setChecked(false, false);
      });

      for (var i = 0, j = allNodes.length; i < j; i++) {
        var node = allNodes[i];
        var nodeKey = node.data[key].toString();
        var checked = keys.indexOf(nodeKey) > -1;

        if (!checked) {
          if (node.checked && !cache[nodeKey]) {
            node.setChecked(false, false);
          }

          continue;
        }

        var parent = node.parent;

        while (parent && parent.level > 0) {
          cache[parent.data[key]] = true;
          parent = parent.parent;
        }

        if (node.isLeaf || this.checkStrictly) {
          // 是否只选中点击的节点
          if (rootOnly) {
            node.setChecked(true, false, false, false, rootOnly);
          } else {
            node.setChecked(true, false);
          }

          continue;
        } // 是否只选中点击的节点


        if (rootOnly) {
          node.setChecked(true, false, false, false, rootOnly);
        } else {
          node.setChecked(true, true);
        }

        if (leafOnly) {
          (function () {
            node.setChecked(false, false);

            var traverse = function traverse(node) {
              var childNodes = node.childNodes;
              childNodes.forEach(function (child) {
                if (!child.isLeaf) {
                  child.setChecked(false, false);
                }

                traverse(child);
              });
            };

            traverse(node);
          })();
        }
      }
    }
  }, {
    key: "setCheckedNodes",
    value: function setCheckedNodes(array) {
      var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var rootOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var key = this.key;
      var checkedKeys = {};
      array.forEach(function (item) {
        checkedKeys[(item || {})[key]] = true;
      });

      this._setCheckedKeys(key, leafOnly, checkedKeys, rootOnly);
    }
  }, {
    key: "setCheckedKeys",
    value: function setCheckedKeys(keys) {
      var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var rootOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.defaultCheckedKeys = keys;
      var key = this.key;
      var checkedKeys = {};
      keys.forEach(function (key) {
        checkedKeys[key] = true;
      });

      this._setCheckedKeys(key, leafOnly, checkedKeys, rootOnly);
    }
  }, {
    key: "setDefaultExpandedKeys",
    value: function setDefaultExpandedKeys(keys) {
      var _this7 = this;

      keys = keys || [];
      this.defaultExpandedKeys = keys;
      keys.forEach(function (key) {
        var node = _this7.getNode(key);

        if (node) node.expand(null, _this7.autoExpandParent);
      });
    }
  }, {
    key: "setChecked",
    value: function setChecked(data, checked, deep) {
      var node = this.getNode(data);

      if (node) {
        node.setChecked(!!checked, deep);
      }
    }
  }, {
    key: "getCurrentNode",
    value: function getCurrentNode() {
      return this.currentNode;
    }
  }, {
    key: "setCurrentNode",
    value: function setCurrentNode(node) {
      if (node === null) {
        this.currentNode = null;
        return;
      }

      this.currentNode = node;
    }
  }, {
    key: "setUserCurrentNode",
    value: function setUserCurrentNode(node) {
      var key = node[this.key];
      var currNode = this.nodesMap[key];
      this.setCurrentNode(currNode);
    }
  }, {
    key: "setCurrentNodeKey",
    value: function setCurrentNodeKey(key) {
      if (key === null) {
        this.currentNode = null;
        return;
      }

      var node = this.getNode(key);

      if (node) {
        this.currentNode = node;
      }
    }
  }]);

  return TreeStore;
}();


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=template&id=32db894e&
var tree_nodevue_type_template_id_32db894e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.node.visible),expression:"node.visible"}],staticClass:"el-tree-node",class:{
    'is-expanded': _vm.expanded,
    'is-current': _vm.isCurrent,
    'is-hidden': !_vm.node.visible,
    'is-disabled': !!_vm.node.disabled,
    'is-drag': _vm.tree.moveConfig.moveFlag,
    'is-nonselectable': !_vm.node.selectable,
    'is-drag-inner':
      _vm.tree.moveConfig.targetNode === _vm.node &&
      _vm.tree.moveConfig.movePosition === 'inner' &&
      _vm.tree.moveConfig.targetNode !== _vm.tree.moveConfig.moveNode
  },attrs:{"data-key":_vm.getNodeKey(_vm.node)},on:{"mousedown":_vm.mouseDown}},[_c('div',{staticClass:"el-tree-node__content",style:(_vm.nodeStyle),on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)},"dblclick":function($event){$event.stopPropagation();return _vm.handleDbClick($event)},"contextmenu":function ($event) { return _vm.handleContextMenu($event); },"mouseenter":function ($event) { return _vm.tree.$emit('node-mouseenter', _vm.node.data, _vm.node, $event); },"mouseleave":function ($event) { return _vm.tree.$emit('node-mouseleave', _vm.node.data, _vm.node, $event); }}},[_c('span',{staticClass:"el-tree-node__expand-icon h-icon-angle_right",class:{
        'is-leaf':
          (_vm.node.isLeaf || _vm.node.data.isLeaf) && _vm.node.childNodes.length === 0,
        expanded: !_vm.node.isLeaf && _vm.expanded
      },on:{"click":function($event){$event.stopPropagation();return _vm.handleExpandIconClick($event)}}}),(_vm.showCheckbox)?_c('el-checkbox',{attrs:{"indeterminate":_vm.node.indeterminate,"disabled":!!_vm.node.disabled},on:{"change":_vm.handleCheckChange},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.node.checked),callback:function ($$v) {_vm.$set(_vm.node, "checked", $$v)},expression:"node.checked"}}):_vm._e(),(_vm.node.svgIcon && _vm.node.svgIconRequire)?_c('h-svg-icon',{staticClass:"el-tree-node__icon",attrs:{"svgs":_vm.node.svgIcon}}):(_vm.node.svgIcon && typeof _vm.node.svgIcon === 'string')?_c('h-svg-icon',{staticClass:"el-tree-node__icon",attrs:{"offline":_vm.node.svgIconOffline}},[_c(_vm.node.svgIcon,{tag:"component",attrs:{"color":_vm.svgIconColor}})],1):(_vm.node.svgIcon && typeof _vm.node.svgIcon === 'object')?_c('h-svg-icon',{staticClass:"el-tree-node__icon",attrs:{"offline":_vm.node.svgIconOffline}},_vm._l((_vm.node.svgIcon),function(icon,index){return _c(icon,{key:index,tag:"component",attrs:{"color":_vm.svgIconColor[index]}})}),1):_vm._e(),(!_vm.node.svgIcon && (_vm.node.icon || _vm.defaultIcon))?_c('span',{class:'el-tree-node__icon ' + (_vm.node.icon || _vm.defaultIcon)}):_vm._e(),(_vm.node.loading)?_c('span',{staticClass:"el-tree-node__loading-icon h-icon-restart"}):_vm._e(),_c('node-content',{attrs:{"node":_vm.node}})],1),(!_vm.renderAfterExpand || _vm.childNodeRendered)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.expanded),expression:"expanded"}],staticClass:"el-tree-node__children"},_vm._l((_vm.node.childNodes),function(child){return _c('el-tree-node',{key:_vm.getNodeKey(child),attrs:{"render-content":_vm.renderContent,"render-after-expand":_vm.renderAfterExpand,"render-when-expand":_vm.renderWhenExpand,"node":child},on:{"node-expand":_vm.handleChildNodeExpand}})}),1):_vm._e()])}
var tree_nodevue_type_template_id_32db894e_staticRenderFns = []


// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=template&id=32db894e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import ElCollapseTransition from 'hui/src/transitions/collapse-transition';




/* harmony default export */ var tree_nodevue_type_script_lang_js_ = ({
  name: 'ElTreeNode',
  componentName: 'ElTreeNode',
  components: {
    // ElCollapseTransition,
    ElCheckbox: packages_checkbox,
    NodeContent: {
      props: {
        node: {
          required: true
        }
      },
      render: function render(h) {
        var parent = this.$parent;
        var tree = parent.tree;
        var node = this.node;
        var data = node.data,
            store = node.store;
        return parent.renderContent ? parent.renderContent.call(parent._renderProxy, h, {
          _self: tree.$vnode.context,
          node: node,
          data: data,
          store: store
        }) : tree.$scopedSlots["default"] ? tree.$scopedSlots["default"]({
          node: node,
          data: data,
          store: store
        }) : h("span", {
          "class": 'el-tree-node__label',
          "attrs": {
            "title": node.label
          }
        }, [node.label]);
      }
    }
  },
  mixins: [emitter],
  props: {
    node: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    props: {
      type: Object,
      "default": null
    },
    renderContent: {
      type: Function,
      "default": null
    },
    renderAfterExpand: {
      type: Boolean,
      "default": true
    },
    renderWhenExpand: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      tree: null,
      expanded: false,
      childNodeRendered: false,
      showCheckbox: false,
      oldChecked: null,
      oldIndeterminate: null // nodeWidth: 0 // 节点宽度

    };
  },
  computed: {
    svgIconColor: function svgIconColor() {
      var node = this.node;

      if (node.svgIconColorActive && this.isCurrent) {
        return node.svgIconColorActive;
      } else if (node.svgIconColor && !this.isCurrent) {
        return node.svgIconColor;
      } else {
        return '';
      }
    },
    isCurrent: function isCurrent() {
      return this.tree.store.currentNode && this.tree.store.currentNode.id === this.node.id;
    },
    nodeStyle: function nodeStyle() {
      var nodeHeight = this.tree.nodeHeight;
      var style = {
        'padding-left': (this.node.level - 1) * this.tree.indent + 'px'
      };
      return nodeHeight ? Object.assign(style, {
        height: nodeHeight + 'px',
        'line-height': nodeHeight - 4 + 'px'
      }) : style;
    }
  },
  watch: {
    'node.indeterminate': function nodeIndeterminate(val) {
      this.handleSelectChange(this.node.checked, val);
    },
    'node.checked': function nodeChecked(val) {
      this.handleSelectChange(val, this.node.indeterminate);
    },
    'node.expanded': function nodeExpanded(val) {
      var _this2 = this;

      this.$nextTick(function () {
        return _this2.expanded = val;
      });

      if (val) {
        this.childNodeRendered = true;
      } else if (!val && this.renderWhenExpand) {
        this.childNodeRendered = false;
      }
    } // 监听树的最长节点宽度，改变时对应修改自身宽度
    // 'tree.maxNodeWidth'(val) {
    //   this.nodeWidth = val;
    // }

  },
  created: function created() {
    var _this3 = this;

    var parent = this.$parent;

    if (parent.wrapClass) {
      parent = parent.$parent;
    }

    if (parent.isTree) {
      this.tree = parent;
    } else {
      this.tree = parent.tree;
    }

    var tree = this.tree;

    if (!tree) {
      // eslint-disable-next-line
      console.warn("Can not find node's tree.");
    }

    var props = tree.props || {};
    var childrenKey = props.children || 'children';
    this.$watch("node.data.".concat(childrenKey), function () {
      _this3.node.updateChildren();
    });
    this.showCheckbox = tree.showCheckbox; // 是否显示图标

    this.showIcon = tree.showIcon; // 默认图标

    this.defaultIcon = tree.defaultIcon;

    if (this.node.expanded) {
      this.expanded = true;
      this.childNodeRendered = true;
    }

    if (this.tree.accordion) {
      this.$on('tree-node-expand', function (node) {
        if (_this3.node !== node) {
          _this3.node.collapse();
        }
      });
    }
  },
  mounted: function mounted() {
    // const contentWidth = this.$el.querySelector('.el-tree-node__content').scrollWidth;
    var parent = this.$parent;

    if (parent.wrapClass) {
      parent = parent.$parent;
    }
  },
  methods: {
    getNodeKey: function getNodeKey(node, index) {
      var nodeKey = this.tree.nodeKey;

      if (nodeKey && node) {
        return node.data[nodeKey];
      }

      return index;
    },
    handleSelectChange: function handleSelectChange(checked, indeterminate) {
      this.tree.$emit('check-change', this.node.data, checked, indeterminate);
      this.oldChecked = checked;
      this.indeterminate = indeterminate;
    },
    handleClick: function handleClick($event) {
      var _this4 = this;

      // selectable 未赋值则可以点击，否则按照 selectable 的值来判断
      var selectable = this.node.selectable;
      var isContinue = selectable === undefined || selectable === '' ? true : selectable;

      var todo = function todo() {
        var store = _this4.tree.store;
        store.setCurrentNode(_this4.node);

        _this4.tree.$emit('current-change', store.currentNode ? store.currentNode.data : null, store.currentNode);

        _this4.tree.currentNode = _this4;

        if (_this4.tree.expandOnClickNode) {
          _this4.handleExpandIconClick();
        }

        if (_this4.tree.checkOnClickNode && !_this4.node.disabled) {
          _this4.handleCheckChange(!_this4.node.checked);
        }

        _this4.tree.$emit('node-click', _this4.node.data, _this4.node, _this4, $event);
      }; // beforeClick 能够覆盖 selectable


      if (this.tree.beforeClick) {
        // 支持beforeClick返回Boolean或Promise
        var result = this.tree.beforeClick(this.node.data, this.node);
        if (result === false) return; // 返回false则无法点击

        if (result === undefined) result = true; // 未返回值可以点击

        Promise.resolve(result).then(function (allowed) {
          if (allowed) {
            todo();
          }
        });
      } else if (isContinue) {
        todo();
      }
    },
    handleDbClick: function handleDbClick($event) {
      if (this.tree.expandOnDbclickNode) {
        this.handleExpandIconClick();
      }

      this.tree.$emit('node-dbclick', this.node.data, this.node, this, $event);
    },
    handleExpandIconClick: function handleExpandIconClick() {
      if ((this.node.isLeaf || this.node.data.isLeaf) && this.node.childNodes.length === 0) {
        return;
      }

      if (this.expanded) {
        this.tree.$emit('node-collapse', this.node.data, this.node, this);
        this.node.collapse();
        this.$emit('node-collapse', this.node.data, this.node, this);
      } else {
        this.node.expand();
        this.$emit('node-expand', this.node.data, this.node, this);
      }
    },

    /**
     * 当某一节点被鼠标右键点击时会触发该事件
     */
    handleContextMenu: function handleContextMenu(event) {
      if (this.tree._events['node-contextmenu'] && this.tree._events['node-contextmenu'].length > 0) {
        event.stopPropagation();
        event.preventDefault();
      }

      this.tree.$emit('node-contextmenu', event, this.node.data, this.node, this);
    },
    handleCheckChange: function handleCheckChange(ev) {
      var _this5 = this;

      this.node.setChecked(ev, !this.tree.checkStrictly);
      this.$nextTick(function () {
        var store = _this5.tree.store;

        _this5.tree.$emit('check', _this5.node.data, {
          checkedNodes: store.getCheckedNodes(),
          checkedKeys: store.getCheckedKeys(),
          halfCheckedNodes: store.getHalfCheckedNodes(),
          halfCheckedKeys: store.getHalfCheckedKeys()
        }, _this5.node.checked);
      });
    },
    handleChildNodeExpand: function handleChildNodeExpand(nodeData, node, instance) {
      this.broadcast('ElTreeNode', 'tree-node-expand', node);
      this.tree.$emit('node-expand', nodeData, node, instance);
    },

    /**
     * 鼠标点击到节点上的事件
     * @author chenguanbin
     * @param {Event} [event] 事件触发时的事件对象
     */
    mouseDown: function mouseDown(event) {
      if (this.tree.move) {
        // 节点拖拽时阻止事件冒泡
        event.stopPropagation(); // beforeDrag 返回false，则无法拖拽

        if (this.tree.beforeDrag && this.tree.beforeDrag(this.node.data, this.node) === false) {
          return;
        }

        var _this = this;

        var leftDist = 20; // 移动节点距离鼠标有20px的位移

        var moveConfig = this.tree.moveConfig;
        moveConfig.mouseDownFlag = true;
        moveConfig.moveNode = this.node;
        moveConfig.$el = this.$el;
        moveConfig.nodeHtml = this.$el.children[0].innerHTML;
        moveConfig.clientX = event.clientX;
        moveConfig.clientY = event.clientY;
        moveConfig.top = moveConfig.clientY + this.tree.$el.scrollTop;
        moveConfig.left = moveConfig.clientX + this.tree.$el.scrollLeft + leftDist; // 在body上绑定onmousemove事件

        document.body.onmousemove = function (event) {
          _this.bodyMouseMove(event);
        }; // 在body上绑定mouseup事件


        document.body.onmouseup = function (event) {
          _this.bodyMouseUp(event);
        }; // 防止IE文字选中


        this.$el.onselectstart = function () {
          return false;
        };
      }
    },

    /**
     * 鼠标在节点上移动的事件
     * @author chenguanbin
     * @param {Event} [event] 事件触发时的事件对象
     */
    bodyMouseMove: function bodyMouseMove(event) {
      if (this.tree.move) {
        var moveConfig = this.tree.moveConfig;
        var x = event.clientX - moveConfig.clientX;
        var y = event.clientY - moveConfig.clientY;
        var reponseDistance = 2; // 拖拽响应距离设置为2px，一定程度上防止误操作
        // 鼠标点击后开始拖拽

        if (moveConfig.mouseDownFlag && (Math.abs(x) > reponseDistance || Math.abs(y) > reponseDistance)) {
          // 若正在移动标志为false
          if (!moveConfig.moveFlag) {
            moveConfig.moveFlag = true; // 若节点展开，收起自身节点

            if (moveConfig.moveNode.expanded && this.tree.moveArea !== 'outter') {
              moveConfig.moveNodeExpanded = true;
              moveConfig.moveNode.collapse();
            } // 触发开始拖拽事件：'node-drag'


            this.tree.$emit('node-drag', event, this.node.data, this.node, this);
          } // 被选中的节点跟着鼠标移动


          moveConfig.top += y;
          moveConfig.left += x;
          moveConfig.clientX = event.clientX;
          moveConfig.clientY = event.clientY; // 触发节点拖拽过程中的事件：'node-drag-move'

          this.tree.$emit('node-drag-move', event, this.node.data, this.node, this); // 若只能移动到树范围之外，则移动到树节点上无响应

          if (this.tree.moveArea === 'outter') return; // 判断是否还在树范围内

          if (this._isWinthinTree(event.target)) {
            // 获取 el-tree-node 节点
            var nodeEl = this._getNodeElement(event.target);

            if (!nodeEl.getAttribute) return;
            var key = nodeEl.getAttribute('data-key');
            var node = this.tree.store.getNode(key);
            var targetNode = moveConfig.targetNode;
            var moveNode = moveConfig.moveNode;

            if (targetNode !== node) {
              if (targetNode && moveConfig.movePosition !== 'out') {
                this.tree.$emit('node-drag-leave', event, moveNode, targetNode, this);
              }

              if (node.id !== moveNode.id) {
                this.tree.$emit('node-drag-enter', event, moveNode, node, this);
              }
            } // 设置目标节点


            moveConfig.targetNode = node;
            moveConfig.targetEl = nodeEl; // 移动到自身上隐藏箭头

            if (nodeEl === moveConfig.$el) {
              moveConfig.arrowFlag = false;
              return;
            } // 移动箭头位置


            this._moveArrow(nodeEl, moveConfig, event);
          } else {
            if (moveConfig.movePosition !== 'out') {
              this.tree.$emit('node-drag-leave', event, moveConfig.moveNode, null, this);
            } // 移出树范围后，移除箭头


            moveConfig.arrowFlag = false;
            moveConfig.movePosition = 'out';
          }
        }
      }
    },

    /**
     * @desc 移动箭头位置
     * @author chenguanbin
     * @param {Document} nodeEl el-tree-node 节点
     * @param {Object} moveConfig 节点移动时的各参数
     */
    _moveArrow: function _moveArrow(nodeEl, moveConfig) {
      var contentNode = nodeEl.querySelector('.el-tree-node__content');
      var treeOffset = this.tree.$el.getBoundingClientRect();
      var offset = model_util_getOffset(contentNode, this.tree.$el);
      var top = moveConfig.top - treeOffset.top + this.tree.scrollTop; // 计算出目前鼠标位于树控件顶部的距离，有滚动条时需要加上滚动条距离

      var nodeHeight = this.tree.nodeHeight || 32; // 节点高度为32px

      var dis = this.tree.nodeHeight ? this.tree.nodeHeight / 4 : 8; // 拖拽响应距离： 0-8px（兄弟前节点）  9-24px（子节点）  25-31px（兄弟后节点）

      var count = 0; // 计算拖动了多少个节点的距离

      while (top >= nodeHeight) {
        top -= nodeHeight;
        count++;
      }

      var targetNode = moveConfig.targetNode; // 添加到目标节点之前

      if (top >= 0 && top < dis) {
        moveConfig.arrowTop = count * nodeHeight;
        moveConfig.movePosition = 'prev';
        moveConfig.arrowFlag = true;
      } else if (top > nodeHeight - dis && top < nodeHeight) {
        // 添加到目标节点之后
        moveConfig.arrowTop = (count + 1) * nodeHeight - 1; // 减1px，为了区分添加到节点前后的情况

        moveConfig.movePosition = 'next';
        moveConfig.arrowFlag = true;
      } else {
        // 添加到子节点
        moveConfig.movePosition = 'inner';
        moveConfig.arrowFlag = false;
        targetNode.childNodes.length && targetNode.expand();
      } // 目标节点为叶子节点时，指示线的起点要去掉展开图标的尺寸32px；


      var iconOffset = this.tree.nodeHeight || 32;
      var borderOffset = 2; // 采用默认border为2px透明的方式，所以要去掉边框的偏移

      var paddingLeft = parseInt(contentNode.style.paddingLeft);
      moveConfig.arrowLeft = offset.left + (targetNode.isLeaf === true ? paddingLeft + iconOffset + borderOffset : paddingLeft + borderOffset);
    },

    /**
     * 在body上绑定的mouseup事件
     * @author chenguanbin
     * @param {Event} [event] 事件触发时的事件对象
     */
    bodyMouseUp: function bodyMouseUp(event) {
      var _this6 = this;

      var tree = this.tree;
      var moveConfig = tree.moveConfig; // 停止拖拽

      moveConfig.mouseDownFlag = false; // 若节点正在移动

      if (moveConfig.moveFlag) {
        // 节点停止移动
        moveConfig.moveFlag = false; // 判断是否还在树范围之内

        if (this._isWinthinTree(event.target)) {
          // 若只能移动到树范围之外
          if (tree.moveArea === 'outter') return; // 获取目标节点

          var targetNode = moveConfig.targetNode; // 若目标节点不是正在移动的节点，则移动节点

          if (this.node.data !== targetNode.data) {
            var todo = function todo() {
              // 触发'node-drop'事件
              tree.$emit('node-drop', event, _this6.node.data, _this6.node, targetNode, moveConfig.movePosition, _this6); // 移动节点

              var newNode = tree.store.move(_this6.node.data, targetNode.data, moveConfig.movePosition);
              var store = _this6.tree.store;
              store.setCurrentNode(newNode);

              _this6.tree.$emit('current-change', store.currentNode ? store.currentNode.data : null, store.currentNode);

              _this6.tree.currentNode = newNode;
            }; // beforeDrop 返回false，则无法完成拖拽


            if (tree.beforeDrop) {
              var result = this.tree.beforeDrop(this.node.data, this.node, targetNode, moveConfig.movePosition);
              if (result === false) return;
              if (result === undefined) result = true;
              Promise.resolve(result).then(function (allowed) {
                if (allowed) {
                  todo();
                }
              });
            } else {
              todo();
            }
          } // 若节点拖拽前为展开状态


          if (moveConfig.moveNodeExpanded) {
            this.$nextTick(function () {
              var node = tree.getNode(moveConfig.moveNode.key);
              node.expand();
              moveConfig.moveNodeExpanded = false; // 若目标节点不是正在移动的节点，则展开子节点

              if (_this6.node.data !== targetNode.data) {
                _this6.expandChildNodes(moveConfig.moveNode.childNodes);
              }
            });
          }

          tree.$emit('node-drag-end', event, this.node.data, this.node, targetNode, moveConfig.movePosition, this);
        } else {
          // beforeDrop 返回false，则无法完成拖拽
          if (tree.beforeDrop && tree.beforeDrop(this.node.data, this.node, null, 'out') === false) {
            return;
          } // 触发'node-drop'事件


          tree.$emit('node-drop', event, this.node.data, this.node, null, 'out', this);
          tree.$emit('node-drag-end', event, this.node.data, this.node, null, 'out', this);
        }
      }
    },

    /**
     * @desc 根据子节点在拖拽前的状态，展开子节点
     * @author chenguanbin
     * @param {Array} nodes 子节点
     */
    expandChildNodes: function expandChildNodes(childNodes) {
      var _iterator = _createForOfIteratorHelper(childNodes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          var node = this.tree.getNode(child.key); // 子节点在拖拽前未展开状态，则展开节点

          child.expanded && node.expand();
          var _childNodes = child.childNodes;
          if (_childNodes && _childNodes.length) this.expandChildNodes(_childNodes);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },

    /**
     * 判断是否还在树范围内
     */
    _isWinthinTree: function _isWinthinTree(node) {
      var isWinthin = false;

      while (node.tagName.toLocaleLowerCase() !== 'body') {
        if (hasClass(node, 'el-tree')) {
          isWinthin = true;
          break;
        }

        node = node.parentNode;
      }

      return isWinthin;
    },

    /**
     * 获取节点元素
     */
    _getNodeElement: function _getNodeElement(node) {
      while (node && node.getAttribute && !node.getAttribute('data-key')) {
        node = node.parentNode;
      }

      return node;
    }
  }
});
// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tree_nodevue_type_script_lang_js_ = (tree_nodevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue





/* normalize component */

var tree_node_component = normalizeComponent(
  src_tree_nodevue_type_script_lang_js_,
  tree_nodevue_type_template_id_32db894e_render,
  tree_nodevue_type_template_id_32db894e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tree_node = (tree_node_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var treevue_type_script_lang_js_ = ({
  name: 'ElTree',
  components: {
    ElScrollbar: scrollbar,
    ElTreeNode: tree_node
  },
  mixins: [emitter],
  props: {
    data: {
      type: Array,
      "default": null
    },
    emptyText: {
      type: String,
      "default": function _default() {
        return Object(locale_["t"])('el.tree.emptyText');
      }
    },
    renderAfterExpand: {
      type: Boolean,
      "default": true
    },
    renderWhenExpand: {
      type: Boolean,
      "default": false
    },
    nodeKey: {
      type: String,
      "default": ''
    },
    parentKey: {
      type: String,
      "default": ''
    },
    checkStrictly: {
      type: Boolean,
      "default": null
    },
    defaultExpandAll: {
      type: Boolean,
      "default": null
    },
    expandOnClickNode: {
      type: Boolean,
      "default": false
    },
    checkOnClickNode: {
      type: Boolean,
      "default": false
    },
    expandOnDbclickNode: {
      type: Boolean,
      "default": true
    },
    checkDescendants: {
      type: Boolean,
      "default": false
    },
    autoExpandParent: {
      type: Boolean,
      "default": true
    },
    defaultCheckedKeys: {
      type: Array,
      "default": null
    },
    defaultExpandedKeys: {
      type: Array,
      "default": null
    },
    renderContent: {
      type: Function,
      "default": null
    },
    showCheckbox: {
      type: Boolean,
      "default": false
    },
    props: {
      type: Object,
      "default": function _default() {
        return {
          children: 'children',
          label: 'label',
          icon: 'icon',
          svgIcon: 'svgIcon',
          svgIconOffline: 'svgIconOffline',
          disabled: 'disabled',
          selectable: 'selectable',
          isLeaf: 'isLeaf'
        };
      }
    },
    lazy: {
      type: Boolean,
      "default": false
    },
    highlightCurrent: {
      type: Boolean,
      "default": true
    },
    currentNodeKey: {
      type: [String, Number],
      "default": ''
    },
    load: {
      type: Function,
      "default": null
    },
    filterNodeMethod: {
      type: Function,
      "default": null
    },
    accordion: {
      type: Boolean,
      "default": null
    },
    indent: {
      type: Number,
      "default": 16
    },
    // 是否使用简单数据结构
    simpleData: {
      type: Boolean,
      "default": false
    },
    // 是否可移动
    move: {
      type: Boolean,
      "default": null
    },
    moveStyle: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    // 节点可拖拽的区域： all(全部) outter(只能拖拽到树区域以外)
    moveArea: {
      type: String,
      "default": 'all'
    },
    // 用于捕获节点被拖拽之前的事件回调函数，若返回 false， 则无法拖拽节点
    beforeDrag: {
      type: Function,
      "default": null
    },
    // 用于捕获节点拖拽操作结束之前的事件回调函数，若返回 false 则无法终止拖拽
    beforeDrop: {
      type: Function,
      "default": null
    },
    // 用于捕获单击节点之前的事件回调函数，若返回 false， 则无法进行单击操作
    beforeClick: {
      type: Function,
      "default": null
    },
    // 是否显示图标
    showIcon: {
      type: Boolean,
      "default": false
    },
    // 默认图标
    defaultIcon: {
      type: String,
      "default": ''
    },
    border: {
      type: Boolean,
      "default": false
    },
    scrollSize: {
      type: Number,
      "default": 6
    },
    customSrcollbar: {
      type: Boolean,
      "default": false
    },
    nodeHeight: {
      type: Number,
      "default": null
    }
  },
  data: function data() {
    return {
      store: null,
      root: null,
      currentNode: null,
      scrollTop: 0,
      moveConfig: {
        mouseDownFlag: false,
        // 鼠标点击节点标志
        moveFlag: false,
        // 节点正在移动标志
        moveNode: null,
        // 被移动的节点
        moveNodeExpanded: false,
        // 节点被移动前是否已经展开
        $el: null,
        // 被移动节点的 DOM
        targetNode: null,
        // 目标节点
        targetEl: null,
        // 目标节点的 DOm
        movePosition: 'inner',
        // 节点被移动到目标节点的位置: inner(目标节点内) prev(目标节点之前) next(目标节点之后)
        nodeHtml: '',
        // 模拟节点：被移动节点的 html
        top: 0,
        // 模拟节点的 top 值
        left: 0,
        // 模拟节点的 left 值
        clientX: 0,
        // 记录开始移动时鼠标的 X 轴定位
        clientY: 0,
        // 记录开始移动时鼠标的 Y 轴定位
        arrowFlag: false,
        // 是否显示箭头
        arrowTop: 0,
        // 箭头 top 值
        arrowLeft: 0 // 箭头 left 值

      },
      defaultProps: {
        children: 'children',
        label: 'label',
        icon: 'icon',
        svgIcon: 'svgIcon',
        svgIconOffline: 'svgIconOffline',
        svgIconColor: 'svgIconColor',
        svgIconColorActive: 'svgIconColorActive',
        svgIconRequire: 'svgIconRequire',
        disabled: 'disabled',
        selectable: 'selectable',
        isLeaf: 'isLeaf'
      }
    };
  },
  computed: {
    children: {
      set: function set(value) {
        this.data = value;
      },
      get: function get() {
        return this.data;
      }
    },
    moveBlockStyle: function moveBlockStyle() {
      var offset = {
        top: this.moveConfig.top + 'px',
        left: this.moveConfig.left + 'px'
      };
      return Object.assign({}, this.moveStyle, offset);
    },
    wrapContainer: function wrapContainer() {
      return this.customSrcollbar ? 'div' : 'el-scrollbar';
    }
  },
  watch: {
    lazy: function lazy(newVal) {
      this.store.lazy = newVal;
    },
    defaultExpandAll: function defaultExpandAll(newVal) {
      this.store.defaultExpandAll = newVal;
    },
    defaultCheckedKeys: function defaultCheckedKeys(newVal) {
      this.store.defaultCheckedKeys = newVal;
      this.store.setDefaultCheckedKey(newVal);
    },
    defaultExpandedKeys: function defaultExpandedKeys(newVal) {
      this.store.defaultExpandedKeys = newVal;
      this.store.setDefaultExpandedKeys(newVal);
    },
    currentNodeKey: function currentNodeKey(newVal) {
      this.store.setCurrentNodeKey(newVal);
      this.store.currentNodeKey = newVal;
    },
    data: function data(newVal) {
      // 启用简单数据，则在改变data后处理数据
      // 判断是否有nodeKey和parentKey
      if (this.simpleData && this.nodeKey && this.parentKey) {
        newVal = formatData(newVal, this.nodeKey, this.parentKey);
      }

      this.store.setData(newVal);
    }
  },
  created: function created() {
    this.isTree = true;
    var _data = this.data;
    this.defaultProps = _objectSpread2(_objectSpread2({}, this.defaultProps), this.props); // 若启用简单数据
    // 判断是否有nodeKey 和 parentKey

    if (this.simpleData && this.nodeKey && this.parentKey) {
      _data = formatData(this.data, this.nodeKey, this.parentKey); // 简单数据结构直接设置 children，这样无需在外部 props 中传入

      this.defaultProps.children = 'children';
    }

    this.store = new tree_store_TreeStore({
      key: this.nodeKey,
      parentKey: this.parentKey,
      data: _data,
      lazy: this.lazy,
      props: this.defaultProps,
      simpleData: this.simpleData,
      load: this.load,
      currentNodeKey: this.currentNodeKey,
      checkStrictly: this.checkStrictly,
      checkDescendants: this.checkDescendants,
      defaultCheckedKeys: this.defaultCheckedKeys,
      defaultExpandedKeys: this.defaultExpandedKeys,
      autoExpandParent: this.autoExpandParent,
      defaultExpandAll: this.defaultExpandAll,
      filterNodeMethod: this.filterNodeMethod
    });
    this.root = this.store.root;
  },
  mounted: function mounted() {
    this.$refs.scrollbar && !this.customSrcollbar && this.$refs.scrollbar.update();
  },
  methods: {
    filter: function filter(value, keepAlive) {
      if (!this.filterNodeMethod) {
        throw new Error('[Tree] filterNodeMethod is required when filter');
      }

      this.store.filter(value, keepAlive);
    },
    getNodeKey: function getNodeKey(node, index) {
      var nodeKey = this.nodeKey;

      if (nodeKey && node) {
        return node.data[nodeKey];
      }

      return index;
    },
    getCheckedNodes: function getCheckedNodes(leafOnly, checkedOnly) {
      return this.store.getCheckedNodes(leafOnly, checkedOnly);
    },
    getCheckedKeys: function getCheckedKeys(leafOnly, checkedOnly) {
      return this.store.getCheckedKeys(leafOnly, checkedOnly);
    },
    setCheckedNodes: function setCheckedNodes(nodes, leafOnly, rootOnly) {
      if (!this.nodeKey) {
        throw new Error('[Tree] nodeKey is required in setCheckedNodes');
      }

      this.store.setCheckedNodes(nodes, leafOnly, rootOnly);
    },
    setCheckedKeys: function setCheckedKeys(keys, leafOnly, rootOnly) {
      if (!this.nodeKey) {
        throw new Error('[Tree] nodeKey is required in setCheckedNodes');
      }

      this.store.setCheckedKeys(keys, leafOnly, rootOnly);
    },
    setChecked: function setChecked(data, checked, deep) {
      this.store.setChecked(data, checked, deep);
    },
    handleNodeExpand: function handleNodeExpand(nodeData, node, instance) {
      var _this = this;

      this.broadcast('ElTreeNode', 'tree-node-expand', node);
      this.$emit('node-expand', nodeData, node, instance);
      setTimeout(function () {
        _this.$refs.scrollbar && !_this.customSrcollbar && _this.$refs.scrollbar.update();
      }, 300);
    },
    handleNodeCollapse: function handleNodeCollapse() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$refs.scrollbar && !_this2.customSrcollbar && _this2.$refs.scrollbar.update();
      }, 300);
    },

    /**
     * 手动触发，重新渲染滚动条
     */
    resizeScrollbar: function resizeScrollbar() {
      this.$refs.scrollbar && !this.customSrcollbar && this.$refs.scrollbar.update();
    },

    /**
     * 选中目标节点
     * @param {Object/String} data 选中节点的 key 或者 data
     * @param {Boolean} selected 节点是否选中
     */
    setSelected: function setSelected(data) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var store = this.store;
      var node = store.getNode(data);

      if (selected) {
        store.setCurrentNode(node);
        this.currentNode = node;
      } else {
        store.setCurrentNode(null);
        this.currentNode = null;
      }

      this.$emit('current-change', node.data, node);
    },
    getSelectedNode: function getSelectedNode() {
      return this.store.currentNode;
    },
    getSelectedKey: function getSelectedKey() {
      return this.store.currentNode ? this.getNodeKey(this.store.currentNode) : '';
    },
    getHalfCheckedNodes: function getHalfCheckedNodes() {
      return this.store.getHalfCheckedNodes();
    },
    getHalfCheckedKeys: function getHalfCheckedKeys() {
      return this.store.getHalfCheckedKeys();
    },
    setCurrentNode: function setCurrentNode(data) {
      if (!this.nodeKey) {
        throw new Error('[Tree] nodeKey is required in setCurrentNode');
      }

      this.store.setUserCurrentNode(data);
    },
    setCurrentKey: function setCurrentKey(key) {
      if (!this.nodeKey) {
        throw new Error('[Tree] nodeKey is required in setCurrentKey');
      }

      this.store.setCurrentNodeKey(key);
    },
    getNode: function getNode(data) {
      return this.store.getNode(data);
    },
    remove: function remove(data) {
      this.store.remove(data);
    },
    append: function append(data, parentNode) {
      this.store.append(data, parentNode);
    },
    insertBefore: function insertBefore(data, refNode) {
      this.store.insertBefore(data, refNode);
    },
    insertAfter: function insertAfter(data, refNode) {
      this.store.insertAfter(data, refNode);
    },
    expandNode: function expandNode(data) {
      var store = this.store;
      var node = store.getNode(data);
      node && node.expand();
    },
    collapseNode: function collapseNode(data) {
      var store = this.store;
      var node = store.getNode(data);
      node && node.collapse();
    },
    onScrollingX: function onScrollingX(s) {
      var scrollLeft = s.scrollLeft,
          percentX = s.percentX;
      this.$emit('on-scrolling-x', {
        scrollLeft: scrollLeft,
        percentX: percentX
      });
      this.$emit('on-scrolling', s);
    },
    onScrollingY: function onScrollingY(s) {
      var scrollTop = s.scrollTop,
          percentY = s.percentY;
      this.scrollTop = scrollTop;
      this.$emit('on-scrolling-y', {
        scrollTop: scrollTop,
        percentY: percentY
      });
      this.$emit('on-scrolling', s);
    },
    reload: function reload(data, done) {
      this.store.reload(data, done);
    }
  }
});
// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_treevue_type_script_lang_js_ = (treevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tree/src/tree.vue





/* normalize component */

var tree_component = normalizeComponent(
  src_treevue_type_script_lang_js_,
  treevue_type_template_id_05ac4e3d_render,
  treevue_type_template_id_05ac4e3d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tree = (tree_component.exports);
// CONCATENATED MODULE: ./packages/tree/index.js


/* istanbul ignore next */

tree.install = function (Vue) {
  Vue.component(tree.name, tree);
};

/* harmony default export */ var packages_tree = (tree);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=template&id=57916940&
var mainvue_type_template_id_57916940_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-alert-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-alert",class:[_vm.typeClass, _vm.isSimple, _vm.isCenter]},[(_vm.showIcon)?_c('h-feedback-icon',{staticClass:"el-alert__icon",attrs:{"icon-name":_vm.iconClass}}):_vm._e(),_c('div',{staticClass:"el-alert__content",class:[_vm.showIcon ? 'is-icon' : '', _vm.closable ? 'is-close' : '']},[(_vm.title || _vm.$slots.title)?_c('span',{staticClass:"el-alert__title",class:[_vm.isBoldTitle, _vm.isSimple]},[_vm._t("title",[_vm._v(" "+_vm._s(_vm.title)+" ")])],2):_vm._e(),_vm._t("default",[(_vm.description)?_c('p',{staticClass:"el-alert__description",class:[_vm.isSimple, _vm.title ? 'is-title' : '']},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e()]),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.closable),expression:"closable"}],staticClass:"el-alert__closebtn",class:[_vm.isCustomed, _vm.iconCloseClass],on:{"click":function($event){return _vm.close()}}},[_vm._v(" "+_vm._s(_vm.closeText)+" ")])],2)],1)])}
var mainvue_type_template_id_57916940_staticRenderFns = []


// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=template&id=57916940&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var TYPE_CLASSES_MAP = {
  success: 'h-icon-feedback_success_sm',
  warning: 'h-icon-feedback_warning_sm',
  error: 'h-icon-feedback_error_sm',
  info: 'h-icon-feedback_info_sm'
};
/* harmony default export */ var alert_src_mainvue_type_script_lang_js_ = ({
  name: 'ElAlert',
  props: {
    title: {
      type: String,
      "default": ''
    },
    description: {
      type: String,
      "default": ''
    },
    type: {
      type: String,
      "default": 'info'
    },
    center: {
      type: Boolean,
      "default": false
    },
    closable: {
      type: Boolean,
      "default": true
    },
    closeText: {
      type: String,
      "default": ''
    },
    closeIcon: {
      type: String,
      "default": ''
    },
    showIcon: {
      type: Boolean,
      "default": false
    },
    icon: {
      type: String,
      "default": ''
    },
    simple: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      visible: true
    };
  },
  computed: {
    typeClass: function typeClass() {
      return "el-alert--".concat(this.type);
    },
    isSimple: function isSimple() {
      return this.simple ? 'is-simple' : '';
    },
    isCenter: function isCenter() {
      return this.center ? 'is-center' : '';
    },
    iconClass: function iconClass() {
      if (this.icon === '') {
        return this.type ? TYPE_CLASSES_MAP[this.type] : '';
      } else {
        return this.icon;
      }
    },
    isCustomed: function isCustomed() {
      return this.closeText ? 'is-customed' : '';
    },
    iconCloseClass: function iconCloseClass() {
      return this.closeText === '' ? this.closeIcon ? this.closeIcon : 'h-icon-close_sm' : '';
    },
    isBoldTitle: function isBoldTitle() {
      return this.description || this.$slots["default"] ? 'is-bold' : '';
    }
  },
  methods: {
    close: function close() {
      this.visible = false;
      this.$emit('close');
    }
  }
});
// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_alert_src_mainvue_type_script_lang_js_ = (alert_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/alert/src/main.vue





/* normalize component */

var alert_src_main_component = normalizeComponent(
  packages_alert_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_57916940_render,
  mainvue_type_template_id_57916940_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var alert_src_main = (alert_src_main_component.exports);
// CONCATENATED MODULE: ./packages/alert/index.js


/* istanbul ignore next */

alert_src_main.install = function (Vue) {
  Vue.component(alert_src_main.name, alert_src_main);
};

/* harmony default export */ var packages_alert = (alert_src_main);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=template&id=78826cc6&
var mainvue_type_template_id_78826cc6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-notification-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-notification",class:[_vm.customClass, _vm.sizeClass, _vm.horizontalClass],style:(_vm.positionStyle),on:{"mouseenter":function($event){return _vm.clearTimer()},"mouseleave":function($event){return _vm.startTimer()},"click":_vm.click}},[_c('div',{staticClass:"el-notification__group"},[_c('div',{staticClass:"el-notification__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"el-notification__content"},[_vm._t("default",[(!_vm.dangerouslyUseHTMLString)?_c('p',[_vm._v(" "+_vm._s(_vm.message)+" ")]):_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],2),(_vm.showClose)?_c('div',{staticClass:"el-notification__closeBtn h-icon-close_sm",on:{"click":function($event){$event.stopPropagation();return _vm.close($event)}}}):_vm._e()]),(_vm.pages.length >= 2)?_c('div',{staticClass:"el-notification__pagination"},[_c('el-pagination',{attrs:{"total":_vm.pages.length * 10,"page-count":4,"small":"","layout":"first, prev, miniPager, next, last"},on:{"current-change":_vm.handlePageChange}})],1):_vm._e()])])}
var mainvue_type_template_id_78826cc6_staticRenderFns = []


// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=template&id=78826cc6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var src_mainvue_type_script_lang_js_sizeMap = {
  small: 'small',
  middle: 'middle',
  large: 'large'
};
/* harmony default export */ var notification_src_mainvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      visible: false,
      title: '',
      message: '',
      duration: 3000,
      showClose: true,
      size: 'small',
      customClass: '',
      onClose: null,
      onClick: null,
      closed: false,
      verticalOffset: 0,
      position: 'top-right',
      timer: null,
      pages: [],
      activePageIndex: 0,
      dangerouslyUseHTMLString: false
    };
  },
  computed: {
    sizeClass: function sizeClass() {
      return src_mainvue_type_script_lang_js_sizeMap[this.size] ? "el-notification--".concat(src_mainvue_type_script_lang_js_sizeMap[this.size]) : 'el-notification--small';
    },
    horizontalClass: function horizontalClass() {
      return this.position.indexOf('right') > -1 ? 'right' : 'left';
    },
    verticalProperty: function verticalProperty() {
      return /^top-/.test(this.position) ? 'top' : 'bottom';
    },
    positionStyle: function positionStyle() {
      return _defineProperty({}, this.verticalProperty, "".concat(this.verticalOffset, "px"));
    }
  },
  watch: {
    closed: function closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.$el.addEventListener('transitionend', this.destroyElement);
      }
    },
    pages: function pages(val) {
      if (val.length !== 1) return;
      this.renderPage(0);
    },
    activePageIndex: function activePageIndex(val) {
      this.renderPage(val);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        if (!_this.closed) {
          _this.close();
        }
      }, this.duration);
    }
  },
  methods: {
    destroyElement: function destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    renderPage: function renderPage(index) {
      this.message = this.pages[index].content;
      this.title = this.pages[index].title;
    },
    click: function click() {
      if (typeof this.onClick === 'function') {
        this.onClick();
      }
    },
    close: function close() {
      this.closed = true;

      if (typeof this.onClose === 'function') {
        this.onClose();
      }
    },
    clearTimer: function clearTimer() {
      clearTimeout(this.timer);
    },
    startTimer: function startTimer() {
      var _this2 = this;

      if (this.duration > 0) {
        this.timer = setTimeout(function () {
          if (!_this2.closed) {
            _this2.close();
          }
        }, this.duration);
      }
    },
    handlePageChange: function handlePageChange(currentPage) {
      this.activePageIndex = currentPage - 1;
    }
  }
});
// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_notification_src_mainvue_type_script_lang_js_ = (notification_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/notification/src/main.vue





/* normalize component */

var notification_src_main_component = normalizeComponent(
  packages_notification_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_78826cc6_render,
  mainvue_type_template_id_78826cc6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var notification_src_main = (notification_src_main_component.exports);
// CONCATENATED MODULE: ./packages/notification/src/main.js









var NotificationConstructor = external_vue_default.a.extend(notification_src_main);
var src_main_instance;
var main_instances = []; // Notification的实例信息

var pages = []; // 分页的页数信息

var main_seed = 1;

var main_Notification = function Notification(options) {
  if (external_vue_default.a.prototype.$isServer) return;
  options = options || {};
  var id = 'notification_' + main_seed++;
  var position = options.position || 'top-right'; // 非分页场景和 分页场景的第一页 都需要新建一个Notification实例

  if (!(options.pagination && pages.length)) {
    var userOnClose = options.onClose;

    options.onClose = function () {
      Notification.close(id, userOnClose);
    };

    src_main_instance = new NotificationConstructor({
      data: options
    });

    if (options.pagination) {
      // 分页的第一条信息  更新pages
      pages.push({
        content: options.message,
        title: options.title
      });
      options.pages = pages;
      var offset = options.offset || 0;
      src_main_instance.verticalOffset = offset + 16;
    } else {
      // 非分页场景 单条或者多条时都包含 考虑多个实例时的偏移问题
      var verticalOffset = options.offset || 0;
      main_instances.filter(function (item) {
        return item.position === position;
      }).forEach(function (item) {
        verticalOffset += item.$el.offsetHeight + 16;
      });
      verticalOffset += 16;
      src_main_instance.verticalOffset = verticalOffset;
    }

    if (isVNode(options.message)) {
      src_main_instance.$slots["default"] = [options.message];
      options.message = 'REPLACED_BY_VNODE';
    }

    src_main_instance.id = id;
    src_main_instance.vm = src_main_instance.$mount();
    document.body.appendChild(src_main_instance.vm.$el);
    src_main_instance.vm.visible = true;
    src_main_instance.dom = src_main_instance.vm.$el;
    src_main_instance.dom.style.zIndex = popup_manager.nextZIndex();
    main_instances.push(src_main_instance);
    return src_main_instance.vm;
  } else {
    // 分页情况下的后续页
    // 第一个实例的timeout清零
    src_main_instance.clearTimer();
    pages.push({
      content: options.message,
      title: options.title
    });
    options.pages = pages;
    options.message = '';
    src_main_instance.id = id;
    src_main_instance.startTimer();
  }
};

main_Notification.close = function (id, userOnClose) {
  var index = -1;
  var len = main_instances.length;
  var instance = main_instances.filter(function (instance, i) {
    if (instance.id === id) {
      index = i;
      return true;
    }

    return false;
  })[0];
  if (!instance) return;

  if (typeof userOnClose === 'function') {
    userOnClose(instance);
  }

  main_instances.splice(index, 1);
  if (len <= 1) return;
  var position = instance.position;
  var removedHeight = instance.dom.offsetHeight;

  for (var i = index; i < len - 1; i++) {
    if (main_instances[i].position === position) {
      main_instances[i].dom.style[instance.verticalProperty] = parseInt(main_instances[i].dom.style[instance.verticalProperty], 10) - removedHeight - 16 + 'px';
    }
  }

  pages = [];
};

/* harmony default export */ var packages_notification_src_main = (main_Notification);
// CONCATENATED MODULE: ./packages/notification/index.js

/* harmony default export */ var notification = (packages_notification_src_main);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=template&id=6061b506&
var mainvue_type_template_id_6061b506_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-slider",class:{
    'is-vertical': _vm.vertical,
    'el-slider--with-input': _vm.showInput,
    'el-slider--with-button': _vm.internalShowButton
  }},[(_vm.showInput && !_vm.range)?_c('el-input-number',{ref:"input",staticClass:"el-slider__input",attrs:{"step":_vm.step,"disabled":_vm.disabled,"controls":_vm.showInputControls,"min":_vm.min,"max":_vm.max,"debounce":_vm.debounce},model:{value:(_vm.firstValue),callback:function ($$v) {_vm.firstValue=$$v},expression:"firstValue"}}):_vm._e(),(_vm.internalShowButton)?_c('el-button',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.onFirstButtonClick),expression:"onFirstButtonClick"}],attrs:{"icon":("h-icon-" + (_vm.vertical ? 'add' : 'minus'))}}):_vm._e(),_c('div',{ref:"slider",staticClass:"el-slider__runway",class:{
      'show-input': _vm.showInput,
      'show-button': _vm.internalShowButton,
      disabled: _vm.disabled
    },style:(_vm.runwayStyle)},[_c('div',{staticClass:"el-slider__runway-click-area",on:{"click":_vm.onSliderClick}}),_c('div',{staticClass:"el-slider__bar",style:(_vm.barStyle)}),_c('slider-button',{ref:"button1",attrs:{"vertical":_vm.vertical},on:{"slider-click-value-change":_vm.sliderClickValueChange,"drag-end":_vm.dragEnd,"button-down":function($event){return _vm.buttonDown(_vm.sliderInput)}},model:{value:(_vm.firstValue),callback:function ($$v) {_vm.firstValue=$$v},expression:"firstValue"}}),(_vm.range)?_c('slider-button',{ref:"button2",attrs:{"vertical":_vm.vertical},on:{"drag-end":_vm.dragEnd,"button-down":function($event){return _vm.buttonDown(_vm.sliderInput2)}},model:{value:(_vm.secondValue),callback:function ($$v) {_vm.secondValue=$$v},expression:"secondValue"}}):_vm._e(),(_vm.showStops)?_c('div',[_vm._l((_vm.stops),function(item,index){return [_c('div',{key:index,staticClass:"el-slider__stop-wrap"},[_c('div',{staticClass:"el-slider__stop el-slider__stop--top el-slider__stop--left",style:(_vm.vertical ? { bottom: item + '%' } : { left: item + '%' })}),_c('div',{staticClass:"el-slider__stop el-slider__stop--bottom el-slider__stop--right",style:(_vm.vertical ? { bottom: item + '%' } : { left: item + '%' })})])]})],2):_vm._e()],1),(_vm.internalShowButton)?_c('el-button',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.onSecondButtonClick),expression:"onSecondButtonClick"}],attrs:{"icon":("h-icon-" + (_vm.vertical ? 'minus' : 'add'))}}):_vm._e()],1)}
var mainvue_type_template_id_6061b506_staticRenderFns = []


// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=template&id=6061b506&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=template&id=33118c53&
var buttonvue_type_template_id_33118c53_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"button",staticClass:"el-slider__button-wrapper",class:{ hover: _vm.hovering, dragging: _vm.dragging },style:(_vm.wrapperStyle),on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave,"mousedown":_vm.onButtonDown}},[_c('el-tooltip',{ref:"tooltip",attrs:{"disabled":!_vm.showTooltip,"effect":"light","placement":"top"}},[_c('span',{attrs:{"slot":"content"},slot:"content"},[_vm._v(" "+_vm._s(_vm.formatValue)+" ")]),_c('div',{staticClass:"el-slider__button",class:{ hover: _vm.hovering, dragging: _vm.dragging }})])],1)}
var buttonvue_type_template_id_33118c53_staticRenderFns = []


// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=template&id=33118c53&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var slider_src_buttonvue_type_script_lang_js_ = ({
  name: 'ElSliderButton',
  components: {
    ElTooltip: packages_tooltip
  },
  props: {
    value: {
      type: Number,
      "default": 0
    },
    vertical: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      hovering: false,
      dragging: false,
      startX: 0,
      currentX: 0,
      startY: 0,
      currentY: 0,
      startPosition: 0,
      newPosition: null,
      oldValue: this.value
    };
  },
  computed: {
    disabled: function disabled() {
      return this.$parent.disabled;
    },
    max: function max() {
      return this.$parent.max;
    },
    min: function min() {
      return this.$parent.min;
    },
    step: function step() {
      return this.$parent.step;
    },
    showTooltip: function showTooltip() {
      return this.$parent.showTooltip && !(this.$parent.showInput && this.$parent.range);
    },
    precision: function precision() {
      return this.$parent.precision;
    },
    currentPosition: function currentPosition() {
      return "".concat((this.value - this.min) / (this.max - this.min) * 100, "%");
    },
    enableFormat: function enableFormat() {
      return this.$parent.formatTooltip instanceof Function;
    },
    formatValue: function formatValue() {
      return this.enableFormat && this.$parent.formatTooltip(this.value) || this.value;
    },
    wrapperStyle: function wrapperStyle() {
      return this.vertical ? {
        bottom: this.currentPosition
      } : {
        left: this.currentPosition
      };
    }
  },
  watch: {
    dragging: function dragging(val) {
      this.$parent.dragging = val;
    }
  },
  methods: {
    displayTooltip: function displayTooltip() {
      this.$refs.tooltip && (this.$refs.tooltip.showPopper = true);
    },
    hideTooltip: function hideTooltip() {
      this.$refs.tooltip && (this.$refs.tooltip.showPopper = false);
    },
    handleMouseEnter: function handleMouseEnter() {
      this.hovering = true;
      this.displayTooltip();
    },
    handleMouseLeave: function handleMouseLeave() {
      this.hovering = false;
      this.hideTooltip();
    },
    onButtonDown: function onButtonDown(event) {
      if (this.disabled) return;
      event.preventDefault();
      this.$emit('button-down');
      this.onDragStart(event);
      window.addEventListener('mousemove', this.onDragging);
      window.addEventListener('mouseup', this.onDragEnd);
      window.addEventListener('contextmenu', this.onDragEnd);
    },
    onDragStart: function onDragStart(event) {
      this.dragging = true;

      if (this.vertical) {
        this.startY = event.clientY;
      } else {
        this.startX = event.clientX;
      }

      this.startPosition = parseFloat(this.currentPosition); // add by zhangxiaogang

      this.$parent.$emit('drag-start', event, this.oldValue);
    },
    onDragging: function onDragging(event) {
      if (this.dragging) {
        this.displayTooltip();
        this.$parent.resetSize();
        var diff = 0;

        if (this.vertical) {
          this.currentY = event.clientY;
          diff = (this.startY - this.currentY) / this.$parent.sliderSize * 100;
        } else {
          this.currentX = event.clientX;
          diff = (this.currentX - this.startX) / this.$parent.sliderSize * 100;
        }

        this.newPosition = this.startPosition + diff;
        this.setPosition(this.newPosition);
      }
    },
    onDragEnd: function onDragEnd() {
      var _this = this;

      if (this.dragging) {
        /*
         * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
         * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
         */
        setTimeout(function () {
          _this.dragging = false;

          _this.hideTooltip();

          _this.setPosition(_this.newPosition); // add by zhangxiaogang


          _this.$emit('drag-end');
        }, 0);
        window.removeEventListener('mousemove', this.onDragging);
        window.removeEventListener('mouseup', this.onDragEnd);
        window.removeEventListener('contextmenu', this.onDragEnd);
      }
    },
    setPosition: function setPosition(newPosition, type) {
      if (newPosition === null) return;

      if (newPosition < 0) {
        newPosition = 0;
      } else if (newPosition > 100) {
        newPosition = 100;
      }

      var lengthPerStep = 100 / ((this.max - this.min) / this.step);
      var steps = Math.round(newPosition / lengthPerStep);
      var value = steps * lengthPerStep * (this.max - this.min) * 0.01 + this.min;
      value = parseFloat(value.toFixed(this.precision));
      this.newPosition = newPosition;
      this.$emit('input', value);
      type && this.$emit(type, value);
      this.$refs.tooltip && this.$refs.tooltip.updatePopper();

      if (!this.dragging && this.value !== this.oldValue) {
        this.oldValue = this.value;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_slider_src_buttonvue_type_script_lang_js_ = (slider_src_buttonvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/slider/src/button.vue





/* normalize component */

var src_button_component = normalizeComponent(
  packages_slider_src_buttonvue_type_script_lang_js_,
  buttonvue_type_template_id_33118c53_render,
  buttonvue_type_template_id_33118c53_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var slider_src_button = (src_button_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/input.vue?vue&type=template&id=0f48dcef&
var inputvue_type_template_id_0f48dcef_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input-number',{ref:"rangeInput",staticClass:"el-slider__range-input",attrs:{"step":_vm.slider.step,"disabled":_vm.slider.disabled,"controls":_vm.slider.showInputControls,"min":_vm.slider.min,"max":_vm.slider.max,"debounce":_vm.slider.debounce},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var inputvue_type_template_id_0f48dcef_staticRenderFns = []


// CONCATENATED MODULE: ./packages/slider/src/input.vue?vue&type=template&id=0f48dcef&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/input.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var slider_src_inputvue_type_script_lang_js_ = ({
  name: 'ElSliderInput',
  components: {
    ElInputNumber: packages_input_number
  },
  mixins: [vue_popper],
  props: {
    placement: {
      type: String,
      "default": 'top'
    },
    value: {
      type: Number,
      "default": 0
    }
  },
  data: function data() {
    return {
      slider: {
        step: 1,
        disabled: false,
        showInputControls: true,
        min: 0,
        max: 100,
        debounce: 300
      },
      button: null
    };
  },
  watch: {
    value: function value(val) {
      if (typeof val !== 'undefined') {
        this.$emit('change', val);
      }
    }
  },
  mounted: function mounted() {
    this.popperElm = this.$el;
    this.referenceElm = this.button;
    this.showPopper = true;
  }
});
// CONCATENATED MODULE: ./packages/slider/src/input.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_slider_src_inputvue_type_script_lang_js_ = (slider_src_inputvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/slider/src/input.vue





/* normalize component */

var src_input_component = normalizeComponent(
  packages_slider_src_inputvue_type_script_lang_js_,
  inputvue_type_template_id_0f48dcef_render,
  inputvue_type_template_id_0f48dcef_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_input = (src_input_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=script&lang=js&







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var slider_src_mainvue_type_script_lang_js_ = ({
  name: 'ElSlider',
  components: {
    ElInputNumber: packages_input_number,
    SliderButton: slider_src_button
  },
  directives: {
    RepeatClick: repeat_click
  },
  mixins: [emitter],
  props: {
    min: {
      type: Number,
      "default": 0
    },
    max: {
      type: Number,
      "default": 100
    },
    step: {
      type: Number,
      "default": 1
    },
    value: {
      type: [Number, Array],
      "default": 0
    },
    showInput: {
      type: Boolean,
      "default": false
    },
    showButton: {
      type: Boolean,
      "default": false
    },
    showInputControls: {
      type: Boolean,
      "default": true
    },
    showStops: {
      type: Boolean,
      "default": false
    },
    showTooltip: {
      type: Boolean,
      "default": true
    },
    formatTooltip: {
      type: Function,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    range: {
      type: Boolean,
      "default": false
    },
    vertical: {
      type: Boolean,
      "default": false
    },
    height: {
      type: String,
      "default": ''
    },
    debounce: {
      type: Number,
      "default": 300
    }
  },
  data: function data() {
    return {
      firstValue: null,
      secondValue: null,
      oldValue: null,
      dragging: false,
      sliderSize: 1,
      sliderInput: null,
      sliderInput2: null
    };
  },
  computed: {
    stops: function stops() {
      if (this.step === 0) {
         false && false;
        return [];
      }

      var stopCount = (this.max - this.min) / this.step;
      var stepWidth = 100 * this.step / (this.max - this.min);
      var result = [];

      for (var i = 0; i <= stopCount; i++) {
        result.push(i * stepWidth);
      }

      return result;
    },
    minValue: function minValue() {
      return Math.min(this.firstValue, this.secondValue);
    },
    maxValue: function maxValue() {
      return Math.max(this.firstValue, this.secondValue);
    },
    barSize: function barSize() {
      return this.range ? "".concat(100 * (this.maxValue - this.minValue) / (this.max - this.min), "%") : "".concat(100 * (this.firstValue - this.min) / (this.max - this.min), "%");
    },
    barStart: function barStart() {
      return this.range ? "".concat(100 * (this.minValue - this.min) / (this.max - this.min), "%") : '0%';
    },
    precision: function precision() {
      var precisions = [this.min, this.max, this.step].map(function (item) {
        var decimal = ('' + item).split('.')[1];
        return decimal ? decimal.length : 0;
      });
      return Math.max.apply(null, precisions);
    },
    runwayStyle: function runwayStyle() {
      return this.vertical ? {
        height: this.height
      } : {};
    },
    barStyle: function barStyle() {
      return this.vertical ? {
        height: this.barSize,
        bottom: this.barStart
      } : {
        width: this.barSize,
        left: this.barStart
      };
    },
    internalShowButton: function internalShowButton() {
      return this.showButton && !this.range && !this.showInput;
    }
  },
  watch: {
    value: function value(val, oldVal) {
      if (this.dragging || Array.isArray(val) && Array.isArray(oldVal) && val.every(function (item, index) {
        return item === oldVal[index];
      })) {
        return;
      }

      this.setValues();
    },
    dragging: function dragging(val) {
      if (!val) {
        this.setValues();
      }
    },
    firstValue: function firstValue(val) {
      if (this.range) {
        this.$emit('input', [this.minValue, this.maxValue]);
      } else {
        this.$emit('input', val);
      }
    },
    secondValue: function secondValue() {
      if (this.range) {
        this.$emit('input', [this.minValue, this.maxValue]);
      }
    },
    min: function min() {
      this.setValues();
    },
    max: function max() {
      this.setValues();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.range) {
      if (Array.isArray(this.value)) {
        this.firstValue = Math.max(this.min, this.value[0]);
        this.secondValue = Math.min(this.max, this.value[1]);
      } else {
        this.firstValue = this.min;
        this.secondValue = this.max;
      }

      this.oldValue = [this.firstValue, this.secondValue]; // 增加范围选择带输入框 add by yangzhini at 2019-4-18

      if (this.showInput) {
        this.sliderInput = this.createInputElement(0);
        this.sliderInput2 = this.createInputElement(1);
        this.$watch('value', function (val) {
          _this.sliderInput.value = _this.firstValue;
          _this.sliderInput2.value = _this.secondValue;

          _this.sliderInput.updatePopper();

          _this.sliderInput2.updatePopper();
        });
      }
    } else {
      if (typeof this.value !== 'number' || isNaN(this.value)) {
        this.firstValue = this.min;
      } else {
        this.firstValue = Math.min(this.max, Math.max(this.min, this.value));
      }

      this.oldValue = this.firstValue;
    }

    this.resetSize();
    window.addEventListener('resize', this.resetSize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resetSize);

    if (this.sliderInput) {
      this.sliderInput.$destroy(true);
    }

    if (this.sliderInput2) {
      this.sliderInput2.$destroy(true);
    }
  },
  methods: {
    valueChanged: function valueChanged() {
      var _this2 = this;

      if (this.range) {
        return ![this.minValue, this.maxValue].every(function (item, index) {
          return item === _this2.oldValue[index];
        });
      } else {
        return this.value !== this.oldValue;
      }
    },
    setValues: function setValues() {
      if (this.min > this.max) {
        console.error('[Hui Error][Slider]min should not be greater than max.');
        return;
      }

      var val = this.value;

      if (this.range && Array.isArray(val)) {
        if (val[1] < this.min) {
          this.$emit('input', [this.min, this.min]);
        } else if (val[0] > this.max) {
          this.$emit('input', [this.max, this.max]);
        } else if (val[0] < this.min) {
          this.$emit('input', [this.min, val[1]]);
        } else if (val[1] > this.max) {
          this.$emit('input', [val[0], this.max]);
        } else {
          this.firstValue = val[0];
          this.secondValue = val[1];

          if (this.valueChanged()) {
            this.$emit('change', [this.minValue, this.maxValue]);
            this.dispatch('ElFormItem', 'el.form.change', [this.minValue, this.maxValue]);
            this.oldValue = val.slice();
          }
        }
      } else if (!this.range && typeof val === 'number' && !isNaN(val)) {
        if (val < this.min) {
          this.$emit('input', this.min);
        } else if (val > this.max) {
          this.$emit('input', this.max);
        } else {
          this.firstValue = val;

          if (this.valueChanged()) {
            this.$emit('change', val);
            this.dispatch('ElFormItem', 'el.form.change', val);
            this.oldValue = val;
          }
        }
      }
    },
    setPosition: function setPosition(percent, type) {
      var targetValue = this.min + percent * (this.max - this.min) / 100;

      if (!this.range) {
        this.$refs.button1.setPosition(percent, type);
        return;
      }

      var button;

      if (Math.abs(this.minValue - targetValue) < Math.abs(this.maxValue - targetValue)) {
        button = this.firstValue < this.secondValue ? 'button1' : 'button2';
      } else {
        button = this.firstValue > this.secondValue ? 'button1' : 'button2';
      }

      this.$refs[button].setPosition(percent, type);
    },
    onSliderClick: function onSliderClick(event) {
      if (this.disabled || this.dragging) return; // add by zhangxiaogang

      this.$emit('before-click', event, this.range && Array.isArray(this.value) ? [this.minValue, this.maxValue] : this.value);
      this.resetSize();

      if (this.vertical) {
        var sliderOffsetBottom = this.$refs.slider.getBoundingClientRect().bottom;
        this.setPosition((sliderOffsetBottom - event.clientY) / this.sliderSize * 100, 'slider-click-value-change');
      } else {
        var sliderOffsetLeft = this.$refs.slider.getBoundingClientRect().left;
        this.setPosition((event.clientX - sliderOffsetLeft) / this.sliderSize * 100, 'slider-click-value-change');
      }
    },
    sliderClickValueChange: function sliderClickValueChange(value) {
      if (this.range && Array.isArray(value)) {
        this.$emit('slider-click', [this.minValue, this.maxValue]);
      } else {
        this.$emit('slider-click', value);
      }
    },
    onSecondButtonClick: function onSecondButtonClick() {
      this.vertical ? this.firstValue -= this.step : this.firstValue += this.step;
    },
    onFirstButtonClick: function onFirstButtonClick() {
      this.vertical ? this.firstValue += this.step : this.firstValue -= this.step;
    },
    resetSize: function resetSize() {
      if (this.$refs.slider) {
        this.sliderSize = this.$refs.slider["client".concat(this.vertical ? 'Height' : 'Width')];
      }
    },
    // add by zhangxiaogang
    dragEnd: function dragEnd() {
      if (this.range && Array.isArray(this.value)) {
        this.$emit('drag-end', [this.minValue, this.maxValue]);
      } else {
        this.$emit('drag-end', this.value);
      }
    },
    // range show-input 情况下，点击 button聚焦 input add by yangzhini
    buttonDown: function buttonDown(sliderInput) {
      if (!sliderInput) return;
      this.sliderInputSelect(sliderInput);
    },
    sliderInputSelect: function sliderInputSelect(sliderInput) {
      if (!sliderInput) return;
      sliderInput.$refs.rangeInput.$refs.input.$refs.input.select();
    },
    // add by yangzhini
    createInputElement: function createInputElement(index) {
      var _this3 = this;

      var sliderInput = new external_vue_default.a(src_input);
      sliderInput.value = this.value[index];
      sliderInput.button = this.$refs["button".concat(index + 1)].$el;
      sliderInput.slider = this;
      !this.$isServer && sliderInput.$mount(document.createElement('div'));
      sliderInput.$on('change', function (value) {
        if (index === 0) {
          _this3.firstValue = value;
        } else {
          _this3.secondValue = value;
        } // 解决[1,6]变为[6,9]时（即1改为9）显示为[9,9]的问题


        sliderInput.$refs.rangeInput.$refs.input.$refs.input.value = value;
        sliderInput.updatePopper();
      });
      return sliderInput;
    }
  }
});
// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_slider_src_mainvue_type_script_lang_js_ = (slider_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/slider/src/main.vue





/* normalize component */

var slider_src_main_component = normalizeComponent(
  packages_slider_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_6061b506_render,
  mainvue_type_template_id_6061b506_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var slider_src_main = (slider_src_main_component.exports);
// CONCATENATED MODULE: ./packages/slider/index.js


/* istanbul ignore next */

slider_src_main.install = function (Vue) {
  Vue.component(slider_src_main.name, slider_src_main);
};

/* harmony default export */ var slider = (slider_src_main);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=template&id=3daff638&
var loadingvue_type_template_id_3daff638_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-loading-fade"},on:{"after-leave":_vm.handleAfterLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-loading-mask",class:[_vm.customClass, { 'is-fullscreen': _vm.fullscreen }]},[_c('div',{staticClass:"el-loading-spinner"},[_c('loading-icon',{staticClass:"h-icon-loading loading-icon"}),(_vm.text)?_c('p',{staticClass:"el-loading-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],1)])])}
var loadingvue_type_template_id_3daff638_staticRenderFns = []


// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=template&id=3daff638&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/loading-icon.vue?vue&type=template&id=ea67e116&
var loading_iconvue_type_template_id_ea67e116_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h-an-icon-loading"},[_c('span',{ref:"path1",staticClass:"path1"}),_c('span',{ref:"path2",staticClass:"path2"}),_c('span',{ref:"path3",staticClass:"path3"}),_c('span',{ref:"path4",staticClass:"path4"})])}
var loading_iconvue_type_template_id_ea67e116_staticRenderFns = []


// CONCATENATED MODULE: ./packages/icon/src/loading-icon.vue?vue&type=template&id=ea67e116&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/loading-icon.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
/* harmony default export */ var loading_iconvue_type_script_lang_js_ = ({
  name: 'ElLoadIcon',
  data: function data() {
    return {
      interval: []
    };
  },
  mounted: function mounted() {
    if (navigator.appName === 'Microsoft Internet Explorer' && navigator.appVersion.split(';')[1].replace(/[ ]/g, '') === 'MSIE9.0' && !this.dataPicker) {
      this.animation({
        time: 0,
        ref: this.$refs.path1
      });
      this.animation({
        time: 600,
        ref: this.$refs.path2
      });
      this.animation({
        time: 800,
        ref: this.$refs.path3
      });
      this.animation({
        time: 1000,
        ref: this.$refs.path4
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i in this.interval) {
      this.interval[i] && clearInterval(this.interval[i]);
    }
  },
  methods: {
    scale: function scale(_scale, ref) {
      ref.style.msTransform = 'scale(' + (1 + _scale) + ')';
      ref.style.opacity = 0.3 + _scale;
    },
    animation: function animation(op) {
      var _this = this;

      setTimeout(function () {
        var scale = 0;
        var isUp = true;
        var interval = setInterval(function () {
          if (scale === 0.7 || scale > 0.7) {
            isUp = false;
          } else if (scale === 0 || scale < 0) {
            isUp = true;
          }

          scale = isUp ? scale + 0.1 : scale - 0.1;

          _this.scale(scale, op.ref);
        }, 80);

        _this.interval.push(interval);
      }, op.time);
    }
  }
});
// CONCATENATED MODULE: ./packages/icon/src/loading-icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_loading_iconvue_type_script_lang_js_ = (loading_iconvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/icon/src/loading-icon.vue





/* normalize component */

var loading_icon_component = normalizeComponent(
  src_loading_iconvue_type_script_lang_js_,
  loading_iconvue_type_template_id_ea67e116_render,
  loading_iconvue_type_template_id_ea67e116_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var loading_icon = (loading_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loadingvue_type_script_lang_js_ = ({
  components: {
    loadingIcon: loading_icon
  },
  data: function data() {
    return {
      text: null,
      fullscreen: true,
      visible: false,
      customClass: ''
    };
  },
  methods: {
    handleAfterLeave: function handleAfterLeave() {
      this.$emit('after-leave');
    },
    setText: function setText(text) {
      this.text = text;
    }
  }
});
// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_loadingvue_type_script_lang_js_ = (loadingvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/loading/src/loading.vue





/* normalize component */

var loading_component = normalizeComponent(
  src_loadingvue_type_script_lang_js_,
  loadingvue_type_template_id_3daff638_render,
  loadingvue_type_template_id_3daff638_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_loading = (loading_component.exports);
// CONCATENATED MODULE: ./packages/loading/src/directive.js






 // let Mask = Vue.extend(require('./loading.vue'));

var Mask = external_vue_default.a.extend(src_loading);
/* harmony default export */ var src_directive = ({
  install: function install(Vue) {
    if (Vue.prototype.$isServer) return;

    var toggleLoading = function toggleLoading(el, binding) {
      if (binding.value) {
        Vue.nextTick(function () {
          if (binding.modifiers.fullscreen) {
            el.originalPosition = getStyle(document.body, 'position');
            el.originalOverflow = getStyle(document.body, 'overflow'); // 获取overflowX、overflowY值，在结束loading设置

            el.originalOverflowX = getStyle(document.body, 'overflowX');
            el.originalOverflowY = getStyle(document.body, 'overflowY');
            addClass(el.mask, 'is-fullscreen');
            insertDom(document.body, el, binding);
          } else {
            removeClass(el.mask, 'is-fullscreen');

            if (binding.modifiers.body) {
              el.originalPosition = getStyle(document.body, 'position');
              ['top', 'left'].forEach(function (property) {
                var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
                el.maskStyle[property] = el.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] + 'px';
              });
              ['height', 'width'].forEach(function (property) {
                el.maskStyle[property] = el.getBoundingClientRect()[property] + 'px';
              });
              insertDom(document.body, el, binding);
            } else {
              el.originalPosition = getStyle(el, 'position');
              insertDom(el, el, binding);
            }
          }
        });
      } else {
        if (el.domVisible) {
          el.instance.$on('after-leave', function () {
            el.domVisible = false; // 结束loading时，分别设置overflowX、overflowY，
            // 解决ie11下overflow多个值无法设置的问题，如：overflow: hidden auto;

            if (binding.modifiers.fullscreen && (el.originalOverflowX !== 'hidden' || el.originalOverflowY !== 'hidden')) {
              if (el.originalOverflowX === el.originalOverflowY) {
                document.body.style.overflow = el.originalOverflow;
              } else {
                document.body.style.overflow = '';
                document.body.style.overflowX = el.originalOverflowX;
                document.body.style.overflowY = el.originalOverflowY;
              }
            }

            if (binding.modifiers.fullscreen || binding.modifiers.body) {
              document.body.style.position = el.originalPosition;
            } else {
              el.style.position = el.originalPosition;
            }
          });
          Vue.nextTick(function () {
            el.instance.visible = false;
          });
        }
      } // icon大小


      if (binding.modifiers.mini) {
        addClass(el.mask, 'is-mini');
      } else if (binding.modifiers.small) {
        addClass(el.mask, 'is-small');
      } else if (binding.modifiers.large) {
        addClass(el.mask, 'is-large');
      } else {
        addClass(el.mask, 'is-default');
      } // 主题色


      addClass(el.mask, binding.modifiers.gray ? 'is-gray' : 'is-primary');
    };

    var insertDom = function insertDom(parent, el, binding) {
      if (!el.domVisible && getStyle(el, 'display') !== 'none' && getStyle(el, 'visibility') !== 'hidden') {
        Object.keys(el.maskStyle).forEach(function (property) {
          el.mask.style[property] = el.maskStyle[property];
        });

        if (el.originalPosition !== 'absolute' && el.originalPosition !== 'fixed') {// parent.style.position = 'relative';
        }

        if (binding.modifiers.fullscreen && binding.modifiers.lock) {
          parent.style.overflow = 'hidden';
        }

        el.domVisible = true;
        parent.appendChild(el.mask);
        Vue.nextTick(function () {
          el.instance.visible = true;
        });
        el.domInserted = true;
      }
    };

    Vue.directive('loading', {
      bind: function bind(el, binding) {
        var mask = new Mask({
          el: document.createElement('div'),
          data: {
            text: el.getAttribute('element-loading-text'),
            fullscreen: !!binding.modifiers.fullscreen
          }
        });
        el.instance = mask;
        el.mask = mask.$el;
        el.maskStyle = {};
        toggleLoading(el, binding);
      },
      update: function update(el, binding) {
        el.instance.setText(el.getAttribute('element-loading-text'));

        if (binding.oldValue !== binding.value) {
          toggleLoading(el, binding);
        }
      },
      unbind: function unbind(el) {
        if (el.domInserted) {
          /* if (binding.modifiers.fullscreen || binding.modifiers.body) {
            document.body.removeChild(el.mask);
          } else { */
          el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask); // }
        }

        el.instance && el.instance.$destroy();
      }
    });
  }
});
// CONCATENATED MODULE: ./packages/loading/src/index.js







var LoadingConstructor = external_vue_default.a.extend(src_loading);
var src_defaults = {
  text: null,
  fullscreen: true,
  body: false,
  lock: false,
  customClass: ''
};
var fullscreenLoading;
LoadingConstructor.prototype.originalPosition = '';
LoadingConstructor.prototype.originalOverflow = '';

LoadingConstructor.prototype.close = function () {
  var _this = this;

  if (this.fullscreen && this.originalOverflow !== 'hidden') {
    document.body.style.overflow = this.originalOverflow;
  }

  if (this.fullscreen || this.body) {
    document.body.style.position = this.originalPosition;
  } else {
    this.target.style.position = this.originalPosition;
  }

  if (this.fullscreen) {
    fullscreenLoading = undefined;
  }

  this.$on('after-leave', function () {
    _this.$el && _this.$el.parentNode && _this.$el.parentNode.removeChild(_this.$el);

    _this.$destroy();
  });
  external_vue_default.a.nextTick(function () {
    _this.visible = false;
  });
};

var src_addStyle = function addStyle(options, parent, instance) {
  var maskStyle = {};

  if (options.fullscreen) {
    instance.originalPosition = getStyle(document.body, 'position');
    instance.originalOverflow = getStyle(document.body, 'overflow');
  } else if (options.body) {
    instance.originalPosition = getStyle(document.body, 'position');
    ['top', 'left'].forEach(function (property) {
      var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
      maskStyle[property] = options.target.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] + 'px';
    });
    ['height', 'width'].forEach(function (property) {
      maskStyle[property] = options.target.getBoundingClientRect()[property] + 'px';
    });
  } else {
    instance.originalPosition = getStyle(parent, 'position');
  }

  Object.keys(maskStyle).forEach(function (property) {
    instance.$el.style[property] = maskStyle[property];
  });
};

var src_Loading = function Loading() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (external_vue_default.a.prototype.$isServer) return;
  options = merge({}, src_defaults, options);

  if (typeof options.target === 'string') {
    options.target = document.querySelector(options.target);
  }

  options.target = options.target || document.body;

  if (options.target !== document.body) {
    options.fullscreen = false;
  } else {
    options.body = true;
  }

  if (options.fullscreen && fullscreenLoading) {
    return fullscreenLoading;
  }

  var parent = options.body ? document.body : options.target;
  var instance = new LoadingConstructor({
    el: document.createElement('div'),
    data: options
  });
  src_addStyle(options, parent, instance);

  if (instance.originalPosition !== 'absolute' && instance.originalPosition !== 'fixed') {// parent.style.position = 'relative';
  }

  if (options.fullscreen && options.lock) {
    parent.style.overflow = 'hidden';
  }

  parent.appendChild(instance.$el);
  external_vue_default.a.nextTick(function () {
    instance.visible = true;
  });

  if (options.fullscreen) {
    fullscreenLoading = instance;
  } // icon大小


  addClass(instance.$el, options.size ? "is-".concat(options.size) : 'is-default'); // 主题色

  addClass(instance.$el, options.color ? "is-".concat(options.color) : 'is-primary');
  return instance;
};

/* harmony default export */ var loading_src = (src_Loading);
// CONCATENATED MODULE: ./packages/loading/index.js


/* harmony default export */ var packages_loading = ({
  install: function install(Vue) {
    Vue.use(src_directive);
    Vue.prototype.$loading = loading_src;
  },
  directive: src_directive,
  service: loading_src
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=template&id=51fa78d1&
var iconvue_type_template_id_51fa78d1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:'h-icon-' + _vm.name})}
var iconvue_type_template_id_51fa78d1_staticRenderFns = []


// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=template&id=51fa78d1&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */ var iconvue_type_script_lang_js_ = ({
  name: 'ElIcon',
  props: {
    name: {
      type: String,
      "default": null
    }
  }
});
// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_iconvue_type_script_lang_js_ = (iconvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/icon/src/icon.vue





/* normalize component */

var icon_component = normalizeComponent(
  src_iconvue_type_script_lang_js_,
  iconvue_type_template_id_51fa78d1_render,
  iconvue_type_template_id_51fa78d1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_icon = (icon_component.exports);
// CONCATENATED MODULE: ./packages/icon/index.js


/* istanbul ignore next */

src_icon.install = function (Vue) {
  Vue.component(src_icon.name, src_icon);
};

/* harmony default export */ var packages_icon = (src_icon);
// CONCATENATED MODULE: ./packages/loading-icon/index.js


/* istanbul ignore next */

loading_icon.install = function (Vue) {
  Vue.component(loading_icon.name, loading_icon);
};

/* harmony default export */ var packages_loading_icon = (loading_icon);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/feedback-icon.vue?vue&type=template&id=7ed91ee5&
var feedback_iconvue_type_template_id_7ed91ee5_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.feedbackIcon},[_c('span',{staticClass:"path1"}),_c('span',{staticClass:"path2"})])}
var feedback_iconvue_type_template_id_7ed91ee5_staticRenderFns = []


// CONCATENATED MODULE: ./packages/icon/src/feedback-icon.vue?vue&type=template&id=7ed91ee5&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/feedback-icon.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
/* harmony default export */ var feedback_iconvue_type_script_lang_js_ = ({
  name: 'HFeedbackIcon',
  props: {
    iconName: {
      type: String,
      "default": undefined
    }
  },
  computed: {
    feedbackIcon: function feedbackIcon() {
      return !this.iconName.includes('h-icon-') ? "h-icon-".concat(this.iconName) : this.iconName;
    }
  }
});
// CONCATENATED MODULE: ./packages/icon/src/feedback-icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_feedback_iconvue_type_script_lang_js_ = (feedback_iconvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/icon/src/feedback-icon.vue





/* normalize component */

var feedback_icon_component = normalizeComponent(
  src_feedback_iconvue_type_script_lang_js_,
  feedback_iconvue_type_template_id_7ed91ee5_render,
  feedback_iconvue_type_template_id_7ed91ee5_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var feedback_icon = (feedback_icon_component.exports);
// CONCATENATED MODULE: ./packages/feedback-icon/index.js


/* istanbul ignore next */

feedback_icon.install = function (Vue) {
  Vue.component(feedback_icon.name, feedback_icon);
};

/* harmony default export */ var packages_feedback_icon = (feedback_icon);
// CONCATENATED MODULE: ./packages/row/src/row.js

/* harmony default export */ var src_row = ({
  name: 'ElRow',
  componentName: 'ElRow',
  props: {
    tag: {
      type: String,
      "default": 'div'
    },
    gutter: Number,
    type: String,
    justify: {
      type: String,
      "default": 'start'
    },
    align: {
      type: String,
      "default": 'top'
    }
  },
  computed: {
    style: function style() {
      var ret = {};

      if (this.gutter) {
        ret.marginLeft = "-".concat(this.gutter / 2, "px");
        ret.marginRight = ret.marginLeft;
      }

      return ret;
    }
  },
  render: function render(h) {
    return h(this.tag, {
      "class": ['el-row', this.justify !== 'start' ? "is-justify-".concat(this.justify) : '', this.align !== 'top' ? "is-align-".concat(this.align) : '', {
        'el-row--flex': this.type === 'flex'
      }],
      style: this.style
    }, this.$slots["default"]);
  }
});
// CONCATENATED MODULE: ./packages/row/index.js


/* istanbul ignore next */

src_row.install = function (Vue) {
  Vue.component(src_row.name, src_row);
};

/* harmony default export */ var packages_row = (src_row);
// EXTERNAL MODULE: external "core-js/modules/es.date.now.js"
var es_date_now_js_ = __webpack_require__("e893");

// EXTERNAL MODULE: external "core-js/modules/web.url.js"
var web_url_js_ = __webpack_require__("b94f");

// CONCATENATED MODULE: ./packages/upload/src/ajax.js






function getError(action, option, xhr) {
  var msg;

  if (xhr.response) {
    msg = "".concat(xhr.response.error || xhr.response);
  } else if (xhr.responseText) {
    msg = "".concat(xhr.responseText);
  } else {
    msg = "fail to post ".concat(action, " ").concat(xhr.status);
  }

  var err = new Error(msg);
  err.status = xhr.status;
  err.method = 'post';
  err.url = action;
  return err;
}

function getBody(xhr) {
  var text = xhr.responseText || xhr.response;

  if (!text) {
    return text;
  }

  try {
    var returnBody = JSON.parse(text);
    returnBody._xhr_ = xhr; // 加入response完整对象返回

    return returnBody;
  } catch (e) {
    return text;
  }
}

function upload(option) {
  if (typeof XMLHttpRequest === 'undefined') {
    return;
  }

  var xhr = new XMLHttpRequest();
  var action = option.action;

  if (xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }

      option.onProgress(e);
    };
  }

  var formData = new FormData();

  if (option.data) {
    Object.keys(option.data).forEach(function (key) {
      formData.append(key, option.data[key]);
    });
  }

  formData.append(option.filename, option.file);

  xhr.onerror = function error(e) {
    option.onError(e, xhr);
  };

  xhr.onload = function onload() {
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(action, option, xhr), xhr);
    }

    option.onSuccess(getBody(xhr), xhr);
  };

  xhr.open('post', action, true);

  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }

  var headers;

  if (option.headers) {
    headers = isFunction(option.headers) ? option.headers() : option.headers;
  } else {
    headers = {};
  }

  for (var item in headers) {
    if (hasOwn(headers, item) && headers[item] !== null) {
      xhr.setRequestHeader(item, headers[item]);
    }
  }

  xhr.send(formData);
  return xhr;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=template&id=57e7b2f3&
var upload_listvue_type_template_id_57e7b2f3_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:[
    'el-upload-list',
    'el-upload-list--' + _vm.listType,
    { 'is-disabled': _vm.disabled }
  ],attrs:{"name":"el-list"}},[_vm._l((_vm.files),function(file,index){return _c('li',{key:("" + index),class:['el-upload-list__item', 'is-' + file.status]},[_c('el-tooltip',{attrs:{"disabled":file.status !== 'fail',"content":_vm.errorTooltipText,"placement":"top","effect":"light"}},[_c('div',[(_vm.listType === 'text')?_c('i',{staticClass:"h-icon-attach"}):_vm._e(),_c('div',{staticClass:"el-upload-list__item-content"},[(
              ['picture-card', 'picture'].indexOf(_vm.listType) > -1 &&
                (file.percentage === undefined ||
                  file.percentage >= 100 ||
                  file.status === 'success' ||
                  _vm.autoUpload === false)
            )?_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"src":file.url,"alt":""}}):_vm._e(),(
              ['picture-card', 'picture'].indexOf(_vm.listType) > -1 &&
                file.percentage !== undefined &&
                file.percentage < 100
            )?_c('i',{staticClass:"uploading-close h-icon-close",on:{"click":function($event){return _vm.$emit('remove', file)}}}):_vm._e(),_c('span',{staticClass:"el-upload-list__item-name",style:({ width: _vm.fileNameWidth(file) }),on:{"click":function($event){return _vm.handleClick(file)}}},[_c('name-content',{attrs:{"file":file,"file-name-render":_vm.fileNameRender}})],1),_c('i',{staticClass:"list-icon-btn h-icon-close_sm",on:{"click":function($event){return _vm.$emit('remove', file)}}}),(file.status === 'fail' && _vm.listType === 'text')?_c('i',{staticClass:"list-icon-btn h-icon-refresh_sm",on:{"click":function($event){return _vm.handleReupload(file)}}}):_vm._e(),(file.status === 'uploading')?_c('el-progress',{attrs:{"show-text":false,"stroke-width":2,"percentage":_vm.parsePercentage(file.percentage),"type":"line"}}):_vm._e()],1),(
            _vm.listType === 'picture-card' &&
              (file.percentage === undefined ||
                file.percentage >= 100 ||
                file.status === 'success' ||
                _vm.autoUpload === false)
          )?_c('span',{staticClass:"el-upload-list__item-actions"},[(file.status === 'fail' && _vm.listType === 'picture-card')?_c('span',{staticClass:"el-upload-list__item-reupload",on:{"click":function($event){return _vm.handleReupload(file)}}},[_c('i',{staticClass:"h-icon-refresh"})]):_vm._e(),(
              file.status !== 'fail' &&
                _vm.handlePreview &&
                _vm.listType === 'picture-card'
            )?_c('span',{staticClass:"el-upload-list__item-preview",on:{"click":function($event){return _vm.handlePreview(file)}}},[_c('i',{staticClass:"h-icon-search"})]):_vm._e(),_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function($event){return _vm.$emit('remove', file)}}},[_c('i',{staticClass:"h-icon-delete"})])]):_vm._e()])])],1)}),_vm._t("default")],2)}
var upload_listvue_type_template_id_57e7b2f3_staticRenderFns = []


// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=template&id=57e7b2f3&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=fa14cf36&
var progressvue_type_template_id_fa14cf36_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-progress",class:[
    'el-progress--' + _vm.type,
    _vm.status ? 'is-' + _vm.status : '',
    _vm.verticalAlign ? 'is-text-vertical' : '',
    {
      'el-progress--without-text': !_vm.internalShowText,
      'el-progress--text-inside': _vm.textInside,
      'el-progress--small': _vm.internalSmall
    }
  ]},[(_vm.type === 'line')?_c('div',{staticClass:"el-progress-bar"},[_c('div',{staticClass:"el-progress-bar__outer",style:({
        height: _vm.internalStrokeWidth + 'px',
        'border-radius': _vm.strokeLinecap === 'square' ? '0px' : '100px'
      })},[_c('div',{staticClass:"el-progress-bar__inner",style:(_vm.barStyle)},[(_vm.internalShowText && _vm.textInside)?_c('div',{staticClass:"el-progress-bar__innerText"},[_vm._v(" "+_vm._s(_vm.percentage)+"% ")]):_vm._e(),(_vm.internalDynamic)?_c('div',{staticClass:"el-progress-bar__dynamic-block",style:(("animation-duration:" + _vm.duration + "s;"))}):_vm._e()])])]):_c('div',{staticClass:"el-progress-circle",style:({ height: _vm.width + 'px', width: _vm.width + 'px' })},[_c('svg',{attrs:{"viewBox":"0 0 100 100"}},[_c('path',{staticClass:"el-progress-circle__track",attrs:{"d":_vm.trackPath,"stroke-width":_vm.relativeStrokeWidth,"stroke":"#ebebeb","fill":"none"}}),_c('path',{staticClass:"el-progress-circle__path",style:(_vm.circlePathStyle),attrs:{"d":_vm.trackPath,"stroke":_vm.stroke,"stroke-width":_vm.relativeStrokeWidth,"fill":"none"}})])]),(_vm.internalShowText && !_vm.textInside)?_c('div',{staticClass:"el-progress__text",style:({ fontSize: _vm.progressTextSize + 'px' }),attrs:{"title":!_vm.status ? (_vm.percentage + "%") : _vm.statusText}},[_vm._t("text",[(!_vm.status)?[_vm._v(_vm._s(_vm.percentage)+"%")]:[_c('i',{class:_vm.iconClass,style:({ fontSize: _vm.iconSize + 'px' })}),(_vm.type === 'line')?_c('span',{staticClass:"el-progress__status-text"},[_vm._v(" "+_vm._s(_vm.statusText)+" ")]):_vm._e()]])],2):_vm._e()])}
var progressvue_type_template_id_fa14cf36_staticRenderFns = []


// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=fa14cf36&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var STROKE_WIDTH_SMALL = 8;
/* harmony default export */ var progressvue_type_script_lang_js_ = ({
  name: 'ElProgress',
  props: {
    type: {
      type: String,
      "default": 'line',
      validator: function validator(val) {
        return ['line', 'circle'].indexOf(val) > -1;
      }
    },
    percentage: {
      type: Number,
      "default": 0,
      validator: function validator(val) {
        return val >= 0 && val <= 100;
      }
    },
    status: {
      type: String,
      "default": ''
    },
    strokeWidth: {
      type: Number,
      "default": function _default() {
        return this.type === 'line' ? 12 : 8;
      }
    },
    textInside: {
      type: Boolean,
      "default": false
    },
    width: {
      type: Number,
      "default": 160
    },
    showText: {
      type: Boolean,
      "default": true
    },
    verticalAlign: {
      type: Boolean,
      "default": false
    },
    small: {
      type: Boolean,
      "default": false
    },
    color: {
      type: String,
      "default": ''
    },
    background: {
      type: String,
      "default": ''
    },
    statusText: {
      type: String,
      "default": ''
    },
    strokeLinecap: {
      type: String,
      "default": 'square'
    },
    dynamic: {
      type: Boolean,
      "default": false
    },
    // 动态进度条一次的播放时间,单位为秒 modify by yangzhini 2019-04-15
    duration: {
      type: Number,
      "default": 1.5,
      validator: function validator(val) {
        return val >= 0;
      }
    }
  },
  computed: {
    barStyle: function barStyle() {
      var style = {};
      style.backgroundColor = this.color;
      if (this.background) style.background = this.background; // 动态进度条在不知道进度的时候使用, 为配合动效, 将percentage设置为100%

      style.width = this.internalDynamic ? '100%' : this.percentage + '%';
      style.borderRadius = this.strokeLinecap === 'square' ? '0px' : '100px';
      return style;
    },
    relativeStrokeWidth: function relativeStrokeWidth() {
      // 进度圈暂不支持小型模式, 直接使用strokeWidth
      return (this.strokeWidth / this.width * 100).toFixed(1);
    },
    trackPath: function trackPath() {
      var radius = parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
      return "M 50 50 m 0 -".concat(radius, " a ").concat(radius, " ").concat(radius, " 0 1 1 0 ").concat(radius * 2, " a ").concat(radius, " ").concat(radius, " 0 1 1 0 -").concat(radius * 2);
    },
    perimeter: function perimeter() {
      var radius = 50 - parseFloat(this.relativeStrokeWidth) / 2;
      return 2 * Math.PI * radius;
    },
    circlePathStyle: function circlePathStyle() {
      var perimeter = this.perimeter;
      return {
        strokeDasharray: "".concat(perimeter, "px,").concat(perimeter, "px"),
        strokeDashoffset: (1 - this.percentage / 100) * perimeter + 'px',
        transition: 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease',
        strokeLinecap: this.strokeLinecap === 'square' ? 'butt' : 'round'
      };
    },
    stroke: function stroke() {
      var ret;

      switch (this.status) {
        case 'success':
          ret = this.color || '#02bf0f'; // $--color-success

          break;

        case 'exception':
          ret = this.color || '#fa3239'; // $--color-danger

          break;

        default:
          ret = this.color || '#2196f3';
        // $--color-info
      }

      return ret;
    },
    iconClass: function iconClass() {
      if (this.type === 'line') {
        return this.status === 'success' ? 'h-icon-tip_right' : 'h-icon-tip_error';
      } else {
        return this.status === 'success' ? 'h-icon-done' : 'h-icon-close';
      }
    },
    progressTextSize: function progressTextSize() {
      return this.type === 'line' ? 8 + this.internalStrokeWidth * 0.5 : this.width * 0.111111;
    },
    iconSize: function iconSize() {
      return this.type === 'line' ? 12 + this.internalStrokeWidth * 0.5 : this.width * 0.2 + 16;
    },
    // '小型'只在线形非内显进度条上生效
    internalSmall: function internalSmall() {
      return this.small && this.type === 'line' && !this.textInside;
    },
    // 确定所使用的线宽, 小型进度条优先使用8px线宽, 否则根据strokeWidth来设定线宽
    internalStrokeWidth: function internalStrokeWidth() {
      return this.internalSmall ? STROKE_WIDTH_SMALL : this.strokeWidth;
    },
    // 动态进度条不显示text
    internalShowText: function internalShowText() {
      return this.internalDynamic ? false : this.showText;
    },
    // 动态进度条暂时只支持线形进度条
    internalDynamic: function internalDynamic() {
      return this.dynamic && this.type === 'line';
    }
  }
});
// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_progressvue_type_script_lang_js_ = (progressvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/progress/src/progress.vue





/* normalize component */

var progress_component = normalizeComponent(
  src_progressvue_type_script_lang_js_,
  progressvue_type_template_id_fa14cf36_render,
  progressvue_type_template_id_fa14cf36_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var progress = (progress_component.exports);
// CONCATENATED MODULE: ./packages/progress/index.js


/* istanbul ignore next */

progress.install = function (Vue) {
  Vue.component(progress.name, progress);
};

/* harmony default export */ var packages_progress = (progress);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var upload_listvue_type_script_lang_js_ = ({
  components: {
    ElProgress: packages_progress,
    ElTooltip: packages_tooltip,
    NameContent: {
      props: {
        file: {
          required: true
        },
        fileNameRender: Function
      },
      render: function render(h) {
        var name = this.file.name;
        return this.fileNameRender ? this.fileNameRender(h, this.file) : h("span", [name]);
      }
    }
  },
  mixins: [locale],
  props: {
    files: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    handlePreview: {
      type: Function,
      "default": null
    },
    listType: {
      type: String,
      "default": ''
    },
    reupload: {
      type: Function,
      "default": null
    },
    fileNameRender: {
      type: Function,
      "default": null
    },
    errorTooltipText: {
      type: String,
      "default": 'upload error'
    },
    autoUpload: {
      type: Boolean,
      "default": true
    }
  },
  methods: {
    parsePercentage: function parsePercentage(val) {
      return parseInt(val, 10);
    },
    handleClick: function handleClick(file) {
      this.handlePreview && this.handlePreview(file);
    },
    handleReupload: function handleReupload(file) {
      this.reupload && this.reupload(file);
    },
    fileNameWidth: function fileNameWidth(file) {
      return file.status === 'fail' && this.listType === 'text' ? "calc(100% - 52px)" : "calc(100% - 28px)";
    }
  }
});
// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_upload_listvue_type_script_lang_js_ = (upload_listvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue





/* normalize component */

var upload_list_component = normalizeComponent(
  src_upload_listvue_type_script_lang_js_,
  upload_listvue_type_template_id_57e7b2f3_render,
  upload_listvue_type_template_id_57e7b2f3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var upload_list = (upload_list_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=template&id=50cb1215&
var upload_draggervue_type_template_id_50cb1215_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-upload-dragger",class:{
    'is-dragover': _vm.dragover
  },on:{"drop":function($event){$event.preventDefault();return _vm.onDrop($event)},"dragover":function($event){$event.preventDefault();return _vm.onDragover($event)},"dragleave":function($event){$event.preventDefault();_vm.dragover = false}}},[_vm._t("default")],2)}
var upload_draggervue_type_template_id_50cb1215_staticRenderFns = []


// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=template&id=50cb1215&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var upload_draggervue_type_script_lang_js_ = ({
  name: 'ElUploadDrag',
  props: {
    disabled: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      dragover: false
    };
  },
  methods: {
    onDragover: function onDragover() {
      if (!this.disabled) {
        this.dragover = true;
      }
    },
    onDrop: function onDrop(e) {
      if (!this.disabled) {
        this.dragover = false;
        this.$emit('file', e.dataTransfer.files);
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_upload_draggervue_type_script_lang_js_ = (upload_draggervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue





/* normalize component */

var upload_dragger_component = normalizeComponent(
  src_upload_draggervue_type_script_lang_js_,
  upload_draggervue_type_template_id_50cb1215_render,
  upload_draggervue_type_template_id_50cb1215_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var upload_dragger = (upload_dragger_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload.vue?vue&type=script&lang=js&













/* harmony default export */ var uploadvue_type_script_lang_js_ = ({
  inject: ['uploader'],
  components: {
    UploadDragger: upload_dragger
  },
  props: {
    visible: {
      type: Boolean,
      "default": true
    },
    type: {
      type: String,
      "default": ''
    },
    action: {
      type: String,
      required: true
    },
    name: {
      type: String,
      "default": 'file'
    },
    data: {
      type: Object,
      "default": null
    },
    headers: {
      type: [Function, Object],
      "default": null
    },
    withCredentials: {
      type: Boolean,
      "default": null
    },
    multiple: {
      type: Boolean,
      "default": null
    },
    accept: {
      type: String,
      "default": ''
    },
    onStart: {
      type: Function,
      "default": null
    },
    onProgress: {
      type: Function,
      "default": null
    },
    onSuccess: {
      type: Function,
      "default": null
    },
    onError: {
      type: Function,
      "default": null
    },
    beforeUpload: {
      type: Function,
      "default": null
    },
    drag: {
      type: Boolean,
      "default": null
    },
    onPreview: {
      type: Function,
      "default": function _default() {}
    },
    onRemove: {
      type: Function,
      "default": function _default() {}
    },
    fileList: {
      type: Array,
      "default": null
    },
    autoUpload: {
      type: Boolean,
      "default": null
    },
    listType: {
      type: String,
      "default": ''
    },
    httpRequest: {
      type: Function,
      "default": upload
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    limit: {
      type: Number,
      "default": null
    },
    onExceed: {
      type: Function,
      "default": function _default() {}
    }
  },
  data: function data() {
    return {
      mouseover: false,
      reqs: {}
    };
  },
  methods: {
    isImage: function isImage(str) {
      return str.indexOf('image') !== -1;
    },
    handleChange: function handleChange(ev) {
      var files = ev.target.files;
      if (!files) return;
      this.uploadFiles(files);
    },
    uploadFiles: function uploadFiles(files) {
      var _this = this;

      if (this.limit && this.fileList.length + files.length > this.limit) {
        this.onExceed && this.onExceed(files, this.fileList);
        return;
      }

      var postFiles = Array.prototype.slice.call(files);

      if (!this.multiple) {
        postFiles = postFiles.slice(0, 1);
      }

      if (postFiles.length === 0) {
        return;
      }

      this.$parent.uploadFilesAll = [];
      postFiles.forEach(function (rawFile) {
        _this.onStart(rawFile);

        if (_this.autoUpload) _this.upload(rawFile);
      });
    },
    upload: function upload(rawFile) {
      var _this2 = this;

      this.$refs.input.value = null;

      if (!this.beforeUpload) {
        return this.post(rawFile);
      }

      var before = this.beforeUpload(rawFile);

      if (before && before.then) {
        before.then(function (processedFile) {
          if (Object.prototype.toString.call(processedFile) === '[object File]') {
            _this2.post(processedFile);
          } else {
            _this2.post(rawFile);
          }
        }, function () {
          _this2.onRemove(null, rawFile);
        });
      } else if (before !== false) {
        this.post(rawFile);
      } else {
        this.onRemove(null, rawFile);
      }
    },
    abort: function abort(file) {
      var reqs = this.reqs;

      if (file) {
        var uid = file;
        if (file.uid) uid = file.uid;

        if (reqs[uid]) {
          reqs[uid].abort();
        }
      } else {
        Object.keys(reqs).forEach(function (uid) {
          if (reqs[uid]) reqs[uid].abort();
          delete reqs[uid];
        });
      }
    },
    post: function post(rawFile) {
      var _this3 = this;

      var uid = rawFile.uid;
      var options = {
        headers: this.headers,
        withCredentials: this.withCredentials,
        file: rawFile,
        data: this.data,
        filename: this.name,
        action: this.action,
        onProgress: function onProgress(e) {
          _this3.onProgress(e, rawFile);
        },
        onSuccess: function onSuccess(res, xhr) {
          _this3.onSuccess(res, rawFile, xhr);

          delete _this3.reqs[uid];
        },
        onError: function onError(err, xhr) {
          _this3.onError(err, rawFile, xhr);

          delete _this3.reqs[uid];
        }
      };
      var req = this.httpRequest(options);
      this.reqs[uid] = req;

      if (req && req.then) {
        req.then(options.onSuccess, options.onError);
      }
    },
    handleClick: function handleClick() {
      if (!this.disabled) {
        this.$refs.input.value = null;
        this.$refs.input.click();
      }
    }
  },
  render: function render() {
    var h = arguments[0];

    /* if (!this.visible) return; */
    var visible = this.visible,
        handleClick = this.handleClick,
        drag = this.drag,
        name = this.name,
        handleChange = this.handleChange,
        multiple = this.multiple,
        accept = this.accept,
        listType = this.listType,
        uploadFiles = this.uploadFiles,
        disabled = this.disabled;
    var data = {
      "class": {
        'el-upload': true
      },
      on: {
        click: handleClick
      }
    };
    data["class"]["el-upload--".concat(listType)] = true;
    return h("div", babel_helper_vue_jsx_merge_props_default()([{}, data, {
      "directives": [{
        name: "show",
        value: visible
      }]
    }]), [drag ? h("upload-dragger", {
      "attrs": {
        "disabled": disabled
      },
      "on": {
        "file": uploadFiles
      }
    }, [this.$slots["default"]]) : this.$slots["default"], h("input", {
      "class": 'el-upload__input',
      "attrs": {
        "type": 'file',
        "name": name,
        "multiple": multiple,
        "accept": accept
      },
      "ref": 'input',
      "on": {
        "change": handleChange
      }
    })]);
  }
});
// CONCATENATED MODULE: ./packages/upload/src/upload.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_uploadvue_type_script_lang_js_ = (uploadvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/upload/src/upload.vue
var upload_render, upload_staticRenderFns




/* normalize component */

var upload_component = normalizeComponent(
  src_uploadvue_type_script_lang_js_,
  upload_render,
  upload_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_upload = (upload_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/iframe-upload.vue?vue&type=script&lang=js&












/* harmony default export */ var iframe_uploadvue_type_script_lang_js_ = ({
  components: {
    UploadDragger: upload_dragger
  },
  props: {
    type: {
      type: String,
      "default": null
    },
    data: {
      type: null,
      "default": null
    },
    action: {
      type: String,
      required: true
    },
    name: {
      type: String,
      "default": 'file'
    },
    withCredentials: {
      type: Boolean,
      "default": null
    },
    accept: {
      type: String,
      "default": null
    },
    onStart: {
      type: Function,
      "default": null
    },
    onProgress: {
      type: Function,
      "default": null
    },
    onSuccess: {
      type: Function,
      "default": null
    },
    onError: {
      type: Function,
      "default": null
    },
    beforeUpload: {
      type: Function,
      "default": null
    },
    onPreview: {
      type: Function,
      "default": function _default() {}
    },
    onRemove: {
      type: Function,
      "default": function _default() {}
    },
    drag: {
      type: Boolean,
      "default": null
    },
    listType: {
      type: String,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      mouseover: false,
      domain: '',
      file: null,
      submitting: false
    };
  },
  created: function created() {
    this.frameName = 'frame-' + Date.now();
  },
  mounted: function mounted() {
    var self = this;
    !this.$isServer && window.addEventListener('message', function (event) {
      if (!self.file) return;
      var targetOrigin = new URL(self.action).origin;
      if (event.origin !== targetOrigin) return;
      var response = event.data;

      if (response.result === 'success') {
        self.onSuccess(response, self.file);
      } else if (response.result === 'failed') {
        self.onError(response, self.file);
      }

      self.submitting = false;
      self.file = null;
    }, false);
  },
  methods: {
    isImage: function isImage(str) {
      return str.indexOf('image') !== -1;
    },
    handleClick: function handleClick() {
      if (!this.disabled) {
        this.$refs.input.click();
      }
    },
    handleChange: function handleChange(ev) {
      var file = ev.target.value;

      if (file) {
        this.uploadFiles(file);
      }
    },
    uploadFiles: function uploadFiles(file) {
      if (this.submitting) return;
      this.submitting = true;
      this.file = file;
      this.onStart(file);
      var formNode = this.getFormNode();
      var dataSpan = this.getFormDataNode();
      var data = this.data;

      if (typeof data === 'function') {
        data = data(file);
      }

      var inputs = [];

      for (var key in data) {
        if (hasOwn(data, key)) {
          inputs.push("<input name=\"".concat(key, "\" value=\"").concat(data[key], "\"/>"));
        }
      }

      dataSpan.innerHTML = inputs.join('');
      formNode.submit();
      dataSpan.innerHTML = '';
    },
    getFormNode: function getFormNode() {
      return this.$refs.form;
    },
    getFormDataNode: function getFormDataNode() {
      return this.$refs.data;
    }
  },
  render: function render() {
    var h = arguments[0];
    var drag = this.drag,
        uploadFiles = this.uploadFiles,
        listType = this.listType,
        frameName = this.frameName,
        disabled = this.disabled;
    var oClass = {
      'el-upload': true
    };
    oClass["el-upload--".concat(listType)] = true;
    return h("div", {
      "class": oClass,
      "on": {
        "click": this.handleClick
      },
      "nativeOn": {
        "drop": this.onDrop,
        "dragover": this.handleDragover,
        "dragleave": this.handleDragleave
      }
    }, [h("iframe", {
      "on": {
        "load": this.onload
      },
      "ref": 'iframe',
      "attrs": {
        "name": frameName
      }
    }), h("form", {
      "ref": 'form',
      "attrs": {
        "action": this.action,
        "target": frameName,
        "enctype": 'multipart/form-data',
        "method": 'POST'
      }
    }, [h("input", {
      "class": 'el-upload__input',
      "attrs": {
        "type": 'file',
        "name": 'file',
        "accept": this.accept
      },
      "ref": 'input',
      "on": {
        "change": this.handleChange
      }
    }), h("input", {
      "attrs": {
        "type": 'hidden',
        "name": 'documentDomain'
      },
      "domProps": {
        "value": this.$isServer ? '' : document.domain
      }
    }), h("span", {
      "ref": 'data'
    })]), drag ? h("upload-dragger", {
      "on": {
        "file": uploadFiles
      },
      "attrs": {
        "disabled": disabled
      }
    }, [this.$slots["default"]]) : this.$slots["default"]]);
  }
});
// CONCATENATED MODULE: ./packages/upload/src/iframe-upload.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_iframe_uploadvue_type_script_lang_js_ = (iframe_uploadvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/upload/src/iframe-upload.vue
var iframe_upload_render, iframe_upload_staticRenderFns




/* normalize component */

var iframe_upload_component = normalizeComponent(
  src_iframe_uploadvue_type_script_lang_js_,
  iframe_upload_render,
  iframe_upload_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var iframe_upload = (iframe_upload_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/index.vue?vue&type=script&lang=js&

























function srcvue_type_script_lang_js_noop() {}

/* harmony default export */ var srcvue_type_script_lang_js_ = ({
  name: 'ElUpload',
  components: {
    ElProgress: packages_progress,
    UploadList: upload_list,
    Upload: src_upload,
    IframeUpload: iframe_upload
  },
  mixins: [migrating],
  provide: {
    uploader: undefined
  },
  props: {
    action: {
      type: String,
      required: true
    },
    headers: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    data: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    multiple: {
      type: Boolean,
      "default": null
    },
    name: {
      type: String,
      "default": 'file'
    },
    drag: {
      type: Boolean,
      "default": null
    },
    dragger: {
      type: Boolean,
      "default": null
    },
    withCredentials: {
      type: Boolean,
      "default": null
    },
    showFileList: {
      type: Boolean,
      "default": true
    },
    accept: {
      type: String,
      "default": ''
    },
    type: {
      type: String,
      "default": 'select'
    },
    beforeUpload: {
      type: Function,
      "default": null
    },
    beforeRemove: {
      type: Function,
      "default": null
    },
    onRemove: {
      type: Function,
      "default": srcvue_type_script_lang_js_noop
    },
    onChange: {
      type: Function,
      "default": srcvue_type_script_lang_js_noop
    },
    onPreview: {
      type: Function,
      "default": null
    },
    onSuccess: {
      type: Function,
      "default": srcvue_type_script_lang_js_noop
    },
    onProgress: {
      type: Function,
      "default": srcvue_type_script_lang_js_noop
    },
    onError: {
      type: Function,
      "default": srcvue_type_script_lang_js_noop
    },
    fileList: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    autoUpload: {
      type: Boolean,
      "default": true
    },
    listType: {
      type: String,
      "default": 'text' // text,picture,picture-card

    },
    httpRequest: {
      type: Function,
      "default": upload
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    limit: {
      type: Number,
      "default": null
    },
    onExceed: {
      type: Function,
      "default": srcvue_type_script_lang_js_noop
    },
    fileNameRender: {
      type: Function,
      "default": null
    },
    singleFile: {
      type: Boolean,
      "default": false
    },
    errorTooltipText: {
      type: String,
      "default": 'upload error'
    }
  },
  data: function data() {
    return {
      uploadFiles: [],
      uploadFilesAll: [],
      // 用于存储所有上传的文件（无论是否showFileList）
      dragOver: false,
      draging: false,
      tempIndex: 1
    };
  },
  watch: {
    fileList: {
      immediate: true,
      handler: function handler(fileList) {
        var _this = this;

        this.uploadFiles = fileList.map(function (item) {
          item.uid = item.uid || Date.now() + _this.tempIndex++;
          item.status = 'success';
          return item;
        });
      }
    }
  },
  methods: {
    reupload: function reupload(rawFile) {
      this.$refs['upload-inner'].upload(rawFile);
    },
    handleStart: function handleStart(rawFile) {
      rawFile.uid = Date.now() + this.tempIndex++;
      var file = {
        status: 'ready',
        name: rawFile.name,
        size: rawFile.size,
        percentage: 0,
        uid: rawFile.uid,
        raw: rawFile
      };

      try {
        file.url = URL.createObjectURL(rawFile);
      } catch (err) {
        // eslint-disable-next-line
        console.error(err);
        return;
      }

      this.showFileList ? this.uploadFiles.push(file) : this.uploadFiles = [file];
      this.uploadFilesAll.push(file); // this.uploadFiles.push(file);

      this.onChange(file, this.uploadFiles);
    },
    handleProgress: function handleProgress(ev, rawFile) {
      var file = this.getFile(rawFile);
      this.onProgress(ev, file, this.uploadFiles);
      file.status = 'uploading';
      file.percentage = ev.percent || 0;
    },
    handleSuccess: function handleSuccess(res, rawFile, xhr) {
      var file = this.getFile(rawFile);

      if (file) {
        file.status = 'success';
        file.response = res;
        this.onSuccess(res, file, this.uploadFiles, xhr);
        this.onChange(file, this.uploadFiles);
      }
    },
    handleError: function handleError(err, rawFile, xhr) {
      var file = this.getFile(rawFile); // var fileList = this.uploadFiles;

      file.status = 'fail'; // fileList.splice(fileList.indexOf(file), 1);

      this.onError(err, file, this.uploadFiles, xhr);
      this.onChange(file, this.uploadFiles);
    },
    handleRemove: function handleRemove(file, raw) {
      var _this2 = this;

      if (raw) {
        file = this.getFile(raw);
      }

      var doRemove = function doRemove() {
        _this2.abort(file);

        var fileList = _this2.uploadFiles;
        fileList.splice(fileList.indexOf(file), 1);

        _this2.onRemove(file, fileList);
      };

      if (!this.beforeRemove) {
        doRemove();
      } else if (typeof this.beforeRemove === 'function') {
        var before = this.beforeRemove(file, this.uploadFiles);

        if (before && before.then) {
          before.then(function () {
            doRemove();
          }, srcvue_type_script_lang_js_noop);
        } else if (before !== false) {
          doRemove();
        }
      }
    },
    getFile: function getFile(rawFile) {
      var fileList = this.multiple && this.showFileList === false ? this.uploadFilesAll : this.uploadFiles;
      var target;
      fileList.every(function (item) {
        target = rawFile.uid === item.uid ? item : null;
        return !target;
      });
      return target;
    },
    abort: function abort(file) {
      this.$refs['upload-inner'] && this.$refs['upload-inner'].abort(file);
    },
    clearFiles: function clearFiles() {
      this.uploadFiles = [];
    },
    submit: function submit() {
      var _this3 = this;

      this.uploadFiles.filter(function (file) {
        return file.status === 'ready';
      }).forEach(function (file) {
        _this3.$refs['upload-inner'].upload(file.raw);
      });
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'default-file-list': 'default-file-list is renamed to file-list.',
          'show-upload-list': 'show-upload-list is renamed to show-file-list.',
          'thumbnail-mode': 'thumbnail-mode has been deprecated, you can implement the same effect according to this case: http://element.eleme.io/#/zh-CN/component/upload#yong-hu-tou-xiang-shang-chuan'
        }
      };
    }
  },
  render: function render() {
    var h = arguments[0];
    var uploadList;
    var uploadData = {
      props: {
        visible: !(this.singleFile && this.uploadFiles.length >= 1),
        type: this.type,
        drag: this.drag,
        limit: this.limit,
        action: this.action,
        multiple: this.multiple,
        'before-upload': this.beforeUpload,
        'with-credentials': this.withCredentials,
        headers: this.headers,
        name: this.name,
        data: this.data,
        accept: this.accept,
        fileList: this.uploadFiles,
        autoUpload: this.autoUpload,
        listType: this.listType,
        disabled: this.disabled,
        'on-exceed': this.onExceed,
        'on-start': this.handleStart,
        'on-progress': this.handleProgress,
        'on-success': this.handleSuccess,
        'on-error': this.handleError,
        'on-preview': this.onPreview,
        'on-remove': this.handleRemove,
        'http-request': this.httpRequest
      },
      ref: 'upload-inner'
    };
    var trigger = this.$slots.trigger || this.$slots["default"];
    var uploadComponent = typeof FormData !== 'undefined' || this.$isServer ? h("upload", babel_helper_vue_jsx_merge_props_default()([{}, uploadData]), [trigger]) : h("iframeUpload", babel_helper_vue_jsx_merge_props_default()([{}, uploadData]), [trigger]);
    /* if (this.singleFile && this.uploadFiles.length >= 1) {
      uploadComponent = undefined;
    } */

    if (this.showFileList) {
      uploadList = h(upload_list, {
        "attrs": {
          "disabled": this.disabled,
          "listType": this.listType,
          "files": this.uploadFiles,
          "reupload": this.reupload,
          "autoUpload": this.autoUpload,
          "handlePreview": this.onPreview,
          "fileNameRender": this.fileNameRender,
          "errorTooltipText": this.errorTooltipText
        },
        "on": {
          "remove": this.handleRemove
        }
      }, [this.listType === 'picture-card' ? uploadComponent : '']);
    }

    return h("div", [this.listType === 'picture-card' ? uploadList : '', this.listType !== 'picture-card' ? this.$slots.trigger ? [uploadComponent, this.$slots["default"]] : uploadComponent : '', this.$slots.tip, this.listType !== 'picture-card' ? uploadList : '']);
  }
});
// CONCATENATED MODULE: ./packages/upload/src/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var upload_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/upload/src/index.vue
var src_render, src_staticRenderFns




/* normalize component */

var upload_src_component = normalizeComponent(
  upload_srcvue_type_script_lang_js_,
  src_render,
  src_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var upload_src = (upload_src_component.exports);
// CONCATENATED MODULE: ./packages/upload/index.js


/* istanbul ignore next */

upload_src.install = function (Vue) {
  Vue.component(upload_src.name, upload_src);
};

/* harmony default export */ var packages_upload = (upload_src);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=template&id=0b250d7a&
var spinnervue_type_template_id_0b250d7a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"el-spinner"},[_c('svg',{staticClass:"el-spinner-inner",style:({ width: _vm.radius / 2 + 'px', height: _vm.radius / 2 + 'px' }),attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"stroke":_vm.strokeColor,"stroke-width":_vm.strokeWidth,"cx":"25","cy":"25","r":"20","fill":"none"}})])])}
var spinnervue_type_template_id_0b250d7a_staticRenderFns = []


// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=template&id=0b250d7a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var spinnervue_type_script_lang_js_ = ({
  name: 'ElSpinner',
  props: {
    type: {
      type: String,
      "default": null
    },
    radius: {
      type: Number,
      "default": 100
    },
    strokeWidth: {
      type: Number,
      "default": 5
    },
    strokeColor: {
      type: String,
      "default": '#efefef'
    }
  }
});
// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_spinnervue_type_script_lang_js_ = (spinnervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue





/* normalize component */

var spinner_component = normalizeComponent(
  src_spinnervue_type_script_lang_js_,
  spinnervue_type_template_id_0b250d7a_render,
  spinnervue_type_template_id_0b250d7a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var spinner = (spinner_component.exports);
// CONCATENATED MODULE: ./packages/spinner/index.js


/* istanbul ignore next */

spinner.install = function (Vue) {
  Vue.component(spinner.name, spinner);
};

/* harmony default export */ var packages_spinner = (spinner);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=template&id=b3417f3a&
var mainvue_type_template_id_b3417f3a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-message-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-message",class:_vm.customClass,style:(("top:" + _vm.verticalOffset + "px")),on:{"mouseenter":_vm.clearTimer,"mouseleave":_vm.startTimer}},[(_vm.iconClass)?_c('i',{staticClass:"el-message__img",class:_vm.iconClass}):_c('feedback-icon',{staticClass:"el-message__typeImg",attrs:{"icon-name":_vm.typeClass}}),_c('div',{staticClass:"el-message__group",class:{ 'is-with-icon': _vm.iconClass }},[_vm._t("default",[_c('div',[(!_vm.dangerouslyUseHTMLString)?_c('p',{class:[_vm.showClose ? 'is-close' : '']},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_c('p',{class:[_vm.showClose ? 'is-close' : ''],domProps:{"innerHTML":_vm._s(_vm.message)}})])]),(_vm.showClose)?_c('div',{staticClass:"el-message__closeBtn h-icon-close_sm",on:{"click":_vm.close}}):_vm._e()],2)],1)])}
var mainvue_type_template_id_b3417f3a_staticRenderFns = []


// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=template&id=b3417f3a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var mainvue_type_script_lang_js_typeMap = {
  success: 'feedback_success_md',
  info: 'feedback_info_md',
  warning: 'feedback_warning_md',
  error: 'feedback_error_md'
};
/* harmony default export */ var message_src_mainvue_type_script_lang_js_ = ({
  components: {
    feedbackIcon: feedback_icon
  },
  data: function data() {
    return {
      visible: false,
      message: '',
      duration: 3000,
      type: 'info',
      iconClass: '',
      customClass: '',
      verticalOffset: 0,
      onClose: null,
      showClose: false,
      closed: false,
      timer: null,
      dangerouslyUseHTMLString: false
    };
  },
  computed: {
    typeClass: function typeClass() {
      return this.type && mainvue_type_script_lang_js_typeMap[this.type] ? "h-icon-".concat(mainvue_type_script_lang_js_typeMap[this.type]) : '';
    }
  },
  watch: {
    closed: function closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.$el.addEventListener('transitionend', this.destroyElement);
      }
    }
  },
  mounted: function mounted() {
    this.startTimer();
  },
  methods: {
    destroyElement: function destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    close: function close() {
      this.closed = true;

      if (typeof this.onClose === 'function') {
        this.onClose(this);
      }
    },
    clearTimer: function clearTimer() {
      clearTimeout(this.timer);
    },
    startTimer: function startTimer() {
      var _this = this;

      if (this.duration > 0) {
        this.timer = setTimeout(function () {
          if (!_this.closed) {
            _this.close();
          }
        }, this.duration);
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_message_src_mainvue_type_script_lang_js_ = (message_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/message/src/main.vue





/* normalize component */

var message_src_main_component = normalizeComponent(
  packages_message_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_b3417f3a_render,
  mainvue_type_template_id_b3417f3a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var message_src_main = (message_src_main_component.exports);
// CONCATENATED MODULE: ./packages/message/src/main.js






 // let MessageConstructor = Vue.extend(require('./main.vue'));

var MessageConstructor = external_vue_default.a.extend(message_src_main);
var message_src_main_instance;
var src_main_instances = [];
var src_main_seed = 1;

var main_Message = function Message(options) {
  if (external_vue_default.a.prototype.$isServer) return;
  options = options || {};

  if (typeof options === 'string') {
    options = {
      message: options
    };
  }

  var userOnClose = options.onClose;
  var id = 'message_' + src_main_seed++;

  options.onClose = function () {
    Message.close(id, userOnClose);
  };

  message_src_main_instance = new MessageConstructor({
    data: options
  });
  var verticalOffset = 0;
  src_main_instances.forEach(function (item) {
    verticalOffset += item.$el.offsetHeight + 16;
  }); // 首个的位置为top:20px

  verticalOffset += 20;
  message_src_main_instance.verticalOffset = verticalOffset;
  message_src_main_instance.id = id;

  if (isVNode(message_src_main_instance.message)) {
    message_src_main_instance.$slots["default"] = [message_src_main_instance.message];
    message_src_main_instance.message = null;
  }

  message_src_main_instance.vm = message_src_main_instance.$mount();
  document.body.appendChild(message_src_main_instance.vm.$el);
  message_src_main_instance.vm.visible = true;
  message_src_main_instance.dom = message_src_main_instance.vm.$el;
  message_src_main_instance.dom.style.zIndex = popup_manager.nextZIndex();
  src_main_instances.push(message_src_main_instance);
  return message_src_main_instance.vm;
};

['success', 'warning', 'info', 'error'].forEach(function (type) {
  main_Message[type] = function (options) {
    if (typeof options === 'string') {
      options = {
        message: options
      };
    }

    options.type = type;
    return main_Message(options);
  };
});

main_Message.close = function (id, userOnClose) {
  var len = src_main_instances.length;

  for (var i = 0; i < len; i++) {
    if (id === src_main_instances[i].id) {
      if (typeof userOnClose === 'function') {
        userOnClose(src_main_instances[i]);
      }

      var removedHeight = src_main_instances[i].dom.offsetHeight;
      src_main_instances.splice(i, 1);
      if (len <= 1) return;

      for (var j = i; j < len - 1; j++) {
        src_main_instances[j].dom.style.top = parseInt(src_main_instances[j].dom.style.top, 10) - removedHeight - 16 + 'px';
      }

      break;
    }
  }
};

main_Message.closeAll = function () {
  for (var i = src_main_instances.length - 1; i >= 0; i--) {
    src_main_instances[i].close();
  }
};

/* harmony default export */ var packages_message_src_main = (main_Message);
// CONCATENATED MODULE: ./packages/message/index.js

/* harmony default export */ var packages_message = (packages_message_src_main);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=template&id=58558c1e&
var mainvue_type_template_id_58558c1e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-badge"},[_vm._t("default"),_c('transition',{attrs:{"name":"el-zoom-in-center"}},[(_vm.max && _vm.showTip)?_c('ElTooltip',{attrs:{"content":'' + _vm.value,"placement":"right"}},[_c('sup',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden && (_vm.content || _vm.isDot)),expression:"!hidden && (content || isDot)"}],staticClass:"el-badge__content",class:{ 'is-fixed': _vm.$slots.default, 'is-dot': _vm.isDot },domProps:{"textContent":_vm._s(_vm.content)}})]):_c('sup',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden && (_vm.content || _vm.isDot)),expression:"!hidden && (content || isDot)"}],staticClass:"el-badge__content",class:{ 'is-fixed': _vm.$slots.default, 'is-dot': _vm.isDot },domProps:{"textContent":_vm._s(_vm.content)}})],1)],2)}
var mainvue_type_template_id_58558c1e_staticRenderFns = []


// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=template&id=58558c1e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var badge_src_mainvue_type_script_lang_js_ = ({
  name: 'ElBadge',
  components: {
    ElTooltip: packages_tooltip
  },
  props: {
    // showTips 最大值存在时，有效；鼠标移至 span 处有提示
    showTip: {
      type: Boolean,
      "default": false
    },
    value: {
      type: null,
      "default": null
    },
    max: {
      type: Number,
      "default": null
    },
    isDot: {
      type: Boolean,
      "default": null
    },
    hidden: {
      type: Boolean,
      "default": null
    }
  },
  computed: {
    content: function content() {
      if (this.isDot) return;
      var value = this.value;
      var max = this.max;

      if (typeof value === 'number' && typeof max === 'number') {
        return max < value ? "".concat(max, "+") : value;
      }

      return value;
    }
  }
});
// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_badge_src_mainvue_type_script_lang_js_ = (badge_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/badge/src/main.vue





/* normalize component */

var badge_src_main_component = normalizeComponent(
  packages_badge_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_58558c1e_render,
  mainvue_type_template_id_58558c1e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var badge_src_main = (badge_src_main_component.exports);
// CONCATENATED MODULE: ./packages/badge/index.js


/* istanbul ignore next */

badge_src_main.install = function (Vue) {
  Vue.component(badge_src_main.name, badge_src_main);
};

/* harmony default export */ var badge = (badge_src_main);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=template&id=be17ff72&
var mainvue_type_template_id_be17ff72_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-card"},[(_vm.$slots.header || _vm.header)?_c('div',{staticClass:"el-card__header"},[_vm._t("header",[_vm._v(" "+_vm._s(_vm.header)+" ")])],2):_vm._e(),_c('div',{staticClass:"el-card__body",style:(_vm.bodyStyle)},[_vm._t("default")],2)])}
var mainvue_type_template_id_be17ff72_staticRenderFns = []


// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=template&id=be17ff72&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var card_src_mainvue_type_script_lang_js_ = ({
  name: 'ElCard',
  props: {
    header: {
      type: null,
      "default": null
    },
    bodyStyle: {
      type: null,
      "default": null
    }
  }
});
// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_card_src_mainvue_type_script_lang_js_ = (card_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/card/src/main.vue





/* normalize component */

var card_src_main_component = normalizeComponent(
  packages_card_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_be17ff72_render,
  mainvue_type_template_id_be17ff72_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var card_src_main = (card_src_main_component.exports);
// CONCATENATED MODULE: ./packages/card/index.js


/* istanbul ignore next */

card_src_main.install = function (Vue) {
  Vue.component(card_src_main.name, card_src_main);
};

/* harmony default export */ var card = (card_src_main);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=template&id=8d7004e6&
var stepsvue_type_template_id_8d7004e6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-steps",class:[
    'is-' + _vm.direction,
    _vm.rightTitle ? 'is-rightTitle' : '',
    _vm.isCenter ? 'is-center' : ''
  ]},[_vm._t("default")],2)}
var stepsvue_type_template_id_8d7004e6_staticRenderFns = []


// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=template&id=8d7004e6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var stepsvue_type_script_lang_js_ = ({
  name: 'ElSteps',
  mixins: [emitter],
  props: {
    space: {
      type: [Number, String],
      "default": null
    },
    active: {
      type: Number,
      "default": null
    },
    direction: {
      type: String,
      "default": 'horizontal'
    },
    size: {
      type: String,
      "default": null
    },
    line: {
      type: Boolean,
      "default": true
    },
    rightTitle: {
      type: Boolean,
      "default": false
    },
    alignCenter: {
      type: Boolean,
      "default": false
    },
    center: {
      type: Boolean,
      "default": null
    },
    finishStatus: {
      type: String,
      "default": 'finish'
    },
    processStatus: {
      type: String,
      "default": 'process'
    },
    disorder: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      steps: [],
      stepOffset: 0
    };
  },
  computed: {
    isCenter: function isCenter() {
      return this.alignCenter || typeof this.space !== 'number';
    }
  },
  watch: {
    active: function active(newVal, oldVal) {
      this.$emit('change', newVal, oldVal);
    },
    steps: function steps(_steps) {
      var _this = this;

      _steps.forEach(function (child, index) {
        child.index = index;
      });

      if (this.center) {
        var len = _steps.length;
        this.$nextTick(function () {
          _this.stepOffset = _steps[len - 1].$el.getBoundingClientRect().width / (len - 1);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_stepsvue_type_script_lang_js_ = (stepsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/steps/src/steps.vue





/* normalize component */

var steps_component = normalizeComponent(
  src_stepsvue_type_script_lang_js_,
  stepsvue_type_template_id_8d7004e6_render,
  stepsvue_type_template_id_8d7004e6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var steps = (steps_component.exports);
// CONCATENATED MODULE: ./packages/steps/index.js


/* istanbul ignore next */

steps.install = function (Vue) {
  Vue.component(steps.name, steps);
};

/* harmony default export */ var packages_steps = (steps);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=template&id=34a837e4&
var stepvue_type_template_id_34a837e4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-step",class:[
    'is-' + _vm.$parent.direction,
    _vm.$parent.size ? 'el-step--' + _vm.$parent.size : '',
    _vm.icon ? 'el-step--' + 'icon' : '',
    _vm.isLast && !_vm.$parent.space && 'is-flex',
    _vm.$parent.disorder ? 'el-step--' + 'disorder' : ''
  ],style:(_vm.style)},[(_vm.$parent.line)?_c('div',{staticClass:"el-step__line",class:['is-' + _vm.$parent.direction, { 'is-icon': _vm.icon }]},[_c('i',{staticClass:"el-step__line-inner",style:(_vm.lineStyle)})]):_vm._e(),_c('div',{staticClass:"el-step__head",class:['is-' + _vm.currentStatus, { 'is-text': !_vm.icon }],on:{"click":_vm.hdClick}},[_c('span',{staticClass:"el-step__icon"},[(
          _vm.currentStatus !== 'success' &&
            _vm.currentStatus !== 'error' &&
            _vm.$parent.size !== 'mini' &&
            !_vm.$parent.disorder
        )?_vm._t("icon",[(_vm.icon)?_c('i',{class:['h-icon-' + _vm.icon]}):_vm._e(),(!_vm.icon)?_c('div',[_vm._v(_vm._s(_vm.index + 1))]):_vm._e()]):(_vm.$parent.size == 'mini' || _vm.$parent.disorder)?_c('i'):_c('i',{class:[
          'h-icon-' + (_vm.currentStatus === 'success' ? 'done' : 'close')
        ]})],2)]),_c('div',{ref:"main",staticClass:"el-step__main",class:[_vm.$parent.rightTitle ? 'rightTitle' : '']},[_c('div',{ref:"title",staticClass:"el-step__title",class:['is-' + _vm.currentStatus]},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_c('div',{staticClass:"el-step__description",class:['is-' + _vm.currentStatus]},[_vm._t("description",[_vm._v(_vm._s(_vm.description))])],2)])])}
var stepvue_type_template_id_34a837e4_staticRenderFns = []


// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=template&id=34a837e4&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var stepvue_type_script_lang_js_ = ({
  name: 'ElStep',
  mixins: [emitter],
  props: {
    title: {
      type: String,
      "default": null
    },
    icon: {
      type: String,
      "default": null
    },
    description: {
      type: String,
      "default": null
    },
    status: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      index: -1,
      lineStyle: {},
      internalStatus: ''
    };
  },
  computed: {
    currentStatus: function currentStatus() {
      return this.status || this.internalStatus;
    },
    prevStatus: function prevStatus() {
      var prevStep = this.$parent.steps[this.index - 1];
      return prevStep ? prevStep.currentStatus : 'wait';
    },
    isLast: function isLast() {
      var parent = this.$parent;
      return parent.steps[parent.steps.length - 1] === this;
    },
    style: function style() {
      var style = {};
      var parent = this.$parent; // const isCenter = parent.center;

      var len = parent.steps.length; // if (isCenter && this.isLast) {
      //   return {};
      // }

      var space = typeof parent.space === 'number' ? parent.space + 'px' : parent.space ? parent.space : 100 / (len - (parent.isCenter ? 0 : 1)) + '%';

      if (parent.direction === 'horizontal') {
        style.flexBasis = space;
      } else {
        if (!this.isLast) {
          style.height = space;
        }
      }

      return style;
    }
  },
  beforeCreate: function beforeCreate() {
    this.$parent.steps.push(this);
  },
  beforeDestroy: function beforeDestroy() {
    var steps = this.$parent.steps;
    var index = steps.indexOf(this);

    if (index >= 0) {
      steps.splice(index, 1);
    }
  },
  mounted: function mounted() {
    var _this = this;

    // const parent = this.$parent;
    var unwatch = this.$watch('index', function () {
      _this.$watch('$parent.active', _this.updateStatus, {
        immediate: true
      });

      unwatch();
    });
  },
  methods: {
    updateStatus: function updateStatus(val) {
      var prevChild = this.$parent.$children[this.index - 1];

      if (val > this.index) {
        this.internalStatus = this.$parent.finishStatus;
      } else if (val === this.index && this.prevStatus !== 'error') {
        this.internalStatus = this.$parent.processStatus;
      } else {
        this.internalStatus = 'wait';
      }

      if (prevChild) prevChild.calcProgress(this.internalStatus);
    },
    calcProgress: function calcProgress(status) {
      var step = 100;
      var style = {};
      style.transitionDelay = 150 * this.index + 'ms';

      if (status === this.$parent.processStatus) {
        step = this.currentStatus !== 'error' ? 100 : 0;
      } else if (status === 'wait') {
        step = 0;
        style.transitionDelay = -150 * this.index + 'ms';
      }

      if (this.$parent.direction === 'vertical') {
        style.borderLeftWidth = step ? '1px' : 0;
        style.height = step + '%';
      } else {
        style.borderTopWidth = step ? '1px' : 0;
        style.width = step + '%';
      }

      this.lineStyle = style;
    },
    hdClick: function hdClick() {
      this.$parent.$emit('step-click', this.index);
    }
  }
});
// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_stepvue_type_script_lang_js_ = (stepvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/steps/src/step.vue





/* normalize component */

var step_component = normalizeComponent(
  src_stepvue_type_script_lang_js_,
  stepvue_type_template_id_34a837e4_render,
  stepvue_type_template_id_34a837e4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_step = (step_component.exports);
// CONCATENATED MODULE: ./packages/step/index.js


/* istanbul ignore next */

src_step.install = function (Vue) {
  Vue.component(src_step.name, src_step);
};

/* harmony default export */ var packages_step = (src_step);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=template&id=e8045852&
var mainvue_type_template_id_e8045852_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-carousel",class:{ 'el-carousel--card': _vm.type === 'card' },on:{"mouseenter":function($event){$event.stopPropagation();return _vm.handleMouseEnter($event)},"mouseleave":function($event){$event.stopPropagation();return _vm.handleMouseLeave($event)}}},[_c('div',{staticClass:"el-carousel__container",style:({ height: _vm.height })},[_c('transition',{attrs:{"name":"carousel-arrow-left"}},[(_vm.arrow !== 'never')?_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.arrow === 'always' || _vm.hover),expression:"arrow === 'always' || hover"}],staticClass:"el-carousel__arrow el-carousel__arrow--left",on:{"mouseenter":function($event){return _vm.handleButtonEnter('left')},"mouseleave":_vm.handleButtonLeave,"click":function($event){$event.stopPropagation();return _vm.throttledArrowClick(_vm.activeIndex - 1)}}},[_c('i',{staticClass:"h-icon-angle_left"})]):_vm._e()]),_c('transition',{attrs:{"name":"carousel-arrow-right"}},[(_vm.arrow !== 'never')?_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.arrow === 'always' || _vm.hover),expression:"arrow === 'always' || hover"}],staticClass:"el-carousel__arrow el-carousel__arrow--right",on:{"mouseenter":function($event){return _vm.handleButtonEnter('right')},"mouseleave":_vm.handleButtonLeave,"click":function($event){$event.stopPropagation();return _vm.throttledArrowClick(_vm.activeIndex + 1)}}},[_c('i',{staticClass:"h-icon-angle_right"})]):_vm._e()]),_vm._t("default")],2),(_vm.indicatorPosition !== 'none')?_c('ul',{staticClass:"el-carousel__indicators",class:{
      'el-carousel__indicators--labels': _vm.hasLabel,
      'el-carousel__indicators--outside':
        _vm.indicatorPosition === 'outside' || _vm.type === 'card'
    }},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"el-carousel__indicator",class:{ 'is-active': index === _vm.activeIndex },on:{"mouseenter":function($event){return _vm.throttledIndicatorHover(index)},"click":function($event){$event.stopPropagation();return _vm.handleIndicatorClick(index)}}},[_c('button',{staticClass:"el-carousel__button"},[(_vm.hasLabel)?_c('span',[_vm._v(" "+_vm._s(item.label)+" ")]):_vm._e()])])}),0):_vm._e()])}
var mainvue_type_template_id_e8045852_staticRenderFns = []


// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=template&id=e8045852&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=script&lang=js&











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var carousel_src_mainvue_type_script_lang_js_ = ({
  name: 'ElCarousel',
  props: {
    initialIndex: {
      type: Number,
      "default": 0
    },
    height: {
      type: String,
      "default": null
    },
    trigger: {
      type: String,
      "default": 'hover'
    },
    autoplay: {
      type: Boolean,
      "default": true
    },
    interval: {
      type: Number,
      "default": 3000
    },
    indicatorPosition: {
      type: String,
      "default": null
    },
    indicator: {
      type: Boolean,
      "default": true
    },
    arrow: {
      type: String,
      "default": 'hover'
    },
    type: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      items: [],
      activeIndex: -1,
      containerWidth: 0,
      timer: null,
      hover: false
    };
  },
  computed: {
    hasLabel: function hasLabel() {
      return this.items.some(function (item) {
        return item.label.toString().length > 0;
      });
    }
  },
  watch: {
    items: function items(val) {
      if (val.length > 0) this.setActiveItem(this.initialIndex);
    },
    activeIndex: function activeIndex(val, oldVal) {
      this.resetItemPosition(oldVal);
      this.$emit('change', val, oldVal);
    },
    autoplay: function autoplay(val) {
      val ? this.startTimer() : this.pauseTimer();
    }
  },
  created: function created() {
    var _this = this;

    this.throttledArrowClick = throttle_default()(300, true, function (index) {
      _this.setActiveItem(index);
    });
    this.throttledIndicatorHover = throttle_default()(300, function (index) {
      _this.handleIndicatorHover(index);
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.updateItems();
    this.$nextTick(function () {
      resize_event_addResizeListener(_this2.$el, _this2.resetItemPosition);

      if (_this2.initialIndex < _this2.items.length && _this2.initialIndex >= 0) {
        _this2.activeIndex = _this2.initialIndex;
      }

      _this2.startTimer();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el) removeResizeListener(this.$el, this.resetItemPosition);
  },
  methods: {
    handleMouseEnter: function handleMouseEnter() {
      this.hover = true;
      this.pauseTimer();
    },
    handleMouseLeave: function handleMouseLeave() {
      this.hover = false;
      this.startTimer();
    },
    itemInStage: function itemInStage(item, index) {
      var length = this.items.length;

      if (index === length - 1 && item.inStage && this.items[0].active || item.inStage && this.items[index + 1] && this.items[index + 1].active) {
        return 'left';
      } else if (index === 0 && item.inStage && this.items[length - 1].active || item.inStage && this.items[index - 1] && this.items[index - 1].active) {
        return 'right';
      }

      return false;
    },
    handleButtonEnter: function handleButtonEnter(arrow) {
      var _this3 = this;

      this.items.forEach(function (item, index) {
        if (arrow === _this3.itemInStage(item, index)) {
          item.hover = true;
        }
      });
    },
    handleButtonLeave: function handleButtonLeave() {
      this.items.forEach(function (item) {
        item.hover = false;
      });
    },
    updateItems: function updateItems() {
      this.items = this.$children.filter(function (child) {
        return child.$options.name === 'ElCarouselItem';
      });
    },
    resetItemPosition: function resetItemPosition(oldIndex) {
      var _this4 = this;

      this.items.forEach(function (item, index) {
        item.translateItem(index, _this4.activeIndex, oldIndex);
      });
    },
    playSlides: function playSlides() {
      if (this.activeIndex < this.items.length - 1) {
        this.activeIndex++;
      } else {
        this.activeIndex = 0;
      }
    },
    pauseTimer: function pauseTimer() {
      clearInterval(this.timer);
    },
    startTimer: function startTimer() {
      if (this.interval <= 0 || !this.autoplay) return;
      this.timer = setInterval(this.playSlides, this.interval);
    },
    setActiveItem: function setActiveItem(index) {
      if (typeof index === 'string') {
        var filteredItems = this.items.filter(function (item) {
          return item.name === index;
        });

        if (filteredItems.length > 0) {
          index = this.items.indexOf(filteredItems[0]);
        }
      }

      index = Number(index);

      if (isNaN(index) || index !== Math.floor(index)) {
        // eslint-disable-next-line
         false && false;
        return;
      }

      var length = this.items.length;

      if (index < 0) {
        this.activeIndex = length - 1;
      } else if (index >= length) {
        this.activeIndex = 0;
      } else {
        this.activeIndex = index;
      }
    },
    prev: function prev() {
      this.setActiveItem(this.activeIndex - 1);
    },
    next: function next() {
      this.setActiveItem(this.activeIndex + 1);
    },
    handleIndicatorClick: function handleIndicatorClick(index) {
      this.activeIndex = index;
    },
    handleIndicatorHover: function handleIndicatorHover(index) {
      if (this.trigger === 'hover' && index !== this.activeIndex) {
        this.activeIndex = index;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_carousel_src_mainvue_type_script_lang_js_ = (carousel_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/carousel/src/main.vue





/* normalize component */

var carousel_src_main_component = normalizeComponent(
  packages_carousel_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_e8045852_render,
  mainvue_type_template_id_e8045852_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var carousel_src_main = (carousel_src_main_component.exports);
// CONCATENATED MODULE: ./packages/carousel/index.js


/* istanbul ignore next */

carousel_src_main.install = function (Vue) {
  Vue.component(carousel_src_main.name, carousel_src_main);
};

/* harmony default export */ var carousel = (carousel_src_main);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=template&id=206a29d2&
var itemvue_type_template_id_206a29d2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],staticClass:"el-carousel__item",class:{
    'is-active': _vm.active,
    'el-carousel__item--card': _vm.$parent.type === 'card',
    'is-in-stage': _vm.inStage,
    'is-hover': _vm.hover,
    'is-animating': _vm.animating
  },style:({
    msTransform: ("translateX(" + _vm.translate + "px) scale(" + _vm.scale + ")"),
    webkitTransform: ("translateX(" + _vm.translate + "px) scale(" + _vm.scale + ")"),
    transform: ("translateX(" + _vm.translate + "px) scale(" + _vm.scale + ")")
  }),on:{"click":_vm.handleItemClick}},[(_vm.$parent.type === 'card')?_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.active),expression:"!active"}],staticClass:"el-carousel__mask"}):_vm._e(),_vm._t("default")],2)}
var itemvue_type_template_id_206a29d2_staticRenderFns = []


// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=template&id=206a29d2&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var CARD_SCALE = 0.83;
/* harmony default export */ var itemvue_type_script_lang_js_ = ({
  name: 'ElCarouselItem',
  props: {
    name: {
      type: String,
      "default": null
    },
    label: {
      type: [String, Number],
      "default": ''
    }
  },
  data: function data() {
    return {
      hover: false,
      translate: 0,
      scale: 1,
      active: false,
      ready: false,
      inStage: false,
      animating: false
    };
  },
  created: function created() {
    this.$parent && this.$parent.updateItems();
  },
  destroyed: function destroyed() {
    this.$parent && this.$parent.updateItems();
  },
  methods: {
    processIndex: function processIndex(index, activeIndex, length) {
      if (activeIndex === 0 && index === length - 1) {
        return -1;
      } else if (activeIndex === length - 1 && index === 0) {
        return length;
      } else if (index < activeIndex - 1 && activeIndex - index >= length / 2) {
        return length + 1;
      } else if (index > activeIndex + 1 && index - activeIndex >= length / 2) {
        return -2;
      }

      return index;
    },
    calculateTranslate: function calculateTranslate(index, activeIndex, parentWidth) {
      if (this.inStage) {
        return parentWidth * ((2 - CARD_SCALE) * (index - activeIndex) + 1) / 4;
      } else if (index < activeIndex) {
        return -(1 + CARD_SCALE) * parentWidth / 4;
      } else {
        return (3 + CARD_SCALE) * parentWidth / 4;
      }
    },
    translateItem: function translateItem(index, activeIndex, oldIndex) {
      var parentWidth = this.$parent.$el.offsetWidth;
      var length = this.$parent.items.length;

      if (this.$parent.type !== 'card' && oldIndex !== undefined) {
        this.animating = index === activeIndex || index === oldIndex;
      }

      if (index !== activeIndex && length > 2) {
        index = this.processIndex(index, activeIndex, length);
      }

      if (this.$parent.type === 'card') {
        this.inStage = Math.round(Math.abs(index - activeIndex)) <= 1;
        this.active = index === activeIndex;
        this.translate = this.calculateTranslate(index, activeIndex, parentWidth);
        this.scale = this.active ? 1 : CARD_SCALE;
      } else {
        this.active = index === activeIndex;
        this.translate = parentWidth * (index - activeIndex);
      }

      this.ready = true;
    },
    handleItemClick: function handleItemClick() {
      var parent = this.$parent;

      if (parent && parent.type === 'card') {
        var index = parent.items.indexOf(this);
        parent.setActiveItem(index);
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_itemvue_type_script_lang_js_ = (itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/carousel/src/item.vue





/* normalize component */

var item_component = normalizeComponent(
  src_itemvue_type_script_lang_js_,
  itemvue_type_template_id_206a29d2_render,
  itemvue_type_template_id_206a29d2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_item = (item_component.exports);
// CONCATENATED MODULE: ./packages/carousel-item/index.js


/* istanbul ignore next */

src_item.install = function (Vue) {
  Vue.component(src_item.name, src_item);
};

/* harmony default export */ var carousel_item = (src_item);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=template&id=1a3dc2b3&
var collapsevue_type_template_id_1a3dc2b3_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-collapse"},[_vm._t("default")],2)}
var collapsevue_type_template_id_1a3dc2b3_staticRenderFns = []


// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=template&id=1a3dc2b3&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=script&lang=js&






//
//
//
//
//
/* harmony default export */ var collapsevue_type_script_lang_js_ = ({
  name: 'ElCollapse',
  componentName: 'ElCollapse',
  props: {
    accordion: {
      type: Boolean,
      "default": null
    },
    value: {
      type: [Array, String, Number],
      "default": function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      activeNames: [].concat(this.value)
    };
  },
  watch: {
    value: function value(_value) {
      this.activeNames = [].concat(_value);
    }
  },
  created: function created() {
    this.$on('item-click', this.handleItemClick);
  },
  methods: {
    setActiveNames: function setActiveNames(activeNames) {
      activeNames = [].concat(activeNames);
      var value = this.accordion ? activeNames[0] : activeNames;
      this.activeNames = activeNames;
      this.$emit('input', value);
      this.$emit('change', value);
    },
    handleItemClick: function handleItemClick(item) {
      if (this.accordion) {
        this.setActiveNames((this.activeNames[0] || this.activeNames[0] === 0) && this.activeNames[0] === item.name ? '' : item.name);
      } else {
        var activeNames = this.activeNames.slice(0);
        var index = activeNames.indexOf(item.name);

        if (index > -1) {
          activeNames.splice(index, 1);
        } else {
          activeNames.push(item.name);
        }

        this.setActiveNames(activeNames);
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_collapsevue_type_script_lang_js_ = (collapsevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue





/* normalize component */

var collapse_component = normalizeComponent(
  src_collapsevue_type_script_lang_js_,
  collapsevue_type_template_id_1a3dc2b3_render,
  collapsevue_type_template_id_1a3dc2b3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var collapse = (collapse_component.exports);
// CONCATENATED MODULE: ./packages/collapse/index.js


/* istanbul ignore next */

collapse.install = function (Vue) {
  Vue.component(collapse.name, collapse);
};

/* harmony default export */ var packages_collapse = (collapse);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=template&id=7c76866e&
var collapse_itemvue_type_template_id_7c76866e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-collapse-item",class:{ 'is-active': _vm.isActive }},[_c('div',{staticClass:"el-collapse-item__header",on:{"click":_vm.handleHeaderClick}},[(_vm.arrowPlacement !== 'right')?_c('i',{staticClass:"el-collapse-item__arrow h-icon-angle_right_sm",class:{
        'is-active': _vm.isActive
      }}):_vm._e(),_c('span',[_vm._t("title",[_vm._v(" "+_vm._s(_vm.title)+" ")])],2),(_vm.arrowPlacement === 'right')?_c('i',{staticClass:"el-collapse-item__arrow h-icon-angle_right_sm on-right",class:{
        'is-active': _vm.isActive
      }}):_vm._e()]),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"el-collapse-item__wrap"},[_c('div',{staticClass:"el-collapse-item__content"},[_vm._t("default")],2)])])],1)}
var collapse_itemvue_type_template_id_7c76866e_staticRenderFns = []


// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=template&id=7c76866e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var collapse_itemvue_type_script_lang_js_ = ({
  name: 'ElCollapseItem',
  componentName: 'ElCollapseItem',
  components: {
    ElCollapseTransition: collapse_transition
  },
  mixins: [emitter],
  props: {
    title: {
      type: String,
      "default": null
    },
    arrowPlacement: {
      type: String,
      "default": 'left'
    },
    name: {
      type: [String, Number],
      "default": function _default() {
        return this._uid;
      }
    }
  },
  data: function data() {
    return {
      contentWrapStyle: {
        height: 'auto',
        display: 'block'
      },
      contentHeight: 0
    };
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.activeNames.indexOf(this.name) > -1;
    }
  },
  mounted: function mounted() {},
  // watch: {
  //     isActive(value) {}
  // },
  methods: {
    handleHeaderClick: function handleHeaderClick() {
      this.dispatch('ElCollapse', 'item-click', this);
    }
  }
});
// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_collapse_itemvue_type_script_lang_js_ = (collapse_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue





/* normalize component */

var collapse_item_component = normalizeComponent(
  src_collapse_itemvue_type_script_lang_js_,
  collapse_itemvue_type_template_id_7c76866e_render,
  collapse_itemvue_type_template_id_7c76866e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var collapse_item = (collapse_item_component.exports);
// CONCATENATED MODULE: ./packages/collapse-item/index.js


/* istanbul ignore next */

collapse_item.install = function (Vue) {
  Vue.component(collapse_item.name, collapse_item);
};

/* harmony default export */ var packages_collapse_item = (collapse_item);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/main.vue?vue&type=template&id=ea8ef2e2&
var mainvue_type_template_id_ea8ef2e2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.handleClickoutside),expression:"handleClickoutside"}],ref:"reference",staticClass:"el-cascader",class:[
    {
      'is-opened': _vm.menuVisible,
      'is-disabled': _vm.disabled
    },
    _vm.size ? 'el-cascader--' + _vm.size : ''
  ],on:{"click":_vm.handleClick,"mouseenter":function($event){_vm.inputHover = true},"mouseleave":function($event){_vm.inputHover = false},"focus":function($event){_vm.inputHover = true},"blur":function($event){_vm.inputHover = false}}},[_c('el-input',{ref:"input",attrs:{"readonly":!_vm.filterable,"placeholder":_vm.currentLabels.length ? undefined : _vm.placeholder,"validate-event":false,"size":_vm.size,"disabled":_vm.disabled},on:{"change":_vm.debouncedInputChange,"focus":_vm.handleFocus,"blur":_vm.handleBlur},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},[_c('template',{slot:"suffix"},[(_vm.clearable && _vm.inputHover && (_vm.currentLabels.length || _vm.inputValue))?_c('i',{key:"1",staticClass:"el-input__icon h-icon-close_f",on:{"click":_vm.clearValue}}):_c('i',{key:"2",staticClass:"el-input__icon h-icon-angle_down_sm"})])],2),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.inputValue === ''),expression:"inputValue === ''"}],staticClass:"el-cascader__label",attrs:{"title":_vm.currentValueTitle}},[(_vm.showAllLevels)?_vm._l((_vm.currentLabels),function(label,index){return _c('span',{key:index},[_vm._v(" "+_vm._s(label)+" "),(index < _vm.currentLabels.length - 1)?_c('span',{staticClass:"el-cascader__separator"},[_vm._v(" / ")]):_vm._e()])}):[_vm._v(" "+_vm._s(_vm.currentLabels[_vm.currentLabels.length - 1])+" ")]],2)],1)}
var mainvue_type_template_id_ea8ef2e2_staticRenderFns = []


// CONCATENATED MODULE: ./packages/cascader/src/main.vue?vue&type=template&id=ea8ef2e2&

// CONCATENATED MODULE: ./src/utils/shared.js
function isDef(val) {
  return val !== undefined && val !== null;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/menu.vue?vue&type=script&lang=js&










var copyArray = function copyArray(arr, props) {
  if (!arr || !Array.isArray(arr) || !props) return arr;
  var result = [];
  var configurableProps = ['__IS__FLAT__OPTIONS', 'label', 'value', 'disabled'];
  var childrenProp = props.children || 'children';
  arr.forEach(function (item) {
    var itemCopy = {};
    configurableProps.forEach(function (prop) {
      var propName = item.__IS__FLAT__OPTIONS ? prop : props[prop] || prop;
      var value = item[propName];
      if (value !== undefined) itemCopy[propName] = value;
    });

    if (Array.isArray(item[childrenProp])) {
      itemCopy[childrenProp] = copyArray(item[childrenProp], props);
    }

    result.push(itemCopy);
  });
  return result;
};

/* harmony default export */ var cascader_src_menuvue_type_script_lang_js_ = ({
  name: 'ElCascaderMenu',
  data: function data() {
    return {
      inputWidth: 0,
      options: [],
      loading: false,
      props: {},
      visible: false,
      activeValue: [],
      value: [],
      check: Function,
      expandTrigger: 'click',
      changeOnSelect: false,
      popperClass: '',
      titleLabel: '',
      noMatch: '',
      filterable: false,
      loadingTitle: ''
    };
  },
  computed: {
    activeOptions: {
      cache: false,
      get: function get() {
        var _this = this;

        var activeValue = this.activeValue;
        var configurableProps = ['label', 'value', 'children', 'disabled'];

        var formatOptions = function formatOptions(options) {
          options.forEach(function (option) {
            if (option.__IS__FLAT__OPTIONS) return;
            configurableProps.forEach(function (prop) {
              var value = option[_this.props[prop] || prop];
              if (value !== undefined) option[prop] = value;
            });

            if (Array.isArray(option.children)) {
              formatOptions(option.children);
            }
          });
        };

        var loadActiveOptions = function loadActiveOptions(options) {
          var activeOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          var level = activeOptions.length;
          activeOptions[level] = options;
          var active = activeValue[level];

          if (isDef(active)) {
            options = options.filter(function (option) {
              return option.value === active;
            })[0];

            if (options && options.children) {
              loadActiveOptions(options.children, activeOptions);
            }
          }

          return activeOptions;
        };

        var optionsCopy = copyArray(this.options, this.props);
        formatOptions(optionsCopy);
        return loadActiveOptions(optionsCopy);
      }
    }
  },
  watch: {
    visible: function visible(value) {
      if (value) {
        this.activeValue = this.value;
      }
    },
    value: {
      immediate: true,
      handler: function handler(value) {
        this.activeValue = value;
      }
    }
  },
  methods: {
    select: function select(item, menuIndex) {
      if (item.__IS__FLAT__OPTIONS) {
        this.activeValue = item.value;
      } else if (menuIndex) {
        this.activeValue.splice(menuIndex, this.activeValue.length - 1, item.value);
      } else {
        this.activeValue = [item.value];
      }

      this.$emit('pick', this.activeValue.slice(), item.children);
    },
    handleMenuLeave: function handleMenuLeave() {
      this.$emit('menuLeave');
    },
    activeItem: function activeItem(item, menuIndex) {
      var len = this.activeOptions.length;
      this.activeValue.splice(menuIndex, len, item.value);
      this.activeOptions.splice(menuIndex + 1, len, item.children);
      this.$emit('activeItemChange', this.activeValue);
    },
    scrollMenu: function scrollMenu(menu) {
      scrollIntoView(menu, menu.getElementsByClassName('is-active')[0]);
    },
    handleMenuEnter: function handleMenuEnter() {
      var _this2 = this;

      this.$nextTick(function () {
        return _this2.$refs.menus.forEach(function (menu) {
          return _this2.scrollMenu(menu);
        });
      });
    }
  },
  render: function render() {
    var _this3 = this;

    var h = arguments[0];
    var activeValue = this.activeValue,
        activeOptions = this.activeOptions,
        visible = this.visible,
        expandTrigger = this.expandTrigger,
        popperClass = this.popperClass,
        noMatch = this.noMatch,
        filterable = this.filterable,
        loadingTitle = this.loadingTitle,
        loading = this.loading;

    var menus = this._l(activeOptions, function (menu, menuIndex) {
      var isFlat = false;

      var items = _this3._l(menu, function (item) {
        var events = {
          on: {}
        };
        if (item.__IS__FLAT__OPTIONS) isFlat = true;

        if (!item.disabled) {
          if (item.children) {
            var triggerEvent = {
              click: 'click',
              hover: 'mouseenter'
            }[expandTrigger]; // if (this.changeOnSelect) {
            //   events.on['mouseenter'] = () => {
            //     const len = this.activeOptions.length;
            //     this.activeValue.splice(menuIndex, len, item.value);
            //     this.activeOptions.splice(menuIndex + 1, len, item.children);
            //     this.$emit('activeItemChange', this.activeValue);
            //     // this.activeItem(item, menuIndex);
            //     this.$nextTick(() => {
            //     // adjust self and next level
            //       this.scrollMenu(this.$refs.menus[menuIndex]);
            //       this.scrollMenu(this.$refs.menus[menuIndex + 1]);
            //     });
            //   };
            // }

            events.on[triggerEvent] = function () {
              if (_this3.changeOnSelect && _this3.check(item, menuIndex)) {
                _this3.select(item, menuIndex); // this.$nextTick(() => this.scrollMenu(this.$refs.menus[menuIndex]));

              }

              _this3.activeItem(item, menuIndex);

              _this3.$nextTick(function () {
                // adjust self and next level
                _this3.scrollMenu(_this3.$refs.menus[menuIndex]);

                _this3.scrollMenu(_this3.$refs.menus[menuIndex + 1]);
              });
            };
          } else {
            events.on.click = function () {
              if (_this3.check(item, menuIndex)) {
                _this3.select(item, menuIndex);
              }

              _this3.$nextTick(function () {
                return _this3.scrollMenu(_this3.$refs.menus[menuIndex]);
              });
            };
          }
        }
        /*
         * 文字超出时显示title否则不显示，后续需要优化为toolTip显示
         * zhangxiaogang  2017-12-13
         */


        events.on.mouseover = function (e) {
          var t = e.target;

          if (t.tagName === 'LI') {
            if (t.scrollWidth > t.offsetWidth) {
              _this3.titleLabel = t.innerText;
            } else {
              _this3.titleLabel = '';
            }
          }
        };

        return h("li", babel_helper_vue_jsx_merge_props_default()([{
          "class": {
            'el-cascader-menu__item': true,
            'el-cascader-menu__item--extensible': item.children,
            'is-active': item.value === activeValue[menuIndex],
            'is-disabled': item.disabled
          }
        }, events, {
          "attrs": {
            "title": _this3.titleLabel
          }
        }]), [item.label, h("i", {
          "class": {
            'h-icon-angle_right_sm': item.children
          }
        })]);
      });

      var menuStyle = {};
      var noDataStyle = {};

      if (isFlat) {
        menuStyle.minWidth = _this3.inputWidth + 'px';
      }

      noDataStyle.width = _this3.inputWidth + 'px';
      noDataStyle.height = '94px';

      if (items.length > 0) {
        return h("ul", {
          "class": {
            'el-cascader-menu': true,
            'el-cascader-menu--flexible': isFlat
          },
          "style": menuStyle,
          "refInFor": true,
          "ref": 'menus'
        }, [h("el-scrollbar", {
          "attrs": {
            "wrap-class": 'el-cascader-scrollbar__wrap',
            "view-class": 'el-cascader-scrollbar__view',
            "isSmall": true
          }
        }, [items])]);
      } else if (loading) {
        return h("ul", {
          "class": {
            'el-cascader-menu': true,
            'el-cascader-menu--flexible': isFlat,
            'el-cascader-menu--noDate': true
          },
          "style": menuStyle,
          "refInFor": true,
          "ref": 'menus'
        }, [h("span", {
          "class": {
            'el-cascader-noDate': true
          }
        }, [loadingTitle])]);
      } else if (filterable & activeOptions[0].length === 0) {
        return h("ul", {
          "class": {
            'el-cascader-menu': true,
            'el-cascader-menu--flexible': isFlat,
            'el-cascader-menu--noDate': true
          },
          "style": noDataStyle,
          "refInFor": true,
          "ref": 'menus'
        }, [h("span", {
          "class": {
            'el-cascader-noDate': true
          }
        }, [noMatch])]);
      } else {
        return h("ul", {
          "class": {
            'el-cascader-menu': true,
            'el-cascader-menu--flexible': isFlat,
            'el-cascader-menu--noDateFirst': true,
            'el-cascader-menu--noDate': true
          },
          "style": menuStyle,
          "refInFor": true,
          "ref": 'menus'
        }, [h("span", {
          "class": {
            'el-cascader-noDate': true
          }
        }, [noMatch])]);
      }
    });

    return h("transition", {
      "attrs": {
        "name": 'el-zoom-in-top'
      },
      "on": {
        "before-enter": this.handleMenuEnter,
        "after-leave": this.handleMenuLeave
      }
    }, [h("div", {
      "directives": [{
        name: "show",
        value: visible
      }],
      "class": ['el-cascader-menus', popperClass],
      "ref": 'wrapper'
    }, [menus])]);
  }
});
// CONCATENATED MODULE: ./packages/cascader/src/menu.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_cascader_src_menuvue_type_script_lang_js_ = (cascader_src_menuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/cascader/src/menu.vue
var menu_render, menu_staticRenderFns




/* normalize component */

var src_menu_component = normalizeComponent(
  packages_cascader_src_menuvue_type_script_lang_js_,
  menu_render,
  menu_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var cascader_src_menu = (src_menu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/main.vue?vue&type=script&lang=js&














//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








 // import ElScrollbar from 'hui/packages/scrollbar';

var popperMixin = {
  props: {
    placement: {
      type: String,
      "default": 'bottom-start'
    },
    appendToBody: vue_popper.props.appendToBody,
    offset: vue_popper.props.offset,
    boundariesPadding: vue_popper.props.boundariesPadding,
    popperOptions: vue_popper.props.popperOptions
  },
  methods: vue_popper.methods,
  data: vue_popper.data,
  beforeDestroy: vue_popper.beforeDestroy
};
/* harmony default export */ var cascader_src_mainvue_type_script_lang_js_ = ({
  name: 'ElCascader',
  directives: {
    Clickoutside: clickoutside
  },
  components: {
    ElInput: packages_input // ElScrollbar

  },
  mixins: [popperMixin, emitter, locale],
  props: {
    options: {
      type: Array,
      required: true
    },
    props: {
      type: Object,
      "default": function _default() {
        return {
          children: 'children',
          label: 'label',
          value: 'value',
          disabled: 'disabled'
        };
      }
    },
    value: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      "default": function _default() {
        return Object(locale_["t"])('el.cascader.placeholder');
      }
    },
    disabled: {
      type: Boolean,
      "default": null
    },
    clearable: {
      type: Boolean,
      "default": false
    },
    changeOnSelect: {
      type: Boolean,
      "default": null
    },
    popperClass: {
      type: String,
      "default": null
    },
    noMatch: {
      type: String,
      "default": function _default() {
        return Object(locale_["t"])('el.cascader.noMatch');
      }
    },
    loading: {
      type: Boolean,
      "default": false
    },
    check: {
      type: Function,
      "default": function _default() {
        return true;
      }
    },
    expandTrigger: {
      type: String,
      "default": 'click'
    },
    filterable: {
      type: Boolean,
      "default": null
    },
    size: {
      type: String,
      "default": null
    },
    showAllLevels: {
      type: Boolean,
      "default": true
    },
    debounce: {
      type: Number,
      "default": 300
    },
    beforeFilter: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.value || [],
      // currentValueTitle: '',
      menu: null,
      debouncedInputChange: function debouncedInputChange() {},
      menuVisible: false,
      inputHover: false,
      inputValue: '',
      flatOptions: null
    };
  },
  computed: {
    labelKey: function labelKey() {
      return this.props.label || 'label';
    },
    valueKey: function valueKey() {
      return this.props.value || 'value';
    },
    childrenKey: function childrenKey() {
      return this.props.children || 'children';
    },
    currentLabels: function currentLabels() {
      var _this = this;

      var options = this.options;
      var labels = [];
      this.currentValue.forEach(function (value) {
        var targetOption = options && options.filter(function (option) {
          return option[_this.valueKey] === value;
        })[0];

        if (targetOption) {
          labels.push(targetOption[_this.labelKey]);
          options = targetOption[_this.childrenKey];
        }
      });
      return labels;
    },
    currentValueTitle: function currentValueTitle() {
      return this.currentLabels.join('/');
    }
  },
  watch: {
    menuVisible: function menuVisible(value) {
      value ? this.showMenu() : this.hideMenu();
    },
    value: function value(_value) {
      this.currentValue = _value;
    },
    currentValue: function currentValue(value) {
      this.dispatch('ElFormItem', 'el.form.change', [value]);
    },
    options: {
      deep: true,
      handler: function handler(value) {
        if (!this.menu) {
          this.initMenu();
        }

        this.flatOptions = this.flattenOptions(this.options);
        this.menu.options = value;
      }
    },
    loading: {
      deep: true,
      handler: function handler(value) {
        if (!this.menu) {
          this.initMenu();
        }

        this.menu.loading = value;
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.debouncedInputChange = debounce_default()(this.debounce, function (value) {
      var before = _this2.beforeFilter(value);

      if (before && before.then) {
        _this2.menu.options = [{
          __IS__FLAT__OPTIONS: true,
          label: _this2.t('el.cascader.loading'),
          value: '',
          disabled: true
        }];
        before.then(function () {
          _this2.$nextTick(function () {
            _this2.handleInputChange(value);
          });
        });
      } else if (before !== false) {
        _this2.$nextTick(function () {
          _this2.handleInputChange(value);
        });
      }
    });
  },
  mounted: function mounted() {
    this.flatOptions = this.flattenOptions(this.options);
  },
  methods: {
    initMenu: function initMenu() {
      this.menu = new external_vue_default.a(cascader_src_menu).$mount();
      this.menu.options = this.options;
      this.menu.loading = this.loading;
      this.menu.filterable = this.filterable;
      this.menu.inputValue = this.inputValue;
      this.menu.props = this.props;
      this.menu.expandTrigger = this.expandTrigger;
      this.menu.noMatch = this.noMatch;
      this.menu.loadingTitle = this.t('el.cascader.loading');
      this.menu.check = this.check;
      this.menu.changeOnSelect = this.changeOnSelect;
      this.menu.popperClass = this.popperClass;
      this.popperElm = this.menu.$el;
      this.menu.$on('pick', this.handlePick);
      this.menu.$on('activeItemChange', this.handleActiveItemChange);
      this.menu.$on('menuLeave', this.doDestroy);
    },
    showMenu: function showMenu() {
      var _this3 = this;

      if (!this.menu) {
        this.initMenu();
      }

      this.menu.value = this.currentValue.slice(0);
      this.menu.visible = true;
      this.menu.options = this.options;
      this.$nextTick(function () {
        _this3.updatePopper();

        _this3.menu.inputWidth = _this3.$refs.input.$el.offsetWidth - 2;
      });
    },
    hideMenu: function hideMenu() {
      this.inputValue = '';
      this.menu.visible = false;
    },
    handleActiveItemChange: function handleActiveItemChange(value) {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.updatePopper();
      });
      this.$emit('active-item-change', value);
    },
    handlePick: function handlePick(value, children) {
      var close = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      this.currentValue = value;
      this.$emit('input', value);
      this.$emit('change', value);

      if (close && !(this.changeOnSelect && children)) {
        this.menuVisible = false;
      } else {
        this.$nextTick(this.updatePopper);
      }
    },
    handleFocus: function handleFocus(event) {
      this.$emit('focus', event);
    },
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
    },
    handleInputChange: function handleInputChange(value) {
      var _this5 = this;

      if (!this.menuVisible) return;
      var flatOptions = this.flatOptions;

      if (!value) {
        this.menu.options = this.options;
        this.$nextTick(this.updatePopper);
        return;
      }

      var filteredFlatOptions = flatOptions.filter(function (optionsStack) {
        return optionsStack.some(function (option) {
          return !option.disabled && new RegExp(value, 'i').test(option[_this5.labelKey]);
        });
      });

      if (filteredFlatOptions.length > 0) {
        filteredFlatOptions = filteredFlatOptions.map(function (optionStack) {
          return {
            __IS__FLAT__OPTIONS: true,
            value: optionStack.map(function (item) {
              return item[_this5.valueKey];
            }),
            label: _this5.renderFilteredOptionLabel(value, optionStack)
          };
        });
      } else {
        filteredFlatOptions = [];
      }

      this.menu.options = filteredFlatOptions;
      this.$nextTick(this.updatePopper);
    },
    renderFilteredOptionLabel: function renderFilteredOptionLabel(inputValue, optionsStack) {
      var _this6 = this;

      return optionsStack.map(function (option, index) {
        var label = option[_this6.labelKey];
        var keywordIndex = label.toLowerCase().indexOf(inputValue.toLowerCase());
        var labelPart = label.slice(keywordIndex, inputValue.length + keywordIndex);
        var node = keywordIndex > -1 ? _this6.highlightKeyword(label, labelPart) : label;
        return index === 0 ? node : ['/', node];
      });
    },
    highlightKeyword: function highlightKeyword(label, keyword) {
      var _this7 = this;

      var h = this._c;
      return label.split(keyword).map(function (node, index) {
        return index === 0 ? node : [h('span', {
          "class": {
            'el-cascader-menu__item__keyword': true
          }
        }, [_this7._v(keyword)]), node];
      });
    },
    flattenOptions: function flattenOptions(options) {
      var _this8 = this;

      var ancestor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var flatOptions = [];
      options.forEach(function (option) {
        var optionsStack = ancestor.concat(option);

        if (!option[_this8.childrenKey]) {
          flatOptions.push(optionsStack);
        } else {
          if (_this8.changeOnSelect) {
            flatOptions.push(optionsStack);
          }

          flatOptions = flatOptions.concat(_this8.flattenOptions(option[_this8.childrenKey], optionsStack));
        }
      });
      return flatOptions;
    },
    clearValue: function clearValue(ev) {
      ev.stopPropagation();
      this.inputValue = '';
      this.handlePick([], true);
    },
    handleClickoutside: function handleClickoutside() {
      this.menuVisible = false;
    },
    handleClick: function handleClick() {
      if (this.disabled) return;

      if (this.filterable) {
        this.menuVisible = true;
        this.$refs.input.$refs.input.focus();
        return;
      }

      this.menuVisible = !this.menuVisible;
    }
  }
});
// CONCATENATED MODULE: ./packages/cascader/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_cascader_src_mainvue_type_script_lang_js_ = (cascader_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/cascader/src/main.vue





/* normalize component */

var cascader_src_main_component = normalizeComponent(
  packages_cascader_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_ea8ef2e2_render,
  mainvue_type_template_id_ea8ef2e2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var cascader_src_main = (cascader_src_main_component.exports);
// CONCATENATED MODULE: ./packages/cascader/index.js


/* istanbul ignore next */

cascader_src_main.install = function (Vue) {
  Vue.component(cascader_src_main.name, cascader_src_main);
};

/* harmony default export */ var cascader = (cascader_src_main);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=template&id=37945865&
var mainvue_type_template_id_37945865_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.hide),expression:"hide"}],staticClass:"h-color-picker"},[_c('el-input',{ref:"inputColor",staticClass:"h-color-picker__input",class:{ 'is-disabled': _vm.disabled },style:(_vm.innerStyle),attrs:{"placeholder":_vm.inputPlaceholder,"readonly":true},nativeOn:{"click":function($event){return _vm.switchShow($event)}},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}}),_c('picker-dropdown',{ref:"dropdown",staticClass:"h-color-picker__panel",class:{ 'is-Simple': _vm.isSimple },attrs:{"input-width":_vm.inputWidth,"current-color":_vm.value,"placement":"bottom-start","color-list":_vm.colorList,"is-simple":_vm.isSimple,"color":_vm.color,"show-alpha":_vm.showAlpha},on:{"selectSimpleColor":_vm.selectColor,"selectColor":_vm.selectColor,"pick":_vm.confirmValue},model:{value:(_vm.showPicker),callback:function ($$v) {_vm.showPicker=$$v},expression:"showPicker"}})],1)}
var mainvue_type_template_id_37945865_staticRenderFns = []


// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=template&id=37945865&

// CONCATENATED MODULE: ./packages/color-picker/src/color.js



















var hsv2hsl = function hsv2hsl(hue, sat, val) {
  return [hue, sat * val / ((hue = (2 - sat) * val) < 1 ? hue : 2 - hue) || 0, hue / 2];
}; // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>


var isOnePointZero = function isOnePointZero(n) {
  return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
};

var isPercentage = function isPercentage(n) {
  return typeof n === 'string' && n.indexOf('%') !== -1;
}; // Take input from [0, n] and return it as [0, 1]


var bound01 = function bound01(value, max) {
  if (isOnePointZero(value)) value = '100%';
  var processPercent = isPercentage(value);
  value = Math.min(max, Math.max(0, parseFloat(value))); // Automatically convert percentage into number

  if (processPercent) {
    value = parseInt(value * max, 10) / 100;
  } // Handle floating point rounding errors


  if (Math.abs(value - max) < 0.000001) {
    return 1;
  } // Convert into [0, 1] range if it isn't already


  return value % max / parseFloat(max);
};

var INT_HEX_MAP = {
  10: 'A',
  11: 'B',
  12: 'C',
  13: 'D',
  14: 'E',
  15: 'F'
};

var _toHex = function toHex(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b;

  var hexOne = function hexOne(value) {
    value = Math.min(Math.round(value), 255);
    var high = Math.floor(value / 16);
    var low = value % 16;
    return '' + (INT_HEX_MAP[high] || high) + (INT_HEX_MAP[low] || low);
  };

  if (isNaN(r) || isNaN(g) || isNaN(b)) return '';
  return '#' + hexOne(r) + hexOne(g) + hexOne(b);
};

var HEX_INT_MAP = {
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15
};

var parseHexChannel = function parseHexChannel(hex) {
  if (hex.length === 2) {
    return (HEX_INT_MAP[hex[0].toUpperCase()] || +hex[0]) * 16 + (HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1]);
  }

  return HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1];
};

var hsl2hsv = function hsl2hsv(hue, sat, light) {
  sat = sat / 100;
  light = light / 100;
  var smin = sat;
  var lmin = Math.max(light, 0.01);
  light *= 2;
  sat *= light <= 1 ? light : 2 - light;
  smin *= lmin <= 1 ? lmin : 2 - lmin;
  var v = (light + sat) / 2;
  var sv = light === 0 ? 2 * smin / (lmin + smin) : 2 * sat / (light + sat);
  return {
    h: hue,
    s: sv * 100,
    v: v * 100
  };
}; // `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]


var rgb2hsv = function rgb2hsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var h;
  var v = max;
  var d = max - min;
  var s = max === 0 ? 0 : d / max;

  if (max === min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;

      case g:
        h = (b - r) / d + 2;
        break;

      case b:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return {
    h: h * 360,
    s: s * 100,
    v: v * 100
  };
}; // `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]


var hsv2rgb = function hsv2rgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  var i = Math.floor(h);
  var f = h - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);
  var mod = i % 6;
  var r = [v, q, p, p, t, v][mod];
  var g = [t, v, v, q, p, p][mod];
  var b = [p, p, t, v, v, q][mod];
  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255)
  };
};

var color_Color = /*#__PURE__*/function () {
  function Color(options) {
    _classCallCheck(this, Color);

    this._hue = 0;
    this._saturation = 100;
    this._value = 100;
    this._alpha = 100;
    this.enableAlpha = false;
    this.format = 'hex';
    this.value = '';
    options = options || {};

    for (var option in options) {
      if (hasOwn(options, option)) {
        this[option] = options[option];
      }
    }

    this.doOnChange();
  }

  _createClass(Color, [{
    key: "set",
    value: function set(prop, value) {
      if (arguments.length === 1 && _typeof(prop) === 'object') {
        for (var p in prop) {
          if (hasOwn(prop, p)) {
            this.set(p, prop[p]);
          }
        }

        return;
      }

      this['_' + prop] = value;
      this.doOnChange();
    }
  }, {
    key: "get",
    value: function get(prop) {
      return this['_' + prop];
    }
  }, {
    key: "toRgb",
    value: function toRgb() {
      return hsv2rgb(this._hue, this._saturation, this._value);
    }
  }, {
    key: "toHsl",
    value: function toHsl() {
      return hsv2hsl(this._hue, this._saturation / 100, this._value / 100);
    }
  }, {
    key: "toHsla",
    value: function toHsla() {
      var hsl = hsv2hsl(this._hue, this._saturation / 100, this._value / 100);
      return {
        h: Number(this._hue).toFixed(0),
        s: Math.round(hsl[1] * 100) + '%',
        l: Math.round(hsl[2] * 100) + '%',
        a: this._alpha / 100
      };
    }
  }, {
    key: "toHex",
    value: function toHex() {
      return _toHex(hsv2rgb(this._hue, this._saturation, this._value));
    }
  }, {
    key: "rgbToHex",
    value: function rgbToHex() {
      // rgba 转 hex 会放弃 alpha 通道
      var matches = this.value.match(/^rgba\((\d+), ?(\d+), ?(\d+), ?([.0-9]+)\)$/);
      var list = matches.map(function (v) {
        return parseInt(v, 10);
      }).slice(1); // list [169, 71, 71, 1]

      return _toHex({
        r: list[0],
        g: list[1],
        b: list[2]
      });
    }
  }, {
    key: "fromString",
    value: function fromString(value) {
      var _this = this;

      if (!value) {
        this._hue = 0;
        this._saturation = 100;
        this._value = 100;
        this.doOnChange();
        return;
      }

      var fromHSV = function fromHSV(h, s, v) {
        _this._hue = h;
        _this._saturation = s;
        _this._value = v;

        _this.doOnChange();
      };

      if (value.indexOf('hsl') !== -1) {
        var parts = value.replace(/hsla|hsl|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
          return val !== '';
        }).map(function (val, index) {
          return index > 2 ? parseFloat(val) : parseInt(val, 10);
        });

        if (parts.length === 4) {
          this._alpha = Math.floor(parseFloat(parts[3]) * 100);
        }

        if (parts.length >= 3) {
          var _hsl2hsv = hsl2hsv(parts[0], parts[1], parts[2]),
              h = _hsl2hsv.h,
              s = _hsl2hsv.s,
              v = _hsl2hsv.v;

          fromHSV(h, s, v);
        }
      } else if (value.indexOf('hsv') !== -1) {
        var _parts = value.replace(/hsva|hsv|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
          return val !== '';
        }).map(function (val, index) {
          return index > 2 ? parseFloat(val) : parseInt(val, 10);
        });

        if (_parts.length === 4) {
          this._alpha = Math.floor(parseFloat(_parts[3]) * 100);
        }

        if (_parts.length >= 3) {
          fromHSV(_parts[0], _parts[1], _parts[2]);
        }
      } else if (value.indexOf('rgb') !== -1) {
        var _parts2 = value.replace(/rgba|rgb|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
          return val !== '';
        }).map(function (val, index) {
          return index > 2 ? parseFloat(val) : parseInt(val, 10);
        });

        if (_parts2.length === 4) {
          this._alpha = Math.floor(parseFloat(_parts2[3]) * 100);
        }

        if (_parts2.length >= 3) {
          var _rgb2hsv = rgb2hsv(_parts2[0], _parts2[1], _parts2[2]),
              _h = _rgb2hsv.h,
              _s = _rgb2hsv.s,
              _v = _rgb2hsv.v;

          fromHSV(_h, _s, _v);
        }
      } else if (value.indexOf('#') !== -1) {
        var hex = value.replace('#', '').trim();
        var r, g, b;

        if (hex.length === 3) {
          r = parseHexChannel(hex[0] + hex[0]);
          g = parseHexChannel(hex[1] + hex[1]);
          b = parseHexChannel(hex[2] + hex[2]);
        } else if (hex.length === 6) {
          r = parseHexChannel(hex.substring(0, 2));
          g = parseHexChannel(hex.substring(2, 4));
          b = parseHexChannel(hex.substring(4));
        }

        var _rgb2hsv2 = rgb2hsv(r, g, b),
            _h2 = _rgb2hsv2.h,
            _s2 = _rgb2hsv2.s,
            _v2 = _rgb2hsv2.v;

        fromHSV(_h2, _s2, _v2);
      }
    }
  }, {
    key: "doOnChange",
    value: function doOnChange() {
      var _hue = this._hue,
          _saturation = this._saturation,
          _value = this._value,
          _alpha = this._alpha,
          format = this.format;

      if (this.enableAlpha) {
        switch (format) {
          case 'hsl':
            {
              var hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);
              this.value = "hsla(".concat(_hue, ", ").concat(Math.round(hsl[1] * 100), "%, ").concat(Math.round(hsl[2] * 100), "%, ").concat(_alpha / 100, ")");
              break;
            }

          case 'hsv':
            this.value = "hsva(".concat(_hue, ", ").concat(Math.round(_saturation), "%, ").concat(Math.round(_value), "%, ").concat(_alpha / 100, ")");
            break;

          default:
            {
              var _hsv2rgb = hsv2rgb(_hue, _saturation, _value),
                  r = _hsv2rgb.r,
                  g = _hsv2rgb.g,
                  b = _hsv2rgb.b;

              this.value = "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(_alpha / 100, ")");
            }
        }
      } else {
        switch (format) {
          case 'hsl':
            {
              var _hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);

              this.value = "hsl(".concat(_hue, ", ").concat(Math.round(_hsl[1] * 100), "%, ").concat(Math.round(_hsl[2] * 100), "%)");
              break;
            }

          case 'hsv':
            this.value = "hsv(".concat(_hue, ", ").concat(Math.round(_saturation), "%, ").concat(Math.round(_value), "%)");
            break;

          case 'rgb':
            {
              var _hsv2rgb2 = hsv2rgb(_hue, _saturation, _value),
                  _r = _hsv2rgb2.r,
                  _g = _hsv2rgb2.g,
                  _b = _hsv2rgb2.b;

              this.value = "rgb(".concat(_r, ", ").concat(_g, ", ").concat(_b, ")");
              break;
            }

          default:
            this.value = _toHex(hsv2rgb(_hue, _saturation, _value));
        }
      }
    }
  }]);

  return Color;
}();


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=b5437c72&
var picker_dropdownvue_type_template_id_b5437c72_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"after-leave":_vm.doDestroy}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"h-color-dropdown"},[(!_vm.isSimple)?_c('div',{staticClass:"h-color-dropdown__complex-main-wrapper",class:{ 'is-showAlpha': _vm.showAlpha },attrs:{"show-alpha":_vm.showAlpha}},[_c('sv-panel',{ref:"sl",attrs:{"color":_vm.color,"show-alpha":_vm.showAlpha}}),_c('hue-slider',{ref:"hue",attrs:{"color":_vm.color,"vertical":"","show-alpha":_vm.showAlpha}}),(_vm.showAlpha)?_c('alpha-slider',{ref:"alpha",attrs:{"vertical":"","color":_vm.color,"show-alpha":_vm.showAlpha}}):_vm._e(),_c('color-details',{ref:"details",attrs:{"color":_vm.color,"show-alpha":_vm.showAlpha,"vertical":"","current-color":_vm.currentColor},on:{"selectColor":_vm.selectColor}})],1):_c('div',{staticClass:"h-color-dropdown__simple-main-wrapper",style:({ minWidth: _vm.inputWidth, maxWidth: _vm.inputWidth })},[_c('simple-panel',{attrs:{"color-list":_vm.colorList,"color":_vm.color},on:{"selectSimpleColor":_vm.selectSimpleColor}})],1)])])}
var picker_dropdownvue_type_template_id_b5437c72_staticRenderFns = []


// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=b5437c72&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=5ed34328&
var sv_panelvue_type_template_id_5ed34328_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-color-svpanel",class:{ 'is-showAlpha': _vm.showAlpha },style:({
    backgroundColor: _vm.background
  })},[_c('div',{staticClass:"h-color-svpanel__white"}),_c('div',{staticClass:"h-color-svpanel__black"}),_c('div',{staticClass:"h-color-svpanel__cursor",style:({
      top: _vm.cursorTop + 'px',
      left: _vm.cursorLeft + 'px'
    })},[_c('div')])])}
var sv_panelvue_type_template_id_5ed34328_staticRenderFns = []


// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=5ed34328&

// CONCATENATED MODULE: ./packages/color-picker/src/draggable.js

var isDragging = false;
/* harmony default export */ var draggable = (function (element, options) {
  if (external_vue_default.a.prototype.$isServer) return;

  var moveFn = function moveFn(event) {
    if (options.drag) {
      options.drag(event);
    }
  };

  var upFn = function upFn(event) {
    document.removeEventListener('mousemove', moveFn);
    document.removeEventListener('mouseup', upFn);
    document.onselectstart = null;
    document.ondragstart = null;
    isDragging = false;

    if (options.end) {
      options.end(event);
    }
  };

  element.addEventListener('mousedown', function (event) {
    if (isDragging) return;

    document.onselectstart = function () {
      return false;
    };

    document.ondragstart = function () {
      return false;
    };

    document.addEventListener('mousemove', moveFn);
    document.addEventListener('mouseup', upFn);
    isDragging = true;

    if (options.start) {
      options.start(event);
    }
  });
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var sv_panelvue_type_script_lang_js_ = ({
  name: 'ElSlPanel',
  props: {
    color: {
      type: null,
      "default": null,
      required: true
    },
    showAlpha: {
      type: Boolean,
      "default": null
    }
  },
  data: function data() {
    return {
      cursorTop: 0,
      cursorLeft: 0,
      background: 'hsl(0, 100%, 50%)'
    };
  },
  computed: {
    colorValue: function colorValue() {
      var hue = this.color.get('hue');
      var value = this.color.get('value');
      return {
        hue: hue,
        value: value
      };
    }
  },
  watch: {
    colorValue: function colorValue() {
      this.update();
    }
  },
  mounted: function mounted() {
    var _this = this;

    draggable(this.$el, {
      drag: function drag(event) {
        _this.handleDrag(event);
      },
      end: function end(event) {
        _this.handleDrag(event);
      }
    });
    this.update();
  },
  methods: {
    update: function update() {
      var saturation = this.color.get('saturation');
      var value = this.color.get('value');
      var el = this.$el;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          width = _el$getBoundingClient.width;

      var _el$getBoundingClient2 = el.getBoundingClientRect(),
          height = _el$getBoundingClient2.height;

      if (!height) height = width * 3 / 4;
      this.cursorLeft = saturation * width / 100;
      this.cursorTop = (100 - value) * height / 100;
      this.background = 'hsl(' + this.color.get('hue') + ', 100%, 50%)';
    },
    handleDrag: function handleDrag(event) {
      var el = this.$el;
      var rect = el.getBoundingClientRect();
      var left = event.clientX - rect.left;
      var top = event.clientY - rect.top;
      left = Math.max(0, left);
      left = Math.min(left, rect.width);
      top = Math.max(0, top);
      top = Math.min(top, rect.height);
      this.cursorLeft = left;
      this.cursorTop = top;
      this.color.set({
        saturation: left / rect.width * 100,
        value: 100 - top / rect.height * 100
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_sv_panelvue_type_script_lang_js_ = (sv_panelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue





/* normalize component */

var sv_panel_component = normalizeComponent(
  components_sv_panelvue_type_script_lang_js_,
  sv_panelvue_type_template_id_5ed34328_render,
  sv_panelvue_type_template_id_5ed34328_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var sv_panel = (sv_panel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=f46ca322&
var hue_slidervue_type_template_id_f46ca322_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-color-hue-slider",class:{ 'is-vertical': _vm.vertical, 'is-showAlpha': _vm.showAlpha }},[_c('div',{ref:"bar",staticClass:"h-color-hue-slider__bar",on:{"click":_vm.handleClick}}),_c('div',{ref:"thumb",staticClass:"h-color-hue-slider__thumb",style:({
      left: _vm.thumbLeft + 'px',
      top: _vm.thumbTop + 'px'
    })})])}
var hue_slidervue_type_template_id_f46ca322_staticRenderFns = []


// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=f46ca322&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var hue_slidervue_type_script_lang_js_ = ({
  name: 'ElColorHueSlider',
  props: {
    color: {
      type: null,
      "default": null,
      required: true
    },
    vertical: {
      type: Boolean,
      "default": null
    },
    showAlpha: {
      type: Boolean,
      "default": null
    }
  },
  data: function data() {
    return {
      thumbLeft: 0,
      thumbTop: 0
    };
  },
  computed: {
    hueValue: function hueValue() {
      var hue = this.color.get('hue');
      return hue;
    }
  },
  watch: {
    hueValue: function hueValue() {
      this.update();
    }
  },
  mounted: function mounted() {
    var _this = this;

    var _this$$refs = this.$refs,
        bar = _this$$refs.bar,
        thumb = _this$$refs.thumb;
    var dragConfig = {
      drag: function drag(event) {
        _this.handleDrag(event);
      },
      end: function end(event) {
        _this.handleDrag(event);
      }
    };
    draggable(bar, dragConfig);
    draggable(thumb, dragConfig);
    this.update();
  },
  methods: {
    handleClick: function handleClick(event) {
      var thumb = this.$refs.thumb;
      var target = event.target;

      if (target !== thumb) {
        this.handleDrag(event);
      }
    },
    handleDrag: function handleDrag(event) {
      var rect = this.$el.getBoundingClientRect();
      var thumb = this.$refs.thumb;
      var hue;

      if (!this.vertical) {
        var left = event.clientX - rect.left;
        left = Math.min(left, rect.width - thumb.offsetWidth / 2);
        left = Math.max(thumb.offsetWidth / 2, left);
        hue = Math.round((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth) * 360);
      } else {
        var top = event.clientY - rect.top;
        top = Math.min(top, rect.height - thumb.offsetHeight / 2);
        top = Math.max(thumb.offsetHeight / 2, top);
        hue = Math.round((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight) * 360);
      }

      this.color.set('hue', hue);
    },
    getThumbLeft: function getThumbLeft() {
      if (this.vertical) return 0;
      var el = this.$el;
      var hue = this.color.get('hue');
      if (!el) return 0;
      var thumb = this.$refs.thumb;
      return Math.round(hue * (el.offsetWidth - thumb.offsetWidth / 2) / 360);
    },
    getThumbTop: function getThumbTop() {
      if (!this.vertical) return 0;
      var el = this.$el;
      var hue = this.color.get('hue');
      if (!el) return 0;
      var thumb = this.$refs.thumb;
      return Math.round(hue * (el.offsetHeight - thumb.offsetHeight / 2) / 360);
    },
    update: function update() {
      this.thumbLeft = this.getThumbLeft();
      this.thumbTop = this.getThumbTop();
    }
  }
});
// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_hue_slidervue_type_script_lang_js_ = (hue_slidervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue





/* normalize component */

var hue_slider_component = normalizeComponent(
  components_hue_slidervue_type_script_lang_js_,
  hue_slidervue_type_template_id_f46ca322_render,
  hue_slidervue_type_template_id_f46ca322_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var hue_slider = (hue_slider_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/simple-panel.vue?vue&type=template&id=5fccd522&
var simple_panelvue_type_template_id_5fccd522_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-color-simple-panel",style:({ minWidth: _vm.minWidth, maxWidth: _vm.maxWidth })},[_c('el-scrollbar',{attrs:{"wrap-class":"h-colorPicker-scrollbar-wrap"}},[_c('div',{staticClass:"h-color-simple-panel-wrapper"},_vm._l((_vm.colorList),function(itemColor,index){return _c('div',{key:index,staticClass:"h-color-simple-panel-item",style:({
          background: itemColor,
          border:
            itemColor === _vm.color.value.toLowerCase() ? '2px solid black' : ''
        }),on:{"click":function($event){return _vm.selectSimpleColor(itemColor)}}})}),0)])],1)}
var simple_panelvue_type_template_id_5fccd522_staticRenderFns = []


// CONCATENATED MODULE: ./packages/color-picker/src/components/simple-panel.vue?vue&type=template&id=5fccd522&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/simple-panel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var simple_panelvue_type_script_lang_js_ = ({
  nameL: 'ElColorSimplePanel',
  components: {
    ElScrollbar: scrollbar
  },
  props: {
    colorList: {
      type: Array,
      "default": null
    },
    color: {
      type: null,
      "default": null,
      required: true
    }
  },
  data: function data() {
    return {
      minWidth: '',
      maxWidth: ''
    };
  },
  methods: {
    selectSimpleColor: function selectSimpleColor(color) {
      this.color.fromString(color);
      this.$emit('selectSimpleColor', color);
    }
  }
});
// CONCATENATED MODULE: ./packages/color-picker/src/components/simple-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_simple_panelvue_type_script_lang_js_ = (simple_panelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/color-picker/src/components/simple-panel.vue





/* normalize component */

var simple_panel_component = normalizeComponent(
  components_simple_panelvue_type_script_lang_js_,
  simple_panelvue_type_template_id_5fccd522_render,
  simple_panelvue_type_template_id_5fccd522_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var simple_panel = (simple_panel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=45a7c397&
var alpha_slidervue_type_template_id_45a7c397_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-color-alpha-slider",class:{ 'is-vertical': _vm.vertical, 'is-showAlpha': _vm.showAlpha }},[_c('div',{ref:"bar",staticClass:"h-color-alpha-slider__bar",style:({
      background: _vm.background
    }),on:{"click":_vm.handleClick}}),_c('div',{ref:"thumb",staticClass:"h-color-alpha-slider__thumb",style:({
      left: _vm.thumbLeft + 'px',
      top: _vm.thumbTop + 'px'
    })})])}
var alpha_slidervue_type_template_id_45a7c397_staticRenderFns = []


// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=45a7c397&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var alpha_slidervue_type_script_lang_js_ = ({
  name: 'ElColorAlphaSlider',
  props: {
    color: {
      type: null,
      "default": null,
      required: true
    },
    vertical: {
      type: Boolean,
      "default": null
    },
    showAlpha: {
      type: Boolean,
      "default": null
    }
  },
  data: function data() {
    return {
      thumbLeft: 0,
      thumbTop: 0,
      background: null
    };
  },
  watch: {
    'color._alpha': function color_alpha() {
      this.update();
    },
    'color.value': function colorValue() {
      this.update();
    }
  },
  mounted: function mounted() {
    var _this = this;

    var _this$$refs = this.$refs,
        bar = _this$$refs.bar,
        thumb = _this$$refs.thumb;
    var dragConfig = {
      drag: function drag(event) {
        _this.handleDrag(event);
      },
      end: function end(event) {
        _this.handleDrag(event);
      }
    };
    draggable(bar, dragConfig);
    draggable(thumb, dragConfig);
    this.update();
  },
  methods: {
    handleClick: function handleClick(event) {
      var thumb = this.$refs.thumb;
      var target = event.target;

      if (target !== thumb) {
        this.handleDrag(event);
      }
    },
    handleDrag: function handleDrag(event) {
      var rect = this.$el.getBoundingClientRect();
      var thumb = this.$refs.thumb;
      var top = event.clientY - rect.top;
      top = Math.max(thumb.offsetHeight / 2, top);
      top = Math.min(top, rect.height - thumb.offsetHeight / 2);
      this.color.set('alpha', Math.round((278 - (top + thumb.offsetHeight / 2)) / (rect.height - thumb.offsetHeight) * 100));
    },
    getThumbLeft: function getThumbLeft() {
      if (this.vertical) return 0;
      var el = this.$el;
      var alpha = this.color._alpha;
      if (!el) return 0;
      var thumb = this.$refs.thumb;
      return Math.round(alpha * (el.offsetWidth - thumb.offsetWidth / 2) / 100);
    },
    getThumbTop: function getThumbTop() {
      if (!this.vertical) return 0;
      var el = this.$el;
      var alpha = this.color._alpha;
      if (!el) return 0;
      return Math.round(el.offsetHeight - alpha * el.offsetHeight / 100);
    },
    getBackground: function getBackground() {
      if (this.color && this.color.value) {
        var _this$color$toRgb = this.color.toRgb(),
            r = _this$color$toRgb.r,
            g = _this$color$toRgb.g,
            b = _this$color$toRgb.b;

        return "linear-gradient(to top, rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", 0) 0%, rgba(").concat(r, ", ").concat(g, ", ").concat(b, ", 1) 100%)");
      }

      return null;
    },
    update: function update() {
      this.thumbTop = this.getThumbTop();
      this.background = this.getBackground();
    }
  }
});
// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_alpha_slidervue_type_script_lang_js_ = (alpha_slidervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue





/* normalize component */

var alpha_slider_component = normalizeComponent(
  components_alpha_slidervue_type_script_lang_js_,
  alpha_slidervue_type_template_id_45a7c397_render,
  alpha_slidervue_type_template_id_45a7c397_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var alpha_slider = (alpha_slider_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/color-details.vue?vue&type=template&id=543cf875&
var color_detailsvue_type_template_id_543cf875_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-color-details"},[_c('div',{staticClass:"h-color-details-contrast"},[_vm._v(" "+_vm._s(_vm.t('el.colorpicker.new_name'))+" "),_c('div',[_c('div',{staticClass:"h-color-details-contrast-color h-color-details-contrast__newColor",style:({ background: _vm.newColor })}),_c('div',{staticClass:"h-color-details-contrast-color h-color-details-contrast__currentColor",style:({ background: _vm.currentColor })})]),_vm._v(" "+_vm._s(_vm.t('el.colorpicker.current_name'))+" ")]),_c('div',{staticClass:"h-color-details-numerical"},[_c('div',{staticClass:"h-color-details-numerical-rgb-hsb-group"},[_c('div',{staticClass:"h-color-details-numerical-rgb"},[_c('div',{staticClass:"h-color-details-numerical__input"},[_c('el-input',{attrs:{"size":"mini","maxlength":3},model:{value:(_vm.rgbColor.r),callback:function ($$v) {_vm.$set(_vm.rgbColor, "r", $$v)},expression:"rgbColor.r"}},[_c('template',{slot:"prepend"},[_c('span',{},[_vm._v("R")])])],2)],1),_c('div',{staticClass:"h-color-details-numerical__input"},[_c('el-input',{attrs:{"size":"mini","maxlength":3},model:{value:(_vm.rgbColor.g),callback:function ($$v) {_vm.$set(_vm.rgbColor, "g", $$v)},expression:"rgbColor.g"}},[_c('template',{slot:"prepend"},[_c('span',{},[_vm._v("G")])])],2)],1),_c('div',{staticClass:"h-color-details-numerical__input"},[_c('el-input',{attrs:{"size":"mini","maxlength":3},model:{value:(_vm.rgbColor.b),callback:function ($$v) {_vm.$set(_vm.rgbColor, "b", $$v)},expression:"rgbColor.b"}},[_c('template',{slot:"prepend"},[_c('span',{},[_vm._v("B")])])],2)],1),(_vm.showAlpha)?_c('div',{staticClass:"h-color-details-numerical__input"},[_c('el-input',{attrs:{"size":"mini","maxlength":4},model:{value:(_vm.rgbColor.a),callback:function ($$v) {_vm.$set(_vm.rgbColor, "a", $$v)},expression:"rgbColor.a"}},[_c('template',{slot:"prepend"},[_c('span',{},[_vm._v("A")])])],2)],1):_vm._e()]),_c('div',{staticClass:"h-color-details-numerical-hsb"},[_c('div',{staticClass:"h-color-details-numerical__input"},[_c('el-input',{attrs:{"size":"mini","maxlength":3},model:{value:(_vm.hslColor.h),callback:function ($$v) {_vm.$set(_vm.hslColor, "h", $$v)},expression:"hslColor.h"}},[_c('template',{slot:"prepend"},[_c('span',{},[_vm._v("H")])])],2)],1),_c('div',{staticClass:"h-color-details-numerical__input",attrs:{"maxlength":3}},[_c('el-input',{attrs:{"size":"mini"},model:{value:(_vm.hslColor.s),callback:function ($$v) {_vm.$set(_vm.hslColor, "s", $$v)},expression:"hslColor.s"}},[_c('template',{slot:"prepend"},[_c('span',{},[_vm._v("S")])])],2)],1),_c('div',{staticClass:"h-color-details-numerical__input",attrs:{"maxlength":3}},[_c('el-input',{attrs:{"size":"mini"},model:{value:(_vm.hslColor.l),callback:function ($$v) {_vm.$set(_vm.hslColor, "l", $$v)},expression:"hslColor.l"}},[_c('template',{slot:"prepend"},[_c('span',{},[_vm._v("L")])])],2)],1),(_vm.showAlpha)?_c('div',{staticClass:"h-color-details-numerical__input"},[_c('el-input',{attrs:{"size":"mini","maxlength":4},model:{value:(_vm.hslColor.a),callback:function ($$v) {_vm.$set(_vm.hslColor, "a", $$v)},expression:"hslColor.a"}},[_c('template',{slot:"prepend"},[_c('span',{},[_vm._v("A")])])],2)],1):_vm._e()])]),_c('div',{staticClass:"h-color-details-numerical-hex"},[_c('div',{staticClass:"h-color-details-numerical__input"},[_c('el-input',{attrs:{"size":"mini","maxlength":6},model:{value:(_vm.hexColor),callback:function ($$v) {_vm.hexColor=$$v},expression:"hexColor"}},[_c('template',{slot:"prepend"},[_c('span',{},[_vm._v("#")])])],2)],1)])]),_c('div',{staticClass:"h-color-details-button"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirmValue}},[_vm._v(" "+_vm._s(_vm.t('el.colorpicker.confirm'))+" ")])],1)])}
var color_detailsvue_type_template_id_543cf875_staticRenderFns = []


// CONCATENATED MODULE: ./packages/color-picker/src/components/color-details.vue?vue&type=template&id=543cf875&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/color-details.vue?vue&type=script&lang=js&













//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var color_detailsvue_type_script_lang_js_ = ({
  name: 'ElColorDetails',
  components: {
    ElInput: packages_input,
    ElButton: packages_button
  },
  mixins: [locale],
  props: {
    color: {
      type: null,
      "default": null,
      required: true
    },
    currentColor: {
      type: String,
      "default": ''
    },
    showAlpha: {
      type: Boolean,
      "default": null
    }
  },
  data: function data() {
    return {
      hexColor: '',
      // 进制颜色
      rgbColor: {
        r: '',
        g: '',
        b: '',
        a: 1
      },
      hslColor: {
        h: '',
        s: '',
        l: '',
        a: 1
      },
      newColor: ''
    };
  },
  computed: {
    cacheHslColor: function cacheHslColor() {
      return JSON.parse(JSON.stringify(this.hslColor));
    },
    cacheRgbColor: function cacheRgbColor() {
      return JSON.parse(JSON.stringify(this.rgbColor));
    }
  },
  watch: {
    color: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        this.hexColor = this.showAlpha ? this.color.rgbToHex().split('#')[1] : this.color.value.split('#')[1];
        this.newColor = this.showAlpha ? this.color.rgbToHex() : this.color.value;

        if (this.showAlpha) {
          var matches = this.color.value.match(/^rgba\((\d+), ?(\d+), ?(\d+), ?([.0-9]+)\)$/);
          var list = matches.map(function (v) {
            return parseFloat(v, 10);
          }).slice(1);
          this.rgbColor = {
            r: list[0],
            g: list[1],
            b: list[2],
            a: list[3]
          };
        } else {
          this.rgbColor = _objectSpread2({}, this.color.toRgb());
        }

        var hslColorData = _toConsumableArray(this.color.toHsl());

        this.hslColor = this.showAlpha ? this.color.toHsla() : {
          h: Number(hslColorData[0]).toFixed(0),
          s: Number(hslColorData[1] * 100).toFixed(0) + '%',
          l: Number(hslColorData[2] * 100).toFixed(0) + '%'
        };
        this.newColor = val.value;
      }
    },
    hexColor: function hexColor(val, oldvalue) {
      if (val !== oldvalue) {
        if (this.validHex(val)) {
          this.color.fromString('#' + val);
        }
      }
    },
    cacheRgbColor: {
      handler: function handler(color, oldvalue) {
        if (JSON.stringify(color) !== JSON.stringify(oldvalue)) {
          if (this.validRgbColor(color)) {
            this.color.fromString("rgb(".concat(color.r, ",").concat(color.g, ",").concat(color.b, ",").concat(color.a, ")"));
          }
        }
      },
      deep: true
    },
    cacheHslColor: {
      handler: function handler(color, oldvalue) {
        if (oldvalue.h === '' && oldvalue.l === '' && oldvalue.a === '') return;

        if (JSON.stringify(color) !== JSON.stringify(oldvalue)) {
          if (this.validHslColor(color)) {
            this.color.fromString("hsl(".concat(color.h, ",").concat(color.s, ",").concat(color.l, ",").concat(color.a, ")"));
          }
        }
      },
      deep: true
    }
  },
  methods: {
    confirmValue: function confirmValue() {
      this.$emit('selectColor', this.color);
    },
    validHex: function validHex(color) {
      return /^[A-Fa-f0-9]{6}$/.test(color);
    },
    validRgbColor: function validRgbColor(color) {
      var r = color.r,
          g = color.g,
          b = color.b,
          a = color.a;
      var newArr = [r, g, b];
      var numReg = /^(0|[1-9]\d*)$/;
      var aReg = /^(0\.[0-9]{0,2}|0|1)$/;
      if (newArr.some(function (item) {
        return !numReg.test(item);
      })) return false;
      newArr = newArr.map(function (item) {
        return parseInt(item, 10);
      });
      if (newArr.some(function (v) {
        return v < 0 || v > 255;
      })) return false;
      if (!aReg.test(a) || /\.$/.test(a)) return false;
      return true;
    },
    validHslColor: function validHslColor(color) {
      var h = color.h,
          s = color.s,
          l = color.l,
          a = color.a;
      var numReg = /^(0|[1-9]\d*)%$/;
      var aReg = /^(0\.[0-9]{0,2}|0|1)$/; // /^(0\.[0-9]{0,2}|0|1)$/

      var slArr = [s, l];
      if (slArr.some(function (item) {
        return !numReg.test(item);
      })) return false; // sl 都为百分数

      if (!/^(0|[1-9]\d*)$/.test(h) || /^(0|[1-9]\d*)$/.test(h) && parseInt(h, 10) > 360) return false; // h 没有百分数

      slArr = slArr.map(function (v) {
        return v.split('%')[0];
      }).map(function (v) {
        return parseInt(v, 10);
      });
      if (slArr.some(function (v) {
        return v < 0 || v > 100;
      })) return false;
      if (!aReg.test(a) || /\.$/.test(a)) return false;
      return true;
    }
  }
});
// CONCATENATED MODULE: ./packages/color-picker/src/components/color-details.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_color_detailsvue_type_script_lang_js_ = (color_detailsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/color-picker/src/components/color-details.vue





/* normalize component */

var color_details_component = normalizeComponent(
  components_color_detailsvue_type_script_lang_js_,
  color_detailsvue_type_template_id_543cf875_render,
  color_detailsvue_type_template_id_543cf875_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var color_details = (color_details_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var picker_dropdownvue_type_script_lang_js_ = ({
  name: 'ElColorPickerDropdown',
  components: {
    SvPanel: sv_panel,
    HueSlider: hue_slider,
    ColorDetails: color_details,
    SimplePanel: simple_panel,
    AlphaSlider: alpha_slider
  },
  mixins: [vue_popper, locale],
  props: {
    color: {
      type: null,
      "default": null,
      required: true
    },
    showAlpha: {
      type: Boolean,
      "default": null
    },
    isSimple: {
      type: Boolean,
      "default": true
    },
    colorList: {
      type: Array,
      "default": null
    },
    currentColor: {
      type: String,
      "default": ''
    },
    inputWidth: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      customInput: ''
    };
  },
  watch: {
    showPopper: function showPopper(val) {
      var _this = this;

      if (val === true) {
        this.$nextTick(function () {
          var _this$$refs = _this.$refs,
              sl = _this$$refs.sl,
              hue = _this$$refs.hue,
              alpha = _this$$refs.alpha;
          sl && sl.update();
          hue && hue.update();
          alpha && alpha.update();
        });
      }
    }
  },
  mounted: function mounted() {
    this.$parent.popperElm = this.popperElm = this.$el;
    this.referenceElm = this.$parent.$el;
  },
  methods: {
    confirmValue: function confirmValue() {
      this.$emit('pick');
    },
    handleConfirm: function handleConfirm() {
      var valid = this.showAlpha ? this.validRGBA(this.customInput) : this.validRGBHex(this.customInput);

      if (valid) {
        this.color.fromString(this.customInput);
      } else {
        this.customInput = this.currentColor;
      }
    },
    validRGBHex: function validRGBHex(color) {
      return /^#[A-Fa-f0-9]{6}$/.test(color);
    },
    validRGBA: function validRGBA(color) {
      var matches = color.match(/^rgba\((\d+), ?(\d+), ?(\d+), ?([.0-9]+)\)$/);
      if (!matches) return false;
      var list = matches.map(function (v) {
        return parseInt(v, 10);
      }).slice(1);
      if (list.some(function (v) {
        return isNaN(v);
      })) return false;

      var _list = _slicedToArray(list, 4),
          r = _list[0],
          g = _list[1],
          b = _list[2],
          a = _list[3];

      if ([r, g, b].some(function (v) {
        return v < 0 || v > 255;
      }) || a < 0 || a > 1) return false;
      return true;
    },
    selectSimpleColor: function selectSimpleColor(color) {
      this.$emit('selectSimpleColor', color);
    },
    selectColor: function selectColor(color) {
      this.$emit('selectColor', color);
    }
  }
});
// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_picker_dropdownvue_type_script_lang_js_ = (picker_dropdownvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue





/* normalize component */

var picker_dropdown_component = normalizeComponent(
  components_picker_dropdownvue_type_script_lang_js_,
  picker_dropdownvue_type_template_id_b5437c72_render,
  picker_dropdownvue_type_template_id_b5437c72_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var picker_dropdown = (picker_dropdown_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var color_picker_src_mainvue_type_script_lang_js_ = ({
  name: 'HColorPicker',
  directives: {
    Clickoutside: clickoutside
  },
  components: {
    PickerDropdown: picker_dropdown,
    ElInput: packages_input
  },
  props: {
    value: {
      type: String,
      "default": ''
    },
    showAlpha: {
      type: Boolean,
      "default": false
    },
    colorFormat: {
      type: String,
      "default": null
    },
    showColorText: {
      type: Boolean,
      "default": true
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    defaultColor: {
      type: String,
      "default": ''
    },
    placeholder: {
      type: String,
      "default": ''
    },
    colorList: {
      type: Array,
      "default": function _default() {
        return ['#f30303', '#e92656', '#960fa3', '#3f40a9', '#2c84ee', '#00b2cd', '#008b7e', '#36a751', '#79be4d', '#c2da46', '#fdeb4a', '#ff911b'];
      }
    },
    isSimple: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    var color = new color_Color({
      enableAlpha: this.showAlpha,
      format: this.colorFormat
    });
    return {
      color: color,
      showPicker: false,
      showPanelColor: false,
      inputWidth: ''
    };
  },
  computed: {
    displayedColor: function displayedColor() {
      if (!this.value && !this.showPanelColor) {
        return 'transparent';
      } else {
        var _this$color$toRgb = this.color.toRgb(),
            r = _this$color$toRgb.r,
            g = _this$color$toRgb.g,
            b = _this$color$toRgb.b;

        return this.showAlpha ? "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(this.color.get('alpha') / 100, ")") : "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
      }
    },
    inputValue: function inputValue() {
      if (this.showColorText) {
        return this.value;
      }

      return '';
    },
    innerStyle: function innerStyle() {
      if (this.defaultColor) {
        return {
          background: this.defaultColor
        };
      } else {
        return '';
      }
    },
    inputPlaceholder: function inputPlaceholder() {
      // 当有绑定值或缺省值时，不展示placeholder
      return this.value || this.defaultColor ? '' : this.placeholder;
    }
  },
  watch: {
    value: function value(val) {
      if (!val && this.defaultColor !== 'transparent' && this.defaultColor !== '') {
        // 没有输入颜色 且defaultColor不为透明与空字符串时，将颜色设置为缺省颜色
        this.color.fromString(this.defaultColor);
        this.setInputColor();
      } else if (!val && (this.defaultColor === 'transparent' || this.defaultColor === '')) {
        // 没有输入颜色 且defaultColor不为透明与空字符串时，直接设置背景色为 transparent
        this.$refs.inputColor.$el.style.background = 'transparent';
        this.showPanelColor = false;
      } else if (val && val !== this.color.value) {
        this.color.fromString(val);
        this.setInputColor();
      }
    },
    color: {
      deep: true,
      handler: function handler() {
        this.showPanelColor = true;
      }
    },
    displayedColor: function displayedColor(val) {
      this.$emit('active-change', val);
    },
    showPicker: function showPicker(val) {
      if (val) {
        this.inputWidth = this.$refs.inputColor.$el.getBoundingClientRect().width + 'px';
      }
    }
  },
  mounted: function mounted() {
    var value = this.value;

    if (value) {
      this.color.fromString(value);
      this.setInputColor();
    } else if (this.defaultColor === '' || this.defaultColor === 'transparent') {
      // 当没有输入颜色，且缺省颜色为 '' 或则 'transparent' 时，直接将背景色设置为透明
      this.color.fromString('#ffffff');
      this.$refs.inputColor.$el.style.background = 'transparent';
    } else if (this.defaultColor) {
      // 当没有输入颜色，但有缺省颜色时，设置缺省色为当前颜色
      this.color.fromString(this.defaultColor);
      this.setInputColor();
    } else {
      this.color.fromString('#ffffff');
      this.setInputColor();
    }
  },
  methods: {
    switchShow: function switchShow() {
      if (!this.disabled) {
        this.showPicker = !this.showPicker;
      }
    },
    confirmValue: function confirmValue() {
      this.$emit('input', this.color.value);
      this.$emit('change', this.color.value);
      this.showPicker = false;
    },
    hide: function hide() {
      this.showPicker = false;
      this.resetColor();
    },
    resetColor: function resetColor() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.value) {
          _this.color.fromString(_this.value);
        } else {
          _this.showPanelColor = false;
        }
      });
    },
    selectColor: function selectColor(color) {
      this.setInputColor();
      var outputColor = this.getOutputColor(color);
      this.showPicker = false;
      this.$emit('input', outputColor);
      this.$emit('change', outputColor);
    },
    judgeColorIsLight: function judgeColorIsLight(rgb) {
      return 0.213 * rgb.r + 0.715 * rgb.g + 0.072 * rgb.b > 255 / 2;
    },
    setInputColor: function setInputColor() {
      var rgbColor = this.color.toRgb();
      var islight = this.judgeColorIsLight(rgbColor);
      this.$refs.inputColor.$el.children[0].style.color = islight ? '#000' : '#fff';
      this.$refs.inputColor.$el.style.background = this.color.value;
    },
    getOutputColor: function getOutputColor(color) {
      // 需求：当rgba场景下，当透明度为1时，控制输出的颜色格式
      var outputColor = null;

      if (this.isSimple) {
        outputColor = color;
      } else {
        if (this.showAlpha && this.color._alpha === 100) {
          outputColor = this.color.rgbToHex();
        } else {
          outputColor = color.value;
        }
      }

      return outputColor;
    }
  }
});
// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_color_picker_src_mainvue_type_script_lang_js_ = (color_picker_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/color-picker/src/main.vue





/* normalize component */

var color_picker_src_main_component = normalizeComponent(
  packages_color_picker_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_37945865_render,
  mainvue_type_template_id_37945865_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var color_picker_src_main = (color_picker_src_main_component.exports);
// CONCATENATED MODULE: ./packages/color-picker/index.js


/* istanbul ignore next */

color_picker_src_main.install = function (Vue) {
  Vue.component(color_picker_src_main.name, color_picker_src_main);
};

/* harmony default export */ var color_picker = (color_picker_src_main);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=template&id=52867b1e&
var mainvue_type_template_id_52867b1e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-transfer"},[_c('transfer-panel',_vm._b({ref:"leftPanel",attrs:{"data":_vm.sourceData,"title":_vm.titles[0] || _vm.t('el.transfer.titles.0'),"default-checked":_vm.leftDefaultChecked,"panel-at":"left"},on:{"checked-change":_vm.onSourceCheckedChange}},'transfer-panel',_vm.$props,false),[_vm._t("left-footer")],2),_c('div',{staticClass:"el-transfer__buttons"},[_c('el-button',{staticClass:"el-transfer__button",attrs:{"disabled":_vm.leftChecked.length === 0},nativeOn:{"click":function($event){return _vm.addToRight($event)}}},[(_vm.buttonTexts[1] !== undefined)?_c('span',[_vm._v(" "+_vm._s(_vm.buttonTexts[1])+" ")]):_vm._e(),_c('i',{staticClass:"h-icon-angle_right"})]),_c('el-button',{staticClass:"el-transfer__button",attrs:{"disabled":_vm.rightChecked.length === 0},nativeOn:{"click":function($event){return _vm.addToLeft($event)}}},[_c('i',{staticClass:"h-icon-angle_left"}),(_vm.buttonTexts[0] !== undefined)?_c('span',[_vm._v(" "+_vm._s(_vm.buttonTexts[0])+" ")]):_vm._e()])],1),_c('transfer-panel',_vm._b({ref:"rightPanel",attrs:{"data":_vm.targetData,"title":_vm.titles[1] || _vm.t('el.transfer.titles.1'),"default-checked":_vm.rightDefaultChecked,"panel-at":"right"},on:{"checked-change":_vm.onTargetCheckedChange}},'transfer-panel',_vm.$props,false),[_vm._t("right-footer")],2)],1)}
var mainvue_type_template_id_52867b1e_staticRenderFns = []


// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=template&id=52867b1e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=template&id=0afe2493&
var transfer_panelvue_type_template_id_0afe2493_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-transfer-panel"},[_c('p',{staticClass:"el-transfer-panel__header"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{class:[
      'el-transfer-panel__body',
      !_vm.isShowFooter ? 'no-footer' : 'is-with-footer',
      _vm.filterable ? 'is-filterable' : ''
    ]},[(_vm.filterable && !_vm.isSearch)?_c('el-input',{staticClass:"el-transfer-panel__filter",attrs:{"placeholder":_vm.placeholder,"icon":_vm.inputIcon,"size":"small"},on:{"click":_vm.clearQuery},nativeOn:{"mouseenter":function($event){_vm.inputHover = true},"mouseleave":function($event){_vm.inputHover = false}},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}}):(_vm.isSearch)?_c('el-input',{staticClass:"el-transfer-panel__filter",attrs:{"placeholder":_vm.placeholder,"icon":_vm.inputIcon,"size":"small"},on:{"click":_vm.clearQuery},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchMethod(_vm.searchQuery)},"mouseenter":function($event){_vm.inputHover = true},"mouseleave":function($event){_vm.inputHover = false}},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}):_vm._e(),_c('el-scrollbar',{attrs:{"wrap-class":_vm.filterable
          ? 'el-transfer-scrollbar-filterable__wrap'
          : 'el-transfer-scrollbar__wrap',"view-class":"el-transfer-scrollbar__view","is-small":""},on:{"on-scrolling":_vm.onScrolling}},[_c('el-checkbox-group',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasNoMatch && _vm.data.length > 0),expression:"!hasNoMatch && data.length > 0"}],staticClass:"el-transfer-panel__list",class:{
          'is-filterable': _vm.filterable
        },model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},_vm._l((_vm.filteredData),function(item){return _c('el-checkbox',{key:item[_vm.keyProp],staticClass:"el-transfer-panel__item",attrs:{"label":item[_vm.keyProp],"disabled":item[_vm.disabledProp]}},[_c('option-content',{attrs:{"option":item}})],1)}),1)],1),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasNoMatch),expression:"hasNoMatch"}],staticClass:"el-transfer-panel__empty"},[_vm._v(" "+_vm._s(_vm.t('el.transfer.noMatch'))+" ")]),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.length === 0 && !_vm.hasNoMatch),expression:"data.length === 0 && !hasNoMatch"}],staticClass:"el-transfer-panel__empty"},[_vm._v(" "+_vm._s(_vm.t('el.transfer.noData'))+" ")])],1),(_vm.isShowFooter)?_c('p',{staticClass:"el-transfer-panel__footer"},[_c('el-checkbox',{attrs:{"indeterminate":_vm.isIndeterminate},on:{"change":_vm.handleAllCheckedChange},model:{value:(_vm.allChecked),callback:function ($$v) {_vm.allChecked=$$v},expression:"allChecked"}},[_vm._v(" "+_vm._s(_vm.checkedSummary)+" ")]),_vm._t("default")],2):_vm._e()])}
var transfer_panelvue_type_template_id_0afe2493_staticRenderFns = []


// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=template&id=0afe2493&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var transfer_panelvue_type_script_lang_js_ = ({
  name: 'ElTransferPanel',
  components: {
    ElCheckboxGroup: packages_checkbox_group,
    ElCheckbox: packages_checkbox,
    ElInput: packages_input,
    ElScrollbar: scrollbar,
    OptionContent: {
      props: {
        option: Object
      },
      render: function render(h) {
        var getParent = function getParent(vm) {
          if (vm.$options.componentName === 'ElTransferPanel') {
            return vm;
          } else if (vm.$parent) {
            return getParent(vm.$parent);
          } else {
            return vm;
          }
        };

        var parent = getParent(this);
        return parent.renderContent ? parent.renderContent(h, this.option) : h("span", [this.option[parent.labelProp] || this.option[parent.keyProp]]);
      }
    }
  },
  mixins: [locale],
  componentName: 'ElTransferPanel',
  props: {
    data: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    renderContent: {
      type: Function,
      "default": null
    },
    title: {
      type: String,
      "default": null
    },
    filterable: {
      type: Boolean,
      "default": null
    },
    filterPlaceholder: {
      type: String,
      "default": ''
    },
    footerFormat: {
      type: [Object, Boolean],
      "default": null
    },
    filterMethod: {
      type: Function,
      "default": null
    },
    defaultChecked: {
      type: Array,
      "default": null
    },
    props: {
      type: Object,
      "default": null
    },
    panelAt: {
      type: String,
      "default": null
    },
    searchPlaceholder: {
      type: String,
      "default": ''
    },
    searchMethod: {
      type: Function,
      "default": null
    }
  },
  data: function data() {
    return {
      checked: [],
      allChecked: false,
      query: '',
      inputHover: false,
      searchQuery: ''
    };
  },
  computed: {
    filteredData: function filteredData() {
      var _this = this;

      return this.data.filter(function (item) {
        if (typeof _this.filterMethod === 'function') {
          return _this.filterMethod(_this.query, item);
        } else {
          var label = item[_this.labelProp] || item[_this.keyProp].toString();

          return label.toLowerCase().indexOf(_this.query.toLowerCase()) > -1;
        }
      });
    },
    checkableData: function checkableData() {
      var _this2 = this;

      return this.filteredData.filter(function (item) {
        return !item[_this2.disabledProp];
      });
    },
    checkedSummary: function checkedSummary() {
      if (this.footerFormat === false) return '';
      var checkedLength = this.checked.length;
      var dataLength = this.data.length;
      var _this$footerFormat = this.footerFormat,
          noChecked = _this$footerFormat.noChecked,
          hasChecked = _this$footerFormat.hasChecked;

      if (noChecked && hasChecked) {
        return checkedLength > 0 ? hasChecked.replace(/\${checked}/g, checkedLength).replace(/\${total}/g, dataLength) : noChecked.replace(/\${total}/g, dataLength);
      } else {
        return checkedLength > 0 ? this.t('el.transfer.hasCheckedFormat', {
          total: dataLength,
          checked: checkedLength
        }) : this.t('el.transfer.noCheckedFormat', {
          total: dataLength
        });
      }
    },
    isIndeterminate: function isIndeterminate() {
      var checkedLength = this.checked.length;
      return checkedLength > 0 && checkedLength < this.checkableData.length;
    },
    hasNoMatch: function hasNoMatch() {
      return this.query.length > 0 && this.filteredData.length === 0;
    },
    inputIcon: function inputIcon() {
      return this.query.length > 0 && this.inputHover ? 'h-icon-close_f' : 'h-icon-search';
    },
    labelProp: function labelProp() {
      return this.props.label || 'label';
    },
    keyProp: function keyProp() {
      return this.props.key || 'key';
    },
    disabledProp: function disabledProp() {
      return this.props.disabled || 'disabled';
    },
    isSearch: function isSearch() {
      return this.panelAt === 'left' && typeof this.searchMethod === 'function';
    },
    isShowFooter: function isShowFooter() {
      return this.footerFormat !== false;
    },
    placeholder: function placeholder() {
      var filterPlaceholder = this.filterPlaceholder,
          filterable = this.filterable,
          searchPlaceholder = this.searchPlaceholder,
          isSearch = this.isSearch,
          t = this.t;

      if (filterable && !isSearch) {
        return filterPlaceholder || t('el.transfer.filterPlaceholder');
      } else if (isSearch) {
        return searchPlaceholder || t('el.transfer.filterPlaceholder');
      } else {
        return '';
      }
    }
  },
  watch: {
    checked: function checked(val) {
      this.updateAllChecked();
      this.$emit('checked-change', val);
    },
    data: function data() {
      var _this3 = this;

      var checked = [];
      var filteredDataKeys = this.filteredData.map(function (item) {
        return item[_this3.keyProp];
      });
      this.checked.forEach(function (item) {
        if (filteredDataKeys.indexOf(item) > -1) {
          checked.push(item);
        }
      });
      this.checked = checked;
    },
    checkableData: function checkableData() {
      this.updateAllChecked();
    },
    defaultChecked: {
      immediate: true,
      handler: function handler(val, oldVal) {
        var _this4 = this;

        if (oldVal && val.length === oldVal.length && val.every(function (item) {
          return oldVal.indexOf(item) > -1;
        })) {
          return;
        }

        var checked = [];
        var checkableDataKeys = this.checkableData.map(function (item) {
          return item[_this4.keyProp];
        });
        val.forEach(function (item) {
          if (checkableDataKeys.indexOf(item) > -1) {
            checked.push(item);
          }
        });
        this.checked = checked;
      }
    }
  },
  methods: {
    updateAllChecked: function updateAllChecked() {
      var _this5 = this;

      var checkableDataKeys = this.checkableData.map(function (item) {
        return item[_this5.keyProp];
      });
      this.allChecked = checkableDataKeys.length > 0 && checkableDataKeys.every(function (item) {
        return _this5.checked.indexOf(item) > -1;
      });
    },
    handleAllCheckedChange: function handleAllCheckedChange(value) {
      var _this6 = this;

      this.checked = value ? this.checkableData.map(function (item) {
        return item[_this6.keyProp];
      }) : [];
    },
    clearQuery: function clearQuery() {
      var searchMethod = this.searchMethod,
          searchQuery = this.searchQuery,
          isSearch = this.isSearch;

      if (this.inputIcon === 'h-icon-close_f') {
        if (isSearch) {
          this.searchQuery = '';
        } else {
          this.query = '';
        }
      } else if (isSearch) {
        searchMethod(searchQuery);
      }
    },
    onScrolling: function onScrolling(s) {
      var scrollTop = s.scrollTop,
          percentY = s.percentY;
      this.$parent.$emit("on-".concat(this.panelAt, "-scrolling"), {
        scrollTop: scrollTop,
        percentY: percentY
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_transfer_panelvue_type_script_lang_js_ = (transfer_panelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue





/* normalize component */

var transfer_panel_component = normalizeComponent(
  src_transfer_panelvue_type_script_lang_js_,
  transfer_panelvue_type_template_id_0afe2493_render,
  transfer_panelvue_type_template_id_0afe2493_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var transfer_panel = (transfer_panel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=script&lang=js&









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var transfer_src_mainvue_type_script_lang_js_ = ({
  name: 'ElTransfer',
  components: {
    TransferPanel: transfer_panel,
    ElButton: packages_button
  },
  mixins: [emitter, locale],
  props: {
    data: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    titles: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    buttonTexts: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    filterPlaceholder: {
      type: String,
      "default": ''
    },
    filterMethod: {
      type: Function,
      "default": null
    },
    leftDefaultChecked: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    rightDefaultChecked: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    renderContent: {
      type: Function,
      "default": null
    },
    value: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    footerFormat: {
      type: [Object, Boolean],
      "default": function _default() {
        return {};
      }
    },
    filterable: {
      type: Boolean,
      "default": null
    },
    props: {
      type: Object,
      "default": function _default() {
        return {
          label: 'label',
          key: 'key',
          disabled: 'disabled'
        };
      }
    },
    searchPlaceholder: {
      type: String,
      "default": ''
    },
    searchMethod: {
      type: Function,
      "default": null
    },
    beforeAddToRight: {
      type: Function,
      "default": function _default() {
        return new Promise(function (resolve) {
          return resolve();
        });
      }
    },
    beforeAddToLeft: {
      type: Function,
      "default": function _default() {
        return new Promise(function (resolve) {
          return resolve();
        });
      }
    }
  },
  data: function data() {
    return {
      leftChecked: [],
      rightChecked: []
    };
  },
  computed: {
    sourceData: function sourceData() {
      var _this = this;

      return this.data.filter(function (item) {
        return _this.value.indexOf(item[_this.props.key]) === -1;
      });
    },
    targetData: function targetData() {
      var _this2 = this;

      return this.data.filter(function (item) {
        return _this2.value.indexOf(item[_this2.props.key]) > -1;
      });
    }
  },
  watch: {
    value: function value(val) {
      this.dispatch('ElFormItem', 'el.form.change', val);
    }
  },
  methods: {
    onSourceCheckedChange: function onSourceCheckedChange(val) {
      this.leftChecked = val;
    },
    onTargetCheckedChange: function onTargetCheckedChange(val) {
      this.rightChecked = val;
    },
    addToLeft: function addToLeft() {
      var _this3 = this;

      this.beforeAddToLeft().then(function () {
        var currentValue = _this3.value.slice();

        _this3.rightChecked.forEach(function (item) {
          var index = currentValue.indexOf(item);

          if (index > -1) {
            currentValue.splice(index, 1);
          }
        });

        _this3.$emit('input', currentValue);

        _this3.$emit('change', currentValue, 'left', _this3.rightChecked);
      })["catch"](function () {});
    },
    addToRight: function addToRight() {
      var _this4 = this;

      this.beforeAddToRight().then(function () {
        var currentValue = _this4.value.slice();

        _this4.leftChecked.forEach(function (item) {
          if (_this4.value.indexOf(item) === -1) {
            currentValue = currentValue.concat(item);
          }
        });

        _this4.$emit('input', currentValue);

        _this4.$emit('change', currentValue, 'right', _this4.leftChecked);
      })["catch"](function () {});
    },
    clearQuery: function clearQuery(which) {
      if (which === 'left') {
        this.$refs.leftPanel.query = '';
      } else if (which === 'right') {
        this.$refs.rightPanel.query = '';
      } else if (which === undefined) {
        this.$refs.leftPanel.query = '';
        this.$refs.rightPanel.query = '';
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_transfer_src_mainvue_type_script_lang_js_ = (transfer_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/transfer/src/main.vue





/* normalize component */

var transfer_src_main_component = normalizeComponent(
  packages_transfer_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_52867b1e_render,
  mainvue_type_template_id_52867b1e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var transfer_src_main = (transfer_src_main_component.exports);
// CONCATENATED MODULE: ./packages/transfer/index.js


/* istanbul ignore next */

transfer_src_main.install = function (Vue) {
  Vue.component(transfer_src_main.name, transfer_src_main);
};

/* harmony default export */ var transfer = (transfer_src_main);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/affix/src/affix.vue?vue&type=template&id=1a2366b6&
var affixvue_type_template_id_1a2366b6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"point",class:{ 'h-affix': _vm.affix },style:(_vm.styles)},[_vm._t("default")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.slot),expression:"slot"}],style:(_vm.slotStyle)})])}
var affixvue_type_template_id_1a2366b6_staticRenderFns = []


// CONCATENATED MODULE: ./packages/affix/src/affix.vue?vue&type=template&id=1a2366b6&

// CONCATENATED MODULE: ./packages/affix/src/util.js
var src_util_getScroll = function getScroll(target, top) {
  var prop = top ? 'pageYOffset' : 'pageXOffset';
  var method = top ? 'scrollTop' : 'scrollLeft';
  var ret = target[prop];

  if (typeof ret !== 'number') {
    ret = target ? target[method] : window.document.documentElement[method];
  }

  return ret;
};
var src_util_getOffset = function getOffset(element, target) {
  var rect = element.getBoundingClientRect();
  var targetTop = target && target.getBoundingClientRect ? target.getBoundingClientRect().top : 0;
  var scrollTop = src_util_getScroll(target || window, true);
  var scrollLeft = src_util_getScroll(target || window);
  var docEl = window.document.body;
  var clientTop = docEl.clientTop || 0;
  var clientLeft = docEl.clientLeft || 0;
  return {
    top: rect.top + scrollTop - clientTop - targetTop,
    left: rect.left + scrollLeft - clientLeft
  };
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/affix/src/affix.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//


/* harmony default export */ var affixvue_type_script_lang_js_ = ({
  name: 'HAffix',
  props: {
    offsetTop: {
      type: Number,
      "default": 0
    },
    offsetBottom: {
      type: Number,
      "default": -1
    },
    slotWidth: {
      type: Number,
      "default": undefined
    },
    slotHeight: {
      type: Number,
      "default": undefined
    },
    container: {
      type: [String, Object],
      "default": ''
    }
  },
  data: function data() {
    return {
      affix: false,
      styles: {},
      slot: false,
      slotStyle: {}
    };
  },
  computed: {
    offsetType: function offsetType() {
      var type = 'top';

      if (this.offsetBottom >= 0) {
        type = 'bottom';
      }

      return type;
    },
    scrollContainer: function scrollContainer() {
      return this.container ? typeof this.container === 'string' ? document.querySelector(this.container) : this.container : window;
    }
  },
  mounted: function mounted() {
    this.handleScroll();
    on(this.scrollContainer, 'scroll', this.handleScroll);
    on(this.scrollContainer, 'resize', this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    off(this.scrollContainer, 'scroll', this.handleScroll);
    off(this.scrollContainer, 'resize', this.handleScroll);
  },
  methods: {
    /**
     * @desc 响应滚动条滚动事件
     * @author chenguanbin
     */
    handleScroll: function handleScroll() {
      var affix = this.affix;
      var scrollTop = src_util_getScroll(this.scrollContainer, true);
      var elOffset = src_util_getOffset(this.$el, this.scrollContainer);
      var windowHeight = this.container ? this.scrollContainer.offsetHeight : window.innerHeight;
      var elHeight = this.$el.getElementsByTagName('div')[0].offsetHeight;
      var containerTop = this.scrollContainer.getBoundingClientRect ? this.scrollContainer.getBoundingClientRect().top : 0; // Fixed Top

      if (elOffset.top - this.offsetTop < scrollTop && this.offsetType === 'top' && !affix) {
        this.affix = true;
        this.slotStyle = {
          width: "".concat(this.slotWidth || this.$refs.point.clientWidth, "px"),
          height: "".concat(this.slotHeight || this.$refs.point.clientHeight, "px")
        };
        this.slot = true;
        this.styles = {
          top: "".concat(this.offsetTop + containerTop, "px"),
          left: "".concat(elOffset.left, "px"),
          width: "".concat(this.$el.offsetWidth, "px")
        };
        this.$emit('on-change', true);
      } else if (elOffset.top - this.offsetTop > scrollTop && this.offsetType === 'top' && affix) {
        this.slotStyle = {};
        this.affix = false;
        this.slot = false;
        this.styles = null;
        this.$emit('on-change', false);
      } else if (this.offsetType === 'top' && affix) {
        this.slotStyle = {
          width: "".concat(this.slotWidth || this.$refs.point.clientWidth, "px"),
          height: "".concat(this.slotHeight || this.$refs.point.clientHeight, "px")
        };
        this.styles = {
          top: "".concat(this.offsetTop + containerTop, "px"),
          left: "".concat(elOffset.left, "px"),
          width: "".concat(this.$el.offsetWidth, "px")
        };
      } // Fixed Bottom


      var containerHeight = window.innerHeight - windowHeight - containerTop;

      if (elOffset.top + this.offsetBottom + elHeight > scrollTop + windowHeight && this.offsetType === 'bottom' && !affix) {
        this.affix = true;
        this.slotStyle = {
          width: "".concat(this.slotWidth || this.$refs.point.clientWidth, "px"),
          height: "".concat(this.slotHeight || this.$refs.point.clientHeight, "px")
        };
        this.slot = true;
        this.styles = {
          bottom: "".concat(this.offsetBottom + containerHeight, "px"),
          left: "".concat(elOffset.left, "px"),
          width: "".concat(this.$el.offsetWidth, "px")
        };
        this.$emit('on-change', true);
      } else if (elOffset.top + this.offsetBottom + elHeight < scrollTop + windowHeight && this.offsetType === 'bottom' && affix) {
        this.slot = false;
        this.affix = false;
        this.styles = null;
        this.$emit('on-change', false);
      } else if (this.offsetType === 'bottom' && affix) {
        this.slotStyle = {
          width: "".concat(this.slotWidth || this.$refs.point.clientWidth, "px"),
          height: "".concat(this.slotHeight || this.$refs.point.clientHeight, "px")
        };
        this.styles = {
          bottom: "".concat(this.offsetBottom + containerHeight, "px"),
          left: "".concat(elOffset.left, "px"),
          width: "".concat(this.$el.offsetWidth, "px")
        };
      }
    },
    updateAffixStyle: function updateAffixStyle(affixStyle) {
      if (!this.affix) return;
      var top = affixStyle.top,
          bottom = affixStyle.bottom,
          left = affixStyle.left,
          width = affixStyle.width;
      if (top !== undefined) this.styles.top = "".concat(parseInt(top), "px");
      if (bottom !== undefined) this.styles.bottom = "".concat(parseInt(bottom), "px");
      if (left !== undefined) this.styles.left = "".concat(parseInt(left), "px");

      if (width !== undefined) {
        this.styles.width = "".concat(parseInt(width), "px");
        this.slotStyle.width = "".concat(parseInt(width), "px");
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/affix/src/affix.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_affixvue_type_script_lang_js_ = (affixvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/affix/src/affix.vue





/* normalize component */

var affix_component = normalizeComponent(
  src_affixvue_type_script_lang_js_,
  affixvue_type_template_id_1a2366b6_render,
  affixvue_type_template_id_1a2366b6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_affix = (affix_component.exports);
// CONCATENATED MODULE: ./packages/affix/index.js



src_affix.install = function (Vue) {
  Vue.component(src_affix.name, src_affix);
};

/* harmony default export */ var packages_affix = (src_affix);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/anchor/src/anchor.vue?vue&type=template&id=0d9f26d6&
var anchorvue_type_template_id_0d9f26d6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.wrapperComponent,{ref:"affix",tag:"component",staticStyle:{"text-align":"right"},attrs:{"container":_vm.container,"offset-top":_vm.offsetTop,"offset-bottom":_vm.offsetBottom}},[_c('div',{staticClass:"h-anchor-wrapper",class:{ folded: _vm.folded },style:(_vm.wrapperStyle),on:{"mouseenter":_vm.handleMouseenter,"mouseleave":_vm.handleMouseleave}},[_c(_vm.scrollComponent,{ref:"scrollbar",tag:"component",attrs:{"wrap-class":"el-anchor-scrollbar__wrap","view-class":"el-anchor-scrollbar__view"}},[_c('div',{ref:"anchor",staticClass:"h-anchor",class:{ 'is-folded': _vm.folded && _vm.isFolded }},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.folded || !_vm.isFolded),expression:"!folded || !isFolded"}]},[_vm._t("default"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInk && _vm.inkActived),expression:"showInk && inkActived"}],staticClass:"h-anchor__ink-ball",style:({ top: ((_vm.inkTop + 8) + "px"), left: '15px' })})],2),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.folded && _vm.isFolded),expression:"folded && isFolded"}],staticClass:"h-anchor-icon h-icon-ctrl_anchor"})])])],1)])}
var anchorvue_type_template_id_0d9f26d6_staticRenderFns = []


// CONCATENATED MODULE: ./packages/anchor/src/anchor.vue?vue&type=template&id=0d9f26d6&

// EXTERNAL MODULE: external "core-js/modules/es.string.anchor.js"
var es_string_anchor_js_ = __webpack_require__("bf90");

// CONCATENATED MODULE: ./packages/anchor/src/util.js








/**
 * @desc 元素滚动到目标位置
 * @author chenguanbin
 * @param {Document} el 滚动元素
 * @param {Number} from 开始位置
 * @param {Number} to 目标位置
 * @param {Number} duration 持续时间
 * @param {Function} endCallback 回调函数
 */
var util_scrollTop = function scrollTop(el) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var to = arguments.length > 2 ? arguments[2] : undefined;
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
  var endCallback = arguments.length > 4 ? arguments[4] : undefined;

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 1000 / 60);
    };
  }

  var difference = Math.abs(from - to);
  var step = Math.ceil(difference / duration * 50);

  function scroll(start, end, step) {
    if (start === end) {
      endCallback && endCallback();
      return;
    }

    var d = start + step > end ? end : start + step;

    if (start > end) {
      d = start - step < end ? end : start - step;
    }

    if (el === window) {
      window.scrollTo(d, d);
    } else {
      el.scrollTop = d;
    }

    window.requestAnimationFrame(function () {
      return scroll(d, end, step);
    });
  }

  scroll(from, to, step);
};
/**
 * @desc 找到子组件中的目标组件
 * @author chenguanbin
 * @param {Object} context 父组件
 * @param {String} componentName 子组件名称
 */

var util_findComponentsDownward = function findComponentsDownward(context, componentName) {
  return context.$children.reduce(function (components, child) {
    componentName = Array.isArray(componentName) ? componentName : [componentName];
    if (componentName.includes(child.$options.name)) components.push(child);
    var foundChilds = findComponentsDownward(child, componentName);
    return components.concat(foundChilds);
  }, []);
}; // 锚点正则

var sharpMatcherRegx = /#([^#]+)$/;
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/anchor/src/anchor.vue?vue&type=script&lang=js&











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var anchorvue_type_script_lang_js_ = ({
  name: 'HAnchor',
  provide: function provide() {
    return {
      anchor: this
    };
  },
  props: {
    affix: {
      /* 固定模式 */
      type: Boolean,
      "default": true
    },
    height: {
      type: [Number, String],
      "default": ''
    },
    offsetTop: {
      /* 固定模式下，距离窗口顶部达到指定偏移量后触发 */
      type: Number,
      "default": 0
    },
    offsetBottom: {
      type: Number,
      "default": -1
    }
    /* 固定模式下，距离窗口底部达到指定偏移量后触发 */
    ,
    bounds: {
      /* 锚点区域边界，单位：px */
      type: Number,
      "default": 5
    },
    scrollOffset: {
      /* 点击滚动的额外距离 */
      type: Number,
      "default": 0
    },
    container: {
      type: [String, Object],
      "default": ''
    }
    /* 指定滚动的容器 */
    ,
    showInk: {
      /* 是否显示小圆点 */
      type: Boolean,
      "default": false
    },
    folded: {
      /* 是否能收起面板 */
      type: Boolean,
      "default": false
    },
    foldedScrollTime: {
      /* 滚动停止时，面板收起的延后时间 */
      type: Number,
      "default": 1000
    }
  },
  data: function data() {
    return {
      inkActived: false,
      // 小圆点是否处于激活状态
      inkTop: 0,
      // 小圆点top值
      animating: false,
      // 是否正在滚动中
      currentLink: '#',
      // current show link =>  #href -> currentLink = #href
      currentId: '',
      // current show title id =>  #href -> currentId = href
      scrollContainer: null,
      // 绑定滚动事件的对象，默认情况下是 window 对象
      scrollElement: null,
      // 滚动的元素，默认情况下是 document.documentElement || document.body
      titlesOffsetArr: [],
      // 锚点关联元素的位置
      wrapperTop: 0,
      scrollTop: 0,
      isFolded: false,
      isMouseEnter: false,
      timer: null,
      childWidth: null,
      minWidth: 120,
      scrollTimer: null // upperFirstTitle: true

    };
  },
  computed: {
    // 固定模式下使用 Affix 图钉控件
    wrapperComponent: function wrapperComponent() {
      return this.affix ? 'h-affix' : 'div';
    },
    // 传入height时，为页面存在滚动条
    scrollComponent: function scrollComponent() {
      return this.height && !(this.folded && this.isFolded) ? 'el-scrollbar' : 'div';
    },
    // 锚点容器样式
    wrapperStyle: function wrapperStyle() {
      var isFolded = this.folded && this.isFolded;
      var isFoldedStyle = {
        padding: '0',
        'box-shadow': 'none',
        'background-color': 'transparent'
      };
      return Object.assign({
        height: this.height ? "".concat(this.height, "px") : 'inherit',
        maxHeight: this.offsetTop ? "calc(100vh - ".concat(this.offsetTop, "px)") : '100vh',
        'min-width': "".concat(this.minWidth, "px")
      }, isFolded ? isFoldedStyle : {});
    },
    // 判断绑定滚动事件的元素是否是 window
    containerIsWindow: function containerIsWindow() {
      return this.scrollContainer === window;
    }
  },
  watch: {
    $route: function $route() {
      var _this = this;

      this.handleHashChange();
      this.$nextTick(function () {
        _this.handleScrollTo();
      });
    },
    container: function container() {
      this.init();
    },
    currentLink: function currentLink(newHref, oldHref) {
      this.$emit('on-change', newHref, oldHref);
    },
    isFolded: {
      handler: function handler(val) {
        var _this2 = this;

        if (!val) {
          this.$nextTick(function () {
            var offsetWidth = _this2.$refs.anchor.offsetWidth;
            _this2.minWidth = offsetWidth > 120 ? offsetWidth : 120;
          });
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeListener();
  },
  methods: {
    handleMouseenter: function handleMouseenter(e) {
      this.isFolded = false;
      this.isMouseEnter = true;
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop || e.target.scrollTop;
      clearTimeout(this.timer);
    },
    handleMouseleave: function handleMouseleave() {
      this.isMouseEnter = false;
      this.isFolded = true;
    },

    /**
     * @desc 滚动容器的滚动事件
     * @author chenguanbin
     * @param {Event} e
     */
    handleScroll: function handleScroll(e) {
      var _this3 = this;

      if (this.animating) return;
      this.updateTitleOffset();
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || e.target.scrollTop;
      this.getCurrentScrollAtTitleId(scrollTop);

      if (this.scrollTop !== scrollTop) {
        clearTimeout(this.timer);
        this.isFolded = false;
        this.timer = setTimeout(function () {
          !_this3.isMouseEnter && (_this3.isFolded = true);
        }, this.foldedScrollTime);
      }

      this.scrollTop = scrollTop;
    },

    /**
     * @desc 浏览器路径发生变化
     * @author chenguanbin
     */
    handleHashChange: function handleHashChange() {
      var url = window.location.href;
      var sharpLinkMatch = sharpMatcherRegx.exec(url);
      if (!sharpLinkMatch) return;
      this.currentLink = sharpLinkMatch[0];
      this.currentId = sharpLinkMatch[1];
    },

    /**
     * @desc 滚动到目标锚点
     * @author chenguanbin
     */
    handleScrollTo: function handleScrollTo() {
      var _this4 = this;

      var anchor = document.getElementById(this.currentId);
      var currentLinkElementA = document.querySelector("a[data-href=\"".concat(this.currentLink, "\"]"));
      var offset = this.scrollOffset;

      if (currentLinkElementA) {
        offset = parseFloat(currentLinkElementA.getAttribute('data-scroll-offset'));
      }

      if (!anchor) return;
      var offsetTop = getOffset(anchor, this.scrollContainer === window ? null : this.scrollContainer).top - this.wrapperTop - offset;
      this.animating = true;
      util_scrollTop(this.scrollContainer, this.scrollElement.scrollTop, offsetTop, 600, function () {
        _this4.animating = false;
      });
      this.handleSetInkTop();
    },

    /**
     * @desc 设置小圆点的 top 值
     * @author chenguanbin
     */
    handleSetInkTop: function handleSetInkTop() {
      var _this5 = this;

      var currentLinkElementA = document.querySelector("a[data-href=\"".concat(this.currentLink, "\"]"));

      if (!currentLinkElementA) {
        var currentChild = this.titlesOffsetArr.find(function (item) {
          return item.active;
        });

        if (!currentChild) {
          this.inkActived = false;
          return;
        } else {
          currentLinkElementA = document.querySelector("a[data-href=\"".concat(currentChild.link, "\"]"));
        }
      }

      this.inkActived = true;
      this.$nextTick(function () {
        var elementATop = getOffset(currentLinkElementA, _this5.$refs.anchor).top; // const top = elementATop < 0 ? this.offsetTop : elementATop;
        // this.inkTop = top;

        _this5.inkTop = Math.abs(elementATop);
      });
    },

    /**
     * @desc 更新锚点关联元素的位置信息
     * @author chenguanbin
     */
    updateTitleOffset: function updateTitleOffset() {
      var links = util_findComponentsDownward(this, ['HAnchorLink', 'HSubanchor']).map(function (link) {
        return {
          href: link.href,
          active: link.active
        };
      });
      var offsetArr = [];

      var _iterator = _createForOfIteratorHelper(links),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var link = _step.value;
          var id = link.href.split('#')[1];
          var titleEle = document.getElementById(id);

          if (titleEle) {
            offsetArr.push({
              link: "#".concat(id),
              offset: getOffset(titleEle, this.scrollContainer === window ? null : this.scrollContainer).top - this.scrollElement.offsetTop,
              active: link.active
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.titlesOffsetArr = offsetArr;
      this.handleSetScroll();
    },

    /**
     * @author xuzilong
     * @desc 设置面板内滚动条的滚动值
     */
    handleSetScroll: function handleSetScroll() {
      var _this6 = this;

      if (!this.height) return;
      var currentLinkElementA = document.querySelector("a[data-href=\"".concat(this.currentLink, "\"]"));
      if (!currentLinkElementA) return;
      var offset = getOffset(currentLinkElementA, this.$refs.anchor); // 给个防抖，否则面板会不停跳动

      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(function () {
        _this6.$refs.scrollbar.setScroll(offset.top);
      }, 100);
    },

    /**
     * @desc 根据滚动距离，判断目前激活的锚点
     * @author chenguanbin
     * @param {Number} scrollTop 滚动距离
     */
    getCurrentScrollAtTitleId: function getCurrentScrollAtTitleId(scrollTop) {
      var i = -1;
      var len = this.titlesOffsetArr.length;
      var titleItem = {
        link: '#',
        offset: 0
      };
      scrollTop += this.bounds;

      while (++i < len) {
        var currentEle = this.titlesOffsetArr[i];
        var nextEle = this.titlesOffsetArr[i + 1];

        if (scrollTop >= currentEle.offset && scrollTop < (nextEle && nextEle.offset || Infinity)) {
          titleItem = this.titlesOffsetArr[i];
          break;
        }
      }

      this.currentLink = titleItem.link;
      this.handleSetInkTop();
    },

    /**
     * @desc 获取滚动的对象和元素
     *       默认情况下分别是 window、document.documentElement || document.body，若设置了 container，则两个都是 container
     * @author chenguanbin
     */
    getContainer: function getContainer() {
      this.scrollContainer = this.container ? typeof this.container === 'string' ? document.querySelector(this.container) : this.container : window;
      this.scrollElement = this.container ? this.scrollContainer : document.documentElement || document.body;
    },

    /**
     * @desc 移除事件监听
     * @author chenguanbin
     */
    removeListener: function removeListener() {
      off(this.scrollContainer, 'scroll', this.handleScroll);
      off(window, 'hashchange', this.handleHashChange);
    },

    /**
     * @desc 初始化
     * @author chenguanbin
     */
    init: function init() {
      var _this7 = this;

      this.handleHashChange();
      this.$nextTick(function () {
        _this7.removeListener();

        _this7.getContainer();

        _this7.wrapperTop = _this7.containerIsWindow ? 0 : _this7.scrollElement.offsetTop;

        _this7.updateTitleOffset();

        _this7.handleScrollTo();

        _this7.handleSetInkTop();

        on(_this7.scrollContainer, 'scroll', _this7.handleScroll);
        on(window, 'hashchange', _this7.handleHashChange);
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/anchor/src/anchor.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_anchorvue_type_script_lang_js_ = (anchorvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/anchor/src/anchor.vue





/* normalize component */

var anchor_component = normalizeComponent(
  src_anchorvue_type_script_lang_js_,
  anchorvue_type_template_id_0d9f26d6_render,
  anchorvue_type_template_id_0d9f26d6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_anchor = (anchor_component.exports);
// CONCATENATED MODULE: ./packages/anchor/index.js



src_anchor.install = function (Vue) {
  Vue.component(src_anchor.name, src_anchor);
};

/* harmony default export */ var packages_anchor = (src_anchor);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/anchor/src/subanchor.vue?vue&type=template&id=17ec8821&
var subanchorvue_type_template_id_17ec8821_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-subanchor",class:{ 'is-expand': _vm.expand }},[_c('div',{staticClass:"h-subanchor-item"},[_c('span',{staticClass:"h-subanchor__point"}),_c('a',{staticClass:"h-subanchor__title",style:({ 'padding-left': ((_vm.level * 16 + 36) + "px") }),attrs:{"href":_vm.href,"data-scroll-offset":_vm.scrollOffset,"data-href":_vm.href,"title":_vm.title}},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"h-subanchor__content"},[_vm._t("default")],2)])}
var subanchorvue_type_template_id_17ec8821_staticRenderFns = []


// CONCATENATED MODULE: ./packages/anchor/src/subanchor.vue?vue&type=template&id=17ec8821&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/anchor/src/subanchor.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var subanchorvue_type_script_lang_js_ = ({
  name: 'HSubanchor',
  inject: ['anchor'],
  props: {
    href: {
      type: String,
      "default": null
    },
    title: {
      type: String,
      "default": null
    },
    scrollOffset: {
      type: Number,
      "default": function _default() {
        return this.anchor.scrollOffset;
      }
    },
    isCurrent: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      level: 0,
      expand: false
    };
  },
  computed: {
    active: function active() {
      return this.href === this.anchor.currentLink || this.anchor.currentLink === '#' && this.isCurrent;
    }
  },
  watch: {
    active: function active(val) {
      this.expand = val;
      this.handleParentAction(this, 'HSubanchor', 'getChildrenActive');
    }
  },
  mounted: function mounted() {
    this.setAnchorLevel(this, 'HSubanchor');
  },
  methods: {
    setAnchorLevel: function setAnchorLevel(context, name) {
      var parent = context.$parent;

      if (parent.$options.name === name) {
        this.level++;
        this.setAnchorLevel(parent, name);
      }
    },
    getChildrenActive: function getChildrenActive() {
      var children = util_findComponentsDownward(this, ['HAnchorLink', 'HSubanchor']);
      this.expand = children.some(function (item) {
        return item.active;
      }) || this.anchor.currentLink === this.href;
    },
    handleParentAction: function handleParentAction(context, name, actionName) {
      var parent = context.$parent;

      if (parent && parent.$options.name === name) {
        parent[actionName]();
      }

      if (parent) {
        this.handleParentAction(parent, name, actionName);
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/anchor/src/subanchor.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_subanchorvue_type_script_lang_js_ = (subanchorvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/anchor/src/subanchor.vue





/* normalize component */

var subanchor_component = normalizeComponent(
  src_subanchorvue_type_script_lang_js_,
  subanchorvue_type_template_id_17ec8821_render,
  subanchorvue_type_template_id_17ec8821_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var subanchor = (subanchor_component.exports);
// CONCATENATED MODULE: ./packages/subanchor/index.js



subanchor.install = function (Vue) {
  Vue.component(subanchor.name, subanchor);
};

/* harmony default export */ var packages_subanchor = (subanchor);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/anchor/src/anchor-link.vue?vue&type=template&id=024df1c2&
var anchor_linkvue_type_template_id_024df1c2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"anchorLink",class:[
    'h-anchor-link',
    _vm.active ? "is-active" : '',
    _vm.hasChildren && 'is-parent'
  ]},[_c('span',{staticClass:"h-anchor-link__point"}),_c('a',{staticClass:"h-anchor-link__title",style:({ 'padding-left': ((_vm.level * 16 + 36) + "px") }),attrs:{"href":_vm.href,"data-scroll-offset":_vm.scrollOffset,"data-href":_vm.href,"title":_vm.title},on:{"click":function($event){$event.preventDefault();return _vm.goAnchor($event)}}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)}
var anchor_linkvue_type_template_id_024df1c2_staticRenderFns = []


// CONCATENATED MODULE: ./packages/anchor/src/anchor-link.vue?vue&type=template&id=024df1c2&

// EXTERNAL MODULE: external "querystring"
var external_querystring_ = __webpack_require__("f319");
var external_querystring_default = /*#__PURE__*/__webpack_require__.n(external_querystring_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/anchor/src/anchor-link.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var anchor_linkvue_type_script_lang_js_ = ({
  name: 'HAnchorLink',
  inject: ['anchor'],
  props: {
    href: {
      type: String,
      "default": null
    },
    title: {
      type: String,
      "default": null
    },
    scrollOffset: {
      type: Number,
      "default": function _default() {
        return this.anchor.scrollOffset;
      }
    },
    isCurrent: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      hasChildren: false,
      level: 0,
      width: 0
    };
  },
  computed: {
    active: function active() {
      return this.href === this.anchor.currentLink || this.anchor.currentLink === '#' && this.isCurrent;
    }
  },
  watch: {
    active: function active(val) {
      this.handleParentAction(this, 'HSubanchor', 'getChildrenActive');
    }
  },
  mounted: function mounted() {
    if (util_findComponentsDownward(this, 'HAnchorLink').length) {
      this.hasChildren = true;
    }

    this.setAnchorLevel(this, 'HSubanchor');
    this.getWidth();
  },
  methods: {
    getWidth: function getWidth() {
      this.width = this.$refs.anchorLink.clientWidth;
    },
    goAnchor: function goAnchor() {
      var noChange = this.active;
      this.anchor.$emit('on-select', this.href);
      var isRoute = this.$router;

      if (isRoute) {
        var query = external_querystring_default.a.stringify(this.$route.query);
        this.$router.push({
          path: this.$route.path + '?' + query + this.href,
          replace: true
        });
      } else {
        var location = window.location;
        window.location.href = location.origin + location.pathname + location.search + this.href;
      }

      if (noChange) {
        this.anchor.handleHashChange();
        this.anchor.handleScrollTo();
      }
    },
    setAnchorLevel: function setAnchorLevel(context, name) {
      var parent = context.$parent;

      if (parent.$options.name === name) {
        this.level++;
        this.setAnchorLevel(parent, name);
      }
    },
    setAnchorProp: function setAnchorProp(context, name, prop, val) {
      var parent = context.$parent;

      if (parent && parent.$options.name === name) {
        parent[prop] = val;
      }

      if (parent) {
        this.setAnchorProp(parent, name, prop, val);
      }
    },
    handleParentAction: function handleParentAction(context, name, actionName) {
      var parent = context.$parent;

      if (parent && parent.$options.name === name) {
        parent[actionName]();
      }

      if (parent) {
        this.handleParentAction(parent, name, actionName);
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/anchor/src/anchor-link.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_anchor_linkvue_type_script_lang_js_ = (anchor_linkvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/anchor/src/anchor-link.vue





/* normalize component */

var anchor_link_component = normalizeComponent(
  src_anchor_linkvue_type_script_lang_js_,
  anchor_linkvue_type_template_id_024df1c2_render,
  anchor_linkvue_type_template_id_024df1c2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var anchor_link = (anchor_link_component.exports);
// CONCATENATED MODULE: ./packages/anchor-link/index.js



anchor_link.install = function (Vue) {
  Vue.component(anchor_link.name, anchor_link);
};

/* harmony default export */ var packages_anchor_link = (anchor_link);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2adef0b2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-sub-item.vue?vue&type=template&id=3b4e3d14&
var breadcrumb_sub_itemvue_type_template_id_3b4e3d14_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'dropdown')?_c('el-dropdown-item',{class:[_vm.to ? '' : 'el-breadcrumb__item__unclickable'],attrs:{"command":_vm.to}},[_vm._t("default")],2):_c('el-breadcrumb-item',{attrs:{"to":_vm.to,"separator-class":_vm.separatorClass,"max-width":_vm.maxWidth},on:{"click":_vm.goto}},[_vm._t("default")],2)}
var breadcrumb_sub_itemvue_type_template_id_3b4e3d14_staticRenderFns = []


// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-sub-item.vue?vue&type=template&id=3b4e3d14&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-sub-item.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var breadcrumb_sub_itemvue_type_script_lang_js_ = ({
  name: 'ElBreadcrumbSubItem',
  props: {
    to: {
      type: null,
      "default": null
    },
    separator: {
      type: String,
      "default": ''
    },
    separatorClass: {
      type: String,
      "default": ''
    },
    replace: {
      type: Boolean,
      "default": null
    },
    // 面包屑子项最大宽度
    maxWidth: {
      type: [String, Number],
      "default": null
    }
  },
  data: function data() {
    return {
      type: ''
    };
  },
  mounted: function mounted() {
    this.type = this.$parent.$attrs.type;
  },
  methods: {
    "goto": function goto() {
      var to = this.to,
          $router = this.$router;
      if (!to || !$router) return;
      self.replace ? $router.replace(to) : $router.push(to);
    }
  }
});
// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-sub-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_breadcrumb_sub_itemvue_type_script_lang_js_ = (breadcrumb_sub_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-sub-item.vue





/* normalize component */

var breadcrumb_sub_item_component = normalizeComponent(
  src_breadcrumb_sub_itemvue_type_script_lang_js_,
  breadcrumb_sub_itemvue_type_template_id_3b4e3d14_render,
  breadcrumb_sub_itemvue_type_template_id_3b4e3d14_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var breadcrumb_sub_item = (breadcrumb_sub_item_component.exports);
// CONCATENATED MODULE: ./packages/breadcrumb-subitem/index.js


/* istanbul ignore next */

breadcrumb_sub_item.install = function (Vue) {
  Vue.component(breadcrumb_sub_item.name, breadcrumb_sub_item);
};

/* harmony default export */ var breadcrumb_subitem = (breadcrumb_sub_item);
// EXTERNAL MODULE: ./packages/theme/index.scss
var theme = __webpack_require__("2c81");

// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__("9224");

// CONCATENATED MODULE: ./src/index.js




























































 // import Rate from '../packages/rate/index.js';





















var components = [packages_pagination, dialog, packages_autocomplete, packages_dropdown, packages_dropdown_menu, packages_dropdown_item, packages_menu, packages_submenu, packages_menu_item, packages_menu_item_group, packages_menu_collapse, packages_input, packages_input_number, packages_ip_input, packages_radio, packages_radio_group, packages_radio_button, packages_checkbox, packages_checkbox_button, packages_checkbox_group, packages_switch, packages_select, packages_option, packages_option_group, packages_button, packages_button_group, packages_table, packages_table_column, h_paged_table, packages_date_picker, packages_time_select, packages_time_picker, popover, packages_tooltip, packages_breadcrumb, packages_breadcrumb_item, packages_form, packages_form_item, packages_tabs, packages_tab_pane, packages_tag, packages_tree, packages_alert, slider, packages_icon, packages_svg_icon, packages_loading_icon, packages_feedback_icon, packages_row, packages_col, packages_upload, packages_progress, packages_spinner, badge, card, // Rate,
packages_steps, packages_step, carousel, scrollbar, carousel_item, packages_collapse, packages_collapse_item, cascader, color_picker, transfer, collapse_transition, packages_affix, packages_anchor, packages_subanchor, packages_anchor_link, breadcrumb_subitem];

var src_install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  /* istanbul ignore if */
  if (install.installed) return;
  locale_default.a.use(opts.locale);
  locale_default.a.i18n(opts.i18n);
  components.map(function (component) {
    Vue.component(component.name, component);
  });
  Vue.use(packages_loading.directive);
  Vue.prototype.$loading = packages_loading.service;
  Vue.prototype.$msgbox = message_box;
  Vue.prototype.$alert = message_box.alert;
  Vue.prototype.$confirm = message_box.confirm;
  Vue.prototype.$prompt = message_box.prompt;
  Vue.prototype.$notify = notification;
  Vue.prototype.$message = packages_message;
};
/* istanbul ignore if */


if (typeof window !== 'undefined' && window.Vue) {
  src_install(window.Vue);
}

/* harmony default export */ var src_0 = ({
  version: package_0.version,
  locale: locale_default.a.use,
  i18n: locale_default.a.i18n,
  install: src_install,
  CollapseTransition: collapse_transition,
  Loading: packages_loading,
  PopupManager: popup_manager,
  nextZIndex: popup_manager.nextZIndex,
  Pagination: packages_pagination,
  Dialog: dialog,
  Autocomplete: packages_autocomplete,
  Dropdown: packages_dropdown,
  DropdownMenu: packages_dropdown_menu,
  DropdownItem: packages_dropdown_item,
  Menu: packages_menu,
  Submenu: packages_submenu,
  MenuItem: packages_menu_item,
  MenuItemGroup: packages_menu_item_group,
  MenuCollapse: packages_menu_collapse,
  Input: packages_input,
  InputNumber: packages_input_number,
  IpInput: packages_ip_input,
  Radio: packages_radio,
  RadioGroup: packages_radio_group,
  RadioButton: packages_radio_button,
  Checkbox: packages_checkbox,
  CheckboxButton: packages_checkbox_button,
  CheckboxGroup: packages_checkbox_group,
  Switch: packages_switch,
  Select: packages_select,
  Option: packages_option,
  OptionGroup: packages_option_group,
  Button: packages_button,
  ButtonGroup: packages_button_group,
  Table: packages_table,
  TableColumn: packages_table_column,
  HPagedTable: h_paged_table,
  DatePicker: packages_date_picker,
  TimeSelect: packages_time_select,
  TimePicker: packages_time_picker,
  Popover: popover,
  Tooltip: packages_tooltip,
  MessageBox: message_box,
  Breadcrumb: packages_breadcrumb,
  BreadcrumbItem: packages_breadcrumb_item,
  Form: packages_form,
  FormItem: packages_form_item,
  Tabs: packages_tabs,
  TabPane: packages_tab_pane,
  Tag: packages_tag,
  Tree: packages_tree,
  Alert: packages_alert,
  Notification: notification,
  Slider: slider,
  Icon: packages_icon,
  SvgIcon: packages_svg_icon,
  LoadingIcon: packages_loading_icon,
  FeedbackIcon: packages_feedback_icon,
  Row: packages_row,
  Col: packages_col,
  Upload: packages_upload,
  Progress: packages_progress,
  Spinner: packages_spinner,
  Message: packages_message,
  Badge: badge,
  Card: card,
  // Rate,
  Steps: packages_steps,
  Step: packages_step,
  Carousel: carousel,
  Scrollbar: scrollbar,
  CarouselItem: carousel_item,
  Collapse: packages_collapse,
  CollapseItem: packages_collapse_item,
  Cascader: cascader,
  ColorPicker: color_picker,
  Transfer: transfer,
  Affix: packages_affix,
  Anchor: packages_anchor,
  Subanchor: packages_subanchor,
  AnchorLink: packages_anchor_link
});
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_0);



/***/ }),

/***/ "fd22":
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.includes.js");

/***/ })

/******/ })["default"];